//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isTenantAvailable(body?: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resolveTenantId(body?: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body?: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendPasswordResetCode(body?: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body?: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendEmailActivationLink(body?: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendPasswordlessLoginCode(body?: SendPasswordlessLoginCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordlessLoginCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordlessLoginCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordlessLoginCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordlessLoginCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifyPasswordlessLoginCode(body?: VerifyPasswordlessLoginCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/VerifyPasswordlessLoginCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPasswordlessLoginCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasswordlessLoginCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyPasswordlessLoginCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateEmail(body?: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeEmail(body?: ChangeEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ChangeEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    impersonateUser(body?: ImpersonateUserInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateUser(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    impersonateTenant(body?: ImpersonateTenantInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateTenant(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delegatedImpersonate(body?: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    switchToLinkedAccount(body?: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdministrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds a new survey to the system.
     * @param body (optional) The survey data to be added.
     * @return OK
     */
    addNewSurvey(body?: SurveyDto | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/AddNewSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processAddNewSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of surveys based on the provided filter criteria.
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllSurvey(filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfAdminSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetAllSurvey?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAdminSurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAdminSurveyDto>;
        }));
    }

    protected processGetAllSurvey(response: HttpResponseBase): Observable<PagedResultDtoOfAdminSurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAdminSurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a survey by its unique survey ID.
     * @param surveyId The unique identifier of the survey to be retrieved.
     * @return OK
     */
    getSurveyBySurveyId(surveyId: number): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetSurveyBySurveyId?";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined and cannot be null.");
        else
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyBySurveyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyBySurveyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetSurveyBySurveyId(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing survey with new information.
     * @param body (optional) The updated survey data.
     * @return OK
     */
    updateSurvey(body?: SurveyDto | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processUpdateSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of tasks based on the provided filter criteria.
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllTasks(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfBackgroundTaskMgmtDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetAllTasks?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBackgroundTaskMgmtDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBackgroundTaskMgmtDto>;
        }));
    }

    protected processGetAllTasks(response: HttpResponseBase): Observable<PagedResultDtoOfBackgroundTaskMgmtDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBackgroundTaskMgmtDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves detailed information about a background task instance, including task metadata and associated logs.
     * @param taskId (optional) The unique identifier of the background task instance.
     * @return OK
     */
    getJobInstancesByJobId(taskId?: number | undefined): Observable<BackgroundTaskInstanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetJobInstancesByJobId?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobInstancesByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobInstancesByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundTaskInstanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundTaskInstanceDto[]>;
        }));
    }

    protected processGetJobInstancesByJobId(response: HttpResponseBase): Observable<BackgroundTaskInstanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundTaskInstanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the log entries associated with a specific background task instance.
     * @param instanceId (optional) 
     * @return OK
     */
    getJobInstanceLogsByInstanceId(instanceId?: number | undefined): Observable<BackgroundTaskInstanceLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetJobInstanceLogsByInstanceId?";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobInstanceLogsByInstanceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobInstanceLogsByInstanceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundTaskInstanceLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundTaskInstanceLogDto[]>;
        }));
    }

    protected processGetJobInstanceLogsByInstanceId(response: HttpResponseBase): Observable<BackgroundTaskInstanceLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundTaskInstanceLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels a background task by its HangFire Job ID.
     * @param hangFireJobId (optional) 
     * @return OK
     */
    updateCancelJob(hangFireJobId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateCancelJob?";
        if (hangFireJobId !== undefined && hangFireJobId !== null)
            url_ += "hangFireJobId=" + encodeURIComponent("" + hangFireJobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCancelJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCancelJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCancelJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get available fields for Lead model (for template usage)
     * @return OK
     */
    getLeadTemplateFields(): Observable<TemplateFieldInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetLeadTemplateFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadTemplateFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadTemplateFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateFieldInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateFieldInfo[]>;
        }));
    }

    protected processGetLeadTemplateFields(response: HttpResponseBase): Observable<TemplateFieldInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateFieldInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get available fields for TicketHolder model (for template usage)
     * @return OK
     */
    getTicketHolderTemplateFields(): Observable<TemplateFieldInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetTicketHolderTemplateFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderTemplateFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderTemplateFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateFieldInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateFieldInfo[]>;
        }));
    }

    protected processGetTicketHolderTemplateFields(response: HttpResponseBase): Observable<TemplateFieldInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateFieldInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Document Template
     * @param body (optional) 
     * @return OK
     */
    createDocumentTemplate(body?: CreateDocumentTemplateDto | undefined): Observable<CreateDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/CreateDocumentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDocumentTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDocumentTemplateDto>;
        }));
    }

    protected processCreateDocumentTemplate(response: HttpResponseBase): Observable<CreateDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks asynchronously whether a document template exists for the given client type and document type.
     * @param clientType (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    getIsTemplateExist(clientType?: ClientType | undefined, documentType?: TicketHolderDocumentType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetIsTemplateExist?";
        if (clientType === null)
            throw new Error("The parameter 'clientType' cannot be null.");
        else if (clientType !== undefined)
            url_ += "ClientType=" + encodeURIComponent("" + clientType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsTemplateExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsTemplateExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIsTemplateExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Document Template
     * @param body (optional) 
     * @return OK
     */
    updateDocumentTemplate(body?: UpdateDocumentTemplateDto | undefined): Observable<UpdateDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateDocumentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDocumentTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDocumentTemplateDto>;
        }));
    }

    protected processUpdateDocumentTemplate(response: HttpResponseBase): Observable<UpdateDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Document Template based on the Filter
     * @param body (optional) 
     * @return OK
     */
    getAllDocumentTemplates(body?: DocumentTemplateFilter | undefined): Observable<PagedResultDtoOfGetDocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetAllDocumentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDocumentTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDocumentTemplateDto>;
        }));
    }

    protected processGetAllDocumentTemplates(response: HttpResponseBase): Observable<PagedResultDtoOfGetDocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Document Template by TemplateId
     * @return OK
     */
    getDocumentTemplateById(templateId: number, languageId: number): Observable<DocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetDocumentTemplateById?";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTemplateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTemplateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplateDto>;
        }));
    }

    protected processGetDocumentTemplateById(response: HttpResponseBase): Observable<DocumentTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Document Template Details By TemplateId and LanguageId
     * @return OK
     */
    getDocumentTemplateDetailsByTemplateId(templateId: number, languageId: number): Observable<DocumentTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetDocumentTemplateDetailsByTemplateId?";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTemplateDetailsByTemplateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTemplateDetailsByTemplateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplateDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplateDetailsDto>;
        }));
    }

    protected processGetDocumentTemplateDetailsByTemplateId(response: HttpResponseBase): Observable<DocumentTemplateDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds new document template details including optional attachments,
    saves any uploaded files, and links them to the template.
     * @param body (optional) DTO containing the details of the document template to add.
     * @return OK
     */
    addDocumentTemplateDetails(body?: AddDocumentTemplateDetailsDto | undefined): Observable<DocumentTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/AddDocumentTemplateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplateDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplateDetailsDto>;
        }));
    }

    protected processAddDocumentTemplateDetails(response: HttpResponseBase): Observable<DocumentTemplateDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates existing document template details including optional new attachments,
    saves any newly uploaded files, and updates their references in the template.
     * @param body (optional) DTO containing the updated details of the document template.
     * @return OK
     */
    updateDocumentTemplateDetails(body?: UpdateDocumentTemplateDetailsDto | undefined): Observable<DocumentTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateDocumentTemplateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplateDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplateDetailsDto>;
        }));
    }

    protected processUpdateDocumentTemplateDetails(response: HttpResponseBase): Observable<DocumentTemplateDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Document Template By Id
     * @return OK
     */
    deleteDocumentTemplateById(templateId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administration/DeleteDocumentTemplateById?";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined and cannot be null.");
        else
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentTemplateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentTemplateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocumentTemplateById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete TemplateDetails By Id
     * @return OK
     */
    deleteTemplateDetailsById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administration/DeleteTemplateDetailsById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTemplateDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTemplateDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTemplateDetailsById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and optionally filtered list of template languages.
    If a language is already used in the specified template, the language name will be appended with " - Translated".
    The English name is excluded from the result.
     * @param filterText (optional) 
     * @param templateId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTemplateLanguageList(filterText?: string | null | undefined, templateId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfDocumentTemplateLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetTemplateLanguageList?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateLanguageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateLanguageList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDocumentTemplateLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDocumentTemplateLanguageDto>;
        }));
    }

    protected processGetTemplateLanguageList(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentTemplateLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDocumentTemplateLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of uploaded ttw forms with pagination support.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getUploadedTTWForms(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetUploadedTTWForms?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadedTTWForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadedTTWForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDocumentDto>;
        }));
    }

    protected processGetUploadedTTWForms(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all uploaded Document TTW Forms
     * @return OK
     */
    getUploadedDocumentTTWForms(): Observable<DocumentFormGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetUploadedDocumentTTWForms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadedDocumentTTWForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadedDocumentTTWForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentFormGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentFormGroupDto[]>;
        }));
    }

    protected processGetUploadedDocumentTTWForms(response: HttpResponseBase): Observable<DocumentFormGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentFormGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * To get document form info by passing formTypes.
     * @return OK
     */
    getDocumentFormTemplate(id: number): Observable<DocumentFormTemplateResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetDocumentFormTemplate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFormTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFormTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentFormTemplateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentFormTemplateResponseDto>;
        }));
    }

    protected processGetDocumentFormTemplate(response: HttpResponseBase): Observable<DocumentFormTemplateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentFormTemplateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload TTW Forms
     * @param file (optional) 
     * @param documentType (optional) 
     * @param formType (optional) 
     * @param templateStatus (optional) 
     * @param languageId (optional) 
     * @return OK
     */
    addUploadTTWForms(file?: FileParameter | undefined, documentType?: TicketHolderDocumentType | undefined, formType?: TTWFormsType | undefined, templateStatus?: TemplateStatus | undefined, languageId?: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/AddUploadTTWForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (documentType === null || documentType === undefined)
            throw new Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (formType === null || formType === undefined)
            throw new Error("The parameter 'formType' cannot be null.");
        else
            content_.append("FormType", formType.toString());
        if (templateStatus === null || templateStatus === undefined)
            throw new Error("The parameter 'templateStatus' cannot be null.");
        else
            content_.append("TemplateStatus", templateStatus.toString());
        if (languageId === null || languageId === undefined)
            throw new Error("The parameter 'languageId' cannot be null.");
        else
            content_.append("LanguageId", languageId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUploadTTWForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUploadTTWForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processAddUploadTTWForms(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create or update Document form template.
     * @param body (optional) 
     * @return OK
     */
    createDocumentFormTemplate(body?: CreateDocumentFormTemplateDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/CreateDocumentFormTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDocumentFormTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDocumentFormTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateDocumentFormTemplate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete document form template
     * @return OK
     */
    deleteDocumentFormTemplate(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/DeleteDocumentFormTemplate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentFormTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentFormTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteDocumentFormTemplate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks whether a TTW form template exists in the document repository for the specified form type.
     * @param body (optional) The TTW form type to check.
     * @return OK
     */
    isTTWFormsExisted(body?: TTWFormsType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/IsTTWFormsExisted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTTWFormsExisted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTTWFormsExisted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTTWFormsExisted(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * SearchAvailableTwilioNumbers
     * @param body (optional) 
     * @return OK
     */
    searchAvailableTwilioNumbers(body?: SearchAvailableTwilioNumbersInput | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/SearchAvailableTwilioNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAvailableTwilioNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAvailableTwilioNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processSearchAvailableTwilioNumbers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * BuyTwilioPhoneNumber
     * @param body (optional) 
     * @return OK
     */
    buyTwilioPhoneNumber(body?: BuyTwilioPhoneNumberInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Administration/BuyTwilioPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyTwilioPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyTwilioPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBuyTwilioPhoneNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds or updates the DigiSigner API key for the current user and tenant.
     * @param apiKey (optional) The DigiSigner API key to store.
     * @return OK
     */
    addOrUpdateDigiSignerApiKey(apiKey?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/AddOrUpdateDigiSignerApiKey?";
        if (apiKey !== undefined && apiKey !== null)
            url_ += "apiKey=" + encodeURIComponent("" + apiKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateDigiSignerApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateDigiSignerApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateDigiSignerApiKey(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the DigiSigner API key for the currently logged-in user.
     * @return OK
     */
    getDigiSignerApiKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetDigiSignerApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDigiSignerApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDigiSignerApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDigiSignerApiKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the DigiSigner webhook URL configured for the current tenant and user.
     * @return OK
     */
    getDigiSignerWebhookUrl(): Observable<DigiSignerWebHookUrlDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetDigiSignerWebhookUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDigiSignerWebhookUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDigiSignerWebhookUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigiSignerWebHookUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigiSignerWebHookUrlDto>;
        }));
    }

    protected processGetDigiSignerWebhookUrl(response: HttpResponseBase): Observable<DigiSignerWebHookUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DigiSignerWebHookUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ENSettings
     * @return OK
     */
    getENSetting(): Observable<ENSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetENSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetENSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetENSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ENSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ENSettingDto>;
        }));
    }

    protected processGetENSetting(response: HttpResponseBase): Observable<ENSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ENSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * SSA staff suitability presets (tenant settings, edited on SSA Contacts → Suitability Contact): the award number, the
    zip password the guide fixes from it (TTWE + last 4 digits; it cannot be changed), recipients and PerSec POC.
     * @return OK
     */
    getSsaSuitabilitySettings(): Observable<SsaSuitabilitySettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetSsaSuitabilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSsaSuitabilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSsaSuitabilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsaSuitabilitySettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsaSuitabilitySettingsDto>;
        }));
    }

    protected processGetSsaSuitabilitySettings(response: HttpResponseBase): Observable<SsaSuitabilitySettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SsaSuitabilitySettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the SSA staff suitability presets for the current tenant. The zip password follows the award number.
     * @param body (optional) 
     * @return OK
     */
    updateSsaSuitabilitySettings(body?: UpdateSsaSuitabilitySettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateSsaSuitabilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSsaSuitabilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSsaSuitabilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSsaSuitabilitySettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Or Update ENSetting
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateENSetting(body?: CreateOrUpdateENSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Administration/CreateOrUpdateENSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateENSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateENSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateENSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * create task template
     * @param body (optional) 
     * @return OK
     */
    createTaskTemplate(body?: CreateTaskTemplateRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/CreateTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateTaskTemplate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update task template
     * @param body (optional) 
     * @return OK
     */
    updateTaskTemplate(body?: UpdateTaskTemplateRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTaskTemplate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete task template
     * @return OK
     */
    deleteTaskTemplate(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/DeleteTaskTemplate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTaskTemplate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all task tempalte template with pagination
     * @param body (optional) 
     * @return OK
     */
    getAllTaskTemplate(body?: TaskTemplateRequestDto | undefined): Observable<PagedResultDtoOfTTWTaskTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetAllTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTTWTaskTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTTWTaskTemplateDto>;
        }));
    }

    protected processGetAllTaskTemplate(response: HttpResponseBase): Observable<PagedResultDtoOfTTWTaskTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTTWTaskTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all SSA contacts, optionally filtered by role.
     * @param role (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSsaContacts(role?: SsaContactRole | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfSsaContactDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetAllSsaContacts?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSsaContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSsaContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSsaContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSsaContactDto>;
        }));
    }

    protected processGetAllSsaContacts(response: HttpResponseBase): Observable<PagedResultDtoOfSsaContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSsaContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assign a user to an SSA contact role, copying the user's contact info.
     * @param body (optional) 
     * @return OK
     */
    createSsaContact(body?: CreateSsaContactRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/CreateSsaContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSsaContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSsaContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateSsaContact(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the contact details of an existing SSA contact assignment.
     * @param body (optional) 
     * @return OK
     */
    updateSsaContact(body?: UpdateSsaContactRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UpdateSsaContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSsaContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSsaContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateSsaContact(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove an SSA contact role assignment.
     * @return OK
     */
    deleteSsaContact(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/DeleteSsaContact?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSsaContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSsaContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteSsaContact(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get uploaded file in base64.
     * @param body (optional) 
     * @return OK
     */
    getUploadedFilesToBase64(body?: UploadFileOutputDto | undefined): Observable<UploadBase64OutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetUploadedFilesToBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadedFilesToBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadedFilesToBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadBase64OutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadBase64OutputDto>;
        }));
    }

    protected processGetUploadedFilesToBase64(response: HttpResponseBase): Observable<UploadBase64OutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadBase64OutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create IWP Document template
     * @param body (optional) 
     * @return OK
     */
    uploadDocumentFormTemplateFile(body?: UploadFileForDocumentFormTemplateDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/UploadDocumentFormTemplateFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocumentFormTemplateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocumentFormTemplateFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadDocumentFormTemplateFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get predefined Document drag and drop lists.
     * @param formName (optional) 
     * @return OK
     */
    getValidPredefinedFieldsByFormName(formName?: string | null | undefined): Observable<PredefinedFieldResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GetValidPredefinedFieldsByFormName?";
        if (formName !== undefined && formName !== null)
            url_ += "formName=" + encodeURIComponent("" + formName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidPredefinedFieldsByFormName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidPredefinedFieldsByFormName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredefinedFieldResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredefinedFieldResponseDto[]>;
        }));
    }

    protected processGetValidPredefinedFieldsByFormName(response: HttpResponseBase): Observable<PredefinedFieldResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PredefinedFieldResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete document file of document form Template
     * @param documentId (optional) 
     * @param uploadId (optional) 
     * @return OK
     */
    deleteDocumentFormTemplateFile(documentId?: number | null | undefined, uploadId?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Administration/DeleteDocumentFormTemplateFile?";
        if (documentId !== undefined && documentId !== null)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (uploadId !== undefined && uploadId !== null)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentFormTemplateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentFormTemplateFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteDocumentFormTemplateFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateAiCostInvoice(body?: AiCostInvoiceInputDto | undefined): Observable<AiCostInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Administration/GenerateAiCostInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAiCostInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAiCostInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiCostInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiCostInvoiceDto>;
        }));
    }

    protected processGenerateAiCostInvoice(response: HttpResponseBase): Observable<AiCostInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiCostInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AIAgentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get AI completion using the configured provider
     * @param body (optional) 
     * @return OK
     */
    getCompletion(body?: AICompletionRequest | undefined): Observable<AICompletionResponse> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/GetCompletion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AICompletionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AICompletionResponse>;
        }));
    }

    protected processGetCompletion(response: HttpResponseBase): Observable<AICompletionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AICompletionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get AI completion using a specific provider
     * @param prompt (optional) 
     * @param systemMessage (optional) 
     * @param conversationHistory (optional) 
     * @param maxTokens (optional) 
     * @param temperature (optional) 
     * @param model (optional) 
     * @param topP (optional) 
     * @param frequencyPenalty (optional) 
     * @param presencePenalty (optional) 
     * @param images (optional) 
     * @param providerName (optional) 
     * @return OK
     */
    getCompletionWithProvider(prompt?: string | null | undefined, systemMessage?: string | null | undefined, conversationHistory?: AIMessage[] | null | undefined, maxTokens?: number | null | undefined, temperature?: number | null | undefined, model?: string | null | undefined, topP?: number | null | undefined, frequencyPenalty?: number | null | undefined, presencePenalty?: number | null | undefined, images?: AIImageAttachment[] | null | undefined, providerName?: string | null | undefined): Observable<AICompletionResponse> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/GetCompletionWithProvider?";
        if (prompt !== undefined && prompt !== null)
            url_ += "Prompt=" + encodeURIComponent("" + prompt) + "&";
        if (systemMessage !== undefined && systemMessage !== null)
            url_ += "SystemMessage=" + encodeURIComponent("" + systemMessage) + "&";
        if (conversationHistory !== undefined && conversationHistory !== null)
            conversationHistory && conversationHistory.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "ConversationHistory[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (maxTokens !== undefined && maxTokens !== null)
            url_ += "MaxTokens=" + encodeURIComponent("" + maxTokens) + "&";
        if (temperature !== undefined && temperature !== null)
            url_ += "Temperature=" + encodeURIComponent("" + temperature) + "&";
        if (model !== undefined && model !== null)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (topP !== undefined && topP !== null)
            url_ += "TopP=" + encodeURIComponent("" + topP) + "&";
        if (frequencyPenalty !== undefined && frequencyPenalty !== null)
            url_ += "FrequencyPenalty=" + encodeURIComponent("" + frequencyPenalty) + "&";
        if (presencePenalty !== undefined && presencePenalty !== null)
            url_ += "PresencePenalty=" + encodeURIComponent("" + presencePenalty) + "&";
        if (images !== undefined && images !== null)
            images && images.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Images[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (providerName !== undefined && providerName !== null)
            url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletionWithProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletionWithProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AICompletionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AICompletionResponse>;
        }));
    }

    protected processGetCompletionWithProvider(response: HttpResponseBase): Observable<AICompletionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AICompletionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if the configured AI provider is available
     * @return OK
     */
    isAvailable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/IsAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if a specific AI provider is available
     * @param providerName (optional) 
     * @return OK
     */
    isProviderAvailable(providerName?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/IsProviderAvailable?";
        if (providerName !== undefined && providerName !== null)
            url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsProviderAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsProviderAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsProviderAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the currently configured provider name
     * @return OK
     */
    getConfiguredProvider(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/GetConfiguredProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguredProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguredProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConfiguredProvider(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generate eight IWP sections for a Ticket to Work participant
     * @param body (optional) 
     * @return OK
     */
    generateIwpSections(body?: GenerateIwpSectionsInput | undefined): Observable<GenerateIwpSectionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/GenerateIwpSections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateIwpSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateIwpSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateIwpSectionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateIwpSectionsOutput>;
        }));
    }

    protected processGenerateIwpSections(response: HttpResponseBase): Observable<GenerateIwpSectionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateIwpSectionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Test AI with a simple prompt
     * @param prompt (optional) 
     * @return OK
     */
    testAI(prompt?: string | null | undefined): Observable<AICompletionResponse> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/TestAI?";
        if (prompt !== undefined && prompt !== null)
            url_ += "prompt=" + encodeURIComponent("" + prompt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestAI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestAI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AICompletionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AICompletionResponse>;
        }));
    }

    protected processTestAI(response: HttpResponseBase): Observable<AICompletionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AICompletionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveIwpGeneratorDraft(body?: SaveIwpGeneratorDraftInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/SaveIwpGeneratorDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIwpGeneratorDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIwpGeneratorDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveIwpGeneratorDraft(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    searchIwpGeneratorDrafts(name?: string | null | undefined): Observable<IwpGeneratorDraftDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AIAgent/SearchIwpGeneratorDrafts?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchIwpGeneratorDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchIwpGeneratorDrafts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IwpGeneratorDraftDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IwpGeneratorDraftDto[]>;
        }));
    }

    protected processSearchIwpGeneratorDrafts(response: HttpResponseBase): Observable<IwpGeneratorDraftDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IwpGeneratorDraftDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AIUsageReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get usage summary for current tenant
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getMyTenantUsageSummary(startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<AIUsageSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AIUsageReport/GetMyTenantUsageSummary?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTenantUsageSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTenantUsageSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIUsageSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIUsageSummaryDto[]>;
        }));
    }

    protected processGetMyTenantUsageSummary(response: HttpResponseBase): Observable<AIUsageSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIUsageSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get detailed usage logs for current tenant
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getMyTenantUsageDetails(startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, maxResultCount?: number | undefined): Observable<AIUsageDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AIUsageReport/GetMyTenantUsageDetails?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTenantUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTenantUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIUsageDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIUsageDetailDto[]>;
        }));
    }

    protected processGetMyTenantUsageDetails(response: HttpResponseBase): Observable<AIUsageDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIUsageDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get usage summary for all tenants (Host only)
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getAllTenantsUsageSummary(startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<AIUsageSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AIUsageReport/GetAllTenantsUsageSummary?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTenantsUsageSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTenantsUsageSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIUsageSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIUsageSummaryDto[]>;
        }));
    }

    protected processGetAllTenantsUsageSummary(response: HttpResponseBase): Observable<AIUsageSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AIUsageSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get total cost for a tenant in a date range
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getTenantTotalCost(startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AIUsageReport/GetTenantTotalCost?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantTotalCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantTotalCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantTotalCost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get usage statistics for current user
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getMyUsageStats(startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<AIUsageSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AIUsageReport/GetMyUsageStats?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyUsageStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyUsageStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AIUsageSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AIUsageSummaryDto>;
        }));
    }

    protected processGetMyUsageStats(response: HttpResponseBase): Observable<AIUsageSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AIUsageSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AiVoiceAgentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAiVoiceAgents(body?: GetAiVoiceAgentsInput | undefined): Observable<PagedResultDtoOfAiVoiceAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/AiVoiceAgent/GetAiVoiceAgents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiVoiceAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiVoiceAgents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAiVoiceAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAiVoiceAgentDto>;
        }));
    }

    protected processGetAiVoiceAgents(response: HttpResponseBase): Observable<PagedResultDtoOfAiVoiceAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAiVoiceAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAiVoiceAgent(id?: number | undefined): Observable<AiVoiceAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/AiVoiceAgent/GetAiVoiceAgent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAiVoiceAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAiVoiceAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiVoiceAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiVoiceAgentDto>;
        }));
    }

    protected processGetAiVoiceAgent(response: HttpResponseBase): Observable<AiVoiceAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiVoiceAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateAiVoiceAgent(body?: CreateUpdateAiVoiceAgentDto | undefined): Observable<AiVoiceAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/AiVoiceAgent/CreateOrUpdateAiVoiceAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAiVoiceAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAiVoiceAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiVoiceAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiVoiceAgentDto>;
        }));
    }

    protected processCreateOrUpdateAiVoiceAgent(response: HttpResponseBase): Observable<AiVoiceAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiVoiceAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteAiVoiceAgent(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AiVoiceAgent/DeleteAiVoiceAgent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAiVoiceAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAiVoiceAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAiVoiceAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    regenerateApiSecret(id?: number | undefined): Observable<AiVoiceAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/AiVoiceAgent/RegenerateApiSecret?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateApiSecret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateApiSecret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiVoiceAgentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiVoiceAgentDto>;
        }));
    }

    protected processRegenerateApiSecret(response: HttpResponseBase): Observable<AiVoiceAgentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiVoiceAgentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogs(startDate?: DateTime | undefined, endDate?: DateTime | undefined, userName?: string | null | undefined, serviceName?: string | null | undefined, methodName?: string | null | undefined, browserInfo?: string | null | undefined, hasException?: boolean | null | undefined, minExecutionDuration?: number | null | undefined, maxExecutionDuration?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAuditLogsToExcel(startDate?: DateTime | undefined, endDate?: DateTime | undefined, userName?: string | null | undefined, serviceName?: string | null | undefined, methodName?: string | null | undefined, browserInfo?: string | null | undefined, hasException?: boolean | null | undefined, minExecutionDuration?: number | null | undefined, maxExecutionDuration?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityChanges(startDate?: DateTime | undefined, endDate?: DateTime | undefined, userName?: string | null | undefined, entityTypeFullName?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityTypeChanges(entityTypeFullName?: string | null | undefined, entityId?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEntityChangesToExcel(startDate?: DateTime | undefined, endDate?: DateTime | undefined, userName?: string | null | undefined, entityTypeFullName?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return OK
     */
    getEntityPropertyChanges(entityChangeId?: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BackgroundJobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param taskInstanceId (optional) 
     * @return OK
     */
    createCancellationTokenForTaskInstance(taskInstanceId?: number | undefined): Observable<CancellationTokenSource> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/CreateCancellationTokenForTaskInstance?";
        if (taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' cannot be null.");
        else if (taskInstanceId !== undefined)
            url_ += "taskInstanceId=" + encodeURIComponent("" + taskInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCancellationTokenForTaskInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCancellationTokenForTaskInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancellationTokenSource>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancellationTokenSource>;
        }));
    }

    protected processCreateCancellationTokenForTaskInstance(response: HttpResponseBase): Observable<CancellationTokenSource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancellationTokenSource.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskInstanceId (optional) 
     * @return OK
     */
    cancelRunningTaskInstance(taskInstanceId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/CancelRunningTaskInstance?";
        if (taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' cannot be null.");
        else if (taskInstanceId !== undefined)
            url_ += "taskInstanceId=" + encodeURIComponent("" + taskInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRunningTaskInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRunningTaskInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelRunningTaskInstance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskInstanceId (optional) 
     * @return OK
     */
    removeCancellationToken(taskInstanceId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/RemoveCancellationToken?";
        if (taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' cannot be null.");
        else if (taskInstanceId !== undefined)
            url_ += "taskInstanceId=" + encodeURIComponent("" + taskInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCancellationToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCancellationToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveCancellationToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskInstanceId (optional) 
     * @return OK
     */
    isTaskInstanceCanceled(taskInstanceId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/IsTaskInstanceCanceled?";
        if (taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' cannot be null.");
        else if (taskInstanceId !== undefined)
            url_ += "taskInstanceId=" + encodeURIComponent("" + taskInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTaskInstanceCanceled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTaskInstanceCanceled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTaskInstanceCanceled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobStatues(): Observable<BackgroundTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/GetJobStatues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobStatues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobStatues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundTaskDto[]>;
        }));
    }

    protected processGetJobStatues(response: HttpResponseBase): Observable<BackgroundTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getJobInstancesByJobId(taskId?: number | undefined): Observable<BackgroundTaskInstanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/GetJobInstancesByJobId?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobInstancesByJobId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobInstancesByJobId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundTaskInstanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundTaskInstanceDto[]>;
        }));
    }

    protected processGetJobInstancesByJobId(response: HttpResponseBase): Observable<BackgroundTaskInstanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundTaskInstanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param instanceId (optional) 
     * @return OK
     */
    getInstanceLogsByInstanceId(instanceId?: number | undefined): Observable<BackgroundTaskInstanceLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/GetInstanceLogsByInstanceId?";
        if (instanceId === null)
            throw new Error("The parameter 'instanceId' cannot be null.");
        else if (instanceId !== undefined)
            url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstanceLogsByInstanceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstanceLogsByInstanceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundTaskInstanceLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundTaskInstanceLogDto[]>;
        }));
    }

    protected processGetInstanceLogsByInstanceId(response: HttpResponseBase): Observable<BackgroundTaskInstanceLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackgroundTaskInstanceLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get list of available on-demand tasks with their parameter schemas
     * @return OK
     */
    getOnDemandTasks(): Observable<OnDemandTaskInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/GetOnDemandTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDemandTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDemandTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnDemandTaskInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnDemandTaskInfoDto[]>;
        }));
    }

    protected processGetOnDemandTasks(response: HttpResponseBase): Observable<OnDemandTaskInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnDemandTaskInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Trigger an on-demand task with optional parameters
     * @param body (optional) 
     * @return OK
     */
    triggerOnDemandTask(body?: TriggerOnDemandTaskInput | undefined): Observable<TriggerTaskOutput> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/TriggerOnDemandTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerOnDemandTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerOnDemandTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerTaskOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerTaskOutput>;
        }));
    }

    protected processTriggerOnDemandTask(response: HttpResponseBase): Observable<TriggerTaskOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TriggerTaskOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param campaignId (optional) 
     * @param status (optional) 
     * @return OK
     */
    cancelCampaignTask(campaignId?: number | undefined, status?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BackgroundJob/CancelCampaignTask?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelCampaignTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelCampaignTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelCampaignTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BenefitsCounselingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param stage (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllBenefitsCounselingCases(filter?: string | null | undefined, stage?: BenefitsCounselingStage | undefined, status?: BenefitsCounselingCaseStatus | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfBenefitsCounselingCaseListDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetAllBenefitsCounselingCases?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (stage === null)
            throw new Error("The parameter 'stage' cannot be null.");
        else if (stage !== undefined)
            url_ += "Stage=" + encodeURIComponent("" + stage) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBenefitsCounselingCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBenefitsCounselingCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBenefitsCounselingCaseListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBenefitsCounselingCaseListDto>;
        }));
    }

    protected processGetAllBenefitsCounselingCases(response: HttpResponseBase): Observable<PagedResultDtoOfBenefitsCounselingCaseListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBenefitsCounselingCaseListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createBenefitsCounselingCase(body?: CreateBenefitsCounselingCaseDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateBenefitsCounselingCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBenefitsCounselingCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBenefitsCounselingCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBenefitsCounselingCase(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getBenefitsCounselingCase(id?: number | undefined): Observable<BenefitsCounselingCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetBenefitsCounselingCase?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitsCounselingCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitsCounselingCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingCaseDto>;
        }));
    }

    protected processGetBenefitsCounselingCase(response: HttpResponseBase): Observable<BenefitsCounselingCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsCounselingCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getBenefitsCounselingCaseByTicketHolderId(ticketHolderId?: number | undefined): Observable<BenefitsCounselingCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetBenefitsCounselingCaseByTicketHolderId?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitsCounselingCaseByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitsCounselingCaseByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingCaseDto>;
        }));
    }

    protected processGetBenefitsCounselingCaseByTicketHolderId(response: HttpResponseBase): Observable<BenefitsCounselingCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsCounselingCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBenefitsCounselingCase(body?: UpdateBenefitsCounselingCaseDto | undefined): Observable<BenefitsCounselingCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/UpdateBenefitsCounselingCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBenefitsCounselingCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBenefitsCounselingCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingCaseDto>;
        }));
    }

    protected processUpdateBenefitsCounselingCase(response: HttpResponseBase): Observable<BenefitsCounselingCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsCounselingCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getBenefitsFollowUpRecords(benefitsCounselingCaseId?: number | undefined): Observable<MyCalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetBenefitsFollowUpRecords?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitsFollowUpRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitsFollowUpRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyCalendarDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyCalendarDto[]>;
        }));
    }

    protected processGetBenefitsFollowUpRecords(response: HttpResponseBase): Observable<MyCalendarDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyCalendarDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setBenefitsFollowUpRecordIds(body?: UpdateBenefitsFollowUpRecordIdsInput | undefined): Observable<BenefitsCounselingCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/SetBenefitsFollowUpRecordIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBenefitsFollowUpRecordIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBenefitsFollowUpRecordIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingCaseDto>;
        }));
    }

    protected processSetBenefitsFollowUpRecordIds(response: HttpResponseBase): Observable<BenefitsCounselingCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsCounselingCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addBenefitsFollowUpRecord(body?: UpdateBenefitsFollowUpRecordInput | undefined): Observable<BenefitsCounselingCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/AddBenefitsFollowUpRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBenefitsFollowUpRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBenefitsFollowUpRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingCaseDto>;
        }));
    }

    protected processAddBenefitsFollowUpRecord(response: HttpResponseBase): Observable<BenefitsCounselingCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsCounselingCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @param calendarEventId (optional) 
     * @return OK
     */
    removeBenefitsFollowUpRecord(benefitsCounselingCaseId?: number | undefined, calendarEventId?: number | undefined): Observable<BenefitsCounselingCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/RemoveBenefitsFollowUpRecord?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "BenefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        if (calendarEventId === null)
            throw new Error("The parameter 'calendarEventId' cannot be null.");
        else if (calendarEventId !== undefined)
            url_ += "CalendarEventId=" + encodeURIComponent("" + calendarEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveBenefitsFollowUpRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveBenefitsFollowUpRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingCaseDto>;
        }));
    }

    protected processRemoveBenefitsFollowUpRecord(response: HttpResponseBase): Observable<BenefitsCounselingCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsCounselingCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getIntakeByCaseId(benefitsCounselingCaseId?: number | undefined): Observable<IntakeRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetIntakeByCaseId?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntakeByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntakeByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntakeRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntakeRecordDto>;
        }));
    }

    protected processGetIntakeByCaseId(response: HttpResponseBase): Observable<IntakeRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntakeRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateIntake(body?: CreateOrUpdateIntakeRecordDto | undefined): Observable<IntakeRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateOrUpdateIntake";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateIntake(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateIntake(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntakeRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntakeRecordDto>;
        }));
    }

    protected processCreateOrUpdateIntake(response: HttpResponseBase): Observable<IntakeRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntakeRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    generateIntakePdf(benefitsCounselingCaseId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GenerateIntakePdf?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateIntakePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateIntakePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGenerateIntakePdf(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCwicUsers(): Observable<CwicUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetCwicUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCwicUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCwicUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CwicUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CwicUserDto[]>;
        }));
    }

    protected processGetCwicUsers(response: HttpResponseBase): Observable<CwicUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CwicUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    createIntakeInvitation(benefitsCounselingCaseId?: number | undefined): Observable<InvitationStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateIntakeInvitation?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIntakeInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIntakeInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitationStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitationStatusDto>;
        }));
    }

    protected processCreateIntakeInvitation(response: HttpResponseBase): Observable<InvitationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getIntakeInvitation(benefitsCounselingCaseId?: number | undefined): Observable<InvitationStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetIntakeInvitation?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntakeInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntakeInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitationStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitationStatusDto>;
        }));
    }

    protected processGetIntakeInvitation(response: HttpResponseBase): Observable<InvitationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    reactivateIntakeInvitation(invitationId?: number | undefined): Observable<InvitationStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/ReactivateIntakeInvitation?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateIntakeInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateIntakeInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitationStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitationStatusDto>;
        }));
    }

    protected processReactivateIntakeInvitation(response: HttpResponseBase): Observable<InvitationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    revokeIntakeInvitation(invitationId?: number | undefined): Observable<InvitationStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/RevokeIntakeInvitation?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeIntakeInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeIntakeInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitationStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitationStatusDto>;
        }));
    }

    protected processRevokeIntakeInvitation(response: HttpResponseBase): Observable<InvitationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitationStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getVerificationRecordsByCaseId(benefitsCounselingCaseId?: number | undefined): Observable<BenefitsVerificationRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetVerificationRecordsByCaseId?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVerificationRecordsByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVerificationRecordsByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsVerificationRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsVerificationRecordDto[]>;
        }));
    }

    protected processGetVerificationRecordsByCaseId(response: HttpResponseBase): Observable<BenefitsVerificationRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BenefitsVerificationRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createVerificationRecord(body?: CreateBenefitsVerificationRecordDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateVerificationRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVerificationRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVerificationRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateVerificationRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateVerificationRecord(body?: UpdateBenefitsVerificationRecordDto | undefined): Observable<BenefitsVerificationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/UpdateVerificationRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVerificationRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVerificationRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsVerificationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsVerificationRecordDto>;
        }));
    }

    protected processUpdateVerificationRecord(response: HttpResponseBase): Observable<BenefitsVerificationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitsVerificationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    areAllBenefitsVerified(benefitsCounselingCaseId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/AreAllBenefitsVerified?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreAllBenefitsVerified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreAllBenefitsVerified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAreAllBenefitsVerified(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getBSAPlanningByCaseId(benefitsCounselingCaseId?: number | undefined): Observable<BSAPlanningRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetBSAPlanningByCaseId?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBSAPlanningByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBSAPlanningByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAPlanningRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAPlanningRecordDto>;
        }));
    }

    protected processGetBSAPlanningByCaseId(response: HttpResponseBase): Observable<BSAPlanningRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAPlanningRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateBSAPlanning(body?: CreateOrUpdateBSAPlanningRecordDto | undefined): Observable<BSAPlanningRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateOrUpdateBSAPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBSAPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBSAPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAPlanningRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAPlanningRecordDto>;
        }));
    }

    protected processCreateOrUpdateBSAPlanning(response: HttpResponseBase): Observable<BSAPlanningRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAPlanningRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadBSAPlanningAttachment(body?: UploadBSAPlanningAttachmentDto | undefined): Observable<BSAPlanningItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/UploadBSAPlanningAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBSAPlanningAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBSAPlanningAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAPlanningItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAPlanningItemDto>;
        }));
    }

    protected processUploadBSAPlanningAttachment(response: HttpResponseBase): Observable<BSAPlanningItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAPlanningItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getBSADeliveryByCaseId(benefitsCounselingCaseId?: number | undefined): Observable<BSARecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetBSADeliveryByCaseId?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBSADeliveryByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBSADeliveryByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSARecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSARecordDto>;
        }));
    }

    protected processGetBSADeliveryByCaseId(response: HttpResponseBase): Observable<BSARecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSARecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateBSADelivery(body?: CreateOrUpdateBSARecordDto | undefined): Observable<BSARecordDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateOrUpdateBSADelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBSADelivery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBSADelivery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSARecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSARecordDto>;
        }));
    }

    protected processCreateOrUpdateBSADelivery(response: HttpResponseBase): Observable<BSARecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSARecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getBSAReportByCaseId(benefitsCounselingCaseId?: number | undefined): Observable<BSAReportDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetBSAReportByCaseId?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBSAReportByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBSAReportByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAReportDto>;
        }));
    }

    protected processGetBSAReportByCaseId(response: HttpResponseBase): Observable<BSAReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateBSAReport(body?: CreateOrUpdateBSAReportDto | undefined): Observable<BSAReportDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateOrUpdateBSAReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateBSAReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBSAReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAReportDto>;
        }));
    }

    protected processCreateOrUpdateBSAReport(response: HttpResponseBase): Observable<BSAReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadBSAReportAttachment(body?: UploadBSAReportAttachmentDto | undefined): Observable<BSAReportItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/UploadBSAReportAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBSAReportAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBSAReportAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAReportItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAReportItemDto>;
        }));
    }

    protected processUploadBSAReportAttachment(response: HttpResponseBase): Observable<BSAReportItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAReportItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    generateBSAReportPdf(benefitsCounselingCaseId?: number | undefined): Observable<BSAReportDto> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GenerateBSAReportPdf?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBSAReportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBSAReportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BSAReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BSAReportDto>;
        }));
    }

    protected processGenerateBSAReportPdf(response: HttpResponseBase): Observable<BSAReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BSAReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param benefitsCounselingCaseId (optional) 
     * @return OK
     */
    getSupportRecordsByCaseId(benefitsCounselingCaseId?: number | undefined): Observable<BenefitsCounselingSupportRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/GetSupportRecordsByCaseId?";
        if (benefitsCounselingCaseId === null)
            throw new Error("The parameter 'benefitsCounselingCaseId' cannot be null.");
        else if (benefitsCounselingCaseId !== undefined)
            url_ += "benefitsCounselingCaseId=" + encodeURIComponent("" + benefitsCounselingCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportRecordsByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportRecordsByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitsCounselingSupportRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitsCounselingSupportRecordDto[]>;
        }));
    }

    protected processGetSupportRecordsByCaseId(response: HttpResponseBase): Observable<BenefitsCounselingSupportRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BenefitsCounselingSupportRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSupportRecord(body?: CreateBenefitsCounselingSupportRecordDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BenefitsCounseling/CreateSupportRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupportRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupportRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSupportRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BillingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Handles uploading one or more paystub files from the client,
    validates file types, saves each file to either Blob or local storage,
    creates corresponding document library entries,
    and enqueues them for wage report processing.
     * @param body (optional) 
     * @return OK
     */
    uploadPaystub(body?: UploadFileOutputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UploadPaystub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPaystub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPaystub(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadPaystub(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads one or more paystub files paired with an extracted wage-data JSON file
    (matched by base file name). For each matched pair, tries to resolve the Ticket Holder
    from the JSON's EmployeeName, find-or-create the matching TicketHolderWorkHistory, and
    create a TicketHolderPayHistory record, enqueueing the wage report as InProgress so it
    shows up in Process Wage Report -> Inprogress Wage Report. Any paystub without a
    matching/parseable data file, or without a resolvable Ticket Holder, falls back to the
    standard Pending manual-review queue.
     * @param body (optional) 
     * @return OK
     */
    uploadPaystubWithData(body?: UploadFileOutputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UploadPaystubWithData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPaystubWithData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPaystubWithData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadPaystubWithData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged and sorted list of wage report processing queue records,
    applying optional filters such as wage file name, creator, source, and removal reason flags.
     * @param body (optional) The filter, paging, and sorting parameters for querying the wage report processing queue.
     * @return OK
     */
    getAllWageReportProcessingQ(body?: WageReportProcessingQFilterDto | undefined): Observable<PagedResultDtoOfWageReportProcessingQDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllWageReportProcessingQ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWageReportProcessingQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWageReportProcessingQ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWageReportProcessingQDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWageReportProcessingQDto>;
        }));
    }

    protected processGetAllWageReportProcessingQ(response: HttpResponseBase): Observable<PagedResultDtoOfWageReportProcessingQDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWageReportProcessingQDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paystub file by its wage report processing queue ID, 
    reads its contents from disk, and returns it as a Base64-encoded 
    document with metadata such as file name, MIME type, size, and 
    uploader details.
     * @param id The unique identifier of the wage report processing queue entry.
    Must be greater than zero.
     * @return OK
     */
    getPaystubFile(id: number): Observable<DocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPaystubFile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaystubFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaystubFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponseDto>;
        }));
    }

    protected processGetPaystubFile(response: HttpResponseBase): Observable<DocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends the wage report processing queue entry's paystub file to the configured AI
    provider and asks it to extract structured pay data from it (employer, pay period,
    hours, rate, gross pay). Used by the "Start Data Entry" form's "Extract Pay Data from
    Wage File" button to pre-fill the form -- the result is always shown for review/edit
    before saving, never applied silently.
     * @param wageReportProcessingQId (optional) 
     * @return OK
     */
    extractPayDataFromWageFile(wageReportProcessingQId?: number | undefined): Observable<WageDataExtractDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/ExtractPayDataFromWageFile?";
        if (wageReportProcessingQId === null)
            throw new Error("The parameter 'wageReportProcessingQId' cannot be null.");
        else if (wageReportProcessingQId !== undefined)
            url_ += "wageReportProcessingQId=" + encodeURIComponent("" + wageReportProcessingQId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtractPayDataFromWageFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtractPayDataFromWageFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WageDataExtractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WageDataExtractDto>;
        }));
    }

    protected processExtractPayDataFromWageFile(response: HttpResponseBase): Observable<WageDataExtractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WageDataExtractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of ticket holders matching the optional filter.
    The search is case-insensitive and matches against FirstName, LastName, and TicketHolderId.
    Only required fields are selected from the database to improve performance.
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTicketHoldersSearch(filter?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetTicketHoldersSearch?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHoldersSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHoldersSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderSearchDto>;
        }));
    }

    protected processGetTicketHoldersSearch(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderSearchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns a ticket holder to an existing wage report processing queue entry.
     * @param body (optional) The assignment details containing the wage report processing queue ID 
    and the ticket holder ID to assign.
     * @return OK
     */
    assignTicketHolderToWageReportProcessingQ(body?: AssignTicketHolderWageProcessingReportQDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/AssignTicketHolderToWageReportProcessingQ";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTicketHolderToWageReportProcessingQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTicketHolderToWageReportProcessingQ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignTicketHolderToWageReportProcessingQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns ticket holders to a batch of wage report processing queue entries in one call
    (the "Save Selected" action). Before saving, entries are split into two groups:
    <list type="bullet"><item>Entries with no extracted pay date (no paired JSON data uploaded) -- there is no
    reliable signal to compare them on, so they are <b>never</b> considered duplicates and
    go straight to being saved.</item><item>Entries that do have an extracted pay date (see
    Thrive.TTW.Billing.Dto.WageDataExtractDto.PayDate) -- among only these, entries selected for the
    same Ticket Holder with the same pay date are treated as duplicate submissions of the
    same paystub: the most recently uploaded entry in each such group is kept, and the rest
    are auto-rejected with Thrive.TTW.WageReportRemovalReason.Duplicate instead of being
    saved.</item></list>
    Every entry that isn't auto-rejected as a duplicate is then saved independently,
    sequentially -- mirroring the one-at-a-time behavior the Angular client previously did
    itself -- so a failure on one entry doesn't stop the rest, and the caller gets a
    per-id outcome with the full exception detail (including inner exceptions) for anything
    that failed.
     * @param body (optional) 
     * @return OK
     */
    assignTicketHolderToWageReportProcessingQBatch(body?: BulkAssignTicketHolderWageProcessingReportQDto | undefined): Observable<BulkWageReportOperationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/AssignTicketHolderToWageReportProcessingQBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTicketHolderToWageReportProcessingQBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTicketHolderToWageReportProcessingQBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkWageReportOperationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkWageReportOperationResultDto>;
        }));
    }

    protected processAssignTicketHolderToWageReportProcessingQBatch(response: HttpResponseBase): Observable<BulkWageReportOperationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkWageReportOperationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Promotes a Pending paystub queue entry (one whose Ticket Holder is already known) to
    InProgress: copies the pending-review file into the Document library as a Paystub
    document, links it, flips the status, and -- if wage-data JSON was captured at upload
    time -- creates the matching pay history. Called both from
    M:Thrive.TTW.Billing.BillingAppService.AssignTicketHolderToWageReportProcessingQAsync(Thrive.TTW.Billing.Dto.AssignTicketHolderWageProcessingReportQDto) and directly after a
    Career Coach uploads a paystub from the Ticket Holder page, so those uploads land
    straight in "Process Wage Report" without a manual assign step. No-ops if the entry
    isn't Pending.
     * @param wageReportProcessingQId (optional) 
     * @return OK
     */
    promotePendingPaystubToProcessing(wageReportProcessingQId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Billing/PromotePendingPaystubToProcessing?";
        if (wageReportProcessingQId === null)
            throw new Error("The parameter 'wageReportProcessingQId' cannot be null.");
        else if (wageReportProcessingQId !== undefined)
            url_ += "wageReportProcessingQId=" + encodeURIComponent("" + wageReportProcessingQId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromotePendingPaystubToProcessing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotePendingPaystubToProcessing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPromotePendingPaystubToProcessing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks a wage report processing queue entry as rejected,
    specifying the reason for removal and updating its status to Thrive.TTW.WageReportProcessingStatus.Completed.
     * @param body (optional) The rejection details, including the wage report queue entry ID and the removal reason.
     * @return OK
     */
    rejectWageReport(body?: RejectionWageReportDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/RejectWageReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectWageReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectWageReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRejectWageReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Rejects a batch of wage report processing queue entries with a single shared reason
    in one call (the "Remove Selected" action). Each entry is processed independently,
    sequentially -- mirroring the one-at-a-time behavior the Angular client previously did
    itself -- so a failure on one entry doesn't stop the rest, and the caller gets a
    per-id outcome.
     * @param body (optional) 
     * @return OK
     */
    rejectWageReportBatch(body?: BulkRejectionWageReportDto | undefined): Observable<BulkWageReportOperationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/RejectWageReportBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectWageReportBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectWageReportBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkWageReportOperationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkWageReportOperationResultDto>;
        }));
    }

    protected processRejectWageReportBatch(response: HttpResponseBase): Observable<BulkWageReportOperationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkWageReportOperationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and optionally filtered list of assigned wage reports,
    joining wage report data with ticket holder details.
     * @param processingStatus (optional) 
     * @param payDateStart (optional) 
     * @param payDateEnd (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllAssignedWageReport(processingStatus?: WageReportProcessingStatus | undefined, payDateStart?: DateTime | null | undefined, payDateEnd?: DateTime | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfAssignedWageReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllAssignedWageReport?";
        if (processingStatus === null)
            throw new Error("The parameter 'processingStatus' cannot be null.");
        else if (processingStatus !== undefined)
            url_ += "ProcessingStatus=" + encodeURIComponent("" + processingStatus) + "&";
        if (payDateStart !== undefined && payDateStart !== null)
            url_ += "PayDateStart=" + encodeURIComponent(payDateStart ? "" + payDateStart.toString() : "") + "&";
        if (payDateEnd !== undefined && payDateEnd !== null)
            url_ += "PayDateEnd=" + encodeURIComponent(payDateEnd ? "" + payDateEnd.toString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignedWageReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignedWageReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAssignedWageReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAssignedWageReportDto>;
        }));
    }

    protected processGetAllAssignedWageReport(response: HttpResponseBase): Observable<PagedResultDtoOfAssignedWageReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAssignedWageReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves detailed information about a Ticket Holder associated with a given Wage Report Processing Queue entry.
     * @param processingQId The unique identifier of the Wage Report Processing Queue entry.  
    Must be greater than zero.
     * @return OK
     */
    getTicketHolderInfoByWageReportProcessingId(processingQId: number): Observable<TicketHolderInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetTicketHolderInfoByWageReportProcessingId?";
        if (processingQId === undefined || processingQId === null)
            throw new Error("The parameter 'processingQId' must be defined and cannot be null.");
        else
            url_ += "processingQId=" + encodeURIComponent("" + processingQId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderInfoByWageReportProcessingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderInfoByWageReportProcessingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderInfoDto>;
        }));
    }

    protected processGetTicketHolderInfoByWageReportProcessingId(response: HttpResponseBase): Observable<TicketHolderInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of all payment requests based on the given filter criteria.
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPaymentRequest(filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllPaymentRequest?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPaymentRequestDto>;
        }));
    }

    protected processGetAllPaymentRequest(response: HttpResponseBase): Observable<PagedResultDtoOfPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of payment request statuses, including ticket holder details.
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPaymentRequestsStatus(filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfPaymentRequestStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllPaymentRequestsStatus?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaymentRequestsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentRequestsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPaymentRequestStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPaymentRequestStatusDto>;
        }));
    }

    protected processGetAllPaymentRequestsStatus(response: HttpResponseBase): Observable<PagedResultDtoOfPaymentRequestStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaymentRequestStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a payment request by its unique identifier.
     * @param paymentRequestId (optional) The ID of the payment request to retrieve.
     * @return OK
     */
    getPaymentRequestById(paymentRequestId?: number | undefined): Observable<PaymentRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPaymentRequestById?";
        if (paymentRequestId === null)
            throw new Error("The parameter 'paymentRequestId' cannot be null.");
        else if (paymentRequestId !== undefined)
            url_ += "paymentRequestId=" + encodeURIComponent("" + paymentRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentRequestDto>;
        }));
    }

    protected processGetPaymentRequestById(response: HttpResponseBase): Observable<PaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged and filtered list of Ticket Holder OSM (Operational Support Material) records
    based on the provided filter criteria. Supports filtering by name, phase/milestone, payment date,
    request date, amount, and denial code, along with paging and sorting.
     * @param ticketHolderName (optional) 
     * @param phaseMilestone (optional) 
     * @param paymentRequestDate (optional) 
     * @param paymentDate (optional) 
     * @param paymentAmount (optional) 
     * @param denialCode (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllTicketHolderOSM(ticketHolderName?: string | null | undefined, phaseMilestone?: string | null | undefined, paymentRequestDate?: DateTime | undefined, paymentDate?: DateTime | null | undefined, paymentAmount?: number | undefined, denialCode?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderOSMDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllTicketHolderOSM?";
        if (ticketHolderName !== undefined && ticketHolderName !== null)
            url_ += "TicketHolderName=" + encodeURIComponent("" + ticketHolderName) + "&";
        if (phaseMilestone !== undefined && phaseMilestone !== null)
            url_ += "PhaseMilestone=" + encodeURIComponent("" + phaseMilestone) + "&";
        if (paymentRequestDate === null)
            throw new Error("The parameter 'paymentRequestDate' cannot be null.");
        else if (paymentRequestDate !== undefined)
            url_ += "PaymentRequestDate=" + encodeURIComponent(paymentRequestDate ? "" + paymentRequestDate.toString() : "") + "&";
        if (paymentDate !== undefined && paymentDate !== null)
            url_ += "PaymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toString() : "") + "&";
        if (paymentAmount === null)
            throw new Error("The parameter 'paymentAmount' cannot be null.");
        else if (paymentAmount !== undefined)
            url_ += "PaymentAmount=" + encodeURIComponent("" + paymentAmount) + "&";
        if (denialCode !== undefined && denialCode !== null)
            url_ += "DenialCode=" + encodeURIComponent("" + denialCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTicketHolderOSM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTicketHolderOSM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderOSMDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderOSMDto>;
        }));
    }

    protected processGetAllTicketHolderOSM(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderOSMDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderOSMDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the work history records associated with a specific ticket holder.
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getWorkHistoryByTicketHolderId(ticketHolderId: number, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetWorkHistoryByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkHistoryByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkHistoryByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderWorkHistoryDto>;
        }));
    }

    protected processGetWorkHistoryByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new work history record for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    addWorkHistory(body?: TicketHolderWorkHistoryDto | undefined): Observable<TicketHolderWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/AddWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderWorkHistoryDto>;
        }));
    }

    protected processAddWorkHistory(response: HttpResponseBase): Observable<TicketHolderWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and sorted list of pay history records for a specific ticket holder.
     * @param ticketHolderId (optional) 
     * @param wageReportProcessingQId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPayHistoryByTicketHolderId(ticketHolderId?: number | undefined, wageReportProcessingQId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<TicketHolderPayHistoryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllPayHistoryByTicketHolderId?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (wageReportProcessingQId !== undefined && wageReportProcessingQId !== null)
            url_ += "WageReportProcessingQId=" + encodeURIComponent("" + wageReportProcessingQId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayHistoryByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayHistoryByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderPayHistoryResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderPayHistoryResultDto>;
        }));
    }

    protected processGetAllPayHistoryByTicketHolderId(response: HttpResponseBase): Observable<TicketHolderPayHistoryResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderPayHistoryResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and sorted list of pay history records for a specific ticket holder and Employer Id.
     * @param employerId (optional) 
     * @param ticketHolderId (optional) 
     * @param wageReportProcessingQId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getPayHistoryByEmployerId(employerId?: number | undefined, ticketHolderId?: number | undefined, wageReportProcessingQId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderPayHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPayHistoryByEmployerId?";
        if (employerId === null)
            throw new Error("The parameter 'employerId' cannot be null.");
        else if (employerId !== undefined)
            url_ += "EmployerId=" + encodeURIComponent("" + employerId) + "&";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (wageReportProcessingQId !== undefined && wageReportProcessingQId !== null)
            url_ += "WageReportProcessingQId=" + encodeURIComponent("" + wageReportProcessingQId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayHistoryByEmployerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayHistoryByEmployerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderPayHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderPayHistoryDto>;
        }));
    }

    protected processGetPayHistoryByEmployerId(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderPayHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderPayHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new pay history record for a ticket holder, including saving and linking an uploaded paystub document.
     * @param body (optional) The Thrive.TTW.Billing.Dto.CreatePayHistoryDto containing pay history details such as employer, pay type, 
    gross pay, and references to the wage report processing queue.
     * @return OK
     */
    addPayHistory(body?: CreatePayHistoryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/AddPayHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPayHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPayHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddPayHistory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePayHistory(body?: UpdatePayHistoryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UpdatePayHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePayHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePayHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePayHistory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Pay hisotry by id
     * @return OK
     */
    deletePayHistoryById(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/DeletePayHistoryById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeletePayHistoryById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a wage report processing queue entry outright (e.g. a paystub upload whose
    extracted data turned out to be a duplicate of an already-logged TicketHolderPayHistory
    record). Cleans up the leftover pending-review physical file, if any; the Document
    library copy (if the paystub had already been assigned) is left alone.
     * @return OK
     */
    deleteWageReportProcessingQ(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/DeleteWageReportProcessingQ?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWageReportProcessingQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWageReportProcessingQ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteWageReportProcessingQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get PayHistory By Id
     * @return OK
     */
    getPayHistoryById(id: number): Observable<TicketHolderPayHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPayHistoryById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderPayHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderPayHistoryDto>;
        }));
    }

    protected processGetPayHistoryById(response: HttpResponseBase): Observable<TicketHolderPayHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderPayHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the processing status of a wage report in the processing queue.
     * @param body (optional) The Thrive.TTW.Billing.Dto.UpdateWageReportStatusDto containing the wage report queue entry ID
    and the desired processing status (Thrive.TTW.WageReportProcessingStatus.InProgress 
    or Thrive.TTW.WageReportProcessingStatus.Completed).
     * @return OK
     */
    updateWageReportStatus(body?: UpdateWageReportStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UpdateWageReportStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWageReportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWageReportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWageReportStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates payment requests for all ticket holders based on their consolidated pay history.
     * @return OK
     */
    generatePaymentRequest(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GeneratePaymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePaymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePaymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGeneratePaymentRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves aggregated information about payment requests,
    including total counts, amounts, unique ticket holders,
    and distribution across phases.
     * @return OK
     */
    getPaymentRequestInfo(): Observable<PaymentRequestInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPaymentRequestInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentRequestInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentRequestInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentRequestInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentRequestInfoDto>;
        }));
    }

    protected processGetPaymentRequestInfo(response: HttpResponseBase): Observable<PaymentRequestInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentRequestInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves detailed information about a ticket holder by their unique identifier.
     * @return OK
     */
    getTicketHolderInfoById(ticketHolderId: number): Observable<TicketHolderInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetTicketHolderInfoById?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderInfoDto>;
        }));
    }

    protected processGetTicketHolderInfoById(response: HttpResponseBase): Observable<TicketHolderInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the work case details of a payment request, including its approval status, 
    work case number, and phase milestone. 
    Throws a Abp.UI.UserFriendlyException if the payment request with the given ID is not found.
     * @param attachment (optional) 
     * @param id (optional) 
     * @param workCaseNumber (optional) 
     * @param phaseMilestoneId (optional) 
     * @return OK
     */
    updateWorkCaseNumber(attachment?: FileParameter | undefined, id?: number | undefined, workCaseNumber?: string | undefined, phaseMilestoneId?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UpdateWorkCaseNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachment === null || attachment === undefined)
            throw new Error("The parameter 'attachment' cannot be null.");
        else
            content_.append("Attachment", attachment.data, attachment.fileName ? attachment.fileName : "Attachment");
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (workCaseNumber === null || workCaseNumber === undefined)
            throw new Error("The parameter 'workCaseNumber' cannot be null.");
        else
            content_.append("WorkCaseNumber", workCaseNumber.toString());
        if (phaseMilestoneId === null || phaseMilestoneId === undefined)
            throw new Error("The parameter 'phaseMilestoneId' cannot be null.");
        else
            content_.append("PhaseMilestoneId", phaseMilestoneId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkCaseNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkCaseNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWorkCaseNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the activity history associated with a specific payment request.
     * @param paymentRequestId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getPaymentRequestAssociatedContactHistory(paymentRequestId?: number | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPaymentRequestAssociatedContactHistory?";
        if (paymentRequestId === null)
            throw new Error("The parameter 'paymentRequestId' cannot be null.");
        else if (paymentRequestId !== undefined)
            url_ += "PaymentRequestId=" + encodeURIComponent("" + paymentRequestId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentRequestAssociatedContactHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentRequestAssociatedContactHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderActivityDto>;
        }));
    }

    protected processGetPaymentRequestAssociatedContactHistory(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Payment Request Filled Form
     * @return OK
     */
    getFilledForm1391FileByPaymentRequestId(paymentRequestId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetFilledForm1391FileByPaymentRequestId?";
        if (paymentRequestId === undefined || paymentRequestId === null)
            throw new Error("The parameter 'paymentRequestId' must be defined and cannot be null.");
        else
            url_ += "paymentRequestId=" + encodeURIComponent("" + paymentRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilledForm1391FileByPaymentRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilledForm1391FileByPaymentRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFilledForm1391FileByPaymentRequestId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates and merges a PDF document containing a summary of the payment request,
    the cover page, calculated pay history, and paystubs. The generated document is saved
    and associated with the provided payment request.
     * @return OK
     */
    getPaymentRequestCompletedDoc(paymentRequestId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPaymentRequestCompletedDoc?";
        if (paymentRequestId === undefined || paymentRequestId === null)
            throw new Error("The parameter 'paymentRequestId' must be defined and cannot be null.");
        else
            url_ += "paymentRequestId=" + encodeURIComponent("" + paymentRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentRequestCompletedDoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentRequestCompletedDoc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPaymentRequestCompletedDoc(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates all PhaseMilestone IDs for the current year
    using the PhaseMilestoneStage enum and mapping logic.
     * @return OK
     */
    getAllPhaseMileStone(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllPhaseMileStone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPhaseMileStone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPhaseMileStone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllPhaseMileStone(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends a payment request document to the Social Security Administration (SSA) via the configured fax provider.
     * @return OK
     */
    sendPaymentRequestFaxToSSA(paymentRequestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/SendPaymentRequestFaxToSSA?";
        if (paymentRequestId === undefined || paymentRequestId === null)
            throw new Error("The parameter 'paymentRequestId' must be defined and cannot be null.");
        else
            url_ += "paymentRequestId=" + encodeURIComponent("" + paymentRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPaymentRequestFaxToSSA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPaymentRequestFaxToSSA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendPaymentRequestFaxToSSA(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Payment Request Status and other resonses after receiving from SSA
     * @param body (optional) 
     * @return OK
     */
    updatePaymentRequestStatus(body?: UpdatePaymentRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UpdatePaymentRequestStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePaymentRequestStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get all wage data search request.
     * @param body (optional) 
     * @return OK
     */
    getAllWageDataSearchRequest(body?: WageDataSearchRequestFilterDto | undefined): Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllWageDataSearchRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWageDataSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWageDataSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto>;
        }));
    }

    protected processGetAllWageDataSearchRequest(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderWageDataSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update wage data status and notes.
     * @param body (optional) 
     * @return OK
     */
    updateWageDataSearchRequestStatus(body?: UpdateWageDataSearchRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/UpdateWageDataSearchRequestStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWageDataSearchRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWageDataSearchRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWageDataSearchRequestStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all employer name on behalf of ticketHolder
     * @return OK
     */
    getAllEmployerIdAndName(ticketHolderId: number): Observable<TicketHolderEmployerIdAndNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllEmployerIdAndName?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployerIdAndName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployerIdAndName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderEmployerIdAndNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderEmployerIdAndNameDto[]>;
        }));
    }

    protected processGetAllEmployerIdAndName(response: HttpResponseBase): Observable<TicketHolderEmployerIdAndNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderEmployerIdAndNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTicketHolderIdAndName(filter?: string | null | undefined): Observable<TicketHolderIdAndNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetTicketHolderIdAndName?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderIdAndName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderIdAndName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderIdAndNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderIdAndNameDto[]>;
        }));
    }

    protected processGetTicketHolderIdAndName(response: HttpResponseBase): Observable<TicketHolderIdAndNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderIdAndNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active ticket holders
     * @param body (optional) 
     * @return OK
     */
    getActiveTicketHolder(body?: ActiveTicketHolderRequestDto | undefined): Observable<PagedResultDtoOfActiveTicketHolderDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetActiveTicketHolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfActiveTicketHolderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfActiveTicketHolderDto>;
        }));
    }

    protected processGetActiveTicketHolder(response: HttpResponseBase): Observable<PagedResultDtoOfActiveTicketHolderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActiveTicketHolderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllPayHistoryByTH(body?: PayHistoryRequestDto | undefined): Observable<TicketHolderPayHistoryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetAllPayHistoryByTH";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayHistoryByTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayHistoryByTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderPayHistoryResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderPayHistoryResultDto>;
        }));
    }

    protected processGetAllPayHistoryByTH(response: HttpResponseBase): Observable<TicketHolderPayHistoryResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderPayHistoryResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTicketHolderBillingInfo(ticketHolderId: number): Observable<TicketHolderBillingDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetTicketHolderBillingInfo?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderBillingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderBillingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderBillingDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderBillingDashboardDto>;
        }));
    }

    protected processGetTicketHolderBillingInfo(response: HttpResponseBase): Observable<TicketHolderBillingDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderBillingDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTHEmployerList(ticketHolderId: number): Observable<TicketHolderEmployerList[]> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetTHEmployerList?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHEmployerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHEmployerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderEmployerList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderEmployerList[]>;
        }));
    }

    protected processGetTHEmployerList(response: HttpResponseBase): Observable<TicketHolderEmployerList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderEmployerList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload file to save for background process.
     * @param body (optional) 
     * @return OK
     */
    fileUpload(body?: UploadFileOutputDto | undefined): Observable<OsmUploadQueueItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Billing/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OsmUploadQueueItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OsmUploadQueueItemDto[]>;
        }));
    }

    protected processFileUpload(response: HttpResponseBase): Observable<OsmUploadQueueItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OsmUploadQueueItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start OSM File Processing in background.
     * @return OK
     */
    startOSMFileProcessing(fileProcessingQueueId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Billing/StartOSMFileProcessing?";
        if (fileProcessingQueueId === undefined || fileProcessingQueueId === null)
            throw new Error("The parameter 'fileProcessingQueueId' must be defined and cannot be null.");
        else
            url_ += "fileProcessingQueueId=" + encodeURIComponent("" + fileProcessingQueueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOSMFileProcessing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOSMFileProcessing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processStartOSMFileProcessing(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get uploaded OSM file list.
     * @param filtertext (optional) 
     * @param uploadedByFilter (optional) 
     * @param uploadStartFilter (optional) 
     * @param uploadEndFilter (optional) 
     * @param importBatchId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOsmImportHistory(filtertext?: string | null | undefined, uploadedByFilter?: number | undefined, uploadStartFilter?: DateTime | undefined, uploadEndFilter?: DateTime | undefined, importBatchId?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfOsmImportHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetOsmImportHistory?";
        if (filtertext !== undefined && filtertext !== null)
            url_ += "Filtertext=" + encodeURIComponent("" + filtertext) + "&";
        if (uploadedByFilter === null)
            throw new Error("The parameter 'uploadedByFilter' cannot be null.");
        else if (uploadedByFilter !== undefined)
            url_ += "UploadedByFilter=" + encodeURIComponent("" + uploadedByFilter) + "&";
        if (uploadStartFilter === null)
            throw new Error("The parameter 'uploadStartFilter' cannot be null.");
        else if (uploadStartFilter !== undefined)
            url_ += "UploadStartFilter=" + encodeURIComponent(uploadStartFilter ? "" + uploadStartFilter.toString() : "") + "&";
        if (uploadEndFilter === null)
            throw new Error("The parameter 'uploadEndFilter' cannot be null.");
        else if (uploadEndFilter !== undefined)
            url_ += "UploadEndFilter=" + encodeURIComponent(uploadEndFilter ? "" + uploadEndFilter.toString() : "") + "&";
        if (importBatchId !== undefined && importBatchId !== null)
            url_ += "ImportBatchId=" + encodeURIComponent("" + importBatchId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOsmImportHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOsmImportHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOsmImportHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOsmImportHistoryDto>;
        }));
    }

    protected processGetOsmImportHistory(response: HttpResponseBase): Observable<PagedResultDtoOfOsmImportHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOsmImportHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMilestoneTimeline(ticketHolderId: number): Observable<MilestoneTimelineDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetMilestoneTimeline?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMilestoneTimeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMilestoneTimeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MilestoneTimelineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MilestoneTimelineDto>;
        }));
    }

    protected processGetMilestoneTimeline(response: HttpResponseBase): Observable<MilestoneTimelineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MilestoneTimelineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSSAOSMData(ticketHolderId: number): Observable<TicketHolderOSMDtos[]> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetSSAOSMData?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSSAOSMData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSSAOSMData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderOSMDtos[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderOSMDtos[]>;
        }));
    }

    protected processGetSSAOSMData(response: HttpResponseBase): Observable<TicketHolderOSMDtos[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderOSMDtos.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getPortalBillPendingQueue(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfPortalBillQueueResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Billing/GetPortalBillPendingQueue?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalBillPendingQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalBillPendingQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPortalBillQueueResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPortalBillQueueResponseDto>;
        }));
    }

    protected processGetPortalBillPendingQueue(response: HttpResponseBase): Observable<PagedResultDtoOfPortalBillQueueResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPortalBillQueueResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    clearCache(body?: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    canClearAllCaches(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Caching/CanClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanClearAllCaches(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CampaignServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the most recently created matching lead recipients (up to
    Thrive.TTW.Campaign.CampaignService.MaxLeadRecipientPreview), newest first.
     * @param city (optional) 
     * @param stateAbbreviation (optional) 
     * @param zipCode (optional) 
     * @param timeZone (optional) 
     * @param importBatchId (optional) 
     * @param campaignType (optional) 
     * @param fetchAll (optional) 
     * @param filterStateCodes (optional) 
     * @param filterInTimeZones (optional) 
     * @return OK
     */
    getLeadRecipients(city?: string | null | undefined, stateAbbreviation?: string | null | undefined, zipCode?: string | null | undefined, timeZone?: USATimeZone | undefined, importBatchId?: string | null | undefined, campaignType?: CampaignType | undefined, fetchAll?: boolean | undefined, filterStateCodes?: string[] | null | undefined, filterInTimeZones?: string[] | null | undefined): Observable<RecipientsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetLeadRecipients?";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (stateAbbreviation !== undefined && stateAbbreviation !== null)
            url_ += "StateAbbreviation=" + encodeURIComponent("" + stateAbbreviation) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (timeZone === null)
            throw new Error("The parameter 'timeZone' cannot be null.");
        else if (timeZone !== undefined)
            url_ += "TimeZone=" + encodeURIComponent("" + timeZone) + "&";
        if (importBatchId !== undefined && importBatchId !== null)
            url_ += "ImportBatchId=" + encodeURIComponent("" + importBatchId) + "&";
        if (campaignType === null)
            throw new Error("The parameter 'campaignType' cannot be null.");
        else if (campaignType !== undefined)
            url_ += "CampaignType=" + encodeURIComponent("" + campaignType) + "&";
        if (fetchAll === null)
            throw new Error("The parameter 'fetchAll' cannot be null.");
        else if (fetchAll !== undefined)
            url_ += "FetchAll=" + encodeURIComponent("" + fetchAll) + "&";
        if (filterStateCodes !== undefined && filterStateCodes !== null)
            filterStateCodes && filterStateCodes.forEach(item => { url_ += "FilterStateCodes=" + encodeURIComponent("" + item) + "&"; });
        if (filterInTimeZones !== undefined && filterInTimeZones !== null)
            filterInTimeZones && filterInTimeZones.forEach(item => { url_ += "FilterInTimeZones=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadRecipients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadRecipients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipientsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipientsDto[]>;
        }));
    }

    protected processGetLeadRecipients(response: HttpResponseBase): Observable<RecipientsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipientsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Lead Recipients data to send the campaign
     * @param city (optional) 
     * @param stateAbbreviation (optional) 
     * @param zipCode (optional) 
     * @param timeZone (optional) 
     * @param campaignType (optional) 
     * @param filterDataSource (optional) 
     * @param filterFromBatchId (optional) 
     * @param filterStateCodes (optional) 
     * @param filterInTimeZones (optional) 
     * @return OK
     */
    getTicketHolderRecipients(city?: string | null | undefined, stateAbbreviation?: string | null | undefined, zipCode?: string | null | undefined, timeZone?: USATimeZone | undefined, campaignType?: CampaignType | undefined, filterDataSource?: CampaignDataSource | undefined, filterFromBatchId?: string | null | undefined, filterStateCodes?: string[] | null | undefined, filterInTimeZones?: string[] | null | undefined): Observable<RecipientsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetTicketHolderRecipients?";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (stateAbbreviation !== undefined && stateAbbreviation !== null)
            url_ += "StateAbbreviation=" + encodeURIComponent("" + stateAbbreviation) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (timeZone === null)
            throw new Error("The parameter 'timeZone' cannot be null.");
        else if (timeZone !== undefined)
            url_ += "TimeZone=" + encodeURIComponent("" + timeZone) + "&";
        if (campaignType === null)
            throw new Error("The parameter 'campaignType' cannot be null.");
        else if (campaignType !== undefined)
            url_ += "CampaignType=" + encodeURIComponent("" + campaignType) + "&";
        if (filterDataSource === null)
            throw new Error("The parameter 'filterDataSource' cannot be null.");
        else if (filterDataSource !== undefined)
            url_ += "FilterDataSource=" + encodeURIComponent("" + filterDataSource) + "&";
        if (filterFromBatchId !== undefined && filterFromBatchId !== null)
            url_ += "FilterFromBatchId=" + encodeURIComponent("" + filterFromBatchId) + "&";
        if (filterStateCodes !== undefined && filterStateCodes !== null)
            filterStateCodes && filterStateCodes.forEach(item => { url_ += "FilterStateCodes=" + encodeURIComponent("" + item) + "&"; });
        if (filterInTimeZones !== undefined && filterInTimeZones !== null)
            filterInTimeZones && filterInTimeZones.forEach(item => { url_ += "FilterInTimeZones=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderRecipients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderRecipients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecipientsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecipientsDto[]>;
        }));
    }

    protected processGetTicketHolderRecipients(response: HttpResponseBase): Observable<RecipientsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecipientsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Asynchronously creates a campaign based on the provided input.
    Depending on the campaign type, it delegates the processing to the appropriate method.
     * @param body (optional) The campaign details encapsulated in the CampaignDto object.
     * @return OK
     */
    createCampaign(body?: CampaignInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/CreateCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing campaign by validating input, resetting its status to Draft,
    updating recipients, and reassigning a new background job.
     * @param body (optional) The campaign data to update.
     * @return OK
     */
    updateCampaign(body?: CampaignUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/UpdateCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the all campaign including sms and email
     * @param body (optional) 
     * @return OK
     */
    getAllCampaign(body?: CampaignFilterDto | undefined): Observable<PagedResultDtoOfCampaignDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetAllCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCampaignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCampaignDto>;
        }));
    }

    protected processGetAllCampaign(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCampaignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Attempts to pause a campaign by deleting its background task and updating its status to Paused.
    Only campaigns in Active status are eligible.
     * @param campaignId (optional) The unique ID of the campaign to pause.
     * @return OK
     */
    updatePauseCampaignById(campaignId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/UpdatePauseCampaignById?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePauseCampaignById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePauseCampaignById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePauseCampaignById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resumes a paused campaign by scheduling its background job.
    Only campaigns in 'Paused' status are eligible.
     * @param campaignId (optional) The campaign ID to resume.
     * @return OK
     */
    updateResumeCampaignById(campaignId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/UpdateResumeCampaignById?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResumeCampaignById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResumeCampaignById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateResumeCampaignById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pause All Campaign which are scheduled
     * @return OK
     */
    updatePauseAllCampaign(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/UpdatePauseAllCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePauseAllCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePauseAllCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdatePauseAllCampaign(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resume all campaign which needs to be run
     * @return OK
     */
    updateResumeAllCampaign(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/UpdateResumeAllCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResumeAllCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResumeAllCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateResumeAllCampaign(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the all recipients related to the specific campaign
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllRecipientsByCampaignId(campaignId: number, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCampaignRecipientDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetAllRecipientsByCampaignId?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRecipientsByCampaignId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRecipientsByCampaignId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCampaignRecipientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCampaignRecipientDto>;
        }));
    }

    protected processGetAllRecipientsByCampaignId(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignRecipientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCampaignRecipientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a campaign by its ID. 
    Ensures the campaign exists, validates the associated task,
    deletes the background job if present, and then deletes the campaign.
     * @param campaignId The ID of the campaign to delete.
     * @return OK
     */
    deleteCampaignById(campaignId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/DeleteCampaignById?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCampaignById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCampaignById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCampaignById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Manually resumes a Voice Campaign's calling run that's currently Paused for an
    outside-calling-window reason (past today's stop-calling cutoff, or a weekend) —
    MaintenanceConsole's CampaignVoiceTask already auto-resumes this on its own, the next
    business day poll before the cutoff (see CampaignCommunicationService.
    ResumePausedVoiceCampaignQueuesAsync), so this only lets a coach/admin skip the wait
    instead of relying purely on that poll. It still enforces the exact same rules the
    automatic path does — this does NOT let anyone dial outside the configured calling
    window, EndDate included.
     * @param campaignId The Voice campaign whose paused run should be resumed.
     * @return OK
     */
    resumeVoiceCampaignCallingById(campaignId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/ResumeVoiceCampaignCallingById?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeVoiceCampaignCallingById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeVoiceCampaignCallingById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResumeVoiceCampaignCallingById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Permanently stops a Voice Campaign's calling run — whether it's currently Paused
    (waiting for the next business day) or still actively InProgress — instead of letting
    it resume automatically. Marks the campaign Sent (finished, for good), the same terminal
    state EndDate closing normally leads to, so it's never picked up by
    ResumePausedVoiceCampaignQueuesAsync again. Any call already ringing is left alone —
    this only prevents further dialing, same as LeadService.StopRetellCallsAsync does for
    the Lead Queue's own "Stop" button.
     * @param campaignId The Voice campaign to stop for good.
     * @return OK
     */
    stopVoiceCampaignCallingById(campaignId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/StopVoiceCampaignCallingById?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopVoiceCampaignCallingById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopVoiceCampaignCallingById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processStopVoiceCampaignCallingById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Campaign Log by using Task Id
     * @param taskId (optional) 
     * @return OK
     */
    getCampaignLogByTaskId(taskId?: number | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetCampaignLogByTaskId?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignLogByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignLogByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogDto[]>;
        }));
    }

    protected processGetCampaignLogByTaskId(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * See ICampaignService.GetCampaignLogByTaskInstanceIdAsync — looks up logs for this
    campaign's own execution instance directly, instead of guessing at "the first instance"
    for a TaskId shared by every run of the same poller task.
     * @param taskInstanceId (optional) 
     * @return OK
     */
    getCampaignLogByTaskInstanceId(taskInstanceId?: number | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetCampaignLogByTaskInstanceId?";
        if (taskInstanceId === null)
            throw new Error("The parameter 'taskInstanceId' cannot be null.");
        else if (taskInstanceId !== undefined)
            url_ += "taskInstanceId=" + encodeURIComponent("" + taskInstanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignLogByTaskInstanceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignLogByTaskInstanceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogDto[]>;
        }));
    }

    protected processGetCampaignLogByTaskInstanceId(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a campaign by its unique ID.
     * @param campaignId The ID of the campaign to retrieve. Must be greater than zero.
     * @return OK
     */
    getCampaignById(campaignId: number): Observable<CampaignDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetCampaignById?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto>;
        }));
    }

    protected processGetCampaignById(response: HttpResponseBase): Observable<CampaignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of all sent campaigns (campaign history) with optional sorting.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCampaignHistory(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCampaignHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetAllCampaignHistory?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCampaignHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCampaignHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCampaignHistoryDto>;
        }));
    }

    protected processGetAllCampaignHistory(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCampaignHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves detailed campaign history by campaign ID.
     * @param campaignId The unique identifier of the campaign.
     * @return OK
     */
    getCampaignHistoryById(campaignId: number): Observable<CampaignHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetCampaignHistoryById?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignHistoryDto>;
        }));
    }

    protected processGetCampaignHistoryById(response: HttpResponseBase): Observable<CampaignHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and sorted list of recipients associated with a specific campaign.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getCampaignRecipientsByCampaignId(campaignId: number, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCampaignRecipientDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetCampaignRecipientsByCampaignId?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaignRecipientsByCampaignId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignRecipientsByCampaignId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCampaignRecipientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCampaignRecipientDto>;
        }));
    }

    protected processGetCampaignRecipientsByCampaignId(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignRecipientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCampaignRecipientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves an SMS log entry by its unique LogId.
     * @param logId The unique identifier of the SMS log entry. Must be greater than zero.
     * @return OK
     */
    getSmsLogByLogId(logId: number): Observable<SmsLogDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetSmsLogByLogId?";
        if (logId === undefined || logId === null)
            throw new Error("The parameter 'logId' must be defined and cannot be null.");
        else
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmsLogByLogId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmsLogByLogId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmsLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmsLogDto>;
        }));
    }

    protected processGetSmsLogByLogId(response: HttpResponseBase): Observable<SmsLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmsLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of distinct batch IDs based on filter criteria.
     * @param batchId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllBatchId(batchId?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetAllBatchId?";
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfString>;
        }));
    }

    protected processGetAllBatchId(response: HttpResponseBase): Observable<PagedResultDtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Lists the current tenant's active AI voice agents for the Voice Campaign wizard's
    agent picker. AiVoiceAgent implements IMustHaveTenant, so this is already scoped to
    the ambient tenant by ABP's own data filter — no manual TenantId check needed.
     * @return OK
     */
    getActiveAiVoiceAgents(): Observable<AiVoiceAgentOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetActiveAiVoiceAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveAiVoiceAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveAiVoiceAgents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AiVoiceAgentOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AiVoiceAgentOptionDto[]>;
        }));
    }

    protected processGetActiveAiVoiceAgents(response: HttpResponseBase): Observable<AiVoiceAgentOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AiVoiceAgentOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves every inbound SMS/Email response tied to a campaign recipient, paired with
    the career coach's next reply (if any).
     * @param body (optional) 
     * @return OK
     */
    getAllCampaignResponses(body?: CampaignResponseFilterDto | undefined): Observable<PagedResultDtoOfCampaignResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/GetAllCampaignResponses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCampaignResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCampaignResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCampaignResponseDto>;
        }));
    }

    protected processGetAllCampaignResponses(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCampaignResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks a campaign response (inbound email/SMS) as "read – no reply needed", so it counts as handled.
    Same effect as "Set as read" on the response's notification.
     * @param channel (optional) "Email" or "SMS" (CampaignResponseDto.Channel).
     * @param id (optional) CampaignResponseDto.Id (the EmailLog/SmsLog id).
     * @return OK
     */
    markCampaignResponseAsRead(channel?: string | null | undefined, id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CampaignService/MarkCampaignResponseAsRead?";
        if (channel !== undefined && channel !== null)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCampaignResponseAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCampaignResponseAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkCampaignResponseAsRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CareerCoachServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Add or Update Career Coach specific documents
     * @param id (optional) 
     * @param file (optional) 
     * @return OK
     */
    addCareerCoachDocument(id?: number | undefined, file?: FileParameter | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/AddCareerCoachDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCareerCoachDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCareerCoachDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processAddCareerCoachDocument(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Mail for posting
     * @param body (optional) 
     * @return OK
     */
    sendMail(body?: MailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/SendMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a follow-up calendar event for a specific Ticket Holder.
     * @param body (optional) Details of the follow-up
     * @return OK
     */
    createFollowup(body?: CreateFollowupDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/CreateFollowup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFollowup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFollowup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateFollowup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Message Template for the Fax, SMS, Email etc..
     * @param templateName (optional) 
     * @param templateType (optional) 
     * @param subject (optional) 
     * @param body (optional) 
     * @param languageId (optional) 
     * @param templateStatus (optional) 
     * @param leadId (optional) 
     * @param ticketHolderId (optional) 
     * @param isSystemTemplate (optional) 
     * @param attachments (optional) 
     * @return OK
     */
    createMessageTemplate(templateName?: string | undefined, templateType?: MessageTemplateType | undefined, subject?: string | undefined, body?: string | undefined, languageId?: number | undefined, templateStatus?: TemplateStatus | undefined, leadId?: number | undefined, ticketHolderId?: number | undefined, isSystemTemplate?: boolean | undefined, attachments?: FileParameter[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/CreateMessageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (templateName === null || templateName === undefined)
            throw new Error("The parameter 'templateName' cannot be null.");
        else
            content_.append("TemplateName", templateName.toString());
        if (templateType === null || templateType === undefined)
            throw new Error("The parameter 'templateType' cannot be null.");
        else
            content_.append("TemplateType", templateType.toString());
        if (subject === null || subject === undefined)
            throw new Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (body === null || body === undefined)
            throw new Error("The parameter 'body' cannot be null.");
        else
            content_.append("Body", body.toString());
        if (languageId === null || languageId === undefined)
            throw new Error("The parameter 'languageId' cannot be null.");
        else
            content_.append("LanguageId", languageId.toString());
        if (templateStatus === null || templateStatus === undefined)
            throw new Error("The parameter 'templateStatus' cannot be null.");
        else
            content_.append("TemplateStatus", templateStatus.toString());
        if (leadId === null || leadId === undefined)
            throw new Error("The parameter 'leadId' cannot be null.");
        else
            content_.append("LeadId", leadId.toString());
        if (ticketHolderId === null || ticketHolderId === undefined)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else
            content_.append("TicketHolderId", ticketHolderId.toString());
        if (isSystemTemplate === null || isSystemTemplate === undefined)
            throw new Error("The parameter 'isSystemTemplate' cannot be null.");
        else
            content_.append("IsSystemTemplate", isSystemTemplate.toString());
        if (attachments === null || attachments === undefined)
            throw new Error("The parameter 'attachments' cannot be null.");
        else
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMessageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateMessageTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a task assigned to another user.
     * @param body (optional) Task details including assignee
     * @return OK
     */
    createTaskForUser(body?: CalendarTaskDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/CreateTaskForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateTaskForUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a reminder calendar event for a ticket holder and the current user.
    This involves creating a calendar event via Microsoft Graph API, scheduling a notification job,
    and storing the event details in the local database.
     * @param body (optional) The reminder details including client ID, ticket holder ID, title, description, and start time.
     * @return OK
     */
    createReminder(body?: CreateReminderDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/CreateReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReminder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing calendar event by its Id.
     * @param eventId (optional) Id of the event to delete
     * @return OK
     */
    deleteCalendarEvent(eventId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/DeleteCalendarEvent?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalendarEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalendarEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteCalendarEvent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Document Career Coach Documents
     * @return OK
     */
    deleteCareerCoachDocuments(documentId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/DeleteCareerCoachDocuments?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined and cannot be null.");
        else
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCareerCoachDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCareerCoachDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteCareerCoachDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the Message Template
     * @param messageTemplateId (optional) 
     * @return OK
     */
    deleteMessageTemplate(messageTemplateId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/DeleteMessageTemplate?";
        if (messageTemplateId === null)
            throw new Error("The parameter 'messageTemplateId' cannot be null.");
        else if (messageTemplateId !== undefined)
            url_ += "messageTemplateId=" + encodeURIComponent("" + messageTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMessageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteMessageTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Disconnect from the Service Provider
     * @param nameOfExternalApi (optional) 
     * @return OK
     */
    disconnectService(nameOfExternalApi?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/DisconnectService?";
        if (nameOfExternalApi !== undefined && nameOfExternalApi !== null)
            url_ += "nameOfExternalApi=" + encodeURIComponent("" + nameOfExternalApi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnectService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnectService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisconnectService(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all advanced search results of the Leads or TicketHolder
     * @param clientType (optional) 
     * @param clientId (optional) 
     * @param emailId (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param middleName (optional) 
     * @param phoneNumber (optional) 
     * @param city (optional) 
     * @param stateAbbreviation (optional) 
     * @param zipCode (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAdvancedSearch(clientType?: ClientType | undefined, clientId?: string | null | undefined, emailId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, phoneNumber?: string | null | undefined, city?: string | null | undefined, stateAbbreviation?: string | null | undefined, zipCode?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfAdvancedSearchResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetAdvancedSearch?";
        if (clientType === null)
            throw new Error("The parameter 'clientType' cannot be null.");
        else if (clientType !== undefined)
            url_ += "ClientType=" + encodeURIComponent("" + clientType) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (emailId !== undefined && emailId !== null)
            url_ += "EmailId=" + encodeURIComponent("" + emailId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (stateAbbreviation !== undefined && stateAbbreviation !== null)
            url_ += "StateAbbreviation=" + encodeURIComponent("" + stateAbbreviation) + "&";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvancedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvancedSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAdvancedSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAdvancedSearchResultDto>;
        }));
    }

    protected processGetAdvancedSearch(response: HttpResponseBase): Observable<PagedResultDtoOfAdvancedSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAdvancedSearchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search Leads and TicketHolders together with a single keyword (name, client id, email, phone, city, state, zip)
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getGlobalSearch(filter?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfAdvancedSearchResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetGlobalSearch?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAdvancedSearchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAdvancedSearchResultDto>;
        }));
    }

    protected processGetGlobalSearch(response: HttpResponseBase): Observable<PagedResultDtoOfAdvancedSearchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAdvancedSearchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Auth Url for the External Service provider
     * @param nameOfExternalApi (optional) 
     * @return OK
     */
    getAuthorizationUrl(nameOfExternalApi?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetAuthorizationUrl?";
        if (nameOfExternalApi !== undefined && nameOfExternalApi !== null)
            url_ += "nameOfExternalApi=" + encodeURIComponent("" + nameOfExternalApi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAuthorizationUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all documents related to career coach
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getCareerCoachAllDocuments(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetCareerCoachAllDocuments?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerCoachAllDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerCoachAllDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDocumentDto>;
        }));
    }

    protected processGetCareerCoachAllDocuments(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the connected Email Service Provider such as Gmail, Microsoft Email etc..
     * @return OK
     */
    getConnectedEmailServiceProvider(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetConnectedEmailServiceProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectedEmailServiceProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectedEmailServiceProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConnectedEmailServiceProvider(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the connected Fax Provider
     * @return OK
     */
    getConnectedFaxServiceProvider(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetConnectedFaxServiceProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectedFaxServiceProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectedFaxServiceProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConnectedFaxServiceProvider(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * This method fetches field information including field name, type, and display name, which can be used
    to dynamically generate search options or filters in a user interface.
     * @return OK
     */
    getDyanmicFieldOfAdvancedSearch(): Observable<AdvancedSearchFieldInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetDyanmicFieldOfAdvancedSearch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDyanmicFieldOfAdvancedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDyanmicFieldOfAdvancedSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvancedSearchFieldInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvancedSearchFieldInfo[]>;
        }));
    }

    protected processGetDyanmicFieldOfAdvancedSearch(response: HttpResponseBase): Observable<AdvancedSearchFieldInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvancedSearchFieldInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Email Service Providers
     * @return OK
     */
    getEmailServiceProviders(): Observable<ExternalApiConnectInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetEmailServiceProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailServiceProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailServiceProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo[]>;
        }));
    }

    protected processGetEmailServiceProviders(response: HttpResponseBase): Observable<ExternalApiConnectInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalApiConnectInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Fax Service Providers
     * @return OK
     */
    getFaxServiceProviders(): Observable<ExternalApiConnectInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetFaxServiceProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxServiceProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxServiceProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo[]>;
        }));
    }

    protected processGetFaxServiceProviders(response: HttpResponseBase): Observable<ExternalApiConnectInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalApiConnectInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all SMS service providers and their connection status.
    RingCentralSms shares the same OAuth token as FaxRingCentral, so connection
    status is derived from the fax provider connection for the current tenant.
     * @return OK
     */
    getSmsServiceProviders(): Observable<ExternalApiConnectInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetSmsServiceProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmsServiceProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmsServiceProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo[]>;
        }));
    }

    protected processGetSmsServiceProviders(response: HttpResponseBase): Observable<ExternalApiConnectInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalApiConnectInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current user's calendar events.
     * @param body (optional) Optional filter input
     * @return OK
     */
    getMyCalendarEvents(body?: GetMyCalendarEventsFilter | undefined): Observable<PagedResultDtoOfMyCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetMyCalendarEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCalendarEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCalendarEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMyCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMyCalendarDto>;
        }));
    }

    protected processGetMyCalendarEvents(response: HttpResponseBase): Observable<PagedResultDtoOfMyCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMyCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current user's tasks.
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getMyTasks(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfMyTasksDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetMyTasks?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMyTasksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMyTasksDto>;
        }));
    }

    protected processGetMyTasks(response: HttpResponseBase): Observable<PagedResultDtoOfMyTasksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMyTasksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Short Message Template
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getShortMessageTemplate(templateType: MessageTemplateType, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfShortMessageTemplate> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetShortMessageTemplate?";
        if (templateType === undefined || templateType === null)
            throw new Error("The parameter 'templateType' must be defined and cannot be null.");
        else
            url_ += "TemplateType=" + encodeURIComponent("" + templateType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortMessageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfShortMessageTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfShortMessageTemplate>;
        }));
    }

    protected processGetShortMessageTemplate(response: HttpResponseBase): Observable<PagedResultDtoOfShortMessageTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfShortMessageTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * check if there is an email service provider has been connected
     * @return OK
     */
    hasConnectedEmailServiceProvider(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/HasConnectedEmailServiceProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasConnectedEmailServiceProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasConnectedEmailServiceProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processHasConnectedEmailServiceProvider(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * check if there is an fax service provider has been connected
     * @return OK
     */
    hasConnectedFaxServiceProvider(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/HasConnectedFaxServiceProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasConnectedFaxServiceProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasConnectedFaxServiceProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processHasConnectedFaxServiceProvider(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Email using Career Coach Email Authentication
     * @param isCareerCoach (optional) 
     * @param senderEmailId (optional) 
     * @param recipientEmailId (optional) 
     * @param cc (optional) 
     * @param bcc (optional) 
     * @param subject (optional) 
     * @param messageBody (optional) 
     * @param leadId (optional) 
     * @param ticketHolderId (optional) 
     * @param clientFullName (optional) 
     * @param clientId (optional) 
     * @param serviceType (optional) 
     * @param jobLeadIds (optional) 
     * @param attachmentFiles (optional) 
     * @return OK
     */
    sendEmail(isCareerCoach?: boolean | undefined, senderEmailId?: string | undefined, recipientEmailId?: string | undefined, cc?: string | undefined, bcc?: string | undefined, subject?: string | undefined, messageBody?: string | undefined, leadId?: number | undefined, ticketHolderId?: number | undefined, clientFullName?: string | undefined, clientId?: string | undefined, serviceType?: ActivityServiceType | undefined, jobLeadIds?: number[] | undefined, attachmentFiles?: FileParameter[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/SendEmail?";
        if (isCareerCoach === null)
            throw new Error("The parameter 'isCareerCoach' cannot be null.");
        else if (isCareerCoach !== undefined)
            url_ += "isCareerCoach=" + encodeURIComponent("" + isCareerCoach) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (senderEmailId === null || senderEmailId === undefined)
            throw new Error("The parameter 'senderEmailId' cannot be null.");
        else
            content_.append("SenderEmailId", senderEmailId.toString());
        if (recipientEmailId === null || recipientEmailId === undefined)
            throw new Error("The parameter 'recipientEmailId' cannot be null.");
        else
            content_.append("RecipientEmailId", recipientEmailId.toString());
        if (cc === null || cc === undefined)
            throw new Error("The parameter 'cc' cannot be null.");
        else
            content_.append("Cc", cc.toString());
        if (bcc === null || bcc === undefined)
            throw new Error("The parameter 'bcc' cannot be null.");
        else
            content_.append("Bcc", bcc.toString());
        if (subject === null || subject === undefined)
            throw new Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (messageBody === null || messageBody === undefined)
            throw new Error("The parameter 'messageBody' cannot be null.");
        else
            content_.append("MessageBody", messageBody.toString());
        if (leadId === null || leadId === undefined)
            throw new Error("The parameter 'leadId' cannot be null.");
        else
            content_.append("LeadId", leadId.toString());
        if (ticketHolderId === null || ticketHolderId === undefined)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else
            content_.append("TicketHolderId", ticketHolderId.toString());
        if (clientFullName === null || clientFullName === undefined)
            throw new Error("The parameter 'clientFullName' cannot be null.");
        else
            content_.append("ClientFullName", clientFullName.toString());
        if (clientId === null || clientId === undefined)
            throw new Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("ClientId", clientId.toString());
        if (serviceType === null || serviceType === undefined)
            throw new Error("The parameter 'serviceType' cannot be null.");
        else
            content_.append("ServiceType", serviceType.toString());
        if (jobLeadIds === null || jobLeadIds === undefined)
            throw new Error("The parameter 'jobLeadIds' cannot be null.");
        else
            jobLeadIds.forEach(item_ => content_.append("JobLeadIds", item_.toString()));
        if (attachmentFiles === null || attachmentFiles === undefined)
            throw new Error("The parameter 'attachmentFiles' cannot be null.");
        else
            attachmentFiles.forEach(item_ => content_.append("attachmentFiles", item_.data, item_.fileName ? item_.fileName : "attachmentFiles") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Fax by provide required input
     * @param body (optional) 
     * @return OK
     */
    sendFax(body?: OutgoingRequestFaxDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/SendFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendFax(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Followup for both Lead and TicketHolder
     * @param body (optional) 
     * @return OK
     */
    updateFollowup(body?: UpdateFollowupDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/UpdateFollowup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFollowup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFollowup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateFollowup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Calendar Event
     * @param body (optional) 
     * @return OK
     */
    updateTask(body?: CalendarTaskDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/UpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateTask(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send Mass SMS
     * @param body (optional) 
     * @return OK
     */
    sendMassSms(body?: SendMassSmsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/SendMassSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMassSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMassSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMassSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send SMS
     * @param body (optional) 
     * @return OK
     */
    sendSms(body?: SendSmsInput | undefined): Observable<SendSmsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/SendSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendSmsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendSmsResultDto>;
        }));
    }

    protected processSendSms(response: HttpResponseBase): Observable<SendSmsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendSmsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks an inbound email ("email") or SMS ("sms") as read – no reply needed, e.g. when the coach
    opens it from the inbound-message notification's "view detail" link. No-op if already marked.
     * @param logType (optional) 
     * @param logId (optional) 
     * @return OK
     */
    markInboundMessageAsRead(logType?: string | null | undefined, logId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/MarkInboundMessageAsRead?";
        if (logType !== undefined && logType !== null)
            url_ += "logType=" + encodeURIComponent("" + logType) + "&";
        if (logId === null)
            throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined)
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkInboundMessageAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkInboundMessageAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkInboundMessageAsRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Email Log By LogId
     * @param id (optional) 
     * @return OK
     */
    getEmailLogDetailById(id?: number | undefined): Observable<EmailLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetEmailLogDetailById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailLogDetailDto>;
        }));
    }

    protected processGetEmailLogDetailById(response: HttpResponseBase): Observable<EmailLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * To view attachment, call api/services/app/Document/GetFile?documentId=98
     * @param contactType (optional) 
     * @param logId (optional) 
     * @return OK
     */
    getLogDetail(contactType?: ContactType2 | undefined, logId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetLogDetail?";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "contactType=" + encodeURIComponent("" + contactType) + "&";
        if (logId === null)
            throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined)
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetLogDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Mail Log By LogId
     * @return OK
     */
    getMailLogDetailById(id: number): Observable<MailLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetMailLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailLogDetailDto>;
        }));
    }

    protected processGetMailLogDetailById(response: HttpResponseBase): Observable<MailLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Fax Log By LogId
     * @return OK
     */
    getFaxLogDetailById(id: number): Observable<FaxLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetFaxLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaxLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaxLogDetailDto>;
        }));
    }

    protected processGetFaxLogDetailById(response: HttpResponseBase): Observable<FaxLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FaxLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Phone Log By LogId
     * @return OK
     */
    getPhoneLogDetailById(id: number): Observable<PhoneLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetPhoneLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhoneLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhoneLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneLogDetailDto>;
        }));
    }

    protected processGetPhoneLogDetailById(response: HttpResponseBase): Observable<PhoneLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get chat log by logid
     * @return OK
     */
    getChatLogDetailById(id: number): Observable<ChatLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetChatLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatLogDetailDto>;
        }));
    }

    protected processGetChatLogDetailById(response: HttpResponseBase): Observable<ChatLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * use open AI to tune up the message
     * @param inputMessage (optional) 
     * @return OK
     */
    tuneUpMessage(inputMessage?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/TuneUpMessage?";
        if (inputMessage !== undefined && inputMessage !== null)
            url_ += "inputMessage=" + encodeURIComponent("" + inputMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTuneUpMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTuneUpMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTuneUpMessage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Translates the given text to the specified target language using Azure Translator.
     * @param body (optional) The translation input containing text, target language, and format (HTML or plain).
     * @return OK
     */
    translateText(body?: TranslateTextInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/TranslateText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslateText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslateText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTranslateText(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Translates an email template's subject and body into the specified target language.
     * @param body (optional) The input containing the subject (plain text), body (HTML), and the target language code.
     * @return OK
     */
    translateTemplate(body?: TranslateTemplateInputDto | undefined): Observable<TranslatedTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/TranslateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTranslateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TranslatedTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TranslatedTemplateDto>;
        }));
    }

    protected processTranslateTemplate(response: HttpResponseBase): Observable<TranslatedTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranslatedTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the list of supported target languages from Azure Translator.
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getSupportedLanguages(filter?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTranslationLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetSupportedLanguages?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportedLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportedLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTranslationLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTranslationLanguageDto>;
        }));
    }

    protected processGetSupportedLanguages(response: HttpResponseBase): Observable<PagedResultDtoOfTranslationLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTranslationLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Document Template based on the Filter
     * @param body (optional) 
     * @return OK
     */
    getDocumentTemplates(body?: TemplateFilterDto | undefined): Observable<PagedResultDtoOfGetDocumentTemplateDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetDocumentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDocumentTemplateDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDocumentTemplateDetailsDto>;
        }));
    }

    protected processGetDocumentTemplates(response: HttpResponseBase): Observable<PagedResultDtoOfGetDocumentTemplateDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDocumentTemplateDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get all task template
     * @param body (optional) 
     * @return OK
     */
    getAllTaskTemplate(body?: TaskTemplateRequestDto | undefined): Observable<PagedResultDtoOfTTWTaskTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetAllTaskTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTTWTaskTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTTWTaskTemplateDto>;
        }));
    }

    protected processGetAllTaskTemplate(response: HttpResponseBase): Observable<PagedResultDtoOfTTWTaskTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTTWTaskTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLeadStage(body?: UpdateLeadStageDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/UpdateLeadStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeadStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeadStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateLeadStage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentStage (optional) 
     * @return OK
     */
    getAllowedLeadStages(currentStage?: CurrentStage | undefined): Observable<LeadStageOptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CareerCoach/GetAllowedLeadStages?";
        if (currentStage === null)
            throw new Error("The parameter 'currentStage' cannot be null.");
        else if (currentStage !== undefined)
            url_ += "currentStage=" + encodeURIComponent("" + currentStage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedLeadStages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedLeadStages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadStageOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadStageOptionDto[]>;
        }));
    }

    protected processGetAllowedLeadStages(response: HttpResponseBase): Observable<LeadStageOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeadStageOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getUserChatMessages(tenantId?: number | null | undefined, userId?: number | undefined, minMessageId?: number | null | undefined, maxResultCount?: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined && minMessageId !== null)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    markAllUnreadMessagesOfUserAsRead(body?: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return OK
     */
    getEditionsForCombobox(onlyFreeItems?: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body?: FindUsersInput | undefined): Observable<PagedResultDtoOfFindUsersOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFindUsersOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFindUsersOutputDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfFindUsersOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFindUsersOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    getUserDashboard(dashboardName?: string | null | undefined, application?: string | null | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Dashboard>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Dashboard>;
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    savePage(body?: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renamePage(body?: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addNewPage(body?: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddNewPageOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddNewPageOutput>;
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    deletePage(id?: string | null | undefined, dashboardName?: string | null | undefined, application?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addWidget(body?: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Widget>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Widget>;
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    getDashboardDefinition(dashboardName?: string | null | undefined, application?: string | null | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOutput>;
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return OK
     */
    getAllWidgetDefinitions(dashboardName?: string | null | undefined, application?: string | null | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @param pageId (optional) 
     * @return OK
     */
    getAllAvailableWidgetDefinitionsForPage(dashboardName?: string | null | undefined, application?: string | null | undefined, pageId?: string | null | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllAvailableWidgetDefinitionsForPage?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        if (pageId !== undefined && pageId !== null)
            url_ += "PageId=" + encodeURIComponent("" + pageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableWidgetDefinitionsForPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableWidgetDefinitionsForPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
        }));
    }

    protected processGetAllAvailableWidgetDefinitionsForPage(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @param dashboardName (optional) 
     * @return OK
     */
    getSettingName(application?: string | null | undefined, dashboardName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application !== undefined && application !== null)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "dashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSettingName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    sendAndGetDate(date?: DateTime | undefined): Observable<DateFieldOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateFieldOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateFieldOutput>;
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateFieldOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateFieldOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    sendAndGetDateTime(date?: DateTime | undefined): Observable<DateFieldOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateFieldOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateFieldOutput>;
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateFieldOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateFieldOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    sendAndGetDateRange(startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<DateRangeFieldOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateRangeFieldOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateRangeFieldOutput>;
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateRangeFieldOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateRangeFieldOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAndGetDateWithText(body?: SendAndGetDateWithTextInput | undefined): Observable<DateWithTextFieldOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateWithText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateWithText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateWithText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateWithTextFieldOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateWithTextFieldOutput>;
        }));
    }

    protected processSendAndGetDateWithText(response: HttpResponseBase): Observable<DateWithTextFieldOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateWithTextFieldOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return OK
     */
    getCountries(searchTerm?: string | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAndGetSelectedCountries(body?: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return OK
     */
    sendAndGetValue(input?: string | null | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringOutput>;
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DigitalSignatureServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Initiates a digital signature request for an IWP (Individual Work Plan) document.
     * @param iwpId The ID of the IWP Section One entry to process.
     * @return OK
     */
    addSendSignatureRequest(iwpId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/AddSendSignatureRequest?";
        if (iwpId === undefined || iwpId === null)
            throw new Error("The parameter 'iwpId' must be defined and cannot be null.");
        else
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSendSignatureRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSendSignatureRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSendSignatureRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resends a digital signature request for an existing IWP document based on a previously initiated signature request.
     * @param previousSignatureId (optional) The ID of the previous digital signature record.
     * @return OK
     */
    resendDigitalSignature(previousSignatureId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/ResendDigitalSignature?";
        if (previousSignatureId === null)
            throw new Error("The parameter 'previousSignatureId' cannot be null.");
        else if (previousSignatureId !== undefined)
            url_ += "PreviousSignatureId=" + encodeURIComponent("" + previousSignatureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendDigitalSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendDigitalSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendDigitalSignature(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Takes an IWP that is waiting for signatures back to editing: cancels its open DigiSigner envelope(s)
    (they stay in the history as Voided) and moves it to Working On IWP. Once fixed, it is sent for e-sign again.
     * @param iwpId The IWP to reopen.
     * @return OK
     */
    reopenIWPForEdit(iwpId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/ReopenIWPForEdit?";
        if (iwpId === undefined || iwpId === null)
            throw new Error("The parameter 'iwpId' must be defined and cannot be null.");
        else
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReopenIWPForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReopenIWPForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReopenIWPForEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a digital signature document from the DigiSigner system using the provided document ID.
     * @param digitalSignatureDocId (optional) The unique identifier of the digital signature document to delete.
     * @return OK
     */
    deleteDigitalSignature(digitalSignatureDocId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/DeleteDigitalSignature?";
        if (digitalSignatureDocId !== undefined && digitalSignatureDocId !== null)
            url_ += "DigitalSignatureDocId=" + encodeURIComponent("" + digitalSignatureDocId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDigitalSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDigitalSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDigitalSignature(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a digital signature request by retrieving the latest information from DigiSigner.
     * @param id The unique identifier of the digital signature to update.
     * @return OK
     */
    updateSignatureRequest(id: number): Observable<DigitalSignatureDto> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/UpdateSignatureRequest?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSignatureRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSignatureRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigitalSignatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigitalSignatureDto>;
        }));
    }

    protected processUpdateSignatureRequest(response: HttpResponseBase): Observable<DigitalSignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DigitalSignatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds DigiSigner API credentials for the current user by storing them in the database.
     * @param apiKey The Thrive.TTW.DigitalSignature.Dtos.UserApiTokenDto containing the DigiSigner API key and related user information.
     * @return OK
     */
    addDigiSignerCredentails(apiKey: string | null): Observable<UserApiTokenDto> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/AddDigiSignerCredentails?";
        if (apiKey === undefined)
            throw new Error("The parameter 'apiKey' must be defined.");
        else if(apiKey !== null)
            url_ += "apiKey=" + encodeURIComponent("" + apiKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDigiSignerCredentails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDigiSignerCredentails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserApiTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserApiTokenDto>;
        }));
    }

    protected processAddDigiSignerCredentails(response: HttpResponseBase): Observable<UserApiTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserApiTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the DigiSigner webhook URL configured for the current tenant and user.
     * @return OK
     */
    getDigiSignerWebhookUrl(): Observable<DigiSignerWebHookUrlDto> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/GetDigiSignerWebhookUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDigiSignerWebhookUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDigiSignerWebhookUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DigiSignerWebHookUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DigiSignerWebHookUrlDto>;
        }));
    }

    protected processGetDigiSignerWebhookUrl(response: HttpResponseBase): Observable<DigiSignerWebHookUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DigiSignerWebHookUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Handles incoming webhook events from DigiSigner by parsing the payload and taking appropriate actions
    based on the event type (e.g., signature completed, document signed).
     * @param payload (optional) The JSON payload received from DigiSigner webhook.
     * @param body (optional) A dictionary containing any headers sent along with the webhook request.
     * @return OK
     */
    handleEventSubscription(payload?: string | null | undefined, body?: { [key: string]: string; } | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/HandleEventSubscription?";
        if (payload !== undefined && payload !== null)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEventSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleEventSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Makes the signed PDF the IWP's document when both parties have signed (downloads it from
    DigiSigner if it was never fetched). For IWPs completed without it, e.g. the manual move to
    Ticket Holder, or a missed webhook.
     * @param iwpId (optional) 
     * @return OK
     */
    syncSignedDocument(iwpId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/SyncSignedDocument?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncSignedDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncSignedDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSyncSignedDocument(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param digitalSignatureId (optional) 
     * @return OK
     */
    ensureSignedDocument(digitalSignatureId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DigitalSignatureService/EnsureSignedDocument?";
        if (digitalSignatureId === null)
            throw new Error("The parameter 'digitalSignatureId' cannot be null.");
        else if (digitalSignatureId !== undefined)
            url_ += "digitalSignatureId=" + encodeURIComponent("" + digitalSignatureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureSignedDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureSignedDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEnsureSignedDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new document.
     * @param body (optional) 
     * @return OK
     */
    create(body?: CreateDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a document by ID.
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of documents with pagination support.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAll?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDocumentDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of template documents with pagination support.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     * @deprecated
     */
    getTemplateDocuments(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetTemplateDocuments?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDocumentDto>;
        }));
    }

    protected processGetTemplateDocuments(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing document.
     * @param body (optional) 
     * @return OK
     */
    update(body?: UpdateDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a document by ID.
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Decrypts a document to a GUID-named copy under the user's folder in storage and returns its path.
    The copy is plain text and nothing removes it automatically: the caller must delete it with
    `_fileStorageManager.DeleteAsync` once done. Prefer M:Thrive.TTW.IO.DocumentAppService.GetDecryptedDocumentBytesAsync(System.Int64)
    when the bytes are all that's needed.
     * @param documentId (optional) 
     * @return OK
     */
    decryptDocument(documentId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/DecryptDocument?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecryptDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecryptDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDecryptDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Decrypts a document straight into memory; no decrypted copy is written to storage.
    Returns null when the document or its file doesn't exist, or decryption fails.
     * @param documentId (optional) 
     * @return OK
     */
    getDecryptedDocumentBytes(documentId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetDecryptedDocumentBytes?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDecryptedDocumentBytes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDecryptedDocumentBytes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDecryptedDocumentBytes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Decrypts many documents concurrently. Unlike calling M:Thrive.TTW.IO.DocumentAppService.DecryptDocumentAsync(System.Int64) once
    per document, this issues a single batched DB lookup up front (EF Core's DbContext isn't
    thread-safe for concurrent queries) and then parallelizes only the actual decrypt file I/O,
    which is what dominates wall-clock time for a large attachment count (e.g. a mail-merge print).
     * @param maxDegreeOfParallelism (optional) Caps concurrent decrypt operations against storage.
     * @param body (optional) The document ids to decrypt.
     * @return OK
     */
    decryptDocuments(maxDegreeOfParallelism?: number | undefined, body?: number[] | undefined): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/services/app/Document/DecryptDocuments?";
        if (maxDegreeOfParallelism === null)
            throw new Error("The parameter 'maxDegreeOfParallelism' cannot be null.");
        else if (maxDegreeOfParallelism !== undefined)
            url_ += "maxDegreeOfParallelism=" + encodeURIComponent("" + maxDegreeOfParallelism) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecryptDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecryptDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processDecryptDocuments(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload the template forms
     * @param file (optional) 
     * @param documentType (optional) 
     * @param templateStatus (optional) 
     * @param languageId (optional) 
     * @return OK
     * @deprecated
     */
    addUploadTemplate(file?: FileParameter | undefined, documentType?: TicketHolderDocumentType | undefined, templateStatus?: TemplateStatus | undefined, languageId?: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/AddUploadTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (documentType === null || documentType === undefined)
            throw new Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (templateStatus === null || templateStatus === undefined)
            throw new Error("The parameter 'templateStatus' cannot be null.");
        else
            content_.append("TemplateStatus", templateStatus.toString());
        if (languageId === null || languageId === undefined)
            throw new Error("The parameter 'languageId' cannot be null.");
        else
            content_.append("LanguageId", languageId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUploadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUploadTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processAddUploadTemplate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload the TTW Forms
     * @param file (optional) 
     * @param documentType (optional) 
     * @param formType (optional) 
     * @param templateStatus (optional) 
     * @param languageId (optional) 
     * @return OK
     * @deprecated
     */
    addUploadTTWForms(file?: FileParameter | undefined, documentType?: TicketHolderDocumentType | undefined, formType?: TTWFormsType | undefined, templateStatus?: TemplateStatus | undefined, languageId?: number | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/AddUploadTTWForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (documentType === null || documentType === undefined)
            throw new Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (formType === null || formType === undefined)
            throw new Error("The parameter 'formType' cannot be null.");
        else
            content_.append("FormType", formType.toString());
        if (templateStatus === null || templateStatus === undefined)
            throw new Error("The parameter 'templateStatus' cannot be null.");
        else
            content_.append("TemplateStatus", templateStatus.toString());
        if (languageId === null || languageId === undefined)
            throw new Error("The parameter 'languageId' cannot be null.");
        else
            content_.append("LanguageId", languageId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUploadTTWForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUploadTTWForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processAddUploadTTWForms(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download the Files using Document Id
     * @param documentId (optional) 
     * @return OK
     */
    getDownloadFile(documentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetDownloadFile?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetDownloadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Files using Document Id
     * @param documentId (optional) 
     * @return OK
     */
    getFile(documentId?: number | undefined): Observable<DocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetFile?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponseDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<DocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a document by ID.
     * @param documentId (optional) The unique identifier of the document to retrieve.
     * @return OK
     */
    getFileInfo(documentId?: number | undefined): Observable<DocumentStreamResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetFileInfo?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentStreamResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentStreamResponseDto>;
        }));
    }

    protected processGetFileInfo(response: HttpResponseBase): Observable<DocumentStreamResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentStreamResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Streams a file from the server for inline preview in the browser without prompting a download.
     * @param documentId (optional) The unique identifier of the document to be previewed.
     * @return OK
     */
    getFileStreamPreview(documentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetFileStreamPreview?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileStreamPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileStreamPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetFileStreamPreview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the All forms
     * @return OK
     */
    getAllForms(): Observable<FormDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAllForms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormDto[]>;
        }));
    }

    protected processGetAllForms(response: HttpResponseBase): Observable<FormDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<DynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicEntityPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityFullName (optional) 
     * @return OK
     */
    getAllPropertiesOfAnEntity(entityFullName?: string | null | undefined): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllPropertiesOfAnEntity?";
        if (entityFullName !== undefined && entityFullName !== null)
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPropertiesOfAnEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPropertiesOfAnEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }));
    }

    protected processGetAllPropertiesOfAnEntity(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body?: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEntitiesHasDynamicProperty(): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllEntitiesHasDynamicProperty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntitiesHasDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntitiesHasDynamicProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>;
        }));
    }

    protected processGetAllEntitiesHasDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyDefinitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllAllowedInputTypeNames(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllAllowedInputTypeNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAllowedInputTypeNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAllowedInputTypeNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllAllowedInputTypeNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEntities(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllEntities(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicEntityPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<DynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicEntityPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicEntityPropertyValueDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param propertyId (optional) 
     * @return OK
     */
    getAll(entityId?: string | null | undefined, propertyId?: number | undefined): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAll?";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicEntityPropertyValueDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body?: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllDynamicEntityPropertyValues(entityFullName: string | null, entityId: string | null): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAllDynamicEntityPropertyValues?";
        if (entityFullName === undefined)
            throw new Error("The parameter 'entityFullName' must be defined.");
        else if(entityFullName !== null)
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        if (entityId === undefined)
            throw new Error("The parameter 'entityId' must be defined.");
        else if(entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDynamicEntityPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDynamicEntityPropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllDynamicEntityPropertyValuesOutput>;
        }));
    }

    protected processGetAllDynamicEntityPropertyValues(response: HttpResponseBase): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllDynamicEntityPropertyValuesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insertOrUpdateAllValues(body?: InsertOrUpdateAllValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/InsertOrUpdateAllValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdateAllValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdateAllValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertOrUpdateAllValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cleanValues(body?: CleanValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/CleanValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCleanValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<DynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicPropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ListResultDtoOfDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body?: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    findAllowedInputType(name?: string | null | undefined): Observable<IInputType> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/FindAllowedInputType?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAllowedInputType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAllowedInputType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IInputType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IInputType>;
        }));
    }

    protected processFindAllowedInputType(response: HttpResponseBase): Observable<IInputType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IInputType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<DynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicPropertyValueDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllValuesOfDynamicProperty(id?: number | undefined): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/GetAllValuesOfDynamicProperty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValuesOfDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValuesOfDynamicProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDynamicPropertyValueDto>;
        }));
    }

    protected processGetAllValuesOfDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    add(body?: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body?: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEditionForEdit(id?: number | null | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createEdition(body?: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateEdition(body?: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteEdition(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveTenantsToAnotherEdition(body?: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return OK
     */
    getEditionComboboxItems(selectedEditionId?: number | null | undefined, addAllItem?: boolean | undefined, onlyFreeItems?: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined && selectedEditionId !== null)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    getTenantCount(editionId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmailMicrosoftGraphApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Check if there ia an microsoft email account is connected
     * @return OK
     */
    getCachedConnectionInfo(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/GetCachedConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCachedConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCachedConnectionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processGetCachedConnectionInfo(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    hasExpiredConnection(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/HasExpiredConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasExpiredConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasExpiredConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasExpiredConnection(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConnectionInfo(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/GetConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processGetConnectionInfo(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    disconnect(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * No need to extend access token
     * @return OK
     */
    extendAccessToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/ExtendAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExtendAccessToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    extendSubscription(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/ExtendSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExtendSubscription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAuthorizationUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/GetAuthorizationUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAuthorizationUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSubscriptions(): Observable<GraphSubscription[]> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/GetSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GraphSubscription[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GraphSubscription[]>;
        }));
    }

    protected processGetSubscriptions(response: HttpResponseBase): Observable<GraphSubscription[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GraphSubscription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payload (optional) 
     * @param body (optional) 
     * @return OK
     */
    handleEventSubscription(payload?: string | null | undefined, body?: { [key: string]: string; } | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/HandleEventSubscription?";
        if (payload !== undefined && payload !== null)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEventSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleEventSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @param body (optional) 
     * @return OK
     */
    handleOAuthCallback(code?: string | null | undefined, body?: OAuthState | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/HandleOAuthCallback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleOAuthCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleOAuthCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleOAuthCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param responseContent (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveSubscriptionEvent(responseContent?: string | null | undefined, body?: UserApiToken | undefined): Observable<ExternalEventSubscription> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/SaveSubscriptionEvent?";
        if (responseContent !== undefined && responseContent !== null)
            url_ += "responseContent=" + encodeURIComponent("" + responseContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSubscriptionEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSubscriptionEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalEventSubscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalEventSubscription>;
        }));
    }

    protected processSaveSubscriptionEvent(response: HttpResponseBase): Observable<ExternalEventSubscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalEventSubscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    subscribeToEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/SubscribeToEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribeToEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeToEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubscribeToEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unsubscribeToEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/UnsubscribeToEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribeToEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeToEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribeToEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return api event data
     * @param body (optional) 
     * @return OK
     */
    createCalendarEvent(body?: CreateCalendarEventDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/CreateCalendarEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCalendarEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCalendarEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCalendarEvent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the Calendar Event
     * @param eventId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateCalendarEvent(eventId?: string | null | undefined, body?: CreateCalendarEventDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/UpdateCalendarEvent?";
        if (eventId !== undefined && eventId !== null)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCalendarEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCalendarEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCalendarEvent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the calendar event
     * @param eventId (optional) 
     * @return OK
     */
    deleteCalendarEvent(eventId?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/DeleteCalendarEvent?";
        if (eventId !== undefined && eventId !== null)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalendarEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalendarEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCalendarEvent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendEmail(body?: MailMessage | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EmailMicrosoftGraphApi/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ENSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return OK
     */
    setCurrentTenantId(tenantId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/SetCurrentTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCurrentTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrentTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCurrentTenantId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Public accessor for the current tenant's private key, meant to be called once up front so
    callers can then decrypt many files concurrently via M:Thrive.TTW.ENSetting.ENSettingAppService.DecryptFile(System.String,System.String,System.String)
    without each concurrent call hitting the DB itself.
     * @return OK
     */
    getPrivateKeyForCurrentTenant(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/GetPrivateKeyForCurrentTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrivateKeyForCurrentTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrivateKeyForCurrentTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPrivateKeyForCurrentTenant(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getENInfo(): Observable<ENSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/GetENInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetENInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetENInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ENSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ENSettingDto>;
        }));
    }

    protected processGetENInfo(response: HttpResponseBase): Observable<ENSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ENSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param plainText (optional) 
     * @return OK
     */
    encryptString(plainText?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/EncryptString?";
        if (plainText !== undefined && plainText !== null)
            url_ += "plainText=" + encodeURIComponent("" + plainText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEncryptString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEncryptString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEncryptString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param encryptedText (optional) 
     * @return OK
     */
    decryptString(encryptedText?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/DecryptString?";
        if (encryptedText !== undefined && encryptedText !== null)
            url_ += "encryptedText=" + encodeURIComponent("" + encryptedText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecryptString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecryptString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDecryptString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputFile (optional) 
     * @param outputFile (optional) 
     * @return OK
     */
    encryptFile(inputFile?: string | null | undefined, outputFile?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/EncryptFile?";
        if (inputFile !== undefined && inputFile !== null)
            url_ += "inputFile=" + encodeURIComponent("" + inputFile) + "&";
        if (outputFile !== undefined && outputFile !== null)
            url_ += "outputFile=" + encodeURIComponent("" + outputFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEncryptFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEncryptFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEncryptFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputFile (optional) 
     * @return OK
     */
    encryptFileToSameDirectory(inputFile?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/EncryptFileToSameDirectory?";
        if (inputFile !== undefined && inputFile !== null)
            url_ += "inputFile=" + encodeURIComponent("" + inputFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEncryptFileToSameDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEncryptFileToSameDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEncryptFileToSameDirectory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param encryptedFile (optional) 
     * @param decryptedFile (optional) 
     * @return OK
     */
    decryptFile(encryptedFile?: string | null | undefined, decryptedFile?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/DecryptFile?";
        if (encryptedFile !== undefined && encryptedFile !== null)
            url_ += "encryptedFile=" + encodeURIComponent("" + encryptedFile) + "&";
        if (decryptedFile !== undefined && decryptedFile !== null)
            url_ += "decryptedFile=" + encodeURIComponent("" + decryptedFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecryptFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecryptFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDecryptFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param encryptedFile (optional) 
     * @return OK
     */
    decryptFileToSameDirectory(encryptedFile?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ENSetting/DecryptFileToSameDirectory?";
        if (encryptedFile !== undefined && encryptedFile !== null)
            url_ += "encryptedFile=" + encodeURIComponent("" + encryptedFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecryptFileToSameDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecryptFileToSameDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDecryptFileToSameDirectory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EntityChangeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @return OK
     */
    getEntityChangesByEntity(entityTypeFullName?: string | null | undefined, entityId?: string | null | undefined): Observable<ListResultDtoOfEntityAndPropertyChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityChange/GetEntityChangesByEntity?";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesByEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesByEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEntityAndPropertyChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEntityAndPropertyChangeListDto>;
        }));
    }

    protected processGetEntityChangesByEntity(response: HttpResponseBase): Observable<ListResultDtoOfEntityAndPropertyChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEntityAndPropertyChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExternalEventSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSubscriptions(): Observable<ExternalEventSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEventSubscription/GetSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalEventSubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalEventSubscriptionDto[]>;
        }));
    }

    protected processGetSubscriptions(response: HttpResponseBase): Observable<ExternalEventSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalEventSubscriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelGroup (optional) 
     * @return OK
     */
    getSubscriptionsForChannel(channelGroup?: string | null | undefined): Observable<ExternalEventSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEventSubscription/GetSubscriptionsForChannel?";
        if (channelGroup !== undefined && channelGroup !== null)
            url_ += "channelGroup=" + encodeURIComponent("" + channelGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionsForChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionsForChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalEventSubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalEventSubscriptionDto[]>;
        }));
    }

    protected processGetSubscriptionsForChannel(response: HttpResponseBase): Observable<ExternalEventSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalEventSubscriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param channelGroup (optional) 
     * @return OK
     */
    getRecentEvents(maxResultCount?: number | undefined, channelGroup?: string | null | undefined): Observable<IncomingEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEventSubscription/GetRecentEvents?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (channelGroup !== undefined && channelGroup !== null)
            url_ += "channelGroup=" + encodeURIComponent("" + channelGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomingEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomingEventDto[]>;
        }));
    }

    protected processGetRecentEvents(response: HttpResponseBase): Observable<IncomingEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomingEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FaxRingCentralServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Unsubscribe all Events
    delete subscription records
    delete api token
     * @return OK
     */
    disconnect(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Authorization Url for OAUth 2.0
     * @return OK
     */
    getAuthorizationUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/GetAuthorizationUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAuthorizationUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Subscribed Events of the Ringcentral
     * @return OK
     */
    getSubscriptions(): Observable<SubscriptionInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/GetSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionInfo[]>;
        }));
    }

    protected processGetSubscriptions(response: HttpResponseBase): Observable<SubscriptionInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Not finished yet
     * @param requestBody (optional) 
     * @param body (optional) 
     * @return OK
     */
    handleEventSubscription(requestBody?: string | null | undefined, body?: { [key: string]: string; } | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/HandleEventSubscription?";
        if (requestBody !== undefined && requestBody !== null)
            url_ += "requestBody=" + encodeURIComponent("" + requestBody) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEventSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleEventSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Handle Callback events of the webhook request by RingCentral Fax
     * @param code (optional) 
     * @param body (optional) 
     * @return OK
     */
    handleOAuthCallback(code?: string | null | undefined, body?: OAuthState | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/HandleOAuthCallback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleOAuthCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleOAuthCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleOAuthCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send out to Lead=1, Ticket Holder=2, SSAOffice=3, or Unknown=0
     * @param body (optional) 
     * @return OK
     */
    sendFax(body?: OutgoingFaxDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/SendFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendFax(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refactorSendFax(body?: OutgoingFaxDto | undefined): Observable<FaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/RefactorSendFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefactorSendFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefactorSendFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaxResponse>;
        }));
    }

    protected processRefactorSendFax(response: HttpResponseBase): Observable<FaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    ensureWebhookSubscription(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/EnsureWebhookSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureWebhookSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureWebhookSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnsureWebhookSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Subscribe events for the webhook for both Fax and SMS
     * @return OK
     */
    subscribeToEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/SubscribeToEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribeToEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeToEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubscribeToEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unsubscribe events and also delete events from the db
     * @return OK
     */
    unsubscribeToEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/UnsubscribeToEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribeToEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeToEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribeToEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get connection info of the ringcentral
     * @return OK
     */
    getConnectionInfo(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/GetConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processGetConnectionInfo(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Extend Access token of the Ringcentral
     * @return OK
     */
    extendAccessToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/ExtendAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExtendAccessToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Extend subscription time period
     * @return OK
     */
    extendSubscription(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/ExtendSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExtendSubscription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Default Fax Number
     * @param accessToken (optional) 
     * @return OK
     */
    getDefaultFaxNumber(accessToken?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/GetDefaultFaxNumber?";
        if (accessToken !== undefined && accessToken !== null)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultFaxNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultFaxNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultFaxNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if there is an ring central fax service provider has been connected
     * @return OK
     */
    getCachedConnectionInfo(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/FaxRingCentral/GetCachedConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCachedConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCachedConnectionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processGetCachedConnectionInfo(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param skipDuplicateCheck (optional) 
     * @param files (optional) 
     * @return OK
     */
    uploadTempFiles(skipDuplicateCheck?: boolean | undefined, files?: FileParameter[] | undefined): Observable<UploadFileOutputDto> {
        let url_ = this.baseUrl + "/api/web/File/UploadTempFiles?";
        if (skipDuplicateCheck === null)
            throw new Error("The parameter 'skipDuplicateCheck' cannot be null.");
        else if (skipDuplicateCheck !== undefined)
            url_ += "skipDuplicateCheck=" + encodeURIComponent("" + skipDuplicateCheck) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTempFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTempFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadFileOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadFileOutputDto>;
        }));
    }

    protected processUploadTempFiles(response: HttpResponseBase): Observable<UploadFileOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadFileOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uploadId (optional) 
     * @param files (optional) 
     * @return OK
     */
    uploadQrCodeFiles(uploadId?: string | null | undefined, files?: FileParameter[] | undefined): Observable<UploadFileOutputDto> {
        let url_ = this.baseUrl + "/api/web/File/UploadQrCodeFiles?";
        if (uploadId !== undefined && uploadId !== null)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadQrCodeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadQrCodeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadFileOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadFileOutputDto>;
        }));
    }

    protected processUploadQrCodeFiles(response: HttpResponseBase): Observable<UploadFileOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadFileOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uploadId (optional) 
     * @return OK
     */
    getUploadSessionInfo(uploadId?: string | null | undefined): Observable<UploadSessionInfoDto> {
        let url_ = this.baseUrl + "/api/web/File/GetUploadSessionInfo?";
        if (uploadId !== undefined && uploadId !== null)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadSessionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadSessionInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadSessionInfoDto>;
        }));
    }

    protected processGetUploadSessionInfo(response: HttpResponseBase): Observable<UploadSessionInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadSessionInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createUploadQrSession(): Observable<CreateUploadQrOutput> {
        let url_ = this.baseUrl + "/api/web/File/CreateUploadQrSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUploadQrSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUploadQrSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUploadQrOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUploadQrOutput>;
        }));
    }

    protected processCreateUploadQrSession(response: HttpResponseBase): Observable<CreateUploadQrOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUploadQrOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uploadId (optional) 
     * @return OK
     */
    getFilesByQrSession(uploadId?: string | null | undefined): Observable<UploadFileOutputDto> {
        let url_ = this.baseUrl + "/api/web/File/GetFilesByQrSession?";
        if (uploadId !== undefined && uploadId !== null)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesByQrSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesByQrSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadFileOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadFileOutputDto>;
        }));
    }

    protected processGetFilesByQrSession(response: HttpResponseBase): Observable<UploadFileOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadFileOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteTempUpload(uploadId: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/web/File/DeleteTempUpload?";
        if (uploadId === undefined)
            throw new Error("The parameter 'uploadId' must be defined.");
        else if(uploadId !== null)
            url_ += "uploadId=" + encodeURIComponent("" + uploadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTempUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTempUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTempUpload(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipRequest(body?: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipWithDifferentTenant(body?: CreateFriendshipWithDifferentTenantInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipWithDifferentTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipWithDifferentTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipWithDifferentTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipWithDifferentTenant(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFriendshipForCurrentTenant(body?: CreateFriendshipForCurrentTenantInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipForCurrentTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipForCurrentTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipForCurrentTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipForCurrentTenant(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    blockUser(body?: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unblockUser(body?: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    acceptFriendshipRequest(body?: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    removeFriend(userId?: number | undefined, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/RemoveFriend?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFriend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFriend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveFriend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GridPreferenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * pass column key to update the order.
     * @param body (optional) 
     * @return OK
     */
    save(body?: SaveGridPreferenceInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GridPreference/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get grid refrences of the user by passing grid key.
     * @param gridKey (optional) 
     * @return OK
     */
    getConfiguration(gridKey?: string | null | undefined): Observable<GridConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/GridPreference/GetConfiguration?";
        if (gridKey !== undefined && gridKey !== null)
            url_ += "gridKey=" + encodeURIComponent("" + gridKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<GridConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getTopStatsData(startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getIncomeStatistics(incomeStatisticsDateInterval?: ChartDateInterval | undefined, startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' cannot be null.");
        else if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getEditionTenantStatistics(startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDocumentTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<HostFormTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostFormTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostFormTemplateDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HostFormTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HostFormTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFormGroups(): Observable<HostFormGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/GetFormGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostFormGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostFormGroupDto[]>;
        }));
    }

    protected processGetFormGroups(response: HttpResponseBase): Observable<HostFormGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HostFormGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getContentTemplates(): Observable<HostContentTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/GetContentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostContentTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostContentTemplateDto[]>;
        }));
    }

    protected processGetContentTemplates(response: HttpResponseBase): Observable<HostContentTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HostContentTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getContentTemplateForEdit(id?: number | undefined): Observable<HostContentTemplateEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/GetContentTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostContentTemplateEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostContentTemplateEditDto>;
        }));
    }

    protected processGetContentTemplateForEdit(response: HttpResponseBase): Observable<HostContentTemplateEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostContentTemplateEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveContentTemplateDetail(body?: SaveHostContentTemplateDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/SaveContentTemplateDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveContentTemplateDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveContentTemplateDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveContentTemplateDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upload(body?: UploadHostFormTemplateFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFileBase64(id?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/GetFileBase64?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFileBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostDocumentTemplate/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllSettings(body?: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTestEmail(body?: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setup(body?: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getInvoiceInfo(id?: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInvoice(body?: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IWPFaxToSSAServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param faxStatus (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getSignedIWPs(keyword?: string | null | undefined, faxStatus?: IWPFaxStatusFilter | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfSignedIWPListItemDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPFaxToSSA/GetSignedIWPs?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (faxStatus === null)
            throw new Error("The parameter 'faxStatus' cannot be null.");
        else if (faxStatus !== undefined)
            url_ += "FaxStatus=" + encodeURIComponent("" + faxStatus) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedIWPs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedIWPs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSignedIWPListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSignedIWPListItemDto>;
        }));
    }

    protected processGetSignedIWPs(response: HttpResponseBase): Observable<PagedResultDtoOfSignedIWPListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSignedIWPListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCanFax(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/IWPFaxToSSA/GetCanFax";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCanFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCanFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCanFax(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    getFaxCoverSheet(iwpId?: number | undefined): Observable<IWPFaxCoverSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPFaxToSSA/GetFaxCoverSheet?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxCoverSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxCoverSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPFaxCoverSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPFaxCoverSheetDto>;
        }));
    }

    protected processGetFaxCoverSheet(response: HttpResponseBase): Observable<IWPFaxCoverSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPFaxCoverSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    prepareFaxPacket(body?: IWPFaxCoverSheetDto | undefined): Observable<IWPFaxPacketDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPFaxToSSA/PrepareFaxPacket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareFaxPacket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareFaxPacket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPFaxPacketDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPFaxPacketDto>;
        }));
    }

    protected processPrepareFaxPacket(response: HttpResponseBase): Observable<IWPFaxPacketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPFaxPacketDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param faxHistoryId (optional) 
     * @return OK
     */
    sendFaxPacket(faxHistoryId?: number | undefined): Observable<IWPFaxHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPFaxToSSA/SendFaxPacket?";
        if (faxHistoryId === null)
            throw new Error("The parameter 'faxHistoryId' cannot be null.");
        else if (faxHistoryId !== undefined)
            url_ += "faxHistoryId=" + encodeURIComponent("" + faxHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFaxPacket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFaxPacket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPFaxHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPFaxHistoryDto>;
        }));
    }

    protected processSendFaxPacket(response: HttpResponseBase): Observable<IWPFaxHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPFaxHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    getFaxHistory(iwpId?: number | undefined): Observable<IWPFaxHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IWPFaxToSSA/GetFaxHistory?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPFaxHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPFaxHistoryDto[]>;
        }));
    }

    protected processGetFaxHistory(response: HttpResponseBase): Observable<IWPFaxHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IWPFaxHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IWPServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Add IWP
     * @param body (optional) 
     * @return OK
     */
    addIWP(body?: IWPDdto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddIWP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIWP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIWP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddIWP(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Session time of the IWP
     * @param body (optional) 
     * @return OK
     */
    addInterviewSession(body?: IWPInterviewSessionWithStatusDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddInterviewSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInterviewSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInterviewSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddInterviewSession(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add IWP Section Four
     * @param body (optional) 
     * @return OK
     */
    addIWPSectionFour(body?: IWPSectionFourDto | undefined): Observable<IWPSectionFourDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddIWPSectionFour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIWPSectionFour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIWPSectionFour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionFourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionFourDto>;
        }));
    }

    protected processAddIWPSectionFour(response: HttpResponseBase): Observable<IWPSectionFourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionFourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add IWP Section one
     * @param body (optional) 
     * @return OK
     */
    addIWPSectionOne(body?: IWPSectionOneDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddIWPSectionOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIWPSectionOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIWPSectionOne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddIWPSectionOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add IWP Section Three
     * @param body (optional) 
     * @return OK
     */
    addIWPSectionThree(body?: IWPSectionThreeDto | undefined): Observable<IWPSectionThreeDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddIWPSectionThree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIWPSectionThree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIWPSectionThree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionThreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionThreeDto>;
        }));
    }

    protected processAddIWPSectionThree(response: HttpResponseBase): Observable<IWPSectionThreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionThreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add IWP Section Two Work History
     * @param body (optional) 
     * @return OK
     */
    addIWPSectionTwoWorkHistory(body?: IWPWorkHistoryDto | undefined): Observable<IWPWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddIWPSectionTwoWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIWPSectionTwoWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIWPSectionTwoWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto>;
        }));
    }

    protected processAddIWPSectionTwoWorkHistory(response: HttpResponseBase): Observable<IWPWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start IWP Process i.e, Transfer Lead to IWP
     * @param leadId (optional) 
     * @return OK
     * @deprecated
     */
    addStartIWPProcess(leadId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/AddStartIWPProcess?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStartIWPProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStartIWPProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddStartIWPProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get IWP by iwpid
     * @return OK
     */
    getIWPById(iwpId: number): Observable<IWPDdto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPById?";
        if (iwpId === undefined || iwpId === null)
            throw new Error("The parameter 'iwpId' must be defined and cannot be null.");
        else
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPDdto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPDdto>;
        }));
    }

    protected processGetIWPById(response: HttpResponseBase): Observable<IWPDdto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPDdto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get IWP Queue
     * @param filter (optional) 
     * @param isDeleted (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getIWPQueues(filter?: string | null | undefined, isDeleted?: boolean | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfIWPQDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPQueues?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPQueues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPQueues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIWPQDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIWPQDto>;
        }));
    }

    protected processGetIWPQueues(response: HttpResponseBase): Observable<PagedResultDtoOfIWPQDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIWPQDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteIWPQ(iwpId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/DeleteIWPQ?";
        if (iwpId === undefined || iwpId === null)
            throw new Error("The parameter 'iwpId' must be defined and cannot be null.");
        else
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteIWPQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIWPQ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteIWPQ(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get IWP Section Four
     * @param iWPId (optional) 
     * @return OK
     */
    getIWPSectionFourByIWPId(iWPId?: number | undefined): Observable<IWPSectionFourDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPSectionFourByIWPId?";
        if (iWPId === null)
            throw new Error("The parameter 'iWPId' cannot be null.");
        else if (iWPId !== undefined)
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSectionFourByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSectionFourByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionFourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionFourDto>;
        }));
    }

    protected processGetIWPSectionFourByIWPId(response: HttpResponseBase): Observable<IWPSectionFourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionFourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get IWP Section One
     * @param iWPId (optional) 
     * @return OK
     */
    getIWPSectionOne(iWPId?: number | undefined): Observable<IWPSectionOneDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPSectionOne?";
        if (iWPId === null)
            throw new Error("The parameter 'iWPId' cannot be null.");
        else if (iWPId !== undefined)
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSectionOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSectionOne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionOneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionOneDto>;
        }));
    }

    protected processGetIWPSectionOne(response: HttpResponseBase): Observable<IWPSectionOneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionOneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get IWP Section Three by IWP Id
     * @param iWPId (optional) 
     * @return OK
     */
    getIWPSectionThreeByIWPId(iWPId?: number | undefined): Observable<IWPSectionThreeDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPSectionThreeByIWPId?";
        if (iWPId === null)
            throw new Error("The parameter 'iWPId' cannot be null.");
        else if (iWPId !== undefined)
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSectionThreeByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSectionThreeByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionThreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionThreeDto>;
        }));
    }

    protected processGetIWPSectionThreeByIWPId(response: HttpResponseBase): Observable<IWPSectionThreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionThreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get OWP Section Two Work History List by IWP Id
     * @param iWPId (optional) 
     * @return OK
     */
    getIWPSectionTwoWorkHistoryListByIWPId(iWPId?: number | undefined): Observable<IWPWorkHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPSectionTwoWorkHistoryListByIWPId?";
        if (iWPId === null)
            throw new Error("The parameter 'iWPId' cannot be null.");
        else if (iWPId !== undefined)
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSectionTwoWorkHistoryListByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSectionTwoWorkHistoryListByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto[]>;
        }));
    }

    protected processGetIWPSectionTwoWorkHistoryListByIWPId(response: HttpResponseBase): Observable<IWPWorkHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IWPWorkHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get IWP Section two work hitory by Id
     * @param id (optional) 
     * @return OK
     */
    getIWPSectionTwoWorkHistoryById(id?: number | undefined): Observable<IWPWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPSectionTwoWorkHistoryById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSectionTwoWorkHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSectionTwoWorkHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto>;
        }));
    }

    protected processGetIWPSectionTwoWorkHistoryById(response: HttpResponseBase): Observable<IWPWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Lead Address by Lead Id
     * @return OK
     */
    getLeadAddressesByLeadId(leadId: number): Observable<AddressDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetLeadAddressesByLeadId?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadAddressesByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadAddressesByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto[]>;
        }));
    }

    protected processGetLeadAddressesByLeadId(response: HttpResponseBase): Observable<AddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Lead Phone number by Lead Id
     * @return OK
     */
    getLeadPhoneNumbersByLeadId(leadId: number): Observable<PhoneDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetLeadPhoneNumbersByLeadId?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadPhoneNumbersByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadPhoneNumbersByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneDto[]>;
        }));
    }

    protected processGetLeadPhoneNumbersByLeadId(response: HttpResponseBase): Observable<PhoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Duration Modality by IWP Id
     * @param iWPId (optional) 
     * @return OK
     */
    getDurationModalityByIWPId(iWPId?: number | undefined): Observable<DurationModalityDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetDurationModalityByIWPId?";
        if (iWPId === null)
            throw new Error("The parameter 'iWPId' cannot be null.");
        else if (iWPId !== undefined)
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDurationModalityByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDurationModalityByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DurationModalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DurationModalityDto>;
        }));
    }

    protected processGetDurationModalityByIWPId(response: HttpResponseBase): Observable<DurationModalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DurationModalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the terms and conditions for a given IWP ID.
     * @param iWPId The ID of the IWP (must be greater than zero).
     * @return OK
     */
    getTermsConditionsByIWPId(iWPId: number): Observable<IWPTermsConditionsDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetTermsConditionsByIWPId?";
        if (iWPId === undefined || iWPId === null)
            throw new Error("The parameter 'iWPId' must be defined and cannot be null.");
        else
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsConditionsByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsConditionsByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPTermsConditionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPTermsConditionsDto>;
        }));
    }

    protected processGetTermsConditionsByIWPId(response: HttpResponseBase): Observable<IWPTermsConditionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPTermsConditionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update IWP
     * @param body (optional) 
     * @return OK
     */
    updateIWP(body?: UpdateIWPDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateIWP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Section Four
     * @param body (optional) 
     * @return OK
     */
    updateIWPSectionFour(body?: IWPSectionFourDto | undefined): Observable<IWPSectionFourDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWPSectionFour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPSectionFour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPSectionFour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionFourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionFourDto>;
        }));
    }

    protected processUpdateIWPSectionFour(response: HttpResponseBase): Observable<IWPSectionFourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionFourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Section one
     * @param body (optional) 
     * @return OK
     */
    updateIWPSectionOne(body?: IWPSectionOneDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWPSectionOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPSectionOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPSectionOne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateIWPSectionOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Section Three
     * @param body (optional) 
     * @return OK
     */
    updateIWPSectionThree(body?: IWPSectionThreeDto | undefined): Observable<IWPSectionThreeDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWPSectionThree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPSectionThree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPSectionThree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionThreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionThreeDto>;
        }));
    }

    protected processUpdateIWPSectionThree(response: HttpResponseBase): Observable<IWPSectionThreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionThreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Section Twp Work History by Id
     * @param body (optional) 
     * @return OK
     */
    updateIWPSectionTwoWorkHistoryById(body?: IWPWorkHistoryDto | undefined): Observable<IWPWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWPSectionTwoWorkHistoryById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPSectionTwoWorkHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPSectionTwoWorkHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto>;
        }));
    }

    protected processUpdateIWPSectionTwoWorkHistoryById(response: HttpResponseBase): Observable<IWPWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Duration Modality
     * @param body (optional) 
     * @return OK
     */
    updateDurationModality(body?: DurationModalityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateDurationModality";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDurationModality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDurationModality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDurationModality(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the terms and conditions associated with a specific IWP.
     * @param body (optional) The DTO containing updated terms and conditions.
     * @return OK
     */
    updateTermsConditions(body?: IWPTermsConditionsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateTermsConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTermsConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTermsConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTermsConditions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Work History
     * @param id (optional) 
     * @return OK
     */
    deleteIWPWorkHistoryById(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/DeleteIWPWorkHistoryById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteIWPWorkHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIWPWorkHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteIWPWorkHistoryById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Filled IWP in the base 64 format
     * @param iWPId (optional) 
     * @return OK
     */
    getFilledForm1370FileByIWPId(iWPId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetFilledForm1370FileByIWPId?";
        if (iWPId === null)
            throw new Error("The parameter 'iWPId' cannot be null.");
        else if (iWPId !== undefined)
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilledForm1370FileByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilledForm1370FileByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFilledForm1370FileByIWPId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Under review IWP
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUnderReviewIWP(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfIWPDdto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetUnderReviewIWP?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnderReviewIWP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnderReviewIWP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIWPDdto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIWPDdto>;
        }));
    }

    protected processGetUnderReviewIWP(response: HttpResponseBase): Observable<PagedResultDtoOfIWPDdto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIWPDdto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Status of the IWP
     * @param body (optional) 
     * @return OK
     */
    updateIWPStatus(body?: UpdateIWPStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWPStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateIWPStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all IWP which is either signed or in processing for signing
     * @param isBothSigned (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllESignProcessing(isBothSigned?: boolean | undefined, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetESignProcessingDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetAllESignProcessing?";
        if (isBothSigned === null)
            throw new Error("The parameter 'isBothSigned' cannot be null.");
        else if (isBothSigned !== undefined)
            url_ += "IsBothSigned=" + encodeURIComponent("" + isBothSigned) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllESignProcessing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllESignProcessing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetESignProcessingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetESignProcessingDto>;
        }));
    }

    protected processGetAllESignProcessing(response: HttpResponseBase): Observable<PagedResultDtoOfGetESignProcessingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetESignProcessingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Transfer data from Lead to Ticket Holder
     * @param leadId (optional) 
     * @return OK
     */
    updateTransferData(leadId?: number | undefined): Observable<TicketHolderInfo> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateTransferData?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderInfo>;
        }));
    }

    protected processUpdateTransferData(response: HttpResponseBase): Observable<TicketHolderInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Manual fallback: triggers Lead → TicketHolder conversion for a DigitalSignature record
    where both parties have already signed but the automatic webhook did not process it.
     * @param digitalSignatureId (optional) 
     * @return OK
     */
    manuallyMoveToTicketHolder(digitalSignatureId?: number | undefined): Observable<TicketHolderInfo> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/ManuallyMoveToTicketHolder?";
        if (digitalSignatureId === null)
            throw new Error("The parameter 'digitalSignatureId' cannot be null.");
        else if (digitalSignatureId !== undefined)
            url_ += "digitalSignatureId=" + encodeURIComponent("" + digitalSignatureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManuallyMoveToTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManuallyMoveToTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderInfo>;
        }));
    }

    protected processManuallyMoveToTicketHolder(response: HttpResponseBase): Observable<TicketHolderInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves Section Six data of the Individual Work Plan (IWP) by the provided IWP ID.
    Gathers client and representative information required for Section Six.
     * @param iWPId The unique identifier for the IWP. Must be provided.
     * @return OK
     */
    getIWPSectionSixByIWPId(iWPId: number): Observable<IWPSectionSixDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIWPSectionSixByIWPId?";
        if (iWPId === undefined || iWPId === null)
            throw new Error("The parameter 'iWPId' must be defined and cannot be null.");
        else
            url_ += "IWPId=" + encodeURIComponent("" + iWPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSectionSixByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSectionSixByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSectionSixDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSectionSixDto>;
        }));
    }

    protected processGetIWPSectionSixByIWPId(response: HttpResponseBase): Observable<IWPSectionSixDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSectionSixDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the client name and email (Section Six) for a specific IWP record, identified by IWPId.
    Throws an exception if the IWP Section One record is not found.
     * @param body (optional) DTO containing the IWP ID, client name, and client email.
     * @return OK
     */
    updateIWPSectionSixByIWPId(body?: UpdateIWPSectionSixDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/UpdateIWPSectionSixByIWPId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPSectionSixByIWPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPSectionSixByIWPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateIWPSectionSixByIWPId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns instructional help text for each field in Thrive.TTW.IWP.IWPSectionFour Section 4.
     * @return OK
     */
    getIwpSection4HelpText(iwpId: number): Observable<FieldHelpDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/GetIwpSection4HelpText?";
        if (iwpId === undefined || iwpId === null)
            throw new Error("The parameter 'iwpId' must be defined and cannot be null.");
        else
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIwpSection4HelpText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIwpSection4HelpText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldHelpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldHelpDto[]>;
        }));
    }

    protected processGetIwpSection4HelpText(response: HttpResponseBase): Observable<FieldHelpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldHelpDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Extract IWP pdf data
     * @param body (optional) 
     * @return OK
     */
    extractIWPInfo(body?: UploadFileOutputDto | undefined): Observable<ExtractIWPDto> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/ExtractIWPInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtractIWPInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtractIWPInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtractIWPDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtractIWPDto>;
        }));
    }

    protected processExtractIWPInfo(response: HttpResponseBase): Observable<ExtractIWPDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtractIWPDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insertIWPInfoForTicketHolder(body?: ExtractIWPDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/IWPService/InsertIWPInfoForTicketHolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertIWPInfoForTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertIWPInfoForTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertIWPInfoForTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new job lead entry associated with a ticket holder.
    Maps the provided DTO to the entity and persists it to the database.
     * @param body (optional) The job lead details to be created.
     * @return OK
     */
    createTicketHolderJobLead(body?: CreateJobLeadDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/CreateTicketHolderJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicketHolderJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicketHolderJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateTicketHolderJobLead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a lead to a career coach's manual (career-coach-only) job search.
    Takes the same payload as the job search assistant's lead form.
     * @param body (optional) 
     * @return OK
     */
    createManualJobSearchLead(body?: CreateManualJobSearchLeadDto | undefined): Observable<CreateJobLeadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/CreateManualJobSearchLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualJobSearchLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualJobSearchLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobLeadResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobLeadResponseDto>;
        }));
    }

    protected processCreateManualJobSearchLead(response: HttpResponseBase): Observable<CreateJobLeadResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobLeadResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a lead pasted as JSON (same format as the job search assistant's JSON tab)
    to a career coach's manual job search.
     * @param body (optional) 
     * @return OK
     */
    createManualJobSearchLeadByJson(body?: CreateManualJobSearchLeadFromJsonDto | undefined): Observable<CreateJobLeadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/CreateManualJobSearchLeadByJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualJobSearchLeadByJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualJobSearchLeadByJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobLeadResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobLeadResponseDto>;
        }));
    }

    protected processCreateManualJobSearchLeadByJson(response: HttpResponseBase): Observable<CreateJobLeadResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobLeadResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSampleJobLeadJsonData(): Observable<JobLeadSampleDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetSampleJobLeadJsonData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleJobLeadJsonData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleJobLeadJsonData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLeadSampleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLeadSampleDto>;
        }));
    }

    protected processGetSampleJobLeadJsonData(response: HttpResponseBase): Observable<JobLeadSampleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLeadSampleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing job lead associated with a ticket holder.
    Retrieves the record by ID, maps the updated values, and saves the changes.
     * @param body (optional) The updated job lead details along with its unique identifier.
     * @return OK
     */
    updateTicketHolderJobLead(body?: UpdateJobLeadDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateTicketHolderJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTicketHolderJobLead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a job lead record by its unique identifier and maps it to an update DTO.
     * @param id The unique identifier of the job lead to retrieve. Must be greater than zero.
     * @return OK
     */
    getJobLeadById(id: number): Observable<TicketHolderJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetJobLeadById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLeadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLeadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderJobLeadDto>;
        }));
    }

    protected processGetJobLeadById(response: HttpResponseBase): Observable<TicketHolderJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Job Lead Location By Lead Id
     * @param body (optional) 
     * @return OK
     */
    updateJobLeadLocation(body?: UpdateJobLeadLocationDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobLeadLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLeadLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLeadLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLeadLocation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes multiple job lead entries by their unique identifiers.
     * @param ids A collection of unique identifiers of job leads to delete.
    Each ID must be greater than zero.
     * @return OK
     */
    deleteJobLeadsByIds(ids: number[] | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/DeleteJobLeadsByIds?";
        if (ids === undefined)
            throw new Error("The parameter 'ids' must be defined.");
        else if(ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobLeadsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobLeadsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobLeadsByIds(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and sorted list of all job leads.
    Maps the result to Thrive.TTW.Job.dto.UpdateJobLeadDto for editing purposes.
     * @param body (optional) Pagination and sorting input.
     * @return OK
     */
    getAllJobLead(body?: JobLeadFilterDto | undefined): Observable<PagedResultDtoOfTicketHolderJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetAllJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderJobLeadDto>;
        }));
    }

    protected processGetAllJobLead(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new job search request for a ticket holder based on the provided input.
    The request is associated with the currently logged-in user as the requester.
     * @param body (optional) The data transfer object containing job search request details.
     * @return OK
     */
    createJobSearchRequest(body?: CreateJobSearchRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/CreateJobSearchRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateJobSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the next offshore career coach user ID based on round-robin assignment.
     * @param jobSearchRequestId (optional) 
     * @return OK
     */
    duplicateJobSearchRequest(jobSearchRequestId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Job/DuplicateJobSearchRequest?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateJobSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateJobSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDuplicateJobSearchRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing job search request with the provided input data.
    Throws a user-friendly exception if the job search request is not found.
     * @param body (optional) The data transfer object containing the updated job search request details, including the ID.
     * @return OK
     */
    updateJobSearchRequest(body?: UpdateJobSearchRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobSearchRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing job search request by its identifier.
    Throws a user-friendly exception if the job search request does not exist.
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getSmartSetupSuggestion(ticketHolderId?: number | undefined): Observable<SmartSetupJobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetSmartSetupSuggestion?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartSetupSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartSetupSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartSetupJobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartSetupJobSearchRequestDto>;
        }));
    }

    protected processGetSmartSetupSuggestion(response: HttpResponseBase): Observable<SmartSetupJobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartSetupJobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * A short list of verified, real "Nearby Location" candidates for a Job Search Request,
    built from the US Census Bureau's public geocoder (see CensusGeocodingService) rather
    than an AI guess -- an LLM can't reliably tell whether an address exists or compute an
    actual distance. Strategy: geocode the ticket holder's real address, then try nearby
    house numbers on the SAME street (closest offset first, within that street's real TIGER
    house-number range), verifying each one via a real geocode + a Haversine distance check,
    collecting every one that lands within 0.2 miles (up to 5) -- this is what "if possible,
    same street" means: same-street candidates only ever come from a genuinely real, distinct
    address within range. If none are found (e.g. a short block, an apartment building, a
    dead end), falls back to a single city/state/ZIP candidate with no street, per the same
    "not then street should not be same" instruction. The coach picks one of these before any
    map/distance is shown (see ReverseGeocodeNearbyLocationAsync for picking a point off-list).
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getNearbyLocationSuggestion(ticketHolderId?: number | undefined): Observable<NearbyLocationSuggestionDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetNearbyLocationSuggestion?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNearbyLocationSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNearbyLocationSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NearbyLocationSuggestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NearbyLocationSuggestionDto>;
        }));
    }

    protected processGetNearbyLocationSuggestion(response: HttpResponseBase): Observable<NearbyLocationSuggestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NearbyLocationSuggestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param originLatitude (optional) 
     * @param originLongitude (optional) 
     * @return OK
     */
    reverseGeocodeNearbyLocation(latitude?: number | undefined, longitude?: number | undefined, originLatitude?: number | undefined, originLongitude?: number | undefined): Observable<NearbyLocationCandidateDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/ReverseGeocodeNearbyLocation?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (originLatitude === null)
            throw new Error("The parameter 'originLatitude' cannot be null.");
        else if (originLatitude !== undefined)
            url_ += "originLatitude=" + encodeURIComponent("" + originLatitude) + "&";
        if (originLongitude === null)
            throw new Error("The parameter 'originLongitude' cannot be null.");
        else if (originLongitude !== undefined)
            url_ += "originLongitude=" + encodeURIComponent("" + originLongitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReverseGeocodeNearbyLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReverseGeocodeNearbyLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NearbyLocationCandidateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NearbyLocationCandidateDto>;
        }));
    }

    protected processReverseGeocodeNearbyLocation(response: HttpResponseBase): Observable<NearbyLocationCandidateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NearbyLocationCandidateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteJobSearchRequest(jobSearchRequestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/DeleteJobSearchRequest?";
        if (jobSearchRequestId === undefined || jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' must be defined and cannot be null.");
        else
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Closes the current round of a working job search request (sets Status → Closed)
    and soft-deletes every job lead associated with that request.
    Intended for the "no search needed at this time" workflow.
     * @param jobSearchRequestId (optional) 
     * @return OK
     */
    closeJobSearchRequestWithLeadCleanup(jobSearchRequestId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/CloseJobSearchRequestWithLeadCleanup?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseJobSearchRequestWithLeadCleanup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseJobSearchRequestWithLeadCleanup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCloseJobSearchRequestWithLeadCleanup(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobSearchRequestId (optional) 
     * @return OK
     */
    closeAndArchiveLeadsByCC(jobSearchRequestId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/CloseAndArchiveLeadsByCC?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseAndArchiveLeadsByCC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseAndArchiveLeadsByCC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCloseAndArchiveLeadsByCC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobSearchRequestId (optional) 
     * @return OK
     */
    startNewRoundByCC(jobSearchRequestId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/StartNewRoundByCC?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartNewRoundByCC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartNewRoundByCC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processStartNewRoundByCC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a job search the career coach runs themselves against an existing request.
    It is a career-coach-only round: it does not become the request's CurrentRound, so the
    JSA workflow is untouched, and it is hidden from job search assistants.
     * @param body (optional) 
     * @return OK
     */
    createManualJobSearchByCC(body?: CreateManualJobSearchDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Job/CreateManualJobSearchByCC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualJobSearchByCC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualJobSearchByCC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateManualJobSearchByCC(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of job search requests for a specific ticket holder, ordered by most recent first.
     * @param body (optional) The filter input containing the TicketHolder ID and pagination/sorting parameters.
     * @return OK
     */
    getAllJobSearchRequestByTicketHolderId(body?: JobSearchRequestFilterDto | undefined): Observable<PagedResultDtoOfJobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetAllJobSearchRequestByTicketHolderId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobSearchRequestByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobSearchRequestByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJobSearchRequestDto>;
        }));
    }

    protected processGetAllJobSearchRequestByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfJobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a job search request by its unique identifier.
    Throws a UserFriendlyException if the request is not found.
     * @param id The unique ID of the job search request. Must be greater than zero.
     * @return OK
     */
    getJobSearchRequestById(id: number): Observable<JobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetJobSearchRequestById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSearchRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSearchRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchRequestDto>;
        }));
    }

    protected processGetJobSearchRequestById(response: HttpResponseBase): Observable<JobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks a specific job lead for a given ticket holder as Thrive.TTW.TicketHolderJobApplicationStatus.Archived.
     * @param ticketHolderId The unique identifier of the ticket holder associated with the job lead.
     * @param body The unique identifier of the job lead to be archived.
     * @return OK
     */
    markJobLeadsToArchive(ticketHolderId: number, body: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/MarkJobLeadsToArchive?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkJobLeadsToArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkJobLeadsToArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkJobLeadsToArchive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Applies the current user to a specified job lead by updating their job activity status.
     * @return OK
     */
    applyJob(jobLeadId: number, ticketHolderId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/ApplyJob?";
        if (jobLeadId === undefined || jobLeadId === null)
            throw new Error("The parameter 'jobLeadId' must be defined and cannot be null.");
        else
            url_ += "jobLeadId=" + encodeURIComponent("" + jobLeadId) + "&";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processApplyJob(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends one or more job leads to a specific ticket holder.
    Creates a new Thrive.TTW.TicketHolder.TicketHolderJobActivity record for each job lead,
    marks it as `Sent`, and triggers communication jobs (if delivery method is SMS or Email).
     * @param ticketHolderId The ID of the ticket holder receiving the job leads.
     * @param body A list of JobLead IDs to be sent to the ticket holder.
     * @return OK
     */
    sendJobLeadsToTicketHolder(ticketHolderId: number, body: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/SendJobLeadsToTicketHolder?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendJobLeadsToTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendJobLeadsToTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendJobLeadsToTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resendJobLeadsToTicketHolder(jobSearchRequestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/ResendJobLeadsToTicketHolder?";
        if (jobSearchRequestId === undefined || jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' must be defined and cannot be null.");
        else
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendJobLeadsToTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendJobLeadsToTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResendJobLeadsToTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of job search requests created by the currently logged-in career coach (user).
     * @param body (optional) The filter and pagination settings to apply when querying job search requests.
     * @return OK
     */
    getMyJobSearchRequests(body?: JobSearchRequestByCareerCoachFilterDto | undefined): Observable<PagedResultDtoOfJobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetMyJobSearchRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyJobSearchRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyJobSearchRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJobSearchRequestDto>;
        }));
    }

    protected processGetMyJobSearchRequests(response: HttpResponseBase): Observable<PagedResultDtoOfJobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Job Lead Company Name
     * @param body (optional) 
     * @return OK
     */
    updateJobLeadCompanyName(body?: UpdateJobLeadCompanyNameDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobLeadCompanyName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLeadCompanyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLeadCompanyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLeadCompanyName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Routs
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getMyRoundStats(ticketHolderId?: number | null | undefined): Observable<JobSearchRoundStatusSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetMyRoundStats?";
        if (ticketHolderId !== undefined && ticketHolderId !== null)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRoundStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRoundStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchRoundStatusSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchRoundStatusSummaryDto>;
        }));
    }

    protected processGetMyRoundStats(response: HttpResponseBase): Observable<JobSearchRoundStatusSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchRoundStatusSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a Job Search Request.
     * @param jobSearchRequestId (optional) The ID of the job search request.
     * @param body (optional) The new status to apply.
     * @return OK
     */
    updateJobSearchRequestStatus(jobSearchRequestId?: number | undefined, body?: JobSearchRequestStatus | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobSearchRequestStatus?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchRequestStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get history of a job activities, mainly status change history
     * @param jobLeadId (optional) 
     * @return OK
     */
    getJobActivityHistoryByJobLeadId(jobLeadId?: number | undefined): Observable<TicketHolderJobActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetJobActivityHistoryByJobLeadId?";
        if (jobLeadId === null)
            throw new Error("The parameter 'jobLeadId' cannot be null.");
        else if (jobLeadId !== undefined)
            url_ += "jobLeadId=" + encodeURIComponent("" + jobLeadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobActivityHistoryByJobLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobActivityHistoryByJobLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderJobActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderJobActivityDto[]>;
        }));
    }

    protected processGetJobActivityHistoryByJobLeadId(response: HttpResponseBase): Observable<TicketHolderJobActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderJobActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Job Interview along with its sessions for a Career Coach.
     * @param body (optional) The job interview data, including optional sessions.
     * @return OK
     */
    createJobInterviewForCoach(body?: CoachCreateOrUpdateJobInterviewDto | undefined): Observable<CoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/CreateJobInterviewForCoach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobInterviewForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobInterviewForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachJobInterviewDto>;
        }));
    }

    protected processCreateJobInterviewForCoach(response: HttpResponseBase): Observable<CoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing Job Interview for a Career Coach, including its sessions.
    Updates existing sessions, adds new ones if Id = 0.
     * @param body (optional) The updated job interview and sessions data.
     * @return OK
     */
    updateJobInterviewForCoach(body?: CoachCreateOrUpdateJobInterviewDto | undefined): Observable<CoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobInterviewForCoach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobInterviewForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobInterviewForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachJobInterviewDto>;
        }));
    }

    protected processUpdateJobInterviewForCoach(response: HttpResponseBase): Observable<CoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a job interview and all its sessions (and related calendar events) for a Career Coach.
     * @param id (optional) 
     * @return OK
     */
    deleteJobInterviewForCoach(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Job/DeleteJobInterviewForCoach?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobInterviewForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobInterviewForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJobInterviewForCoach(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a single job interview with sessions for a Career Coach.
     * @param id (optional) 
     * @return OK
     */
    getJobInterviewForCoach(id?: number | undefined): Observable<CoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetJobInterviewForCoach?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobInterviewForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobInterviewForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachJobInterviewDto>;
        }));
    }

    protected processGetJobInterviewForCoach(response: HttpResponseBase): Observable<CoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all job interviews for a given Ticket Holder, with paging and sorting.
     * @param ticketHolderId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobInterviewsByTicketHolder(ticketHolderId?: number | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetAllJobInterviewsByTicketHolder?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobInterviewsByTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobInterviewsByTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
        }));
    }

    protected processGetAllJobInterviewsByTicketHolder(response: HttpResponseBase): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all upcoming job interviews for a given Ticket Holder, with paging and sorting.
     * @param ticketHolderId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getUpcomingJobInterviewsByTicketHolder(ticketHolderId?: number | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetUpcomingJobInterviewsByTicketHolder?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingJobInterviewsByTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingJobInterviewsByTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
        }));
    }

    protected processGetUpcomingJobInterviewsByTicketHolder(response: HttpResponseBase): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all past successful job interviews for a given Ticket Holder, with paging and sorting.
     * @param ticketHolderId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getPastSuccessfulJobInterviewsByTicketHolder(ticketHolderId?: number | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetPastSuccessfulJobInterviewsByTicketHolder?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastSuccessfulJobInterviewsByTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastSuccessfulJobInterviewsByTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
        }));
    }

    protected processGetPastSuccessfulJobInterviewsByTicketHolder(response: HttpResponseBase): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all past unsuccessful job interviews for a given Ticket Holder, with paging and sorting.
     * @param ticketHolderId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getPastUnsuccessfulJobInterviewsByTicketHolder(ticketHolderId?: number | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetPastUnsuccessfulJobInterviewsByTicketHolder?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastUnsuccessfulJobInterviewsByTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastUnsuccessfulJobInterviewsByTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCoachJobInterviewDto>;
        }));
    }

    protected processGetPastUnsuccessfulJobInterviewsByTicketHolder(response: HttpResponseBase): Observable<PagedResultDtoOfCoachJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCoachJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new job interview session to an existing job interview.
     * @param jobInterviewId (optional) The parent job interview Id.
     * @param body (optional) The session details.
     * @return OK
     */
    addJobInterviewSessionForCoach(jobInterviewId?: number | undefined, body?: CoachCreateOrUpdateJobInterviewSessionDto | undefined): Observable<CoachJobInterviewSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/AddJobInterviewSessionForCoach?";
        if (jobInterviewId === null)
            throw new Error("The parameter 'jobInterviewId' cannot be null.");
        else if (jobInterviewId !== undefined)
            url_ += "jobInterviewId=" + encodeURIComponent("" + jobInterviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddJobInterviewSessionForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddJobInterviewSessionForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachJobInterviewSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachJobInterviewSessionDto>;
        }));
    }

    protected processAddJobInterviewSessionForCoach(response: HttpResponseBase): Observable<CoachJobInterviewSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachJobInterviewSessionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing job interview session for a Career Coach.
     * @param body (optional) The updated session details.
     * @return OK
     */
    updateJobInterviewSessionForCoach(body?: CoachCreateOrUpdateJobInterviewSessionDto | undefined): Observable<CoachJobInterviewSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobInterviewSessionForCoach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobInterviewSessionForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobInterviewSessionForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachJobInterviewSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachJobInterviewSessionDto>;
        }));
    }

    protected processUpdateJobInterviewSessionForCoach(response: HttpResponseBase): Observable<CoachJobInterviewSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachJobInterviewSessionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update JobLead Status
     * @param body (optional) 
     * @return OK
     */
    updateJobLeadStatus(body?: UpdateJobLeadStatusRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobLeadStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLeadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLeadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLeadStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a job interview session for a Career Coach.
     * @param id (optional) 
     * @return OK
     */
    deleteJobInterviewSessionForCoach(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/DeleteJobInterviewSessionForCoach?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobInterviewSessionForCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobInterviewSessionForCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobInterviewSessionForCoach(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get allowed job application status
     * @param currentStatus (optional) 
     * @return OK
     */
    getAllowedJobsStatus(currentStatus?: CurrentStatus | undefined): Observable<JobApplicationStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetAllowedJobsStatus?";
        if (currentStatus === null)
            throw new Error("The parameter 'currentStatus' cannot be null.");
        else if (currentStatus !== undefined)
            url_ += "currentStatus=" + encodeURIComponent("" + currentStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedJobsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedJobsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationStatusDto[]>;
        }));
    }

    protected processGetAllowedJobsStatus(response: HttpResponseBase): Observable<JobApplicationStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update job search request status to paused or pending based on current status and input status
     * @param body (optional) 
     * @return OK
     */
    updateJobSearchToPausedStatus(body?: UpdateJobSearchStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Job/UpdateJobSearchToPausedStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchToPausedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchToPausedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchToPausedStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllLeads(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Job/GetAllLeads?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderJobLeadDto>;
        }));
    }

    protected processGetAllLeads(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobSearchAssistanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMyJobSearchRequests(body?: JSAJobSearchRequestFilterDto | undefined): Observable<PagedResultDtoOfJSAJobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetMyJobSearchRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyJobSearchRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyJobSearchRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJSAJobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJSAJobSearchRequestDto>;
        }));
    }

    protected processGetMyJobSearchRequests(response: HttpResponseBase): Observable<PagedResultDtoOfJSAJobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJSAJobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all job search request. Accessible only to OCC manager
     * @param body (optional) 
     * @return OK
     */
    getAllJobSearchRequests(body?: JSAMJobSearchRequestFilterDto | undefined): Observable<PagedResultDtoOfJSAJobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetAllJobSearchRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobSearchRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobSearchRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJSAJobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJSAJobSearchRequestDto>;
        }));
    }

    protected processGetAllJobSearchRequests(response: HttpResponseBase): Observable<PagedResultDtoOfJSAJobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJSAJobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new job lead and related job activity record.
    Optionally triggers a communication job if the delivery method is SMS or Email.
     * @param body (optional) The details for creating the job lead.
     * @return OK
     */
    createJobLead(body?: JSACreateJobLeadDto | undefined): Observable<CreateJobLeadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/CreateJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobLeadResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobLeadResponseDto>;
        }));
    }

    protected processCreateJobLead(response: HttpResponseBase): Observable<CreateJobLeadResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobLeadResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSampleJobLeadJsonData(): Observable<JobLeadSampleDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetSampleJobLeadJsonData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleJobLeadJsonData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleJobLeadJsonData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLeadSampleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLeadSampleDto>;
        }));
    }

    protected processGetSampleJobLeadJsonData(response: HttpResponseBase): Observable<JobLeadSampleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLeadSampleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createJobLeadByJson(body?: CreateJobLeadFromJsonDto | undefined): Observable<CreateJobLeadResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/CreateJobLeadByJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobLeadByJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobLeadByJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobLeadResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobLeadResponseDto>;
        }));
    }

    protected processCreateJobLeadByJson(response: HttpResponseBase): Observable<CreateJobLeadResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobLeadResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobSearchRequestsForDropdown(): Observable<JSAJobSearchRequestDropdownItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetJobSearchRequestsForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSearchRequestsForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSearchRequestsForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JSAJobSearchRequestDropdownItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JSAJobSearchRequestDropdownItemDto[]>;
        }));
    }

    protected processGetJobSearchRequestsForDropdown(response: HttpResponseBase): Observable<JSAJobSearchRequestDropdownItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JSAJobSearchRequestDropdownItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a job lead entry by its unique identifier.
    No need to log job activity because this is initial lead creation
     * @param id The unique identifier of the job lead to delete. Must be greater than zero.
     * @return OK
     */
    deleteJobLeadById(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/DeleteJobLeadById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobLeadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobLeadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobLeadById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of job leads for a specific job search request,
    filtered by search text, work arrangement, and posted date range.
     * @param filterText (optional) 
     * @param workArrangement (optional) 
     * @param postedStartDate (optional) 
     * @param postedEndDate (optional) 
     * @param statuses (optional) 
     * @param roundNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobLead(jobSearchRequestId: number, filterText?: string | null | undefined, workArrangement?: WorkArrangement[] | null | undefined, postedStartDate?: DateTime | null | undefined, postedEndDate?: DateTime | null | undefined, statuses?: JobApplicationStatus[] | null | undefined, roundNumber?: number | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfJSAJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetAllJobLead?";
        if (jobSearchRequestId === undefined || jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' must be defined and cannot be null.");
        else
            url_ += "JobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (workArrangement !== undefined && workArrangement !== null)
            workArrangement && workArrangement.forEach(item => { url_ += "WorkArrangement=" + encodeURIComponent("" + item) + "&"; });
        if (postedStartDate !== undefined && postedStartDate !== null)
            url_ += "PostedStartDate=" + encodeURIComponent(postedStartDate ? "" + postedStartDate.toString() : "") + "&";
        if (postedEndDate !== undefined && postedEndDate !== null)
            url_ += "PostedEndDate=" + encodeURIComponent(postedEndDate ? "" + postedEndDate.toString() : "") + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (roundNumber !== undefined && roundNumber !== null)
            url_ += "RoundNumber=" + encodeURIComponent("" + roundNumber) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJSAJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJSAJobLeadDto>;
        }));
    }

    protected processGetAllJobLead(response: HttpResponseBase): Observable<PagedResultDtoOfJSAJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJSAJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a job lead by its unique identifier.
     * @param id (optional) The unique identifier of the job lead.
     * @return OK
     */
    getJobLeadById(id?: number | undefined): Observable<JSAJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetJobLeadById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLeadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLeadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JSAJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JSAJobLeadDto>;
        }));
    }

    protected processGetJobLeadById(response: HttpResponseBase): Observable<JSAJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JSAJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing job lead with new details.
     * @param body (optional) The updated job lead details.
     * @return OK
     */
    updateJobLead(body?: JSAUpdateJobLeadDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/UpdateJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks a job search request as completed and updates the status of associated job leads.
     * @param body (optional) 
     * @return OK
     */
    updateJobSearchAsSearchComplete(body?: JSAUpdateJobSearchAsSearchCompleteReqDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/UpdateJobSearchAsSearchComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchAsSearchComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchAsSearchComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchAsSearchComplete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobSearchRequestById(id: number): Observable<JobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetJobSearchRequestById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSearchRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSearchRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchRequestDto>;
        }));
    }

    protected processGetJobSearchRequestById(response: HttpResponseBase): Observable<JobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * JSA Manager variant of M:Thrive.TTWJSA.JobSearch.JobSearchAssistanceAppService.GetJobSearchRequestByIdAsync(System.Int64).
    Returns the same data but is authorized under the JSA Manager permission, so a
    manager can open a job search request for editing without needing the JSA staff
    JobSearchRequest permission. Shares logic via M:Thrive.TTWJSA.JobSearch.JobSearchAssistanceAppService.BuildJobSearchRequestByIdAsync(System.Int64).
     * @return OK
     */
    getJobSearchRequestByIdForJSAManager(id: number): Observable<JobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetJobSearchRequestByIdForJSAManager?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSearchRequestByIdForJSAManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSearchRequestByIdForJSAManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchRequestDto>;
        }));
    }

    protected processGetJobSearchRequestByIdForJSAManager(response: HttpResponseBase): Observable<JobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeJobSearchRequestJSAAssignee(body?: ChangeJobSearchRequestAssigneeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/ChangeJobSearchRequestJSAAssignee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeJobSearchRequestJSAAssignee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeJobSearchRequestJSAAssignee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeJobSearchRequestJSAAssignee(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateJobSearchRequestByJSA(body?: UpdateJobSearchRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/UpdateJobSearchRequestByJSA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchRequestByJSA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchRequestByJSA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchRequestByJSA(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateJobSearchToPausedStatus(body?: UpdateJobSearchStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/UpdateJobSearchToPausedStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchToPausedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchToPausedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchToPausedStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Starts the job search for a request that is currently Closed (e.g. a freshly
    created request sitting at round 0, or a request whose previous round was closed).
    Opens the next round (round 0 -> round 1) with status Pending so the search begins.
     * @param jobSearchRequestId (optional) 
     * @return OK
     */
    startJobSearch(jobSearchRequestId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/StartJobSearch?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartJobSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartJobSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processStartJobSearch(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Archives every job lead linked to jobSearchRequestId by setting
    each lead's status to Thrive.TTW.JobApplicationStatus.Archived and recording an
    audit activity, then closes the current round and marks the request as Closed.
     * @param body (optional) 
     * @return OK
     */
    getAllJobSearchRequestsToExcel(body?: JSAMJobSearchRequestFilterDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/GetAllJobSearchRequestsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobSearchRequestsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobSearchRequestsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAllJobSearchRequestsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param jobSearchRequestId (optional) 
     * @return OK
     */
    closeJobSearchRequestAndArchiveLeads(jobSearchRequestId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/JobSearchAssistance/CloseJobSearchRequestAndArchiveLeads?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseJobSearchRequestAndArchiveLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseJobSearchRequestAndArchiveLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCloseJobSearchRequestAndArchiveLeads(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLanguageForEdit(id?: number | null | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateLanguage(body?: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteLanguage(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setDefaultLanguage(body?: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return OK
     */
    getLanguageTexts(sourceName: string | null, targetLanguageName: string | null, maxResultCount?: number | undefined, skipCount?: number | undefined, sorting?: string | null | undefined, baseLanguageName?: string | null | undefined, targetValueFilter?: string | null | undefined, filterText?: string | null | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (sourceName === undefined)
            throw new Error("The parameter 'sourceName' must be defined.");
        else if(sourceName !== null)
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (targetLanguageName === undefined)
            throw new Error("The parameter 'targetLanguageName' must be defined.");
        else if(targetLanguageName !== null)
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (baseLanguageName !== undefined && baseLanguageName !== null)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetValueFilter !== undefined && targetValueFilter !== null)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLanguageText(body?: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LeadServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Add New Lead by providing input
     * @param body (optional) 
     * @return OK
     */
    addNewLead(body?: NewLeadDto | undefined): Observable<LeadDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddNewLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto>;
        }));
    }

    protected processAddNewLead(response: HttpResponseBase): Observable<LeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all leads as pagination and also filter lead by providing filter input
     * @param body (optional) 
     * @return OK
     */
    getLeads(body?: LeadFilterDto | undefined): Observable<PagedResultDtoOfLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadDto>;
        }));
    }

    protected processGetLeads(response: HttpResponseBase): Observable<PagedResultDtoOfLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * When a Lead has been converted to a Ticket Holder (IWP signed by both parties), the Lead is deleted.
    Returns the formatted Ticket Holder id (e.g. "T...") the Lead was converted to, or null if the Lead
    still exists or was never converted. Lets old "CLT-..." links redirect to the Ticket Holder.
     * @param leadId (optional) 
     * @return OK
     */
    getConvertedTicketHolderId(leadId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetConvertedTicketHolderId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConvertedTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConvertedTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConvertedTicketHolderId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get lead by Lead Id
     * @param leadId (optional) 
     * @return OK
     */
    getLeadById(leadId?: number | undefined): Observable<LeadDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadById?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto>;
        }));
    }

    protected processGetLeadById(response: HttpResponseBase): Observable<LeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Lead Queue as per assigned to the current user
     * @return OK
     */
    getMyLeadQueue(): Observable<LeadDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetMyLeadQueue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLeadQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLeadQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto[]>;
        }));
    }

    protected processGetMyLeadQueue(response: HttpResponseBase): Observable<LeadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeadDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Starts a Retell AI calling run over every lead currently in the caller's Lead Queue.
    Leads are dialed strictly one at a time — this call places the first one and returns
    immediately; each subsequent lead is dialed only after the previous one's call outcome
    webhook lands (see DialNextRetellCallJob / OAuthWebhookController.AIVoiceCallOutcomeCallback).
     * @return OK
     */
    initiateRetellCalls(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/InitiateRetellCalls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateRetellCalls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateRetellCalls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitiateRetellCalls(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Stops the caller's own in-progress Retell run from dialing any further leads. Any call
    already ringing is left alone — Retell isn't told to hang it up, this only prevents the
    next lead in the queue from being dialed. Resumable via ResumeRetellCallsAsync.
     * @return OK
     */
    stopRetellCalls(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/StopRetellCalls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopRetellCalls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopRetellCalls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStopRetellCalls(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resumes a paused Retell run — either one the coach manually stopped, or one auto-paused
    after a successful transfer. Clears whichever lead the run was paused on (the coach has
    moved past it) and dials the next pending lead, if any.
     * @return OK
     */
    resumeRetellCalls(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/ResumeRetellCalls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeRetellCalls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeRetellCalls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResumeRetellCalls(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The caller's own current Retell run state, for the Lead Queue page to render the right
    button (Call via Retell AI / Stop / Resume) on load, before any SignalR event arrives.
     * @return OK
     */
    getRetellCallQueueStatus(): Observable<RetellCallQueueStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetRetellCallQueueStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetellCallQueueStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetellCallQueueStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetellCallQueueStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetellCallQueueStatusDto>;
        }));
    }

    protected processGetRetellCallQueueStatus(response: HttpResponseBase): Observable<RetellCallQueueStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetellCallQueueStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get profile section lead details
     * @param leadId (optional) 
     * @return OK
     */
    getProfile(leadId?: number | undefined): Observable<ProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetProfile?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDto>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<ProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Profile section lead details
     * @param body (optional) 
     * @return OK
     */
    updateProfile(body?: ProfileDto | undefined): Observable<ProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDto>;
        }));
    }

    protected processUpdateProfile(response: HttpResponseBase): Observable<ProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get in touch section lead details
     * @param leadId (optional) 
     * @return OK
     */
    getInTouch(leadId?: number | undefined): Observable<GetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetInTouch?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInTouch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInTouch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInTouchDto>;
        }));
    }

    protected processGetInTouch(response: HttpResponseBase): Observable<GetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update GetIn Touch section lead details
     * @param body (optional) 
     * @return OK
     */
    updateGetInTouch(body?: GetInTouchDto | undefined): Observable<GetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateGetInTouch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGetInTouch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGetInTouch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInTouchDto>;
        }));
    }

    protected processUpdateGetInTouch(response: HttpResponseBase): Observable<GetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Lead Work History
     * @param body (optional) 
     * @return OK
     */
    addLeadWorkHistoryByLeadId(body?: LeadWorkHistoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddLeadWorkHistoryByLeadId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLeadWorkHistoryByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLeadWorkHistoryByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLeadWorkHistoryByLeadId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get lead Work History by providing lead Id
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadWorkHistoryByLeadId(leadId: number, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadWorkHistoryByLeadId?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadWorkHistoryByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadWorkHistoryByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadWorkHistoryDto>;
        }));
    }

    protected processGetLeadWorkHistoryByLeadId(response: HttpResponseBase): Observable<PagedResultDtoOfLeadWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Lead Work History
     * @param body (optional) 
     * @return OK
     */
    updateLeadWorkHistory(body?: LeadWorkHistoryDto | undefined): Observable<LeadWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateLeadWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeadWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeadWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadWorkHistoryDto>;
        }));
    }

    protected processUpdateLeadWorkHistory(response: HttpResponseBase): Observable<LeadWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a Lead Work History record by its unique identifier.
     * @param id The unique identifier of the Lead Work History record to be deleted.  
    Must be greater than zero.
     * @return OK
     */
    deleteLeadWorkHistory(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/DeleteLeadWorkHistory?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLeadWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeadWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteLeadWorkHistory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Benefit type section
     * @param leadId (optional) 
     * @return OK
     */
    getBenefitType(leadId?: number | undefined): Observable<BenefitTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetBenefitType?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitTypeDto>;
        }));
    }

    protected processGetBenefitType(response: HttpResponseBase): Observable<BenefitTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Benefit type section
     * @param body (optional) 
     * @return OK
     */
    updateBenefitType(body?: BenefitTypeDto | undefined): Observable<BenefitTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateBenefitType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BenefitTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BenefitTypeDto>;
        }));
    }

    protected processUpdateBenefitType(response: HttpResponseBase): Observable<BenefitTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BenefitTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate Eligibility Verification Request
     * @param body (optional) 
     * @return OK
     */
    addWishToValidate(body?: TicketAssignabilityVerificationDto | undefined): Observable<TicketAssignabilityVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddWishToValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWishToValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWishToValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketAssignabilityVerificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketAssignabilityVerificationDto>;
        }));
    }

    protected processAddWishToValidate(response: HttpResponseBase): Observable<TicketAssignabilityVerificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketAssignabilityVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get suitability validation history by lead id
     * @param leadId (optional) 
     * @return OK
     */
    getEligibilityValidationHistoryByLeadId(leadId?: number | undefined): Observable<TicketAssignabilityVerificationOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetEligibilityValidationHistoryByLeadId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibilityValidationHistoryByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibilityValidationHistoryByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketAssignabilityVerificationOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketAssignabilityVerificationOutputDto[]>;
        }));
    }

    protected processGetEligibilityValidationHistoryByLeadId(response: HttpResponseBase): Observable<TicketAssignabilityVerificationOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAssignabilityVerificationOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get comment section of the lead details
     * @param leadId (optional) 
     * @return OK
     */
    getComments(leadId?: number | undefined): Observable<CommentsDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetComments?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentsDto>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<CommentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update comment section
     * @param body (optional) 
     * @return OK
     */
    updateComments(body?: CommentsDto | undefined): Observable<CommentsDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentsDto>;
        }));
    }

    protected processUpdateComments(response: HttpResponseBase): Observable<CommentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Or Update Lead Survey responses
     * @param body (optional) 
     * @return OK
     */
    addLeadSurveyResponse(body?: SurveyResponseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddLeadSurveyResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLeadSurveyResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLeadSurveyResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLeadSurveyResponse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Lead Survey with questionare with responses
     * @param clientId (optional) 
     * @return OK
     */
    getSurveyWithResponses(clientId?: string | null | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetSurveyWithResponses?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyWithResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyWithResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetSurveyWithResponses(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Supported Services by using Lead Id
    Supported service like ResumeAssistance, JobSearch etc..
     * @param leadId (optional) 
     * @return OK
     */
    getSupportServicesByLeadId(leadId?: number | undefined): Observable<SupportServicesDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetSupportServicesByLeadId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportServicesByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportServicesByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportServicesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportServicesDto>;
        }));
    }

    protected processGetSupportServicesByLeadId(response: HttpResponseBase): Observable<SupportServicesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportServicesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Supported services by lead id
     * @param body (optional) 
     * @return OK
     */
    updateSupportServicesByLeadId(body?: SupportServicesDto | undefined): Observable<SupportServicesDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateSupportServicesByLeadId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupportServicesByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupportServicesByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportServicesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportServicesDto>;
        }));
    }

    protected processUpdateSupportServicesByLeadId(response: HttpResponseBase): Observable<SupportServicesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportServicesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all lead activity with filtered data
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadActivities(leadId: number, contactType?: ContactType | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadActivityOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadActivities?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadActivityOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadActivityOutputDto>;
        }));
    }

    protected processGetLeadActivities(response: HttpResponseBase): Observable<PagedResultDtoOfLeadActivityOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadActivityOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * "Contact History" — every LeadActivity row across every lead currently assigned to
    the caller (not just one lead, unlike GetLeadActivitiesAsync above). Scoped by
    Lead.AssigneeId rather than LeadActivity.CreatorUserId (the pattern the equivalent
    Ticket Holder endpoint uses) because Retell AI's webhook and background watchdog job
    write activity rows with no ambient user session — CreatorUserId would be null on
    those, silently excluding every automated call from "my" contact history.
     * @param filter (optional) 
     * @param leadId (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllLeadContactHistory(filter?: string | null | undefined, leadId?: number | null | undefined, contactType?: ContactType | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadContactHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetAllLeadContactHistory?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leadId !== undefined && leadId !== null)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeadContactHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeadContactHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadContactHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadContactHistoryDto>;
        }));
    }

    protected processGetAllLeadContactHistory(response: HttpResponseBase): Observable<PagedResultDtoOfLeadContactHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadContactHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Lead Followups by using Lead Id
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param selectedStatuses (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadFollowupsByLeadId(leadId: number, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, selectedStatuses?: number[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadFollowupDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadFollowupsByLeadId?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (selectedStatuses !== undefined && selectedStatuses !== null)
            selectedStatuses && selectedStatuses.forEach(item => { url_ += "SelectedStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadFollowupsByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadFollowupsByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadFollowupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadFollowupDto>;
        }));
    }

    protected processGetLeadFollowupsByLeadId(response: HttpResponseBase): Observable<PagedResultDtoOfLeadFollowupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadFollowupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Lead Stage
     * @param body (optional) 
     * @return OK
     */
    updateOnlyLeadStageByLeadId(body?: LeadStageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateOnlyLeadStageByLeadId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOnlyLeadStageByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOnlyLeadStageByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOnlyLeadStageByLeadId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get leads for check in
     * @param filter (optional) 
     * @param leadId (optional) 
     * @param doBFilter (optional) 
     * @param firstNameFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param middleNameFilter (optional) 
     * @param emailIdFilter (optional) 
     * @param phoneNumberFilter (optional) 
     * @param importBatchIdFilter (optional) 
     * @param contactById (optional) 
     * @param timeZone (optional) 
     * @param leadStage (optional) 
     * @param contactDateStart (optional) 
     * @param contactDateEnd (optional) 
     * @param noteFilter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadsForCheckIn(filter?: string | null | undefined, leadId?: string | null | undefined, doBFilter?: DateTime | null | undefined, firstNameFilter?: string | null | undefined, lastNameFilter?: string | null | undefined, middleNameFilter?: string | null | undefined, emailIdFilter?: string | null | undefined, phoneNumberFilter?: string | null | undefined, importBatchIdFilter?: string | null | undefined, contactById?: number[] | null | undefined, timeZone?: USATimeZone | undefined, leadStage?: LeadStage[] | null | undefined, contactDateStart?: DateTime | null | undefined, contactDateEnd?: DateTime | null | undefined, noteFilter?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadsForCheckIn?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leadId !== undefined && leadId !== null)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (doBFilter !== undefined && doBFilter !== null)
            url_ += "DoBFilter=" + encodeURIComponent(doBFilter ? "" + doBFilter.toString() : "") + "&";
        if (firstNameFilter !== undefined && firstNameFilter !== null)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
        if (lastNameFilter !== undefined && lastNameFilter !== null)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&";
        if (middleNameFilter !== undefined && middleNameFilter !== null)
            url_ += "MiddleNameFilter=" + encodeURIComponent("" + middleNameFilter) + "&";
        if (emailIdFilter !== undefined && emailIdFilter !== null)
            url_ += "EmailIdFilter=" + encodeURIComponent("" + emailIdFilter) + "&";
        if (phoneNumberFilter !== undefined && phoneNumberFilter !== null)
            url_ += "PhoneNumberFilter=" + encodeURIComponent("" + phoneNumberFilter) + "&";
        if (importBatchIdFilter !== undefined && importBatchIdFilter !== null)
            url_ += "ImportBatchIdFilter=" + encodeURIComponent("" + importBatchIdFilter) + "&";
        if (contactById !== undefined && contactById !== null)
            contactById && contactById.forEach(item => { url_ += "ContactById=" + encodeURIComponent("" + item) + "&"; });
        if (timeZone === null)
            throw new Error("The parameter 'timeZone' cannot be null.");
        else if (timeZone !== undefined)
            url_ += "TimeZone=" + encodeURIComponent("" + timeZone) + "&";
        if (leadStage !== undefined && leadStage !== null)
            leadStage && leadStage.forEach(item => { url_ += "LeadStage=" + encodeURIComponent("" + item) + "&"; });
        if (contactDateStart !== undefined && contactDateStart !== null)
            url_ += "ContactDateStart=" + encodeURIComponent(contactDateStart ? "" + contactDateStart.toString() : "") + "&";
        if (contactDateEnd !== undefined && contactDateEnd !== null)
            url_ += "ContactDateEnd=" + encodeURIComponent(contactDateEnd ? "" + contactDateEnd.toString() : "") + "&";
        if (noteFilter !== undefined && noteFilter !== null)
            url_ += "NoteFilter=" + encodeURIComponent("" + noteFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadsForCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadsForCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadDto>;
        }));
    }

    protected processGetLeadsForCheckIn(response: HttpResponseBase): Observable<PagedResultDtoOfLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Lead Owner
     * @param body (optional) 
     * @return OK
     */
    updateLeadOwner(body?: LeadOwnerChangeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateLeadOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeadOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeadOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLeadOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The assigned career coach's own acknowledgement that they've picked up this lead — lets
    Operation Managers/Campaign Monitor tell "assigned" apart from "assigned AND actually
    being worked" on the Interested Leads Management page. Only the current assignee can
    acknowledge their own lead, and only referral leads need it — leads created in the CRM
    are treated as already acknowledged.
     * @return OK
     */
    acknowledgeLead(leadId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AcknowledgeLead?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcknowledgeLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new phone number for a given lead if it does not already exist.
     * @param body (optional) The phone number to add.
     * @return OK
     */
    addLeadPhoneNumber(body?: NewPhoneDto | undefined): Observable<GetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddLeadPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLeadPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLeadPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInTouchDto>;
        }));
    }

    protected processAddLeadPhoneNumber(response: HttpResponseBase): Observable<GetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing phone number for a given lead.
     * @param leadId (optional) The ID of the lead.
     * @param phoneNumber (optional) The phone number to delete.
     * @return OK
     */
    deleteLeadPhoneNumber(leadId?: number | undefined, phoneNumber?: string | null | undefined): Observable<GetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/DeleteLeadPhoneNumber?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLeadPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeadPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInTouchDto>;
        }));
    }

    protected processDeleteLeadPhoneNumber(response: HttpResponseBase): Observable<GetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves phone numbers for a specific lead, optionally filtered by phone type.
     * @param leadId (optional) 
     * @param phoneType (optional) 
     * @return OK
     */
    getLeadPhoneNumbersByLeadId(leadId?: number | undefined, phoneType?: PhoneType | undefined): Observable<PhoneDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadPhoneNumbersByLeadId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (phoneType === null)
            throw new Error("The parameter 'phoneType' cannot be null.");
        else if (phoneType !== undefined)
            url_ += "PhoneType=" + encodeURIComponent("" + phoneType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadPhoneNumbersByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadPhoneNumbersByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneDto[]>;
        }));
    }

    protected processGetLeadPhoneNumbersByLeadId(response: HttpResponseBase): Observable<PhoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Lead Address by lead id
     * @param body (optional) 
     * @return OK
     */
    addLeadAddress(body?: AddressDto | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddLeadAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLeadAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLeadAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto>;
        }));
    }

    protected processAddLeadAddress(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the lead addresses by lead ID, with an optional filter for address type.
     * @param leadId (optional) 
     * @param addressType (optional) 
     * @return OK
     */
    getLeadAddressByLeadId(leadId?: number | undefined, addressType?: AddressType | undefined): Observable<AddressDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetLeadAddressByLeadId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (addressType === null)
            throw new Error("The parameter 'addressType' cannot be null.");
        else if (addressType !== undefined)
            url_ += "AddressType=" + encodeURIComponent("" + addressType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadAddressByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadAddressByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto[]>;
        }));
    }

    protected processGetLeadAddressByLeadId(response: HttpResponseBase): Observable<AddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Lead Address
     * @param body (optional) 
     * @return OK
     */
    updateLeadAddress(body?: AddressDto | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateLeadAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeadAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeadAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressDto>;
        }));
    }

    protected processUpdateLeadAddress(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete lead address
     * @return OK
     */
    deleteLeadAddress(addressId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/DeleteLeadAddress?";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined and cannot be null.");
        else
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLeadAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeadAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLeadAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add lead phone numbers
     * @param body (optional) 
     * @return OK
     */
    addPhoneLog(body?: PhoneLogDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/AddPhoneLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPhoneLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPhoneLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPhoneLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Phone Log
     * @param body (optional) 
     * @return OK
     */
    updatePhoneLog(body?: UpdatePhoneLogDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdatePhoneLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePhoneLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePhoneLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePhoneLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a mail log and the associated lead activity based on the provided input.
    This applies only when the contact type is set to mail.
     * @param body (optional) The input model containing log ID, activity ID, status, and contact type.
     * @return OK
     */
    updateLogAndActivityStatus(body?: UpdateLogAndActivityStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/UpdateLogAndActivityStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogAndActivityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogAndActivityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLogAndActivityStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of SMS activity records associated with a specific lead,
    filtered and sorted based on the provided input criteria.
     * @param contactInfo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getChatSMSByLeadId(leadId: number, contactInfo?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfLeadChatSMSDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetChatSMSByLeadId?";
        if (leadId === undefined || leadId === null)
            throw new Error("The parameter 'leadId' must be defined and cannot be null.");
        else
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (contactInfo !== undefined && contactInfo !== null)
            url_ += "ContactInfo=" + encodeURIComponent("" + contactInfo) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatSMSByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatSMSByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadChatSMSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadChatSMSDto>;
        }));
    }

    protected processGetChatSMSByLeadId(response: HttpResponseBase): Observable<PagedResultDtoOfLeadChatSMSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadChatSMSDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assignabilityReasonCode (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEligibiltyCheckQueue(assignabilityReasonCode?: AssignabilityReasonCode[] | null | undefined, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetEligibiltyCheckQueue?";
        if (assignabilityReasonCode !== undefined && assignabilityReasonCode !== null)
            assignabilityReasonCode && assignabilityReasonCode.forEach(item => { url_ += "AssignabilityReasonCode=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibiltyCheckQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibiltyCheckQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
        }));
    }

    protected processGetEligibiltyCheckQueue(response: HttpResponseBase): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEligibilityCheckQueueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assignabilityReasonCode (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllEligibiltyHistory(assignabilityReasonCode?: AssignabilityReasonCode[] | null | undefined, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetAllEligibiltyHistory?";
        if (assignabilityReasonCode !== undefined && assignabilityReasonCode !== null)
            assignabilityReasonCode && assignabilityReasonCode.forEach(item => { url_ += "AssignabilityReasonCode=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEligibiltyHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEligibiltyHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
        }));
    }

    protected processGetAllEligibiltyHistory(response: HttpResponseBase): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEligibilityCheckQueueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param leadId (optional) 
     * @return OK
     */
    getTicketToWorkByLeadId(leadId?: number | undefined): Observable<TicketToWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetTicketToWorkByLeadId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketToWorkByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketToWorkByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketToWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketToWorkDto>;
        }));
    }

    protected processGetTicketToWorkByLeadId(response: HttpResponseBase): Observable<TicketToWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketToWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param leadId (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveTicketToWorkByLeadId(leadId?: number | undefined, body?: TicketToWorkDto | undefined): Observable<TicketToWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/SaveTicketToWorkByLeadId?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTicketToWorkByLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTicketToWorkByLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketToWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketToWorkDto>;
        }));
    }

    protected processSaveTicketToWorkByLeadId(response: HttpResponseBase): Observable<TicketToWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketToWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param leadId (optional) 
     * @return OK
     */
    createApplicationLink(leadId?: number | undefined): Observable<LeadApplicationLinkStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/CreateApplicationLink?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateApplicationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateApplicationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadApplicationLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadApplicationLinkStatusDto>;
        }));
    }

    protected processCreateApplicationLink(response: HttpResponseBase): Observable<LeadApplicationLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadApplicationLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param leadId (optional) 
     * @return OK
     */
    getApplicationLink(leadId?: number | undefined): Observable<LeadApplicationLinkStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/GetApplicationLink?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadApplicationLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadApplicationLinkStatusDto>;
        }));
    }

    protected processGetApplicationLink(response: HttpResponseBase): Observable<LeadApplicationLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadApplicationLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    reactivateApplicationLink(invitationId?: number | undefined): Observable<LeadApplicationLinkStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/ReactivateApplicationLink?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateApplicationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateApplicationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadApplicationLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadApplicationLinkStatusDto>;
        }));
    }

    protected processReactivateApplicationLink(response: HttpResponseBase): Observable<LeadApplicationLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadApplicationLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    revokeApplicationLink(invitationId?: number | undefined): Observable<LeadApplicationLinkStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/RevokeApplicationLink?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeApplicationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeApplicationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadApplicationLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadApplicationLinkStatusDto>;
        }));
    }

    protected processRevokeApplicationLink(response: HttpResponseBase): Observable<LeadApplicationLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadApplicationLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Emails the Lead their Application Link (the same URL shown on Lead Details).
     * @param invitationId (optional) 
     * @return OK
     */
    sendApplicationLinkEmail(invitationId?: number | undefined): Observable<LeadApplicationLinkStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/SendApplicationLinkEmail?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendApplicationLinkEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendApplicationLinkEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadApplicationLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadApplicationLinkStatusDto>;
        }));
    }

    protected processSendApplicationLinkEmail(response: HttpResponseBase): Observable<LeadApplicationLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadApplicationLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Emails the Lead a reminder that their Application Link is still waiting to be filled in.
     * @param invitationId (optional) 
     * @return OK
     */
    sendApplicationLinkReminderEmail(invitationId?: number | undefined): Observable<LeadApplicationLinkStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/LeadService/SendApplicationLinkReminderEmail?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendApplicationLinkReminderEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendApplicationLinkReminderEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadApplicationLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadApplicationLinkStatusDto>;
        }));
    }

    protected processSendApplicationLinkReminderEmail(response: HttpResponseBase): Observable<LeadApplicationLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadApplicationLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getPendingMailLogs(): Observable<MailLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mail/GetPendingMailLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingMailLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingMailLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailLogDto[]>;
        }));
    }

    protected processGetPendingMailLogs(response: HttpResponseBase): Observable<MailLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param direction (optional) 
     * @param careerCoachName (optional) 
     * @param careerCoachUserId (optional) 
     * @param careerCoachAddress (optional) 
     * @param clientName (optional) 
     * @param clientAddress (optional) 
     * @param clientId (optional) 
     * @param subject (optional) 
     * @param messageBody (optional) 
     * @param attachments (optional) 
     * @return OK
     */
    createMailLog(direction?: ActivityDirection | undefined, careerCoachName?: string | undefined, careerCoachUserId?: number | undefined, careerCoachAddress?: string | undefined, clientName?: string | undefined, clientAddress?: string | undefined, clientId?: string | undefined, subject?: string | undefined, messageBody?: string | undefined, attachments?: FileParameter[] | undefined): Observable<MailLogDto> {
        let url_ = this.baseUrl + "/api/services/app/Mail/CreateMailLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (direction === null || direction === undefined)
            throw new Error("The parameter 'direction' cannot be null.");
        else
            content_.append("Direction", direction.toString());
        if (careerCoachName === null || careerCoachName === undefined)
            throw new Error("The parameter 'careerCoachName' cannot be null.");
        else
            content_.append("CareerCoachName", careerCoachName.toString());
        if (careerCoachUserId === null || careerCoachUserId === undefined)
            throw new Error("The parameter 'careerCoachUserId' cannot be null.");
        else
            content_.append("CareerCoachUserId", careerCoachUserId.toString());
        if (careerCoachAddress === null || careerCoachAddress === undefined)
            throw new Error("The parameter 'careerCoachAddress' cannot be null.");
        else
            content_.append("CareerCoachAddress", careerCoachAddress.toString());
        if (clientName === null || clientName === undefined)
            throw new Error("The parameter 'clientName' cannot be null.");
        else
            content_.append("ClientName", clientName.toString());
        if (clientAddress === null || clientAddress === undefined)
            throw new Error("The parameter 'clientAddress' cannot be null.");
        else
            content_.append("ClientAddress", clientAddress.toString());
        if (clientId === null || clientId === undefined)
            throw new Error("The parameter 'clientId' cannot be null.");
        else
            content_.append("ClientId", clientId.toString());
        if (subject === null || subject === undefined)
            throw new Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (messageBody === null || messageBody === undefined)
            throw new Error("The parameter 'messageBody' cannot be null.");
        else
            content_.append("MessageBody", messageBody.toString());
        if (attachments === null || attachments === undefined)
            throw new Error("The parameter 'attachments' cannot be null.");
        else
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailLogDto>;
        }));
    }

    protected processCreateMailLog(response: HttpResponseBase): Observable<MailLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMailLog(body?: UpdateMailLogInput | undefined): Observable<MailLogDto> {
        let url_ = this.baseUrl + "/api/services/app/Mail/UpdateMailLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailLogDto>;
        }));
    }

    protected processUpdateMailLog(response: HttpResponseBase): Observable<MailLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteMailLog(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mail/DeleteMailLog?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMailLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMailLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMailLogsStatus(body?: UpdateMailLogStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mail/UpdateMailLogsStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailLogsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailLogsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMailLogsStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mailLogIds (optional) 
     * @return OK
     */
    printMailLogs(mailLogIds?: number[] | null | undefined): Observable<PrintMailSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Mail/PrintMailLogs?";
        if (mailLogIds !== undefined && mailLogIds !== null)
            mailLogIds && mailLogIds.forEach(item => { url_ += "mailLogIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintMailLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintMailLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrintMailSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrintMailSummaryDto>;
        }));
    }

    protected processPrintMailLogs(response: HttpResponseBase): Observable<PrintMailSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintMailSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MaintenanceConsoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getActiveServer(): Observable<ActiveMaintenanceConsoleDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetActiveServer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveMaintenanceConsoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveMaintenanceConsoleDto>;
        }));
    }

    protected processGetActiveServer(response: HttpResponseBase): Observable<ActiveMaintenanceConsoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveMaintenanceConsoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param machineName (optional) 
     * @return OK
     */
    getServerByMachineName(machineName?: string | null | undefined): Observable<MaintenanceConsoleServerDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetServerByMachineName?";
        if (machineName !== undefined && machineName !== null)
            url_ += "machineName=" + encodeURIComponent("" + machineName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServerByMachineName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServerByMachineName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceConsoleServerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceConsoleServerDto>;
        }));
    }

    protected processGetServerByMachineName(response: HttpResponseBase): Observable<MaintenanceConsoleServerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceConsoleServerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllServers(skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMaintenanceConsoleServerDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetAllServers?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMaintenanceConsoleServerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMaintenanceConsoleServerDto>;
        }));
    }

    protected processGetAllServers(response: HttpResponseBase): Observable<PagedResultDtoOfMaintenanceConsoleServerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMaintenanceConsoleServerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllTasks(skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMaintenanceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetAllTasks?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMaintenanceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMaintenanceTaskDto>;
        }));
    }

    protected processGetAllTasks(response: HttpResponseBase): Observable<PagedResultDtoOfMaintenanceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMaintenanceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    getTaskById(taskId?: number | undefined): Observable<MaintenanceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetTaskById?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceTaskDto>;
        }));
    }

    protected processGetTaskById(response: HttpResponseBase): Observable<MaintenanceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRunningTasks(): Observable<RunningTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetRunningTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRunningTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRunningTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RunningTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RunningTaskDto[]>;
        }));
    }

    protected processGetRunningTasks(response: HttpResponseBase): Observable<RunningTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RunningTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFailedTasks(): Observable<FailedTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetFailedTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFailedTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFailedTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FailedTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FailedTaskDto[]>;
        }));
    }

    protected processGetFailedTasks(response: HttpResponseBase): Observable<FailedTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FailedTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    triggerTask(taskId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/TriggerTask?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scheduleTask(body?: ScheduleTaskInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/ScheduleTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScheduleTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @return OK
     */
    cancelTask(taskId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/CancelTask?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param instanceId (optional) 
     * @param logLevel (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getTaskLogs(taskId?: number | null | undefined, instanceId?: number | null | undefined, logLevel?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMaintenanceTaskLogDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetTaskLogs?";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (instanceId !== undefined && instanceId !== null)
            url_ += "InstanceId=" + encodeURIComponent("" + instanceId) + "&";
        if (logLevel !== undefined && logLevel !== null)
            url_ += "LogLevel=" + encodeURIComponent("" + logLevel) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMaintenanceTaskLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMaintenanceTaskLogDto>;
        }));
    }

    protected processGetTaskLogs(response: HttpResponseBase): Observable<PagedResultDtoOfMaintenanceTaskLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMaintenanceTaskLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskId (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getTaskExecutions(taskId?: number | undefined, status?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTaskExecutionDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetTaskExecutions?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskExecutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskExecutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTaskExecutionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTaskExecutionDto>;
        }));
    }

    protected processGetTaskExecutions(response: HttpResponseBase): Observable<PagedResultDtoOfTaskExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTaskExecutionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getBatchRuns(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfBatchRunDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetBatchRuns?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchRuns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchRuns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBatchRunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBatchRunDto>;
        }));
    }

    protected processGetBatchRuns(response: HttpResponseBase): Observable<PagedResultDtoOfBatchRunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBatchRunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getBatchRunLogs(batchId?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfBatchRunLogDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetBatchRunLogs?";
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchRunLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchRunLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBatchRunLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBatchRunLogDto>;
        }));
    }

    protected processGetBatchRunLogs(response: HttpResponseBase): Observable<PagedResultDtoOfBatchRunLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBatchRunLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getBatchInstances(batchId?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfBatchInstanceDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetBatchInstances?";
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBatchInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBatchInstanceDto>;
        }));
    }

    protected processGetBatchInstances(response: HttpResponseBase): Observable<PagedResultDtoOfBatchInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBatchInstanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @param month (optional) 
     * @return OK
     */
    getTokenExtenderDailyStatus(year?: number | undefined, month?: number | undefined): Observable<TokenExtenderDailyStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetTokenExtenderDailyStatus?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenExtenderDailyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenExtenderDailyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenExtenderDailyStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenExtenderDailyStatusDto[]>;
        }));
    }

    protected processGetTokenExtenderDailyStatus(response: HttpResponseBase): Observable<TokenExtenderDailyStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenExtenderDailyStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskName (optional) 
     * @param year (optional) 
     * @param month (optional) 
     * @param day (optional) 
     * @return OK
     */
    getTokenExtenderDayDetail(taskName?: string | null | undefined, year?: number | undefined, month?: number | undefined, day?: number | undefined): Observable<TokenExtenderRunDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceConsole/GetTokenExtenderDayDetail?";
        if (taskName !== undefined && taskName !== null)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (day === null)
            throw new Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "day=" + encodeURIComponent("" + day) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenExtenderDayDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenExtenderDayDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenExtenderRunDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenExtenderRunDetailDto[]>;
        }));
    }

    protected processGetTokenExtenderDayDetail(response: HttpResponseBase): Observable<TokenExtenderRunDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TokenExtenderRunDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MarketingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param ssaRegion (optional) 
     * @param state (optional) 
     * @param type (optional) 
     * @param excludeType (optional) 
     * @param relationshipStage (optional) 
     * @param ownerUserId (optional) 
     * @param category (optional) 
     * @param hasPhone (optional) 
     * @param hasEmail (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOrganizations(filter?: string | null | undefined, ssaRegion?: string | null | undefined, state?: string | null | undefined, type?: MarketingOrganizationType | undefined, excludeType?: MarketingOrganizationType | undefined, relationshipStage?: MarketingRelationshipStage | undefined, ownerUserId?: number | null | undefined, category?: string | null | undefined, hasPhone?: boolean | null | undefined, hasEmail?: boolean | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMarketingOrganizationListDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetOrganizations?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ssaRegion !== undefined && ssaRegion !== null)
            url_ += "SsaRegion=" + encodeURIComponent("" + ssaRegion) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (excludeType === null)
            throw new Error("The parameter 'excludeType' cannot be null.");
        else if (excludeType !== undefined)
            url_ += "ExcludeType=" + encodeURIComponent("" + excludeType) + "&";
        if (relationshipStage === null)
            throw new Error("The parameter 'relationshipStage' cannot be null.");
        else if (relationshipStage !== undefined)
            url_ += "RelationshipStage=" + encodeURIComponent("" + relationshipStage) + "&";
        if (ownerUserId !== undefined && ownerUserId !== null)
            url_ += "OwnerUserId=" + encodeURIComponent("" + ownerUserId) + "&";
        if (category !== undefined && category !== null)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (hasPhone !== undefined && hasPhone !== null)
            url_ += "HasPhone=" + encodeURIComponent("" + hasPhone) + "&";
        if (hasEmail !== undefined && hasEmail !== null)
            url_ += "HasEmail=" + encodeURIComponent("" + hasEmail) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMarketingOrganizationListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMarketingOrganizationListDto>;
        }));
    }

    protected processGetOrganizations(response: HttpResponseBase): Observable<PagedResultDtoOfMarketingOrganizationListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMarketingOrganizationListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * How many organizations match the filters at each stage (the stage filter itself is ignored),
    for the stage buttons above the list.
     * @param filter (optional) 
     * @param ssaRegion (optional) 
     * @param state (optional) 
     * @param type (optional) 
     * @param excludeType (optional) 
     * @param relationshipStage (optional) 
     * @param ownerUserId (optional) 
     * @param category (optional) 
     * @param hasPhone (optional) 
     * @param hasEmail (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getStageCounts(filter?: string | null | undefined, ssaRegion?: string | null | undefined, state?: string | null | undefined, type?: MarketingOrganizationType | undefined, excludeType?: MarketingOrganizationType | undefined, relationshipStage?: MarketingRelationshipStage | undefined, ownerUserId?: number | null | undefined, category?: string | null | undefined, hasPhone?: boolean | null | undefined, hasEmail?: boolean | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<MarketingStageCountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetStageCounts?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ssaRegion !== undefined && ssaRegion !== null)
            url_ += "SsaRegion=" + encodeURIComponent("" + ssaRegion) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (excludeType === null)
            throw new Error("The parameter 'excludeType' cannot be null.");
        else if (excludeType !== undefined)
            url_ += "ExcludeType=" + encodeURIComponent("" + excludeType) + "&";
        if (relationshipStage === null)
            throw new Error("The parameter 'relationshipStage' cannot be null.");
        else if (relationshipStage !== undefined)
            url_ += "RelationshipStage=" + encodeURIComponent("" + relationshipStage) + "&";
        if (ownerUserId !== undefined && ownerUserId !== null)
            url_ += "OwnerUserId=" + encodeURIComponent("" + ownerUserId) + "&";
        if (category !== undefined && category !== null)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (hasPhone !== undefined && hasPhone !== null)
            url_ += "HasPhone=" + encodeURIComponent("" + hasPhone) + "&";
        if (hasEmail !== undefined && hasEmail !== null)
            url_ += "HasEmail=" + encodeURIComponent("" + hasEmail) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStageCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStageCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingStageCountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingStageCountDto[]>;
        }));
    }

    protected processGetStageCounts(response: HttpResponseBase): Observable<MarketingStageCountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingStageCountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Moves one or more organizations to a stage (stage badge and bulk change on the lists), recording each change.
    Returns how many actually changed (those already at the stage are skipped).
     * @param body (optional) 
     * @return OK
     */
    setOrganizationStage(body?: SetMarketingOrganizationStageInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/SetOrganizationStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrganizationStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrganizationStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetOrganizationStage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * An organization's stage changes, newest first.
     * @param organizationId (optional) 
     * @return OK
     */
    getStageHistory(organizationId?: number | undefined): Observable<MarketingStageHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetStageHistory?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStageHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStageHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingStageHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingStageHistoryDto[]>;
        }));
    }

    protected processGetStageHistory(response: HttpResponseBase): Observable<MarketingStageHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingStageHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getOrganization(id?: number | undefined): Observable<MarketingOrganizationDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetOrganization?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingOrganizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingOrganizationDto>;
        }));
    }

    protected processGetOrganization(response: HttpResponseBase): Observable<MarketingOrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingOrganizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Issues a business partner its Referral Partner ID (the code entered on the public referral form),
    creating the linked ReferralPartner. Returns the existing code when one was already issued.
     * @param id (optional) 
     * @return OK
     */
    generatePartnerCode(id?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GeneratePartnerCode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePartnerCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePartnerCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGeneratePartnerCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the partner admin login for the partner area of the marketing website (/partner/login/), with the
    Partner ID as the user ID and a temporary password, and emails it to the partner contact. When it already exists,
    issues a new temporary password and emails it again. The admin adds colleagues in the partner area. Partner
    logins can't sign in to the CRM.
     * @param id (optional) 
     * @return OK
     */
    createPartnerLogin(id?: number | undefined): Observable<MarketingOrganizationDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/CreatePartnerLogin?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePartnerLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePartnerLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingOrganizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingOrganizationDto>;
        }));
    }

    protected processCreatePartnerLogin(response: HttpResponseBase): Observable<MarketingOrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingOrganizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The organization's partner area logins: the partner admin (Partner ID) first, then the people the admin added.
     * @param organizationId (optional) 
     * @return OK
     */
    getPartnerLogins(organizationId?: number | undefined): Observable<MarketingPartnerLoginDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetPartnerLogins?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartnerLogins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartnerLogins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingPartnerLoginDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingPartnerLoginDto[]>;
        }));
    }

    protected processGetPartnerLogins(response: HttpResponseBase): Observable<MarketingPartnerLoginDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingPartnerLoginDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets a new temporary password for one of the organization's partner logins and emails it to that person.
     * @param organizationId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    resetPartnerLogin(organizationId?: number | undefined, userId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/ResetPartnerLogin?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPartnerLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPartnerLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPartnerLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    removePartnerLogin(organizationId?: number | undefined, userId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/RemovePartnerLogin?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePartnerLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePartnerLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemovePartnerLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Issues a Referral Partner ID to every business partner that has signed (Signed Referral Agreement or
    Active) and does not have one yet. Leads that have not signed are left out: after the disability-organization
    import there are thousands of them, and a referral partner record should only exist once a partner agrees.
     * @return OK
     */
    generatePartnerCodes(): Observable<GeneratePartnerCodesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GeneratePartnerCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePartnerCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePartnerCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneratePartnerCodesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneratePartnerCodesResultDto>;
        }));
    }

    protected processGeneratePartnerCodes(response: HttpResponseBase): Observable<GeneratePartnerCodesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneratePartnerCodesResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateOrganization(body?: CreateOrUpdateMarketingOrganizationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/CreateOrUpdateOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateOrganization(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteOrganization(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/DeleteOrganization?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getOrganizationLookup(filter?: string | null | undefined): Observable<NameValueDtoOfInt64[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetOrganizationLookup?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDtoOfInt64[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDtoOfInt64[]>;
        }));
    }

    protected processGetOrganizationLookup(response: HttpResponseBase): Observable<NameValueDtoOfInt64[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDtoOfInt64.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Region/State roll-up of contacts and contact history (the workbook's Summary tab).
     * @return OK
     */
    getStateSummary(): Observable<MarketingStateSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetStateSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingStateSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingStateSummaryDto[]>;
        }));
    }

    protected processGetStateSummary(response: HttpResponseBase): Observable<MarketingStateSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingStateSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Business partner dashboard: pipeline funnel, referral results by partner and month,
    and partners that need follow-up.
     * @return OK
     */
    getBusinessPartnerSummary(): Observable<MarketingBusinessPartnerSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetBusinessPartnerSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessPartnerSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessPartnerSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingBusinessPartnerSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingBusinessPartnerSummaryDto>;
        }));
    }

    protected processGetBusinessPartnerSummary(response: HttpResponseBase): Observable<MarketingBusinessPartnerSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingBusinessPartnerSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param state (optional) 
     * @param isActive (optional) 
     * @param ownerUserId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getContacts(filter?: string | null | undefined, organizationId?: number | null | undefined, state?: string | null | undefined, isActive?: boolean | null | undefined, ownerUserId?: number | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMarketingContactDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetContacts?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (ownerUserId !== undefined && ownerUserId !== null)
            url_ += "OwnerUserId=" + encodeURIComponent("" + ownerUserId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMarketingContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMarketingContactDto>;
        }));
    }

    protected processGetContacts(response: HttpResponseBase): Observable<PagedResultDtoOfMarketingContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMarketingContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateContact(body?: CreateOrUpdateMarketingContactDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/CreateOrUpdateContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateContact(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteContact(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/DeleteContact?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationId (optional) 
     * @param contactId (optional) 
     * @param eventId (optional) 
     * @param state (optional) 
     * @param status (optional) 
     * @param method (optional) 
     * @param overdueOnly (optional) 
     * @param mineOnly (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getInteractions(filter?: string | null | undefined, organizationId?: number | null | undefined, contactId?: number | null | undefined, eventId?: number | null | undefined, state?: string | null | undefined, status?: MarketingInteractionStatus | undefined, method?: MarketingInteractionMethod | undefined, overdueOnly?: boolean | undefined, mineOnly?: boolean | undefined, fromDate?: DateTime | null | undefined, toDate?: DateTime | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMarketingInteractionDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetInteractions?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (eventId !== undefined && eventId !== null)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (method === null)
            throw new Error("The parameter 'method' cannot be null.");
        else if (method !== undefined)
            url_ += "Method=" + encodeURIComponent("" + method) + "&";
        if (overdueOnly === null)
            throw new Error("The parameter 'overdueOnly' cannot be null.");
        else if (overdueOnly !== undefined)
            url_ += "OverdueOnly=" + encodeURIComponent("" + overdueOnly) + "&";
        if (mineOnly === null)
            throw new Error("The parameter 'mineOnly' cannot be null.");
        else if (mineOnly !== undefined)
            url_ += "MineOnly=" + encodeURIComponent("" + mineOnly) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInteractions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInteractions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMarketingInteractionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMarketingInteractionDto>;
        }));
    }

    protected processGetInteractions(response: HttpResponseBase): Observable<PagedResultDtoOfMarketingInteractionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMarketingInteractionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateInteraction(body?: CreateOrUpdateMarketingInteractionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/CreateOrUpdateInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateInteraction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateInteraction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateInteraction(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    completeInteraction(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/CompleteInteraction?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteInteraction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteInteraction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteInteraction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteInteraction(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/DeleteInteraction?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInteraction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInteraction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInteraction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOrganizationNotes(organizationId: number, filter?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMarketingOrganizationNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetOrganizationNotes?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined and cannot be null.");
        else
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMarketingOrganizationNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMarketingOrganizationNoteDto>;
        }));
    }

    protected processGetOrganizationNotes(response: HttpResponseBase): Observable<PagedResultDtoOfMarketingOrganizationNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMarketingOrganizationNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateOrganizationNote(body?: CreateOrUpdateMarketingOrganizationNoteDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/CreateOrUpdateOrganizationNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateOrganizationNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateOrganizationNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateOrganizationNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteOrganizationNote(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/DeleteOrganizationNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The people a business partner referred, i.e. referrals submitted with its Partner ID. Empty until the
    partner has a Partner ID.
     * @param organizationId (optional) 
     * @return OK
     */
    getOrganizationReferrals(organizationId?: number | undefined): Observable<MarketingOrganizationReferralDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetOrganizationReferrals?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationReferrals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationReferrals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingOrganizationReferralDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingOrganizationReferralDto[]>;
        }));
    }

    protected processGetOrganizationReferrals(response: HttpResponseBase): Observable<MarketingOrganizationReferralDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingOrganizationReferralDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Contact history of a business partner's referrals, newest first: calls / emails / SMS with each referred
    person (once they became a Lead) and the notes added to the referral itself.
     * @param organizationId (optional) 
     * @return OK
     */
    getOrganizationReferralHistory(organizationId?: number | undefined): Observable<MarketingReferralHistoryItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/GetOrganizationReferralHistory?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationReferralHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationReferralHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingReferralHistoryItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingReferralHistoryItemDto[]>;
        }));
    }

    protected processGetOrganizationReferralHistory(response: HttpResponseBase): Observable<MarketingReferralHistoryItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingReferralHistoryItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Imports the SSA TTW Coordinator Contact Tracker workbook (one sheet per state).
    Re-importing updates existing records instead of duplicating them.
     * @param file (optional) 
     * @param previewOnly (optional) 
     * @return OK
     */
    importWorkbook(file?: FileParameter | undefined, previewOnly?: boolean | undefined): Observable<MarketingImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/ImportWorkbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (previewOnly === null || previewOnly === undefined)
            throw new Error("The parameter 'previewOnly' cannot be null.");
        else
            content_.append("PreviewOnly", previewOnly.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportWorkbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportWorkbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingImportResultDto>;
        }));
    }

    protected processImportWorkbook(response: HttpResponseBase): Observable<MarketingImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Imports the U.S. disability-organization list as business partners at stage Lead, matched on EIN.
    Re-importing only fills in missing details; stages, owners and history are kept.
     * @param file (optional) 
     * @param previewOnly (optional) 
     * @param highConfidenceOnly (optional) 
     * @param withContactInfoOnly (optional) 
     * @param states (optional) 
     * @return OK
     */
    importBusinessPartners(file?: FileParameter | undefined, previewOnly?: boolean | undefined, highConfidenceOnly?: boolean | undefined, withContactInfoOnly?: boolean | undefined, states?: string | undefined): Observable<MarketingBusinessPartnerImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Marketing/ImportBusinessPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (previewOnly === null || previewOnly === undefined)
            throw new Error("The parameter 'previewOnly' cannot be null.");
        else
            content_.append("PreviewOnly", previewOnly.toString());
        if (highConfidenceOnly === null || highConfidenceOnly === undefined)
            throw new Error("The parameter 'highConfidenceOnly' cannot be null.");
        else
            content_.append("HighConfidenceOnly", highConfidenceOnly.toString());
        if (withContactInfoOnly === null || withContactInfoOnly === undefined)
            throw new Error("The parameter 'withContactInfoOnly' cannot be null.");
        else
            content_.append("WithContactInfoOnly", withContactInfoOnly.toString());
        if (states === null || states === undefined)
            throw new Error("The parameter 'states' cannot be null.");
        else
            content_.append("States", states.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBusinessPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBusinessPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingBusinessPartnerImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingBusinessPartnerImportResultDto>;
        }));
    }

    protected processImportBusinessPartners(response: HttpResponseBase): Observable<MarketingBusinessPartnerImportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingBusinessPartnerImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MarketingCampaignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCampaigns(): Observable<MarketingCampaignDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingCampaign/GetCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCampaigns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaigns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingCampaignDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingCampaignDto[]>;
        }));
    }

    protected processGetCampaigns(response: HttpResponseBase): Observable<MarketingCampaignDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateCampaign(body?: CreateOrUpdateMarketingCampaignDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingCampaign/CreateOrUpdateCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateCampaign(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteCampaign(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingCampaign/DeleteCampaign?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCampaign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MarketingEmailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param activeOnly (optional) 
     * @return OK
     */
    getEmailTemplates(activeOnly?: boolean | undefined): Observable<MarketingEmailTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEmail/GetEmailTemplates?";
        if (activeOnly === null)
            throw new Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingEmailTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingEmailTemplateDto[]>;
        }));
    }

    protected processGetEmailTemplates(response: HttpResponseBase): Observable<MarketingEmailTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingEmailTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateEmailTemplate(body?: MarketingEmailTemplateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEmail/CreateOrUpdateEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateEmailTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteEmailTemplate(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEmail/DeleteEmailTemplate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEmailTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contactId (optional) 
     * @param templateId (optional) 
     * @return OK
     */
    getContactEmail(contactId?: number | undefined, templateId?: number | undefined): Observable<MarketingContactEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEmail/GetContactEmail?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingContactEmailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingContactEmailDto>;
        }));
    }

    protected processGetContactEmail(response: HttpResponseBase): Observable<MarketingContactEmailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingContactEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendContactEmail(body?: SendMarketingContactEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEmail/SendContactEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendContactEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendContactEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MarketingEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param status (optional) 
     * @param eventType (optional) 
     * @param mode (optional) 
     * @param state (optional) 
     * @param ownerUserId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param upcoming (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getEvents(filter?: string | null | undefined, status?: MarketingEventStatus | undefined, eventType?: MarketingEventType | undefined, mode?: MarketingEventMode | undefined, state?: string | null | undefined, ownerUserId?: number | null | undefined, fromDate?: DateTime | null | undefined, toDate?: DateTime | null | undefined, upcoming?: boolean | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMarketingEventListDto> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetEvents?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (eventType === null)
            throw new Error("The parameter 'eventType' cannot be null.");
        else if (eventType !== undefined)
            url_ += "EventType=" + encodeURIComponent("" + eventType) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "Mode=" + encodeURIComponent("" + mode) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (ownerUserId !== undefined && ownerUserId !== null)
            url_ += "OwnerUserId=" + encodeURIComponent("" + ownerUserId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (upcoming !== undefined && upcoming !== null)
            url_ += "Upcoming=" + encodeURIComponent("" + upcoming) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMarketingEventListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMarketingEventListDto>;
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<PagedResultDtoOfMarketingEventListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMarketingEventListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Events overlapping the given range, for the Career Coach calendar. Rejected and cancelled events are left out.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getCalendarEvents(startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<MarketingEventCalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetCalendarEvents?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingEventCalendarDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingEventCalendarDto[]>;
        }));
    }

    protected processGetCalendarEvents(response: HttpResponseBase): Observable<MarketingEventCalendarDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingEventCalendarDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getEvent(id?: number | undefined): Observable<MarketingEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetEvent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingEventDto>;
        }));
    }

    protected processGetEvent(response: HttpResponseBase): Observable<MarketingEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateEvent(body?: CreateOrUpdateMarketingEventDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CreateOrUpdateEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateEvent(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteEvent(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/DeleteEvent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    submitForApproval(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/SubmitForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitForApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approveEvent(body?: MarketingEventDecisionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/ApproveEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rejectEvent(body?: MarketingEventDecisionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/RejectEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approved → Ready. Requires every checklist task to be done, unless a reason for going ahead anyway is given.
     * @param body (optional) 
     * @return OK
     */
    markReady(body?: MarketingEventDecisionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/MarkReady";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkReady(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    completeEvent(body?: CompleteMarketingEventInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CompleteEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelEvent(body?: MarketingEventDecisionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CancelEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return OK
     */
    getChecklist(eventId?: number | undefined): Observable<MarketingEventChecklistItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetChecklist?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingEventChecklistItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingEventChecklistItemDto[]>;
        }));
    }

    protected processGetChecklist(response: HttpResponseBase): Observable<MarketingEventChecklistItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingEventChecklistItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateChecklistItem(body?: CreateOrUpdateMarketingEventChecklistItemDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CreateOrUpdateChecklistItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateChecklistItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateChecklistItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateChecklistItem(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setChecklistItemDone(body?: SetChecklistItemDoneInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/SetChecklistItemDone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetChecklistItemDone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetChecklistItemDone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetChecklistItemDone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteChecklistItem(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/DeleteChecklistItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChecklistItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChecklistItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteChecklistItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    applyChecklistTemplate(body?: ApplyChecklistTemplateInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/ApplyChecklistTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyChecklistTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyChecklistTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplyChecklistTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return OK
     */
    getParticipants(eventId?: number | undefined): Observable<MarketingEventParticipantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetParticipants?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingEventParticipantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingEventParticipantDto[]>;
        }));
    }

    protected processGetParticipants(response: HttpResponseBase): Observable<MarketingEventParticipantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingEventParticipantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addParticipants(body?: AddMarketingEventParticipantsInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/AddParticipants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddParticipants(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateParticipant(body?: UpdateMarketingEventParticipantDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/UpdateParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateParticipant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteParticipant(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/DeleteParticipant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParticipant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return OK
     */
    getRegistrations(eventId?: number | undefined): Observable<MarketingEventRegistrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetRegistrations?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingEventRegistrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingEventRegistrationDto[]>;
        }));
    }

    protected processGetRegistrations(response: HttpResponseBase): Observable<MarketingEventRegistrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingEventRegistrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Staff adds or edits a sign-up (e.g. from a sign-up sheet at our booth).
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateRegistration(body?: CreateOrUpdateMarketingEventRegistrationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CreateOrUpdateRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateRegistration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteRegistration(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/DeleteRegistration?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param registrationId (optional) 
     * @return OK
     */
    createLeadFromRegistration(registrationId?: number | undefined): Observable<CreateLeadsFromRegistrationsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CreateLeadFromRegistration?";
        if (registrationId === null)
            throw new Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeadFromRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeadFromRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLeadsFromRegistrationsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLeadsFromRegistrationsResultDto>;
        }));
    }

    protected processCreateLeadFromRegistration(response: HttpResponseBase): Observable<CreateLeadsFromRegistrationsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLeadsFromRegistrationsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates leads for every beneficiary sign-up of the event that doesn't have one yet.
     * @param eventId (optional) 
     * @return OK
     */
    createLeadsForBeneficiaries(eventId?: number | undefined): Observable<CreateLeadsFromRegistrationsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CreateLeadsForBeneficiaries?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeadsForBeneficiaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeadsForBeneficiaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLeadsFromRegistrationsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLeadsFromRegistrationsResultDto>;
        }));
    }

    protected processCreateLeadsForBeneficiaries(response: HttpResponseBase): Observable<CreateLeadsFromRegistrationsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLeadsFromRegistrationsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Turns on the public sign-up link of a hosted event and returns its token.
     * @param body (optional) 
     * @return OK
     */
    enableRegistration(body?: EnableMarketingEventRegistrationInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/EnableRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEnableRegistration(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return OK
     */
    disableRegistration(eventId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/DisableRegistration?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getChecklistTemplates(): Observable<MarketingChecklistTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/GetChecklistTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketingChecklistTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketingChecklistTemplateDto[]>;
        }));
    }

    protected processGetChecklistTemplates(response: HttpResponseBase): Observable<MarketingChecklistTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingChecklistTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateChecklistTemplate(body?: MarketingChecklistTemplateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/CreateOrUpdateChecklistTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateChecklistTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateChecklistTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrUpdateChecklistTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteChecklistTemplate(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarketingEvent/DeleteChecklistTemplate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChecklistTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChecklistTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteChecklistTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUserNotifications(state?: UserNotificationState | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    shouldUserUpdateApp(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Notification/ShouldUserUpdateApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldUserUpdateApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldUserUpdateApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processShouldUserUpdateApp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setAllAvailableVersionNotificationAsRead(): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllAvailableVersionNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllAvailableVersionNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllAvailableVersionNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetAllAvailableVersionNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setNotificationAsRead(body?: EntityDtoOfGuid | undefined): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateNotificationSettings(body?: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteNotification(id?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    deleteAllUserNotifications(state?: UserNotificationState | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllUserForLookupTable(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMassNotificationUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllUserForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMassNotificationUserLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMassNotificationUserLookupTableDto>;
        }));
    }

    protected processGetAllUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMassNotificationUserLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMassNotificationUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllOrganizationUnitForLookupTable(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllOrganizationUnitForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto>;
        }));
    }

    protected processGetAllOrganizationUnitForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMassNotification(body?: CreateMassNotificationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateMassNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMassNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMassNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMassNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createNewVersionReleasedNotification(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateNewVersionReleasedNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersionReleasedNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersionReleasedNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNewVersionReleasedNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllNotifiers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllNotifiers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotifiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotifiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllNotifiers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getNotificationsPublishedByUser(startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<GetPublishedNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationsPublishedByUser?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationsPublishedByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationsPublishedByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublishedNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublishedNotificationsOutput>;
        }));
    }

    protected processGetNotificationsPublishedByUser(response: HttpResponseBase): Observable<GetPublishedNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublishedNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OauthWebhooksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param code (optional) 
     * @param state (optional) 
     * @param error (optional) 
     * @param error_description (optional) 
     * @return OK
     */
    callback(code?: string | null | undefined, state?: string | null | undefined, error?: string | null | undefined, error_description?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/callback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (error !== undefined && error !== null)
            url_ += "error=" + encodeURIComponent("" + error) + "&";
        if (error_description !== undefined && error_description !== null)
            url_ += "error_description=" + encodeURIComponent("" + error_description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    event(tenantid: number, userdata: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/event/{tenantid}/{userdata}";
        if (tenantid === undefined || tenantid === null)
            throw new Error("The parameter 'tenantid' must be defined.");
        url_ = url_.replace("{tenantid}", encodeURIComponent("" + tenantid));
        if (userdata === undefined || userdata === null)
            throw new Error("The parameter 'userdata' must be defined.");
        url_ = url_.replace("{userdata}", encodeURIComponent("" + userdata));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    graphapi(tenantid: number, userdata: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/graphapi/{tenantid}/{userdata}";
        if (tenantid === undefined || tenantid === null)
            throw new Error("The parameter 'tenantid' must be defined.");
        url_ = url_.replace("{tenantid}", encodeURIComponent("" + tenantid));
        if (userdata === undefined || userdata === null)
            throw new Error("The parameter 'userdata' must be defined.");
        url_ = url_.replace("{userdata}", encodeURIComponent("" + userdata));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGraphapi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGraphapi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGraphapi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    digisigner(tenantid: number, userdata: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/digisigner/{tenantid}/{userdata}";
        if (tenantid === undefined || tenantid === null)
            throw new Error("The parameter 'tenantid' must be defined.");
        url_ = url_.replace("{tenantid}", encodeURIComponent("" + tenantid));
        if (userdata === undefined || userdata === null)
            throw new Error("The parameter 'userdata' must be defined.");
        url_ = url_.replace("{userdata}", encodeURIComponent("" + userdata));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDigisigner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDigisigner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDigisigner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    twilioSms(tenantid: number, userdata: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/twilio-sms/{tenantid}/{userdata}";
        if (tenantid === undefined || tenantid === null)
            throw new Error("The parameter 'tenantid' must be defined.");
        url_ = url_.replace("{tenantid}", encodeURIComponent("" + tenantid));
        if (userdata === undefined || userdata === null)
            throw new Error("The parameter 'userdata' must be defined.");
        url_ = url_.replace("{userdata}", encodeURIComponent("" + userdata));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwilioSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwilioSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTwilioSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    twilioCall(tenantId: number, userState: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/twilio-call/{tenantId}/{userState}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userState === undefined || userState === null)
            throw new Error("The parameter 'userState' must be defined.");
        url_ = url_.replace("{userState}", encodeURIComponent("" + userState));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwilioCall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwilioCall(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTwilioCall(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    oauthWebhooks(provider: string | null, tenantid: number, apiclientid: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/oauth-webhooks/{provider}/{tenantid}/{apiclientid}";
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        if (tenantid === undefined || tenantid === null)
            throw new Error("The parameter 'tenantid' must be defined.");
        url_ = url_.replace("{tenantid}", encodeURIComponent("" + tenantid));
        if (apiclientid === undefined || apiclientid === null)
            throw new Error("The parameter 'apiclientid' must be defined.");
        url_ = url_.replace("{apiclientid}", encodeURIComponent("" + apiclientid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOauthWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOauthWebhooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOauthWebhooks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OperationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Upload the File Lead, Paystub,Others
     * @param file (optional) 
     * @param documentType (optional) 
     * @param isSSA (optional) 
     * @return OK
     */
    fileUpload(file?: FileParameter | undefined, documentType?: DocumentType | undefined, isSSA?: boolean | undefined): Observable<ImportLeadUploadDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/FileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (documentType === null || documentType === undefined)
            throw new Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("DocumentType", documentType.toString());
        if (isSSA === null || isSSA === undefined)
            throw new Error("The parameter 'isSSA' cannot be null.");
        else
            content_.append("isSSA", isSSA.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportLeadUploadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportLeadUploadDto>;
        }));
    }

    protected processFileUpload(response: HttpResponseBase): Observable<ImportLeadUploadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportLeadUploadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Import History of the Leads
     * @param filtertext (optional) 
     * @param batchIdFilter (optional) 
     * @param uploadedByFilter (optional) 
     * @param uploadStartFilter (optional) 
     * @param uploadEndFilter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadImportHistory(filtertext?: string | null | undefined, batchIdFilter?: string | null | undefined, uploadedByFilter?: number | undefined, uploadStartFilter?: DateTime | undefined, uploadEndFilter?: DateTime | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadImportHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetLeadImportHistory?";
        if (filtertext !== undefined && filtertext !== null)
            url_ += "Filtertext=" + encodeURIComponent("" + filtertext) + "&";
        if (batchIdFilter !== undefined && batchIdFilter !== null)
            url_ += "BatchIdFilter=" + encodeURIComponent("" + batchIdFilter) + "&";
        if (uploadedByFilter === null)
            throw new Error("The parameter 'uploadedByFilter' cannot be null.");
        else if (uploadedByFilter !== undefined)
            url_ += "UploadedByFilter=" + encodeURIComponent("" + uploadedByFilter) + "&";
        if (uploadStartFilter === null)
            throw new Error("The parameter 'uploadStartFilter' cannot be null.");
        else if (uploadStartFilter !== undefined)
            url_ += "UploadStartFilter=" + encodeURIComponent(uploadStartFilter ? "" + uploadStartFilter.toString() : "") + "&";
        if (uploadEndFilter === null)
            throw new Error("The parameter 'uploadEndFilter' cannot be null.");
        else if (uploadEndFilter !== undefined)
            url_ += "UploadEndFilter=" + encodeURIComponent(uploadEndFilter ? "" + uploadEndFilter.toString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadImportHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadImportHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadImportHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadImportHistoryDto>;
        }));
    }

    protected processGetLeadImportHistory(response: HttpResponseBase): Observable<PagedResultDtoOfLeadImportHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadImportHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hard-deletes the leads that came in on an import batch. Every lead that still carries the
    batch's `ImportBatchId` is physically removed together with all of its related data
    (child rows wired to the lead by a foreign key, plus the mail/fax/sms/phone/email/survey
    logs that reference it by ClientId). Leads whose Thrive.TTW.LeadStage has advanced to
    Interested / EligibilityChecking / IWPPending / IWPWaitingSignature / IWPSigned / SVRInUse
    are kept. The import-history row is always left in place — SSA sends a fresh batch every
    quarter and the EN keeps the history of what was received and when.
     * @return OK
     */
    deleteLeadImportBatch(fileProcessingQueueId: number): Observable<DeleteLeadImportBatchResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/DeleteLeadImportBatch?";
        if (fileProcessingQueueId === undefined || fileProcessingQueueId === null)
            throw new Error("The parameter 'fileProcessingQueueId' must be defined and cannot be null.");
        else
            url_ += "fileProcessingQueueId=" + encodeURIComponent("" + fileProcessingQueueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLeadImportBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeadImportBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteLeadImportBatchResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteLeadImportBatchResultDto>;
        }));
    }

    protected processDeleteLeadImportBatch(response: HttpResponseBase): Observable<DeleteLeadImportBatchResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteLeadImportBatchResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * After file Upload Start the File Processing using this API by providing fileProcessingQueueId
     * @param batchId (optional) 
     * @return OK
     */
    startLeadFileProcessing(fileProcessingQueueId: number, batchId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/StartLeadFileProcessing?";
        if (fileProcessingQueueId === undefined || fileProcessingQueueId === null)
            throw new Error("The parameter 'fileProcessingQueueId' must be defined and cannot be null.");
        else
            url_ += "fileProcessingQueueId=" + encodeURIComponent("" + fileProcessingQueueId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartLeadFileProcessing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartLeadFileProcessing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartLeadFileProcessing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiates the processing of an OSM (Operational Support Material) file by validating the file,
    checking its document type, and starting the corresponding background import job.
     * @param fileProcessingQueueId The ID of the file processing queue entry.
     * @return OK
     */
    startOSMFileProcessing(fileProcessingQueueId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/StartOSMFileProcessing?";
        if (fileProcessingQueueId === undefined || fileProcessingQueueId === null)
            throw new Error("The parameter 'fileProcessingQueueId' must be defined and cannot be null.");
        else
            url_ += "fileProcessingQueueId=" + encodeURIComponent("" + fileProcessingQueueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOSMFileProcessing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOSMFileProcessing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processStartOSMFileProcessing(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Called server-to-server by the Maintenance Console after it has finished processing a Lead file.
    Saves the CSV bytes from FileProcessingQueues.FileContent to IFileStorageManager
    (local UNC or Blob), stores the resulting path in FilePath, and clears FileContent
    from the DB to free space.
    This runs with no user session, so it is marked [AbpAllowAnonymous] and is protected instead by
    the shared X-Internal-Api-Key header validated against the configured SaaSApi:InternalApiKey.
     * @return OK
     */
    archiveLeadFile(fileProcessingQueueId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/ArchiveLeadFile?";
        if (fileProcessingQueueId === undefined || fileProcessingQueueId === null)
            throw new Error("The parameter 'fileProcessingQueueId' must be defined and cannot be null.");
        else
            url_ += "fileProcessingQueueId=" + encodeURIComponent("" + fileProcessingQueueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveLeadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveLeadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveLeadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Called server-to-server by the Maintenance Console after a digital signature completes an IWP
    (the console updates the database directly and has no AI access). Queues the AI "IWP Summary"
    phone log for Contact History. [AbpAllowAnonymous] + X-Internal-Api-Key, same as ArchiveLeadFileAsync.
     * @return OK
     */
    queueIwpSummary(tenantId: number, iwpId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/QueueIwpSummary?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (iwpId === undefined || iwpId === null)
            throw new Error("The parameter 'iwpId' must be defined and cannot be null.");
        else
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueueIwpSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueueIwpSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQueueIwpSummary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Called server-to-server by the Maintenance Console after it processes an inbound
    email / fax / SMS. Publishes an in-app notification to the assigned career coach through
    the real ABP pipeline (so it reaches SignalR and AbpUserNotifications correctly).
    [AbpAllowAnonymous] + X-Internal-Api-Key, same as ArchiveLeadFileAsync.
     * @param body (optional) 
     * @return OK
     */
    notifyInboundMessage(body?: NotifyInboundMessageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/NotifyInboundMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyInboundMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyInboundMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyInboundMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Logs of the Lead Import Files by providing task id
     * @param taskId (optional) 
     * @return OK
     */
    getLeadImportLogsByTaskId(taskId?: number | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetLeadImportLogsByTaskId?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadImportLogsByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadImportLogsByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogDto[]>;
        }));
    }

    protected processGetLeadImportLogsByTaskId(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the List of IWP Review
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getIWPReviewQueue(filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfIWPReviewQueueDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetIWPReviewQueue?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPReviewQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPReviewQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIWPReviewQueueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIWPReviewQueueDto>;
        }));
    }

    protected processGetIWPReviewQueue(response: HttpResponseBase): Observable<PagedResultDtoOfIWPReviewQueueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIWPReviewQueueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the Status of the IWP which is under review
     * @param body (optional) 
     * @return OK
     */
    updateIWPReview(body?: IWPReviewDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateIWPReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateIWPReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Tenant-wide (not scoped to the current user) paged lead list for one tab of Interested Leads
    Management: Interested, IWP Pending, or IWP Completed. There is no LeadStage for "completed" —
    it lives on the IWP record (IWP.IWPStatus == Completed) — so that tab filters on the IWP table.
    Search, sorting and paging all run in the database, so only one page of leads is ever loaded.
     * @param tab (optional) 
     * @param filterText (optional) 
     * @param onlyNeedsAttention (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadsForManagement(tab?: InterestedLeadManagementTab | undefined, filterText?: string | null | undefined, onlyNeedsAttention?: boolean | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfInterestedLeadManagementDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetLeadsForManagement?";
        if (tab === null)
            throw new Error("The parameter 'tab' cannot be null.");
        else if (tab !== undefined)
            url_ += "Tab=" + encodeURIComponent("" + tab) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (onlyNeedsAttention !== undefined && onlyNeedsAttention !== null)
            url_ += "OnlyNeedsAttention=" + encodeURIComponent("" + onlyNeedsAttention) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadsForManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadsForManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfInterestedLeadManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfInterestedLeadManagementDto>;
        }));
    }

    protected processGetLeadsForManagement(response: HttpResponseBase): Observable<PagedResultDtoOfInterestedLeadManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfInterestedLeadManagementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns (or reassigns) a career coach on an interested lead and notifies them by email +
    in-app notification. A no-op if the lead is already assigned to the same career coach.
     * @param body (optional) 
     * @return OK
     */
    assignCareerCoachToLead(body?: AssignCareerCoachDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/AssignCareerCoachToLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCareerCoachToLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCareerCoachToLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignCareerCoachToLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the List of the Unknown Incoming Fax
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllUnknownIncomingFax(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfUnknownIncomingFaxDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllUnknownIncomingFax?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnknownIncomingFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnknownIncomingFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUnknownIncomingFaxDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUnknownIncomingFaxDto>;
        }));
    }

    protected processGetAllUnknownIncomingFax(response: HttpResponseBase): Observable<PagedResultDtoOfUnknownIncomingFaxDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUnknownIncomingFaxDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of all outgoing fax records.
    Filters and paginates the results based on the provided Thrive.TTW.Operation.dto.OutgoingFaxFilterDto input.
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllOutgoingFax(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfOutgoingFaxLogDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllOutgoingFax?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOutgoingFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOutgoingFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOutgoingFaxLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOutgoingFaxLogDto>;
        }));
    }

    protected processGetAllOutgoingFax(response: HttpResponseBase): Observable<PagedResultDtoOfOutgoingFaxLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOutgoingFaxLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the unknown fax after confirming the details
     * @param faxLogId (optional) 
     * @return OK
     */
    deleteUnknownFax(faxLogId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/DeleteUnknownFax?";
        if (faxLogId === null)
            throw new Error("The parameter 'faxLogId' cannot be null.");
        else if (faxLogId !== undefined)
            url_ += "FaxLogId=" + encodeURIComponent("" + faxLogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUnknownFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUnknownFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUnknownFax(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the unknown fax data into existing Lead or Ticket Holder as per details confirmation
     * @param body (optional) 
     * @return OK
     */
    updateAssignUnknownFax(body?: UnknownFaxAssignDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateAssignUnknownFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssignUnknownFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssignUnknownFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAssignUnknownFax(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search Leads for the Assignment
     * @param clientId (optional) 
     * @param firstName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getSearchLeads(clientId?: string | null | undefined, firstName?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfSearchLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetSearchLeads?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchLeadDto>;
        }));
    }

    protected processGetSearchLeads(response: HttpResponseBase): Observable<PagedResultDtoOfSearchLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Search Ticket Holders for Assignment
     * @param clientId (optional) 
     * @param firstName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getSearchTicketHolders(clientId?: string | null | undefined, firstName?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfSearchTicketHolderDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetSearchTicketHolders?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchTicketHolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchTicketHolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchTicketHolderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchTicketHolderDto>;
        }));
    }

    protected processGetSearchTicketHolders(response: HttpResponseBase): Observable<PagedResultDtoOfSearchTicketHolderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchTicketHolderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Leads for Check-In
     * @param assigneeIds (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getLeadsForCheckIn(assigneeIds?: number[] | null | undefined, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetLeadsForCheckIn?";
        if (assigneeIds !== undefined && assigneeIds !== null)
            assigneeIds && assigneeIds.forEach(item => { url_ += "AssigneeIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadsForCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadsForCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeadDto>;
        }));
    }

    protected processGetLeadsForCheckIn(response: HttpResponseBase): Observable<PagedResultDtoOfLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Outgoing Mails
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllOutgoingMail(filter?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfOutgoingMailDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllOutgoingMail?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOutgoingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOutgoingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOutgoingMailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOutgoingMailDto>;
        }));
    }

    protected processGetAllOutgoingMail(response: HttpResponseBase): Observable<PagedResultDtoOfOutgoingMailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOutgoingMailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Merges selected outgoing mail attachments into a single PDF and returns it as a base64-encoded file.
     * @param body (optional) List of mail log IDs whose attachments will be merged.
     * @return OK
     */
    printSelectedOutgoingMail(body?: number[] | undefined): Observable<DocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/PrintSelectedOutgoingMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintSelectedOutgoingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintSelectedOutgoingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponseDto>;
        }));
    }

    protected processPrintSelectedOutgoingMail(response: HttpResponseBase): Observable<DocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels the selected outgoing mail by updating their status to "Mail_Out_Canceled".
     * @param body (optional) List of mail log IDs to cancel.
     * @return OK
     */
    cancelSelectedOutgoingMail(body?: number[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/CancelSelectedOutgoingMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSelectedOutgoingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSelectedOutgoingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelSelectedOutgoingMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves a letter id (the "Letter Id" printed and QR-encoded in the footer of outgoing mail) to
    the client the letter was sent to.
     * @param letterId (optional) 
     * @return OK
     */
    getMailLetterById(letterId?: number | undefined): Observable<MailLetterLookupDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetMailLetterById?";
        if (letterId === null)
            throw new Error("The parameter 'letterId' cannot be null.");
        else if (letterId !== undefined)
            url_ += "letterId=" + encodeURIComponent("" + letterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailLetterById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailLetterById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailLetterLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailLetterLookupDto>;
        }));
    }

    protected processGetMailLetterById(response: HttpResponseBase): Observable<MailLetterLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailLetterLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check In Lead using LeadId
     * @param body (optional) 
     * @return OK
     */
    updateCheckInLead(body?: number[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateCheckInLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCheckInLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCheckInLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCheckInLead(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged and sorted list of unassign requests based on the provided filter criteria.
    Supports optional filtering by unassign request status.
     * @param unassignStatus (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllUnassignRequest(unassignStatus?: TicketHolderUnassignStatus | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfUnassignRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllUnassignRequest?";
        if (unassignStatus === null)
            throw new Error("The parameter 'unassignStatus' cannot be null.");
        else if (unassignStatus !== undefined)
            url_ += "UnassignStatus=" + encodeURIComponent("" + unassignStatus) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnassignRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnassignRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUnassignRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUnassignRequestDto>;
        }));
    }

    protected processGetAllUnassignRequest(response: HttpResponseBase): Observable<PagedResultDtoOfUnassignRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUnassignRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUnassignRequestById(body?: UpdateUnassignRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateUnassignRequestById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnassignRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnassignRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateUnassignRequestById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of reinstatement requests with optional filtering by status.
    The result is ordered by creation time in descending order.
     * @param status (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllReinstatementRequest(status?: ReinstatementStatus | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfReinstatementDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllReinstatementRequest?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReinstatementRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReinstatementRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReinstatementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReinstatementDto>;
        }));
    }

    protected processGetAllReinstatementRequest(response: HttpResponseBase): Observable<PagedResultDtoOfReinstatementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReinstatementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the full list of reinstatement history records associated with a specific reinstatement ID.
    Each record represents a status change made during the reinstatement process.
     * @param reinstatementId The ID of the Ticket Holder Reinstatement.
     * @return OK
     */
    getReinstatementHistoryByReinstatementId(reinstatementId: number): Observable<ReinstatementHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetReinstatementHistoryByReinstatementId?";
        if (reinstatementId === undefined || reinstatementId === null)
            throw new Error("The parameter 'reinstatementId' must be defined and cannot be null.");
        else
            url_ += "reinstatementId=" + encodeURIComponent("" + reinstatementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReinstatementHistoryByReinstatementId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReinstatementHistoryByReinstatementId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReinstatementHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReinstatementHistoryDto[]>;
        }));
    }

    protected processGetReinstatementHistoryByReinstatementId(response: HttpResponseBase): Observable<ReinstatementHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReinstatementHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns a reinstatement request to a CWIC (Community Work Incentives Coordinator),
    creates a history entry with status set to UnderReview, and updates the related Ticket Holder status.
     * @param body (optional) The assignment details including reinstatement ID, CWIC user ID, and optional reason or note.
     * @return OK
     */
    assignReinstatementRequestToBenefitCounselor(body?: AssignReinstatementDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/AssignReinstatementRequestToBenefitCounselor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignReinstatementRequestToBenefitCounselor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignReinstatementRequestToBenefitCounselor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignReinstatementRequestToBenefitCounselor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a reinstatement request and conditionally updates the related Ticket Holder status
    based on specific terminal reinstatement statuses.
     * @param body (optional) The input DTO containing the reinstatement ID, new status, and optional reason or note.
     * @return OK
     */
    updateReinstatementStatus(body?: UpdateReinstatementStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateReinstatementStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReinstatementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReinstatementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReinstatementStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the EN Ticket Unassignment form, fills it with data from the given unassignment request ID,
    and returns the filled form as a PDF byte array.
     * @param id The unique ID of the unassignment request.
     * @return OK
     */
    getENTicketUnassignmentFormByUnassigmentRequestId(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetENTicketUnassignmentFormByUnassigmentRequestId?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetENTicketUnassignmentFormByUnassigmentRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetENTicketUnassignmentFormByUnassigmentRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetENTicketUnassignmentFormByUnassigmentRequestId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and optionally filtered list of job search requests
    assigned to one or more offshore career coaches.
     * @param assignedToUserId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllJobSearchRequestsJSAAssignee(assignedToUserId?: number[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfJobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllJobSearchRequestsJSAAssignee?";
        if (assignedToUserId !== undefined && assignedToUserId !== null)
            assignedToUserId && assignedToUserId.forEach(item => { url_ += "AssignedToUserId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobSearchRequestsJSAAssignee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobSearchRequestsJSAAssignee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJobSearchRequestDto>;
        }));
    }

    protected processGetAllJobSearchRequestsJSAAssignee(response: HttpResponseBase): Observable<PagedResultDtoOfJobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Changes the assignee of a specific job search request.
     * @param body (optional) The data transfer object containing the job search request identifier and
    the new assignee's user identifier. Both values must be greater than zero.
     * @return OK
     */
    changeJobSearchRequestJSAAssignee(body?: ChangeJobSearchRequestAssigneeDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/ChangeJobSearchRequestJSAAssignee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeJobSearchRequestJSAAssignee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeJobSearchRequestJSAAssignee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeJobSearchRequestJSAAssignee(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged and sorted list of ticket holders along with their
    assigned career coach details, based on the provided filter criteria.
     * @param filterText (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param middleName (optional) 
     * @param assignedCC (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllTicketHolderForAssigneCareerCoach(filterText?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, assignedCC?: number[] | null | undefined, status?: TicketHolderStatus[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllTicketHolderForAssigneCareerCoach?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (assignedCC !== undefined && assignedCC !== null)
            assignedCC && assignedCC.forEach(item => { url_ += "AssignedCC=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTicketHolderForAssigneCareerCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTicketHolderForAssigneCareerCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto>;
        }));
    }

    protected processGetAllTicketHolderForAssigneCareerCoach(response: HttpResponseBase): Observable<PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTicketHolderShortNoteByTHId(body?: UpdateTHShortNotesRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateTicketHolderShortNoteByTHId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderShortNoteByTHId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderShortNoteByTHId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTicketHolderShortNoteByTHId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update ticket holder Status from the Operation > Ticket Holder Management quick action.
     * @param body (optional) 
     * @return OK
     */
    updateTicketHolderStatusByTHId(body?: UpdateTicketHolderStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateTicketHolderStatusByTHId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderStatusByTHId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderStatusByTHId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTicketHolderStatusByTHId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns a career coach to a ticket holder by updating the assignee information.
     * @param ticketHolderId The unique identifier of the ticket holder (must be greater than zero).
     * @param careerCoachUserId The unique identifier of the career coach (must be greater than zero).
     * @return OK
     */
    assigneCareerCoachToTicketHolder(ticketHolderId: number, careerCoachUserId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/AssigneCareerCoachToTicketHolder?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (careerCoachUserId === undefined || careerCoachUserId === null)
            throw new Error("The parameter 'careerCoachUserId' must be defined and cannot be null.");
        else
            url_ += "careerCoachUserId=" + encodeURIComponent("" + careerCoachUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssigneCareerCoachToTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssigneCareerCoachToTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssigneCareerCoachToTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns one career coach to many ticket holders at once (Ticket Holder Management batch "Change CC").
    SelectAll = true reassigns every ticket holder matching the grid filters (across all pages);
    otherwise only the given TicketHolderIds.
     * @param body (optional) 
     * @return OK
     */
    bulkAssignCareerCoachToTicketHolders(body?: BulkAssignCareerCoachToTicketHoldersDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Operation/BulkAssignCareerCoachToTicketHolders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkAssignCareerCoachToTicketHolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkAssignCareerCoachToTicketHolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBulkAssignCareerCoachToTicketHolders(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new ticket holder along with associated addresses and phone numbers.
     * @param body (optional) 
     * @return OK
     */
    createTicketHolder(body?: CreateTicketHolderDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/CreateTicketHolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Unknown SMS
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllUnknownSMS(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfUnknownIncomingSMSDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllUnknownSMS?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnknownSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnknownSMS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUnknownIncomingSMSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUnknownIncomingSMSDto>;
        }));
    }

    protected processGetAllUnknownSMS(response: HttpResponseBase): Observable<PagedResultDtoOfUnknownIncomingSMSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUnknownIncomingSMSDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Unknow sms
     * @param smsLogId (optional) 
     * @return OK
     */
    deleteUnknownSMS(smsLogId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/DeleteUnknownSMS?";
        if (smsLogId === null)
            throw new Error("The parameter 'smsLogId' cannot be null.");
        else if (smsLogId !== undefined)
            url_ += "smsLogId=" + encodeURIComponent("" + smsLogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUnknownSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUnknownSMS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUnknownSMS(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Unknown sms
     * @param body (optional) 
     * @return OK
     */
    updateUnknownSMS(body?: UpdateUnknownIncomingSMSDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateUnknownSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnknownSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnknownSMS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUnknownSMS(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Referral Partner
     * @param body (optional) 
     * @return OK
     */
    createReferralPartner(body?: CreateReferralPartnerDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/CreateReferralPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReferralPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReferralPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReferralPartner(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update referral partner
     * @param body (optional) 
     * @return OK
     */
    updateReferralPartner(body?: UpdateReferralPartnerDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateReferralPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReferralPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReferralPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReferralPartner(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReferralPartnerStatus(body?: UpdateReferralPartnerStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateReferralPartnerStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReferralPartnerStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReferralPartnerStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReferralPartnerStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Referral Partner by Id
     * @param id (optional) 
     * @return OK
     */
    getReferralPartnerById(id?: number | undefined): Observable<ReferralPartnerDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetReferralPartnerById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralPartnerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralPartnerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralPartnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralPartnerDto>;
        }));
    }

    protected processGetReferralPartnerById(response: HttpResponseBase): Observable<ReferralPartnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralPartnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all referral partner
     * @param body (optional) 
     * @return OK
     */
    getAllReferralPartner(body?: ReferralPartnerRequestDto | undefined): Observable<PagedResultDtoOfReferralPartnerDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllReferralPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReferralPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReferralPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReferralPartnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReferralPartnerDto>;
        }));
    }

    protected processGetAllReferralPartner(response: HttpResponseBase): Observable<PagedResultDtoOfReferralPartnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReferralPartnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * CreateReferral
     * @param body (optional) 
     * @return OK
     */
    createReferral(body?: CreateTtwReferralDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/CreateReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReferral(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createReferralWithNewPartner(body?: CreateTtwReferralWithoutPartnerIdDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/CreateReferralWithNewPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReferralWithNewPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReferralWithNewPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReferralWithNewPartner(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * update referral
     * @param body (optional) 
     * @return OK
     */
    updateReferral(body?: UpdateTtwReferralDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReferral(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReferralStatus(body?: UpdateReferralStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateReferralStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReferralStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReferralStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReferralStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get referall by Id
     * @return OK
     */
    getReferralById(id: number): Observable<TtwReferralDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetReferralById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwReferralDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwReferralDto>;
        }));
    }

    protected processGetReferralById(response: HttpResponseBase): Observable<TtwReferralDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwReferralDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getReferralPartnerIdAndName(): Observable<PartnerIdAndNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetReferralPartnerIdAndName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralPartnerIdAndName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralPartnerIdAndName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerIdAndNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerIdAndNameDto[]>;
        }));
    }

    protected processGetReferralPartnerIdAndName(response: HttpResponseBase): Observable<PartnerIdAndNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerIdAndNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all referal
     * @param body (optional) 
     * @return OK
     */
    getAllReferral(body?: ReferralRequestDto | undefined): Observable<PagedResultDtoOfTtwReferralDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTtwReferralDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTtwReferralDto>;
        }));
    }

    protected processGetAllReferral(response: HttpResponseBase): Observable<PagedResultDtoOfTtwReferralDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTtwReferralDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add new lead by referral Id.
     * @param body (optional) 
     * @return OK
     */
    addNewLeadByTTEReferral(body?: NewLeadByReferralIdDto | undefined): Observable<LeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/AddNewLeadByTTEReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewLeadByTTEReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewLeadByTTEReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadDto>;
        }));
    }

    protected processAddNewLeadByTTEReferral(response: HttpResponseBase): Observable<LeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getCareerCoachOverview(filter?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfCareerCoachOverviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetCareerCoachOverview?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerCoachOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerCoachOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCareerCoachOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCareerCoachOverviewDto>;
        }));
    }

    protected processGetCareerCoachOverview(response: HttpResponseBase): Observable<PagedResultDtoOfCareerCoachOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCareerCoachOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllJobSearchRequests(body?: AllJobSearchRequestDto | undefined): Observable<GetAllJobSearchRequestsResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllJobSearchRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobSearchRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobSearchRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllJobSearchRequestsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllJobSearchRequestsResponseDto>;
        }));
    }

    protected processGetAllJobSearchRequests(response: HttpResponseBase): Observable<GetAllJobSearchRequestsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllJobSearchRequestsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the job search request with the specified identifier asynchronously.
     * @param jobSearchRequestId Identifier of the job search request to delete. Must be greater than zero.
     * @return OK
     */
    deleteJobSearchRequest(jobSearchRequestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/DeleteJobSearchRequest?";
        if (jobSearchRequestId === undefined || jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' must be defined and cannot be null.");
        else
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobLeadById(id: number): Observable<TicketHolderJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetJobLeadById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLeadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLeadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderJobLeadDto>;
        }));
    }

    protected processGetJobLeadById(response: HttpResponseBase): Observable<TicketHolderJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Job Search Request By Id
     * @return OK
     */
    getJobSearchRequestById(id: number): Observable<JobSearchRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetJobSearchRequestById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSearchRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSearchRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSearchRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSearchRequestDto>;
        }));
    }

    protected processGetJobSearchRequestById(response: HttpResponseBase): Observable<JobSearchRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSearchRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllJobLead(body?: JobLeadFilterDto | undefined): Observable<PagedResultDtoOfTicketHolderJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetAllJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderJobLeadDto>;
        }));
    }

    protected processGetAllJobLead(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteJobLeadsByIds(ids: number[] | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/DeleteJobLeadsByIds?";
        if (ids === undefined)
            throw new Error("The parameter 'ids' must be defined.");
        else if(ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobLeadsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobLeadsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobLeadsByIds(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendJobLeadsToTicketHolder(ticketHolderId: number, body: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/SendJobLeadsToTicketHolder?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendJobLeadsToTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendJobLeadsToTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendJobLeadsToTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a Job Search Request.
     * @param jobSearchRequestId (optional) The ID of the job search request.
     * @param body (optional) The new status to apply.
     * @return OK
     */
    updateJobSearchRequestStatus(jobSearchRequestId?: number | undefined, body?: JobSearchRequestStatus | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateJobSearchRequestStatus?";
        if (jobSearchRequestId === null)
            throw new Error("The parameter 'jobSearchRequestId' cannot be null.");
        else if (jobSearchRequestId !== undefined)
            url_ += "jobSearchRequestId=" + encodeURIComponent("" + jobSearchRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchRequestStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateJobLeadCompanyName(body?: UpdateJobLeadCompanyNameDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateJobLeadCompanyName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLeadCompanyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLeadCompanyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLeadCompanyName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateJobLeadLocation(body?: UpdateJobLeadLocationDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateJobLeadLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLeadLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLeadLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLeadLocation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update job search request status to paused or pending based on current status and input status
     * @param body (optional) 
     * @return OK
     */
    updateJobSearchToPausedStatus(body?: UpdateJobSearchStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Operation/UpdateJobSearchToPausedStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSearchToPausedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSearchToPausedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobSearchToPausedStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRingCentralCallLogLastSyncTime(): Observable<DateTime> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetRingCentralCallLogLastSyncTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRingCentralCallLogLastSyncTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRingCentralCallLogLastSyncTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime>;
        }));
    }

    protected processGetRingCentralCallLogLastSyncTime(response: HttpResponseBase): Observable<DateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getRingCentralCallLogs(startDate?: DateTime | undefined, endDate?: DateTime | undefined): Observable<RingCentralCallLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetRingCentralCallLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRingCentralCallLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRingCentralCallLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RingCentralCallLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RingCentralCallLogDto[]>;
        }));
    }

    protected processGetRingCentralCallLogs(response: HttpResponseBase): Observable<RingCentralCallLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RingCentralCallLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Two Way Management (Operation view): every assigned ticket holder tenant-wide, bucketed by
    days since last successful two-way communication, grouped by Career Coach. Lives here (rather
    than on TicketHolderService) so an Operation Manager's access to this screen depends only on
    the Operation module permission, not incidentally on Ticket Holder module access.
     * @return OK
     */
    getTwoWayCommunicationOverview(): Observable<TwoWayCommunicationBucketDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetTwoWayCommunicationOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTwoWayCommunicationOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTwoWayCommunicationOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoWayCommunicationBucketDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoWayCommunicationBucketDto[]>;
        }));
    }

    protected processGetTwoWayCommunicationOverview(response: HttpResponseBase): Observable<TwoWayCommunicationBucketDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TwoWayCommunicationBucketDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * On-demand refresh: triggers the same "UpdateTicketHolderTwoWayCommunicationTask" the
    nightly cron runs, right now. Runs tenant-wide on the MaintenanceConsole side (the task
    has no per-coach scope), so this has the same effect whichever page's Refresh button calls it.
     * @return OK
     */
    refreshTwoWayCommunicationData(): Observable<TwoWayCommunicationRefreshResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/RefreshTwoWayCommunicationData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshTwoWayCommunicationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTwoWayCommunicationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoWayCommunicationRefreshResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoWayCommunicationRefreshResultDto>;
        }));
    }

    protected processRefreshTwoWayCommunicationData(response: HttpResponseBase): Observable<TwoWayCommunicationRefreshResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoWayCommunicationRefreshResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Next UTC time the nightly cron will run the two-way-communication refresh.
     * @return OK
     */
    getTwoWayCommunicationNextRun(): Observable<TwoWayCommunicationNextRunDto> {
        let url_ = this.baseUrl + "/api/services/app/Operation/GetTwoWayCommunicationNextRun";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTwoWayCommunicationNextRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTwoWayCommunicationNextRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoWayCommunicationNextRunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoWayCommunicationNextRunDto>;
        }));
    }

    protected processGetTwoWayCommunicationNextRun(response: HttpResponseBase): Observable<TwoWayCommunicationNextRunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoWayCommunicationNextRunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OptOutManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOptOutLeads(filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfOptOutLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/OptOutManagement/GetOptOutLeads?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptOutLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptOutLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOptOutLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOptOutLeadDto>;
        }));
    }

    protected processGetOptOutLeads(response: HttpResponseBase): Observable<PagedResultDtoOfOptOutLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOptOutLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveLead(body?: MoveOptOutLeadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OptOutManagement/MoveLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param leadId (optional) 
     * @return OK
     */
    getHistory(leadId?: number | undefined): Observable<OptOutHistoryEntryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OptOutManagement/GetHistory?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OptOutHistoryEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OptOutHistoryEntryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<OptOutHistoryEntryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OptOutHistoryEntryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param leadId (optional) 
     * @return OK
     */
    deleteLead(leadId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OptOutManagement/DeleteLead?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOrganizationUnitUsers(id?: number | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getOrganizationUnitRoles(id?: number | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrganizationUnit(body?: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateOrganizationUnit(body?: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    moveOrganizationUnit(body?: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteOrganizationUnit(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return OK
     */
    removeUserFromOrganizationUnit(userId?: number | undefined, organizationUnitId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return OK
     */
    removeRoleFromOrganizationUnit(roleId?: number | undefined, organizationUnitId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addUsersToOrganizationUnit(body?: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRolesToOrganizationUnit(body?: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findUsers(body?: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfFindOrganizationUnitUsersOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFindOrganizationUnitUsersOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFindOrganizationUnitUsersOutputDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfFindOrganizationUnitUsersOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFindOrganizationUnitUsersOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    findRoles(body?: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartnerAgreementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAgreement(body?: EntityDtoOfInt64 | undefined): Observable<PartnerAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/GetAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementDto>;
        }));
    }

    protected processGetAgreement(response: HttpResponseBase): Observable<PartnerAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateDraft(body?: EntityDtoOfInt64 | undefined): Observable<PartnerAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/GenerateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementDto>;
        }));
    }

    protected processGenerateDraft(response: HttpResponseBase): Observable<PartnerAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Each organization can have its own wording, so staff may edit the agreement until both sides
    have signed. Editing one that is out for signature cancels that envelope (see ApplyEditAsync).
     * @param body (optional) 
     * @return OK
     */
    saveAgreementText(body?: SavePartnerAgreementTextDto | undefined): Observable<PartnerAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/SaveAgreementText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAgreementText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAgreementText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementDto>;
        }));
    }

    protected processSaveAgreementText(response: HttpResponseBase): Observable<PartnerAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The current user signs for SpringUp (signer 2). Re-sending is allowed while the previous envelope
    is unsigned, e.g. after correcting the agreement text.
     * @param body (optional) 
     * @return OK
     */
    sendForSignature(body?: EntityDtoOfInt64 | undefined): Observable<PartnerAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/SendForSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendForSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendForSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementDto>;
        }));
    }

    protected processSendForSignature(response: HttpResponseBase): Observable<PartnerAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refreshSignatureStatus(body?: EntityDtoOfInt64 | undefined): Observable<PartnerAgreementDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/RefreshSignatureStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshSignatureStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshSignatureStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementDto>;
        }));
    }

    protected processRefreshSignatureStatus(response: HttpResponseBase): Observable<PartnerAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    declineRegistration(body?: DeclinePartnerRegistrationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/DeclineRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeclineRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resendPortalInvitation(body?: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/ResendPortalInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendPortalInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendPortalInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendPortalInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSignedAgreement(body?: EntityDtoOfInt64 | undefined): Observable<PartnerAgreementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PartnerAgreement/GetSignedAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementFileDto>;
        }));
    }

    protected processGetSignedAgreement(response: HttpResponseBase): Observable<PartnerAgreementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPayment(body?: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelPayment(body?: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePayment(body?: UpdatePaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpdatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getPaymentHistory(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param recurringPaymentsEnabled (optional) 
     * @return OK
     */
    getActiveGateways(recurringPaymentsEnabled?: boolean | null | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled !== undefined && recurringPaymentsEnabled !== null)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentGatewayModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentGatewayModel[]>;
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    getPayment(paymentId?: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    paymentFailed(paymentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    hasAnyPayment(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Payment/HasAnyPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAnyPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAnyPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAnyPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates payment requests for all ticket holders by consolidating their pay histories.
     * @return OK
     */
    createPaymentRequest(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PaymentRequest/CreatePaymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreatePaymentRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param paymentId (optional) 
     * @param paypalOrderId (optional) 
     * @return OK
     */
    confirmPayment(paymentId?: number | undefined, paypalOrderId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalOrderId !== undefined && paypalOrderId !== null)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayPalConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayPalConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaystubUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    getStatus(token?: string | null | undefined): Observable<PaystubUploadLinkStatusDto> {
        let url_ = this.baseUrl + "/api/web/PaystubUpload/GetStatus?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadLinkStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadLinkStatusDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<PaystubUploadLinkStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadLinkStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param passcode (optional) 
     * @return OK
     */
    verifyPasscode(token?: string | null | undefined, passcode?: string | null | undefined): Observable<PaystubUploadVerifyResultDto> {
        let url_ = this.baseUrl + "/api/web/PaystubUpload/VerifyPasscode?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (passcode !== undefined && passcode !== null)
            url_ += "passcode=" + encodeURIComponent("" + passcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPasscode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasscode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadVerifyResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadVerifyResultDto>;
        }));
    }

    protected processVerifyPasscode(response: HttpResponseBase): Observable<PaystubUploadVerifyResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadVerifyResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param files (optional) 
     * @param token (optional) 
     * @param passcode (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    uploadFiles(files?: FileParameter[] | undefined, token?: string | undefined, passcode?: string | undefined, documentType?: TicketHolderDocumentType | undefined): Observable<PaystubUploadResultDto> {
        let url_ = this.baseUrl + "/api/web/PaystubUpload/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (token === null || token === undefined)
            throw new Error("The parameter 'token' cannot be null.");
        else
            content_.append("token", token.toString());
        if (passcode === null || passcode === undefined)
            throw new Error("The parameter 'passcode' cannot be null.");
        else
            content_.append("passcode", passcode.toString());
        if (documentType === null || documentType === undefined)
            throw new Error("The parameter 'documentType' cannot be null.");
        else
            content_.append("documentType", documentType.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadResultDto>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<PaystubUploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PdfSigningServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @param request (optional) 
     * @return OK
     */
    send(file?: FileParameter | undefined, request?: string | undefined): Observable<PdfSigningRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/PdfSigning/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (request === null || request === undefined)
            throw new Error("The parameter 'request' cannot be null.");
        else
            content_.append("Request", request.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfSigningRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfSigningRequestDto>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<PdfSigningRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdfSigningRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter?: string | null | undefined, status?: PdfSigningStatus | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfPdfSigningRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/PdfSigning/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPdfSigningRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPdfSigningRequestDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPdfSigningRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPdfSigningRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refreshStatus(body?: EntityDtoOfInt64 | undefined): Observable<PdfSigningRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/PdfSigning/RefreshStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfSigningRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfSigningRequestDto>;
        }));
    }

    protected processRefreshStatus(response: HttpResponseBase): Observable<PdfSigningRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdfSigningRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancel(body?: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PdfSigning/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param signed (optional) 
     * @return OK
     */
    download(id?: number | undefined, signed?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PdfSigning/Download?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (signed === null)
            throw new Error("The parameter 'signed' cannot be null.");
        else if (signed !== undefined)
            url_ += "signed=" + encodeURIComponent("" + signed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PhaseMilestoneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Finds a PhaseMilestone based on the given year and milestone stage.
     * @param year (optional) The year of the milestone.
     * @param body (optional) The milestone stage status.
     * @return OK
     */
    findPhaseMilestone(year?: number | undefined, body?: PhaseMilestoneStage | undefined): Observable<PhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/FindPhaseMilestone?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindPhaseMilestone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindPhaseMilestone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneDto>;
        }));
    }

    protected processFindPhaseMilestone(response: HttpResponseBase): Observable<PhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new PhaseMilestone to the system.
     * @param body (optional) The PhaseMilestone data to add.
     * @return OK
     */
    addPhaseMilestone(body?: PhaseMilestoneDto | undefined): Observable<PhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/AddPhaseMilestone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPhaseMilestone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPhaseMilestone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneDto>;
        }));
    }

    protected processAddPhaseMilestone(response: HttpResponseBase): Observable<PhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a PhaseMilestone by its unique ID.
     * @param phaseMilestoneId (optional) The ID of the milestone.
     * @return OK
     */
    getPhaseMilestoneById(phaseMilestoneId?: number | undefined): Observable<PhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/GetPhaseMilestoneById?";
        if (phaseMilestoneId === null)
            throw new Error("The parameter 'phaseMilestoneId' cannot be null.");
        else if (phaseMilestoneId !== undefined)
            url_ += "PhaseMilestoneId=" + encodeURIComponent("" + phaseMilestoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhaseMilestoneById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhaseMilestoneById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneDto>;
        }));
    }

    protected processGetPhaseMilestoneById(response: HttpResponseBase): Observable<PhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing PhaseMilestone.
     * @param body (optional) The updated milestone data.
     * @return OK
     */
    updatePhaseMilestone(body?: PhaseMilestoneDto | undefined): Observable<PhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/UpdatePhaseMilestone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePhaseMilestone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePhaseMilestone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneDto>;
        }));
    }

    protected processUpdatePhaseMilestone(response: HttpResponseBase): Observable<PhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the next phase milestone based on the current phase milestone ID and payment request the month of the year.
     * @param currentPhaseMilestoneId (optional) "ProgramType-Year-Phase-Milestone"
     * @param monthOfYear (optional) latest Pay history month
     * @return OK
     */
    getNextPhaseMilestoneId(currentPhaseMilestoneId?: string | null | undefined, monthOfYear?: number | undefined): Observable<PhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/GetNextPhaseMilestoneId?";
        if (currentPhaseMilestoneId !== undefined && currentPhaseMilestoneId !== null)
            url_ += "currentPhaseMilestoneId=" + encodeURIComponent("" + currentPhaseMilestoneId) + "&";
        if (monthOfYear === null)
            throw new Error("The parameter 'monthOfYear' cannot be null.");
        else if (monthOfYear !== undefined)
            url_ += "monthOfYear=" + encodeURIComponent("" + monthOfYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextPhaseMilestoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextPhaseMilestoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneDto>;
        }));
    }

    protected processGetNextPhaseMilestoneId(response: HttpResponseBase): Observable<PhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the previous phase milestone based on the current phase milestone ID and payment request the month of the year.
     * @param currentPhaseMilestoneId (optional) "ProgramType-Year-Phase-Milestone"
     * @param monthOfYear (optional) latest pay history month
     * @return OK
     */
    getPreviousPhaseMilestoneId(currentPhaseMilestoneId?: string | null | undefined, monthOfYear?: number | undefined): Observable<PhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/GetPreviousPhaseMilestoneId?";
        if (currentPhaseMilestoneId !== undefined && currentPhaseMilestoneId !== null)
            url_ += "currentPhaseMilestoneId=" + encodeURIComponent("" + currentPhaseMilestoneId) + "&";
        if (monthOfYear === null)
            throw new Error("The parameter 'monthOfYear' cannot be null.");
        else if (monthOfYear !== undefined)
            url_ += "monthOfYear=" + encodeURIComponent("" + monthOfYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviousPhaseMilestoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviousPhaseMilestoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneDto>;
        }));
    }

    protected processGetPreviousPhaseMilestoneId(response: HttpResponseBase): Observable<PhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates all PhaseMilestone IDs for the current year
    using the PhaseMilestoneStage enum and mapping logic.
     * @return OK
     */
    generatePhaseMilestoneIdsForCurrentYear(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/GeneratePhaseMilestoneIdsForCurrentYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePhaseMilestoneIdsForCurrentYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePhaseMilestoneIdsForCurrentYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGeneratePhaseMilestoneIdsForCurrentYear(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Extracts the "MILESTONE OUTCOME PAYMENT METHOD" table from an uploaded SSA
    "Payments at a Glance" PDF for host-admin review before saving.
     * @param body (optional) 
     * @return OK
     */
    extractPhaseMilestonesFromPdf(body?: UploadFileOutputDto | undefined): Observable<PhaseMilestoneImportPreviewDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/ExtractPhaseMilestonesFromPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtractPhaseMilestonesFromPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtractPhaseMilestonesFromPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhaseMilestoneImportPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhaseMilestoneImportPreviewDto>;
        }));
    }

    protected processExtractPhaseMilestonesFromPdf(response: HttpResponseBase): Observable<PhaseMilestoneImportPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhaseMilestoneImportPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves a reviewed import preview for a year. Phase1 rows are saved as-is; Phase2/Outcome
    template rows are expanded across every milestone/month number defined for that
    ProgramType+Phase. Upserts by (ProgramType, Year, Phase, Milestone), so re-uploading the
    same year updates existing rows instead of duplicating them.
     * @param body (optional) 
     * @return OK
     */
    saveYearlyPhaseMilestones(body?: PhaseMilestoneImportPreviewDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/SaveYearlyPhaseMilestones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveYearlyPhaseMilestones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveYearlyPhaseMilestones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveYearlyPhaseMilestones(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged, optionally year-filtered list of saved PhaseMilestone records.
     * @param year (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPhaseMilestones(year?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfPhaseMilestoneDto> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/GetAllPhaseMilestones?";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPhaseMilestones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPhaseMilestones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPhaseMilestoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPhaseMilestoneDto>;
        }));
    }

    protected processGetAllPhaseMilestones(response: HttpResponseBase): Observable<PagedResultDtoOfPhaseMilestoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPhaseMilestoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the distinct years that have PhaseMilestone data, newest first.
     * @return OK
     */
    getPhaseMilestoneYears(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/GetPhaseMilestoneYears";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhaseMilestoneYears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhaseMilestoneYears(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetPhaseMilestoneYears(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes every PhaseMilestone record for a given year (e.g. to redo a bad upload).
     * @param year (optional) 
     * @return OK
     */
    deletePhaseMilestonesByYear(year?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhaseMilestone/DeletePhaseMilestonesByYear?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePhaseMilestonesByYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePhaseMilestonesByYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePhaseMilestonesByYear(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PhoneRingCentralServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getConnectionInfo(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/GetConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processGetConnectionInfo(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    disconnect(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/Disconnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisconnect(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    extendAccessToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/ExtendAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExtendAccessToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    extendSubscription(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/ExtendSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExtendSubscription(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAuthorizationUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/GetAuthorizationUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAuthorizationUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payload (optional) 
     * @param body (optional) 
     * @return OK
     */
    handleEventSubscription(payload?: string | null | undefined, body?: { [key: string]: string; } | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/HandleEventSubscription?";
        if (payload !== undefined && payload !== null)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEventSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleEventSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @param body (optional) 
     * @return OK
     */
    handleOAuthCallback(code?: string | null | undefined, body?: OAuthState | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/HandleOAuthCallback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleOAuthCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleOAuthCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleOAuthCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    subscribeToEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/SubscribeToEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribeToEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeToEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubscribeToEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unsubscribeToEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/UnsubscribeToEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribeToEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeToEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribeToEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCachedConnectionInfo(): Observable<ExternalApiConnectInfo> {
        let url_ = this.baseUrl + "/api/services/app/PhoneRingCentral/GetCachedConnectionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCachedConnectionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCachedConnectionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalApiConnectInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalApiConnectInfo>;
        }));
    }

    protected processGetCachedConnectionInfo(response: HttpResponseBase): Observable<ExternalApiConnectInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalApiConnectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PiiReviewServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitForReview(body?: EntityDtoOfInt64 | undefined): Observable<PiiSubmitResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/SubmitForReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PiiSubmitResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PiiSubmitResultDto>;
        }));
    }

    protected processSubmitForReview(response: HttpResponseBase): Observable<PiiSubmitResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PiiSubmitResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param status (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getQueue(status?: PiiReviewStatus | undefined, filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfPiiReviewQueueItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/GetQueue?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPiiReviewQueueItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPiiReviewQueueItemDto>;
        }));
    }

    protected processGetQueue(response: HttpResponseBase): Observable<PagedResultDtoOfPiiReviewQueueItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPiiReviewQueueItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getDetail(id?: number | undefined): Observable<PiiReviewDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/GetDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PiiReviewDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PiiReviewDetailDto>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<PiiReviewDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PiiReviewDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getMyDetail(id?: number | undefined): Observable<PiiReviewDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/GetMyDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PiiReviewDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PiiReviewDetailDto>;
        }));
    }

    protected processGetMyDetail(response: HttpResponseBase): Observable<PiiReviewDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PiiReviewDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @param channel (optional) 
     * @return OK
     */
    getHeldByTicketHolder(ticketHolderId?: number | undefined, channel?: PiiReviewChannel | undefined): Observable<PiiHeldMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/GetHeldByTicketHolder?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeldByTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeldByTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PiiHeldMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PiiHeldMessageDto[]>;
        }));
    }

    protected processGetHeldByTicketHolder(response: HttpResponseBase): Observable<PiiHeldMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PiiHeldMessageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    review(body?: ReviewPiiRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/Review";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retrySend(body?: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PiiReview/RetrySend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrySend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrySend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetrySend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    disableGoogleAuthenticator(body?: VerifyAuthenticatorCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    viewRecoveryCodes(body?: VerifyAuthenticatorCodeInput | undefined): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ViewRecoveryCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewRecoveryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewRecoveryCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processViewRecoveryCodes(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Google autheticator key which will display in Google Authenticator
    such as tenant1.ttwhub.us
     * @return OK
     */
    generateGoogleAuthenticatorKey(): Observable<GenerateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GenerateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processGenerateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<GenerateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateGoogleAuthenticatorKey(body?: UpdateGoogleAuthenticatorKeyInput | undefined): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendVerificationSms(body?: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifySmsCode(body?: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateCurrentUserProfile(body?: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body?: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProfilePicture(body?: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    verifyAuthenticatorCode(body?: VerifyAuthenticatorCodeInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifyAuthenticatorCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyAuthenticatorCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAuthenticatorCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyAuthenticatorCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    getProfilePictureByUserName(username?: string | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    getFriendProfilePicture(userId?: number | undefined, tenantId?: number | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getProfilePictureByUser(userId?: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeLanguage(body?: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicDocumentShareServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    getShareStatus(documentId?: number | undefined): Observable<PublicDocumentShareInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicDocumentShare/GetShareStatus?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShareStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShareStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicDocumentShareInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicDocumentShareInfoDto>;
        }));
    }

    protected processGetShareStatus(response: HttpResponseBase): Observable<PublicDocumentShareInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicDocumentShareInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param passcode (optional) 
     * @return OK
     */
    verifyPasscode(documentId?: number | undefined, passcode?: string | null | undefined): Observable<DocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicDocumentShare/VerifyPasscode?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (passcode !== undefined && passcode !== null)
            url_ += "passcode=" + encodeURIComponent("" + passcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPasscode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasscode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponseDto>;
        }));
    }

    protected processVerifyPasscode(response: HttpResponseBase): Observable<DocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicIntakeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    getState(token?: string | null | undefined): Observable<PublicIntakeStateDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicIntake/GetState?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicIntakeStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicIntakeStateDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<PublicIntakeStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicIntakeStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    requestOtp(token?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicIntake/RequestOtp?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestOtp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param code (optional) 
     * @return OK
     */
    verifyOtp(token?: string | null | undefined, code?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PublicIntake/VerifyOtp?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyOtp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return OK
     */
    submit(token?: string | null | undefined, body?: PublicIntakeSubmissionDto | undefined): Observable<DateTime> {
        let url_ = this.baseUrl + "/api/services/app/PublicIntake/Submit?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<DateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicLeadApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    getState(token?: string | null | undefined): Observable<PublicLeadApplicationStateDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicLeadApplication/GetState?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicLeadApplicationStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicLeadApplicationStateDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<PublicLeadApplicationStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicLeadApplicationStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return OK
     */
    submit(token?: string | null | undefined, body?: LeadApplicationSubmissionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicLeadApplication/Submit?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicMarketingEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    getEvent(token?: string | null | undefined): Observable<PublicMarketingEventDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicMarketingEvent/GetEvent?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicMarketingEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicMarketingEventDto>;
        }));
    }

    protected processGetEvent(response: HttpResponseBase): Observable<PublicMarketingEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicMarketingEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return OK
     */
    register(token?: string | null | undefined, body?: PublicMarketingEventRegistrationInput | undefined): Observable<PublicMarketingEventRegistrationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicMarketingEvent/Register?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicMarketingEventRegistrationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicMarketingEventRegistrationResultDto>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<PublicMarketingEventRegistrationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicMarketingEventRegistrationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicPartnerPortalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Checks the partner's CRM credentials (lockout and password rules are the CRM's). Only users linked
    to a signed, active referral partner can log in; staff and ticket-holder accounts are refused.
     * @param body (optional) 
     * @return OK
     */
    login(body?: PartnerLoginInputDto | undefined): Observable<PartnerLoginResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerLoginResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerLoginResultDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<PartnerLoginResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerLoginResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * First login (temporary emailed password) or a voluntary change: re-checks the current password,
    then sets the new one with the CRM's password rules.
     * @param body (optional) 
     * @return OK
     */
    changePassword(body?: PartnerChangePasswordInputDto | undefined): Observable<PartnerLoginResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerLoginResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerLoginResultDto>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<PartnerLoginResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerLoginResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDashboard(body?: PartnerSessionDto | undefined): Observable<PartnerPortalDashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/GetDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerPortalDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerPortalDashboardDto>;
        }));
    }

    protected processGetDashboard(response: HttpResponseBase): Observable<PartnerPortalDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerPortalDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getReferrals(body?: GetPartnerPortalReferralsInput | undefined): Observable<PagedResultDtoOfPartnerPortalReferralDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/GetReferrals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferrals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferrals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPartnerPortalReferralDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPartnerPortalReferralDto>;
        }));
    }

    protected processGetReferrals(response: HttpResponseBase): Observable<PagedResultDtoOfPartnerPortalReferralDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPartnerPortalReferralDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends a referral as this partner through the same path as the public referral form with a
    partner code (ReferralManagement/CreateReferral), so staff notifications match.
     * @param body (optional) 
     * @return OK
     */
    sendReferral(body?: PartnerPortalSendReferralDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/SendReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendReferral(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSignedAgreement(body?: PartnerSessionDto | undefined): Observable<PartnerAgreementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/GetSignedAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerAgreementFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerAgreementFileDto>;
        }));
    }

    protected processGetSignedAgreement(response: HttpResponseBase): Observable<PartnerAgreementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The partner opts in or out of the public Our Partners list on the website.
     * @param body (optional) 
     * @return OK
     */
    setShowOnWebsite(body?: SetPartnerShowOnWebsiteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/SetShowOnWebsite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetShowOnWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetShowOnWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetShowOnWebsite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadLogo(body?: UploadPartnerLogoInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/UploadLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The partner's logins: the admin first, then the people the admin added.
     * @param body (optional) 
     * @return OK
     */
    getUsers(body?: PartnerSessionDto | undefined): Observable<PartnerPortalUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerPortalUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerPortalUserDto[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PartnerPortalUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerPortalUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The partner admin gives a colleague their own login (user ID = their email); the login is emailed to them with a
    temporary password. Adding someone who already has a login for this partner resends it.
     * @param body (optional) 
     * @return OK
     */
    addUser(body?: PartnerPortalAddUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The partner admin sends a colleague a new temporary password (their current one stops working).
     * @param body (optional) 
     * @return OK
     */
    resendUserLogin(body?: PartnerPortalUserActionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/ResendUserLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendUserLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendUserLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendUserLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The partner admin removes a colleague's login; they are signed out at once.
     * @param body (optional) 
     * @return OK
     */
    removeUser(body?: PartnerPortalUserActionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerPortal/RemoveUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicPartnerRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Called server-to-server by the marketing website's "Become a Partner" form. Anonymous, so it is
    protected by the X-Website-Api-Key header (same as PublicWebsiteLead/Submit), whose tenant gets the partner.
    The partner is saved as Pending Review and stays inactive until both parties sign the agreement.
     * @param body (optional) 
     * @return OK
     */
    register(body?: PartnerRegistrationInputDto | undefined): Observable<PartnerRegistrationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerRegistration/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerRegistrationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerRegistrationResultDto>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<PartnerRegistrationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRegistrationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Active partners (except those that hid themselves with ShowOnWebsite) for the marketing website's Our Partners page, partners with a logo first.
    Personal referrers (no organization name) and contact details are never returned. Protected by X-Website-Api-Key.
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getPartners(tenancyName: string | null, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfPublicPartnerDto> {
        let url_ = this.baseUrl + "/api/services/app/PublicPartnerRegistration/GetPartners?";
        if (tenancyName === undefined)
            throw new Error("The parameter 'tenancyName' must be defined.");
        else if(tenancyName !== null)
            url_ += "TenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPublicPartnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPublicPartnerDto>;
        }));
    }

    protected processGetPartners(response: HttpResponseBase): Observable<PagedResultDtoOfPublicPartnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPublicPartnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PublicWebsiteLeadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Called server-to-server by a tenant's marketing website. There is no user session, so it is
    [AbpAllowAnonymous] and protected instead by the X-Website-Api-Key header; the lead is saved in
    that key's tenant (see Thrive.TTW.Website.WebsiteApiKeyManager).
     * @param body (optional) 
     * @return OK
     */
    submit(body?: WebsiteLeadInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublicWebsiteLead/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QrCodeGeneratorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param content (optional) 
     * @return OK
     */
    generateQrPngAsDataUrl(content?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/QrCodeGenerator/GenerateQrPngAsDataUrl?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQrPngAsDataUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQrPngAsDataUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateQrPngAsDataUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param content (optional) 
     * @return OK
     */
    generateQrPngBytes(content?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/QrCodeGenerator/GenerateQrPngBytes?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQrPngBytes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQrPngBytes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateQrPngBytes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param content (optional) 
     * @return OK
     */
    generateQrSvg(content?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/QrCodeGenerator/GenerateQrSvg?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQrSvg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQrSvg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateQrSvg(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReferralManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create referral when partner code exist.
     * @param body (optional) 
     * @return OK
     */
    createReferral(body?: CreateTtwReferralWithTenantDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ReferralManagement/CreateReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReferral(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create referral when partner does not exists.
     * @param body (optional) 
     * @return OK
     */
    createReferralWithNewPartner(body?: CreateTtwReferralWithTenantsDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ReferralManagement/CreateReferralWithNewPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReferralWithNewPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReferralWithNewPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReferralWithNewPartner(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getReports(body?: GetReportsInput | undefined): Observable<PagedResultDtoOfReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/GetReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportDto>;
        }));
    }

    protected processGetReports(response: HttpResponseBase): Observable<PagedResultDtoOfReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getReport(id?: number | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/GetReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateReport(body?: CreateUpdateReportDto | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/CreateOrUpdateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processCreateOrUpdateReport(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteReport(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/DeleteReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAvailableRoles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/GetAvailableRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAvailableRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateSql(body?: ValidateSqlInput | undefined): Observable<ValidateSqlResult> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/ValidateSql";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateSql(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateSql(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateSqlResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateSqlResult>;
        }));
    }

    protected processValidateSql(response: HttpResponseBase): Observable<ValidateSqlResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateSqlResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    testRunReport(id?: number | undefined): Observable<SqlReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/TestRunReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestRunReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestRunReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlReportResultDto>;
        }));
    }

    protected processTestRunReport(response: HttpResponseBase): Observable<SqlReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getReportRequests(body?: GetReportRequestsInput | undefined): Observable<PagedResultDtoOfReportRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/GetReportRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportRequestDto>;
        }));
    }

    protected processGetReportRequests(response: HttpResponseBase): Observable<PagedResultDtoOfReportRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReportRequest(body?: UpdateReportRequestDto | undefined): Observable<ReportRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/UpdateReportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportRequestDto>;
        }));
    }

    protected processUpdateReportRequest(response: HttpResponseBase): Observable<ReportRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteReportRequest(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportManagement/DeleteReportRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteReportRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportViewerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getMyReports(): Observable<ReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportViewer/GetMyReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto[]>;
        }));
    }

    protected processGetMyReports(response: HttpResponseBase): Observable<ReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getReport(id?: number | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportViewer/GetReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    runReport(body?: RunReportInput | undefined): Observable<SqlReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportViewer/RunReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlReportResultDto>;
        }));
    }

    protected processRunReport(response: HttpResponseBase): Observable<SqlReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return OK
     */
    exportReport(reportId?: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportViewer/ExportReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitReportRequest(body?: CreateReportRequestDto | undefined): Observable<ReportRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportViewer/SubmitReportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitReportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitReportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportRequestDto>;
        }));
    }

    protected processSubmitReportRequest(response: HttpResponseBase): Observable<ReportRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyReportRequests(): Observable<ReportRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportViewer/GetMyReportRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyReportRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyReportRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportRequestDto[]>;
        }));
    }

    protected processGetMyReportRequests(response: HttpResponseBase): Observable<ReportRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ResumeBuilderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getDrafts(ticketHolderId?: number | undefined): Observable<ResumeDraftSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/GetDrafts?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrafts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeDraftSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeDraftSummaryDto[]>;
        }));
    }

    protected processGetDrafts(response: HttpResponseBase): Observable<ResumeDraftSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResumeDraftSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<ResumeDraftDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeDraftDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResumeDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeDraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generate(body?: GenerateResumeDraftInput | undefined): Observable<ResumeDraftDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeDraftDto>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<ResumeDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeDraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    save(body?: SaveResumeDraftInput | undefined): Observable<ResumeDraftDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeDraftDto>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<ResumeDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeDraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param draftId (optional) 
     * @return OK
     */
    getIdentityFromRecord(draftId?: number | undefined): Observable<ResumeIdentityDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/GetIdentityFromRecord?";
        if (draftId === null)
            throw new Error("The parameter 'draftId' cannot be null.");
        else if (draftId !== undefined)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentityFromRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentityFromRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeIdentityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeIdentityDto>;
        }));
    }

    protected processGetIdentityFromRecord(response: HttpResponseBase): Observable<ResumeIdentityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeIdentityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    finalize(id?: number | undefined): Observable<ResumePdfDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/Finalize?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumePdfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumePdfDto>;
        }));
    }

    protected processFinalize(response: HttpResponseBase): Observable<ResumePdfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumePdfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    downloadFinal(id?: number | undefined): Observable<ResumePdfDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/DownloadFinal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFinal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFinal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumePdfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumePdfDto>;
        }));
    }

    protected processDownloadFinal(response: HttpResponseBase): Observable<ResumePdfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumePdfDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ResumeBuilder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ResumeWorksheetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    getStatus(token?: string | null | undefined): Observable<ResumeWorksheetPublicStatusDto> {
        let url_ = this.baseUrl + "/api/web/ResumeWorksheet/GetStatus?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetPublicStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetPublicStatusDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<ResumeWorksheetPublicStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetPublicStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param passcode (optional) 
     * @return OK
     */
    verifyPasscode(token?: string | null | undefined, passcode?: string | null | undefined): Observable<ResumeWorksheetVerifyResultDto> {
        let url_ = this.baseUrl + "/api/web/ResumeWorksheet/VerifyPasscode?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (passcode !== undefined && passcode !== null)
            url_ += "passcode=" + encodeURIComponent("" + passcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPasscode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasscode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetVerifyResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetVerifyResultDto>;
        }));
    }

    protected processVerifyPasscode(response: HttpResponseBase): Observable<ResumeWorksheetVerifyResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetVerifyResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveDraft(body?: ResumeWorksheetSaveInput | undefined): Observable<ResumeWorksheetSaveResultDto> {
        let url_ = this.baseUrl + "/api/web/ResumeWorksheet/SaveDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetSaveResultDto>;
        }));
    }

    protected processSaveDraft(response: HttpResponseBase): Observable<ResumeWorksheetSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetSaveResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submit(body?: ResumeWorksheetSaveInput | undefined): Observable<ResumeWorksheetSaveResultDto> {
        let url_ = this.baseUrl + "/api/web/ResumeWorksheet/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetSaveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetSaveResultDto>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<ResumeWorksheetSaveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetSaveResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getList(ticketHolderId?: number | undefined): Observable<ResumeWorksheetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ResumeWorksheet/GetList?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ResumeWorksheetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResumeWorksheetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: number | undefined): Observable<ResumeWorksheetDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeWorksheet/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResumeWorksheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    sendByEmail(ticketHolderId?: number | undefined): Observable<ResumeWorksheetDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeWorksheet/SendByEmail?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetDto>;
        }));
    }

    protected processSendByEmail(response: HttpResponseBase): Observable<ResumeWorksheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    sendBySms(ticketHolderId?: number | undefined): Observable<ResumeWorksheetDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeWorksheet/SendBySms?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBySms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBySms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetDto>;
        }));
    }

    protected processSendBySms(response: HttpResponseBase): Observable<ResumeWorksheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @param worksheetId (optional) 
     * @return OK
     */
    getForEdit(ticketHolderId?: number | undefined, worksheetId?: number | null | undefined): Observable<ResumeWorksheetEditDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeWorksheet/GetForEdit?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (worksheetId !== undefined && worksheetId !== null)
            url_ += "worksheetId=" + encodeURIComponent("" + worksheetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetEditDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<ResumeWorksheetEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveForTicketHolder(body?: SaveResumeWorksheetForTicketHolderInput | undefined): Observable<ResumeWorksheetDto> {
        let url_ = this.baseUrl + "/api/services/app/ResumeWorksheet/SaveForTicketHolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveForTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveForTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeWorksheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeWorksheetDto>;
        }));
    }

    protected processSaveForTicketHolder(response: HttpResponseBase): Observable<ResumeWorksheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeWorksheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RingCentralSmsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Handles incoming RingCentral SMS webhook events, processes the payload, logs the SMS, and saves any attached media.
     * @param payload (optional) The raw query string payload from Twilio.
     * @param body (optional) The HTTP headers associated with the webhook request.
     * @return OK
     */
    handleEventSubscription(payload?: string | null | undefined, body?: { [key: string]: string; } | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RingCentralSms/HandleEventSubscription?";
        if (payload !== undefined && payload !== null)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEventSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleEventSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    send(message: string | null, body: string[]): Observable<GetSMSMessageInfoResponse> {
        let url_ = this.baseUrl + "/api/services/app/RingCentralSms/Send?";
        if (message === undefined)
            throw new Error("The parameter 'message' must be defined.");
        else if(message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSMSMessageInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSMSMessageInfoResponse>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<GetSMSMessageInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSMSMessageInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Converts a Twilio SMS status to an internal Thrive.TTW.ActivityStatus enum value.
     * @param twilioStatus (optional) The Twilio SMS status string.
     * @return OK
     */
    convertTwilioStatusToActivityStatus(twilioStatus?: string | null | undefined): Observable<ActivityStatus> {
        let url_ = this.baseUrl + "/api/services/app/RingCentralSms/ConvertTwilioStatusToActivityStatus?";
        if (twilioStatus !== undefined && twilioStatus !== null)
            url_ += "twilioStatus=" + encodeURIComponent("" + twilioStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertTwilioStatusToActivityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertTwilioStatusToActivityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityStatus>;
        }));
    }

    protected processConvertTwilioStatusToActivityStatus(response: HttpResponseBase): Observable<ActivityStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getRoles(body?: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRoleForEdit(id?: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateRole(body?: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteRole(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SharedTHChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves chat session info and the latest messages between the current Ticket Holder and their assigned Career Coach.
     * @return OK
     */
    tHGetMyChatSessionInfo(): Observable<THChatChannelInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/SharedTHChat/THGetMyChatSessionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTHGetMyChatSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTHGetMyChatSessionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THChatChannelInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THChatChannelInfoDto>;
        }));
    }

    protected processTHGetMyChatSessionInfo(response: HttpResponseBase): Observable<THChatChannelInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THChatChannelInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves chat session info and the latest messages for a specified Ticket Holder, called by the assigned Career Coach.
     * @param ticketHolderId (optional) 
     * @return OK
     */
    careerCoachGetTHChatSessionInfo(ticketHolderId?: number | undefined): Observable<THChatChannelInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/SharedTHChat/CareerCoachGetTHChatSessionInfo?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCareerCoachGetTHChatSessionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCareerCoachGetTHChatSessionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THChatChannelInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THChatChannelInfoDto>;
        }));
    }

    protected processCareerCoachGetTHChatSessionInfo(response: HttpResponseBase): Observable<THChatChannelInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THChatChannelInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Loads chat history (paged, oldest-to-newest) for the given ChatSessionId.
    Supports "scroll up for more" pagination.
     * @param oldestMessageId (optional) 
     * @param oldestMessageTime (optional) 
     * @return OK
     */
    getChatMessages(chatSessionId: string | null, oldestMessageId?: number | null | undefined, oldestMessageTime?: DateTime | null | undefined): Observable<ThChatMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SharedTHChat/GetChatMessages?";
        if (chatSessionId === undefined)
            throw new Error("The parameter 'chatSessionId' must be defined.");
        else if(chatSessionId !== null)
            url_ += "ChatSessionId=" + encodeURIComponent("" + chatSessionId) + "&";
        if (oldestMessageId !== undefined && oldestMessageId !== null)
            url_ += "OldestMessageId=" + encodeURIComponent("" + oldestMessageId) + "&";
        if (oldestMessageTime !== undefined && oldestMessageTime !== null)
            url_ += "OldestMessageTime=" + encodeURIComponent(oldestMessageTime ? "" + oldestMessageTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThChatMessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThChatMessageDto[]>;
        }));
    }

    protected processGetChatMessages(response: HttpResponseBase): Observable<ThChatMessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThChatMessageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns one chat attachment with its content (Base64), for image previews and opening files.
    Only the ticket holder or the career coach of a chat that contains the file can load it.
     * @param documentId (optional) 
     * @return OK
     */
    getChatAttachment(documentId?: number | undefined): Observable<THChatFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SharedTHChat/GetChatAttachment?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THChatFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THChatFileDto>;
        }));
    }

    protected processGetChatAttachment(response: HttpResponseBase): Observable<THChatFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THChatFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SSAServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Eligibility Verification queue: leads whose ticket assignability is still pending verification.
     * @param assignabilityReasonCode (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEligibilityVerificationQueue(assignabilityReasonCode?: AssignabilityReasonCode[] | null | undefined, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetEligibilityVerificationQueue?";
        if (assignabilityReasonCode !== undefined && assignabilityReasonCode !== null)
            assignabilityReasonCode && assignabilityReasonCode.forEach(item => { url_ += "AssignabilityReasonCode=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibilityVerificationQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibilityVerificationQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
        }));
    }

    protected processGetEligibilityVerificationQueue(response: HttpResponseBase): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEligibilityCheckQueueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and sorted list of eligibility check history records based on assignability reason codes.
    If no assignability reason codes are provided, it excludes records with Thrive.TTW.AssignabilityReasonCode.PendingToVerify.
     * @param assignabilityReasonCode (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getEligibilityVerificationHistory(assignabilityReasonCode?: AssignabilityReasonCode[] | null | undefined, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetEligibilityVerificationHistory?";
        if (assignabilityReasonCode !== undefined && assignabilityReasonCode !== null)
            assignabilityReasonCode && assignabilityReasonCode.forEach(item => { url_ += "AssignabilityReasonCode=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibilityVerificationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibilityVerificationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEligibilityCheckQueueDto>;
        }));
    }

    protected processGetEligibilityVerificationHistory(response: HttpResponseBase): Observable<PagedResultDtoOfGetEligibilityCheckQueueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEligibilityCheckQueueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records the SSA eligibility verification result for a lead. An Assignable result creates the IWP
    (Sections 1 and 2 prefilled) and moves the lead to IWP Pending; the requester is notified either way.
     * @param body (optional) 
     * @return OK
     */
    updateEligibilityVerification(body?: TicketAssignabilityVerificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/UpdateEligibilityVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEligibilityVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEligibilityVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEligibilityVerification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ticket Assignment queue: ticket holders whose ticket has not yet been assigned to work
    (i.e. no TicketToWork row, or one whose TicketAssignmentDate is still null), most
    recently created ticket holder first.
     * @param keyword (optional) 
     * @param uploadStatuses (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTicketAssignmentQueue(keyword?: string | null | undefined, uploadStatuses?: string[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketAssignmentListItemDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetTicketAssignmentQueue?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (uploadStatuses !== undefined && uploadStatuses !== null)
            uploadStatuses && uploadStatuses.forEach(item => { url_ += "UploadStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketAssignmentQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketAssignmentQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketAssignmentListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketAssignmentListItemDto>;
        }));
    }

    protected processGetTicketAssignmentQueue(response: HttpResponseBase): Observable<PagedResultDtoOfTicketAssignmentListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketAssignmentListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads the IWP-related documents for a ticket holder (the filled Form 1370, plus any
    uploaded IWP/IWP Addendum documents on file) so the operation manager can submit them to
    the SSA portal. Downloading has no side effects; the assignment is recorded separately by
    M:Thrive.TTW.SSA.SSAAppService.MarkTicketAssignmentUploadedAsync(System.Int64) once the operation manager confirms the upload.
    The Form 1370 is already generated and saved once (as a `Document` row referenced by
    !:IWP.DocumentId) whenever the IWP is completed/signed
    (see `IWPService.SaveInputFileToDocumentLibraryAsync`), so we fetch that stored document
    directly by id via M:Thrive.TTW.IO.DocumentAppService.GetFileAsync(System.Int64) instead of re-generating the
    PDF on every download. Regeneration via M:Thrive.TTW.IWP.IIWPService.GetFilledForm1370FileByIWPId(System.Int64)
    is only used as a fallback for the rare legacy IWP with no `DocumentId` on file.
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getTicketAssignmentDocuments(ticketHolderId?: number | undefined): Observable<TicketAssignmentDocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetTicketAssignmentDocuments?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketAssignmentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketAssignmentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketAssignmentDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketAssignmentDocumentDto[]>;
        }));
    }

    protected processGetTicketAssignmentDocuments(response: HttpResponseBase): Observable<TicketAssignmentDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAssignmentDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Quick action: records that the IWP packet has been uploaded to the SSA portal. Sets
    TicketToWork.TicketAssignmentDate = today (creating the TicketToWork row if needed) and
    advances the ticket holder out of PendingCoachReview, which drops it out of the queue.
     * @param ticketHolderId (optional) 
     * @return OK
     */
    markTicketAssignmentUploaded(ticketHolderId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/MarkTicketAssignmentUploaded?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTicketAssignmentUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTicketAssignmentUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkTicketAssignmentUploaded(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edits the SSA upload status from the Ticket Assignment page (pencil icon):
    Uploaded → sets TicketToWork.TicketAssignmentDate (given date or today);
    Pending → clears it. The ticket holder status is not rolled back when reverting.
     * @param body (optional) 
     * @return OK
     */
    updateTicketAssignmentUploadStatus(body?: UpdateSsaUploadStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/UpdateTicketAssignmentUploadStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketAssignmentUploadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketAssignmentUploadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTicketAssignmentUploadStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ticket holders to pick for a Services and Supports Review package. All ticket holders by default,
    since TPM samples by SSN and the assignment date is not recorded in Thrive for every ticket holder;
    `UploadStatuses` narrows to "uploaded" (ticket assignment recorded) and/or "pending" (not recorded).
     * @param keyword (optional) 
     * @param uploadStatuses (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getProgramIntegrityTicketHolders(keyword?: string | null | undefined, uploadStatuses?: string[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketAssignmentListItemDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetProgramIntegrityTicketHolders?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (uploadStatuses !== undefined && uploadStatuses !== null)
            uploadStatuses && uploadStatuses.forEach(item => { url_ += "UploadStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramIntegrityTicketHolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramIntegrityTicketHolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketAssignmentListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketAssignmentListItemDto>;
        }));
    }

    protected processGetProgramIntegrityTicketHolders(response: HttpResponseBase): Observable<PagedResultDtoOfTicketAssignmentListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketAssignmentListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Builds the Services and Supports Review documentation package as a zip: a coversheet plus one
    PDF per Ticketholder (cover page, contact history for the period, then the IWP and every
    amendment). Uploaded IWP files that are not PDFs are added beside it in an "_attachments" folder.
    Returns a temp-file token for download; the EN uploads the zip to TPM Program Integrity via GSO.
     * @param body (optional) 
     * @return OK
     */
    generateAuditPackage(body?: ProgramIntegrityAuditPackageInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GenerateAuditPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAuditPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAuditPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGenerateAuditPackage(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Preset suitability values for the Staff Suitability page (read-only there): award number, the zip password the
    guide fixes from it, PerSec POC and SSA recipients. Set by the tenant admin on SSA Contacts → Suitability Contact.
     * @return OK
     */
    getSuitabilitySettings(): Observable<SsaSuitabilitySettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetSuitabilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuitabilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuitabilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsaSuitabilitySettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsaSuitabilitySettingsDto>;
        }));
    }

    protected processGetSuitabilitySettings(response: HttpResponseBase): Observable<SsaSuitabilitySettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SsaSuitabilitySettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Step 1 preview: the email M:Thrive.TTW.SSA.SSAAppService.SendSuitabilityInstructionsAsync(Thrive.TTW.Operation.dto.SendSuitabilityInstructionsInput) would send. Nothing is sent or created.
     * @param body (optional) 
     * @return OK
     */
    previewSuitabilityInstructions(body?: SendSuitabilityInstructionsInput | undefined): Observable<SuitabilityEmailPreviewDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/PreviewSuitabilityInstructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewSuitabilityInstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewSuitabilityInstructions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilityEmailPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilityEmailPreviewDto>;
        }));
    }

    protected processPreviewSuitabilityInstructions(response: HttpResponseBase): Observable<SuitabilityEmailPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilityEmailPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Step 1: adds the applicant with a 7-day upload link and emails them their part of the guide (fingerprinting, OF-306
    filled in and signed in Adobe Acrobat Reader, uploading it through the link, NBIS eApp within 5 business days) from
    the signed-in user's connected mailbox. Inviting the same email again while the applicant is still waiting for
    documents renews their link instead of adding them twice.
     * @param body (optional) 
     * @return OK
     */
    sendSuitabilityInstructions(body?: SendSuitabilityInstructionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/SendSuitabilityInstructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSuitabilityInstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSuitabilityInstructions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSuitabilityInstructions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * New 7-day link and the instructions emailed again: for an expired link, or to let the applicant replace a document
    (their uploaded documents are kept; a generated package is discarded because it would no longer match).
     * @param id (optional) 
     * @return OK
     */
    resendSuitabilityUploadLink(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/ResendSuitabilityUploadLink?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendSuitabilityUploadLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendSuitabilityUploadLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendSuitabilityUploadLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * New applicants invited from step 1, newest first, filtered by name/email and status, one page at a time.
     * @param filter (optional) 
     * @param status (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getSuitabilityApplicants(filter?: string | null | undefined, status?: SsaSuitabilityRequestStatus | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfSsaSuitabilityApplicantListDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetSuitabilityApplicants?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuitabilityApplicants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuitabilityApplicants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSsaSuitabilityApplicantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSsaSuitabilityApplicantListDto>;
        }));
    }

    protected processGetSuitabilityApplicants(response: HttpResponseBase): Observable<PagedResultDtoOfSsaSuitabilityApplicantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSsaSuitabilityApplicantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * One applicant with what they entered and uploaded.
     * @param id (optional) 
     * @return OK
     */
    getSuitabilityApplicant(id?: number | undefined): Observable<SsaSuitabilityApplicantDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetSuitabilityApplicant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuitabilityApplicant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuitabilityApplicant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsaSuitabilityApplicantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsaSuitabilityApplicantDto>;
        }));
    }

    protected processGetSuitabilityApplicant(response: HttpResponseBase): Observable<SsaSuitabilityApplicantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SsaSuitabilityApplicantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads a document the applicant uploaded.
     * @param fileId (optional) 
     * @return OK
     */
    downloadSuitabilityFile(fileId?: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/DownloadSuitabilityFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSuitabilityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSuitabilityFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadSuitabilityFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads the generated password-protected zip (new applicant or rollover).
     * @param requestId (optional) 
     * @return OK
     */
    downloadSuitabilityPackage(requestId?: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/DownloadSuitabilityPackage?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSuitabilityPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSuitabilityPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadSuitabilityPackage(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an applicant, their uploaded documents and any generated package.
     * @param id (optional) 
     * @return OK
     */
    deleteSuitabilityApplicant(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/DeleteSuitabilityApplicant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSuitabilityApplicant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuitabilityApplicant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSuitabilityApplicant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Step 2a (guide, New Applicants step 4): saves the Applicant Listing fields, builds the Electronic Application
    Applicant Listing and zips it with the uploaded documents ("Last, First 306.pdf" etc.) using AES-256 and the SSA
    password. The zip is kept until it is sent. Returns the recommended email for step 2b.
     * @param body (optional) 
     * @return OK
     */
    generateSuitabilityPackage(body?: GenerateSuitabilityPackageInput | undefined): Observable<SuitabilitySendDraftDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GenerateSuitabilityPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSuitabilityPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSuitabilityPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilitySendDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilitySendDraftDto>;
        }));
    }

    protected processGenerateSuitabilityPackage(response: HttpResponseBase): Observable<SuitabilitySendDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilitySendDraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Rollover step 1 (guide, "Current Contractor/EN Personnel Moving to Another Award"): fills the Contractor Personnel
    Rollover Request Form and zips it with AES-256 and the SSA password. Only names and agreement numbers are stored;
    SSNs and dates of birth exist only inside the encrypted zip. Returns the recommended email for step 2.
     * @param body (optional) 
     * @return OK
     */
    generateRolloverRequest(body?: GenerateRolloverRequestInput | undefined): Observable<SuitabilitySendDraftDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GenerateRolloverRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRolloverRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRolloverRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilitySendDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilitySendDraftDto>;
        }));
    }

    protected processGenerateRolloverRequest(response: HttpResponseBase): Observable<SuitabilitySendDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilitySendDraftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Step 2b / rollover step 2: emails the generated zip from the signed-in user's connected mailbox to PerSec and EN
    Service, copying the sender and the Suitability Contacts, with the subject and body confirmed by the user. The
    password is never written into the email.
     * @param body (optional) 
     * @return OK
     */
    sendSuitabilityPackage(body?: SendSuitabilityPackageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/SendSuitabilityPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSuitabilityPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSuitabilityPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSuitabilityPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ticket Unassignment queue: unassign requests raised by career coaches that are still open
    (not completed / canceled / rejected), oldest request first so the longest-waiting is on top.
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTicketUnassignmentQueue(keyword?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketUnassignmentListItemDto> {
        let url_ = this.baseUrl + "/api/services/app/SSA/GetTicketUnassignmentQueue?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketUnassignmentQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketUnassignmentQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketUnassignmentListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketUnassignmentListItemDto>;
        }));
    }

    protected processGetTicketUnassignmentQueue(response: HttpResponseBase): Observable<PagedResultDtoOfTicketUnassignmentListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketUnassignmentListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Operation manager completes an open unassign request after submitting it to SSA: the request moves
    to Completed and the ticket holder is closed (Closed - Completed).
     * @param unassignRequestId (optional) 
     * @return OK
     */
    completeTicketUnassignment(unassignRequestId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SSA/CompleteTicketUnassignment?";
        if (unassignRequestId === null)
            throw new Error("The parameter 'unassignRequestId' cannot be null.");
        else if (unassignRequestId !== undefined)
            url_ += "unassignRequestId=" + encodeURIComponent("" + unassignRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteTicketUnassignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteTicketUnassignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteTicketUnassignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPaymentSession(body?: StripeCreatePaymentSessionInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    getPaymentResult(paymentId?: number | undefined): Observable<StripePaymentResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripePaymentResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripePaymentResultOutput>;
        }));
    }

    protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripePaymentResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startExtendSubscription(body?: StartExtendSubscriptionInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/StartExtendSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartExtendSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartExtendSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processStartExtendSubscription(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startUpgradeSubscription(body?: StartUpgradeSubscriptionInput | undefined): Observable<StartUpgradeSubscriptionOutput> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/StartUpgradeSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartUpgradeSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartUpgradeSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartUpgradeSubscriptionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartUpgradeSubscriptionOutput>;
        }));
    }

    protected processStartUpgradeSubscription(response: HttpResponseBase): Observable<StartUpgradeSubscriptionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartUpgradeSubscriptionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startTrialToBuySubscription(body?: StartTrialToBuySubscriptionInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/StartTrialToBuySubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTrialToBuySubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTrialToBuySubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processStartTrialToBuySubscription(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SuitabilityUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    getInfo(token?: string | null | undefined): Observable<SuitabilityUploadInfoDto> {
        let url_ = this.baseUrl + "/api/web/SuitabilityUpload/GetInfo?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilityUploadInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilityUploadInfoDto>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<SuitabilityUploadInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilityUploadInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param fileType (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadFile(token?: string | undefined, fileType?: SsaSuitabilityFileType | undefined, file?: FileParameter | undefined): Observable<SuitabilityUploadInfoDto> {
        let url_ = this.baseUrl + "/api/web/SuitabilityUpload/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (token === null || token === undefined)
            throw new Error("The parameter 'token' cannot be null.");
        else
            content_.append("token", token.toString());
        if (fileType === null || fileType === undefined)
            throw new Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("fileType", fileType.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilityUploadInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilityUploadInfoDto>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<SuitabilityUploadInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilityUploadInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param fileId (optional) 
     * @return OK
     */
    removeFile(token?: string | null | undefined, fileId?: number | undefined): Observable<SuitabilityUploadInfoDto> {
        let url_ = this.baseUrl + "/api/web/SuitabilityUpload/RemoveFile?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilityUploadInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilityUploadInfoDto>;
        }));
    }

    protected processRemoveFile(response: HttpResponseBase): Observable<SuitabilityUploadInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilityUploadInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    complete(body?: CompleteSuitabilityUploadInput | undefined): Observable<SuitabilityUploadInfoDto> {
        let url_ = this.baseUrl + "/api/web/SuitabilityUpload/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuitabilityUploadInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuitabilityUploadInfoDto>;
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<SuitabilityUploadInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuitabilityUploadInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SupportTicketServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new support ticket with the provided description and assigns the current user as the creator.
    The ticket is initialized with status 'Open'.
     * @param body (optional) The DTO containing the support ticket creation details.
     * @return OK
     */
    create(body?: CreateSupportTicketDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SupportTicket/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of support tickets filtered by status and user context.
    Admins can view all tickets, while regular users only see tickets they created or are assigned to.
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getSupportTickets(statusFilter?: SupportTicketStatus | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfSupportTicketDto> {
        let url_ = this.baseUrl + "/api/services/app/SupportTicket/GetSupportTickets?";
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSupportTicketDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSupportTicketDto>;
        }));
    }

    protected processGetSupportTickets(response: HttpResponseBase): Observable<PagedResultDtoOfSupportTicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSupportTicketDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns a support ticket to a specified user.
     * @param body (optional) The assignment details containing the ticket ID and target user ID.
     * @return OK
     */
    assignTicket(body?: AssignSupportTicketDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SupportTicket/AssignTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignTicket(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new comment to the specified support ticket.
     * @param body (optional) The DTO containing the ticket ID and comment content.
     * @return OK
     */
    addComment(body?: AddSupportTicketCommentDto | undefined): Observable<SupportTicketDto> {
        let url_ = this.baseUrl + "/api/services/app/SupportTicket/AddComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportTicketDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportTicketDto>;
        }));
    }

    protected processAddComment(response: HttpResponseBase): Observable<SupportTicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportTicketDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a support ticket.
     * @param body (optional) The DTO containing the ticket ID and the new status value.
     * @return OK
     */
    updateStatus(body?: UpdateSupportTicketStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SupportTicket/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a support ticket by its ID, including its associated comments.
     * @param id (optional) The unique identifier of the support ticket.
     * @return OK
     */
    get(id?: number | undefined): Observable<SupportTicketDto> {
        let url_ = this.baseUrl + "/api/services/app/SupportTicket/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportTicketDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportTicketDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SupportTicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportTicketDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTenants(filter?: string | null | undefined, subscriptionEndDateStart?: DateTime | null | undefined, subscriptionEndDateEnd?: DateTime | null | undefined, creationDateStart?: DateTime | null | undefined, creationDateEnd?: DateTime | null | undefined, editionId?: number | null | undefined, editionIdSpecified?: boolean | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined && subscriptionEndDateStart !== null)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd !== undefined && subscriptionEndDateEnd !== null)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId !== undefined && editionId !== null)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTenant(body?: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantForEdit(id?: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenant(body?: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteTenant(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getTenantFeaturesForEdit(id?: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTenantFeatures(body?: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetTenantSpecificFeatures(body?: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlockTenantAdmin(body?: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param extension (optional) 
     * @return OK
     */
    getTenantLogo(skin: string | null, tenantId?: number | null | undefined, extension?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}/{extension}?";
        if (skin === undefined || skin === null)
            throw new Error("The parameter 'skin' must be defined.");
        url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (extension !== undefined && extension !== null)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return OK
     */
    getDashboardData(salesSummaryDatePeriod?: SalesSummaryDatePeriod | undefined): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' cannot be null.");
        else if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopStatsOutput>;
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfitShareOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfitShareOutput>;
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailySalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailySalesOutput>;
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return OK
     */
    getSalesSummary(salesSummaryDatePeriod?: SalesSummaryDatePeriod | undefined): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' cannot be null.");
        else if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Job management, my appointment info count.
     * @return OK
     */
    getTHCardSummary(): Observable<GetTHCardSummary> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTHCardSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHCardSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHCardSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTHCardSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTHCardSummary>;
        }));
    }

    protected processGetTHCardSummary(response: HttpResponseBase): Observable<GetTHCardSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTHCardSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserNotifications(): Observable<GetNotificationOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetUserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMessengerInfo(): Observable<GetTicketHolderMessengerOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMessengerInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessengerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessengerInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTicketHolderMessengerOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTicketHolderMessengerOutput[]>;
        }));
    }

    protected processGetMessengerInfo(response: HttpResponseBase): Observable<GetTicketHolderMessengerOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTicketHolderMessengerOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update all notification as read.
     * @return OK
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUpcomingAppointments(): Observable<GeTHUpcomingAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetUpcomingAppointments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingAppointments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeTHUpcomingAppointmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeTHUpcomingAppointmentDto[]>;
        }));
    }

    protected processGetUpcomingAppointments(response: HttpResponseBase): Observable<GeTHUpcomingAppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeTHUpcomingAppointmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentMonthCreatedLeads(): Observable<GetCurrentMonthLeadsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCurrentMonthCreatedLeads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMonthCreatedLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMonthCreatedLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentMonthLeadsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentMonthLeadsOutput>;
        }));
    }

    protected processGetCurrentMonthCreatedLeads(response: HttpResponseBase): Observable<GetCurrentMonthLeadsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentMonthLeadsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLeadStats(): Observable<LeadStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetLeadStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadStatsDto>;
        }));
    }

    protected processGetLeadStats(response: HttpResponseBase): Observable<LeadStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dateFilter (optional) 
     * @return OK
     */
    getSMSCampaignSummary(dateFilter?: DateFilter | undefined): Observable<SMSCampaignStatusSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSMSCampaignSummary?";
        if (dateFilter === null)
            throw new Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSCampaignSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSCampaignSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SMSCampaignStatusSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SMSCampaignStatusSummaryDto>;
        }));
    }

    protected processGetSMSCampaignSummary(response: HttpResponseBase): Observable<SMSCampaignStatusSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSCampaignStatusSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dateFilter (optional) 
     * @return OK
     */
    getEmailCampaignSummary(dateFilter?: DateFilter | undefined): Observable<EmailCampaignStatusSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetEmailCampaignSummary?";
        if (dateFilter === null)
            throw new Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailCampaignSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailCampaignSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailCampaignStatusSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailCampaignStatusSummaryDto>;
        }));
    }

    protected processGetEmailCampaignSummary(response: HttpResponseBase): Observable<EmailCampaignStatusSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailCampaignStatusSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get iwp queue stats with filters.
     * @param dateFilter (optional) 
     * @return OK
     */
    getIWPQStats(dateFilter?: DateFilter | undefined): Observable<GetIWPQStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetIWPQStats?";
        if (dateFilter === null)
            throw new Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPQStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPQStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIWPQStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIWPQStatsOutput>;
        }));
    }

    protected processGetIWPQStats(response: HttpResponseBase): Observable<GetIWPQStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIWPQStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getIWPSignSummary(): Observable<IWPSignSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetIWPSignSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPSignSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPSignSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPSignSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPSignSummaryDto>;
        }));
    }

    protected processGetIWPSignSummary(response: HttpResponseBase): Observable<IWPSignSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPSignSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ticket Holder employement status
     * @return OK
     */
    getTHEmployementStatusSummary(): Observable<TicketHolderSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTHEmployementStatusSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHEmployementStatusSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHEmployementStatusSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderSummaryDto>;
        }));
    }

    protected processGetTHEmployementStatusSummary(response: HttpResponseBase): Observable<TicketHolderSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get State wise ticketHolder counts..
     * @return OK
     */
    getTicketHolderCountsByState(): Observable<PagedResultDtoOfTicketHolderStateCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTicketHolderCountsByState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderCountsByState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderCountsByState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderStateCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderStateCountDto>;
        }));
    }

    protected processGetTicketHolderCountsByState(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderStateCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderStateCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Ticket Holder working status count.
     * @return OK
     */
    getTHWorkingStatusCount(): Observable<THWorkingStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTHWorkingStatusCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHWorkingStatusCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHWorkingStatusCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THWorkingStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THWorkingStatusDto>;
        }));
    }

    protected processGetTHWorkingStatusCount(response: HttpResponseBase): Observable<THWorkingStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THWorkingStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ticket Holder other details.
     * @return OK
     */
    getTHOtherDetails(): Observable<THOtherDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTHOtherDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHOtherDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHOtherDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THOtherDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THOtherDetailsDto>;
        }));
    }

    protected processGetTHOtherDetails(response: HttpResponseBase): Observable<THOtherDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THOtherDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getOperationTHEmployementStatusSummary(): Observable<TicketHolderSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetOperationTHEmployementStatusSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationTHEmployementStatusSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationTHEmployementStatusSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderSummaryDto>;
        }));
    }

    protected processGetOperationTHEmployementStatusSummary(response: HttpResponseBase): Observable<TicketHolderSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getOperationTicketHolderCountsByState(): Observable<PagedResultDtoOfTicketHolderStateCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetOperationTicketHolderCountsByState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationTicketHolderCountsByState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationTicketHolderCountsByState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderStateCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderStateCountDto>;
        }));
    }

    protected processGetOperationTicketHolderCountsByState(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderStateCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderStateCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getOperationTHWorkingStatusCount(): Observable<THWorkingStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetOperationTHWorkingStatusCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationTHWorkingStatusCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationTHWorkingStatusCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THWorkingStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THWorkingStatusDto>;
        }));
    }

    protected processGetOperationTHWorkingStatusCount(response: HttpResponseBase): Observable<THWorkingStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THWorkingStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTotalCareerCoachCount(): Observable<AssigneeTicketHolderCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTotalCareerCoachCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalCareerCoachCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalCareerCoachCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssigneeTicketHolderCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssigneeTicketHolderCountDto>;
        }));
    }

    protected processGetTotalCareerCoachCount(response: HttpResponseBase): Observable<AssigneeTicketHolderCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssigneeTicketHolderCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dateFilter (optional) 
     * @return OK
     */
    getAssignabilityStatusCounts(dateFilter?: DateFilter | undefined): Observable<AssignabilityStatusCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAssignabilityStatusCounts?";
        if (dateFilter === null)
            throw new Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignabilityStatusCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignabilityStatusCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignabilityStatusCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignabilityStatusCountDto>;
        }));
    }

    protected processGetAssignabilityStatusCounts(response: HttpResponseBase): Observable<AssignabilityStatusCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignabilityStatusCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dateFilter (optional) 
     * @return OK
     */
    getOutgoingMailStatusCounts(dateFilter?: DateFilter | undefined): Observable<OutgoingMailStatusCountDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetOutgoingMailStatusCounts?";
        if (dateFilter === null)
            throw new Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutgoingMailStatusCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutgoingMailStatusCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingMailStatusCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingMailStatusCountDto>;
        }));
    }

    protected processGetOutgoingMailStatusCounts(response: HttpResponseBase): Observable<OutgoingMailStatusCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutgoingMailStatusCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active ticketHolders
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getActiveTicketHolder(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetActiveTicketHolderDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetActiveTicketHolder?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetActiveTicketHolderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetActiveTicketHolderDto>;
        }));
    }

    protected processGetActiveTicketHolder(response: HttpResponseBase): Observable<PagedResultDtoOfGetActiveTicketHolderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetActiveTicketHolderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerTenant(body?: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    buyNowSucceed(paymentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    newRegistrationSucceed(paymentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    upgradeSucceed(paymentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return OK
     */
    extendSucceed(paymentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return OK
     */
    getEdition(editionId?: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAllSettings(body?: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearDarkLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearDarkLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearDarkLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearDarkLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearDarkLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearDarkLogoMinimal(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearDarkLogoMinimal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearDarkLogoMinimal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearDarkLogoMinimal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearDarkLogoMinimal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearLightLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLightLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLightLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLightLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLightLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearLightLogoMinimal(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLightLogoMinimal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLightLogoMinimal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLightLogoMinimal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLightLogoMinimal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTestEmail(body?: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestAutomationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAvailableProjects(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/TestAutomation/GetAvailableProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAvailableProjects(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    beginReportAccess(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TestAutomation/BeginReportAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginReportAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginReportAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBeginReportAccess(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    run(body?: RunTestInput | undefined): Observable<TestRunDto> {
        let url_ = this.baseUrl + "/api/services/app/TestAutomation/Run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestRunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestRunDto>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<TestRunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestRunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param runId (optional) 
     * @return OK
     */
    getStatus(runId?: string | undefined): Observable<TestRunDto> {
        let url_ = this.baseUrl + "/api/services/app/TestAutomation/GetStatus?";
        if (runId === null)
            throw new Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestRunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestRunDto>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<TestRunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestRunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param runId (optional) 
     * @return OK
     */
    cancel(runId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TestAutomation/Cancel?";
        if (runId === null)
            throw new Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TicketHolderAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticate(body?: TicketHolderAuthenticateModel | undefined): Observable<TicketHolderAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TicketHolderAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderAuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<TicketHolderAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return OK
     */
    refreshToken(refreshToken?: string | null | undefined): Observable<TicketHolderRefreshTokenResultModel> {
        let url_ = this.baseUrl + "/api/TicketHolderAuth/RefreshToken?";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderRefreshTokenResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderRefreshTokenResultModel>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<TicketHolderRefreshTokenResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderRefreshTokenResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendPasswordResetCode(body?: TicketHolderSendPasswordResetCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TicketHolderAuth/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body?: TicketHolderResetPasswordModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TicketHolderAuth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TicketHolderIWPServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getNewIWP(ticketHolderId?: number | undefined): Observable<TicketHolderIWPDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/GetNewIWP?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewIWP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewIWP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderIWPDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderIWPDetailsDto>;
        }));
    }

    protected processGetNewIWP(response: HttpResponseBase): Observable<TicketHolderIWPDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderIWPDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveIWP(body?: SaveTicketHolderIWPInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/SaveIWP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIWP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIWP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveIWP(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    getIWPWorkHistory(iwpId?: number | undefined): Observable<IWPWorkHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/GetIWPWorkHistory?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto[]>;
        }));
    }

    protected processGetIWPWorkHistory(response: HttpResponseBase): Observable<IWPWorkHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IWPWorkHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addIWPWorkHistory(body?: IWPWorkHistoryDto | undefined): Observable<IWPWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/AddIWPWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddIWPWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddIWPWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto>;
        }));
    }

    protected processAddIWPWorkHistory(response: HttpResponseBase): Observable<IWPWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateIWPWorkHistory(body?: IWPWorkHistoryDto | undefined): Observable<IWPWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/UpdateIWPWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIWPWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIWPWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPWorkHistoryDto>;
        }));
    }

    protected processUpdateIWPWorkHistory(response: HttpResponseBase): Observable<IWPWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IWPWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    loadIWPWorkHistoryFromTicketHolder(iwpId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/LoadIWPWorkHistoryFromTicketHolder?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadIWPWorkHistoryFromTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadIWPWorkHistoryFromTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLoadIWPWorkHistoryFromTicketHolder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    getIWPPaidMonths(iwpId?: number | undefined): Observable<DateTime[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/GetIWPPaidMonths?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPPaidMonths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPPaidMonths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime[]>;
        }));
    }

    protected processGetIWPPaidMonths(response: HttpResponseBase): Observable<DateTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DateTime.fromISO(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteIWPWorkHistory(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/DeleteIWPWorkHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteIWPWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIWPWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteIWPWorkHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    createIWPAmendment(iwpId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/CreateIWPAmendment?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIWPAmendment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIWPAmendment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateIWPAmendment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @param iwpId (optional) 
     * @return OK
     */
    getIWPRawSSN(ticketHolderId?: number | undefined, iwpId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/GetIWPRawSSN?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPRawSSN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPRawSSN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetIWPRawSSN(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    getIWPDetails(iwpId?: number | undefined): Observable<TicketHolderIWPDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/GetIWPDetails?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIWPDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIWPDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderIWPDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderIWPDetailsDto>;
        }));
    }

    protected processGetIWPDetails(response: HttpResponseBase): Observable<TicketHolderIWPDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderIWPDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iwpId (optional) 
     * @return OK
     */
    getDigiSignerHistory(iwpId?: number | undefined): Observable<IWPDigiSignerEnvelopeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderIWP/GetDigiSignerHistory?";
        if (iwpId === null)
            throw new Error("The parameter 'iwpId' cannot be null.");
        else if (iwpId !== undefined)
            url_ += "iwpId=" + encodeURIComponent("" + iwpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDigiSignerHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDigiSignerHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWPDigiSignerEnvelopeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWPDigiSignerEnvelopeDto[]>;
        }));
    }

    protected processGetDigiSignerHistory(response: HttpResponseBase): Observable<IWPDigiSignerEnvelopeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IWPDigiSignerEnvelopeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TicketHolderLoginManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filterText (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTicketHolderLogins(filterText?: string | null | undefined, status?: TicketHolderLoginStatus | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderLoginRowDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderLoginManagement/GetTicketHolderLogins?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderLogins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderLogins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderLoginRowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderLoginRowDto>;
        }));
    }

    protected processGetTicketHolderLogins(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderLoginRowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderLoginRowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSummary(): Observable<TicketHolderLoginSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderLoginManagement/GetSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderLoginSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderLoginSummaryDto>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<TicketHolderLoginSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderLoginSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TicketHolderServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get TicketHolder Glance
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getTicketHolderGlance(ticketHolderId?: number | undefined): Observable<TicketHolderGlanceDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderGlance?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderGlance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderGlance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderGlanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderGlanceDto>;
        }));
    }

    protected processGetTicketHolderGlance(response: HttpResponseBase): Observable<TicketHolderGlanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderGlanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get ticket holder login information
     * @return OK
     */
    ticketHoloderLoginInfo(ticketHolderId: number): Observable<TicketHolderLoginAttempts[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/TicketHoloderLoginInfo?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTicketHoloderLoginInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTicketHoloderLoginInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderLoginAttempts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderLoginAttempts[]>;
        }));
    }

    protected processTicketHoloderLoginInfo(response: HttpResponseBase): Observable<TicketHolderLoginAttempts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderLoginAttempts.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the TicketHolder assigned to current user (Career Coach)
     * @param filter (optional) 
     * @param ticketHolderId (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param middleName (optional) 
     * @param city (optional) 
     * @param state (optional) 
     * @param zip (optional) 
     * @param phoneNumber (optional) 
     * @param status (optional) 
     * @param careerCoachId (optional) 
     * @param phaseMilestone (optional) 
     * @param workStatus (optional) 
     * @param latestContactResult (optional) 
     * @param emailId (optional) 
     * @param scheduledSearchDay (optional) 
     * @param tag (optional) 
     * @param untaggedOnly (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getMyTicketHolders(filter?: string | null | undefined, ticketHolderId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, middleName?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, phoneNumber?: string | null | undefined, status?: TicketHolderStatus[] | null | undefined, careerCoachId?: number[] | null | undefined, phaseMilestone?: string | null | undefined, workStatus?: WorkStatus[] | null | undefined, latestContactResult?: ActivityStatus[] | null | undefined, emailId?: string | null | undefined, scheduledSearchDay?: WeekDays[] | null | undefined, tag?: string | null | undefined, untaggedOnly?: boolean | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultWithGridDtoOfTicketHolderDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetMyTicketHolders?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketHolderId !== undefined && ticketHolderId !== null)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (middleName !== undefined && middleName !== null)
            url_ += "MiddleName=" + encodeURIComponent("" + middleName) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (zip !== undefined && zip !== null)
            url_ += "Zip=" + encodeURIComponent("" + zip) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (careerCoachId !== undefined && careerCoachId !== null)
            careerCoachId && careerCoachId.forEach(item => { url_ += "CareerCoachId=" + encodeURIComponent("" + item) + "&"; });
        if (phaseMilestone !== undefined && phaseMilestone !== null)
            url_ += "PhaseMilestone=" + encodeURIComponent("" + phaseMilestone) + "&";
        if (workStatus !== undefined && workStatus !== null)
            workStatus && workStatus.forEach(item => { url_ += "WorkStatus=" + encodeURIComponent("" + item) + "&"; });
        if (latestContactResult !== undefined && latestContactResult !== null)
            latestContactResult && latestContactResult.forEach(item => { url_ += "LatestContactResult=" + encodeURIComponent("" + item) + "&"; });
        if (emailId !== undefined && emailId !== null)
            url_ += "EmailId=" + encodeURIComponent("" + emailId) + "&";
        if (scheduledSearchDay !== undefined && scheduledSearchDay !== null)
            scheduledSearchDay && scheduledSearchDay.forEach(item => { url_ += "ScheduledSearchDay=" + encodeURIComponent("" + item) + "&"; });
        if (tag !== undefined && tag !== null)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        if (untaggedOnly !== undefined && untaggedOnly !== null)
            url_ += "UntaggedOnly=" + encodeURIComponent("" + untaggedOnly) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTicketHolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTicketHolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultWithGridDtoOfTicketHolderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultWithGridDtoOfTicketHolderDto>;
        }));
    }

    protected processGetMyTicketHolders(response: HttpResponseBase): Observable<PagedResultWithGridDtoOfTicketHolderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultWithGridDtoOfTicketHolderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMyTwoWayCommunicationOverview(): Observable<TwoWayCommunicationBucketDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetMyTwoWayCommunicationOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTwoWayCommunicationOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTwoWayCommunicationOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoWayCommunicationBucketDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoWayCommunicationBucketDto[]>;
        }));
    }

    protected processGetMyTwoWayCommunicationOverview(response: HttpResponseBase): Observable<TwoWayCommunicationBucketDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TwoWayCommunicationBucketDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * On-demand refresh: triggers the same "UpdateTicketHolderTwoWayCommunicationTask" the
    nightly cron runs, right now, instead of waiting for it. Runs tenant-wide on the
    MaintenanceConsole side (the task has no per-coach scope), so this has the same effect
    whichever page's Refresh button calls it.
     * @return OK
     */
    refreshTwoWayCommunicationData(): Observable<TwoWayCommunicationRefreshResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/RefreshTwoWayCommunicationData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshTwoWayCommunicationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTwoWayCommunicationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoWayCommunicationRefreshResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoWayCommunicationRefreshResultDto>;
        }));
    }

    protected processRefreshTwoWayCommunicationData(response: HttpResponseBase): Observable<TwoWayCommunicationRefreshResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoWayCommunicationRefreshResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Next UTC time the nightly cron will run the two-way-communication refresh.
     * @return OK
     */
    getTwoWayCommunicationNextRun(): Observable<TwoWayCommunicationNextRunDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTwoWayCommunicationNextRun";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTwoWayCommunicationNextRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTwoWayCommunicationNextRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoWayCommunicationNextRunDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoWayCommunicationNextRunDto>;
        }));
    }

    protected processGetTwoWayCommunicationNextRun(response: HttpResponseBase): Observable<TwoWayCommunicationNextRunDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoWayCommunicationNextRunDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Profile section details of the ticketHolder
     * @return OK
     */
    getProfile(ticketHolderId: number): Observable<TicketHolderProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetProfile?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderProfileDto>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<TicketHolderProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the Profile section details of the ticketHolder
     * @param body (optional) 
     * @return OK
     */
    updateProfile(body?: TicketHolderProfileDto | undefined): Observable<TicketHolderProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderProfileDto>;
        }));
    }

    protected processUpdateProfile(response: HttpResponseBase): Observable<TicketHolderProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Distinct, non-empty Tag values already used across the tenant's ticket holders (for the Tag picker).
     * @return OK
     */
    getDistinctTags(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetDistinctTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDistinctTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Lean, paged ticket holder list scoped to one Tag (or untagged) — used by Tag View.
    Projects only the fields the grouped list renders (no PhoneNumbers/Addresses
    includes, no full TicketHolderDto mapping) so it loads fast.
     * @param filter (optional) 
     * @param tag (optional) 
     * @param untaggedOnly (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTicketHoldersByTag(filter?: string | null | undefined, tag?: string | null | undefined, untaggedOnly?: boolean | null | undefined, status?: TicketHolderStatus[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTagGroupTicketHolderDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHoldersByTag?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (tag !== undefined && tag !== null)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        if (untaggedOnly !== undefined && untaggedOnly !== null)
            url_ += "UntaggedOnly=" + encodeURIComponent("" + untaggedOnly) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHoldersByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHoldersByTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTagGroupTicketHolderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTagGroupTicketHolderDto>;
        }));
    }

    protected processGetTicketHoldersByTag(response: HttpResponseBase): Observable<PagedResultDtoOfTagGroupTicketHolderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTagGroupTicketHolderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the getInTouch section details of the ticketHolder
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getInTouch(ticketHolderId?: number | undefined): Observable<TicketHolderGetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetInTouch?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInTouch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInTouch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderGetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderGetInTouchDto>;
        }));
    }

    protected processGetInTouch(response: HttpResponseBase): Observable<TicketHolderGetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderGetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the getInTouch section details of the ticketHolder
     * @param body (optional) 
     * @return OK
     */
    updateGetInTouch(body?: TicketHolderGetInTouchDto | undefined): Observable<TicketHolderGetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateGetInTouch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGetInTouch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGetInTouch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderGetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderGetInTouchDto>;
        }));
    }

    protected processUpdateGetInTouch(response: HttpResponseBase): Observable<TicketHolderGetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderGetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Insert benifit type
     * @param body (optional) 
     * @return OK
     */
    addBenefitType(body?: BaseTicketHolderBenefitType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddBenefitType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddBenefitType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBenefitType(body?: UpdateTicketHolderBenifitType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateBenefitType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateBenefitType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete benifit type by id
     * @param id (optional) 
     * @return OK
     */
    deleteBenefitType(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteBenefitType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBenefitType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get all benifits of ticket holder by ticket holder id
     * @return OK
     */
    getAllBenefitsByTicketHolderId(ticketHolderId: number): Observable<TicketHolderBenefitResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllBenefitsByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBenefitsByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBenefitsByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderBenefitResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderBenefitResponseDto[]>;
        }));
    }

    protected processGetAllBenefitsByTicketHolderId(response: HttpResponseBase): Observable<TicketHolderBenefitResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderBenefitResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBenefitsById(id: number): Observable<TicketHolderBenefitResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetBenefitsById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderBenefitResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderBenefitResponseDto>;
        }));
    }

    protected processGetBenefitsById(response: HttpResponseBase): Observable<TicketHolderBenefitResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderBenefitResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Insert medical Insurance
     * @param body (optional) 
     * @return OK
     */
    insertMedicalInsurance(body?: MedicalInsuranceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/InsertMedicalInsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMedicalInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMedicalInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertMedicalInsurance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update medical Insurance
     * @param body (optional) 
     * @return OK
     */
    updateMedicalInsurance(body?: UpdateMedicalInsuranceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateMedicalInsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateMedicalInsurance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete medical insureance
     * @return OK
     */
    deleteMedicalInsurance(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteMedicalInsurance?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMedicalInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMedicalInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMedicalInsurance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param medicalInsuranceId (optional) 
     * @param medicarePart (optional) 
     * @param forceDelete (optional) 
     * @return OK
     */
    deleteMedicalInsuranceByMedicarePart(medicalInsuranceId?: number | undefined, medicarePart?: MedicarePart | undefined, forceDelete?: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteMedicalInsuranceByMedicarePart?";
        if (medicalInsuranceId === null)
            throw new Error("The parameter 'medicalInsuranceId' cannot be null.");
        else if (medicalInsuranceId !== undefined)
            url_ += "MedicalInsuranceId=" + encodeURIComponent("" + medicalInsuranceId) + "&";
        if (medicarePart === null)
            throw new Error("The parameter 'medicarePart' cannot be null.");
        else if (medicarePart !== undefined)
            url_ += "medicarePart=" + encodeURIComponent("" + medicarePart) + "&";
        if (forceDelete === null)
            throw new Error("The parameter 'forceDelete' cannot be null.");
        else if (forceDelete !== undefined)
            url_ += "ForceDelete=" + encodeURIComponent("" + forceDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMedicalInsuranceByMedicarePart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMedicalInsuranceByMedicarePart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMedicalInsuranceByMedicarePart(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteMedicaidByMedicalInsurancceId(medicalInsuranceId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteMedicaidByMedicalInsurancceId?";
        if (medicalInsuranceId === undefined || medicalInsuranceId === null)
            throw new Error("The parameter 'medicalInsuranceId' must be defined and cannot be null.");
        else
            url_ += "medicalInsuranceId=" + encodeURIComponent("" + medicalInsuranceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMedicaidByMedicalInsurancceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMedicaidByMedicalInsurancceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMedicaidByMedicalInsurancceId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllMedicalInsuranceByTicketHolderId(ticketHolderId: number): Observable<MedicalInsuranceResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllMedicalInsuranceByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMedicalInsuranceByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMedicalInsuranceByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalInsuranceResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalInsuranceResponseDto[]>;
        }));
    }

    protected processGetAllMedicalInsuranceByTicketHolderId(response: HttpResponseBase): Observable<MedicalInsuranceResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalInsuranceResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get Medical insurance info by id
     * @return OK
     */
    getMedicalInsuranceById(id: number): Observable<MedicalInsuranceResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetMedicalInsuranceById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalInsuranceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalInsuranceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalInsuranceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalInsuranceResponseDto>;
        }));
    }

    protected processGetMedicalInsuranceById(response: HttpResponseBase): Observable<MedicalInsuranceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalInsuranceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add an eligibility record for the ticket holder.
     * @return OK
     * @deprecated
     */
    addEligibility(ticketHolderId: number): Observable<TicketAssignabilityVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddEligibility?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEligibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEligibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketAssignabilityVerificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketAssignabilityVerificationDto>;
        }));
    }

    protected processAddEligibility(response: HttpResponseBase): Observable<TicketAssignabilityVerificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketAssignabilityVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve all eligibility records associated with a specific ticket holder.
     * @return OK
     */
    getEligibilityByTicketHolderId(ticketHolderId: number): Observable<TicketAssignabilityVerificationOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetEligibilityByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEligibilityByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEligibilityByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketAssignabilityVerificationOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketAssignabilityVerificationOutputDto[]>;
        }));
    }

    protected processGetEligibilityByTicketHolderId(response: HttpResponseBase): Observable<TicketAssignabilityVerificationOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketAssignabilityVerificationOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getTicketHolderNotes(ticketHolderId?: number | undefined): Observable<TicketHolderNoteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderNotes?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderNoteDto[]>;
        }));
    }

    protected processGetTicketHolderNotes(response: HttpResponseBase): Observable<TicketHolderNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTicketHolderNote(body?: CreateTicketHolderNoteDto | undefined): Observable<TicketHolderNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CreateTicketHolderNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicketHolderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicketHolderNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderNoteDto>;
        }));
    }

    protected processCreateTicketHolderNote(response: HttpResponseBase): Observable<TicketHolderNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTicketHolderNote(body?: UpdateTicketHolderNoteDto | undefined): Observable<TicketHolderNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTicketHolderNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderNoteDto>;
        }));
    }

    protected processUpdateTicketHolderNote(response: HttpResponseBase): Observable<TicketHolderNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param noteId (optional) 
     * @return OK
     */
    deleteTicketHolderNote(noteId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteTicketHolderNote?";
        if (noteId === null)
            throw new Error("The parameter 'noteId' cannot be null.");
        else if (noteId !== undefined)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTicketHolderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTicketHolderNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTicketHolderNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getNotes(ticketHolderId?: number | undefined): Observable<TicketHolderNotesDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetNotes?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderNotesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderNotesDto>;
        }));
    }

    protected processGetNotes(response: HttpResponseBase): Observable<TicketHolderNotesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderNotesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update or save notes for a specific ticket holder.
     * @param body (optional) 
     * @return OK
     */
    updateNotes(body?: TicketHolderNotesDto | undefined): Observable<TicketHolderNotesDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderNotesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderNotesDto>;
        }));
    }

    protected processUpdateNotes(response: HttpResponseBase): Observable<TicketHolderNotesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderNotesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the survey response for a specific ticket holder.
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getSurveyResponseByTicketHolderId(ticketHolderId?: string | null | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetSurveyResponseByTicketHolderId?";
        if (ticketHolderId !== undefined && ticketHolderId !== null)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyResponseByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponseByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetSurveyResponseByTicketHolderId(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the survey response for a ticket holder.
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateSurveyResponse(body?: TicketHolderSurveyResponseDto | undefined): Observable<TicketHolderSurveyResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateSurveyResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSurveyResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSurveyResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderSurveyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderSurveyResponseDto>;
        }));
    }

    protected processUpdateSurveyResponse(response: HttpResponseBase): Observable<TicketHolderSurveyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderSurveyResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the work history records associated with a specific ticket holder.
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getWorkHistoryByTicketHolderId(ticketHolderId: number, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetWorkHistoryByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkHistoryByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkHistoryByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderWorkHistoryDto>;
        }));
    }

    protected processGetWorkHistoryByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new work history record for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    addWorkHistory(body?: TicketHolderWorkHistoryDto | undefined): Observable<TicketHolderWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderWorkHistoryDto>;
        }));
    }

    protected processAddWorkHistory(response: HttpResponseBase): Observable<TicketHolderWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a work history record by its ID.
     * @param id The unique identifier of the work history record.
    Must be greater than zero.
     * @return OK
     */
    deleteWorkHistory(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteWorkHistory?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteWorkHistory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing work history record for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    updateWorkHistory(body?: TicketHolderWorkHistoryDto | undefined): Observable<TicketHolderWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderWorkHistoryDto>;
        }));
    }

    protected processUpdateWorkHistory(response: HttpResponseBase): Observable<TicketHolderWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a new document for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    addDocument(body?: TicketHolderInputDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processAddDocument(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve paged documents associated with a specific ticket holder, based on filter criteria.
     * @param documentTypes (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getDocumentsByTicketHolderId(ticketHolderId: number, documentTypes?: TicketHolderDocumentType[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetDocumentsByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (documentTypes !== undefined && documentTypes !== null)
            documentTypes && documentTypes.forEach(item => { url_ += "DocumentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDocumentDto>;
        }));
    }

    protected processGetDocumentsByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete document uploaded for the ticket holder
     * @param documentId (optional) 
     * @return OK
     */
    deleteDocument(documentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteDocument?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Quick-edit endpoint: updates just a document's DocumentType (e.g. correcting a
    paystub/BPQY upload that was mis-tagged), without touching its file or other metadata.
     * @param documentId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateDocumentType(documentId?: number | undefined, body?: TicketHolderDocumentType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateDocumentType?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDocumentType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    shareDocumentByEmail(documentId?: number | undefined): Observable<DocumentShareLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/ShareDocumentByEmail?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShareDocumentByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShareDocumentByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentShareLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentShareLinkDto>;
        }));
    }

    protected processShareDocumentByEmail(response: HttpResponseBase): Observable<DocumentShareLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentShareLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shareLinkId (optional) 
     * @return OK
     */
    resendShareEmail(shareLinkId?: number | undefined): Observable<DocumentShareLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/ResendShareEmail?";
        if (shareLinkId === null)
            throw new Error("The parameter 'shareLinkId' cannot be null.");
        else if (shareLinkId !== undefined)
            url_ += "shareLinkId=" + encodeURIComponent("" + shareLinkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendShareEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendShareEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentShareLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentShareLinkDto>;
        }));
    }

    protected processResendShareEmail(response: HttpResponseBase): Observable<DocumentShareLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentShareLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param shareLinkId (optional) 
     * @return OK
     */
    revokeShareLink(shareLinkId?: number | undefined): Observable<DocumentShareLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/RevokeShareLink?";
        if (shareLinkId === null)
            throw new Error("The parameter 'shareLinkId' cannot be null.");
        else if (shareLinkId !== undefined)
            url_ += "shareLinkId=" + encodeURIComponent("" + shareLinkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeShareLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeShareLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentShareLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentShareLinkDto>;
        }));
    }

    protected processRevokeShareLink(response: HttpResponseBase): Observable<DocumentShareLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentShareLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    getShareLinksByDocumentId(documentId?: number | undefined): Observable<DocumentShareLinkDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetShareLinksByDocumentId?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShareLinksByDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShareLinksByDocumentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentShareLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentShareLinkDto[]>;
        }));
    }

    protected processGetShareLinksByDocumentId(response: HttpResponseBase): Observable<DocumentShareLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentShareLinkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getPaystubUploadLinkInfo(ticketHolderId?: number | undefined): Observable<PaystubUploadLinkInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetPaystubUploadLinkInfo?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaystubUploadLinkInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaystubUploadLinkInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadLinkInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadLinkInfoDto>;
        }));
    }

    protected processGetPaystubUploadLinkInfo(response: HttpResponseBase): Observable<PaystubUploadLinkInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadLinkInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    regeneratePaystubUploadLink(ticketHolderId?: number | undefined): Observable<PaystubUploadLinkInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/RegeneratePaystubUploadLink?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegeneratePaystubUploadLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegeneratePaystubUploadLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadLinkInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadLinkInfoDto>;
        }));
    }

    protected processRegeneratePaystubUploadLink(response: HttpResponseBase): Observable<PaystubUploadLinkInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadLinkInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    sendPaystubUploadLinkByEmail(ticketHolderId?: number | undefined): Observable<PaystubUploadLinkInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/SendPaystubUploadLinkByEmail?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPaystubUploadLinkByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPaystubUploadLinkByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadLinkInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadLinkInfoDto>;
        }));
    }

    protected processSendPaystubUploadLinkByEmail(response: HttpResponseBase): Observable<PaystubUploadLinkInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadLinkInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    sendPaystubUploadLinkBySms(ticketHolderId?: number | undefined): Observable<PaystubUploadLinkInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/SendPaystubUploadLinkBySms?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPaystubUploadLinkBySms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPaystubUploadLinkBySms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubUploadLinkInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubUploadLinkInfoDto>;
        }));
    }

    protected processSendPaystubUploadLinkBySms(response: HttpResponseBase): Observable<PaystubUploadLinkInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubUploadLinkInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Follwup
     * @param body (optional) 
     * @return OK
     */
    createTicketHolderFollowup(body?: CreateTicketHolderFollowupDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CreateTicketHolderFollowup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicketHolderFollowup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicketHolderFollowup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateTicketHolderFollowup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Followup
     * @param body (optional) 
     * @return OK
     */
    updateTicketHolderFollowup(body?: TicketHolderFollowupDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTicketHolderFollowup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderFollowup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderFollowup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateTicketHolderFollowup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Ticket Holder Followups by providing ticket Holder Id
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param selectedStatuses (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getTicketHolderFollowupByTicketHolderId(ticketHolderId: number, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, selectedStatuses?: CalendarEventStatus[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderFollowupDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderFollowupByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (selectedStatuses !== undefined && selectedStatuses !== null)
            selectedStatuses && selectedStatuses.forEach(item => { url_ += "SelectedStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderFollowupByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderFollowupByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderFollowupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderFollowupDto>;
        }));
    }

    protected processGetTicketHolderFollowupByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderFollowupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderFollowupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new activity record for a ticket holder.
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    addActivity(body?: TicketHolderActivityDto | undefined): Observable<TicketHolderActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderActivityDto>;
        }));
    }

    protected processAddActivity(response: HttpResponseBase): Observable<TicketHolderActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a paginated list of ticket holder activities based on the provided filter.
     * @param year (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getInitialActivity(ticketHolderId: number, year?: number | null | undefined, contactType?: ContactType[] | null | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<MonthPagedResultDtoOfTicketHolderActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetInitialActivity?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (contactType !== undefined && contactType !== null)
            contactType && contactType.forEach(item => { url_ += "ContactType=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitialActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitialActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthPagedResultDtoOfTicketHolderActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthPagedResultDtoOfTicketHolderActivityDto[]>;
        }));
    }

    protected processGetInitialActivity(response: HttpResponseBase): Observable<MonthPagedResultDtoOfTicketHolderActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthPagedResultDtoOfTicketHolderActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get month wise activity.
     * @param lastRecordDate (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getActivitiesByMonth(year: number, month: number, ticketHolderId: number, lastRecordDate?: DateTime | null | undefined, contactType?: ContactType[] | null | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<MonthPagedResultDtoOfTicketHolderActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetActivitiesByMonth?";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (lastRecordDate !== undefined && lastRecordDate !== null)
            url_ += "LastRecordDate=" + encodeURIComponent(lastRecordDate ? "" + lastRecordDate.toString() : "") + "&";
        if (contactType !== undefined && contactType !== null)
            contactType && contactType.forEach(item => { url_ += "ContactType=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthPagedResultDtoOfTicketHolderActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthPagedResultDtoOfTicketHolderActivityDto>;
        }));
    }

    protected processGetActivitiesByMonth(response: HttpResponseBase): Observable<MonthPagedResultDtoOfTicketHolderActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthPagedResultDtoOfTicketHolderActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Phone Log
     * @param body (optional) 
     * @return OK
     */
    addPhoneLog(body?: TicketHolderPhoneLogDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddPhoneLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPhoneLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPhoneLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPhoneLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Default activity service type for a Ticket Holder: always Job Search.
    Used to prefill the Service Type on call log, SMS, chat, email, mail and fax; the Career Coach can change it.
     * @param ticketHolderId (optional) TicketHolders.Id
     * @return OK
     */
    getDefaultServiceType(ticketHolderId?: number | undefined): Observable<ActivityServiceType> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetDefaultServiceType?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityServiceType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityServiceType>;
        }));
    }

    protected processGetDefaultServiceType(response: HttpResponseBase): Observable<ActivityServiceType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Phone Log
     * @param body (optional) 
     * @return OK
     */
    updatePhoneLog(body?: UpdateTHPhoneLogDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdatePhoneLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePhoneLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePhoneLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePhoneLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a fax record for a ticket holder.
     * @param attachments (optional) 
     * @param ticketHolderId (optional) 
     * @param senderName (optional) 
     * @param senderAddress (optional) 
     * @param recipientName (optional) 
     * @param faxNumber (optional) 
     * @param subject (optional) 
     * @param messageBody (optional) 
     * @return OK
     * @deprecated
     */
    addFax(attachments?: FileParameter[] | undefined, ticketHolderId?: number | undefined, senderName?: string | undefined, senderAddress?: string | undefined, recipientName?: string | undefined, faxNumber?: string | undefined, subject?: string | undefined, messageBody?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachments === null || attachments === undefined)
            throw new Error("The parameter 'attachments' cannot be null.");
        else
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );
        if (ticketHolderId === null || ticketHolderId === undefined)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else
            content_.append("TicketHolderId", ticketHolderId.toString());
        if (senderName === null || senderName === undefined)
            throw new Error("The parameter 'senderName' cannot be null.");
        else
            content_.append("SenderName", senderName.toString());
        if (senderAddress === null || senderAddress === undefined)
            throw new Error("The parameter 'senderAddress' cannot be null.");
        else
            content_.append("SenderAddress", senderAddress.toString());
        if (recipientName === null || recipientName === undefined)
            throw new Error("The parameter 'recipientName' cannot be null.");
        else
            content_.append("RecipientName", recipientName.toString());
        if (faxNumber === null || faxNumber === undefined)
            throw new Error("The parameter 'faxNumber' cannot be null.");
        else
            content_.append("FaxNumber", faxNumber.toString());
        if (subject === null || subject === undefined)
            throw new Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (messageBody === null || messageBody === undefined)
            throw new Error("The parameter 'messageBody' cannot be null.");
        else
            content_.append("MessageBody", messageBody.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddFax(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a mail record for a ticket holder.
     * @param attachments (optional) 
     * @param ticketHolderId (optional) 
     * @param senderName (optional) 
     * @param senderAddress (optional) 
     * @param recipientName (optional) 
     * @param recipientAddress (optional) 
     * @param subject (optional) 
     * @param messageBody (optional) 
     * @return OK
     * @deprecated
     */
    addMail(attachments?: FileParameter[] | undefined, ticketHolderId?: number | undefined, senderName?: string | undefined, senderAddress?: string | undefined, recipientName?: string | undefined, recipientAddress?: string | undefined, subject?: string | undefined, messageBody?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachments === null || attachments === undefined)
            throw new Error("The parameter 'attachments' cannot be null.");
        else
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );
        if (ticketHolderId === null || ticketHolderId === undefined)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else
            content_.append("TicketHolderId", ticketHolderId.toString());
        if (senderName === null || senderName === undefined)
            throw new Error("The parameter 'senderName' cannot be null.");
        else
            content_.append("SenderName", senderName.toString());
        if (senderAddress === null || senderAddress === undefined)
            throw new Error("The parameter 'senderAddress' cannot be null.");
        else
            content_.append("SenderAddress", senderAddress.toString());
        if (recipientName === null || recipientName === undefined)
            throw new Error("The parameter 'recipientName' cannot be null.");
        else
            content_.append("RecipientName", recipientName.toString());
        if (recipientAddress === null || recipientAddress === undefined)
            throw new Error("The parameter 'recipientAddress' cannot be null.");
        else
            content_.append("RecipientAddress", recipientAddress.toString());
        if (subject === null || subject === undefined)
            throw new Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (messageBody === null || messageBody === undefined)
            throw new Error("The parameter 'messageBody' cannot be null.");
        else
            content_.append("MessageBody", messageBody.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of service requests for a given Ticket Holder ID,
    with optional filters on due date range, service type, and status.
     * @param body (optional) The filter input containing pagination and filter criteria.
     * @return OK
     */
    getAllServiceRequestsTicketHolderId(body?: ServiceRequestFilter | undefined): Observable<PagedResultDtoOfVwServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllServiceRequestsTicketHolderId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceRequestsTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceRequestsTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfVwServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfVwServiceRequestDto>;
        }));
    }

    protected processGetAllServiceRequestsTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfVwServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfVwServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add advocacy service requests
     * @param body (optional) 
     * @return OK
     */
    addAdvocacyServiceRequest(body?: AdvocacyServiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddAdvocacyServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAdvocacyServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAdvocacyServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAdvocacyServiceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get advocacy service requests
     * @return OK
     */
    getAdvocacyServiceRequest(idRaw: number, serviceType: ServiceType): Observable<AdvocacyServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAdvocacyServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvocacyServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvocacyServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvocacyServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvocacyServiceRequestDto>;
        }));
    }

    protected processGetAdvocacyServiceRequest(response: HttpResponseBase): Observable<AdvocacyServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvocacyServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add education service requests
     * @param body (optional) 
     * @return OK
     */
    addEducationServiceRequest(body?: EducationServiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddEducationServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddEducationServiceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get education service requests
     * @return OK
     */
    getEducationServiceRequest(idRaw: number, serviceType: ServiceType): Observable<EducationServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetEducationServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationServiceRequestDto>;
        }));
    }

    protected processGetEducationServiceRequest(response: HttpResponseBase): Observable<EducationServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add housing service requests
     * @param body (optional) 
     * @return OK
     */
    addHousingServiceRequest(body?: HousingServiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddHousingServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddHousingServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddHousingServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddHousingServiceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get housing service requests
     * @return OK
     */
    getHousingServiceRequest(idRaw: number, serviceType: ServiceType): Observable<HousingServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetHousingServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHousingServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHousingServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HousingServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HousingServiceRequestDto>;
        }));
    }

    protected processGetHousingServiceRequest(response: HttpResponseBase): Observable<HousingServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HousingServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Interview assistance service requests
     * @param body (optional) 
     * @return OK
     */
    addInterviewAssistanceServiceRequest(body?: InterviewAssistanceServiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddInterviewAssistanceServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInterviewAssistanceServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInterviewAssistanceServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddInterviewAssistanceServiceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get interview assistance service requests
     * @return OK
     */
    getInterviewAssistanceServiceRequest(idRaw: number, serviceType: ServiceType): Observable<InterviewAssistanceServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetInterviewAssistanceServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterviewAssistanceServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterviewAssistanceServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterviewAssistanceServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterviewAssistanceServiceRequestDto>;
        }));
    }

    protected processGetInterviewAssistanceServiceRequest(response: HttpResponseBase): Observable<InterviewAssistanceServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterviewAssistanceServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add resume service requests
     * @param body (optional) 
     * @return OK
     */
    addResumeServiceRequest(body?: ResumeServiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddResumeServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddResumeServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddResumeServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddResumeServiceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get resume service requests
     * @return OK
     */
    getResumeServiceRequest(idRaw: number, serviceType: ServiceType): Observable<ResumeServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetResumeServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResumeServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResumeServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeServiceRequestDto>;
        }));
    }

    protected processGetResumeServiceRequest(response: HttpResponseBase): Observable<ResumeServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumeServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add transport service requests
     * @param body (optional) 
     * @return OK
     */
    addTransportationServiceRequest(body?: TransportationServiceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddTransportationServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTransportationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTransportationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddTransportationServiceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get transport service requests
     * @return OK
     */
    getTransportationServiceRequest(idRaw: number, serviceType: ServiceType): Observable<TransportationServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTransportationServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransportationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransportationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransportationServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransportationServiceRequestDto>;
        }));
    }

    protected processGetTransportationServiceRequest(response: HttpResponseBase): Observable<TransportationServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportationServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all payments service requests
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPaymentRequest(filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllPaymentRequest?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPaymentRequestDto>;
        }));
    }

    protected processGetAllPaymentRequest(response: HttpResponseBase): Observable<PagedResultDtoOfPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Ticket Holder Contact History
     * @param filter (optional) 
     * @param ticketHolderId (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param cursorCreationTime (optional) 
     * @param cursorId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllContactHistory(filter?: string | null | undefined, ticketHolderId?: number | null | undefined, contactType?: ContactType | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, cursorCreationTime?: DateTime | null | undefined, cursorId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfContactHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllContactHistory?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketHolderId !== undefined && ticketHolderId !== null)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (cursorCreationTime !== undefined && cursorCreationTime !== null)
            url_ += "CursorCreationTime=" + encodeURIComponent(cursorCreationTime ? "" + cursorCreationTime.toString() : "") + "&";
        if (cursorId !== undefined && cursorId !== null)
            url_ += "CursorId=" + encodeURIComponent("" + cursorId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfContactHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfContactHistoryDto>;
        }));
    }

    protected processGetAllContactHistory(response: HttpResponseBase): Observable<PagedResultDtoOfContactHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new phone number for a given ticketHolder if it does not already exist.
     * @param body (optional) The phone number to add.
     * @return OK
     */
    addTHPhoneNumber(body?: TicketHolderNewPhoneDto | undefined): Observable<TicketHolderGetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddTHPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTHPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTHPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderGetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderGetInTouchDto>;
        }));
    }

    protected processAddTHPhoneNumber(response: HttpResponseBase): Observable<TicketHolderGetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderGetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves phone numbers for a specific TH, optionally filtered by phone type.
     * @param body (optional) Filter containing THId and optional PhoneType.
     * @return OK
     */
    getTHPhoneNumbersByTHId(body?: GetTHPhoneNumberFilterDto | undefined): Observable<TicketHolderPhoneNumberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTHPhoneNumbersByTHId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHPhoneNumbersByTHId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHPhoneNumbersByTHId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderPhoneNumberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderPhoneNumberDto[]>;
        }));
    }

    protected processGetTHPhoneNumbersByTHId(response: HttpResponseBase): Observable<TicketHolderPhoneNumberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderPhoneNumberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an existing phone number for a given ticketHolder.
     * @param ticketHolderId The ID of the TicketHolder.
     * @param phoneNumber (optional) The phone number to delete.
     * @return OK
     */
    deleteTHPhoneNumber(ticketHolderId: number, phoneNumber?: string | null | undefined): Observable<TicketHolderGetInTouchDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteTHPhoneNumber?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTHPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTHPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderGetInTouchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderGetInTouchDto>;
        }));
    }

    protected processDeleteTHPhoneNumber(response: HttpResponseBase): Observable<TicketHolderGetInTouchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderGetInTouchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new address record for the specified TicketHolder.
     * @param body (optional) The new address details to be associated with a TicketHolder.
     * @return OK
     */
    addTHAddress(body?: TicketHolderNewAddressDto | undefined): Observable<TicketHolderAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddTHAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTHAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTHAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderAddressDto>;
        }));
    }

    protected processAddTHAddress(response: HttpResponseBase): Observable<TicketHolderAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all address records associated with the specified TicketHolder.
     * @param ticketHolderId (optional) 
     * @param addressType (optional) 
     * @return OK
     */
    getTicketHolderAddressByTHId(ticketHolderId?: number | undefined, addressType?: AddressType | undefined): Observable<TicketHolderAddressDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderAddressByTHId?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (addressType === null)
            throw new Error("The parameter 'addressType' cannot be null.");
        else if (addressType !== undefined)
            url_ += "AddressType=" + encodeURIComponent("" + addressType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderAddressByTHId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderAddressByTHId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderAddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderAddressDto[]>;
        }));
    }

    protected processGetTicketHolderAddressByTHId(response: HttpResponseBase): Observable<TicketHolderAddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderAddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing TicketHolder address with the provided data.
     * @param body (optional) The updated address data for a TicketHolder.
     * @return OK
     */
    updateTHAddress(body?: TicketHolderAddressDto | undefined): Observable<TicketHolderAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTHAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTHAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTHAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderAddressDto>;
        }));
    }

    protected processUpdateTHAddress(response: HttpResponseBase): Observable<TicketHolderAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the TicketHolder address with the specified ID.
     * @param addressId (optional) The ID of the address to delete.
     * @return OK
     */
    deleteTHAddress(addressId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteTHAddress?";
        if (addressId === null)
            throw new Error("The parameter 'addressId' cannot be null.");
        else if (addressId !== undefined)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTHAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTHAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTHAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged list of SMS activity records associated with a specific ticketHolder,
    filtered and sorted based on the provided input criteria.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getChatSMSByTicketHolderId(ticketHolderId: number, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTHChatSMSDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetChatSMSByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatSMSByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatSMSByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHChatSMSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHChatSMSDto>;
        }));
    }

    protected processGetChatSMSByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfTHChatSMSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHChatSMSDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated list of payout (pay history) records for a specific ticket holder,
    ordered by most recent entries first.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getPayRequestHistoryByTicketHolderId(ticketHolderId: number, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderPayRequestHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetPayRequestHistoryByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRequestHistoryByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRequestHistoryByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderPayRequestHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderPayRequestHistoryDto>;
        }));
    }

    protected processGetPayRequestHistoryByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderPayRequestHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderPayRequestHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a mail log and the associated ticketHolder activity based on the provided input.
    This applies only when the contact type is set to mail.
     * @param body (optional) The input model containing log ID, activity ID, status, and contact type.
     * @return OK
     */
    updateLogAndActivityStatus(body?: UpdateLogAndActivityStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateLogAndActivityStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogAndActivityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogAndActivityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLogAndActivityStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of unassign requests associated with the specified Ticket Holder ID.
    Throws a UserFriendlyException if the Ticket Holder ID is invalid (zero or negative).
     * @param ticketHolderId The ID of the Ticket Holder whose unassign requests are to be retrieved.
     * @return OK
     */
    getUnassignRequestByTicketHolderId(ticketHolderId: number): Observable<UnassignRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetUnassignRequestByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignRequestByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignRequestByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnassignRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnassignRequestDto[]>;
        }));
    }

    protected processGetUnassignRequestByTicketHolderId(response: HttpResponseBase): Observable<UnassignRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnassignRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new reinstatement request for a given Ticket Holder.
    Validates the Ticket Holder ID and ensures the Ticket Holder exists before creating the request.
     * @param body (optional) The DTO containing Ticket Holder ID and optional notes.
     * @return OK
     */
    createReinstatementByTicketHolderId(body?: CreateReinstatementDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CreateReinstatementByTicketHolderId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReinstatementByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReinstatementByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReinstatementByTicketHolderId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the reinstatement request details for a given Ticket Holder ID.
    Throws a UserFriendlyException if the ID is invalid (less than or equal to zero).
    Returns null if no reinstatement record is found.
     * @param ticketHolderId The ID of the Ticket Holder.
     * @return OK
     */
    getReinstatementByTicketHolderId(ticketHolderId: number): Observable<ReinstatementDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetReinstatementByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReinstatementByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReinstatementByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReinstatementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReinstatementDto>;
        }));
    }

    protected processGetReinstatementByTicketHolderId(response: HttpResponseBase): Observable<ReinstatementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReinstatementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new history record for a Ticket Holder's reinstatement process and updates the current status.
    Also captures metadata about the user performing the action.
     * @param body (optional) The DTO containing the reinstatement ID, new status, and optional reason or note.
     * @return OK
     */
    createReinstatementHistoryByTicketHolderId(body?: CreateReinstatementHistoryDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CreateReinstatementHistoryByTicketHolderId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReinstatementHistoryByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReinstatementHistoryByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReinstatementHistoryByTicketHolderId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the full list of reinstatement history records associated with a specific reinstatement ID.
    Each record represents a status change made during the reinstatement process.
     * @param reinstatementId The ID of the Ticket Holder Reinstatement.
     * @return OK
     */
    getReinstatementHistoryByReinstatementId(reinstatementId: number): Observable<ReinstatementHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetReinstatementHistoryByReinstatementId?";
        if (reinstatementId === undefined || reinstatementId === null)
            throw new Error("The parameter 'reinstatementId' must be defined and cannot be null.");
        else
            url_ += "reinstatementId=" + encodeURIComponent("" + reinstatementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReinstatementHistoryByReinstatementId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReinstatementHistoryByReinstatementId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReinstatementHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReinstatementHistoryDto[]>;
        }));
    }

    protected processGetReinstatementHistoryByReinstatementId(response: HttpResponseBase): Observable<ReinstatementHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReinstatementHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllIWPByTicketHolderId(ticketHolderId: number, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTicketHolderIWPDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllIWPByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIWPByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIWPByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderIWPDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderIWPDto>;
        }));
    }

    protected processGetAllIWPByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderIWPDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderIWPDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the status of a Ticket Holder based on the provided input.
     * @param body (optional) An object containing the Ticket Holder ID and the new status.
     * @return OK
     */
    updateTicketHolderStatus(body?: UpdateTicketHolderStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTicketHolderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTicketHolderStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a portal login for the specified ticket holder and returns their login information.
     * @param ticketHolderId The unique identifier of the ticket holder.
     * @return OK
     */
    createTicketHolderPortalLogin(ticketHolderId: number): Observable<TicketHolderLoginInfo> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CreateTicketHolderPortalLogin?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTicketHolderPortalLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTicketHolderPortalLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderLoginInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderLoginInfo>;
        }));
    }

    protected processCreateTicketHolderPortalLogin(response: HttpResponseBase): Observable<TicketHolderLoginInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderLoginInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    resendTicketHolderInvitation(ticketHolderId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/ResendTicketHolderInvitation?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendTicketHolderInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendTicketHolderInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResendTicketHolderInvitation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    resetTicketHolderPassword(ticketHolderId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/ResetTicketHolderPassword?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTicketHolderPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTicketHolderPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetTicketHolderPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    deleteTicketHolderPortalLogin(ticketHolderId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteTicketHolderPortalLogin?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTicketHolderPortalLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTicketHolderPortalLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTicketHolderPortalLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Blocks the ticket holder from the web portal and mobile app right away (open sessions end on their next
    request). The login is kept, so M:Thrive.TTW.TicketHolder.TicketHolderService.RestoreTicketHolderPortalAccessAsync(System.Int64) can undo it.
     * @param body (optional) 
     * @return OK
     */
    revokeTicketHolderPortalAccess(body?: RevokeTicketHolderPortalAccessInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/RevokeTicketHolderPortalAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeTicketHolderPortalAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeTicketHolderPortalAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevokeTicketHolderPortalAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    restoreTicketHolderPortalAccess(ticketHolderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/RestoreTicketHolderPortalAccess?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreTicketHolderPortalAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreTicketHolderPortalAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreTicketHolderPortalAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the login information for a ticket holder based on their ticket holder ID.
    If no user is associated, returns an empty Thrive.TTW.TicketHolder.Dtos.TicketHolderLoginInfo object.
     * @param ticketHolderId The unique identifier of the ticket holder.
     * @return OK
     */
    getTicketHolderLoginInfoByTicketHolderId(ticketHolderId: number): Observable<TicketHolderLoginInfo> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderLoginInfoByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderLoginInfoByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderLoginInfoByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderLoginInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderLoginInfo>;
        }));
    }

    protected processGetTicketHolderLoginInfoByTicketHolderId(response: HttpResponseBase): Observable<TicketHolderLoginInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderLoginInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the work status of a Ticket Holder.
     * @param body (optional) 
     * @return OK
     */
    updateWorkStatus(body?: UpdateTicketHolderWorkStatusDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateWorkStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWorkStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new login entry for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    addNewLogin(body?: CreateLoginDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/AddNewLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddNewLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing login entry.
    Career coaches can manage multiple Ticket Holders, so TicketHolderId is allowed to change.
     * @param body (optional) 
     * @return OK
     */
    updateLogin(body?: LoginDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a login entry by ID.
     * @return OK
     */
    getLoginById(id: number): Observable<LoginDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetLoginById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginDto>;
        }));
    }

    protected processGetLoginById(response: HttpResponseBase): Observable<LoginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all login entries for a ticket holder.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getLoginByTicketHolderId(ticketHolderId: number, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfLoginDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetLoginByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLoginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLoginDto>;
        }));
    }

    protected processGetLoginByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfLoginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLoginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a login entry.
     * @return OK
     */
    deleteLoginById(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteLoginById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLoginById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLoginById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteLoginById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enables/Disables 2FA.
     * @param body (optional) 
     * @return OK
     */
    updateTwoFactorEnabled(body?: TwoFactorEnabledDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTwoFactorEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTwoFactorEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTwoFactorEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTwoFactorEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves the effective time zone for a Ticket Holder.
     * @param ticketHolderId (optional) The unique ID of the Ticket Holder.
     * @return OK
     */
    getTicketHolderTimeZone(ticketHolderId?: number | undefined): Observable<TicketHolderTimeZoneDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderTimeZone?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderTimeZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderTimeZoneDto>;
        }));
    }

    protected processGetTicketHolderTimeZone(response: HttpResponseBase): Observable<TicketHolderTimeZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderTimeZoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of time zone options for a specific Ticket Holder,
    formatted as Abp.Application.Services.Dto.ComboboxItemDto for UI dropdowns.
     * @param ticketHolderId (optional) The unique ID of the Ticket Holder.
     * @return OK
     */
    getTicketHolderTimeZoneComboboxItems(ticketHolderId?: number | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderTimeZoneComboboxItems?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderTimeZoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderTimeZoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTicketHolderTimeZoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Contact Histories Contacted by the Current Login
     * @param filter (optional) 
     * @param ticketHolderId (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param cursorCreationTime (optional) 
     * @param cursorId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllContactHistoryForCurrentLogin(filter?: string | null | undefined, ticketHolderId?: number | null | undefined, contactType?: ContactType | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, cursorCreationTime?: DateTime | null | undefined, cursorId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfContactHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllContactHistoryForCurrentLogin?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketHolderId !== undefined && ticketHolderId !== null)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (cursorCreationTime !== undefined && cursorCreationTime !== null)
            url_ += "CursorCreationTime=" + encodeURIComponent(cursorCreationTime ? "" + cursorCreationTime.toString() : "") + "&";
        if (cursorId !== undefined && cursorId !== null)
            url_ += "CursorId=" + encodeURIComponent("" + cursorId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactHistoryForCurrentLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactHistoryForCurrentLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfContactHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfContactHistoryDto>;
        }));
    }

    protected processGetAllContactHistoryForCurrentLogin(response: HttpResponseBase): Observable<PagedResultDtoOfContactHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Section summary for the current login's Contact History: newest-first relative-date
    sections (Today, Yesterday, This Week, Last 30 Days, then months of the current year,
    then years), each with its activity count and the UTC range to fetch it lazily with.
    Sections are computed in the caller's local calendar (Thrive.TTW.TicketHolder.Dtos.ContactHistoryBucketsInput.UtcOffsetMinutes)
    and clipped to the request's date range; empty sections are omitted.
     * @param utcOffsetMinutes (optional) 
     * @param filter (optional) 
     * @param ticketHolderId (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param cursorCreationTime (optional) 
     * @param cursorId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getContactHistoryBucketsForCurrentLogin(utcOffsetMinutes?: number | undefined, filter?: string | null | undefined, ticketHolderId?: number | null | undefined, contactType?: ContactType | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, cursorCreationTime?: DateTime | null | undefined, cursorId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<ContactHistoryBucketDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetContactHistoryBucketsForCurrentLogin?";
        if (utcOffsetMinutes === null)
            throw new Error("The parameter 'utcOffsetMinutes' cannot be null.");
        else if (utcOffsetMinutes !== undefined)
            url_ += "UtcOffsetMinutes=" + encodeURIComponent("" + utcOffsetMinutes) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketHolderId !== undefined && ticketHolderId !== null)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (cursorCreationTime !== undefined && cursorCreationTime !== null)
            url_ += "CursorCreationTime=" + encodeURIComponent(cursorCreationTime ? "" + cursorCreationTime.toString() : "") + "&";
        if (cursorId !== undefined && cursorId !== null)
            url_ += "CursorId=" + encodeURIComponent("" + cursorId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactHistoryBucketsForCurrentLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactHistoryBucketsForCurrentLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactHistoryBucketDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactHistoryBucketDto[]>;
        }));
    }

    protected processGetContactHistoryBucketsForCurrentLogin(response: HttpResponseBase): Observable<ContactHistoryBucketDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactHistoryBucketDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * To check phone number is already exist or not.
     * @param number (optional) 
     * @return OK
     */
    isPhoneNumberExist(number?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/IsPhoneNumberExist?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPhoneNumberExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPhoneNumberExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPhoneNumberExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * SSA office Information.
     * @param body (optional) 
     * @return OK
     */
    insertTicketHolderSSAInfo(body?: TicketHolderSSOOfficeRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/InsertTicketHolderSSAInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertTicketHolderSSAInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertTicketHolderSSAInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertTicketHolderSSAInfo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTicketHolderSSAInfo(body?: TicketHolderSSOOfficeRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTicketHolderSSAInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderSSAInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderSSAInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTicketHolderSSAInfo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteTicketHolderSSAOffice(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteTicketHolderSSAOffice?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTicketHolderSSAOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTicketHolderSSAOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTicketHolderSSAOffice(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllTicketHolderSSAOffices(ticketHolderId: number): Observable<TicketHolderSSAOfficeAIInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllTicketHolderSSAOffices?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTicketHolderSSAOffices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTicketHolderSSAOffices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderSSAOfficeAIInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderSSAOfficeAIInfoDto[]>;
        }));
    }

    protected processGetAllTicketHolderSSAOffices(response: HttpResponseBase): Observable<TicketHolderSSAOfficeAIInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderSSAOfficeAIInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    findTHSSAOfficeUsingAI(ticketHolderId: number, address: string | null): Observable<TicketHolderSSAOfficeAIInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/FindTHSSAOfficeUsingAI?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (address === undefined)
            throw new Error("The parameter 'address' must be defined.");
        else if(address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindTHSSAOfficeUsingAI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindTHSSAOfficeUsingAI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderSSAOfficeAIInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderSSAOfficeAIInfoDto[]>;
        }));
    }

    protected processFindTHSSAOfficeUsingAI(response: HttpResponseBase): Observable<TicketHolderSSAOfficeAIInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderSSAOfficeAIInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTicketHolderSSALocationInfo(ticketHolderId: number): Observable<TicketHolderSSAOfficeAIInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketHolderSSALocationInfo?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderSSALocationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderSSALocationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderSSAOfficeAIInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderSSAOfficeAIInfoDto>;
        }));
    }

    protected processGetTicketHolderSSALocationInfo(response: HttpResponseBase): Observable<TicketHolderSSAOfficeAIInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderSSAOfficeAIInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    uploadPaystubs(ticketHolderId: number, body?: UploadFileOutputDto | undefined): Observable<UploadPaystubsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UploadPaystubs?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPaystubs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPaystubs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadPaystubsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadPaystubsResultDto>;
        }));
    }

    protected processUploadPaystubs(response: HttpResponseBase): Observable<UploadPaystubsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadPaystubsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Wage Report ProcessingQ
     * @param body (optional) 
     * @return OK
     */
    getProcessingPaystubsByTicketHolderId(body?: WageReportProcessingQRequestDto | undefined): Observable<PagedResultDtoOfWageReportProcessingQDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetProcessingPaystubsByTicketHolderId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessingPaystubsByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessingPaystubsByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWageReportProcessingQDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWageReportProcessingQDto>;
        }));
    }

    protected processGetProcessingPaystubsByTicketHolderId(response: HttpResponseBase): Observable<PagedResultDtoOfWageReportProcessingQDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWageReportProcessingQDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Lets a Career Coach delete a paystub they uploaded from the Ticket Holder page while it
    hasn't been fully processed yet (status Pending or InProgress). Cleans up everything the
    upload/auto-promote created: the pay history rows tied to it, the Document library copy,
    the pending-review file, and the processing queue entry. A Completed or already-Removed
    paystub can't be deleted here.
     * @return OK
     */
    deleteUploadedPaystub(wageReportProcessingQId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteUploadedPaystub?";
        if (wageReportProcessingQId === undefined || wageReportProcessingQId === null)
            throw new Error("The parameter 'wageReportProcessingQId' must be defined and cannot be null.");
        else
            url_ += "wageReportProcessingQId=" + encodeURIComponent("" + wageReportProcessingQId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUploadedPaystub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUploadedPaystub(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUploadedPaystub(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes (soft-deletes) a single pay history record from the Ticket Holder's Pay History tab.
    The source paystub document is kept: it stays in the Documents library and other pay history
    rows may have been extracted from the same document.
     * @return OK
     */
    deletePayHistory(payHistoryId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeletePayHistory?";
        if (payHistoryId === undefined || payHistoryId === null)
            throw new Error("The parameter 'payHistoryId' must be defined and cannot be null.");
        else
            url_ += "payHistoryId=" + encodeURIComponent("" + payHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeletePayHistory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get pay stub file by id.
     * @return OK
     */
    getPaystubFile(id: number): Observable<DocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetPaystubFile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaystubFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaystubFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponseDto>;
        }));
    }

    protected processGetPaystubFile(response: HttpResponseBase): Observable<DocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paginated and sorted list of pay history records for a specific ticket holder.
     * @param ticketHolderId (optional) 
     * @param wageReportProcessingQId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPayHistoryByTicketHolderId(ticketHolderId?: number | undefined, wageReportProcessingQId?: number | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<TicketHolderPayHistoryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllPayHistoryByTicketHolderId?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (wageReportProcessingQId !== undefined && wageReportProcessingQId !== null)
            url_ += "WageReportProcessingQId=" + encodeURIComponent("" + wageReportProcessingQId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayHistoryByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayHistoryByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderPayHistoryResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderPayHistoryResultDto>;
        }));
    }

    protected processGetAllPayHistoryByTicketHolderId(response: HttpResponseBase): Observable<TicketHolderPayHistoryResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderPayHistoryResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Builds the "Pay History Overview" tab: per employer, finds the pay pattern from the paystubs
    (Thrive.TTW.TicketHolder.PayScheduleDetector), flags expected pay dates with no paystub as missing and
    predicts the next paystub; per year, totals recorded gross
    earnings and pairs them with the SSA reference thresholds (TWL/SGA, 1619(b), SSI FBR)
    so a counselor can see at a glance whether reported earnings are pushing past a
    work-incentive boundary.
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getPayHistoryOverview(ticketHolderId?: number | undefined): Observable<PayHistoryOverviewResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetPayHistoryOverview?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayHistoryOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayHistoryOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayHistoryOverviewResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayHistoryOverviewResultDto>;
        }));
    }

    protected processGetPayHistoryOverview(response: HttpResponseBase): Observable<PayHistoryOverviewResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayHistoryOverviewResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Insert Wage Data Search Request
     * @param body (optional) 
     * @return OK
     */
    insertWageDataSearchRequest(body?: TicketHolderWageDataSearchRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/InsertWageDataSearchRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertWageDataSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertWageDataSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertWageDataSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get TicketHolder Employer name and ids.
     * @return OK
     */
    getEmployerIdAndNameByTicketHolderId(ticketHolderId: number): Observable<TicketHolderEmployerIdAndNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetEmployerIdAndNameByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerIdAndNameByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerIdAndNameByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderEmployerIdAndNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderEmployerIdAndNameDto[]>;
        }));
    }

    protected processGetEmployerIdAndNameByTicketHolderId(response: HttpResponseBase): Observable<TicketHolderEmployerIdAndNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TicketHolderEmployerIdAndNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get all wage data search request.
     * @param body (optional) 
     * @return OK
     */
    getAllWageDataSearchRequest(body?: TicketHolderWageDataSearchRequestFilterDto | undefined): Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllWageDataSearchRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWageDataSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWageDataSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto>;
        }));
    }

    protected processGetAllWageDataSearchRequest(response: HttpResponseBase): Observable<PagedResultDtoOfTicketHolderWageDataSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTicketHolderWageDataSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Wage Data Search Request
     * @param body (optional) 
     * @return OK
     */
    updateWageDataSearchRequest(body?: UpdateTicketHolderWageDataSearchRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateWageDataSearchRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWageDataSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWageDataSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateWageDataSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Wage Data Search Request
     * @return OK
     */
    deleteWageDataSearchRequest(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteWageDataSearchRequest?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWageDataSearchRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWageDataSearchRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteWageDataSearchRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * create bpqy request.
     * @param body (optional) 
     * @return OK
     */
    createBPQYRequest(body?: CreateBpqyRequestDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CreateBPQYRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBPQYRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBPQYRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBPQYRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get bpqy info by ticketHolderId
     * @return OK
     */
    getBPQYRequestByTicketHolderId(ticketHolderId: number): Observable<BpqyRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetBPQYRequestByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBPQYRequestByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBPQYRequestByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BpqyRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BpqyRequestDto>;
        }));
    }

    protected processGetBPQYRequestByTicketHolderId(response: HttpResponseBase): Observable<BpqyRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BpqyRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete nBpqy outgoing concent mail by documentId.
     * @return OK
     */
    deleteBPQYOutgoingConsentMailDocument(bpqyId: number, documentId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteBPQYOutgoingConsentMailDocument?";
        if (bpqyId === undefined || bpqyId === null)
            throw new Error("The parameter 'bpqyId' must be defined and cannot be null.");
        else
            url_ += "bpqyId=" + encodeURIComponent("" + bpqyId) + "&";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined and cannot be null.");
        else
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBPQYOutgoingConsentMailDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBPQYOutgoingConsentMailDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBPQYOutgoingConsentMailDocument(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendConsentToTicketHolder(bpqyRequestId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/SendConsentToTicketHolder?";
        if (bpqyRequestId === undefined || bpqyRequestId === null)
            throw new Error("The parameter 'bpqyRequestId' must be defined and cannot be null.");
        else
            url_ += "bpqyRequestId=" + encodeURIComponent("" + bpqyRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConsentToTicketHolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConsentToTicketHolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendConsentToTicketHolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bpqyRequestId (optional) 
     * @param body (optional) 
     * @return OK
     */
    uploadSignedConsent(bpqyRequestId?: number | undefined, body?: UploadFileOutputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UploadSignedConsent?";
        if (bpqyRequestId === null)
            throw new Error("The parameter 'bpqyRequestId' cannot be null.");
        else if (bpqyRequestId !== undefined)
            url_ += "bpqyRequestId=" + encodeURIComponent("" + bpqyRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSignedConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSignedConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadSignedConsent(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Prepare fax and send fax to ssa and also add in faxHistory.
     * @param bpqyRequestId (optional) 
     * @param body (optional) 
     * @return OK
     */
    prepareFaxPackage(bpqyRequestId?: number | undefined, body?: PrepareFaxDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/PrepareFaxPackage?";
        if (bpqyRequestId === null)
            throw new Error("The parameter 'bpqyRequestId' cannot be null.");
        else if (bpqyRequestId !== undefined)
            url_ += "bpqyRequestId=" + encodeURIComponent("" + bpqyRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareFaxPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareFaxPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPrepareFaxPackage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param faxHistoryId (optional) 
     * @return OK
     */
    sendFaxPackageTOSSAOffice(bpqyId: number, faxHistoryId?: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/SendFaxPackageTOSSAOffice?";
        if (bpqyId === undefined || bpqyId === null)
            throw new Error("The parameter 'bpqyId' must be defined and cannot be null.");
        else
            url_ += "bpqyId=" + encodeURIComponent("" + bpqyId) + "&";
        if (faxHistoryId !== undefined && faxHistoryId !== null)
            url_ += "faxHistoryId=" + encodeURIComponent("" + faxHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFaxPackageTOSSAOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFaxPackageTOSSAOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendFaxPackageTOSSAOffice(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all faxAttempt hostory by
     * @param bpqyRequestId (optional) 
     * @return OK
     */
    getFaxAttempts(bpqyRequestId?: number | undefined): Observable<BpqyFaxAttemptResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetFaxAttempts?";
        if (bpqyRequestId === null)
            throw new Error("The parameter 'bpqyRequestId' cannot be null.");
        else if (bpqyRequestId !== undefined)
            url_ += "bpqyRequestId=" + encodeURIComponent("" + bpqyRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BpqyFaxAttemptResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BpqyFaxAttemptResultDto>;
        }));
    }

    protected processGetFaxAttempts(response: HttpResponseBase): Observable<BpqyFaxAttemptResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BpqyFaxAttemptResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get fax attemp details by fax history id
     * @param faxHistoryId (optional) 
     * @return OK
     */
    getFaxAttemptDetails(faxHistoryId?: number | undefined): Observable<BpqyFaxAttemptDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetFaxAttemptDetails?";
        if (faxHistoryId === null)
            throw new Error("The parameter 'faxHistoryId' cannot be null.");
        else if (faxHistoryId !== undefined)
            url_ += "faxHistoryId=" + encodeURIComponent("" + faxHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxAttemptDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxAttemptDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BpqyFaxAttemptDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BpqyFaxAttemptDetailDto>;
        }));
    }

    protected processGetFaxAttemptDetails(response: HttpResponseBase): Observable<BpqyFaxAttemptDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BpqyFaxAttemptDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a generated fax package document from a fax attempt so it can be regenerated.
    Only allowed before the fax has actually been sent.
     * @return OK
     */
    deleteFaxPackageDocument(faxHistoryId: number, documentId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/DeleteFaxPackageDocument?";
        if (faxHistoryId === undefined || faxHistoryId === null)
            throw new Error("The parameter 'faxHistoryId' must be defined and cannot be null.");
        else
            url_ += "faxHistoryId=" + encodeURIComponent("" + faxHistoryId) + "&";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined and cannot be null.");
        else
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFaxPackageDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFaxPackageDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFaxPackageDocument(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * BPQY Recieved from SSA
     * @param body (optional) 
     * @return OK
     */
    bpqyReceivedFromSSA(body?: BpQyRecievedSSAUpload | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/BpqyReceivedFromSSA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBpqyReceivedFromSSA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBpqyReceivedFromSSA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBpqyReceivedFromSSA(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends an uploaded BPQY PDF/image to the configured AI provider and asks it to extract
    structured benefit/medical-insurance data for review before saving. Standalone from
    the formal BPQY request workflow -- for a BPQY the coach already has in hand. Doesn't
    persist the uploaded file anywhere; the temp upload is discarded after extraction.
     * @param body (optional) 
     * @return OK
     */
    extractBpqyData(body?: UploadFileOutputDto | undefined): Observable<BpqyExtractDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/ExtractBpqyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtractBpqyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtractBpqyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BpqyExtractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BpqyExtractDto>;
        }));
    }

    protected processExtractBpqyData(response: HttpResponseBase): Observable<BpqyExtractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BpqyExtractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Complete BPQYRequest step.
     * @param body (optional) 
     * @return OK
     */
    completeStepBPQYRequest(body?: BpqyCompleteStep | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/CompleteStepBPQYRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteStepBPQYRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteStepBPQYRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCompleteStepBPQYRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Bpqy Info With Steps By TicketHolderId
     * @return OK
     */
    getBpqyInfoWithStepsByTicketHolderId(ticketHolderId: number): Observable<BpqyInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetBpqyInfoWithStepsByTicketHolderId?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBpqyInfoWithStepsByTicketHolderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBpqyInfoWithStepsByTicketHolderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BpqyInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BpqyInfoDto>;
        }));
    }

    protected processGetBpqyInfoWithStepsByTicketHolderId(response: HttpResponseBase): Observable<BpqyInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BpqyInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateTicketHolderShortNoteByTHId(body?: UpdateTHShortNotesRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/UpdateTicketHolderShortNoteByTHId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTicketHolderShortNoteByTHId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTicketHolderShortNoteByTHId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTicketHolderShortNoteByTHId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllPendingBPQY(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfBPQYListDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetAllPendingBPQY?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPendingBPQY(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPendingBPQY(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBPQYListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBPQYListDto>;
        }));
    }

    protected processGetAllPendingBPQY(response: HttpResponseBase): Observable<PagedResultDtoOfBPQYListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBPQYListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the sender (Employment Network, from ENSettings) and receiver (Ticket Holder's
    Local SSA Office) fax contact info used to prefill the "Send Selected Paystubs To SSA"
    confirmation dialog.
     * @return OK
     */
    getPaystubFaxContactInfo(ticketHolderId: number): Observable<PaystubFaxContactInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetPaystubFaxContactInfo?";
        if (ticketHolderId === undefined || ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' must be defined and cannot be null.");
        else
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaystubFaxContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaystubFaxContactInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaystubFaxContactInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaystubFaxContactInfoDto>;
        }));
    }

    protected processGetPaystubFaxContactInfo(response: HttpResponseBase): Observable<PaystubFaxContactInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaystubFaxContactInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a fax cover sheet and merges it with the selected Pay History paystub
    documents into a single PDF, saved to the document library. This lets the Career
    Coach preview the exact fax packet before M:Thrive.TTW.TicketHolder.TicketHolderService.SendPreparedPaystubFaxAsync(Thrive.TTW.Billing.Dto.SendPreparedPaystubFaxDto)
    actually sends it.
     * @param body (optional) 
     * @return OK
     */
    preparePaystubFaxPackage(body?: SendPaystubsToSSAFaxDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/PreparePaystubFaxPackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreparePaystubFaxPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreparePaystubFaxPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPreparePaystubFaxPackage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Faxes a previously-prepared paystub fax packet (see
    M:Thrive.TTW.TicketHolder.TicketHolderService.PreparePaystubFaxPackageAsync(Thrive.TTW.Billing.Dto.SendPaystubsToSSAFaxDto)) to the Ticket Holder's Local SSA Office,
    once the Career Coach has reviewed and confirmed it.
     * @param body (optional) 
     * @return OK
     */
    sendPreparedPaystubFax(body?: SendPreparedPaystubFaxDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/SendPreparedPaystubFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPreparedPaystubFax(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPreparedPaystubFax(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendPreparedPaystubFax(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getTicketToWork(ticketHolderId?: number | undefined): Observable<TicketToWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/GetTicketToWork?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketToWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketToWork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketToWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketToWorkDto>;
        }));
    }

    protected processGetTicketToWork(response: HttpResponseBase): Observable<TicketToWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketToWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveTicketToWork(body?: TicketToWorkDto | undefined): Observable<TicketToWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/TicketHolderService/SaveTicketToWork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTicketToWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTicketToWork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketToWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketToWorkDto>;
        }));
    }

    protected processSaveTicketToWork(response: HttpResponseBase): Observable<TicketToWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketToWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return OK
     */
    getTimezones(defaultTimezoneScope?: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return OK
     */
    getTimezoneComboboxItems(selectedTimezoneId?: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns only U.S. time zones (Eastern, Central, Mountain, Pacific, Alaska, Hawaii),
    with the default time zone added as the first entry (like GetTimezones).
     * @param defaultTimezoneScope (optional) 
     * @return OK
     */
    getUSATimeZones(defaultTimezoneScope?: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetUSATimeZones?";
        if (defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSATimeZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSATimeZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetUSATimeZones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns only U.S. time zones formatted for UI combobox (dropdown),
    with the default time zone as the first entry and selected item highlighted.
     * @param selectedTimezoneId (optional) 
     * @return OK
     */
    getUSATimezoneComboboxItems(selectedTimezoneId?: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetUSATimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSATimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSATimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetUSATimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns U.S. time zones only.
    Optionally marks a selected time zone.
     * @param selectedTimeZone (optional) 
     * @return OK
     */
    getUSATimeZonesWithSelectedTimeZone(selectedTimeZone?: string | null | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetUSATimeZonesWithSelectedTimeZone?";
        if (selectedTimeZone !== undefined && selectedTimeZone !== null)
            url_ += "selectedTimeZone=" + encodeURIComponent("" + selectedTimeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSATimeZonesWithSelectedTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSATimeZonesWithSelectedTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetUSATimeZonesWithSelectedTimeZone(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns U.S. time zones as Combobox items.
    Selected time zone will be marked.
     * @param selectedTimeZone (optional) 
     * @return OK
     */
    getUSATimezoneComboboxItemsWithSelectedTimeZone(selectedTimeZone?: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetUSATimezoneComboboxItemsWithSelectedTimeZone?";
        if (selectedTimeZone !== undefined && selectedTimeZone !== null)
            url_ += "selectedTimeZone=" + encodeURIComponent("" + selectedTimeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSATimezoneComboboxItemsWithSelectedTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSATimezoneComboboxItemsWithSelectedTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetUSATimezoneComboboxItemsWithSelectedTimeZone(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticate(body?: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    passwordlessAuthenticate(body?: PasswordlessAuthenticateModel | undefined): Observable<PasswordlessAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/PasswordlessAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPasswordlessAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPasswordlessAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PasswordlessAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PasswordlessAuthenticateResultModel>;
        }));
    }

    protected processPasswordlessAuthenticate(response: HttpResponseBase): Observable<PasswordlessAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordlessAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return OK
     */
    refreshToken(refreshToken?: string | null | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendTwoFactorAuthCode(body?: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return OK
     */
    impersonatedAuthenticate(impersonationToken?: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return OK
     */
    delegatedImpersonatedAuthenticate(userDelegationId?: number | undefined, impersonationToken?: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param signInToken (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    signInWithToken(signInToken?: string | null | undefined, userId?: number | undefined, tenantId?: number | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/SignInWithToken?";
        if (signInToken !== undefined && signInToken !== null)
            url_ += "signInToken=" + encodeURIComponent("" + signInToken) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignInWithToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignInWithToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processSignInWithToken(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return OK
     */
    linkedAccountAuthenticate(switchAccountToken?: string | null | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined && switchAccountToken !== null)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    externalAuthenticate(body?: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return OK
     */
    testNotification(message?: string | null | undefined, severity?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined && severity !== null)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientAppointmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get TicketHolder Followup
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param selectedStatuses (optional) 
     * @param isUpcoming (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getMyAppointments(startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, selectedStatuses?: CalendarEventStatus[] | null | undefined, isUpcoming?: boolean | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTHFollowupDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientAppointment/GetMyAppointments?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (selectedStatuses !== undefined && selectedStatuses !== null)
            selectedStatuses && selectedStatuses.forEach(item => { url_ += "SelectedStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (isUpcoming !== undefined && isUpcoming !== null)
            url_ += "IsUpcoming=" + encodeURIComponent("" + isUpcoming) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAppointments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHFollowupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHFollowupDto>;
        }));
    }

    protected processGetMyAppointments(response: HttpResponseBase): Observable<PagedResultDtoOfTHFollowupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHFollowupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a calendar appointment (CalendarEvent) belonging to the current Ticket Holder.
    Ensures the appointment exists and belongs to the logged-in user before deletion.
     * @param id (optional) The ID of the appointment to delete.
     * @return OK
     */
    deleteAppointment(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientAppointment/DeleteAppointment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAppointment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a calendar interview schedule for a ticket holder and the current user.
    This includes creating a calendar event via Graph API, sending a notification, and saving the event locally.
     * @param body (optional) The input containing interview schedule details such as title, description, start time, and ticket holder ID.
     * @return OK
     * @deprecated
     */
    createInterviewSchedule(body?: THCreateInterviewSchedule | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientAppointment/CreateInterviewSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInterviewSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInterviewSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateInterviewSchedule(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a reminder calendar event for a ticket holder and the current user.
    This involves creating a calendar event via Microsoft Graph API, scheduling a notification job,
    and storing the event details in the local database.
     * @param body (optional) The reminder details including client ID, ticket holder ID, title, description, and start time.
     * @return OK
     */
    createReminder(body?: THCreateReminderDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientAppointment/CreateReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReminder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a meeting event between a Ticket Holder (TH) and their assigned Career Coach.  
    The method performs the following steps:
    1. Retrieves the current Ticket Holder, Career Coach (assignee), and logged-in user.
    2. Builds a Thrive.TTW.Communication.Dtos.CreateCalendarEventDto with the provided meeting details.
    3. Sends a request to Microsoft Graph API to create the calendar event and retrieves the external event ID.
    4. Creates and schedules a background notification job to notify attendees.
    5. Persists the event details in the Thrive.TTW.Communication.CalendarEvent repository for local tracking.
    Returns `true` if the meeting creation process completes successfully.
     * @param body (optional) 
     * @return OK
     */
    createMeetingWithCareerCoach(body?: THMeetingWithCareerCoachDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientAppointment/CreateMeetingWithCareerCoach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMeetingWithCareerCoach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMeetingWithCareerCoach(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateMeetingWithCareerCoach(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientCommunicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves chat messages exchanged between the currently logged-in user and the specified target user,
    with optional filtering based on a minimum message ID for pagination purposes.
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getCareerCoachChatMessages(tenantId?: number | null | undefined, userId?: number | undefined, minMessageId?: number | null | undefined, maxResultCount?: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetCareerCoachChatMessages?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined && minMessageId !== null)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerCoachChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerCoachChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetCareerCoachChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the career coach information assigned to the currently logged-in ticket holder.
    Returns a blank Thrive.TTWClient.Communication.dto.CareerCoachInfoDto if no data is found.
     * @return OK
     */
    getCareerCoachInformations(): Observable<CareerCoachInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetCareerCoachInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerCoachInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerCoachInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerCoachInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerCoachInfoDto>;
        }));
    }

    protected processGetCareerCoachInformations(response: HttpResponseBase): Observable<CareerCoachInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareerCoachInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a paginated list of ticket holder contact history based on the provided filter.
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllContactHistories(contactType?: ContactType | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTHContactHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetAllContactHistories?";
        if (contactType === null)
            throw new Error("The parameter 'contactType' cannot be null.");
        else if (contactType !== undefined)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHContactHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHContactHistoryDto>;
        }));
    }

    protected processGetAllContactHistories(response: HttpResponseBase): Observable<PagedResultDtoOfTHContactHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHContactHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initial call of contact hostory list.
     * @param year (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getInitialContactHistories(year?: number | null | undefined, contactType?: ContactType[] | null | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<ContactHistoryInitialDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetInitialContactHistories?";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (contactType !== undefined && contactType !== null)
            contactType && contactType.forEach(item => { url_ += "ContactType=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitialContactHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitialContactHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactHistoryInitialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactHistoryInitialDto>;
        }));
    }

    protected processGetInitialContactHistories(response: HttpResponseBase): Observable<ContactHistoryInitialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactHistoryInitialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get contact history by months, used for scroll to get the below information.
     * @param year (optional) 
     * @param month (optional) 
     * @param lastRecordDate (optional) 
     * @param contactType (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getContactHistoriesByMonth(year?: number | undefined, month?: number | undefined, lastRecordDate?: DateTime | null | undefined, contactType?: ContactType[] | null | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined): Observable<MonthPagedResultDtoOfTHContactHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetContactHistoriesByMonth?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (lastRecordDate !== undefined && lastRecordDate !== null)
            url_ += "LastRecordDate=" + encodeURIComponent(lastRecordDate ? "" + lastRecordDate.toString() : "") + "&";
        if (contactType !== undefined && contactType !== null)
            contactType && contactType.forEach(item => { url_ += "ContactType=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactHistoriesByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactHistoriesByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthPagedResultDtoOfTHContactHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthPagedResultDtoOfTHContactHistoryDto>;
        }));
    }

    protected processGetContactHistoriesByMonth(response: HttpResponseBase): Observable<MonthPagedResultDtoOfTHContactHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthPagedResultDtoOfTHContactHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Email Log By LogId
     * @return OK
     */
    getEmailLogDetailById(id: number): Observable<THEmailLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetEmailLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THEmailLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THEmailLogDetailDto>;
        }));
    }

    protected processGetEmailLogDetailById(response: HttpResponseBase): Observable<THEmailLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THEmailLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Mail Log By LogId
     * @return OK
     */
    getMailLogDetailById(id: number): Observable<THMailLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetMailLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THMailLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THMailLogDetailDto>;
        }));
    }

    protected processGetMailLogDetailById(response: HttpResponseBase): Observable<THMailLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THMailLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Fax Log By LogId
     * @return OK
     */
    getFaxLogDetailById(id: number): Observable<THFaxLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetFaxLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaxLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaxLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THFaxLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THFaxLogDetailDto>;
        }));
    }

    protected processGetFaxLogDetailById(response: HttpResponseBase): Observable<THFaxLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THFaxLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Phone Log By LogId
     * @return OK
     */
    getPhoneLogDetailById(id: number): Observable<THPhoneLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetPhoneLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhoneLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhoneLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THPhoneLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THPhoneLogDetailDto>;
        }));
    }

    protected processGetPhoneLogDetailById(response: HttpResponseBase): Observable<THPhoneLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THPhoneLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get chat log by logid
     * @return OK
     */
    getChatLogDetailById(id: number): Observable<ChatLogDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCommunication/GetChatLogDetailById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChatLogDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChatLogDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatLogDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatLogDetailDto>;
        }));
    }

    protected processGetChatLogDetailById(response: HttpResponseBase): Observable<ChatLogDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatLogDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientCredentialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds a new external login record for a Ticket Holder.
     * @param body (optional) 
     * @return OK
     */
    addNewLogin(body?: CreateLoginDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCredential/AddNewLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddNewLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing external login record.
     * @param body (optional) 
     * @return OK
     */
    updateLogin(body?: LoginDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCredential/UpdateLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a specific external login by its ID.
     * @return OK
     */
    getLoginById(id: number): Observable<LoginDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCredential/GetLoginById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginDto>;
        }));
    }

    protected processGetLoginById(response: HttpResponseBase): Observable<LoginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Lists all external logins for a Ticket Holder.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getMyLogins(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfLoginDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCredential/GetMyLogins?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLogins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLogins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLoginDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLoginDto>;
        }));
    }

    protected processGetMyLogins(response: HttpResponseBase): Observable<PagedResultDtoOfLoginDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLoginDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a specific external login.
     * @return OK
     */
    deleteLoginById(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCredential/DeleteLoginById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLoginById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLoginById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteLoginById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the two-factor authentication (2FA) setting for a specific login entry.
     * @param body (optional) The DTO containing the login ID and the desired 2FA enabled state.
     * @return OK
     */
    updateTwoFactorEnabled(body?: TwoFactorEnabledDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientCredential/UpdateTwoFactorEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTwoFactorEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTwoFactorEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTwoFactorEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Add a new document for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    addDocument(body?: THInputDocumentDto | undefined): Observable<THDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientDocument/AddDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THDocumentDto>;
        }));
    }

    protected processAddDocument(response: HttpResponseBase): Observable<THDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve paged documents associated with a specific ticket holder, based on filter criteria.
     * @param documentTypes (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getMyDocuments(documentTypes?: TicketHolderDocumentType[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTHDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientDocument/GetMyDocuments?";
        if (documentTypes !== undefined && documentTypes !== null)
            documentTypes && documentTypes.forEach(item => { url_ += "DocumentTypes=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHDocumentDto>;
        }));
    }

    protected processGetMyDocuments(response: HttpResponseBase): Observable<PagedResultDtoOfTHDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete document uploaded for the ticket holder
     * @param documentId (optional) 
     * @return OK
     */
    deleteDocument(documentId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientDocument/DeleteDocument?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the file of one of the ticket holder's own documents (Base64 with name, type and size).
     * @param documentId (optional) 
     * @return OK
     */
    getMyDocumentFile(documentId?: number | undefined): Observable<THDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientDocument/GetMyDocumentFile?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THDocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THDocumentResponseDto>;
        }));
    }

    protected processGetMyDocumentFile(response: HttpResponseBase): Observable<THDocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THDocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientJobLeadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a paginated and sorted list of all job leads.
    Maps the result to Thrive.TTWClient.Job.dto.THJobLeadDto for editing purposes.
     * @param filterText (optional) 
     * @param workArrangement (optional) 
     * @param postedStartDate (optional) 
     * @param postedEndDate (optional) 
     * @param appliedStartDate (optional) 
     * @param appliedEndDate (optional) 
     * @param statuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllMyJobLead(filterText?: string | null | undefined, workArrangement?: WorkArrangement[] | null | undefined, postedStartDate?: DateTime | null | undefined, postedEndDate?: DateTime | null | undefined, appliedStartDate?: DateTime | null | undefined, appliedEndDate?: DateTime | null | undefined, statuses?: JobApplicationStatus[] | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTHJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetAllMyJobLead?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (workArrangement !== undefined && workArrangement !== null)
            workArrangement && workArrangement.forEach(item => { url_ += "WorkArrangement=" + encodeURIComponent("" + item) + "&"; });
        if (postedStartDate !== undefined && postedStartDate !== null)
            url_ += "PostedStartDate=" + encodeURIComponent(postedStartDate ? "" + postedStartDate.toString() : "") + "&";
        if (postedEndDate !== undefined && postedEndDate !== null)
            url_ += "PostedEndDate=" + encodeURIComponent(postedEndDate ? "" + postedEndDate.toString() : "") + "&";
        if (appliedStartDate !== undefined && appliedStartDate !== null)
            url_ += "AppliedStartDate=" + encodeURIComponent(appliedStartDate ? "" + appliedStartDate.toString() : "") + "&";
        if (appliedEndDate !== undefined && appliedEndDate !== null)
            url_ += "AppliedEndDate=" + encodeURIComponent(appliedEndDate ? "" + appliedEndDate.toString() : "") + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMyJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMyJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHJobLeadDto>;
        }));
    }

    protected processGetAllMyJobLead(response: HttpResponseBase): Observable<PagedResultDtoOfTHJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a job lead record by its unique identifier and maps it to an update DTO.
     * @param id The unique identifier of the job lead to retrieve. Must be greater than zero.
     * @return OK
     */
    getJobLeadById(id: number): Observable<THJobLeadDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetJobLeadById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLeadById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLeadById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobLeadDto>;
        }));
    }

    protected processGetJobLeadById(response: HttpResponseBase): Observable<THJobLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THJobLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Job Lead status to the specified status
     * @param body (optional) 
     * @return OK
     */
    updateJobLeadStatus(body?: UpdateJobLeadStatusAsync | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/UpdateJobLeadStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobLeadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobLeadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateJobLeadStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Requests the Career Coach to apply for a job on behalf of the ticket holder.
    Updates the job activity status and job lead status to reflect the request.
     * @return OK
     */
    askCareerCoachToApplyJob(jobLeadId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/AskCareerCoachToApplyJob?";
        if (jobLeadId === undefined || jobLeadId === null)
            throw new Error("The parameter 'jobLeadId' must be defined and cannot be null.");
        else
            url_ += "jobLeadId=" + encodeURIComponent("" + jobLeadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskCareerCoachToApplyJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskCareerCoachToApplyJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAskCareerCoachToApplyJob(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get history of a job activities, mainly status change history
     * @param jobLeadId (optional) 
     * @return OK
     */
    getJobActivityHistoryByJobLeadId(jobLeadId?: number | undefined): Observable<THJobActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetJobActivityHistoryByJobLeadId?";
        if (jobLeadId === null)
            throw new Error("The parameter 'jobLeadId' cannot be null.");
        else if (jobLeadId !== undefined)
            url_ += "jobLeadId=" + encodeURIComponent("" + jobLeadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobActivityHistoryByJobLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobActivityHistoryByJobLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobActivityDto[]>;
        }));
    }

    protected processGetJobActivityHistoryByJobLeadId(response: HttpResponseBase): Observable<THJobActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(THJobActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new job interview for the current Ticket Holder, including optional sessions.
     * @param body (optional) The interview data to create.
     * @return OK
     */
    createJobInterviewForTH(body?: THCreateOrUpdateJobInterviewDto | undefined): Observable<THJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/CreateJobInterviewForTH";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobInterviewForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobInterviewForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobInterviewDto>;
        }));
    }

    protected processCreateJobInterviewForTH(response: HttpResponseBase): Observable<THJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing job interview for the current Ticket Holder, including session updates.
     * @param body (optional) The interview data to update.
     * @return OK
     */
    updateJobInterviewForTH(body?: THCreateOrUpdateJobInterviewDto | undefined): Observable<THJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/UpdateJobInterviewForTH";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobInterviewForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobInterviewForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobInterviewDto>;
        }));
    }

    protected processUpdateJobInterviewForTH(response: HttpResponseBase): Observable<THJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a job interview and its sessions for the current Ticket Holder.
     * @param id (optional) 
     * @return OK
     */
    deleteJobInterviewForTH(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/DeleteJobInterviewForTH?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobInterviewForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobInterviewForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobInterviewForTH(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a job interview for the current Ticket Holder by Id.
     * @param id (optional) 
     * @return OK
     */
    getJobInterviewByJobLead(id?: number | undefined): Observable<THJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetJobInterviewByJobLead?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobInterviewByJobLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobInterviewByJobLead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobInterviewDto>;
        }));
    }

    protected processGetJobInterviewByJobLead(response: HttpResponseBase): Observable<THJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all job interviews for the current Ticket Holder with paging and sorting.
     * @param ticketHolderId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobInterviewsForTH(ticketHolderId?: number | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTHJobInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetAllJobInterviewsForTH?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "TicketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobInterviewsForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobInterviewsForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHJobInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHJobInterviewDto>;
        }));
    }

    protected processGetAllJobInterviewsForTH(response: HttpResponseBase): Observable<PagedResultDtoOfTHJobInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHJobInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new session to an existing job interview for the current Ticket Holder.
     * @param jobInterviewId (optional) The parent interview Id.
     * @param body (optional) The session data.
     * @return OK
     */
    addJobInterviewSessionForTH(jobInterviewId?: number | undefined, body?: THCreateOrUpdateJobInterviewSessionDto | undefined): Observable<THJobInterviewSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/AddJobInterviewSessionForTH?";
        if (jobInterviewId === null)
            throw new Error("The parameter 'jobInterviewId' cannot be null.");
        else if (jobInterviewId !== undefined)
            url_ += "jobInterviewId=" + encodeURIComponent("" + jobInterviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddJobInterviewSessionForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddJobInterviewSessionForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobInterviewSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobInterviewSessionDto>;
        }));
    }

    protected processAddJobInterviewSessionForTH(response: HttpResponseBase): Observable<THJobInterviewSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THJobInterviewSessionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing interview session for the current Ticket Holder.
     * @param body (optional) The session update data.
     * @return OK
     */
    updateJobInterviewSessionForTH(body?: THCreateOrUpdateJobInterviewSessionDto | undefined): Observable<THJobInterviewSessionDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/UpdateJobInterviewSessionForTH";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobInterviewSessionForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobInterviewSessionForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THJobInterviewSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THJobInterviewSessionDto>;
        }));
    }

    protected processUpdateJobInterviewSessionForTH(response: HttpResponseBase): Observable<THJobInterviewSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THJobInterviewSessionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an interview session for the current Ticket Holder.
     * @param id (optional) 
     * @return OK
     */
    deleteJobInterviewSessionForTH(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/DeleteJobInterviewSessionForTH?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobInterviewSessionForTH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobInterviewSessionForTH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobInterviewSessionForTH(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Groups job leads for the current Ticket Holder by their application status.
    Returns the count of each group (Pending Review by TH, Pending Apply by CC, Applied, Rejected, Archived).
     * @return OK
     */
    getJobLeadStatusGroup(): Observable<JobApplicationStatusGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetJobLeadStatusGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLeadStatusGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLeadStatusGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationStatusGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationStatusGroupDto>;
        }));
    }

    protected processGetJobLeadStatusGroup(response: HttpResponseBase): Observable<JobApplicationStatusGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobApplicationStatusGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param currentStatus (optional) 
     * @return OK
     */
    getAllowedJobsStatus(currentStatus?: CurrentStatus2 | undefined): Observable<AllowedJobStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientJobLead/GetAllowedJobsStatus?";
        if (currentStatus === null)
            throw new Error("The parameter 'currentStatus' cannot be null.");
        else if (currentStatus !== undefined)
            url_ += "currentStatus=" + encodeURIComponent("" + currentStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedJobsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedJobsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowedJobStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowedJobStatusDto[]>;
        }));
    }

    protected processGetAllowedJobsStatus(response: HttpResponseBase): Observable<AllowedJobStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllowedJobStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientPayHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get TicketHolder Specific Pay History
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllMyPayHistories(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTHOutputPayHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientPayHistory/GetAllMyPayHistories?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMyPayHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMyPayHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHOutputPayHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHOutputPayHistoryDto>;
        }));
    }

    protected processGetAllMyPayHistories(response: HttpResponseBase): Observable<PagedResultDtoOfTHOutputPayHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHOutputPayHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * ?How to upload with QR code
    Handles uploading one or more paystub files from the client,
    validates file types, saves each file to either Blob or local storage,
    creates corresponding document library entries,
    and enqueues them for wage report processing.
     * @param body (optional) 
     * @return OK
     */
    uploadPaystubs(body?: UploadFileOutputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientPayHistory/UploadPaystubs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPaystubs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPaystubs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadPaystubs(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the Processing Paystub uploaded files
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getProcessingPaystubs(sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTHWageReportProcessingQDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientPayHistory/GetProcessingPaystubs?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessingPaystubs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessingPaystubs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHWageReportProcessingQDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHWageReportProcessingQDto>;
        }));
    }

    protected processGetProcessingPaystubs(response: HttpResponseBase): Observable<PagedResultDtoOfTHWageReportProcessingQDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHWageReportProcessingQDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paystub file by its wage report processing queue ID, 
    reads its contents from disk, and returns it as a Base64-encoded 
    document with metadata such as file name, MIME type, size, and 
    uploader details.
     * @return OK
     */
    getPaystubFile(id: number): Observable<THDocumentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientPayHistory/GetPaystubFile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaystubFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaystubFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THDocumentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THDocumentResponseDto>;
        }));
    }

    protected processGetPaystubFile(response: HttpResponseBase): Observable<THDocumentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THDocumentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds a new phone number for a given ticketHolder if it does not already exist.
     * @param body (optional) The phone number to add.
     * @return OK
     */
    addTHPhoneNumber(body?: THNewPhoneDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/AddTHPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTHPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTHPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddTHPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves phone numbers for a specific TH, optionally filtered by phone type.
     * @param phoneType (optional) 
     * @return OK
     */
    getTHPhoneNumbers(phoneType?: PhoneType | undefined): Observable<THPhoneNumberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/GetTHPhoneNumbers?";
        if (phoneType === null)
            throw new Error("The parameter 'phoneType' cannot be null.");
        else if (phoneType !== undefined)
            url_ += "PhoneType=" + encodeURIComponent("" + phoneType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTHPhoneNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTHPhoneNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THPhoneNumberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THPhoneNumberDto[]>;
        }));
    }

    protected processGetTHPhoneNumbers(response: HttpResponseBase): Observable<THPhoneNumberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(THPhoneNumberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing phone number record for the current ticket holder.
     * @param body (optional) The phone number DTO containing updated information.
     * @return OK
     */
    updateTHPhoneNumbers(body?: THPhoneNumberDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/UpdateTHPhoneNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTHPhoneNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTHPhoneNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTHPhoneNumbers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a Ticket Holder's phone number by ID.
     * @param id The ID of the phone number to delete. Must be greater than zero.
     * @return OK
     */
    deleteTHPhoneNumber(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/DeleteTHPhoneNumber?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTHPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTHPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTHPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new address record for the specified TicketHolder.
     * @param body (optional) The new address details to be associated with a TicketHolder.
     * @return OK
     */
    addTHAddress(body?: THNewAddressDto | undefined): Observable<THAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/AddTHAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTHAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTHAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THAddressDto>;
        }));
    }

    protected processAddTHAddress(response: HttpResponseBase): Observable<THAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all address records associated with the specified TicketHolder.
     * @param addressType (optional) 
     * @return OK
     */
    getTicketHolderAddress(addressType?: AddressType | undefined): Observable<THAddressDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/GetTicketHolderAddress?";
        if (addressType === null)
            throw new Error("The parameter 'addressType' cannot be null.");
        else if (addressType !== undefined)
            url_ += "AddressType=" + encodeURIComponent("" + addressType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTicketHolderAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketHolderAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THAddressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THAddressDto[]>;
        }));
    }

    protected processGetTicketHolderAddress(response: HttpResponseBase): Observable<THAddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(THAddressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing TicketHolder address with the provided data.
     * @param body (optional) The updated address data for a TicketHolder.
     * @return OK
     */
    updateTHAddress(body?: THAddressDto | undefined): Observable<THAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/UpdateTHAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTHAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTHAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THAddressDto>;
        }));
    }

    protected processUpdateTHAddress(response: HttpResponseBase): Observable<THAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the TicketHolder address with the specified ID.
     * @param id The ID of the address to delete.
     * @return OK
     */
    deleteTHAddress(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/DeleteTHAddress?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTHAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTHAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTHAddress(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the benefit details of the ticketHolder
     * @return OK
     */
    getBenefitType(): Observable<THBenefitTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/GetBenefitType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THBenefitTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THBenefitTypeDto>;
        }));
    }

    protected processGetBenefitType(response: HttpResponseBase): Observable<THBenefitTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THBenefitTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the benefit section details of the ticketHolder
     * @param body (optional) 
     * @return OK
     */
    updateBenefitType(body?: THBenefitTypeDto | undefined): Observable<THBenefitTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/UpdateBenefitType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBenefitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBenefitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THBenefitTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THBenefitTypeDto>;
        }));
    }

    protected processUpdateBenefitType(response: HttpResponseBase): Observable<THBenefitTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THBenefitTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves the effective time zone for a Ticket Holder.
     * @return OK
     */
    getMyTimeZone(): Observable<TicketHolderTimeZoneDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/GetMyTimeZone";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTimeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTimeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TicketHolderTimeZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TicketHolderTimeZoneDto>;
        }));
    }

    protected processGetMyTimeZone(response: HttpResponseBase): Observable<TicketHolderTimeZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHolderTimeZoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of time zone options for a specific Ticket Holder,
    formatted as Abp.Application.Services.Dto.ComboboxItemDto for UI dropdowns.
     * @return OK
     */
    getMyTimeZoneComboboxItems(): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientProfile/GetMyTimeZoneComboboxItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTimeZoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTimeZoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetMyTimeZoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientServiceRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves a paginated list of service requests for a given user ID,
    with optional filters on due date range, service type, and status.
     * @param startDueDate (optional) 
     * @param endDueDate (optional) 
     * @param serviceType (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllServiceRequests(startDueDate?: DateTime | null | undefined, endDueDate?: DateTime | null | undefined, serviceType?: ServiceType[] | null | undefined, status?: ServiceRequestStatus[] | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfTHVwServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetAllServiceRequests?";
        if (startDueDate !== undefined && startDueDate !== null)
            url_ += "StartDueDate=" + encodeURIComponent(startDueDate ? "" + startDueDate.toString() : "") + "&";
        if (endDueDate !== undefined && endDueDate !== null)
            url_ += "EndDueDate=" + encodeURIComponent(endDueDate ? "" + endDueDate.toString() : "") + "&";
        if (serviceType !== undefined && serviceType !== null)
            serviceType && serviceType.forEach(item => { url_ += "ServiceType=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHVwServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHVwServiceRequestDto>;
        }));
    }

    protected processGetAllServiceRequests(response: HttpResponseBase): Observable<PagedResultDtoOfTHVwServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHVwServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add advocacy service requests
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateAdvocacyServiceRequest(body?: THAdvocacyServiceRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/AddOrUpdateAdvocacyServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAdvocacyServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAdvocacyServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateAdvocacyServiceRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get advocacy service requests
     * @return OK
     */
    getAdvocacyServiceRequest(idRaw: number, serviceType: ServiceType): Observable<THAdvocacyServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetAdvocacyServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvocacyServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvocacyServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THAdvocacyServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THAdvocacyServiceRequestDto>;
        }));
    }

    protected processGetAdvocacyServiceRequest(response: HttpResponseBase): Observable<THAdvocacyServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THAdvocacyServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add education service requests
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateEducationServiceRequest(body?: THEducationServiceRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/AddOrUpdateEducationServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateEducationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateEducationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateEducationServiceRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get education service requests
     * @return OK
     */
    getEducationServiceRequest(idRaw: number, serviceType: ServiceType): Observable<THEducationServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetEducationServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THEducationServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THEducationServiceRequestDto>;
        }));
    }

    protected processGetEducationServiceRequest(response: HttpResponseBase): Observable<THEducationServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THEducationServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add housing service requests
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateHousingServiceRequest(body?: THHousingServiceRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/AddOrUpdateHousingServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateHousingServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateHousingServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateHousingServiceRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get housing service requests
     * @return OK
     */
    getHousingServiceRequest(idRaw: number, serviceType: ServiceType): Observable<THHousingServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetHousingServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHousingServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHousingServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THHousingServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THHousingServiceRequestDto>;
        }));
    }

    protected processGetHousingServiceRequest(response: HttpResponseBase): Observable<THHousingServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THHousingServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Interview assistance service requests
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateInterviewAssistanceServiceRequest(body?: THInterviewAssistanceServiceRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/AddOrUpdateInterviewAssistanceServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateInterviewAssistanceServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateInterviewAssistanceServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateInterviewAssistanceServiceRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get interview assistance service requests
     * @return OK
     */
    getInterviewAssistanceServiceRequest(idRaw: number, serviceType: ServiceType): Observable<THInterviewAssistanceServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetInterviewAssistanceServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterviewAssistanceServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterviewAssistanceServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THInterviewAssistanceServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THInterviewAssistanceServiceRequestDto>;
        }));
    }

    protected processGetInterviewAssistanceServiceRequest(response: HttpResponseBase): Observable<THInterviewAssistanceServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THInterviewAssistanceServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add resume service requests
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateResumeServiceRequest(body?: THResumeServiceRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/AddOrUpdateResumeServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateResumeServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateResumeServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateResumeServiceRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get resume service requests
     * @return OK
     */
    getResumeServiceRequest(idRaw: number, serviceType: ServiceType): Observable<THResumeServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetResumeServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResumeServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResumeServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THResumeServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THResumeServiceRequestDto>;
        }));
    }

    protected processGetResumeServiceRequest(response: HttpResponseBase): Observable<THResumeServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THResumeServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add transport service requests
     * @param body (optional) 
     * @return OK
     */
    addOrUpdateTransportationServiceRequest(body?: THTransportationServiceRequestDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/AddOrUpdateTransportationServiceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateTransportationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateTransportationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddOrUpdateTransportationServiceRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get transport service requests
     * @return OK
     */
    getTransportationServiceRequest(idRaw: number, serviceType: ServiceType): Observable<THTransportationServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientServiceRequest/GetTransportationServiceRequest?";
        if (idRaw === undefined || idRaw === null)
            throw new Error("The parameter 'idRaw' must be defined and cannot be null.");
        else
            url_ += "IdRaw=" + encodeURIComponent("" + idRaw) + "&";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransportationServiceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransportationServiceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THTransportationServiceRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THTransportationServiceRequestDto>;
        }));
    }

    protected processGetTransportationServiceRequest(response: HttpResponseBase): Observable<THTransportationServiceRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THTransportationServiceRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWClientWorkHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve the work history records associated with a specific ticket holder.
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getWorkHistory(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTHWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientWorkHistory/GetWorkHistory?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTHWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTHWorkHistoryDto>;
        }));
    }

    protected processGetWorkHistory(response: HttpResponseBase): Observable<PagedResultDtoOfTHWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTHWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new work history record for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    addWorkHistory(body?: THNewWorkHistoryDto | undefined): Observable<THWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientWorkHistory/AddWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THWorkHistoryDto>;
        }));
    }

    protected processAddWorkHistory(response: HttpResponseBase): Observable<THWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing work history record for a ticket holder.
     * @param body (optional) 
     * @return OK
     */
    updateWorkHistory(body?: THWorkHistoryDto | undefined): Observable<THWorkHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientWorkHistory/UpdateWorkHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<THWorkHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<THWorkHistoryDto>;
        }));
    }

    protected processUpdateWorkHistory(response: HttpResponseBase): Observable<THWorkHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = THWorkHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads and saves a ticket holder's pay stub(s), creates corresponding document records,
    and stores the pay history entry along with the associated document IDs.
     * @param attachments (optional) 
     * @param payType (optional) 
     * @param grossPay (optional) 
     * @param hoursWorked (optional) 
     * @param payPeriodStart (optional) 
     * @param payPeriodEnd (optional) 
     * @param payDate (optional) 
     * @param notes (optional) 
     * @return OK
     */
    addPayStub(attachments?: FileParameter | undefined, payType?: PayType | undefined, grossPay?: number | undefined, hoursWorked?: number | undefined, payPeriodStart?: DateTime | undefined, payPeriodEnd?: DateTime | undefined, payDate?: DateTime | undefined, notes?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TTWClientWorkHistory/AddPayStub";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachments === null || attachments === undefined)
            throw new Error("The parameter 'attachments' cannot be null.");
        else
            content_.append("Attachments", attachments.data, attachments.fileName ? attachments.fileName : "Attachments");
        if (payType === null || payType === undefined)
            throw new Error("The parameter 'payType' cannot be null.");
        else
            content_.append("PayType", payType.toString());
        if (grossPay === null || grossPay === undefined)
            throw new Error("The parameter 'grossPay' cannot be null.");
        else
            content_.append("GrossPay", grossPay.toString());
        if (hoursWorked === null || hoursWorked === undefined)
            throw new Error("The parameter 'hoursWorked' cannot be null.");
        else
            content_.append("HoursWorked", hoursWorked.toString());
        if (payPeriodStart === null || payPeriodStart === undefined)
            throw new Error("The parameter 'payPeriodStart' cannot be null.");
        else
            content_.append("PayPeriodStart", payPeriodStart.toJSON());
        if (payPeriodEnd === null || payPeriodEnd === undefined)
            throw new Error("The parameter 'payPeriodEnd' cannot be null.");
        else
            content_.append("PayPeriodEnd", payPeriodEnd.toJSON());
        if (payDate === null || payDate === undefined)
            throw new Error("The parameter 'payDate' cannot be null.");
        else
            content_.append("PayDate", payDate.toJSON());
        if (notes === null || notes === undefined)
            throw new Error("The parameter 'notes' cannot be null.");
        else
            content_.append("Notes", notes.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPayStub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPayStub(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddPayStub(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TTWSharedServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get the RAW SSN by providing encrypted SSN
     * @param encryptedSSN (optional) 
     * @return OK
     */
    getRawSSN(encryptedSSN?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetRawSSN?";
        if (encryptedSSN !== undefined && encryptedSSN !== null)
            url_ += "encryptedSSN=" + encodeURIComponent("" + encryptedSSN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawSSN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawSSN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRawSSN(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the diability master data
     * @param filtertext (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getDisability(filtertext?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfDisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetDisability?";
        if (filtertext !== undefined && filtertext !== null)
            url_ += "Filtertext=" + encodeURIComponent("" + filtertext) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDisabilityDto>;
        }));
    }

    protected processGetDisability(response: HttpResponseBase): Observable<PagedResultDtoOfDisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get USA States Master
     * @param filtertext (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUSAStates(filtertext?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfUSAStateDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetUSAStates?";
        if (filtertext !== undefined && filtertext !== null)
            url_ += "Filtertext=" + encodeURIComponent("" + filtertext) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUSAStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUSAStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUSAStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUSAStateDto>;
        }));
    }

    protected processGetUSAStates(response: HttpResponseBase): Observable<PagedResultDtoOfUSAStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUSAStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get All Spoken language master
     * @param filtertext (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllSpokenLangauges(filtertext?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfSpokenLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetAllSpokenLangauges?";
        if (filtertext !== undefined && filtertext !== null)
            url_ += "Filtertext=" + encodeURIComponent("" + filtertext) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSpokenLangauges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpokenLangauges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSpokenLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSpokenLanguageDto>;
        }));
    }

    protected processGetAllSpokenLangauges(response: HttpResponseBase): Observable<PagedResultDtoOfSpokenLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSpokenLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Activity Status Prefix
     * @param prefixes (optional) 
     * @return OK
     */
    getActivityStatusesByPrefixes(prefixes?: string[] | null | undefined): Observable<EnumDropdownItem[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetActivityStatusesByPrefixes?";
        if (prefixes !== undefined && prefixes !== null)
            prefixes && prefixes.forEach(item => { url_ += "prefixes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityStatusesByPrefixes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityStatusesByPrefixes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDropdownItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDropdownItem[]>;
        }));
    }

    protected processGetActivityStatusesByPrefixes(response: HttpResponseBase): Observable<EnumDropdownItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumDropdownItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the activity service types allowed for a Lead or a Ticket Holder, in lifecycle order.
     * @param isTicketHolder (optional) true for Ticket Holder service types, false for Lead service types.
     * @return OK
     */
    getActivityServiceTypes(isTicketHolder?: boolean | undefined): Observable<EnumDropdownItem[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetActivityServiceTypes?";
        if (isTicketHolder === null)
            throw new Error("The parameter 'isTicketHolder' cannot be null.");
        else if (isTicketHolder !== undefined)
            url_ += "isTicketHolder=" + encodeURIComponent("" + isTicketHolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDropdownItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDropdownItem[]>;
        }));
    }

    protected processGetActivityServiceTypes(response: HttpResponseBase): Observable<EnumDropdownItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumDropdownItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Default activity service type for a Lead, based on their current stage.
    Used to prefill the Service Type on call log, SMS, email and mail; the Career Coach can change it.
     * @param leadId (optional) Leads.Id
     * @return OK
     */
    getDefaultLeadServiceType(leadId?: number | undefined): Observable<ActivityServiceType> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetDefaultLeadServiceType?";
        if (leadId === null)
            throw new Error("The parameter 'leadId' cannot be null.");
        else if (leadId !== undefined)
            url_ += "leadId=" + encodeURIComponent("" + leadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultLeadServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultLeadServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityServiceType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityServiceType>;
        }));
    }

    protected processGetDefaultLeadServiceType(response: HttpResponseBase): Observable<ActivityServiceType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Message Template
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getMessageTemplate(templateType: MessageTemplateType, filterText?: string | null | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetMessageTemplate> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetMessageTemplate?";
        if (templateType === undefined || templateType === null)
            throw new Error("The parameter 'templateType' must be defined and cannot be null.");
        else
            url_ += "TemplateType=" + encodeURIComponent("" + templateType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMessageTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMessageTemplate>;
        }));
    }

    protected processGetMessageTemplate(response: HttpResponseBase): Observable<PagedResultDtoOfGetMessageTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMessageTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the details of an enum type by its name, including its integer value, name, and display name.
     * @param enumTypeName The name of the enum type to retrieve details for.
     * @return OK
     */
    getEnumDetails(enumTypeName: string | null): Observable<EnumInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetEnumDetails?";
        if (enumTypeName === undefined)
            throw new Error("The parameter 'enumTypeName' must be defined.");
        else if(enumTypeName !== null)
            url_ += "enumTypeName=" + encodeURIComponent("" + enumTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnumDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnumDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumInfoDto[]>;
        }));
    }

    protected processGetEnumDetails(response: HttpResponseBase): Observable<EnumInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all users assigned to the `Job Search Assistant` role 
    and returns them as a list of Thrive.TTW.Common.Dtos.JSACCDto objects.
     * @return OK
     */
    getAllJobSearchAssistant(): Observable<JSACCDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTWSharedService/GetAllJobSearchAssistant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobSearchAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobSearchAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JSACCDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JSACCDto[]>;
        }));
    }

    protected processGetAllJobSearchAssistant(response: HttpResponseBase): Observable<JSACCDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JSACCDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TtwTrackingSheetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    getTtwTrackingSheet(ticketHolderId?: number | undefined): Observable<TtwTrackingSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/GetTtwTrackingSheet?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTtwTrackingSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTtwTrackingSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwTrackingSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwTrackingSheetDto>;
        }));
    }

    protected processGetTtwTrackingSheet(response: HttpResponseBase): Observable<TtwTrackingSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwTrackingSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ticketHolderId (optional) 
     * @return OK
     */
    refreshTrackingSheet(ticketHolderId?: number | undefined): Observable<TtwTrackingSheetDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/RefreshTrackingSheet?";
        if (ticketHolderId === null)
            throw new Error("The parameter 'ticketHolderId' cannot be null.");
        else if (ticketHolderId !== undefined)
            url_ += "ticketHolderId=" + encodeURIComponent("" + ticketHolderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshTrackingSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTrackingSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwTrackingSheetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwTrackingSheetDto>;
        }));
    }

    protected processRefreshTrackingSheet(response: HttpResponseBase): Observable<TtwTrackingSheetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwTrackingSheetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateTrackingSheetMonth(body?: CreateOrUpdateTtwTrackingSheetMonthDto | undefined): Observable<TtwTrackingSheetMonthDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/CreateOrUpdateTrackingSheetMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTrackingSheetMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTrackingSheetMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwTrackingSheetMonthDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwTrackingSheetMonthDto>;
        }));
    }

    protected processCreateOrUpdateTrackingSheetMonth(response: HttpResponseBase): Observable<TtwTrackingSheetMonthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwTrackingSheetMonthDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getThresholds(): Observable<TtwAnnualThresholdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/GetThresholds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwAnnualThresholdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwAnnualThresholdDto[]>;
        }));
    }

    protected processGetThresholds(response: HttpResponseBase): Observable<TtwAnnualThresholdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TtwAnnualThresholdDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateThreshold(body?: CreateOrUpdateTtwAnnualThresholdDto | undefined): Observable<TtwAnnualThresholdDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/CreateOrUpdateThreshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateThreshold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateThreshold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwAnnualThresholdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwAnnualThresholdDto>;
        }));
    }

    protected processCreateOrUpdateThreshold(response: HttpResponseBase): Observable<TtwAnnualThresholdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwAnnualThresholdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get1619bThresholds(): Observable<Ttw1619bThresholdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/Get1619bThresholds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet1619bThresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet1619bThresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ttw1619bThresholdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ttw1619bThresholdDto[]>;
        }));
    }

    protected processGet1619bThresholds(response: HttpResponseBase): Observable<Ttw1619bThresholdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ttw1619bThresholdDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdate1619bThreshold(body?: CreateOrUpdateTtw1619bThresholdDto | undefined): Observable<Ttw1619bThresholdDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/CreateOrUpdate1619bThreshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate1619bThreshold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate1619bThreshold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ttw1619bThresholdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ttw1619bThresholdDto>;
        }));
    }

    protected processCreateOrUpdate1619bThreshold(response: HttpResponseBase): Observable<Ttw1619bThresholdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ttw1619bThresholdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lookup1619bThresholdViaAi(body?: Lookup1619bThresholdAiRequestDto | undefined): Observable<Ttw1619bAiLookupResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/Lookup1619bThresholdViaAi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookup1619bThresholdViaAi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookup1619bThresholdViaAi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ttw1619bAiLookupResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ttw1619bAiLookupResultDto>;
        }));
    }

    protected processLookup1619bThresholdViaAi(response: HttpResponseBase): Observable<Ttw1619bAiLookupResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ttw1619bAiLookupResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSsiFederalBenefitRates(): Observable<TtwSsiFederalBenefitRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/GetSsiFederalBenefitRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSsiFederalBenefitRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSsiFederalBenefitRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwSsiFederalBenefitRateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwSsiFederalBenefitRateDto[]>;
        }));
    }

    protected processGetSsiFederalBenefitRates(response: HttpResponseBase): Observable<TtwSsiFederalBenefitRateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TtwSsiFederalBenefitRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateSsiFederalBenefitRate(body?: CreateOrUpdateTtwSsiFederalBenefitRateDto | undefined): Observable<TtwSsiFederalBenefitRateDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/CreateOrUpdateSsiFederalBenefitRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSsiFederalBenefitRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSsiFederalBenefitRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwSsiFederalBenefitRateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwSsiFederalBenefitRateDto>;
        }));
    }

    protected processCreateOrUpdateSsiFederalBenefitRate(response: HttpResponseBase): Observable<TtwSsiFederalBenefitRateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwSsiFederalBenefitRateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    lookupSsiFederalBenefitRateViaAi(body?: LookupSsiFbrAiRequestDto | undefined): Observable<TtwSsiFbrAiLookupResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TtwTrackingSheet/LookupSsiFederalBenefitRateViaAi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupSsiFederalBenefitRateViaAi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupSsiFederalBenefitRateViaAi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TtwSsiFbrAiLookupResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TtwSsiFbrAiLookupResultDto>;
        }));
    }

    protected processLookupSsiFederalBenefitRateViaAi(response: HttpResponseBase): Observable<TtwSsiFbrAiLookupResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TtwSsiFbrAiLookupResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwilioSmsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Handles incoming Twilio SMS webhook events, processes the payload, logs the SMS, and saves any attached media.
     * @param payload (optional) The raw query string payload from Twilio.
     * @param body (optional) The HTTP headers associated with the webhook request.
     * @return OK
     */
    handleEventSubscription(payload?: string | null | undefined, body?: { [key: string]: string; } | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TwilioSms/HandleEventSubscription?";
        if (payload !== undefined && payload !== null)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleEventSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHandleEventSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Converts a Twilio SMS status to an internal Thrive.TTW.ActivityStatus enum value.
     * @param twilioStatus (optional) The Twilio SMS status string.
     * @return OK
     */
    convertTwilioStatusToActivityStatus(twilioStatus?: string | null | undefined): Observable<ActivityStatus> {
        let url_ = this.baseUrl + "/api/services/app/TwilioSms/ConvertTwilioStatusToActivityStatus?";
        if (twilioStatus !== undefined && twilioStatus !== null)
            url_ += "twilioStatus=" + encodeURIComponent("" + twilioStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertTwilioStatusToActivityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertTwilioStatusToActivityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityStatus>;
        }));
    }

    protected processConvertTwilioStatusToActivityStatus(response: HttpResponseBase): Observable<ActivityStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwitterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
        }));
    }

    protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param verifier (optional) 
     * @return OK
     */
    getAccessToken(token?: string | null | undefined, verifier?: string | null | undefined): Observable<TwitterGetAccessTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (verifier !== undefined && verifier !== null)
            url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
        }));
    }

    protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return OK
     */
    changeThemeWithDefaultValues(themeName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName !== undefined && themeName !== null)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUiManagementSettings(body?: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateDefaultUiManagementSettings(body?: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isDarkModeActive (optional) 
     * @return OK
     */
    changeDarkModeOfCurrentTheme(isDarkModeActive?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeDarkModeOfCurrentTheme?";
        if (isDarkModeActive === null)
            throw new Error("The parameter 'isDarkModeActive' cannot be null.");
        else if (isDarkModeActive !== undefined)
            url_ += "isDarkModeActive=" + encodeURIComponent("" + isDarkModeActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeDarkModeOfCurrentTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeDarkModeOfCurrentTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeDarkModeOfCurrentTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getUsers(body?: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param selectedColumns (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getUsersToExcel(filter?: string | null | undefined, permissions?: string[] | null | undefined, selectedColumns?: string[] | null | undefined, role?: number | null | undefined, onlyLockedUsers?: boolean | undefined, sorting?: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions !== undefined && permissions !== null)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (selectedColumns !== undefined && selectedColumns !== null)
            selectedColumns && selectedColumns.forEach(item => { url_ += "SelectedColumns=" + encodeURIComponent("" + item) + "&"; });
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserExcelColumnsToExcel(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserExcelColumnsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserExcelColumnsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserExcelColumnsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserExcelColumnsToExcel(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserForEdit(id?: number | null | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getUserPermissionsForEdit(id?: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetUserSpecificPermissions(body?: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateUserPermissions(body?: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateUser(body?: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteUser(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlockUser(body?: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getDelegatedUsers(maxResultCount?: number | undefined, skipCount?: number | undefined, sorting?: string | null | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    delegateNewUser(body?: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    removeDelegation(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns active user delegations for current user
     * @return OK
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    linkToUser(body?: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return OK
     */
    getLinkedUsers(maxResultCount?: number | undefined, skipCount?: number | undefined, sorting?: string | null | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    unlinkUser(body?: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param result (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getUserLoginAttempts(filter?: string | null | undefined, startDate?: DateTime | null | undefined, endDate?: DateTime | null | undefined, result?: AbpLoginResultType | undefined, sorting?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (result === null)
            throw new Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "Result=" + encodeURIComponent("" + result) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getExternalLoginProviderNameByUser(userId?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetExternalLoginProviderNameByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalLoginProviderNameByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalLoginProviderNameByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetExternalLoginProviderNameByUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id?: string | null | undefined): Observable<WebhookEvent> {
        let url_ = this.baseUrl + "/api/services/app/WebhookEvent/Get?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebhookEvent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebhookEvent>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WebhookEvent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookEvent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookSendAttemptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param subscriptionId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return OK
     */
    getAllSendAttempts(subscriptionId?: string | null | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttempts?";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
        }));
    }

    protected processGetAllSendAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAllSendAttemptsOfWebhookEvent(id?: string | null | undefined): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttemptsOfWebhookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttemptsOfWebhookEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
        }));
    }

    protected processGetAllSendAttemptsOfWebhookEvent(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sendAttemptId (optional) 
     * @return OK
     */
    resend(sendAttemptId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/Resend?";
        if (sendAttemptId !== undefined && sendAttemptId !== null)
            url_ += "sendAttemptId=" + encodeURIComponent("" + sendAttemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    publishTestWebhook(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/PublishTestWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishTestWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishTestWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPublishTestWebhook(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllSubscriptions(): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }));
    }

    protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subscriptionId (optional) 
     * @return OK
     */
    getSubscription(subscriptionId?: string | null | undefined): Observable<WebhookSubscription> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetSubscription?";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebhookSubscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebhookSubscription>;
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<WebhookSubscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookSubscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addSubscription(body?: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/AddSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSubscription(body?: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activateWebhookSubscription(body?: ActivateWebhookSubscriptionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/ActivateWebhookSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateWebhookSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateWebhookSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateWebhookSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param webhookName (optional) 
     * @return OK
     */
    isSubscribed(webhookName?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/IsSubscribed?";
        if (webhookName !== undefined && webhookName !== null)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSubscribed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSubscribed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSubscribed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param webhookName (optional) 
     * @return OK
     */
    getAllSubscriptionsIfFeaturesGranted(webhookName?: string | null | undefined): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?";
        if (webhookName !== undefined && webhookName !== null)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionsIfFeaturesGranted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionsIfFeaturesGranted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }));
    }

    protected processGetAllSubscriptionsIfFeaturesGranted(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAvailableWebhooks(): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllAvailableWebhooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableWebhooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
        }));
    }

    protected processGetAllAvailableWebhooks(response: HttpResponseBase): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebsiteAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * The current side's submissions: the host sees the Thrive product site's Contact Us form, a tenant sees the
    leads from its own marketing website (ContactUsRequest is IMayHaveTenant, so the tenant filter does this).
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getContactUsRequests(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfContactUsListDto> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/GetContactUsRequests?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactUsRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactUsRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfContactUsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfContactUsListDto>;
        }));
    }

    protected processGetContactUsRequests(response: HttpResponseBase): Observable<PagedResultDtoOfContactUsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactUsListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getScheduleDemoRequests(sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfScheduleDemoListDto> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/GetScheduleDemoRequests?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleDemoRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleDemoRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfScheduleDemoListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfScheduleDemoListDto>;
        }));
    }

    protected processGetScheduleDemoRequests(response: HttpResponseBase): Observable<PagedResultDtoOfScheduleDemoListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfScheduleDemoListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    markContactUsRead(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/MarkContactUsRead?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkContactUsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkContactUsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkContactUsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    markScheduleDemoRead(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/MarkScheduleDemoRead?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkScheduleDemoRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkScheduleDemoRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkScheduleDemoRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateScheduleDemoStatus(id?: number | undefined, body?: ScheduleDemoStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/UpdateScheduleDemoStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduleDemoStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduleDemoStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateScheduleDemoStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scheduleMeetingAndNotify(body?: ScheduleMeetingInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/ScheduleMeetingAndNotify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleMeetingAndNotify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleMeetingAndNotify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleMeetingAndNotify(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records which Host Admin first opened the Teams join link from the CRM, purely so other
    Host Admins can see someone already joined — Teams itself allows anyone with the link in
    regardless, so this is informational, not a real join gate. First click wins; later
    callers just get back who got there first.
     * @param id (optional) 
     * @return OK
     */
    markMeetingJoined(id?: number | undefined): Observable<MeetingJoinInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteAdmin/MarkMeetingJoined?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkMeetingJoined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkMeetingJoined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeetingJoinInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeetingJoinInfoDto>;
        }));
    }

    protected processMarkMeetingJoined(response: HttpResponseBase): Observable<MeetingJoinInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingJoinInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebsiteApiKeyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * A tenant without any key gets one here, so the key is ready to copy the first time the tab opens.
     * @return OK
     */
    getSettings(): Observable<WebsiteSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteApiKey/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebsiteSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebsiteSettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<WebsiteSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebsiteSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createKey(): Observable<WebsiteApiKeyDto> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteApiKey/CreateKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebsiteApiKeyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebsiteApiKeyDto>;
        }));
    }

    protected processCreateKey(response: HttpResponseBase): Observable<WebsiteApiKeyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebsiteApiKeyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    revokeKey(body?: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteApiKey/RevokeKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevokeKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    deleteKey(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteApiKey/DeleteKey?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePartnerLoginUrl(body?: UpdateWebsitePartnerLoginUrlInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebsiteApiKey/UpdatePartnerLoginUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerLoginUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerLoginUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePartnerLoginUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AICompletionRequest implements IAICompletionRequest {
    prompt!: string | undefined;
    systemMessage!: string | undefined;
    conversationHistory!: AIMessage[] | undefined;
    maxTokens!: number | undefined;
    temperature!: number | undefined;
    model!: string | undefined;
    topP!: number | undefined;
    frequencyPenalty!: number | undefined;
    presencePenalty!: number | undefined;
    images!: AIImageAttachment[] | undefined;

    constructor(data?: IAICompletionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.systemMessage = _data["systemMessage"];
            if (Array.isArray(_data["conversationHistory"])) {
                this.conversationHistory = [] as any;
                for (let item of _data["conversationHistory"])
                    this.conversationHistory!.push(AIMessage.fromJS(item));
            }
            this.maxTokens = _data["maxTokens"];
            this.temperature = _data["temperature"];
            this.model = _data["model"];
            this.topP = _data["topP"];
            this.frequencyPenalty = _data["frequencyPenalty"];
            this.presencePenalty = _data["presencePenalty"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(AIImageAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AICompletionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AICompletionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["systemMessage"] = this.systemMessage;
        if (Array.isArray(this.conversationHistory)) {
            data["conversationHistory"] = [];
            for (let item of this.conversationHistory)
                data["conversationHistory"].push(item.toJSON());
        }
        data["maxTokens"] = this.maxTokens;
        data["temperature"] = this.temperature;
        data["model"] = this.model;
        data["topP"] = this.topP;
        data["frequencyPenalty"] = this.frequencyPenalty;
        data["presencePenalty"] = this.presencePenalty;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAICompletionRequest {
    prompt: string | undefined;
    systemMessage: string | undefined;
    conversationHistory: AIMessage[] | undefined;
    maxTokens: number | undefined;
    temperature: number | undefined;
    model: string | undefined;
    topP: number | undefined;
    frequencyPenalty: number | undefined;
    presencePenalty: number | undefined;
    images: AIImageAttachment[] | undefined;
}

export class AICompletionResponse implements IAICompletionResponse {
    content!: string | undefined;
    model!: string | undefined;
    promptTokens!: number;
    completionTokens!: number;
    totalTokens!: number;
    finishReason!: string | undefined;
    provider!: string | undefined;
    success!: boolean;
    errorMessage!: string | undefined;

    constructor(data?: IAICompletionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.model = _data["model"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            this.finishReason = _data["finishReason"];
            this.provider = _data["provider"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AICompletionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AICompletionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["model"] = this.model;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        data["finishReason"] = this.finishReason;
        data["provider"] = this.provider;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAICompletionResponse {
    content: string | undefined;
    model: string | undefined;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
    finishReason: string | undefined;
    provider: string | undefined;
    success: boolean;
    errorMessage: string | undefined;
}

export class AIImageAttachment implements IAIImageAttachment {
    mediaType!: string | undefined;
    base64Data!: string | undefined;

    constructor(data?: IAIImageAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaType = _data["mediaType"];
            this.base64Data = _data["base64Data"];
        }
    }

    static fromJS(data: any): AIImageAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new AIImageAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaType"] = this.mediaType;
        data["base64Data"] = this.base64Data;
        return data;
    }
}

export interface IAIImageAttachment {
    mediaType: string | undefined;
    base64Data: string | undefined;
}

export class AIMessage implements IAIMessage {
    role!: string | undefined;
    content!: string | undefined;

    constructor(data?: IAIMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AIMessage {
        data = typeof data === 'object' ? data : {};
        let result = new AIMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        return data;
    }
}

export interface IAIMessage {
    role: string | undefined;
    content: string | undefined;
}

/** DTO for detailed usage report */
export class AIUsageDetailDto implements IAIUsageDetailDto {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    userName!: string | undefined;
    provider!: string | undefined;
    model!: string | undefined;
    promptTokens!: number;
    completionTokens!: number;
    totalTokens!: number;
    estimatedCostUSD!: number;
    durationMs!: number;
    success!: boolean;
    errorMessage!: string | undefined;
    endpointCalled!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IAIUsageDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.provider = _data["provider"];
            this.model = _data["model"];
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            this.estimatedCostUSD = _data["estimatedCostUSD"];
            this.durationMs = _data["durationMs"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.endpointCalled = _data["endpointCalled"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AIUsageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AIUsageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["provider"] = this.provider;
        data["model"] = this.model;
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        data["estimatedCostUSD"] = this.estimatedCostUSD;
        data["durationMs"] = this.durationMs;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["endpointCalled"] = this.endpointCalled;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

/** DTO for detailed usage report */
export interface IAIUsageDetailDto {
    id: number;
    tenantId: number | undefined;
    userId: number;
    userName: string | undefined;
    provider: string | undefined;
    model: string | undefined;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
    estimatedCostUSD: number;
    durationMs: number;
    success: boolean;
    errorMessage: string | undefined;
    endpointCalled: string | undefined;
    creationTime: DateTime;
}

/** DTO for AI usage summary */
export class AIUsageSummaryDto implements IAIUsageSummaryDto {
    tenantId!: number | undefined;
    tenantName!: string | undefined;
    userId!: number;
    userName!: string | undefined;
    provider!: string | undefined;
    model!: string | undefined;
    totalRequests!: number;
    successfulRequests!: number;
    failedRequests!: number;
    totalTokens!: number;
    totalPromptTokens!: number;
    totalCompletionTokens!: number;
    totalCostUSD!: number;
    averageDurationMs!: number;
    firstUsed!: DateTime;
    lastUsed!: DateTime;

    constructor(data?: IAIUsageSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.provider = _data["provider"];
            this.model = _data["model"];
            this.totalRequests = _data["totalRequests"];
            this.successfulRequests = _data["successfulRequests"];
            this.failedRequests = _data["failedRequests"];
            this.totalTokens = _data["totalTokens"];
            this.totalPromptTokens = _data["totalPromptTokens"];
            this.totalCompletionTokens = _data["totalCompletionTokens"];
            this.totalCostUSD = _data["totalCostUSD"];
            this.averageDurationMs = _data["averageDurationMs"];
            this.firstUsed = _data["firstUsed"] ? DateTime.fromISO(_data["firstUsed"].toString()) : <any>undefined;
            this.lastUsed = _data["lastUsed"] ? DateTime.fromISO(_data["lastUsed"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AIUsageSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AIUsageSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["provider"] = this.provider;
        data["model"] = this.model;
        data["totalRequests"] = this.totalRequests;
        data["successfulRequests"] = this.successfulRequests;
        data["failedRequests"] = this.failedRequests;
        data["totalTokens"] = this.totalTokens;
        data["totalPromptTokens"] = this.totalPromptTokens;
        data["totalCompletionTokens"] = this.totalCompletionTokens;
        data["totalCostUSD"] = this.totalCostUSD;
        data["averageDurationMs"] = this.averageDurationMs;
        data["firstUsed"] = this.firstUsed ? this.firstUsed.toString() : <any>undefined;
        data["lastUsed"] = this.lastUsed ? this.lastUsed.toString() : <any>undefined;
        return data;
    }
}

/** DTO for AI usage summary */
export interface IAIUsageSummaryDto {
    tenantId: number | undefined;
    tenantName: string | undefined;
    userId: number;
    userName: string | undefined;
    provider: string | undefined;
    model: string | undefined;
    totalRequests: number;
    successfulRequests: number;
    failedRequests: number;
    totalTokens: number;
    totalPromptTokens: number;
    totalCompletionTokens: number;
    totalCostUSD: number;
    averageDurationMs: number;
    firstUsed: DateTime;
    lastUsed: DateTime;
}

export enum AbpLoginResultType {
    Success = 1,
    InvalidUserNameOrEmailAddress = 2,
    InvalidPassword = 3,
    UserIsNotActive = 4,
    InvalidTenancyName = 5,
    TenantIsNotActive = 6,
    UserEmailIsNotConfirmed = 7,
    UnknownExternalLogin = 8,
    LockedOut = 9,
    UserPhoneNumberIsNotConfirmed = 10,
    FailedForOtherReason = 11,
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ActivateWebhookSubscriptionInput implements IActivateWebhookSubscriptionInput {
    subscriptionId!: string;
    isActive!: boolean;

    constructor(data?: IActivateWebhookSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivateWebhookSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateWebhookSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivateWebhookSubscriptionInput {
    subscriptionId: string;
    isActive: boolean;
}

export class ActiveMaintenanceConsoleDto implements IActiveMaintenanceConsoleDto {
    url!: string | undefined;
    machineName!: string | undefined;
    ipAddress!: string | undefined;
    lastHeartbeat!: DateTime;
    startupTime!: DateTime;
    environment!: string | undefined;

    constructor(data?: IActiveMaintenanceConsoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.machineName = _data["machineName"];
            this.ipAddress = _data["ipAddress"];
            this.lastHeartbeat = _data["lastHeartbeat"] ? DateTime.fromISO(_data["lastHeartbeat"].toString()) : <any>undefined;
            this.startupTime = _data["startupTime"] ? DateTime.fromISO(_data["startupTime"].toString()) : <any>undefined;
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): ActiveMaintenanceConsoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMaintenanceConsoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["machineName"] = this.machineName;
        data["ipAddress"] = this.ipAddress;
        data["lastHeartbeat"] = this.lastHeartbeat ? this.lastHeartbeat.toString() : <any>undefined;
        data["startupTime"] = this.startupTime ? this.startupTime.toString() : <any>undefined;
        data["environment"] = this.environment;
        return data;
    }
}

export interface IActiveMaintenanceConsoleDto {
    url: string | undefined;
    machineName: string | undefined;
    ipAddress: string | undefined;
    lastHeartbeat: DateTime;
    startupTime: DateTime;
    environment: string | undefined;
}

export class ActiveTicketHolderDto implements IActiveTicketHolderDto {
    id!: number;
    ticketHolderName!: string | undefined;
    status!: TicketHolderStatus;
    statusValue!: string | undefined;
    employer!: string | undefined;
    latestPaymentRequest!: DateTime;
    phaseMilestone!: string | undefined;
    ticketHolderId!: string | undefined;
    hasPayStub!: boolean;

    constructor(data?: IActiveTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.status = _data["status"];
            this.statusValue = _data["statusValue"];
            this.employer = _data["employer"];
            this.latestPaymentRequest = _data["latestPaymentRequest"] ? DateTime.fromISO(_data["latestPaymentRequest"].toString()) : <any>undefined;
            this.phaseMilestone = _data["phaseMilestone"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.hasPayStub = _data["hasPayStub"];
        }
    }

    static fromJS(data: any): ActiveTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderName"] = this.ticketHolderName;
        data["status"] = this.status;
        data["statusValue"] = this.statusValue;
        data["employer"] = this.employer;
        data["latestPaymentRequest"] = this.latestPaymentRequest ? this.latestPaymentRequest.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phaseMilestone"] = this.phaseMilestone;
        data["ticketHolderId"] = this.ticketHolderId;
        data["hasPayStub"] = this.hasPayStub;
        return data;
    }
}

export interface IActiveTicketHolderDto {
    id: number;
    ticketHolderName: string | undefined;
    status: TicketHolderStatus;
    statusValue: string | undefined;
    employer: string | undefined;
    latestPaymentRequest: DateTime;
    phaseMilestone: string | undefined;
    ticketHolderId: string | undefined;
    hasPayStub: boolean;
}

export class ActiveTicketHolderRequestDto implements IActiveTicketHolderRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    status!: TicketHolderStatus;
    hasPayStub!: boolean | undefined;

    constructor(data?: IActiveTicketHolderRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.status = _data["status"];
            this.hasPayStub = _data["hasPayStub"];
        }
    }

    static fromJS(data: any): ActiveTicketHolderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveTicketHolderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["status"] = this.status;
        data["hasPayStub"] = this.hasPayStub;
        return data;
    }
}

export interface IActiveTicketHolderRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    status: TicketHolderStatus;
    hasPayStub: boolean | undefined;
}

export enum ActivityDirection {
    Incoming = 0,
    Outgoing = 1,
}

export enum ActivityServiceType {
    Outreach = 1,
    EligibilityCheckingConfirmation = 2,
    IWPDevelopment = 3,
    ResumeDevelopment = 101,
    GoalSettingCareerPlanning = 102,
    JobSearch = 103,
    JobCoaching = 104,
    JobPlacement = 105,
    JobStabilizationRetention = 106,
    WorkplaceAccommodationAssistance = 107,
    WageWorkIncentiveSupport = 108,
    CareerAdvancement = 109,
    BenefitsCounseling = 110,
    TicketUnassignment = 111,
}

export enum ActivityStatus {
    Common_New = 100,
    Common_Pending = 101,
    Common_Completed = 102,
    Common_Failed = 103,
    Common_Queued = 104,
    Common_Sent = 105,
    Common_Delivered = 106,
    Common_Read = 107,
    Common_Typing = 108,
    Common_Bounced = 109,
    Common_Unsubscribed = 110,
    Common_Clicked = 111,
    Common_Preparing = 112,
    Common_Unknown = 113,
    Common_Canceled = 114,
    Common_OptOut = 115,
    Common_SentFax = 116,
    Common_ReceivedFax = 117,
    Common_OptIn = 118,
    Phone_NoAnswerLeftVoiceMessage = 200,
    Phone_NoAnswerVoicemailNotSetup = 201,
    Phone_NoAnswerVoicemailFull = 202,
    Phone_SuccessInterested = 203,
    Phone_SuccessNotInterested = 204,
    Phone_SuccessAlreadyWorking = 205,
    Phone_SuccessNeedsTimeToDecide = 206,
    Phone_SuccessFollowUpScheduled = 207,
    Phone_SuccessRequestedCallBackLater = 208,
    Phone_SuccessCheckingIwpEligibility = 209,
    Phone_SuccessWaitingIwpSignature = 210,
    Phone_SuccessIwpSigned = 211,
    Phone_SuccessSignedWithVr = 212,
    Phone_SuccessSignedWithAnotherEn = 213,
    Phone_InvalidNumber = 214,
    Phone_DisconnectedNumber = 215,
    Phone_WrongPerson = 216,
    Phone_HangUp = 217,
    Phone_Busy = 218,
    Phone_NoAnswer = 219,
    Phone_DialFailed = 220,
    Phone_TechnicalError = 221,
    Phone_OptOut = 222,
    SMS_SentText = 300,
    SMS_TextingOptOut = 301,
    SMS_Queued = 302,
    SMS_Sending = 303,
    SMS_Sent = 304,
    SMS_Delivered = 305,
    SMS_Undelivered = 306,
    SMS_Failed = 307,
    SMS_Receiving = 308,
    SMS_Received = 309,
    SMS_Accepted = 310,
    SMS_Scheduled = 311,
    SMS_Read = 312,
    Email_Sent = 400,
    Email_Outgoing_Error = 401,
    Email_Incoming = 402,
    Mail_Out_Draft = 500,
    Mail_Out_Pending = 501,
    Mail_Out_ReviewRejected = 502,
    Mail_Out_ReviewApproved = 503,
    Mail_Out_Sent = 504,
    Mail_Out_Canceled = 505,
    Mail_In_Received = 506,
    Fax_Draft = 600,
    Fax_Queued = 601,
    Fax_Sending = 602,
    Fax_Sent = 603,
    Fax_Delivered = 604,
    Fax_Failed = 605,
    Fax_Canceled = 606,
    Fax_Retry = 607,
    Fax_Received = 608,
    Fax_PartiallyDelivered = 609,
    Fax_Unknown = 610,
    Eligibility_DoesNotQualify = 700,
    Eligibility_UnableToWork = 701,
    Eligibility_NotReceivingBenefit = 702,
    Eligibility_NotAgeAppropriate = 703,
    Eligibility_EnrolledWithAnotherEN = 704,
    Eligibility_DuplicatedRecord = 705,
    Eligibility_AssignedElsewhere = 706,
    Eligibility_ReferredToStateVR = 707,
    Eligibility_NotInterested = 708,
    Eligibility_WishesToValidate = 709,
    Eligibility_NotAssignableAlreadyAssigned = 710,
    Eligibility_NotAssignableInUseWithStateVR = 711,
    Eligibility_NotAssignableTerminatedFromTTW = 712,
    Eligibility_NotAssignableOther = 713,
    Eligibility_NotAssignableNotEligibleForTTW = 714,
    Chat_Sent = 800,
    Chat_Delivered = 801,
    Chat_Read = 802,
    Chat_Failed = 803,
    Chat_Recieved = 804,
    Pii_PendingReview = 900,
    Pii_Approved = 901,
    Pii_Rejected = 902,
}

export class AddDocumentTemplateDetailsDto implements IAddDocumentTemplateDetailsDto {
    templateId!: number;
    languageId!: number | undefined;
    subject!: string | undefined;
    bodyContent!: string;
    isBodyHtml!: boolean;
    attachments!: string[] | undefined;

    constructor(data?: IAddDocumentTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): AddDocumentTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddDocumentTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        return data;
    }
}

export interface IAddDocumentTemplateDetailsDto {
    templateId: number;
    languageId: number | undefined;
    subject: string | undefined;
    bodyContent: string;
    isBodyHtml: boolean;
    attachments: string[] | undefined;
}

export class AddMarketingEventParticipantsInput implements IAddMarketingEventParticipantsInput {
    eventId!: number;
    organizationIds!: number[] | undefined;
    contactIds!: number[] | undefined;
    includeContacts!: boolean;
    participationType!: MarketingParticipationType;

    constructor(data?: IAddMarketingEventParticipantsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            this.includeContacts = _data["includeContacts"];
            this.participationType = _data["participationType"];
        }
    }

    static fromJS(data: any): AddMarketingEventParticipantsInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddMarketingEventParticipantsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        data["includeContacts"] = this.includeContacts;
        data["participationType"] = this.participationType;
        return data;
    }
}

export interface IAddMarketingEventParticipantsInput {
    eventId: number;
    organizationIds: number[] | undefined;
    contactIds: number[] | undefined;
    includeContacts: boolean;
    participationType: MarketingParticipationType;
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data;
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddSupportTicketCommentDto implements IAddSupportTicketCommentDto {
    ticketId!: number;
    htmlContent!: string | undefined;

    constructor(data?: IAddSupportTicketCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.htmlContent = _data["htmlContent"];
        }
    }

    static fromJS(data: any): AddSupportTicketCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddSupportTicketCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["htmlContent"] = this.htmlContent;
        return data;
    }
}

export interface IAddSupportTicketCommentDto {
    ticketId: number;
    htmlContent: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.pageId = _data["pageId"];
            this.dashboardName = _data["dashboardName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class AdditionalBenefitDto implements IAdditionalBenefitDto {
    id!: number | undefined;
    benefitName!: string | undefined;
    comments!: string | undefined;

    constructor(data?: IAdditionalBenefitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitName = _data["benefitName"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AdditionalBenefitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalBenefitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitName"] = this.benefitName;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IAdditionalBenefitDto {
    id: number | undefined;
    benefitName: string | undefined;
    comments: string | undefined;
}

export class AddressDto implements IAddressDto {
    id!: number;
    leadId!: number;
    street!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    zipCode!: string | undefined;
    timeZone!: USATimeZone;
    addressType!: AddressType;
    isVerifiedByUSPS!: boolean | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.timeZone = _data["timeZone"];
            this.addressType = _data["addressType"];
            this.isVerifiedByUSPS = _data["isVerifiedByUSPS"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["timeZone"] = this.timeZone;
        data["addressType"] = this.addressType;
        data["isVerifiedByUSPS"] = this.isVerifiedByUSPS;
        return data;
    }
}

export interface IAddressDto {
    id: number;
    leadId: number;
    street: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    zipCode: string | undefined;
    timeZone: USATimeZone;
    addressType: AddressType;
    isVerifiedByUSPS: boolean | undefined;
}

export enum AddressType {
    Residential = 1,
    Business = 2,
    Mailing = 4,
    Billing = 8,
    Shipping = 16,
    Work = 32,
    Temporary = 64,
    Permanent = 128,
    POBox = 256,
    Military = 512,
    Other = 1024,
}

export class AdminSurveyDto implements IAdminSurveyDto {
    id!: number;
    title!: string;
    description!: string | undefined;
    isActive!: boolean;

    constructor(data?: IAdminSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AdminSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAdminSurveyDto {
    id: number;
    title: string;
    description: string | undefined;
    isActive: boolean;
}

export class AdvancedSearchFieldInfo implements IAdvancedSearchFieldInfo {
    fieldName!: string | undefined;
    fieldType!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IAdvancedSearchFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AdvancedSearchFieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchFieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAdvancedSearchFieldInfo {
    fieldName: string | undefined;
    fieldType: string | undefined;
    displayName: string | undefined;
}

export class AdvancedSearchResultDto implements IAdvancedSearchResultDto {
    id!: number;
    clientType!: ClientType;
    clientId!: string | undefined;
    emailId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    readonly fullName!: string | undefined;
    phoneNumber!: string | undefined;
    fullAddress!: string | undefined;

    constructor(data?: IAdvancedSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientType = _data["clientType"];
            this.clientId = _data["clientId"];
            this.emailId = _data["emailId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.fullAddress = _data["fullAddress"];
        }
    }

    static fromJS(data: any): AdvancedSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientType"] = this.clientType;
        data["clientId"] = this.clientId;
        data["emailId"] = this.emailId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["fullAddress"] = this.fullAddress;
        return data;
    }
}

export interface IAdvancedSearchResultDto {
    id: number;
    clientType: ClientType;
    clientId: string | undefined;
    emailId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    fullAddress: string | undefined;
}

export class AdvocacyServiceRequestDto implements IAdvocacyServiceRequestDto {
    id!: number;
    ticketHolderId!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    requestState!: string;
    sendToEmail!: boolean;
    email!: string | undefined;
    sendToMailbox!: boolean;
    mailAddressLine1!: string | undefined;
    mailAddressLine2!: string | undefined;
    mailCity!: string | undefined;
    mailState!: string | undefined;
    mailZip!: string | undefined;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: IAdvocacyServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.requestState = _data["requestState"];
            this.sendToEmail = _data["sendToEmail"];
            this.email = _data["email"];
            this.sendToMailbox = _data["sendToMailbox"];
            this.mailAddressLine1 = _data["mailAddressLine1"];
            this.mailAddressLine2 = _data["mailAddressLine2"];
            this.mailCity = _data["mailCity"];
            this.mailState = _data["mailState"];
            this.mailZip = _data["mailZip"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AdvocacyServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvocacyServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["requestState"] = this.requestState;
        data["sendToEmail"] = this.sendToEmail;
        data["email"] = this.email;
        data["sendToMailbox"] = this.sendToMailbox;
        data["mailAddressLine1"] = this.mailAddressLine1;
        data["mailAddressLine2"] = this.mailAddressLine2;
        data["mailCity"] = this.mailCity;
        data["mailState"] = this.mailState;
        data["mailZip"] = this.mailZip;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface IAdvocacyServiceRequestDto {
    id: number;
    ticketHolderId: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    requestState: string;
    sendToEmail: boolean;
    email: string | undefined;
    sendToMailbox: boolean;
    mailAddressLine1: string | undefined;
    mailAddressLine2: string | undefined;
    mailCity: string | undefined;
    mailState: string | undefined;
    mailZip: string | undefined;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class AiCostInvoiceDto implements IAiCostInvoiceDto {
    totalTokens!: number;
    totalDurationMs!: number;
    totalCost!: number;
    providers!: ProviderUsageDto[] | undefined;

    constructor(data?: IAiCostInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTokens = _data["totalTokens"];
            this.totalDurationMs = _data["totalDurationMs"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(ProviderUsageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AiCostInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiCostInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTokens"] = this.totalTokens;
        data["totalDurationMs"] = this.totalDurationMs;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAiCostInvoiceDto {
    totalTokens: number;
    totalDurationMs: number;
    totalCost: number;
    providers: ProviderUsageDto[] | undefined;
}

export class AiCostInvoiceInputDto implements IAiCostInvoiceInputDto {
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    provider!: string | undefined;
    model!: string | undefined;

    constructor(data?: IAiCostInvoiceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiCostInvoiceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiCostInvoiceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toString() : <any>undefined;
        data["provider"] = this.provider;
        data["model"] = this.model;
        return data;
    }
}

export interface IAiCostInvoiceInputDto {
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    provider: string | undefined;
    model: string | undefined;
}

export class AiVoiceAgentDto implements IAiVoiceAgentDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    provider!: AiVoiceAgentProvider;
    apiClientId!: string | undefined;
    apiSecret!: string | undefined;
    outboundApiKey!: string | undefined;
    fromPhoneNumber!: string | undefined;
    isActive!: boolean;
    tenantId!: number;
    tenantName!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IAiVoiceAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.provider = _data["provider"];
            this.apiClientId = _data["apiClientId"];
            this.apiSecret = _data["apiSecret"];
            this.outboundApiKey = _data["outboundApiKey"];
            this.fromPhoneNumber = _data["fromPhoneNumber"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any): AiVoiceAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiVoiceAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["provider"] = this.provider;
        data["apiClientId"] = this.apiClientId;
        data["apiSecret"] = this.apiSecret;
        data["outboundApiKey"] = this.outboundApiKey;
        data["fromPhoneNumber"] = this.fromPhoneNumber;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IAiVoiceAgentDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    provider: AiVoiceAgentProvider;
    apiClientId: string | undefined;
    apiSecret: string | undefined;
    outboundApiKey: string | undefined;
    fromPhoneNumber: string | undefined;
    isActive: boolean;
    tenantId: number;
    tenantName: string | undefined;
    creationTime: string | undefined;
}

export class AiVoiceAgentOptionDto implements IAiVoiceAgentOptionDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    provider!: AiVoiceAgentProvider;
    fromPhoneNumber!: string | undefined;
    isFullyConfigured!: boolean;

    constructor(data?: IAiVoiceAgentOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.provider = _data["provider"];
            this.fromPhoneNumber = _data["fromPhoneNumber"];
            this.isFullyConfigured = _data["isFullyConfigured"];
        }
    }

    static fromJS(data: any): AiVoiceAgentOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiVoiceAgentOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["provider"] = this.provider;
        data["fromPhoneNumber"] = this.fromPhoneNumber;
        data["isFullyConfigured"] = this.isFullyConfigured;
        return data;
    }
}

export interface IAiVoiceAgentOptionDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    provider: AiVoiceAgentProvider;
    fromPhoneNumber: string | undefined;
    isFullyConfigured: boolean;
}

export enum AiVoiceAgentProvider {
    OpenAI = 10,
    ElevenLabs = 20,
    Vapi = 30,
    RetellAI = 40,
    BlandAI = 50,
    Synthflow = 60,
    Deepgram = 70,
    PolyAI = 80,
    PlayAI = 90,
    Voiceflow = 100,
}

export class AllJobSearchRequestDto implements IAllJobSearchRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    isClosed!: boolean | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    jobSearchStatusFilters!: JobSearchRequestStatus[] | undefined;
    assignedToUserIds!: number[] | undefined;
    preferredDayOfWeekFilters!: WeekDays[] | undefined;
    searchRequestedByFilters!: number[] | undefined;

    constructor(data?: IAllJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.isClosed = _data["isClosed"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["jobSearchStatusFilters"])) {
                this.jobSearchStatusFilters = [] as any;
                for (let item of _data["jobSearchStatusFilters"])
                    this.jobSearchStatusFilters!.push(item);
            }
            if (Array.isArray(_data["assignedToUserIds"])) {
                this.assignedToUserIds = [] as any;
                for (let item of _data["assignedToUserIds"])
                    this.assignedToUserIds!.push(item);
            }
            if (Array.isArray(_data["preferredDayOfWeekFilters"])) {
                this.preferredDayOfWeekFilters = [] as any;
                for (let item of _data["preferredDayOfWeekFilters"])
                    this.preferredDayOfWeekFilters!.push(item);
            }
            if (Array.isArray(_data["searchRequestedByFilters"])) {
                this.searchRequestedByFilters = [] as any;
                for (let item of _data["searchRequestedByFilters"])
                    this.searchRequestedByFilters!.push(item);
            }
        }
    }

    static fromJS(data: any): AllJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["isClosed"] = this.isClosed;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        if (Array.isArray(this.jobSearchStatusFilters)) {
            data["jobSearchStatusFilters"] = [];
            for (let item of this.jobSearchStatusFilters)
                data["jobSearchStatusFilters"].push(item);
        }
        if (Array.isArray(this.assignedToUserIds)) {
            data["assignedToUserIds"] = [];
            for (let item of this.assignedToUserIds)
                data["assignedToUserIds"].push(item);
        }
        if (Array.isArray(this.preferredDayOfWeekFilters)) {
            data["preferredDayOfWeekFilters"] = [];
            for (let item of this.preferredDayOfWeekFilters)
                data["preferredDayOfWeekFilters"].push(item);
        }
        if (Array.isArray(this.searchRequestedByFilters)) {
            data["searchRequestedByFilters"] = [];
            for (let item of this.searchRequestedByFilters)
                data["searchRequestedByFilters"].push(item);
        }
        return data;
    }
}

export interface IAllJobSearchRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    isClosed: boolean | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    jobSearchStatusFilters: JobSearchRequestStatus[] | undefined;
    assignedToUserIds: number[] | undefined;
    preferredDayOfWeekFilters: WeekDays[] | undefined;
    searchRequestedByFilters: number[] | undefined;
}

export class AllJobSearchResponseDto implements IAllJobSearchResponseDto {
    id!: number;
    jobSearchKeywords!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    readonly enumDisplayWorkArrangement!: string | undefined;
    jobSearchType!: JobSearchType;
    readonly enumDisplayJobSearchType!: string | undefined;
    isSalaryRangeHourly!: boolean;
    salaryRangeStart!: number | undefined;
    salaryRangeEnd!: number | undefined;
    notes!: NoteEntry[] | undefined;
    status!: JobSearchRequestStatus;
    readonly enumDisplayJobSearchRequest!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    jobLeadsCount!: number;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    desiredJobCount!: number | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    jobSearchRequestId!: string | undefined;
    readonly formattedJobSearchRequestId!: string | undefined;
    sentJobLeadToTHCount!: number;
    formattedTicketHolderId!: string | undefined;
    currentRound!: number;
    latestRoundCreationTime!: DateTime | undefined;
    skillsQualifications!: string | undefined;
    instructions!: string | undefined;
    maxTravelDistance!: number | undefined;
    maxTravelTime!: number | undefined;
    totalRounds!: number;
    ticketHolderStatus!: TicketHolderStatus;
    readonly enumDisplayTicketHolderStatus!: string | undefined;
    ticketHolderDoB!: DateTime | undefined;
    ticketHolderStateAbbreviation!: string | undefined;
    ccNotes!: string | undefined;
    ticketHolderEmail!: string | undefined;
    preferredDayOfWeek!: WeekDays;
    enumPreferredDayOfWeek!: string | undefined;
    roundSummaries!: RoundLeadSummaryDto[] | undefined;
    searchRequestedBy!: number;
    searchRequestedByName!: string | undefined;

    constructor(data?: IAllJobSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobSearchKeywords = _data["jobSearchKeywords"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            (<any>this).enumDisplayWorkArrangement = _data["enumDisplayWorkArrangement"];
            this.jobSearchType = _data["jobSearchType"];
            (<any>this).enumDisplayJobSearchType = _data["enumDisplayJobSearchType"];
            this.isSalaryRangeHourly = _data["isSalaryRangeHourly"];
            this.salaryRangeStart = _data["salaryRangeStart"];
            this.salaryRangeEnd = _data["salaryRangeEnd"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteEntry.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).enumDisplayJobSearchRequest = _data["enumDisplayJobSearchRequest"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.jobLeadsCount = _data["jobLeadsCount"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.desiredJobCount = _data["desiredJobCount"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            (<any>this).formattedJobSearchRequestId = _data["formattedJobSearchRequestId"];
            this.sentJobLeadToTHCount = _data["sentJobLeadToTHCount"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.currentRound = _data["currentRound"];
            this.latestRoundCreationTime = _data["latestRoundCreationTime"] ? DateTime.fromISO(_data["latestRoundCreationTime"].toString()) : <any>undefined;
            this.skillsQualifications = _data["skillsQualifications"];
            this.instructions = _data["instructions"];
            this.maxTravelDistance = _data["maxTravelDistance"];
            this.maxTravelTime = _data["maxTravelTime"];
            this.totalRounds = _data["totalRounds"];
            this.ticketHolderStatus = _data["ticketHolderStatus"];
            (<any>this).enumDisplayTicketHolderStatus = _data["enumDisplayTicketHolderStatus"];
            this.ticketHolderDoB = _data["ticketHolderDoB"] ? DateTime.fromISO(_data["ticketHolderDoB"].toString()) : <any>undefined;
            this.ticketHolderStateAbbreviation = _data["ticketHolderStateAbbreviation"];
            this.ccNotes = _data["ccNotes"];
            this.ticketHolderEmail = _data["ticketHolderEmail"];
            this.preferredDayOfWeek = _data["preferredDayOfWeek"];
            this.enumPreferredDayOfWeek = _data["enumPreferredDayOfWeek"];
            if (Array.isArray(_data["roundSummaries"])) {
                this.roundSummaries = [] as any;
                for (let item of _data["roundSummaries"])
                    this.roundSummaries!.push(RoundLeadSummaryDto.fromJS(item));
            }
            this.searchRequestedBy = _data["searchRequestedBy"];
            this.searchRequestedByName = _data["searchRequestedByName"];
        }
    }

    static fromJS(data: any): AllJobSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllJobSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobSearchKeywords"] = this.jobSearchKeywords;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["enumDisplayWorkArrangement"] = this.enumDisplayWorkArrangement;
        data["jobSearchType"] = this.jobSearchType;
        data["enumDisplayJobSearchType"] = this.enumDisplayJobSearchType;
        data["isSalaryRangeHourly"] = this.isSalaryRangeHourly;
        data["salaryRangeStart"] = this.salaryRangeStart;
        data["salaryRangeEnd"] = this.salaryRangeEnd;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["enumDisplayJobSearchRequest"] = this.enumDisplayJobSearchRequest;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["jobLeadsCount"] = this.jobLeadsCount;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["desiredJobCount"] = this.desiredJobCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["formattedJobSearchRequestId"] = this.formattedJobSearchRequestId;
        data["sentJobLeadToTHCount"] = this.sentJobLeadToTHCount;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["currentRound"] = this.currentRound;
        data["latestRoundCreationTime"] = this.latestRoundCreationTime ? this.latestRoundCreationTime.toString() : <any>undefined;
        data["skillsQualifications"] = this.skillsQualifications;
        data["instructions"] = this.instructions;
        data["maxTravelDistance"] = this.maxTravelDistance;
        data["maxTravelTime"] = this.maxTravelTime;
        data["totalRounds"] = this.totalRounds;
        data["ticketHolderStatus"] = this.ticketHolderStatus;
        data["enumDisplayTicketHolderStatus"] = this.enumDisplayTicketHolderStatus;
        data["ticketHolderDoB"] = this.ticketHolderDoB ? this.ticketHolderDoB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ticketHolderStateAbbreviation"] = this.ticketHolderStateAbbreviation;
        data["ccNotes"] = this.ccNotes;
        data["ticketHolderEmail"] = this.ticketHolderEmail;
        data["preferredDayOfWeek"] = this.preferredDayOfWeek;
        data["enumPreferredDayOfWeek"] = this.enumPreferredDayOfWeek;
        if (Array.isArray(this.roundSummaries)) {
            data["roundSummaries"] = [];
            for (let item of this.roundSummaries)
                data["roundSummaries"].push(item.toJSON());
        }
        data["searchRequestedBy"] = this.searchRequestedBy;
        data["searchRequestedByName"] = this.searchRequestedByName;
        return data;
    }
}

export interface IAllJobSearchResponseDto {
    id: number;
    jobSearchKeywords: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    enumDisplayWorkArrangement: string | undefined;
    jobSearchType: JobSearchType;
    enumDisplayJobSearchType: string | undefined;
    isSalaryRangeHourly: boolean;
    salaryRangeStart: number | undefined;
    salaryRangeEnd: number | undefined;
    notes: NoteEntry[] | undefined;
    status: JobSearchRequestStatus;
    enumDisplayJobSearchRequest: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    jobLeadsCount: number;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    desiredJobCount: number | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    jobSearchRequestId: string | undefined;
    formattedJobSearchRequestId: string | undefined;
    sentJobLeadToTHCount: number;
    formattedTicketHolderId: string | undefined;
    currentRound: number;
    latestRoundCreationTime: DateTime | undefined;
    skillsQualifications: string | undefined;
    instructions: string | undefined;
    maxTravelDistance: number | undefined;
    maxTravelTime: number | undefined;
    totalRounds: number;
    ticketHolderStatus: TicketHolderStatus;
    enumDisplayTicketHolderStatus: string | undefined;
    ticketHolderDoB: DateTime | undefined;
    ticketHolderStateAbbreviation: string | undefined;
    ccNotes: string | undefined;
    ticketHolderEmail: string | undefined;
    preferredDayOfWeek: WeekDays;
    enumPreferredDayOfWeek: string | undefined;
    roundSummaries: RoundLeadSummaryDto[] | undefined;
    searchRequestedBy: number;
    searchRequestedByName: string | undefined;
}

export class AllowedJobStatusDto implements IAllowedJobStatusDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAllowedJobStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AllowedJobStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowedJobStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAllowedJobStatusDto {
    id: number;
    name: string | undefined;
}

export class AlternateView implements IAlternateView {
    readonly contentStream!: string | undefined;
    contentId!: string | undefined;
    contentType!: ContentType;
    transferEncoding!: TransferEncoding;
    readonly linkedResources!: LinkedResource[] | undefined;
    baseUri!: string | undefined;

    constructor(data?: IAlternateView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).contentStream = _data["contentStream"];
            this.contentId = _data["contentId"];
            this.contentType = _data["contentType"] ? ContentType.fromJS(_data["contentType"]) : <any>undefined;
            this.transferEncoding = _data["transferEncoding"];
            if (Array.isArray(_data["linkedResources"])) {
                (<any>this).linkedResources = [] as any;
                for (let item of _data["linkedResources"])
                    (<any>this).linkedResources!.push(LinkedResource.fromJS(item));
            }
            this.baseUri = _data["baseUri"];
        }
    }

    static fromJS(data: any): AlternateView {
        data = typeof data === 'object' ? data : {};
        let result = new AlternateView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStream"] = this.contentStream;
        data["contentId"] = this.contentId;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        data["transferEncoding"] = this.transferEncoding;
        if (Array.isArray(this.linkedResources)) {
            data["linkedResources"] = [];
            for (let item of this.linkedResources)
                data["linkedResources"].push(item.toJSON());
        }
        data["baseUri"] = this.baseUri;
        return data;
    }
}

export interface IAlternateView {
    contentStream: string | undefined;
    contentId: string | undefined;
    contentType: ContentType;
    transferEncoding: TransferEncoding;
    linkedResources: LinkedResource[] | undefined;
    baseUri: string | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    passwordlessLoginCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            this.passwordlessLoginCodeExpireSeconds = _data["passwordlessLoginCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        data["passwordlessLoginCodeExpireSeconds"] = this.passwordlessLoginCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    passwordlessLoginCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
}

export class ApplyChecklistTemplateInput implements IApplyChecklistTemplateInput {
    eventId!: number;
    templateId!: number;

    constructor(data?: IApplyChecklistTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): ApplyChecklistTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyChecklistTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IApplyChecklistTemplateInput {
    eventId: number;
    templateId: number;
}

export class Assembly implements IAssembly {
    readonly definedTypes!: TypeInfo[] | undefined;
    readonly exportedTypes!: Type[] | undefined;
    readonly codeBase!: string | undefined;
    entryPoint!: MethodInfo;
    readonly fullName!: string | undefined;
    readonly imageRuntimeVersion!: string | undefined;
    readonly isDynamic!: boolean;
    readonly location!: string | undefined;
    readonly reflectionOnly!: boolean;
    readonly isCollectible!: boolean;
    readonly isFullyTrusted!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly escapedCodeBase!: string | undefined;
    manifestModule!: Module;
    readonly modules!: Module[] | undefined;
    readonly globalAssemblyCache!: boolean;
    readonly hostContext!: number;
    securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item.toJSON());
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes: TypeInfo[] | undefined;
    exportedTypes: Type[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class AssignCareerCoachDto implements IAssignCareerCoachDto {
    leadId!: number;
    careerCoachUserId!: number;

    constructor(data?: IAssignCareerCoachDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.careerCoachUserId = _data["careerCoachUserId"];
        }
    }

    static fromJS(data: any): AssignCareerCoachDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCareerCoachDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["careerCoachUserId"] = this.careerCoachUserId;
        return data;
    }
}

export interface IAssignCareerCoachDto {
    leadId: number;
    careerCoachUserId: number;
}

export class AssignReinstatementDto implements IAssignReinstatementDto {
    reinstatementId!: number;
    reasonOrNote!: string | undefined;
    status!: ReinstatementStatus;
    cwicUserId!: number;

    constructor(data?: IAssignReinstatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reinstatementId = _data["reinstatementId"];
            this.reasonOrNote = _data["reasonOrNote"];
            this.status = _data["status"];
            this.cwicUserId = _data["cwicUserId"];
        }
    }

    static fromJS(data: any): AssignReinstatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignReinstatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reinstatementId"] = this.reinstatementId;
        data["reasonOrNote"] = this.reasonOrNote;
        data["status"] = this.status;
        data["cwicUserId"] = this.cwicUserId;
        return data;
    }
}

export interface IAssignReinstatementDto {
    reinstatementId: number;
    reasonOrNote: string | undefined;
    status: ReinstatementStatus;
    cwicUserId: number;
}

export class AssignSupportTicketDto implements IAssignSupportTicketDto {
    ticketId!: number;
    assignedUserId!: number | undefined;

    constructor(data?: IAssignSupportTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.assignedUserId = _data["assignedUserId"];
        }
    }

    static fromJS(data: any): AssignSupportTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSupportTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["assignedUserId"] = this.assignedUserId;
        return data;
    }
}

export interface IAssignSupportTicketDto {
    ticketId: number;
    assignedUserId: number | undefined;
}

export class AssignTicketHolderWageProcessingReportQDto implements IAssignTicketHolderWageProcessingReportQDto {
    id!: number;
    ticketHolderId!: number;
    isPaystub!: boolean;
    fromSource!: TicketHolderFileSource;

    constructor(data?: IAssignTicketHolderWageProcessingReportQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.isPaystub = _data["isPaystub"];
            this.fromSource = _data["fromSource"];
        }
    }

    static fromJS(data: any): AssignTicketHolderWageProcessingReportQDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignTicketHolderWageProcessingReportQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["isPaystub"] = this.isPaystub;
        data["fromSource"] = this.fromSource;
        return data;
    }
}

export interface IAssignTicketHolderWageProcessingReportQDto {
    id: number;
    ticketHolderId: number;
    isPaystub: boolean;
    fromSource: TicketHolderFileSource;
}

export enum AssignabilityReasonCode {
    PendingToVerify = 0,
    Assignable = 1,
    Assigned = 2,
    InUseSVR = 3,
    NotAssignable = 4,
    NotEligible = 5,
    Terminated = 6,
    MaxTimeInuse = 7,
    InActive = 8,
    Withdrawn = 9,
}

export class AssignabilityStatusCountDto implements IAssignabilityStatusCountDto {
    total!: number;
    pendingToVerify!: number;
    assignable!: number;
    assigned!: number;
    inUseSVR!: number;
    notAssignable!: number;
    notEligible!: number;
    terminated!: number;
    maxTimeInuse!: number;
    inActive!: number;
    withdrawn!: number;

    constructor(data?: IAssignabilityStatusCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.pendingToVerify = _data["pendingToVerify"];
            this.assignable = _data["assignable"];
            this.assigned = _data["assigned"];
            this.inUseSVR = _data["inUseSVR"];
            this.notAssignable = _data["notAssignable"];
            this.notEligible = _data["notEligible"];
            this.terminated = _data["terminated"];
            this.maxTimeInuse = _data["maxTimeInuse"];
            this.inActive = _data["inActive"];
            this.withdrawn = _data["withdrawn"];
        }
    }

    static fromJS(data: any): AssignabilityStatusCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignabilityStatusCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["pendingToVerify"] = this.pendingToVerify;
        data["assignable"] = this.assignable;
        data["assigned"] = this.assigned;
        data["inUseSVR"] = this.inUseSVR;
        data["notAssignable"] = this.notAssignable;
        data["notEligible"] = this.notEligible;
        data["terminated"] = this.terminated;
        data["maxTimeInuse"] = this.maxTimeInuse;
        data["inActive"] = this.inActive;
        data["withdrawn"] = this.withdrawn;
        return data;
    }
}

export interface IAssignabilityStatusCountDto {
    total: number;
    pendingToVerify: number;
    assignable: number;
    assigned: number;
    inUseSVR: number;
    notAssignable: number;
    notEligible: number;
    terminated: number;
    maxTimeInuse: number;
    inActive: number;
    withdrawn: number;
}

export class AssignedWageReportDto implements IAssignedWageReportDto {
    id!: number;
    ticketHolderName!: string | undefined;
    ticketHolderId!: string | undefined;
    wageFileName!: string | undefined;
    maskedSSN!: string | undefined;
    fromSource!: TicketHolderFileSource;
    readonly enumDisplayNameFromSource!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    payDate!: DateTime | undefined;
    payPeriodStart!: DateTime | undefined;
    payPeriodEnd!: DateTime | undefined;

    constructor(data?: IAssignedWageReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.wageFileName = _data["wageFileName"];
            this.maskedSSN = _data["maskedSSN"];
            this.fromSource = _data["fromSource"];
            (<any>this).enumDisplayNameFromSource = _data["enumDisplayNameFromSource"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignedWageReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedWageReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["wageFileName"] = this.wageFileName;
        data["maskedSSN"] = this.maskedSSN;
        data["fromSource"] = this.fromSource;
        data["enumDisplayNameFromSource"] = this.enumDisplayNameFromSource;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IAssignedWageReportDto {
    id: number;
    ticketHolderName: string | undefined;
    ticketHolderId: string | undefined;
    wageFileName: string | undefined;
    maskedSSN: string | undefined;
    fromSource: TicketHolderFileSource;
    enumDisplayNameFromSource: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    payDate: DateTime | undefined;
    payPeriodStart: DateTime | undefined;
    payPeriodEnd: DateTime | undefined;
}

export class AssigneeTicketHolderCount implements IAssigneeTicketHolderCount {
    assigneeId!: number | undefined;
    assigneeName!: string | undefined;
    count!: number;

    constructor(data?: IAssigneeTicketHolderCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigneeId = _data["assigneeId"];
            this.assigneeName = _data["assigneeName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AssigneeTicketHolderCount {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeTicketHolderCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigneeId"] = this.assigneeId;
        data["assigneeName"] = this.assigneeName;
        data["count"] = this.count;
        return data;
    }
}

export interface IAssigneeTicketHolderCount {
    assigneeId: number | undefined;
    assigneeName: string | undefined;
    count: number;
}

export class AssigneeTicketHolderCountDto implements IAssigneeTicketHolderCountDto {
    totalCount!: number;
    unAssignedCount!: number;
    assignedCount!: number;
    assigneeInfo!: AssigneeTicketHolderCount[] | undefined;

    constructor(data?: IAssigneeTicketHolderCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.unAssignedCount = _data["unAssignedCount"];
            this.assignedCount = _data["assignedCount"];
            if (Array.isArray(_data["assigneeInfo"])) {
                this.assigneeInfo = [] as any;
                for (let item of _data["assigneeInfo"])
                    this.assigneeInfo!.push(AssigneeTicketHolderCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssigneeTicketHolderCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeTicketHolderCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["unAssignedCount"] = this.unAssignedCount;
        data["assignedCount"] = this.assignedCount;
        if (Array.isArray(this.assigneeInfo)) {
            data["assigneeInfo"] = [];
            for (let item of this.assigneeInfo)
                data["assigneeInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssigneeTicketHolderCountDto {
    totalCount: number;
    unAssignedCount: number;
    assignedCount: number;
    assigneeInfo: AssigneeTicketHolderCount[] | undefined;
}

export class Attachment implements IAttachment {
    readonly contentStream!: string | undefined;
    contentId!: string | undefined;
    contentType!: ContentType;
    transferEncoding!: TransferEncoding;
    name!: string | undefined;
    nameEncoding!: Encoding;
    contentDisposition!: ContentDisposition;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).contentStream = _data["contentStream"];
            this.contentId = _data["contentId"];
            this.contentType = _data["contentType"] ? ContentType.fromJS(_data["contentType"]) : <any>undefined;
            this.transferEncoding = _data["transferEncoding"];
            this.name = _data["name"];
            this.nameEncoding = _data["nameEncoding"] ? Encoding.fromJS(_data["nameEncoding"]) : <any>undefined;
            this.contentDisposition = _data["contentDisposition"] ? ContentDisposition.fromJS(_data["contentDisposition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStream"] = this.contentStream;
        data["contentId"] = this.contentId;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        data["transferEncoding"] = this.transferEncoding;
        data["name"] = this.name;
        data["nameEncoding"] = this.nameEncoding ? this.nameEncoding.toJSON() : <any>undefined;
        data["contentDisposition"] = this.contentDisposition ? this.contentDisposition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAttachment {
    contentStream: string | undefined;
    contentId: string | undefined;
    contentType: ContentType;
    transferEncoding: TransferEncoding;
    name: string | undefined;
    nameEncoding: Encoding;
    contentDisposition: ContentDisposition;
}

export class AuditLogListDto implements IAuditLogListDto {
    id!: number;
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        return data;
    }
}

export interface IAuditLogListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    requiresTwoFactorSetup!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    c!: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            this.requiresTwoFactorSetup = _data["requiresTwoFactorSetup"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        data["requiresTwoFactorSetup"] = this.requiresTwoFactorSetup;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["c"] = this.c;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    requiresTwoFactorSetup: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    c: string | undefined;
}

export class BPQYListDto implements IBPQYListDto {
    id!: number;
    ticketHolderId!: string | undefined;
    ticketHolderName!: string | undefined;
    creationTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    bpqyStatus!: BpqyRequestStatus;
    enumBpqyStatus!: string | undefined;
    ticketHolderStatus!: TicketHolderStatus;
    enumTicketHolderStatus!: string | undefined;

    constructor(data?: IBPQYListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.bpqyStatus = _data["bpqyStatus"];
            this.enumBpqyStatus = _data["enumBpqyStatus"];
            this.ticketHolderStatus = _data["ticketHolderStatus"];
            this.enumTicketHolderStatus = _data["enumTicketHolderStatus"];
        }
    }

    static fromJS(data: any): BPQYListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BPQYListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["bpqyStatus"] = this.bpqyStatus;
        data["enumBpqyStatus"] = this.enumBpqyStatus;
        data["ticketHolderStatus"] = this.ticketHolderStatus;
        data["enumTicketHolderStatus"] = this.enumTicketHolderStatus;
        return data;
    }
}

export interface IBPQYListDto {
    id: number;
    ticketHolderId: string | undefined;
    ticketHolderName: string | undefined;
    creationTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    bpqyStatus: BpqyRequestStatus;
    enumBpqyStatus: string | undefined;
    ticketHolderStatus: TicketHolderStatus;
    enumTicketHolderStatus: string | undefined;
}

export class BSAPlanningItemDto implements IBSAPlanningItemDto {
    id!: number | undefined;
    section!: BSAPlanningSection;
    subSubject!: BSAPlanningSubSubject;
    notes!: string | undefined;
    documentId!: number | undefined;
    documentName!: string | undefined;
    isCurrentlyEmployed!: boolean | undefined;
    jobTitle!: string | undefined;
    startDate!: DateTime | undefined;
    hoursOrPayInfo!: string | undefined;
    rateOfPay!: string | undefined;
    monthlyEarningsEstimate!: number | undefined;

    constructor(data?: IBSAPlanningItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.section = _data["section"];
            this.subSubject = _data["subSubject"];
            this.notes = _data["notes"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.isCurrentlyEmployed = _data["isCurrentlyEmployed"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.hoursOrPayInfo = _data["hoursOrPayInfo"];
            this.rateOfPay = _data["rateOfPay"];
            this.monthlyEarningsEstimate = _data["monthlyEarningsEstimate"];
        }
    }

    static fromJS(data: any): BSAPlanningItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BSAPlanningItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["section"] = this.section;
        data["subSubject"] = this.subSubject;
        data["notes"] = this.notes;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["isCurrentlyEmployed"] = this.isCurrentlyEmployed;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["hoursOrPayInfo"] = this.hoursOrPayInfo;
        data["rateOfPay"] = this.rateOfPay;
        data["monthlyEarningsEstimate"] = this.monthlyEarningsEstimate;
        return data;
    }
}

export interface IBSAPlanningItemDto {
    id: number | undefined;
    section: BSAPlanningSection;
    subSubject: BSAPlanningSubSubject;
    notes: string | undefined;
    documentId: number | undefined;
    documentName: string | undefined;
    isCurrentlyEmployed: boolean | undefined;
    jobTitle: string | undefined;
    startDate: DateTime | undefined;
    hoursOrPayInfo: string | undefined;
    rateOfPay: string | undefined;
    monthlyEarningsEstimate: number | undefined;
}

export class BSAPlanningRecordDto implements IBSAPlanningRecordDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    ticketHolderId!: number;
    analysisStartedAt!: DateTime | undefined;
    analysisCompletedAt!: DateTime | undefined;
    isBSAReportNeeded!: boolean | undefined;
    bsaReportNotNeededReason!: string | undefined;
    bsaPlanningAnalysisDocumentId!: number | undefined;
    items!: BSAPlanningItemDto[] | undefined;

    constructor(data?: IBSAPlanningRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.analysisStartedAt = _data["analysisStartedAt"] ? DateTime.fromISO(_data["analysisStartedAt"].toString()) : <any>undefined;
            this.analysisCompletedAt = _data["analysisCompletedAt"] ? DateTime.fromISO(_data["analysisCompletedAt"].toString()) : <any>undefined;
            this.isBSAReportNeeded = _data["isBSAReportNeeded"];
            this.bsaReportNotNeededReason = _data["bsaReportNotNeededReason"];
            this.bsaPlanningAnalysisDocumentId = _data["bsaPlanningAnalysisDocumentId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BSAPlanningItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BSAPlanningRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new BSAPlanningRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["analysisStartedAt"] = this.analysisStartedAt ? this.analysisStartedAt.toString() : <any>undefined;
        data["analysisCompletedAt"] = this.analysisCompletedAt ? this.analysisCompletedAt.toString() : <any>undefined;
        data["isBSAReportNeeded"] = this.isBSAReportNeeded;
        data["bsaReportNotNeededReason"] = this.bsaReportNotNeededReason;
        data["bsaPlanningAnalysisDocumentId"] = this.bsaPlanningAnalysisDocumentId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBSAPlanningRecordDto {
    id: number;
    benefitsCounselingCaseId: number;
    ticketHolderId: number;
    analysisStartedAt: DateTime | undefined;
    analysisCompletedAt: DateTime | undefined;
    isBSAReportNeeded: boolean | undefined;
    bsaReportNotNeededReason: string | undefined;
    bsaPlanningAnalysisDocumentId: number | undefined;
    items: BSAPlanningItemDto[] | undefined;
}

export enum BSAPlanningSection {
    CurrentSituation = 1,
    CashBenefits = 2,
    HealthInsurance = 3,
    OtherBenefits = 4,
    EmploymentServices = 5,
    OtherTopics = 6,
    ImportantThingsToRemember = 7,
    Attachments = 8,
}

export enum BSAPlanningSubSubject {
    VerifiedBenefits = 101,
    AdditionalDetails = 102,
    CurrentEmploymentSituation = 103,
    FutureEmploymentPlansAndEarningsGoals = 104,
    TitleIIWorkIncentives = 201,
    SSIWorkIncentives = 202,
    OtherCashBenefits = 203,
    Medicaid = 301,
    Medicare = 302,
    MedicarePartABFinancialAssistance = 303,
    MedicarePartDLowIncomeSubsidy = 304,
    OtherHealthInsuranceOptions = 305,
    OtherHealthInsuranceCurrentlyReceived = 306,
    OtherBenefitsReceived = 401,
    CurrentEmploymentServices = 501,
    RecommendedEmploymentServices = 502,
    OtherTopicsGeneral = 601,
    ReportingEarningsToSocialSecurity = 602,
    ReportingEarningsToOtherAgencies = 603,
    ImportantDatesOrDeadlines = 701,
    TwpEpeTrackingSheet = 801,
    SsiCalculationSheet = 802,
    MspCalculationSheet = 803,
    LisCalculationSheet = 804,
    OtherFactSheet = 805,
}

export class BSARecordDto implements IBSARecordDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    ticketHolderId!: number;
    deliveredAt!: DateTime | undefined;
    deliveryMethod!: PreferredContactMethod;
    deliveryMethodOther!: string | undefined;
    bsaDeliveryReviewDocumentId!: number | undefined;
    reviewDate!: DateTime;
    beneficiaryUnderstoodKeyPoints!: boolean | undefined;
    questionsOrConcerns!: string | undefined;
    agreedActionItems!: string | undefined;

    constructor(data?: IBSARecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.deliveredAt = _data["deliveredAt"] ? DateTime.fromISO(_data["deliveredAt"].toString()) : <any>undefined;
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryMethodOther = _data["deliveryMethodOther"];
            this.bsaDeliveryReviewDocumentId = _data["bsaDeliveryReviewDocumentId"];
            this.reviewDate = _data["reviewDate"] ? DateTime.fromISO(_data["reviewDate"].toString()) : <any>undefined;
            this.beneficiaryUnderstoodKeyPoints = _data["beneficiaryUnderstoodKeyPoints"];
            this.questionsOrConcerns = _data["questionsOrConcerns"];
            this.agreedActionItems = _data["agreedActionItems"];
        }
    }

    static fromJS(data: any): BSARecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new BSARecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["deliveredAt"] = this.deliveredAt ? this.deliveredAt.toString() : <any>undefined;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryMethodOther"] = this.deliveryMethodOther;
        data["bsaDeliveryReviewDocumentId"] = this.bsaDeliveryReviewDocumentId;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toString() : <any>undefined;
        data["beneficiaryUnderstoodKeyPoints"] = this.beneficiaryUnderstoodKeyPoints;
        data["questionsOrConcerns"] = this.questionsOrConcerns;
        data["agreedActionItems"] = this.agreedActionItems;
        return data;
    }
}

export interface IBSARecordDto {
    id: number;
    benefitsCounselingCaseId: number;
    ticketHolderId: number;
    deliveredAt: DateTime | undefined;
    deliveryMethod: PreferredContactMethod;
    deliveryMethodOther: string | undefined;
    bsaDeliveryReviewDocumentId: number | undefined;
    reviewDate: DateTime;
    beneficiaryUnderstoodKeyPoints: boolean | undefined;
    questionsOrConcerns: string | undefined;
    agreedActionItems: string | undefined;
}

export class BSAReportDto implements IBSAReportDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    ticketHolderId!: number;
    reportDate!: DateTime;
    introText!: string | undefined;
    generatedReportDocumentId!: number | undefined;
    generatedReportDocumentName!: string | undefined;
    items!: BSAReportItemDto[] | undefined;

    constructor(data?: IBSAReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : <any>undefined;
            this.introText = _data["introText"];
            this.generatedReportDocumentId = _data["generatedReportDocumentId"];
            this.generatedReportDocumentName = _data["generatedReportDocumentName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BSAReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BSAReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BSAReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : <any>undefined;
        data["introText"] = this.introText;
        data["generatedReportDocumentId"] = this.generatedReportDocumentId;
        data["generatedReportDocumentName"] = this.generatedReportDocumentName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBSAReportDto {
    id: number;
    benefitsCounselingCaseId: number;
    ticketHolderId: number;
    reportDate: DateTime;
    introText: string | undefined;
    generatedReportDocumentId: number | undefined;
    generatedReportDocumentName: string | undefined;
    items: BSAReportItemDto[] | undefined;
}

export class BSAReportItemDto implements IBSAReportItemDto {
    id!: number | undefined;
    section!: BSAReportSection;
    itemType!: BSAReportItemType;
    displayOrder!: number;
    title!: string | undefined;
    narrativeText!: string | undefined;
    specificToYouText!: string | undefined;
    documentId!: number | undefined;
    documentName!: string | undefined;

    constructor(data?: IBSAReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.section = _data["section"];
            this.itemType = _data["itemType"];
            this.displayOrder = _data["displayOrder"];
            this.title = _data["title"];
            this.narrativeText = _data["narrativeText"];
            this.specificToYouText = _data["specificToYouText"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
        }
    }

    static fromJS(data: any): BSAReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BSAReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["section"] = this.section;
        data["itemType"] = this.itemType;
        data["displayOrder"] = this.displayOrder;
        data["title"] = this.title;
        data["narrativeText"] = this.narrativeText;
        data["specificToYouText"] = this.specificToYouText;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        return data;
    }
}

export interface IBSAReportItemDto {
    id: number | undefined;
    section: BSAReportSection;
    itemType: BSAReportItemType;
    displayOrder: number;
    title: string | undefined;
    narrativeText: string | undefined;
    specificToYouText: string | undefined;
    documentId: number | undefined;
    documentName: string | undefined;
}

export enum BSAReportItemType {
    CurrentSituationSummary = 1,
    EmploymentDetails = 2,
    NamedItem = 10,
    ImmediateAction = 20,
    ImportantDateOrDeadline = 21,
    TwpEpeTrackingChart = 40,
    SsiCalculationSheet = 41,
    MspCalculationSheet = 42,
    LisCalculationSheet = 43,
    OtherAttachment = 44,
}

export enum BSAReportSection {
    CurrentSituationAndEmploymentGoals = 1,
    CashBenefits = 2,
    HealthInsurance = 3,
    OtherBenefits = 4,
    EmploymentServices = 5,
    OtherTopics = 6,
    ImportantThings = 7,
    Attachments = 8,
}

export class BackgroundTaskDto implements IBackgroundTaskDto {
    id!: number;
    taskName!: string | undefined;
    isRecurring!: boolean;
    cronExpression!: string | undefined;
    status!: string | undefined;

    constructor(data?: IBackgroundTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.isRecurring = _data["isRecurring"];
            this.cronExpression = _data["cronExpression"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BackgroundTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["isRecurring"] = this.isRecurring;
        data["cronExpression"] = this.cronExpression;
        data["status"] = this.status;
        return data;
    }
}

export interface IBackgroundTaskDto {
    id: number;
    taskName: string | undefined;
    isRecurring: boolean;
    cronExpression: string | undefined;
    status: string | undefined;
}

export class BackgroundTaskInstanceDto implements IBackgroundTaskInstanceDto {
    id!: number;
    backgroundTaskId!: number;
    instanceName!: string | undefined;
    hangfireJobId!: string | undefined;
    status!: JobProcessingStatus;
    isRecurring!: boolean;
    cronExpression!: string | undefined;
    scheduledStartTime!: DateTime;
    actualStartTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    errorMessage!: string | undefined;
    taskId!: number;

    constructor(data?: IBackgroundTaskInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.backgroundTaskId = _data["backgroundTaskId"];
            this.instanceName = _data["instanceName"];
            this.hangfireJobId = _data["hangfireJobId"];
            this.status = _data["status"];
            this.isRecurring = _data["isRecurring"];
            this.cronExpression = _data["cronExpression"];
            this.scheduledStartTime = _data["scheduledStartTime"] ? DateTime.fromISO(_data["scheduledStartTime"].toString()) : <any>undefined;
            this.actualStartTime = _data["actualStartTime"] ? DateTime.fromISO(_data["actualStartTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): BackgroundTaskInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundTaskInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["backgroundTaskId"] = this.backgroundTaskId;
        data["instanceName"] = this.instanceName;
        data["hangfireJobId"] = this.hangfireJobId;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["cronExpression"] = this.cronExpression;
        data["scheduledStartTime"] = this.scheduledStartTime ? this.scheduledStartTime.toString() : <any>undefined;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface IBackgroundTaskInstanceDto {
    id: number;
    backgroundTaskId: number;
    instanceName: string | undefined;
    hangfireJobId: string | undefined;
    status: JobProcessingStatus;
    isRecurring: boolean;
    cronExpression: string | undefined;
    scheduledStartTime: DateTime;
    actualStartTime: DateTime | undefined;
    endTime: DateTime | undefined;
    errorMessage: string | undefined;
    taskId: number;
}

export class BackgroundTaskInstanceLogDto implements IBackgroundTaskInstanceLogDto {
    id!: number;
    backgroundTaskInstanceId!: number;
    logMessage!: string | undefined;
    logLevel!: string | undefined;

    constructor(data?: IBackgroundTaskInstanceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.backgroundTaskInstanceId = _data["backgroundTaskInstanceId"];
            this.logMessage = _data["logMessage"];
            this.logLevel = _data["logLevel"];
        }
    }

    static fromJS(data: any): BackgroundTaskInstanceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundTaskInstanceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["backgroundTaskInstanceId"] = this.backgroundTaskInstanceId;
        data["logMessage"] = this.logMessage;
        data["logLevel"] = this.logLevel;
        return data;
    }
}

export interface IBackgroundTaskInstanceLogDto {
    id: number;
    backgroundTaskInstanceId: number;
    logMessage: string | undefined;
    logLevel: string | undefined;
}

export class BackgroundTaskMgmtDto implements IBackgroundTaskMgmtDto {
    id!: number;
    taskName!: string | undefined;
    description!: string | undefined;
    hangfireJobId!: string | undefined;
    creationTime!: DateTime;
    futureRunTime!: DateTime | undefined;

    constructor(data?: IBackgroundTaskMgmtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.hangfireJobId = _data["hangfireJobId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.futureRunTime = _data["futureRunTime"] ? DateTime.fromISO(_data["futureRunTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BackgroundTaskMgmtDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundTaskMgmtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["hangfireJobId"] = this.hangfireJobId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["futureRunTime"] = this.futureRunTime ? this.futureRunTime.toString() : <any>undefined;
        return data;
    }
}

export interface IBackgroundTaskMgmtDto {
    id: number;
    taskName: string | undefined;
    description: string | undefined;
    hangfireJobId: string | undefined;
    creationTime: DateTime;
    futureRunTime: DateTime | undefined;
}

export class BaseCreateOrUpdateJobInterviewSessionDto implements IBaseCreateOrUpdateJobInterviewSessionDto {
    id!: number | undefined;
    interviewRound!: InterviewRound;
    interviewMethod!: InterviewMethod;
    interviewDate!: DateTime;
    timeZone!: string;
    locationAddress!: string | undefined;
    interviewerName!: string | undefined;
    interviewerContact!: string | undefined;
    outcome!: InterviewOutcome;
    notes!: string | undefined;

    constructor(data?: IBaseCreateOrUpdateJobInterviewSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interviewRound = _data["interviewRound"];
            this.interviewMethod = _data["interviewMethod"];
            this.interviewDate = _data["interviewDate"] ? DateTime.fromISO(_data["interviewDate"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.locationAddress = _data["locationAddress"];
            this.interviewerName = _data["interviewerName"];
            this.interviewerContact = _data["interviewerContact"];
            this.outcome = _data["outcome"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): BaseCreateOrUpdateJobInterviewSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCreateOrUpdateJobInterviewSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interviewRound"] = this.interviewRound;
        data["interviewMethod"] = this.interviewMethod;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["locationAddress"] = this.locationAddress;
        data["interviewerName"] = this.interviewerName;
        data["interviewerContact"] = this.interviewerContact;
        data["outcome"] = this.outcome;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IBaseCreateOrUpdateJobInterviewSessionDto {
    id: number | undefined;
    interviewRound: InterviewRound;
    interviewMethod: InterviewMethod;
    interviewDate: DateTime;
    timeZone: string;
    locationAddress: string | undefined;
    interviewerName: string | undefined;
    interviewerContact: string | undefined;
    outcome: InterviewOutcome;
    notes: string | undefined;
}

export class BaseTicketHolderBenefitType implements IBaseTicketHolderBenefitType {
    ticketHolderId!: number;
    benefitType!: BenefitType;
    currentStatus!: BenefitPaymentStatus;
    isStatutorilyBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    entitlementDate!: DateTime | undefined;
    fullAmount!: number | undefined;
    netAmount!: number | undefined;
    othersPaid!: boolean | undefined;
    totalFamilyCashBenifit!: number | undefined;
    overPaymentBalance!: number | undefined;
    monthlyAmountWithHeld!: number | undefined;
    isRepresentativePayee!: boolean | undefined;
    isAuthorisedRepresentative!: boolean | undefined;
    nextMedicalReviewDate!: DateTime | undefined;
    medicalReExamCycle!: string | undefined;

    constructor(data?: IBaseTicketHolderBenefitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.benefitType = _data["benefitType"];
            this.currentStatus = _data["currentStatus"];
            this.isStatutorilyBlind = _data["isStatutorilyBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.entitlementDate = _data["entitlementDate"] ? DateTime.fromISO(_data["entitlementDate"].toString()) : <any>undefined;
            this.fullAmount = _data["fullAmount"];
            this.netAmount = _data["netAmount"];
            this.othersPaid = _data["othersPaid"];
            this.totalFamilyCashBenifit = _data["totalFamilyCashBenifit"];
            this.overPaymentBalance = _data["overPaymentBalance"];
            this.monthlyAmountWithHeld = _data["monthlyAmountWithHeld"];
            this.isRepresentativePayee = _data["isRepresentativePayee"];
            this.isAuthorisedRepresentative = _data["isAuthorisedRepresentative"];
            this.nextMedicalReviewDate = _data["nextMedicalReviewDate"] ? DateTime.fromISO(_data["nextMedicalReviewDate"].toString()) : <any>undefined;
            this.medicalReExamCycle = _data["medicalReExamCycle"];
        }
    }

    static fromJS(data: any): BaseTicketHolderBenefitType {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTicketHolderBenefitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["benefitType"] = this.benefitType;
        data["currentStatus"] = this.currentStatus;
        data["isStatutorilyBlind"] = this.isStatutorilyBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toString() : <any>undefined;
        data["entitlementDate"] = this.entitlementDate ? this.entitlementDate.toString() : <any>undefined;
        data["fullAmount"] = this.fullAmount;
        data["netAmount"] = this.netAmount;
        data["othersPaid"] = this.othersPaid;
        data["totalFamilyCashBenifit"] = this.totalFamilyCashBenifit;
        data["overPaymentBalance"] = this.overPaymentBalance;
        data["monthlyAmountWithHeld"] = this.monthlyAmountWithHeld;
        data["isRepresentativePayee"] = this.isRepresentativePayee;
        data["isAuthorisedRepresentative"] = this.isAuthorisedRepresentative;
        data["nextMedicalReviewDate"] = this.nextMedicalReviewDate ? this.nextMedicalReviewDate.toString() : <any>undefined;
        data["medicalReExamCycle"] = this.medicalReExamCycle;
        return data;
    }
}

export interface IBaseTicketHolderBenefitType {
    ticketHolderId: number;
    benefitType: BenefitType;
    currentStatus: BenefitPaymentStatus;
    isStatutorilyBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    entitlementDate: DateTime | undefined;
    fullAmount: number | undefined;
    netAmount: number | undefined;
    othersPaid: boolean | undefined;
    totalFamilyCashBenifit: number | undefined;
    overPaymentBalance: number | undefined;
    monthlyAmountWithHeld: number | undefined;
    isRepresentativePayee: boolean | undefined;
    isAuthorisedRepresentative: boolean | undefined;
    nextMedicalReviewDate: DateTime | undefined;
    medicalReExamCycle: string | undefined;
}

export class BatchInstanceDto implements IBatchInstanceDto {
    id!: number;
    batchId!: string | undefined;
    backgroundTaskId!: number;
    taskName!: string | undefined;
    instanceName!: string | undefined;
    status!: string | undefined;
    isFailed!: boolean;
    actualStartTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    durationSeconds!: number | undefined;
    errorMessage!: string | undefined;
    logCount!: number;
    progressPercentage!: number | undefined;
    currentStep!: string | undefined;
    progressMessage!: string | undefined;
    totalItems!: number | undefined;
    processedItems!: number | undefined;

    constructor(data?: IBatchInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batchId = _data["batchId"];
            this.backgroundTaskId = _data["backgroundTaskId"];
            this.taskName = _data["taskName"];
            this.instanceName = _data["instanceName"];
            this.status = _data["status"];
            this.isFailed = _data["isFailed"];
            this.actualStartTime = _data["actualStartTime"] ? DateTime.fromISO(_data["actualStartTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.durationSeconds = _data["durationSeconds"];
            this.errorMessage = _data["errorMessage"];
            this.logCount = _data["logCount"];
            this.progressPercentage = _data["progressPercentage"];
            this.currentStep = _data["currentStep"];
            this.progressMessage = _data["progressMessage"];
            this.totalItems = _data["totalItems"];
            this.processedItems = _data["processedItems"];
        }
    }

    static fromJS(data: any): BatchInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchId"] = this.batchId;
        data["backgroundTaskId"] = this.backgroundTaskId;
        data["taskName"] = this.taskName;
        data["instanceName"] = this.instanceName;
        data["status"] = this.status;
        data["isFailed"] = this.isFailed;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["durationSeconds"] = this.durationSeconds;
        data["errorMessage"] = this.errorMessage;
        data["logCount"] = this.logCount;
        data["progressPercentage"] = this.progressPercentage;
        data["currentStep"] = this.currentStep;
        data["progressMessage"] = this.progressMessage;
        data["totalItems"] = this.totalItems;
        data["processedItems"] = this.processedItems;
        return data;
    }
}

export interface IBatchInstanceDto {
    id: number;
    batchId: string | undefined;
    backgroundTaskId: number;
    taskName: string | undefined;
    instanceName: string | undefined;
    status: string | undefined;
    isFailed: boolean;
    actualStartTime: DateTime | undefined;
    endTime: DateTime | undefined;
    durationSeconds: number | undefined;
    errorMessage: string | undefined;
    logCount: number;
    progressPercentage: number | undefined;
    currentStep: string | undefined;
    progressMessage: string | undefined;
    totalItems: number | undefined;
    processedItems: number | undefined;
}

export class BatchRunDto implements IBatchRunDto {
    batchId!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime | undefined;
    taskCount!: number;
    successCount!: number;
    failCount!: number;
    runningCount!: number;
    tasksScheduled!: number;
    tasksSkipped!: number;
    hasErrors!: boolean;

    constructor(data?: IBatchRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.taskCount = _data["taskCount"];
            this.successCount = _data["successCount"];
            this.failCount = _data["failCount"];
            this.runningCount = _data["runningCount"];
            this.tasksScheduled = _data["tasksScheduled"];
            this.tasksSkipped = _data["tasksSkipped"];
            this.hasErrors = _data["hasErrors"];
        }
    }

    static fromJS(data: any): BatchRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["taskCount"] = this.taskCount;
        data["successCount"] = this.successCount;
        data["failCount"] = this.failCount;
        data["runningCount"] = this.runningCount;
        data["tasksScheduled"] = this.tasksScheduled;
        data["tasksSkipped"] = this.tasksSkipped;
        data["hasErrors"] = this.hasErrors;
        return data;
    }
}

export interface IBatchRunDto {
    batchId: string | undefined;
    startTime: DateTime;
    endTime: DateTime | undefined;
    taskCount: number;
    successCount: number;
    failCount: number;
    runningCount: number;
    tasksScheduled: number;
    tasksSkipped: number;
    hasErrors: boolean;
}

export class BatchRunLogDto implements IBatchRunLogDto {
    id!: number;
    batchId!: string | undefined;
    taskName!: string | undefined;
    isSuccess!: boolean;
    message!: string | undefined;
    exception!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime | undefined;
    durationInSeconds!: number | undefined;
    creationTime!: DateTime;

    constructor(data?: IBatchRunLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batchId = _data["batchId"];
            this.taskName = _data["taskName"];
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.exception = _data["exception"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.durationInSeconds = _data["durationInSeconds"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchRunLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchRunLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchId"] = this.batchId;
        data["taskName"] = this.taskName;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["exception"] = this.exception;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["durationInSeconds"] = this.durationInSeconds;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IBatchRunLogDto {
    id: number;
    batchId: string | undefined;
    taskName: string | undefined;
    isSuccess: boolean;
    message: string | undefined;
    exception: string | undefined;
    startTime: DateTime;
    endTime: DateTime | undefined;
    durationInSeconds: number | undefined;
    creationTime: DateTime;
}

export enum BenefitAtIntakeCategory {
    SSABenefits = 46,
    Medicaid = 47,
    Medicare = 48,
    OtherBenefits = 49,
}

export class BenefitAtIntakeDto implements IBenefitAtIntakeDto {
    id!: number | undefined;
    category!: BenefitAtIntakeCategory;
    rowType!: BenefitAtIntakeRowType;
    receiving!: boolean;
    recommended!: boolean | undefined;
    comments!: string | undefined;

    constructor(data?: IBenefitAtIntakeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.rowType = _data["rowType"];
            this.receiving = _data["receiving"];
            this.recommended = _data["recommended"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): BenefitAtIntakeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitAtIntakeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["rowType"] = this.rowType;
        data["receiving"] = this.receiving;
        data["recommended"] = this.recommended;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IBenefitAtIntakeDto {
    id: number | undefined;
    category: BenefitAtIntakeCategory;
    rowType: BenefitAtIntakeRowType;
    receiving: boolean;
    recommended: boolean | undefined;
    comments: string | undefined;
}

export enum BenefitAtIntakeRowType {
    SSI = 1,
    SSDI = 2,
    CDB = 3,
    DWB = 4,
    SSAOther = 5,
    MedicaidSSIBased = 10,
    Medicaid1619b = 11,
    MedicaidHCBSWaiver = 12,
    MedicaidSpendDown = 13,
    MedicaidBuyIn = 14,
    MedicaidOtherProgram = 15,
    MedicarePartA = 20,
    MedicarePartB = 21,
    MedicareSavingsProgram = 22,
    MedicarePartD = 23,
    MedicarePartDLowIncomeSubsidy = 24,
    MedicarePremiumHIWorkingDisabled = 25,
    OtherEmployerPrivateHealthInsurance = 30,
    OtherFoodStampsSNAP = 31,
    OtherHousingSubsidy = 32,
    OtherVeteransCompensation = 33,
    OtherVeteransPension = 34,
    OtherTANF = 35,
    OtherUnemploymentInsurance = 36,
    OtherWorkersCompensation = 37,
    OtherPublicDisabilityBenefit = 38,
    OtherAlimonyOrChildSupport = 39,
    OtherEnergyAssistance = 40,
    OtherSSIStateSupplementation = 41,
    OtherOther = 42,
}

export enum BenefitPaymentStatus {
    CurrentPay = 1,
    Suspended = 2,
    Terminated = 3,
    Pending = 4,
    NonPay = 5,
}

export enum BenefitType {
    Unknown = 0,
    SSDI = 1,
    SSI = 2,
    Concurrent = 3,
}

export class BenefitTypeDto implements IBenefitTypeDto {
    leadId!: number;
    benefitType!: BenefitType;

    constructor(data?: IBenefitTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.benefitType = _data["benefitType"];
        }
    }

    static fromJS(data: any): BenefitTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["benefitType"] = this.benefitType;
        return data;
    }
}

export interface IBenefitTypeDto {
    leadId: number;
    benefitType: BenefitType;
}

export class BenefitsCounselingCaseDto implements IBenefitsCounselingCaseDto {
    id!: number;
    ticketHolderId!: number;
    stage!: BenefitsCounselingStage;
    status!: BenefitsCounselingCaseStatus;
    assignedCpwicUserId!: number | undefined;
    openedAt!: DateTime;
    closedAt!: DateTime | undefined;
    closeReason!: string | undefined;
    bpqyDocumentId!: number | undefined;
    intakeRecordId!: number | undefined;
    bsaPlanningAnalysisRecordId!: number | undefined;
    bsaDeliveryReviewRecordId!: number | undefined;
    benefitsFollowUpRecordsJson!: string | undefined;
    benefitsFollowUpRecordIds!: number[] | undefined;

    constructor(data?: IBenefitsCounselingCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.stage = _data["stage"];
            this.status = _data["status"];
            this.assignedCpwicUserId = _data["assignedCpwicUserId"];
            this.openedAt = _data["openedAt"] ? DateTime.fromISO(_data["openedAt"].toString()) : <any>undefined;
            this.closedAt = _data["closedAt"] ? DateTime.fromISO(_data["closedAt"].toString()) : <any>undefined;
            this.closeReason = _data["closeReason"];
            this.bpqyDocumentId = _data["bpqyDocumentId"];
            this.intakeRecordId = _data["intakeRecordId"];
            this.bsaPlanningAnalysisRecordId = _data["bsaPlanningAnalysisRecordId"];
            this.bsaDeliveryReviewRecordId = _data["bsaDeliveryReviewRecordId"];
            this.benefitsFollowUpRecordsJson = _data["benefitsFollowUpRecordsJson"];
            if (Array.isArray(_data["benefitsFollowUpRecordIds"])) {
                this.benefitsFollowUpRecordIds = [] as any;
                for (let item of _data["benefitsFollowUpRecordIds"])
                    this.benefitsFollowUpRecordIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BenefitsCounselingCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitsCounselingCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["stage"] = this.stage;
        data["status"] = this.status;
        data["assignedCpwicUserId"] = this.assignedCpwicUserId;
        data["openedAt"] = this.openedAt ? this.openedAt.toString() : <any>undefined;
        data["closedAt"] = this.closedAt ? this.closedAt.toString() : <any>undefined;
        data["closeReason"] = this.closeReason;
        data["bpqyDocumentId"] = this.bpqyDocumentId;
        data["intakeRecordId"] = this.intakeRecordId;
        data["bsaPlanningAnalysisRecordId"] = this.bsaPlanningAnalysisRecordId;
        data["bsaDeliveryReviewRecordId"] = this.bsaDeliveryReviewRecordId;
        data["benefitsFollowUpRecordsJson"] = this.benefitsFollowUpRecordsJson;
        if (Array.isArray(this.benefitsFollowUpRecordIds)) {
            data["benefitsFollowUpRecordIds"] = [];
            for (let item of this.benefitsFollowUpRecordIds)
                data["benefitsFollowUpRecordIds"].push(item);
        }
        return data;
    }
}

export interface IBenefitsCounselingCaseDto {
    id: number;
    ticketHolderId: number;
    stage: BenefitsCounselingStage;
    status: BenefitsCounselingCaseStatus;
    assignedCpwicUserId: number | undefined;
    openedAt: DateTime;
    closedAt: DateTime | undefined;
    closeReason: string | undefined;
    bpqyDocumentId: number | undefined;
    intakeRecordId: number | undefined;
    bsaPlanningAnalysisRecordId: number | undefined;
    bsaDeliveryReviewRecordId: number | undefined;
    benefitsFollowUpRecordsJson: string | undefined;
    benefitsFollowUpRecordIds: number[] | undefined;
}

export class BenefitsCounselingCaseListDto implements IBenefitsCounselingCaseListDto {
    id!: number;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    ticketHolderFormattedId!: string | undefined;
    stage!: BenefitsCounselingStage;
    stageDisplayName!: string | undefined;
    status!: BenefitsCounselingCaseStatus;
    statusDisplayName!: string | undefined;
    assignedCpwicUserId!: number | undefined;
    assignedCpwicName!: string | undefined;
    openedAt!: DateTime;
    closedAt!: DateTime | undefined;
    intakeRecordId!: number | undefined;
    bsaPlanningAnalysisRecordId!: number | undefined;
    bsaDeliveryReviewRecordId!: number | undefined;
    verificationRecordCount!: number;
    verifiedBenefitCount!: number;
    supportRecordCount!: number;
    followUpRecordCount!: number;

    constructor(data?: IBenefitsCounselingCaseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderFormattedId = _data["ticketHolderFormattedId"];
            this.stage = _data["stage"];
            this.stageDisplayName = _data["stageDisplayName"];
            this.status = _data["status"];
            this.statusDisplayName = _data["statusDisplayName"];
            this.assignedCpwicUserId = _data["assignedCpwicUserId"];
            this.assignedCpwicName = _data["assignedCpwicName"];
            this.openedAt = _data["openedAt"] ? DateTime.fromISO(_data["openedAt"].toString()) : <any>undefined;
            this.closedAt = _data["closedAt"] ? DateTime.fromISO(_data["closedAt"].toString()) : <any>undefined;
            this.intakeRecordId = _data["intakeRecordId"];
            this.bsaPlanningAnalysisRecordId = _data["bsaPlanningAnalysisRecordId"];
            this.bsaDeliveryReviewRecordId = _data["bsaDeliveryReviewRecordId"];
            this.verificationRecordCount = _data["verificationRecordCount"];
            this.verifiedBenefitCount = _data["verifiedBenefitCount"];
            this.supportRecordCount = _data["supportRecordCount"];
            this.followUpRecordCount = _data["followUpRecordCount"];
        }
    }

    static fromJS(data: any): BenefitsCounselingCaseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitsCounselingCaseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderFormattedId"] = this.ticketHolderFormattedId;
        data["stage"] = this.stage;
        data["stageDisplayName"] = this.stageDisplayName;
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        data["assignedCpwicUserId"] = this.assignedCpwicUserId;
        data["assignedCpwicName"] = this.assignedCpwicName;
        data["openedAt"] = this.openedAt ? this.openedAt.toString() : <any>undefined;
        data["closedAt"] = this.closedAt ? this.closedAt.toString() : <any>undefined;
        data["intakeRecordId"] = this.intakeRecordId;
        data["bsaPlanningAnalysisRecordId"] = this.bsaPlanningAnalysisRecordId;
        data["bsaDeliveryReviewRecordId"] = this.bsaDeliveryReviewRecordId;
        data["verificationRecordCount"] = this.verificationRecordCount;
        data["verifiedBenefitCount"] = this.verifiedBenefitCount;
        data["supportRecordCount"] = this.supportRecordCount;
        data["followUpRecordCount"] = this.followUpRecordCount;
        return data;
    }
}

export interface IBenefitsCounselingCaseListDto {
    id: number;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    ticketHolderFormattedId: string | undefined;
    stage: BenefitsCounselingStage;
    stageDisplayName: string | undefined;
    status: BenefitsCounselingCaseStatus;
    statusDisplayName: string | undefined;
    assignedCpwicUserId: number | undefined;
    assignedCpwicName: string | undefined;
    openedAt: DateTime;
    closedAt: DateTime | undefined;
    intakeRecordId: number | undefined;
    bsaPlanningAnalysisRecordId: number | undefined;
    bsaDeliveryReviewRecordId: number | undefined;
    verificationRecordCount: number;
    verifiedBenefitCount: number;
    supportRecordCount: number;
    followUpRecordCount: number;
}

export enum BenefitsCounselingCaseStatus {
    Open = 1,
    OnHold = 2,
    Closed = 3,
}

export enum BenefitsCounselingStage {
    Intake = 0,
    BenefitsVerification = 10,
    BS_A_Planning = 20,
    BS_A_Delivery_Review = 30,
    BenefitsManagementSupport = 40,
}

export class BenefitsCounselingSupportRecordDto implements IBenefitsCounselingSupportRecordDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    ticketHolderId!: number;
    calendarEventId!: number | undefined;
    supportDate!: DateTime;
    supportType!: BenefitsSupportType;
    workIncentiveDiscussed!: string | undefined;
    reportingSupportProvided!: string | undefined;
    issueSummary!: string | undefined;
    outcome!: string | undefined;
    nextActionDueDate!: DateTime | undefined;
    caseNotes!: string | undefined;

    constructor(data?: IBenefitsCounselingSupportRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.calendarEventId = _data["calendarEventId"];
            this.supportDate = _data["supportDate"] ? DateTime.fromISO(_data["supportDate"].toString()) : <any>undefined;
            this.supportType = _data["supportType"];
            this.workIncentiveDiscussed = _data["workIncentiveDiscussed"];
            this.reportingSupportProvided = _data["reportingSupportProvided"];
            this.issueSummary = _data["issueSummary"];
            this.outcome = _data["outcome"];
            this.nextActionDueDate = _data["nextActionDueDate"] ? DateTime.fromISO(_data["nextActionDueDate"].toString()) : <any>undefined;
            this.caseNotes = _data["caseNotes"];
        }
    }

    static fromJS(data: any): BenefitsCounselingSupportRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitsCounselingSupportRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["calendarEventId"] = this.calendarEventId;
        data["supportDate"] = this.supportDate ? this.supportDate.toString() : <any>undefined;
        data["supportType"] = this.supportType;
        data["workIncentiveDiscussed"] = this.workIncentiveDiscussed;
        data["reportingSupportProvided"] = this.reportingSupportProvided;
        data["issueSummary"] = this.issueSummary;
        data["outcome"] = this.outcome;
        data["nextActionDueDate"] = this.nextActionDueDate ? this.nextActionDueDate.toString() : <any>undefined;
        data["caseNotes"] = this.caseNotes;
        return data;
    }
}

export interface IBenefitsCounselingSupportRecordDto {
    id: number;
    benefitsCounselingCaseId: number;
    ticketHolderId: number;
    calendarEventId: number | undefined;
    supportDate: DateTime;
    supportType: BenefitsSupportType;
    workIncentiveDiscussed: string | undefined;
    reportingSupportProvided: string | undefined;
    issueSummary: string | undefined;
    outcome: string | undefined;
    nextActionDueDate: DateTime | undefined;
    caseNotes: string | undefined;
}

export enum BenefitsSupportType {
    BenefitsLiteracy = 1,
    WorkReporting = 2,
    WorkIncentive = 3,
    BenefitsIssue = 4,
    Referral = 5,
}

export class BenefitsVerificationRecordDto implements IBenefitsVerificationRecordDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    ticketHolderId!: number;
    source!: BenefitsVerificationSource;
    benefitName!: string | undefined;
    requestedAt!: DateTime | undefined;
    receivedAt!: DateTime | undefined;
    isVerified!: boolean;
    verifiedAt!: DateTime | undefined;
    verificationNotes!: string | undefined;
    verificationDocumentId!: number | undefined;

    constructor(data?: IBenefitsVerificationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.source = _data["source"];
            this.benefitName = _data["benefitName"];
            this.requestedAt = _data["requestedAt"] ? DateTime.fromISO(_data["requestedAt"].toString()) : <any>undefined;
            this.receivedAt = _data["receivedAt"] ? DateTime.fromISO(_data["receivedAt"].toString()) : <any>undefined;
            this.isVerified = _data["isVerified"];
            this.verifiedAt = _data["verifiedAt"] ? DateTime.fromISO(_data["verifiedAt"].toString()) : <any>undefined;
            this.verificationNotes = _data["verificationNotes"];
            this.verificationDocumentId = _data["verificationDocumentId"];
        }
    }

    static fromJS(data: any): BenefitsVerificationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitsVerificationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["source"] = this.source;
        data["benefitName"] = this.benefitName;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toString() : <any>undefined;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toString() : <any>undefined;
        data["isVerified"] = this.isVerified;
        data["verifiedAt"] = this.verifiedAt ? this.verifiedAt.toString() : <any>undefined;
        data["verificationNotes"] = this.verificationNotes;
        data["verificationDocumentId"] = this.verificationDocumentId;
        return data;
    }
}

export interface IBenefitsVerificationRecordDto {
    id: number;
    benefitsCounselingCaseId: number;
    ticketHolderId: number;
    source: BenefitsVerificationSource;
    benefitName: string | undefined;
    requestedAt: DateTime | undefined;
    receivedAt: DateTime | undefined;
    isVerified: boolean;
    verifiedAt: DateTime | undefined;
    verificationNotes: string | undefined;
    verificationDocumentId: number | undefined;
}

export enum BenefitsVerificationSource {
    BPQY = 1,
    AwardLetter = 2,
    AgencyVerification = 3,
    BeneficiaryStatement = 4,
    Other = 5,
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class BpQyRecievedSSAUpload implements IBpQyRecievedSSAUpload {
    bpqyRequestId!: number;
    uploadBPQYDoc!: UploadFileOutputDto;

    constructor(data?: IBpQyRecievedSSAUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bpqyRequestId = _data["bpqyRequestId"];
            this.uploadBPQYDoc = _data["uploadBPQYDoc"] ? UploadFileOutputDto.fromJS(_data["uploadBPQYDoc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BpQyRecievedSSAUpload {
        data = typeof data === 'object' ? data : {};
        let result = new BpQyRecievedSSAUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bpqyRequestId"] = this.bpqyRequestId;
        data["uploadBPQYDoc"] = this.uploadBPQYDoc ? this.uploadBPQYDoc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBpQyRecievedSSAUpload {
    bpqyRequestId: number;
    uploadBPQYDoc: UploadFileOutputDto;
}

export class BpqyCompleteStep implements IBpqyCompleteStep {
    bpqyId!: number;
    isCompleted!: boolean;
    status!: BpqyRequestStatus;

    constructor(data?: IBpqyCompleteStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bpqyId = _data["bpqyId"];
            this.isCompleted = _data["isCompleted"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BpqyCompleteStep {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyCompleteStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bpqyId"] = this.bpqyId;
        data["isCompleted"] = this.isCompleted;
        data["status"] = this.status;
        return data;
    }
}

export interface IBpqyCompleteStep {
    bpqyId: number;
    isCompleted: boolean;
    status: BpqyRequestStatus;
}

export class BpqyDocumentStepDto implements IBpqyDocumentStepDto {
    completed!: boolean;
    status!: BpqyRequestStatus;
    completedOnStatus!: string | undefined;
    documentId!: number | undefined;
    documentName!: string | undefined;
    documentFileType!: string | undefined;

    constructor(data?: IBpqyDocumentStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.status = _data["status"];
            this.completedOnStatus = _data["completedOnStatus"];
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.documentFileType = _data["documentFileType"];
        }
    }

    static fromJS(data: any): BpqyDocumentStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyDocumentStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["status"] = this.status;
        data["completedOnStatus"] = this.completedOnStatus;
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["documentFileType"] = this.documentFileType;
        return data;
    }
}

export interface IBpqyDocumentStepDto {
    completed: boolean;
    status: BpqyRequestStatus;
    completedOnStatus: string | undefined;
    documentId: number | undefined;
    documentName: string | undefined;
    documentFileType: string | undefined;
}

export class BpqyExtractDto implements IBpqyExtractDto {
    benefitType!: string | undefined;
    currentStatus!: string | undefined;
    isStatutorilyBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    entitlementDate!: DateTime | undefined;
    fullAmount!: number | undefined;
    netAmount!: number | undefined;
    othersPaid!: boolean | undefined;
    totalFamilyCashBenefit!: number | undefined;
    overpaymentBalance!: number | undefined;
    monthlyAmountWithheld!: number | undefined;
    isRepresentativePayee!: boolean | undefined;
    isAuthorizedRepresentative!: boolean | undefined;
    nextMedicalReviewDate!: DateTime | undefined;
    medicalReExamCycle!: string | undefined;
    medicareParts!: BpqyMedicarePartExtractDto[] | undefined;
    medicaidEligibilityType!: string | undefined;
    medicaidDetermination!: string | undefined;
    medicaidBuyIn!: boolean | undefined;

    constructor(data?: IBpqyExtractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitType = _data["benefitType"];
            this.currentStatus = _data["currentStatus"];
            this.isStatutorilyBlind = _data["isStatutorilyBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.entitlementDate = _data["entitlementDate"] ? DateTime.fromISO(_data["entitlementDate"].toString()) : <any>undefined;
            this.fullAmount = _data["fullAmount"];
            this.netAmount = _data["netAmount"];
            this.othersPaid = _data["othersPaid"];
            this.totalFamilyCashBenefit = _data["totalFamilyCashBenefit"];
            this.overpaymentBalance = _data["overpaymentBalance"];
            this.monthlyAmountWithheld = _data["monthlyAmountWithheld"];
            this.isRepresentativePayee = _data["isRepresentativePayee"];
            this.isAuthorizedRepresentative = _data["isAuthorizedRepresentative"];
            this.nextMedicalReviewDate = _data["nextMedicalReviewDate"] ? DateTime.fromISO(_data["nextMedicalReviewDate"].toString()) : <any>undefined;
            this.medicalReExamCycle = _data["medicalReExamCycle"];
            if (Array.isArray(_data["medicareParts"])) {
                this.medicareParts = [] as any;
                for (let item of _data["medicareParts"])
                    this.medicareParts!.push(BpqyMedicarePartExtractDto.fromJS(item));
            }
            this.medicaidEligibilityType = _data["medicaidEligibilityType"];
            this.medicaidDetermination = _data["medicaidDetermination"];
            this.medicaidBuyIn = _data["medicaidBuyIn"];
        }
    }

    static fromJS(data: any): BpqyExtractDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyExtractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitType"] = this.benefitType;
        data["currentStatus"] = this.currentStatus;
        data["isStatutorilyBlind"] = this.isStatutorilyBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["entitlementDate"] = this.entitlementDate ? this.entitlementDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["fullAmount"] = this.fullAmount;
        data["netAmount"] = this.netAmount;
        data["othersPaid"] = this.othersPaid;
        data["totalFamilyCashBenefit"] = this.totalFamilyCashBenefit;
        data["overpaymentBalance"] = this.overpaymentBalance;
        data["monthlyAmountWithheld"] = this.monthlyAmountWithheld;
        data["isRepresentativePayee"] = this.isRepresentativePayee;
        data["isAuthorizedRepresentative"] = this.isAuthorizedRepresentative;
        data["nextMedicalReviewDate"] = this.nextMedicalReviewDate ? this.nextMedicalReviewDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medicalReExamCycle"] = this.medicalReExamCycle;
        if (Array.isArray(this.medicareParts)) {
            data["medicareParts"] = [];
            for (let item of this.medicareParts)
                data["medicareParts"].push(item.toJSON());
        }
        data["medicaidEligibilityType"] = this.medicaidEligibilityType;
        data["medicaidDetermination"] = this.medicaidDetermination;
        data["medicaidBuyIn"] = this.medicaidBuyIn;
        return data;
    }
}

export interface IBpqyExtractDto {
    benefitType: string | undefined;
    currentStatus: string | undefined;
    isStatutorilyBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    entitlementDate: DateTime | undefined;
    fullAmount: number | undefined;
    netAmount: number | undefined;
    othersPaid: boolean | undefined;
    totalFamilyCashBenefit: number | undefined;
    overpaymentBalance: number | undefined;
    monthlyAmountWithheld: number | undefined;
    isRepresentativePayee: boolean | undefined;
    isAuthorizedRepresentative: boolean | undefined;
    nextMedicalReviewDate: DateTime | undefined;
    medicalReExamCycle: string | undefined;
    medicareParts: BpqyMedicarePartExtractDto[] | undefined;
    medicaidEligibilityType: string | undefined;
    medicaidDetermination: string | undefined;
    medicaidBuyIn: boolean | undefined;
}

export class BpqyFaxAttemptDetailDto implements IBpqyFaxAttemptDetailDto {
    senderCompany!: string | undefined;
    senderPhone!: string | undefined;
    senderFax!: string | undefined;
    senderEmail!: string | undefined;
    recipientOfficeName!: string | undefined;
    recipientFax!: string | undefined;
    recipientPhone!: string | undefined;
    recipientAttention!: string | undefined;
    subject!: string | undefined;
    totalPages!: number;
    generatedAt!: DateTime;
    enAuthorizationDocumentId!: number | undefined;
    status!: ActivityStatus;
    enumStatusDisplayName!: string | undefined;

    constructor(data?: IBpqyFaxAttemptDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderCompany = _data["senderCompany"];
            this.senderPhone = _data["senderPhone"];
            this.senderFax = _data["senderFax"];
            this.senderEmail = _data["senderEmail"];
            this.recipientOfficeName = _data["recipientOfficeName"];
            this.recipientFax = _data["recipientFax"];
            this.recipientPhone = _data["recipientPhone"];
            this.recipientAttention = _data["recipientAttention"];
            this.subject = _data["subject"];
            this.totalPages = _data["totalPages"];
            this.generatedAt = _data["generatedAt"] ? DateTime.fromISO(_data["generatedAt"].toString()) : <any>undefined;
            this.enAuthorizationDocumentId = _data["enAuthorizationDocumentId"];
            this.status = _data["status"];
            this.enumStatusDisplayName = _data["enumStatusDisplayName"];
        }
    }

    static fromJS(data: any): BpqyFaxAttemptDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyFaxAttemptDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderCompany"] = this.senderCompany;
        data["senderPhone"] = this.senderPhone;
        data["senderFax"] = this.senderFax;
        data["senderEmail"] = this.senderEmail;
        data["recipientOfficeName"] = this.recipientOfficeName;
        data["recipientFax"] = this.recipientFax;
        data["recipientPhone"] = this.recipientPhone;
        data["recipientAttention"] = this.recipientAttention;
        data["subject"] = this.subject;
        data["totalPages"] = this.totalPages;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toString() : <any>undefined;
        data["enAuthorizationDocumentId"] = this.enAuthorizationDocumentId;
        data["status"] = this.status;
        data["enumStatusDisplayName"] = this.enumStatusDisplayName;
        return data;
    }
}

export interface IBpqyFaxAttemptDetailDto {
    senderCompany: string | undefined;
    senderPhone: string | undefined;
    senderFax: string | undefined;
    senderEmail: string | undefined;
    recipientOfficeName: string | undefined;
    recipientFax: string | undefined;
    recipientPhone: string | undefined;
    recipientAttention: string | undefined;
    subject: string | undefined;
    totalPages: number;
    generatedAt: DateTime;
    enAuthorizationDocumentId: number | undefined;
    status: ActivityStatus;
    enumStatusDisplayName: string | undefined;
}

export class BpqyFaxAttemptListDto implements IBpqyFaxAttemptListDto {
    faxHistoryId!: number;
    status!: ActivityStatus;
    enumFaxStatusValue!: string | undefined;
    faxLogId!: number;
    sentAt!: DateTime;
    senderFax!: string | undefined;
    faxPacketDocumentId!: number | undefined;
    documentName!: string | undefined;
    documentFileType!: string | undefined;
    recipientOfficeName!: string | undefined;
    recipientFax!: string | undefined;
    recipientPhone!: string | undefined;
    recipientAttention!: string | undefined;

    constructor(data?: IBpqyFaxAttemptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faxHistoryId = _data["faxHistoryId"];
            this.status = _data["status"];
            this.enumFaxStatusValue = _data["enumFaxStatusValue"];
            this.faxLogId = _data["faxLogId"];
            this.sentAt = _data["sentAt"] ? DateTime.fromISO(_data["sentAt"].toString()) : <any>undefined;
            this.senderFax = _data["senderFax"];
            this.faxPacketDocumentId = _data["faxPacketDocumentId"];
            this.documentName = _data["documentName"];
            this.documentFileType = _data["documentFileType"];
            this.recipientOfficeName = _data["recipientOfficeName"];
            this.recipientFax = _data["recipientFax"];
            this.recipientPhone = _data["recipientPhone"];
            this.recipientAttention = _data["recipientAttention"];
        }
    }

    static fromJS(data: any): BpqyFaxAttemptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyFaxAttemptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faxHistoryId"] = this.faxHistoryId;
        data["status"] = this.status;
        data["enumFaxStatusValue"] = this.enumFaxStatusValue;
        data["faxLogId"] = this.faxLogId;
        data["sentAt"] = this.sentAt ? this.sentAt.toString() : <any>undefined;
        data["senderFax"] = this.senderFax;
        data["faxPacketDocumentId"] = this.faxPacketDocumentId;
        data["documentName"] = this.documentName;
        data["documentFileType"] = this.documentFileType;
        data["recipientOfficeName"] = this.recipientOfficeName;
        data["recipientFax"] = this.recipientFax;
        data["recipientPhone"] = this.recipientPhone;
        data["recipientAttention"] = this.recipientAttention;
        return data;
    }
}

export interface IBpqyFaxAttemptListDto {
    faxHistoryId: number;
    status: ActivityStatus;
    enumFaxStatusValue: string | undefined;
    faxLogId: number;
    sentAt: DateTime;
    senderFax: string | undefined;
    faxPacketDocumentId: number | undefined;
    documentName: string | undefined;
    documentFileType: string | undefined;
    recipientOfficeName: string | undefined;
    recipientFax: string | undefined;
    recipientPhone: string | undefined;
    recipientAttention: string | undefined;
}

export class BpqyFaxAttemptResultDto implements IBpqyFaxAttemptResultDto {
    totalCount!: number;
    items!: BpqyFaxAttemptListDto[] | undefined;

    constructor(data?: IBpqyFaxAttemptResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BpqyFaxAttemptListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BpqyFaxAttemptResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyFaxAttemptResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBpqyFaxAttemptResultDto {
    totalCount: number;
    items: BpqyFaxAttemptListDto[] | undefined;
}

export class BpqyFaxStepDto implements IBpqyFaxStepDto {
    completed!: boolean;
    status!: BpqyRequestStatus;
    completedOnStatus!: string | undefined;
    faxSummary!: FaxSummaryDto;

    constructor(data?: IBpqyFaxStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.status = _data["status"];
            this.completedOnStatus = _data["completedOnStatus"];
            this.faxSummary = _data["faxSummary"] ? FaxSummaryDto.fromJS(_data["faxSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BpqyFaxStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyFaxStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["status"] = this.status;
        data["completedOnStatus"] = this.completedOnStatus;
        data["faxSummary"] = this.faxSummary ? this.faxSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBpqyFaxStepDto {
    completed: boolean;
    status: BpqyRequestStatus;
    completedOnStatus: string | undefined;
    faxSummary: FaxSummaryDto;
}

export class BpqyInfoDto implements IBpqyInfoDto {
    id!: number;
    ticketHolderId!: number;
    status!: BpqyRequestStatus;
    statusDisplayName!: string | undefined;
    creationTime!: DateTime;
    steps!: BpqyStepsDto;
    senderFaxInfo!: SenderFaxInfo;
    receiverFaxInfo!: ReceiverInfo;

    constructor(data?: IBpqyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.status = _data["status"];
            this.statusDisplayName = _data["statusDisplayName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.steps = _data["steps"] ? BpqyStepsDto.fromJS(_data["steps"]) : <any>undefined;
            this.senderFaxInfo = _data["senderFaxInfo"] ? SenderFaxInfo.fromJS(_data["senderFaxInfo"]) : <any>undefined;
            this.receiverFaxInfo = _data["receiverFaxInfo"] ? ReceiverInfo.fromJS(_data["receiverFaxInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BpqyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["steps"] = this.steps ? this.steps.toJSON() : <any>undefined;
        data["senderFaxInfo"] = this.senderFaxInfo ? this.senderFaxInfo.toJSON() : <any>undefined;
        data["receiverFaxInfo"] = this.receiverFaxInfo ? this.receiverFaxInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBpqyInfoDto {
    id: number;
    ticketHolderId: number;
    status: BpqyRequestStatus;
    statusDisplayName: string | undefined;
    creationTime: DateTime;
    steps: BpqyStepsDto;
    senderFaxInfo: SenderFaxInfo;
    receiverFaxInfo: ReceiverInfo;
}

export class BpqyMedicarePartExtractDto implements IBpqyMedicarePartExtractDto {
    part!: string | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    buyIn!: boolean | undefined;

    constructor(data?: IBpqyMedicarePartExtractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.part = _data["part"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.buyIn = _data["buyIn"];
        }
    }

    static fromJS(data: any): BpqyMedicarePartExtractDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyMedicarePartExtractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["part"] = this.part;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["buyIn"] = this.buyIn;
        return data;
    }
}

export interface IBpqyMedicarePartExtractDto {
    part: string | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    buyIn: boolean | undefined;
}

export class BpqyRequestDto implements IBpqyRequestDto {
    id!: number;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    assignedCareerCoachUserId!: number | undefined;
    assignedCareerCoachName!: string | undefined;
    status!: BpqyRequestStatus;
    enumStatusDisplayName!: string | undefined;
    creationTime!: DateTime;
    outgoingConsentMailDocumentId!: number | undefined;
    signedConsentDocumentId!: number | undefined;
    bpqyDocumentId!: number | undefined;
    completedAt!: DateTime | undefined;
    faxHistories!: BpqyFaxAttemptDetailDto[] | undefined;

    constructor(data?: IBpqyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.assignedCareerCoachUserId = _data["assignedCareerCoachUserId"];
            this.assignedCareerCoachName = _data["assignedCareerCoachName"];
            this.status = _data["status"];
            this.enumStatusDisplayName = _data["enumStatusDisplayName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.outgoingConsentMailDocumentId = _data["outgoingConsentMailDocumentId"];
            this.signedConsentDocumentId = _data["signedConsentDocumentId"];
            this.bpqyDocumentId = _data["bpqyDocumentId"];
            this.completedAt = _data["completedAt"] ? DateTime.fromISO(_data["completedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["faxHistories"])) {
                this.faxHistories = [] as any;
                for (let item of _data["faxHistories"])
                    this.faxHistories!.push(BpqyFaxAttemptDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BpqyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["assignedCareerCoachUserId"] = this.assignedCareerCoachUserId;
        data["assignedCareerCoachName"] = this.assignedCareerCoachName;
        data["status"] = this.status;
        data["enumStatusDisplayName"] = this.enumStatusDisplayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["outgoingConsentMailDocumentId"] = this.outgoingConsentMailDocumentId;
        data["signedConsentDocumentId"] = this.signedConsentDocumentId;
        data["bpqyDocumentId"] = this.bpqyDocumentId;
        data["completedAt"] = this.completedAt ? this.completedAt.toString() : <any>undefined;
        if (Array.isArray(this.faxHistories)) {
            data["faxHistories"] = [];
            for (let item of this.faxHistories)
                data["faxHistories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBpqyRequestDto {
    id: number;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    assignedCareerCoachUserId: number | undefined;
    assignedCareerCoachName: string | undefined;
    status: BpqyRequestStatus;
    enumStatusDisplayName: string | undefined;
    creationTime: DateTime;
    outgoingConsentMailDocumentId: number | undefined;
    signedConsentDocumentId: number | undefined;
    bpqyDocumentId: number | undefined;
    completedAt: DateTime | undefined;
    faxHistories: BpqyFaxAttemptDetailDto[] | undefined;
}

export enum BpqyRequestStatus {
    Draft = 0,
    SentConsentFormToTicketHolder = 10,
    ReceivedSignedConsentForm = 20,
    PreparedConsentFormToSSAForFax = 30,
    FaxedConsentFormToSSA = 40,
    ReceivedBPQYFromSSA = 50,
    Completed = 100,
}

export class BpqyStepsDto implements IBpqyStepsDto {
    step1!: BpqyDocumentStepDto;
    step2!: BpqyDocumentStepDto;
    step3!: BpqyFaxStepDto;
    step4!: BpqyDocumentStepDto;

    constructor(data?: IBpqyStepsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step1 = _data["step1"] ? BpqyDocumentStepDto.fromJS(_data["step1"]) : <any>undefined;
            this.step2 = _data["step2"] ? BpqyDocumentStepDto.fromJS(_data["step2"]) : <any>undefined;
            this.step3 = _data["step3"] ? BpqyFaxStepDto.fromJS(_data["step3"]) : <any>undefined;
            this.step4 = _data["step4"] ? BpqyDocumentStepDto.fromJS(_data["step4"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BpqyStepsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BpqyStepsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step1"] = this.step1 ? this.step1.toJSON() : <any>undefined;
        data["step2"] = this.step2 ? this.step2.toJSON() : <any>undefined;
        data["step3"] = this.step3 ? this.step3.toJSON() : <any>undefined;
        data["step4"] = this.step4 ? this.step4.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBpqyStepsDto {
    step1: BpqyDocumentStepDto;
    step2: BpqyDocumentStepDto;
    step3: BpqyFaxStepDto;
    step4: BpqyDocumentStepDto;
}

export class BulkAssignCareerCoachToTicketHoldersDto implements IBulkAssignCareerCoachToTicketHoldersDto {
    careerCoachUserId!: number;
    selectAll!: boolean;
    ticketHolderIds!: number[] | undefined;
    filterText!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    assignedCC!: number[] | undefined;
    status!: TicketHolderStatus[] | undefined;

    constructor(data?: IBulkAssignCareerCoachToTicketHoldersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.selectAll = _data["selectAll"];
            if (Array.isArray(_data["ticketHolderIds"])) {
                this.ticketHolderIds = [] as any;
                for (let item of _data["ticketHolderIds"])
                    this.ticketHolderIds!.push(item);
            }
            this.filterText = _data["filterText"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            if (Array.isArray(_data["assignedCC"])) {
                this.assignedCC = [] as any;
                for (let item of _data["assignedCC"])
                    this.assignedCC!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkAssignCareerCoachToTicketHoldersDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAssignCareerCoachToTicketHoldersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["selectAll"] = this.selectAll;
        if (Array.isArray(this.ticketHolderIds)) {
            data["ticketHolderIds"] = [];
            for (let item of this.ticketHolderIds)
                data["ticketHolderIds"].push(item);
        }
        data["filterText"] = this.filterText;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        if (Array.isArray(this.assignedCC)) {
            data["assignedCC"] = [];
            for (let item of this.assignedCC)
                data["assignedCC"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        return data;
    }
}

export interface IBulkAssignCareerCoachToTicketHoldersDto {
    careerCoachUserId: number;
    selectAll: boolean;
    ticketHolderIds: number[] | undefined;
    filterText: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    assignedCC: number[] | undefined;
    status: TicketHolderStatus[] | undefined;
}

export class BulkAssignTicketHolderWageProcessingReportQDto implements IBulkAssignTicketHolderWageProcessingReportQDto {
    items!: AssignTicketHolderWageProcessingReportQDto[];

    constructor(data?: IBulkAssignTicketHolderWageProcessingReportQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssignTicketHolderWageProcessingReportQDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkAssignTicketHolderWageProcessingReportQDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAssignTicketHolderWageProcessingReportQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkAssignTicketHolderWageProcessingReportQDto {
    items: AssignTicketHolderWageProcessingReportQDto[];
}

export class BulkRejectionWageReportDto implements IBulkRejectionWageReportDto {
    ids!: number[];
    removeReason!: WageReportRemovalReason;

    constructor(data?: IBulkRejectionWageReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.removeReason = _data["removeReason"];
        }
    }

    static fromJS(data: any): BulkRejectionWageReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkRejectionWageReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["removeReason"] = this.removeReason;
        return data;
    }
}

export interface IBulkRejectionWageReportDto {
    ids: number[];
    removeReason: WageReportRemovalReason;
}

export class BulkWageReportOperationDuplicateDto implements IBulkWageReportOperationDuplicateDto {
    id!: number;
    keptId!: number;

    constructor(data?: IBulkWageReportOperationDuplicateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keptId = _data["keptId"];
        }
    }

    static fromJS(data: any): BulkWageReportOperationDuplicateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWageReportOperationDuplicateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keptId"] = this.keptId;
        return data;
    }
}

export interface IBulkWageReportOperationDuplicateDto {
    id: number;
    keptId: number;
}

export class BulkWageReportOperationErrorDto implements IBulkWageReportOperationErrorDto {
    id!: number;
    errorMessage!: string | undefined;

    constructor(data?: IBulkWageReportOperationErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BulkWageReportOperationErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWageReportOperationErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBulkWageReportOperationErrorDto {
    id: number;
    errorMessage: string | undefined;
}

export class BulkWageReportOperationResultDto implements IBulkWageReportOperationResultDto {
    successCount!: number;
    errors!: BulkWageReportOperationErrorDto[] | undefined;
    duplicates!: BulkWageReportOperationDuplicateDto[] | undefined;
    missingFileIds!: number[] | undefined;

    constructor(data?: IBulkWageReportOperationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successCount = _data["successCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(BulkWageReportOperationErrorDto.fromJS(item));
            }
            if (Array.isArray(_data["duplicates"])) {
                this.duplicates = [] as any;
                for (let item of _data["duplicates"])
                    this.duplicates!.push(BulkWageReportOperationDuplicateDto.fromJS(item));
            }
            if (Array.isArray(_data["missingFileIds"])) {
                this.missingFileIds = [] as any;
                for (let item of _data["missingFileIds"])
                    this.missingFileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkWageReportOperationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkWageReportOperationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (Array.isArray(this.duplicates)) {
            data["duplicates"] = [];
            for (let item of this.duplicates)
                data["duplicates"].push(item.toJSON());
        }
        if (Array.isArray(this.missingFileIds)) {
            data["missingFileIds"] = [];
            for (let item of this.missingFileIds)
                data["missingFileIds"].push(item);
        }
        return data;
    }
}

export interface IBulkWageReportOperationResultDto {
    successCount: number;
    errors: BulkWageReportOperationErrorDto[] | undefined;
    duplicates: BulkWageReportOperationDuplicateDto[] | undefined;
    missingFileIds: number[] | undefined;
}

export class BuyTwilioPhoneNumberInput implements IBuyTwilioPhoneNumberInput {
    phoneNumber!: string | undefined;
    voiceCallForwardToPhoneNumber!: string | undefined;

    constructor(data?: IBuyTwilioPhoneNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.voiceCallForwardToPhoneNumber = _data["voiceCallForwardToPhoneNumber"];
        }
    }

    static fromJS(data: any): BuyTwilioPhoneNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new BuyTwilioPhoneNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["voiceCallForwardToPhoneNumber"] = this.voiceCallForwardToPhoneNumber;
        return data;
    }
}

export interface IBuyTwilioPhoneNumberInput {
    phoneNumber: string | undefined;
    voiceCallForwardToPhoneNumber: string | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CalendarAttendee implements ICalendarAttendee {
    name!: string | undefined;
    email!: string | undefined;
    status!: CalendarAttendeeStatus;
    type!: CalendarAttendeeType;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: ICalendarAttendee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CalendarAttendee {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAttendee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["status"] = this.status;
        data["type"] = this.type;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICalendarAttendee {
    name: string | undefined;
    email: string | undefined;
    status: CalendarAttendeeStatus;
    type: CalendarAttendeeType;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    userId: number | undefined;
}

export enum CalendarAttendeeStatus {
    Accepted = 0,
    Declined = 1,
    Pending = 2,
}

export enum CalendarAttendeeType {
    Required = 0,
    Optional = 1,
}

export enum CalendarEventStatus {
    Pending = 0,
    Confirmed = 1,
    Cancelled = 2,
    Missed = 3,
    Completed = 4,
}

export enum CalendarEventType {
    TicketHolderFollowup = 0,
    LeadFollowup = 1,
    Task = 2,
    TicketHolderInterview = 3,
    TicketHolderReminder = 4,
    Other = 99,
}

export class CalendarTaskDto implements ICalendarTaskDto {
    id!: number | undefined;
    assignedToUserId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    dueDateTime!: DateTime;
    status!: CalendarEventStatus;
    followupType!: FollowupType;
    isCalendar!: boolean;
    eventType!: CalendarEventType;

    constructor(data?: ICalendarTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dueDateTime = _data["dueDateTime"] ? DateTime.fromISO(_data["dueDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.followupType = _data["followupType"];
            this.isCalendar = _data["isCalendar"];
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): CalendarTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dueDateTime"] = this.dueDateTime ? this.dueDateTime.toString() : <any>undefined;
        data["status"] = this.status;
        data["followupType"] = this.followupType;
        data["isCalendar"] = this.isCalendar;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface ICalendarTaskDto {
    id: number | undefined;
    assignedToUserId: number | undefined;
    title: string | undefined;
    description: string | undefined;
    dueDateTime: DateTime;
    status: CalendarEventStatus;
    followupType: FollowupType;
    isCalendar: boolean;
    eventType: CalendarEventType;
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export enum CampaignDataSource {
    Lead = 1,
    TicketHolder = 2,
}

export class CampaignDto implements ICampaignDto {
    id!: number;
    campaignName!: string | undefined;
    campaignType!: CampaignType;
    status!: CampaignStatus;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    messageSubject!: string | undefined;
    messageBody!: string | undefined;
    aiVoiceAgentId!: number | undefined;
    forwardPhoneNumber!: string | undefined;
    stopCallingEnabled!: boolean;
    isCallingPaused!: boolean;
    taskId!: number | undefined;
    taskInstanceId!: number | undefined;
    creationTime!: DateTime;
    jobId!: string | undefined;
    filterDataSource!: CampaignDataSource;
    filterFromBatchId!: string | undefined;
    filterStateCodes!: string[] | undefined;
    filterInTimeZones!: string[] | undefined;
    recipients!: CampaignRecipientDto[] | undefined;

    constructor(data?: ICampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campaignName = _data["campaignName"];
            this.campaignType = _data["campaignType"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.messageSubject = _data["messageSubject"];
            this.messageBody = _data["messageBody"];
            this.aiVoiceAgentId = _data["aiVoiceAgentId"];
            this.forwardPhoneNumber = _data["forwardPhoneNumber"];
            this.stopCallingEnabled = _data["stopCallingEnabled"];
            this.isCallingPaused = _data["isCallingPaused"];
            this.taskId = _data["taskId"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.jobId = _data["jobId"];
            this.filterDataSource = _data["filterDataSource"];
            this.filterFromBatchId = _data["filterFromBatchId"];
            if (Array.isArray(_data["filterStateCodes"])) {
                this.filterStateCodes = [] as any;
                for (let item of _data["filterStateCodes"])
                    this.filterStateCodes!.push(item);
            }
            if (Array.isArray(_data["filterInTimeZones"])) {
                this.filterInTimeZones = [] as any;
                for (let item of _data["filterInTimeZones"])
                    this.filterInTimeZones!.push(item);
            }
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(CampaignRecipientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campaignName"] = this.campaignName;
        data["campaignType"] = this.campaignType;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["messageSubject"] = this.messageSubject;
        data["messageBody"] = this.messageBody;
        data["aiVoiceAgentId"] = this.aiVoiceAgentId;
        data["forwardPhoneNumber"] = this.forwardPhoneNumber;
        data["stopCallingEnabled"] = this.stopCallingEnabled;
        data["isCallingPaused"] = this.isCallingPaused;
        data["taskId"] = this.taskId;
        data["taskInstanceId"] = this.taskInstanceId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["jobId"] = this.jobId;
        data["filterDataSource"] = this.filterDataSource;
        data["filterFromBatchId"] = this.filterFromBatchId;
        if (Array.isArray(this.filterStateCodes)) {
            data["filterStateCodes"] = [];
            for (let item of this.filterStateCodes)
                data["filterStateCodes"].push(item);
        }
        if (Array.isArray(this.filterInTimeZones)) {
            data["filterInTimeZones"] = [];
            for (let item of this.filterInTimeZones)
                data["filterInTimeZones"].push(item);
        }
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICampaignDto {
    id: number;
    campaignName: string | undefined;
    campaignType: CampaignType;
    status: CampaignStatus;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    messageSubject: string | undefined;
    messageBody: string | undefined;
    aiVoiceAgentId: number | undefined;
    forwardPhoneNumber: string | undefined;
    stopCallingEnabled: boolean;
    isCallingPaused: boolean;
    taskId: number | undefined;
    taskInstanceId: number | undefined;
    creationTime: DateTime;
    jobId: string | undefined;
    filterDataSource: CampaignDataSource;
    filterFromBatchId: string | undefined;
    filterStateCodes: string[] | undefined;
    filterInTimeZones: string[] | undefined;
    recipients: CampaignRecipientDto[] | undefined;
}

export class CampaignFilterDto implements ICampaignFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filterText!: string | undefined;
    campaignName!: string | undefined;
    campaignType!: CampaignType;
    status!: CampaignStatus[] | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;

    constructor(data?: ICampaignFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filterText = _data["filterText"];
            this.campaignName = _data["campaignName"];
            this.campaignType = _data["campaignType"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CampaignFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filterText"] = this.filterText;
        data["campaignName"] = this.campaignName;
        data["campaignType"] = this.campaignType;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface ICampaignFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filterText: string | undefined;
    campaignName: string | undefined;
    campaignType: CampaignType;
    status: CampaignStatus[] | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
}

export class CampaignHistoryDto implements ICampaignHistoryDto {
    id!: number;
    campaignName!: string | undefined;
    campaignType!: CampaignType;
    status!: CampaignStatus;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    taskId!: number | undefined;
    taskInstanceId!: number | undefined;
    totalRecipients!: number;
    totalSuccess!: number;
    totalOptedOut!: number;
    totalBounceBack!: number;

    constructor(data?: ICampaignHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campaignName = _data["campaignName"];
            this.campaignType = _data["campaignType"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.taskId = _data["taskId"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.totalRecipients = _data["totalRecipients"];
            this.totalSuccess = _data["totalSuccess"];
            this.totalOptedOut = _data["totalOptedOut"];
            this.totalBounceBack = _data["totalBounceBack"];
        }
    }

    static fromJS(data: any): CampaignHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campaignName"] = this.campaignName;
        data["campaignType"] = this.campaignType;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["taskId"] = this.taskId;
        data["taskInstanceId"] = this.taskInstanceId;
        data["totalRecipients"] = this.totalRecipients;
        data["totalSuccess"] = this.totalSuccess;
        data["totalOptedOut"] = this.totalOptedOut;
        data["totalBounceBack"] = this.totalBounceBack;
        return data;
    }
}

export interface ICampaignHistoryDto {
    id: number;
    campaignName: string | undefined;
    campaignType: CampaignType;
    status: CampaignStatus;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    taskId: number | undefined;
    taskInstanceId: number | undefined;
    totalRecipients: number;
    totalSuccess: number;
    totalOptedOut: number;
    totalBounceBack: number;
}

export class CampaignInputDto implements ICampaignInputDto {
    campaignName!: string | undefined;
    campaignType!: CampaignType;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    messageSubject!: string | undefined;
    messageBody!: string | undefined;
    aiVoiceAgentId!: number | undefined;
    forwardPhoneNumber!: string | undefined;
    stopCallingEnabled!: boolean;
    filterDataSource!: CampaignDataSource;
    filterFromBatchId!: string | undefined;
    filterStateCodes!: string[] | undefined;
    filterInTimeZones!: string[] | undefined;
    status!: CampaignStatus;
    recipients!: CampaignRecipientInputDto[] | undefined;
    isImmediate!: boolean;
    futureRunTime!: DateTime | undefined;
    isRecurring!: boolean | undefined;
    recurringJobSchedule!: string | undefined;

    constructor(data?: ICampaignInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.campaignType = _data["campaignType"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.messageSubject = _data["messageSubject"];
            this.messageBody = _data["messageBody"];
            this.aiVoiceAgentId = _data["aiVoiceAgentId"];
            this.forwardPhoneNumber = _data["forwardPhoneNumber"];
            this.stopCallingEnabled = _data["stopCallingEnabled"];
            this.filterDataSource = _data["filterDataSource"];
            this.filterFromBatchId = _data["filterFromBatchId"];
            if (Array.isArray(_data["filterStateCodes"])) {
                this.filterStateCodes = [] as any;
                for (let item of _data["filterStateCodes"])
                    this.filterStateCodes!.push(item);
            }
            if (Array.isArray(_data["filterInTimeZones"])) {
                this.filterInTimeZones = [] as any;
                for (let item of _data["filterInTimeZones"])
                    this.filterInTimeZones!.push(item);
            }
            this.status = _data["status"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(CampaignRecipientInputDto.fromJS(item));
            }
            this.isImmediate = _data["isImmediate"];
            this.futureRunTime = _data["futureRunTime"] ? DateTime.fromISO(_data["futureRunTime"].toString()) : <any>undefined;
            this.isRecurring = _data["isRecurring"];
            this.recurringJobSchedule = _data["recurringJobSchedule"];
        }
    }

    static fromJS(data: any): CampaignInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["campaignType"] = this.campaignType;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["messageSubject"] = this.messageSubject;
        data["messageBody"] = this.messageBody;
        data["aiVoiceAgentId"] = this.aiVoiceAgentId;
        data["forwardPhoneNumber"] = this.forwardPhoneNumber;
        data["stopCallingEnabled"] = this.stopCallingEnabled;
        data["filterDataSource"] = this.filterDataSource;
        data["filterFromBatchId"] = this.filterFromBatchId;
        if (Array.isArray(this.filterStateCodes)) {
            data["filterStateCodes"] = [];
            for (let item of this.filterStateCodes)
                data["filterStateCodes"].push(item);
        }
        if (Array.isArray(this.filterInTimeZones)) {
            data["filterInTimeZones"] = [];
            for (let item of this.filterInTimeZones)
                data["filterInTimeZones"].push(item);
        }
        data["status"] = this.status;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["isImmediate"] = this.isImmediate;
        data["futureRunTime"] = this.futureRunTime ? this.futureRunTime.toString() : <any>undefined;
        data["isRecurring"] = this.isRecurring;
        data["recurringJobSchedule"] = this.recurringJobSchedule;
        return data;
    }
}

export interface ICampaignInputDto {
    campaignName: string | undefined;
    campaignType: CampaignType;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    messageSubject: string | undefined;
    messageBody: string | undefined;
    aiVoiceAgentId: number | undefined;
    forwardPhoneNumber: string | undefined;
    stopCallingEnabled: boolean;
    filterDataSource: CampaignDataSource;
    filterFromBatchId: string | undefined;
    filterStateCodes: string[] | undefined;
    filterInTimeZones: string[] | undefined;
    status: CampaignStatus;
    recipients: CampaignRecipientInputDto[] | undefined;
    isImmediate: boolean;
    futureRunTime: DateTime | undefined;
    isRecurring: boolean | undefined;
    recurringJobSchedule: string | undefined;
}

export class CampaignRecipientDto implements ICampaignRecipientDto {
    id!: number;
    campaignId!: number;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    contactType!: string | undefined;
    contactInfo!: string | undefined;
    status!: ActivityStatus;
    readonly statusDisplayName!: string | undefined;
    sentDate!: DateTime | undefined;
    logId!: number | undefined;

    constructor(data?: ICampaignRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.campaignId = _data["campaignId"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.contactType = _data["contactType"];
            this.contactInfo = _data["contactInfo"];
            this.status = _data["status"];
            (<any>this).statusDisplayName = _data["statusDisplayName"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.logId = _data["logId"];
        }
    }

    static fromJS(data: any): CampaignRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campaignId"] = this.campaignId;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["contactType"] = this.contactType;
        data["contactInfo"] = this.contactInfo;
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["logId"] = this.logId;
        return data;
    }
}

export interface ICampaignRecipientDto {
    id: number;
    campaignId: number;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    contactType: string | undefined;
    contactInfo: string | undefined;
    status: ActivityStatus;
    statusDisplayName: string | undefined;
    sentDate: DateTime | undefined;
    logId: number | undefined;
}

export class CampaignRecipientInputDto implements ICampaignRecipientInputDto {
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    contactInfo!: string;

    constructor(data?: ICampaignRecipientInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.contactInfo = _data["contactInfo"];
        }
    }

    static fromJS(data: any): CampaignRecipientInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignRecipientInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["contactInfo"] = this.contactInfo;
        return data;
    }
}

export interface ICampaignRecipientInputDto {
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    contactInfo: string;
}

export class CampaignResponseDto implements ICampaignResponseDto {
    id!: number;
    channel!: string | undefined;
    campaignId!: number | undefined;
    campaignName!: string | undefined;
    clientId!: string | undefined;
    clientName!: string | undefined;
    contactInfo!: string | undefined;
    receivedMessage!: string | undefined;
    receivedDate!: DateTime;
    careerCoachUserId!: number | undefined;
    careerCoachName!: string | undefined;
    isHandled!: boolean;
    responseMessage!: string | undefined;
    responseDate!: DateTime | undefined;
    isMarkedAsRead!: boolean;
    markedAsReadBy!: string | undefined;

    constructor(data?: ICampaignResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channel = _data["channel"];
            this.campaignId = _data["campaignId"];
            this.campaignName = _data["campaignName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.contactInfo = _data["contactInfo"];
            this.receivedMessage = _data["receivedMessage"];
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : <any>undefined;
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachName = _data["careerCoachName"];
            this.isHandled = _data["isHandled"];
            this.responseMessage = _data["responseMessage"];
            this.responseDate = _data["responseDate"] ? DateTime.fromISO(_data["responseDate"].toString()) : <any>undefined;
            this.isMarkedAsRead = _data["isMarkedAsRead"];
            this.markedAsReadBy = _data["markedAsReadBy"];
        }
    }

    static fromJS(data: any): CampaignResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channel"] = this.channel;
        data["campaignId"] = this.campaignId;
        data["campaignName"] = this.campaignName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["contactInfo"] = this.contactInfo;
        data["receivedMessage"] = this.receivedMessage;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : <any>undefined;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachName"] = this.careerCoachName;
        data["isHandled"] = this.isHandled;
        data["responseMessage"] = this.responseMessage;
        data["responseDate"] = this.responseDate ? this.responseDate.toString() : <any>undefined;
        data["isMarkedAsRead"] = this.isMarkedAsRead;
        data["markedAsReadBy"] = this.markedAsReadBy;
        return data;
    }
}

export interface ICampaignResponseDto {
    id: number;
    channel: string | undefined;
    campaignId: number | undefined;
    campaignName: string | undefined;
    clientId: string | undefined;
    clientName: string | undefined;
    contactInfo: string | undefined;
    receivedMessage: string | undefined;
    receivedDate: DateTime;
    careerCoachUserId: number | undefined;
    careerCoachName: string | undefined;
    isHandled: boolean;
    responseMessage: string | undefined;
    responseDate: DateTime | undefined;
    isMarkedAsRead: boolean;
    markedAsReadBy: string | undefined;
}

export class CampaignResponseFilterDto implements ICampaignResponseFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filterText!: string | undefined;
    channel!: string | undefined;
    handledFilter!: CampaignResponseHandledFilter;

    constructor(data?: ICampaignResponseFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filterText = _data["filterText"];
            this.channel = _data["channel"];
            this.handledFilter = _data["handledFilter"];
        }
    }

    static fromJS(data: any): CampaignResponseFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignResponseFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filterText"] = this.filterText;
        data["channel"] = this.channel;
        data["handledFilter"] = this.handledFilter;
        return data;
    }
}

export interface ICampaignResponseFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filterText: string | undefined;
    channel: string | undefined;
    handledFilter: CampaignResponseHandledFilter;
}

export enum CampaignResponseHandledFilter {
    All = 0,
    Handled = 1,
    Missed = 2,
}

export enum CampaignStatus {
    Draft = 0,
    Active = 1,
    Sent = 2,
    Failed = 3,
    Paused = 4,
    Running = 5,
}

export enum CampaignType {
    SMS = 0,
    Email = 1,
    Voice = 2,
}

export class CampaignUpdateDto implements ICampaignUpdateDto {
    campaignName!: string | undefined;
    campaignType!: CampaignType;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    messageSubject!: string | undefined;
    messageBody!: string | undefined;
    aiVoiceAgentId!: number | undefined;
    forwardPhoneNumber!: string | undefined;
    stopCallingEnabled!: boolean;
    filterDataSource!: CampaignDataSource;
    filterFromBatchId!: string | undefined;
    filterStateCodes!: string[] | undefined;
    filterInTimeZones!: string[] | undefined;
    status!: CampaignStatus;
    recipients!: CampaignRecipientInputDto[] | undefined;
    isImmediate!: boolean;
    futureRunTime!: DateTime | undefined;
    isRecurring!: boolean | undefined;
    recurringJobSchedule!: string | undefined;
    id!: number;

    constructor(data?: ICampaignUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.campaignType = _data["campaignType"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.messageSubject = _data["messageSubject"];
            this.messageBody = _data["messageBody"];
            this.aiVoiceAgentId = _data["aiVoiceAgentId"];
            this.forwardPhoneNumber = _data["forwardPhoneNumber"];
            this.stopCallingEnabled = _data["stopCallingEnabled"];
            this.filterDataSource = _data["filterDataSource"];
            this.filterFromBatchId = _data["filterFromBatchId"];
            if (Array.isArray(_data["filterStateCodes"])) {
                this.filterStateCodes = [] as any;
                for (let item of _data["filterStateCodes"])
                    this.filterStateCodes!.push(item);
            }
            if (Array.isArray(_data["filterInTimeZones"])) {
                this.filterInTimeZones = [] as any;
                for (let item of _data["filterInTimeZones"])
                    this.filterInTimeZones!.push(item);
            }
            this.status = _data["status"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(CampaignRecipientInputDto.fromJS(item));
            }
            this.isImmediate = _data["isImmediate"];
            this.futureRunTime = _data["futureRunTime"] ? DateTime.fromISO(_data["futureRunTime"].toString()) : <any>undefined;
            this.isRecurring = _data["isRecurring"];
            this.recurringJobSchedule = _data["recurringJobSchedule"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CampaignUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["campaignType"] = this.campaignType;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["messageSubject"] = this.messageSubject;
        data["messageBody"] = this.messageBody;
        data["aiVoiceAgentId"] = this.aiVoiceAgentId;
        data["forwardPhoneNumber"] = this.forwardPhoneNumber;
        data["stopCallingEnabled"] = this.stopCallingEnabled;
        data["filterDataSource"] = this.filterDataSource;
        data["filterFromBatchId"] = this.filterFromBatchId;
        if (Array.isArray(this.filterStateCodes)) {
            data["filterStateCodes"] = [];
            for (let item of this.filterStateCodes)
                data["filterStateCodes"].push(item);
        }
        if (Array.isArray(this.filterInTimeZones)) {
            data["filterInTimeZones"] = [];
            for (let item of this.filterInTimeZones)
                data["filterInTimeZones"].push(item);
        }
        data["status"] = this.status;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["isImmediate"] = this.isImmediate;
        data["futureRunTime"] = this.futureRunTime ? this.futureRunTime.toString() : <any>undefined;
        data["isRecurring"] = this.isRecurring;
        data["recurringJobSchedule"] = this.recurringJobSchedule;
        data["id"] = this.id;
        return data;
    }
}

export interface ICampaignUpdateDto {
    campaignName: string | undefined;
    campaignType: CampaignType;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    messageSubject: string | undefined;
    messageBody: string | undefined;
    aiVoiceAgentId: number | undefined;
    forwardPhoneNumber: string | undefined;
    stopCallingEnabled: boolean;
    filterDataSource: CampaignDataSource;
    filterFromBatchId: string | undefined;
    filterStateCodes: string[] | undefined;
    filterInTimeZones: string[] | undefined;
    status: CampaignStatus;
    recipients: CampaignRecipientInputDto[] | undefined;
    isImmediate: boolean;
    futureRunTime: DateTime | undefined;
    isRecurring: boolean | undefined;
    recurringJobSchedule: string | undefined;
    id: number;
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export class CancellationToken implements ICancellationToken {
    readonly isCancellationRequested!: boolean;
    readonly canBeCanceled!: boolean;
    waitHandle!: WaitHandle;

    constructor(data?: ICancellationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isCancellationRequested = _data["isCancellationRequested"];
            (<any>this).canBeCanceled = _data["canBeCanceled"];
            this.waitHandle = _data["waitHandle"] ? WaitHandle.fromJS(_data["waitHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancellationToken {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCancellationRequested"] = this.isCancellationRequested;
        data["canBeCanceled"] = this.canBeCanceled;
        data["waitHandle"] = this.waitHandle ? this.waitHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICancellationToken {
    isCancellationRequested: boolean;
    canBeCanceled: boolean;
    waitHandle: WaitHandle;
}

export class CancellationTokenSource implements ICancellationTokenSource {
    readonly isCancellationRequested!: boolean;
    token!: CancellationToken;

    constructor(data?: ICancellationTokenSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isCancellationRequested = _data["isCancellationRequested"];
            this.token = _data["token"] ? CancellationToken.fromJS(_data["token"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancellationTokenSource {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationTokenSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCancellationRequested"] = this.isCancellationRequested;
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICancellationTokenSource {
    isCancellationRequested: boolean;
    token: CancellationToken;
}

export class CaptchaSettingsEditDto implements ICaptchaSettingsEditDto {
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnEmailActivation!: boolean;
    useCaptchaOnResetPassword!: boolean;
    useCaptchaOnLogin!: boolean;

    constructor(data?: ICaptchaSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnEmailActivation = _data["useCaptchaOnEmailActivation"];
            this.useCaptchaOnResetPassword = _data["useCaptchaOnResetPassword"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
        }
    }

    static fromJS(data: any): CaptchaSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaptchaSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnEmailActivation"] = this.useCaptchaOnEmailActivation;
        data["useCaptchaOnResetPassword"] = this.useCaptchaOnResetPassword;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        return data;
    }
}

export interface ICaptchaSettingsEditDto {
    useCaptchaOnRegistration: boolean;
    useCaptchaOnEmailActivation: boolean;
    useCaptchaOnResetPassword: boolean;
    useCaptchaOnLogin: boolean;
}

export class CareerCoachInfoDto implements ICareerCoachInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    mailAddress!: string | undefined;
    fax!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;

    constructor(data?: ICareerCoachInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.mailAddress = _data["mailAddress"];
            this.fax = _data["fax"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
        }
    }

    static fromJS(data: any): CareerCoachInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareerCoachInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["mailAddress"] = this.mailAddress;
        data["fax"] = this.fax;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        return data;
    }
}

export interface ICareerCoachInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    mailAddress: string | undefined;
    fax: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
}

export class CareerCoachOverviewDto implements ICareerCoachOverviewDto {
    assigneeId!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    ticketHolderCount!: number;

    constructor(data?: ICareerCoachOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigneeId = _data["assigneeId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.ticketHolderCount = _data["ticketHolderCount"];
        }
    }

    static fromJS(data: any): CareerCoachOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareerCoachOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigneeId"] = this.assigneeId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["ticketHolderCount"] = this.ticketHolderCount;
        return data;
    }
}

export interface ICareerCoachOverviewDto {
    assigneeId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    ticketHolderCount: number;
}

export class ChangeEmailInput implements IChangeEmailInput {
    c!: string | undefined;

    constructor(data?: IChangeEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ChangeEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IChangeEmailInput {
    c: string | undefined;
}

export class ChangeJobSearchRequestAssigneeDto implements IChangeJobSearchRequestAssigneeDto {
    id!: number;
    assignedToUserId!: number;

    constructor(data?: IChangeJobSearchRequestAssigneeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
        }
    }

    static fromJS(data: any): ChangeJobSearchRequestAssigneeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeJobSearchRequestAssigneeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        return data;
    }
}

export interface IChangeJobSearchRequestAssigneeDto {
    id: number;
    assignedToUserId: number;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class ChatLogDetailDto implements IChatLogDetailDto {
    id!: number;
    tenantId!: number | undefined;
    direction!: ActivityDirection;
    careerCoachUserId!: number;
    careerCoachName!: string | undefined;
    ticketHolderId!: string | undefined;
    ticketHolderName!: string | undefined;
    chatSessionId!: string | undefined;
    messageContent!: string | undefined;
    status!: ActivityStatus;
    enumDisplayActivityStatus!: string | undefined;
    attachmentIds!: number[] | undefined;
    attachments!: THChatFileDto[] | undefined;
    errorMessage!: string | undefined;
    logType!: LogType;
    isRead!: boolean;
    readTime!: DateTime | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;

    constructor(data?: IChatLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.direction = _data["direction"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachName = _data["careerCoachName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.chatSessionId = _data["chatSessionId"];
            this.messageContent = _data["messageContent"];
            this.status = _data["status"];
            this.enumDisplayActivityStatus = _data["enumDisplayActivityStatus"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(THChatFileDto.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.logType = _data["logType"];
            this.isRead = _data["isRead"];
            this.readTime = _data["readTime"] ? DateTime.fromISO(_data["readTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): ChatLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["direction"] = this.direction;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachName"] = this.careerCoachName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["chatSessionId"] = this.chatSessionId;
        data["messageContent"] = this.messageContent;
        data["status"] = this.status;
        data["enumDisplayActivityStatus"] = this.enumDisplayActivityStatus;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["logType"] = this.logType;
        data["isRead"] = this.isRead;
        data["readTime"] = this.readTime ? this.readTime.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }
}

export interface IChatLogDetailDto {
    id: number;
    tenantId: number | undefined;
    direction: ActivityDirection;
    careerCoachUserId: number;
    careerCoachName: string | undefined;
    ticketHolderId: string | undefined;
    ticketHolderName: string | undefined;
    chatSessionId: string | undefined;
    messageContent: string | undefined;
    status: ActivityStatus;
    enumDisplayActivityStatus: string | undefined;
    attachmentIds: number[] | undefined;
    attachments: THChatFileDto[] | undefined;
    errorMessage: string | undefined;
    logType: LogType;
    isRead: boolean;
    readTime: DateTime | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
}

export class ChatMessageDto implements IChatMessageDto {
    id!: number;
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: DateTime;
    sharedMessageId!: string | undefined;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = _data["sharedMessageId"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        return data;
    }
}

export interface IChatMessageDto {
    id: number;
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: DateTime;
    sharedMessageId: string | undefined;
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class CleanValuesInput implements ICleanValuesInput {
    dynamicEntityPropertyId!: number;
    entityId!: string | undefined;

    constructor(data?: ICleanValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): CleanValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CleanValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ICleanValuesInput {
    dynamicEntityPropertyId: number;
    entityId: string | undefined;
}

export enum ClientType {
    Lead = 1,
    TicketHolder = 2,
    General = 3,
    Campaign = 4,
}

export class CoachCreateOrUpdateJobInterviewDto implements ICoachCreateOrUpdateJobInterviewDto {
    id!: number | undefined;
    ticketHolderId!: number;
    jobLeadId!: number | undefined;
    companyName!: string | undefined;
    overallOutcome!: InterviewOutcome;
    notes!: string | undefined;
    sessions!: BaseCreateOrUpdateJobInterviewSessionDto[] | undefined;

    constructor(data?: ICoachCreateOrUpdateJobInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobLeadId = _data["jobLeadId"];
            this.companyName = _data["companyName"];
            this.overallOutcome = _data["overallOutcome"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(BaseCreateOrUpdateJobInterviewSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoachCreateOrUpdateJobInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoachCreateOrUpdateJobInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobLeadId"] = this.jobLeadId;
        data["companyName"] = this.companyName;
        data["overallOutcome"] = this.overallOutcome;
        data["notes"] = this.notes;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoachCreateOrUpdateJobInterviewDto {
    id: number | undefined;
    ticketHolderId: number;
    jobLeadId: number | undefined;
    companyName: string | undefined;
    overallOutcome: InterviewOutcome;
    notes: string | undefined;
    sessions: BaseCreateOrUpdateJobInterviewSessionDto[] | undefined;
}

export class CoachCreateOrUpdateJobInterviewSessionDto implements ICoachCreateOrUpdateJobInterviewSessionDto {
    id!: number | undefined;
    interviewRound!: InterviewRound;
    interviewMethod!: InterviewMethod;
    interviewDate!: DateTime;
    timeZone!: string;
    locationAddress!: string | undefined;
    interviewerName!: string | undefined;
    interviewerContact!: string | undefined;
    outcome!: InterviewOutcome;
    notes!: string | undefined;

    constructor(data?: ICoachCreateOrUpdateJobInterviewSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interviewRound = _data["interviewRound"];
            this.interviewMethod = _data["interviewMethod"];
            this.interviewDate = _data["interviewDate"] ? DateTime.fromISO(_data["interviewDate"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.locationAddress = _data["locationAddress"];
            this.interviewerName = _data["interviewerName"];
            this.interviewerContact = _data["interviewerContact"];
            this.outcome = _data["outcome"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CoachCreateOrUpdateJobInterviewSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoachCreateOrUpdateJobInterviewSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interviewRound"] = this.interviewRound;
        data["interviewMethod"] = this.interviewMethod;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["locationAddress"] = this.locationAddress;
        data["interviewerName"] = this.interviewerName;
        data["interviewerContact"] = this.interviewerContact;
        data["outcome"] = this.outcome;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICoachCreateOrUpdateJobInterviewSessionDto {
    id: number | undefined;
    interviewRound: InterviewRound;
    interviewMethod: InterviewMethod;
    interviewDate: DateTime;
    timeZone: string;
    locationAddress: string | undefined;
    interviewerName: string | undefined;
    interviewerContact: string | undefined;
    outcome: InterviewOutcome;
    notes: string | undefined;
}

export class CoachJobInterviewDto implements ICoachJobInterviewDto {
    id!: number;
    jobLeadId!: number | undefined;
    companyName!: string | undefined;
    overallOutcome!: InterviewOutcome;
    notes!: string | undefined;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    sessions!: CoachJobInterviewSessionDto[] | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;

    constructor(data?: ICoachJobInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobLeadId = _data["jobLeadId"];
            this.companyName = _data["companyName"];
            this.overallOutcome = _data["overallOutcome"];
            this.notes = _data["notes"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(CoachJobInterviewSessionDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
        }
    }

    static fromJS(data: any): CoachJobInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoachJobInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobLeadId"] = this.jobLeadId;
        data["companyName"] = this.companyName;
        data["overallOutcome"] = this.overallOutcome;
        data["notes"] = this.notes;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        return data;
    }
}

export interface ICoachJobInterviewDto {
    id: number;
    jobLeadId: number | undefined;
    companyName: string | undefined;
    overallOutcome: InterviewOutcome;
    notes: string | undefined;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    sessions: CoachJobInterviewSessionDto[] | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
}

export class CoachJobInterviewSessionDto implements ICoachJobInterviewSessionDto {
    id!: number;
    interviewRound!: InterviewRound;
    interviewMethod!: InterviewMethod;
    interviewDate!: DateTime;
    timeZone!: string | undefined;
    outcome!: InterviewOutcome;
    notes!: string | undefined;
    locationAddress!: string | undefined;
    interviewerName!: string | undefined;
    interviewerContact!: string | undefined;
    enumInterviewRoundDisplayName!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;

    constructor(data?: ICoachJobInterviewSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interviewRound = _data["interviewRound"];
            this.interviewMethod = _data["interviewMethod"];
            this.interviewDate = _data["interviewDate"] ? DateTime.fromISO(_data["interviewDate"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.outcome = _data["outcome"];
            this.notes = _data["notes"];
            this.locationAddress = _data["locationAddress"];
            this.interviewerName = _data["interviewerName"];
            this.interviewerContact = _data["interviewerContact"];
            this.enumInterviewRoundDisplayName = _data["enumInterviewRoundDisplayName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
        }
    }

    static fromJS(data: any): CoachJobInterviewSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoachJobInterviewSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interviewRound"] = this.interviewRound;
        data["interviewMethod"] = this.interviewMethod;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["outcome"] = this.outcome;
        data["notes"] = this.notes;
        data["locationAddress"] = this.locationAddress;
        data["interviewerName"] = this.interviewerName;
        data["interviewerContact"] = this.interviewerContact;
        data["enumInterviewRoundDisplayName"] = this.enumInterviewRoundDisplayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        return data;
    }
}

export interface ICoachJobInterviewSessionDto {
    id: number;
    interviewRound: InterviewRound;
    interviewMethod: InterviewMethod;
    interviewDate: DateTime;
    timeZone: string | undefined;
    outcome: InterviewOutcome;
    notes: string | undefined;
    locationAddress: string | undefined;
    interviewerName: string | undefined;
    interviewerContact: string | undefined;
    enumInterviewRoundDisplayName: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class CommentsDto implements ICommentsDto {
    leadId!: number;
    comments!: string | undefined;

    constructor(data?: ICommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICommentsDto {
    leadId: number;
    comments: string | undefined;
}

export class CompleteMarketingEventInput implements ICompleteMarketingEventInput {
    id!: number;
    outcome!: string | undefined;

    constructor(data?: ICompleteMarketingEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outcome = _data["outcome"];
        }
    }

    static fromJS(data: any): CompleteMarketingEventInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteMarketingEventInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outcome"] = this.outcome;
        return data;
    }
}

export interface ICompleteMarketingEventInput {
    id: number;
    outcome: string | undefined;
}

export class CompleteSuitabilityUploadInput implements ICompleteSuitabilityUploadInput {
    token!: string;
    middleName!: string | undefined;
    phone!: string | undefined;
    isUsCitizen!: boolean;
    fingerprintDate!: DateTime | undefined;

    constructor(data?: ICompleteSuitabilityUploadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.middleName = _data["middleName"];
            this.phone = _data["phone"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.fingerprintDate = _data["fingerprintDate"] ? DateTime.fromISO(_data["fingerprintDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteSuitabilityUploadInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteSuitabilityUploadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["middleName"] = this.middleName;
        data["phone"] = this.phone;
        data["isUsCitizen"] = this.isUsCitizen;
        data["fingerprintDate"] = this.fingerprintDate ? this.fingerprintDate.toString() : <any>undefined;
        return data;
    }
}

export interface ICompleteSuitabilityUploadInput {
    token: string;
    middleName: string | undefined;
    phone: string | undefined;
    isUsCitizen: boolean;
    fingerprintDate: DateTime | undefined;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    memberType!: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }
}

export interface IConstructorInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
}

export class ContactHistoryBucketDto implements IContactHistoryBucketDto {
    label!: string | undefined;
    count!: number;
    startUtc!: DateTime;
    endUtc!: DateTime;

    constructor(data?: IContactHistoryBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.count = _data["count"];
            this.startUtc = _data["startUtc"] ? DateTime.fromISO(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? DateTime.fromISO(_data["endUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactHistoryBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactHistoryBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["count"] = this.count;
        data["startUtc"] = this.startUtc ? this.startUtc.toString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toString() : <any>undefined;
        return data;
    }
}

export interface IContactHistoryBucketDto {
    label: string | undefined;
    count: number;
    startUtc: DateTime;
    endUtc: DateTime;
}

export class ContactHistoryDto implements IContactHistoryDto {
    id!: number;
    ticketHolderId!: number;
    activityType!: ContactType;
    enumDisplayActivityType!: string | undefined;
    direction!: ActivityDirection;
    contactInfo!: string | undefined;
    subject!: string | undefined;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    enumDisplayActivityStatus!: string | undefined;
    serviceType!: ActivityServiceType;
    enumDisplayServiceType!: string | undefined;
    startTime!: DateTime;
    logId!: number | undefined;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    hasAttachments!: boolean;
    piiReviewRequestId!: number | undefined;
    piiNumber!: string | undefined;
    piiSendStatus!: PiiSendStatus;
    ticketHolderFullName!: string | undefined;
    formattedTicketHolderId!: string | undefined;

    constructor(data?: IContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.activityType = _data["activityType"];
            this.enumDisplayActivityType = _data["enumDisplayActivityType"];
            this.direction = _data["direction"];
            this.contactInfo = _data["contactInfo"];
            this.subject = _data["subject"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.enumDisplayActivityStatus = _data["enumDisplayActivityStatus"];
            this.serviceType = _data["serviceType"];
            this.enumDisplayServiceType = _data["enumDisplayServiceType"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.logId = _data["logId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.hasAttachments = _data["hasAttachments"];
            this.piiReviewRequestId = _data["piiReviewRequestId"];
            this.piiNumber = _data["piiNumber"];
            this.piiSendStatus = _data["piiSendStatus"];
            this.ticketHolderFullName = _data["ticketHolderFullName"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
        }
    }

    static fromJS(data: any): ContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["activityType"] = this.activityType;
        data["enumDisplayActivityType"] = this.enumDisplayActivityType;
        data["direction"] = this.direction;
        data["contactInfo"] = this.contactInfo;
        data["subject"] = this.subject;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["enumDisplayActivityStatus"] = this.enumDisplayActivityStatus;
        data["serviceType"] = this.serviceType;
        data["enumDisplayServiceType"] = this.enumDisplayServiceType;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["logId"] = this.logId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["hasAttachments"] = this.hasAttachments;
        data["piiReviewRequestId"] = this.piiReviewRequestId;
        data["piiNumber"] = this.piiNumber;
        data["piiSendStatus"] = this.piiSendStatus;
        data["ticketHolderFullName"] = this.ticketHolderFullName;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        return data;
    }
}

export interface IContactHistoryDto {
    id: number;
    ticketHolderId: number;
    activityType: ContactType;
    enumDisplayActivityType: string | undefined;
    direction: ActivityDirection;
    contactInfo: string | undefined;
    subject: string | undefined;
    activityContent: string | undefined;
    status: ActivityStatus;
    enumDisplayActivityStatus: string | undefined;
    serviceType: ActivityServiceType;
    enumDisplayServiceType: string | undefined;
    startTime: DateTime;
    logId: number | undefined;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    hasAttachments: boolean;
    piiReviewRequestId: number | undefined;
    piiNumber: string | undefined;
    piiSendStatus: PiiSendStatus;
    ticketHolderFullName: string | undefined;
    formattedTicketHolderId: string | undefined;
}

export class ContactHistoryInitialDto implements IContactHistoryInitialDto {
    months!: MonthPagedResultDtoOfTHContactHistoryDto[] | undefined;

    constructor(data?: IContactHistoryInitialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(MonthPagedResultDtoOfTHContactHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactHistoryInitialDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactHistoryInitialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContactHistoryInitialDto {
    months: MonthPagedResultDtoOfTHContactHistoryDto[] | undefined;
}

export class ContactInfoDto implements IContactInfoDto {
    id!: number | undefined;
    isPrimary!: boolean;
    contactRole!: ContactRole;
    contactRoleOther!: string | undefined;
    address!: string | undefined;
    homePhone!: string | undefined;
    cellPhone!: string | undefined;
    workPhone!: string | undefined;
    ttyVideophoneNumber!: string | undefined;
    email!: string | undefined;
    bestTimeToReach!: string | undefined;
    preferredContactMethod!: PreferredContactMethod;
    preferredContactMethodOther!: string | undefined;
    accommodationNeeds!: string | undefined;

    constructor(data?: IContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isPrimary = _data["isPrimary"];
            this.contactRole = _data["contactRole"];
            this.contactRoleOther = _data["contactRoleOther"];
            this.address = _data["address"];
            this.homePhone = _data["homePhone"];
            this.cellPhone = _data["cellPhone"];
            this.workPhone = _data["workPhone"];
            this.ttyVideophoneNumber = _data["ttyVideophoneNumber"];
            this.email = _data["email"];
            this.bestTimeToReach = _data["bestTimeToReach"];
            this.preferredContactMethod = _data["preferredContactMethod"];
            this.preferredContactMethodOther = _data["preferredContactMethodOther"];
            this.accommodationNeeds = _data["accommodationNeeds"];
        }
    }

    static fromJS(data: any): ContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isPrimary"] = this.isPrimary;
        data["contactRole"] = this.contactRole;
        data["contactRoleOther"] = this.contactRoleOther;
        data["address"] = this.address;
        data["homePhone"] = this.homePhone;
        data["cellPhone"] = this.cellPhone;
        data["workPhone"] = this.workPhone;
        data["ttyVideophoneNumber"] = this.ttyVideophoneNumber;
        data["email"] = this.email;
        data["bestTimeToReach"] = this.bestTimeToReach;
        data["preferredContactMethod"] = this.preferredContactMethod;
        data["preferredContactMethodOther"] = this.preferredContactMethodOther;
        data["accommodationNeeds"] = this.accommodationNeeds;
        return data;
    }
}

export interface IContactInfoDto {
    id: number | undefined;
    isPrimary: boolean;
    contactRole: ContactRole;
    contactRoleOther: string | undefined;
    address: string | undefined;
    homePhone: string | undefined;
    cellPhone: string | undefined;
    workPhone: string | undefined;
    ttyVideophoneNumber: string | undefined;
    email: string | undefined;
    bestTimeToReach: string | undefined;
    preferredContactMethod: PreferredContactMethod;
    preferredContactMethodOther: string | undefined;
    accommodationNeeds: string | undefined;
}

export enum ContactResult {
    NoAnswer = 0,
    LeftMessage = 1,
    LeftVoiceMessage = 2,
    VoicemailNotSetup = 3,
    RequestCallBack = 4,
    InvalidNumber = 5,
    WrongPerson = 6,
    RequireDifferentLanguage = 7,
    RequireOtherLanguage = 8,
    DoesNotQualify = 9,
    NotInterested = 10,
    CallDroppedOrHangup = 11,
    ContactInfoInvalid = 12,
}

export enum ContactRole {
    Beneficiary = 1,
    RepresentativePayee = 2,
    Guardian = 3,
    Other = 4,
}

export enum ContactType {
    Phone = 0,
    Email = 1,
    SMS = 2,
    WebChat = 3,
    MobileChat = 4,
    Fax = 5,
    Mail = 6,
    Others = 7,
}

export class ContactUsListDto implements IContactUsListDto {
    id!: number;
    fullName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    subject!: string | undefined;
    message!: string | undefined;
    isRead!: boolean;
    creationTime!: DateTime;

    constructor(data?: IContactUsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.isRead = _data["isRead"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactUsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["isRead"] = this.isRead;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IContactUsListDto {
    id: number;
    fullName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    isRead: boolean;
    creationTime: DateTime;
}

export class ContentDisposition implements IContentDisposition {
    dispositionType!: string | undefined;
    readonly parameters!: any[] | undefined;
    fileName!: string | undefined;
    creationDate!: DateTime;
    modificationDate!: DateTime;
    inline!: boolean;
    readDate!: DateTime;
    size!: number;

    constructor(data?: IContentDisposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispositionType = _data["dispositionType"];
            if (Array.isArray(_data["parameters"])) {
                (<any>this).parameters = [] as any;
                for (let item of _data["parameters"])
                    (<any>this).parameters!.push(item);
            }
            this.fileName = _data["fileName"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.modificationDate = _data["modificationDate"] ? DateTime.fromISO(_data["modificationDate"].toString()) : <any>undefined;
            this.inline = _data["inline"];
            this.readDate = _data["readDate"] ? DateTime.fromISO(_data["readDate"].toString()) : <any>undefined;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ContentDisposition {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDisposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispositionType"] = this.dispositionType;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        data["fileName"] = this.fileName;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toString() : <any>undefined;
        data["inline"] = this.inline;
        data["readDate"] = this.readDate ? this.readDate.toString() : <any>undefined;
        data["size"] = this.size;
        return data;
    }
}

export interface IContentDisposition {
    dispositionType: string | undefined;
    parameters: any[] | undefined;
    fileName: string | undefined;
    creationDate: DateTime;
    modificationDate: DateTime;
    inline: boolean;
    readDate: DateTime;
    size: number;
}

export class ContentType implements IContentType {
    boundary!: string | undefined;
    charSet!: string | undefined;
    mediaType!: string | undefined;
    name!: string | undefined;
    readonly parameters!: any[] | undefined;

    constructor(data?: IContentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boundary = _data["boundary"];
            this.charSet = _data["charSet"];
            this.mediaType = _data["mediaType"];
            this.name = _data["name"];
            if (Array.isArray(_data["parameters"])) {
                (<any>this).parameters = [] as any;
                for (let item of _data["parameters"])
                    (<any>this).parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): ContentType {
        data = typeof data === 'object' ? data : {};
        let result = new ContentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boundary"] = this.boundary;
        data["charSet"] = this.charSet;
        data["mediaType"] = this.mediaType;
        data["name"] = this.name;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface IContentType {
    boundary: string | undefined;
    charSet: string | undefined;
    mediaType: string | undefined;
    name: string | undefined;
    parameters: any[] | undefined;
}

export class ConversationInfo implements IConversationInfo {
    id!: string | undefined;
    uri!: string | undefined;

    constructor(data?: IConversationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): ConversationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IConversationInfo {
    id: string | undefined;
    uri: string | undefined;
}

export class CreateBenefitsCounselingCaseDto implements ICreateBenefitsCounselingCaseDto {
    ticketHolderId!: number;
    stage!: BenefitsCounselingStage;
    status!: BenefitsCounselingCaseStatus;
    assignedCpwicUserId!: number | undefined;
    openedAt!: DateTime | undefined;
    closedAt!: DateTime | undefined;
    closeReason!: string | undefined;
    bpqyDocumentId!: number | undefined;
    benefitsFollowUpRecordIds!: number[] | undefined;

    constructor(data?: ICreateBenefitsCounselingCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.stage = _data["stage"];
            this.status = _data["status"];
            this.assignedCpwicUserId = _data["assignedCpwicUserId"];
            this.openedAt = _data["openedAt"] ? DateTime.fromISO(_data["openedAt"].toString()) : <any>undefined;
            this.closedAt = _data["closedAt"] ? DateTime.fromISO(_data["closedAt"].toString()) : <any>undefined;
            this.closeReason = _data["closeReason"];
            this.bpqyDocumentId = _data["bpqyDocumentId"];
            if (Array.isArray(_data["benefitsFollowUpRecordIds"])) {
                this.benefitsFollowUpRecordIds = [] as any;
                for (let item of _data["benefitsFollowUpRecordIds"])
                    this.benefitsFollowUpRecordIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateBenefitsCounselingCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBenefitsCounselingCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["stage"] = this.stage;
        data["status"] = this.status;
        data["assignedCpwicUserId"] = this.assignedCpwicUserId;
        data["openedAt"] = this.openedAt ? this.openedAt.toString() : <any>undefined;
        data["closedAt"] = this.closedAt ? this.closedAt.toString() : <any>undefined;
        data["closeReason"] = this.closeReason;
        data["bpqyDocumentId"] = this.bpqyDocumentId;
        if (Array.isArray(this.benefitsFollowUpRecordIds)) {
            data["benefitsFollowUpRecordIds"] = [];
            for (let item of this.benefitsFollowUpRecordIds)
                data["benefitsFollowUpRecordIds"].push(item);
        }
        return data;
    }
}

export interface ICreateBenefitsCounselingCaseDto {
    ticketHolderId: number;
    stage: BenefitsCounselingStage;
    status: BenefitsCounselingCaseStatus;
    assignedCpwicUserId: number | undefined;
    openedAt: DateTime | undefined;
    closedAt: DateTime | undefined;
    closeReason: string | undefined;
    bpqyDocumentId: number | undefined;
    benefitsFollowUpRecordIds: number[] | undefined;
}

export class CreateBenefitsCounselingSupportRecordDto implements ICreateBenefitsCounselingSupportRecordDto {
    benefitsCounselingCaseId!: number;
    calendarEventId!: number | undefined;
    supportDate!: DateTime;
    supportType!: BenefitsSupportType;
    workIncentiveDiscussed!: string | undefined;
    reportingSupportProvided!: string | undefined;
    issueSummary!: string | undefined;
    outcome!: string | undefined;
    nextActionDueDate!: DateTime | undefined;
    caseNotes!: string | undefined;

    constructor(data?: ICreateBenefitsCounselingSupportRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.calendarEventId = _data["calendarEventId"];
            this.supportDate = _data["supportDate"] ? DateTime.fromISO(_data["supportDate"].toString()) : <any>undefined;
            this.supportType = _data["supportType"];
            this.workIncentiveDiscussed = _data["workIncentiveDiscussed"];
            this.reportingSupportProvided = _data["reportingSupportProvided"];
            this.issueSummary = _data["issueSummary"];
            this.outcome = _data["outcome"];
            this.nextActionDueDate = _data["nextActionDueDate"] ? DateTime.fromISO(_data["nextActionDueDate"].toString()) : <any>undefined;
            this.caseNotes = _data["caseNotes"];
        }
    }

    static fromJS(data: any): CreateBenefitsCounselingSupportRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBenefitsCounselingSupportRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["calendarEventId"] = this.calendarEventId;
        data["supportDate"] = this.supportDate ? this.supportDate.toString() : <any>undefined;
        data["supportType"] = this.supportType;
        data["workIncentiveDiscussed"] = this.workIncentiveDiscussed;
        data["reportingSupportProvided"] = this.reportingSupportProvided;
        data["issueSummary"] = this.issueSummary;
        data["outcome"] = this.outcome;
        data["nextActionDueDate"] = this.nextActionDueDate ? this.nextActionDueDate.toString() : <any>undefined;
        data["caseNotes"] = this.caseNotes;
        return data;
    }
}

export interface ICreateBenefitsCounselingSupportRecordDto {
    benefitsCounselingCaseId: number;
    calendarEventId: number | undefined;
    supportDate: DateTime;
    supportType: BenefitsSupportType;
    workIncentiveDiscussed: string | undefined;
    reportingSupportProvided: string | undefined;
    issueSummary: string | undefined;
    outcome: string | undefined;
    nextActionDueDate: DateTime | undefined;
    caseNotes: string | undefined;
}

export class CreateBenefitsVerificationRecordDto implements ICreateBenefitsVerificationRecordDto {
    benefitsCounselingCaseId!: number;
    source!: BenefitsVerificationSource;
    benefitName!: string;
    requestedAt!: DateTime | undefined;

    constructor(data?: ICreateBenefitsVerificationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.source = _data["source"];
            this.benefitName = _data["benefitName"];
            this.requestedAt = _data["requestedAt"] ? DateTime.fromISO(_data["requestedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateBenefitsVerificationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBenefitsVerificationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["source"] = this.source;
        data["benefitName"] = this.benefitName;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateBenefitsVerificationRecordDto {
    benefitsCounselingCaseId: number;
    source: BenefitsVerificationSource;
    benefitName: string;
    requestedAt: DateTime | undefined;
}

export class CreateBpqyRequestDto implements ICreateBpqyRequestDto {
    ticketHolderId!: number;

    constructor(data?: ICreateBpqyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
        }
    }

    static fromJS(data: any): CreateBpqyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBpqyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        return data;
    }
}

export interface ICreateBpqyRequestDto {
    ticketHolderId: number;
}

export class CreateCalendarEventDto implements ICreateCalendarEventDto {
    eventType!: CalendarEventType;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime | undefined;
    timeZone!: string | undefined;
    location!: string | undefined;
    attendees!: string[] | undefined;
    category!: string | undefined;
    colorHex!: string | undefined;

    constructor(data?: ICreateCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.location = _data["location"];
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(item);
            }
            this.category = _data["category"];
            this.colorHex = _data["colorHex"];
        }
    }

    static fromJS(data: any): CreateCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["location"] = this.location;
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item);
        }
        data["category"] = this.category;
        data["colorHex"] = this.colorHex;
        return data;
    }
}

export interface ICreateCalendarEventDto {
    eventType: CalendarEventType;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    title: string | undefined;
    description: string | undefined;
    startTime: DateTime;
    endTime: DateTime | undefined;
    timeZone: string | undefined;
    location: string | undefined;
    attendees: string[] | undefined;
    category: string | undefined;
    colorHex: string | undefined;
}

export class CreateDocumentDto implements ICreateDocumentDto {
    documentName!: string | undefined;
    tenantDocumentId!: number;
    filePath!: string | undefined;
    fileType!: string | undefined;
    versionNumber!: string | undefined;
    isLatest!: boolean;
    isTemplate!: boolean;
    uploadDate!: DateTime;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    uploadedBy!: string | undefined;
    templateStatus!: TemplateStatus;
    documentType!: TicketHolderDocumentType;
    languageId!: number | undefined;

    constructor(data?: ICreateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data["documentName"];
            this.tenantDocumentId = _data["tenantDocumentId"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.versionNumber = _data["versionNumber"];
            this.isLatest = _data["isLatest"];
            this.isTemplate = _data["isTemplate"];
            this.uploadDate = _data["uploadDate"] ? DateTime.fromISO(_data["uploadDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.uploadedBy = _data["uploadedBy"];
            this.templateStatus = _data["templateStatus"];
            this.documentType = _data["documentType"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): CreateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentName"] = this.documentName;
        data["tenantDocumentId"] = this.tenantDocumentId;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["versionNumber"] = this.versionNumber;
        data["isLatest"] = this.isLatest;
        data["isTemplate"] = this.isTemplate;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["uploadedBy"] = this.uploadedBy;
        data["templateStatus"] = this.templateStatus;
        data["documentType"] = this.documentType;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface ICreateDocumentDto {
    documentName: string | undefined;
    tenantDocumentId: number;
    filePath: string | undefined;
    fileType: string | undefined;
    versionNumber: string | undefined;
    isLatest: boolean;
    isTemplate: boolean;
    uploadDate: DateTime;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    uploadedBy: string | undefined;
    templateStatus: TemplateStatus;
    documentType: TicketHolderDocumentType;
    languageId: number | undefined;
}

export class CreateDocumentFormTemplateDto implements ICreateDocumentFormTemplateDto {
    uploadId!: string;
    formId!: string | undefined;
    formName!: string | undefined;
    description!: string | undefined;
    fields!: SaveDocumentTemplateFieldDto[] | undefined;

    constructor(data?: ICreateDocumentFormTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SaveDocumentTemplateFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDocumentFormTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentFormTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateDocumentFormTemplateDto {
    uploadId: string;
    formId: string | undefined;
    formName: string | undefined;
    description: string | undefined;
    fields: SaveDocumentTemplateFieldDto[] | undefined;
}

export class CreateDocumentTemplateDetailsDto implements ICreateDocumentTemplateDetailsDto {
    id!: number;
    templateId!: number;
    languageId!: number | undefined;
    subject!: string | undefined;
    bodyContent!: string;
    isBodyHtml!: boolean;
    attachments!: string[] | undefined;

    constructor(data?: ICreateDocumentTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateId = _data["templateId"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDocumentTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateId"] = this.templateId;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        return data;
    }
}

export interface ICreateDocumentTemplateDetailsDto {
    id: number;
    templateId: number;
    languageId: number | undefined;
    subject: string | undefined;
    bodyContent: string;
    isBodyHtml: boolean;
    attachments: string[] | undefined;
}

export class CreateDocumentTemplateDto implements ICreateDocumentTemplateDto {
    id!: number;
    templateName!: string;
    clientType!: ClientType;
    type!: TicketHolderDocumentType;
    status!: TemplateStatus;
    subject!: string | undefined;
    documentTemplateDetails!: CreateDocumentTemplateDetailsDto;

    constructor(data?: ICreateDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.clientType = _data["clientType"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.subject = _data["subject"];
            this.documentTemplateDetails = _data["documentTemplateDetails"] ? CreateDocumentTemplateDetailsDto.fromJS(_data["documentTemplateDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateDocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["clientType"] = this.clientType;
        data["type"] = this.type;
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["documentTemplateDetails"] = this.documentTemplateDetails ? this.documentTemplateDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateDocumentTemplateDto {
    id: number;
    templateName: string;
    clientType: ClientType;
    type: TicketHolderDocumentType;
    status: TemplateStatus;
    subject: string | undefined;
    documentTemplateDetails: CreateDocumentTemplateDetailsDto;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class CreateFollowupDto implements ICreateFollowupDto {
    relatedToLeadId!: number | undefined;
    relatedTicketHolderId!: number | undefined;
    title!: string | undefined;
    followupNote!: string | undefined;
    followupDateTime!: DateTime;
    followupType!: FollowupType;

    constructor(data?: ICreateFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedToLeadId = _data["relatedToLeadId"];
            this.relatedTicketHolderId = _data["relatedTicketHolderId"];
            this.title = _data["title"];
            this.followupNote = _data["followupNote"];
            this.followupDateTime = _data["followupDateTime"] ? DateTime.fromISO(_data["followupDateTime"].toString()) : <any>undefined;
            this.followupType = _data["followupType"];
        }
    }

    static fromJS(data: any): CreateFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedToLeadId"] = this.relatedToLeadId;
        data["relatedTicketHolderId"] = this.relatedTicketHolderId;
        data["title"] = this.title;
        data["followupNote"] = this.followupNote;
        data["followupDateTime"] = this.followupDateTime ? this.followupDateTime.toString() : <any>undefined;
        data["followupType"] = this.followupType;
        return data;
    }
}

export interface ICreateFollowupDto {
    relatedToLeadId: number | undefined;
    relatedTicketHolderId: number | undefined;
    title: string | undefined;
    followupNote: string | undefined;
    followupDateTime: DateTime;
    followupType: FollowupType;
}

export class CreateFriendshipForCurrentTenantInput implements ICreateFriendshipForCurrentTenantInput {
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipForCurrentTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipForCurrentTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipForCurrentTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipForCurrentTenantInput {
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipWithDifferentTenantInput implements ICreateFriendshipWithDifferentTenantInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipWithDifferentTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipWithDifferentTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipWithDifferentTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipWithDifferentTenantInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateJobLeadDto implements ICreateJobLeadDto {
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    deliveryMethod!: TikcetHolderJobLeadDeliveryMethod;
    importantNotes!: string | undefined;

    constructor(data?: ICreateJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.importantNotes = _data["importantNotes"];
        }
    }

    static fromJS(data: any): CreateJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["deliveryMethod"] = this.deliveryMethod;
        data["importantNotes"] = this.importantNotes;
        return data;
    }
}

export interface ICreateJobLeadDto {
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    deliveryMethod: TikcetHolderJobLeadDeliveryMethod;
    importantNotes: string | undefined;
}

export class CreateJobLeadFromJsonDto implements ICreateJobLeadFromJsonDto {
    jsonInput!: string | undefined;
    jobSearchRequestId!: number;
    ticketHolderId!: number;

    constructor(data?: ICreateJobLeadFromJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonInput = _data["jsonInput"];
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
        }
    }

    static fromJS(data: any): CreateJobLeadFromJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobLeadFromJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jsonInput"] = this.jsonInput;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        return data;
    }
}

export interface ICreateJobLeadFromJsonDto {
    jsonInput: string | undefined;
    jobSearchRequestId: number;
    ticketHolderId: number;
}

export class CreateJobLeadResponseDto implements ICreateJobLeadResponseDto {
    errors!: LeadError[] | undefined;
    jobLeadId!: number | undefined;

    constructor(data?: ICreateJobLeadResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(LeadError.fromJS(item));
            }
            this.jobLeadId = _data["jobLeadId"];
        }
    }

    static fromJS(data: any): CreateJobLeadResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobLeadResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["jobLeadId"] = this.jobLeadId;
        return data;
    }
}

export interface ICreateJobLeadResponseDto {
    errors: LeadError[] | undefined;
    jobLeadId: number | undefined;
}

export class CreateJobSearchRequestDto implements ICreateJobSearchRequestDto {
    ticketHolderId!: number;
    jobSearchKeywords!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobSearchType!: JobSearchType;
    isSalaryRangeHourly!: boolean;
    salaryRangeStart!: number | undefined;
    desiredJobCount!: number | undefined;
    salaryRangeEnd!: number | undefined;
    notes!: string | undefined;
    preferredDayOfWeek!: WeekDays;
    runNow!: boolean;
    skillsQualifications!: string | undefined;
    instructions!: string | undefined;
    maxTravelDistance!: number | undefined;
    maxTravelTime!: number | undefined;

    constructor(data?: ICreateJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobSearchKeywords = _data["jobSearchKeywords"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobSearchType = _data["jobSearchType"];
            this.isSalaryRangeHourly = _data["isSalaryRangeHourly"];
            this.salaryRangeStart = _data["salaryRangeStart"];
            this.desiredJobCount = _data["desiredJobCount"];
            this.salaryRangeEnd = _data["salaryRangeEnd"];
            this.notes = _data["notes"];
            this.preferredDayOfWeek = _data["preferredDayOfWeek"];
            this.runNow = _data["runNow"];
            this.skillsQualifications = _data["skillsQualifications"];
            this.instructions = _data["instructions"];
            this.maxTravelDistance = _data["maxTravelDistance"];
            this.maxTravelTime = _data["maxTravelTime"];
        }
    }

    static fromJS(data: any): CreateJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobSearchKeywords"] = this.jobSearchKeywords;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobSearchType"] = this.jobSearchType;
        data["isSalaryRangeHourly"] = this.isSalaryRangeHourly;
        data["salaryRangeStart"] = this.salaryRangeStart;
        data["desiredJobCount"] = this.desiredJobCount;
        data["salaryRangeEnd"] = this.salaryRangeEnd;
        data["notes"] = this.notes;
        data["preferredDayOfWeek"] = this.preferredDayOfWeek;
        data["runNow"] = this.runNow;
        data["skillsQualifications"] = this.skillsQualifications;
        data["instructions"] = this.instructions;
        data["maxTravelDistance"] = this.maxTravelDistance;
        data["maxTravelTime"] = this.maxTravelTime;
        return data;
    }
}

export interface ICreateJobSearchRequestDto {
    ticketHolderId: number;
    jobSearchKeywords: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobSearchType: JobSearchType;
    isSalaryRangeHourly: boolean;
    salaryRangeStart: number | undefined;
    desiredJobCount: number | undefined;
    salaryRangeEnd: number | undefined;
    notes: string | undefined;
    preferredDayOfWeek: WeekDays;
    runNow: boolean;
    skillsQualifications: string | undefined;
    instructions: string | undefined;
    maxTravelDistance: number | undefined;
    maxTravelTime: number | undefined;
}

export class CreateLeadsFromRegistrationsResultDto implements ICreateLeadsFromRegistrationsResultDto {
    created!: number;
    linkedToExisting!: number;
    skipped!: number;

    constructor(data?: ICreateLeadsFromRegistrationsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"];
            this.linkedToExisting = _data["linkedToExisting"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): CreateLeadsFromRegistrationsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeadsFromRegistrationsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created;
        data["linkedToExisting"] = this.linkedToExisting;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface ICreateLeadsFromRegistrationsResultDto {
    created: number;
    linkedToExisting: number;
    skipped: number;
}

export class CreateLoginDto implements ICreateLoginDto {
    ticketHolderId!: number;
    accountName!: string;
    loginUrl!: string | undefined;
    userId!: string;
    encryptedAccessKey!: string;
    isTwoFactorEnabled!: boolean;
    pinDestination!: string | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.accountName = _data["accountName"];
            this.loginUrl = _data["loginUrl"];
            this.userId = _data["userId"];
            this.encryptedAccessKey = _data["encryptedAccessKey"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.pinDestination = _data["pinDestination"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["accountName"] = this.accountName;
        data["loginUrl"] = this.loginUrl;
        data["userId"] = this.userId;
        data["encryptedAccessKey"] = this.encryptedAccessKey;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["pinDestination"] = this.pinDestination;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateLoginDto {
    ticketHolderId: number;
    accountName: string;
    loginUrl: string | undefined;
    userId: string;
    encryptedAccessKey: string;
    isTwoFactorEnabled: boolean;
    pinDestination: string | undefined;
    notes: string | undefined;
}

export class CreateManualJobSearchDto implements ICreateManualJobSearchDto {
    jobSearchRequestId!: number;

    constructor(data?: ICreateManualJobSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
        }
    }

    static fromJS(data: any): CreateManualJobSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualJobSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        return data;
    }
}

export interface ICreateManualJobSearchDto {
    jobSearchRequestId: number;
}

export class CreateManualJobSearchLeadDto implements ICreateManualJobSearchLeadDto {
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    importantNotes!: string | undefined;
    locationDistance!: number | undefined;
    copiedFromJobLeadId!: number | undefined;
    jobSearchRequestRoundId!: number;

    constructor(data?: ICreateManualJobSearchLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.importantNotes = _data["importantNotes"];
            this.locationDistance = _data["locationDistance"];
            this.copiedFromJobLeadId = _data["copiedFromJobLeadId"];
            this.jobSearchRequestRoundId = _data["jobSearchRequestRoundId"];
        }
    }

    static fromJS(data: any): CreateManualJobSearchLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualJobSearchLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["importantNotes"] = this.importantNotes;
        data["locationDistance"] = this.locationDistance;
        data["copiedFromJobLeadId"] = this.copiedFromJobLeadId;
        data["jobSearchRequestRoundId"] = this.jobSearchRequestRoundId;
        return data;
    }
}

export interface ICreateManualJobSearchLeadDto {
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    importantNotes: string | undefined;
    locationDistance: number | undefined;
    copiedFromJobLeadId: number | undefined;
    jobSearchRequestRoundId: number;
}

export class CreateManualJobSearchLeadFromJsonDto implements ICreateManualJobSearchLeadFromJsonDto {
    jsonInput!: string | undefined;
    jobSearchRequestRoundId!: number;

    constructor(data?: ICreateManualJobSearchLeadFromJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonInput = _data["jsonInput"];
            this.jobSearchRequestRoundId = _data["jobSearchRequestRoundId"];
        }
    }

    static fromJS(data: any): CreateManualJobSearchLeadFromJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualJobSearchLeadFromJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jsonInput"] = this.jsonInput;
        data["jobSearchRequestRoundId"] = this.jobSearchRequestRoundId;
        return data;
    }
}

export interface ICreateManualJobSearchLeadFromJsonDto {
    jsonInput: string | undefined;
    jobSearchRequestRoundId: number;
}

export class CreateMassNotificationInput implements ICreateMassNotificationInput {
    message!: string | undefined;
    severity!: NotificationSeverity;
    userIds!: number[] | undefined;
    organizationUnitIds!: number[] | undefined;
    targetNotifiers!: string[] | undefined;

    constructor(data?: ICreateMassNotificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.severity = _data["severity"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["organizationUnitIds"])) {
                this.organizationUnitIds = [] as any;
                for (let item of _data["organizationUnitIds"])
                    this.organizationUnitIds!.push(item);
            }
            if (Array.isArray(_data["targetNotifiers"])) {
                this.targetNotifiers = [] as any;
                for (let item of _data["targetNotifiers"])
                    this.targetNotifiers!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMassNotificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMassNotificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["severity"] = this.severity;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.organizationUnitIds)) {
            data["organizationUnitIds"] = [];
            for (let item of this.organizationUnitIds)
                data["organizationUnitIds"].push(item);
        }
        if (Array.isArray(this.targetNotifiers)) {
            data["targetNotifiers"] = [];
            for (let item of this.targetNotifiers)
                data["targetNotifiers"].push(item);
        }
        return data;
    }
}

export interface ICreateMassNotificationInput {
    message: string | undefined;
    severity: NotificationSeverity;
    userIds: number[] | undefined;
    organizationUnitIds: number[] | undefined;
    targetNotifiers: string[] | undefined;
}

export class CreateOrUpdateBSAPlanningRecordDto implements ICreateOrUpdateBSAPlanningRecordDto {
    id!: number | undefined;
    benefitsCounselingCaseId!: number;
    analysisStartedAt!: DateTime | undefined;
    analysisCompletedAt!: DateTime | undefined;
    isBSAReportNeeded!: boolean | undefined;
    bsaReportNotNeededReason!: string | undefined;
    bsaPlanningAnalysisDocumentId!: number | undefined;
    items!: BSAPlanningItemDto[] | undefined;

    constructor(data?: ICreateOrUpdateBSAPlanningRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.analysisStartedAt = _data["analysisStartedAt"] ? DateTime.fromISO(_data["analysisStartedAt"].toString()) : <any>undefined;
            this.analysisCompletedAt = _data["analysisCompletedAt"] ? DateTime.fromISO(_data["analysisCompletedAt"].toString()) : <any>undefined;
            this.isBSAReportNeeded = _data["isBSAReportNeeded"];
            this.bsaReportNotNeededReason = _data["bsaReportNotNeededReason"];
            this.bsaPlanningAnalysisDocumentId = _data["bsaPlanningAnalysisDocumentId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BSAPlanningItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateBSAPlanningRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBSAPlanningRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["analysisStartedAt"] = this.analysisStartedAt ? this.analysisStartedAt.toString() : <any>undefined;
        data["analysisCompletedAt"] = this.analysisCompletedAt ? this.analysisCompletedAt.toString() : <any>undefined;
        data["isBSAReportNeeded"] = this.isBSAReportNeeded;
        data["bsaReportNotNeededReason"] = this.bsaReportNotNeededReason;
        data["bsaPlanningAnalysisDocumentId"] = this.bsaPlanningAnalysisDocumentId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateBSAPlanningRecordDto {
    id: number | undefined;
    benefitsCounselingCaseId: number;
    analysisStartedAt: DateTime | undefined;
    analysisCompletedAt: DateTime | undefined;
    isBSAReportNeeded: boolean | undefined;
    bsaReportNotNeededReason: string | undefined;
    bsaPlanningAnalysisDocumentId: number | undefined;
    items: BSAPlanningItemDto[] | undefined;
}

export class CreateOrUpdateBSARecordDto implements ICreateOrUpdateBSARecordDto {
    id!: number | undefined;
    benefitsCounselingCaseId!: number;
    deliveredAt!: DateTime | undefined;
    deliveryMethod!: PreferredContactMethod;
    deliveryMethodOther!: string | undefined;
    bsaDeliveryReviewDocumentId!: number | undefined;
    reviewDate!: DateTime;
    beneficiaryUnderstoodKeyPoints!: boolean | undefined;
    questionsOrConcerns!: string | undefined;
    agreedActionItems!: string | undefined;

    constructor(data?: ICreateOrUpdateBSARecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.deliveredAt = _data["deliveredAt"] ? DateTime.fromISO(_data["deliveredAt"].toString()) : <any>undefined;
            this.deliveryMethod = _data["deliveryMethod"];
            this.deliveryMethodOther = _data["deliveryMethodOther"];
            this.bsaDeliveryReviewDocumentId = _data["bsaDeliveryReviewDocumentId"];
            this.reviewDate = _data["reviewDate"] ? DateTime.fromISO(_data["reviewDate"].toString()) : <any>undefined;
            this.beneficiaryUnderstoodKeyPoints = _data["beneficiaryUnderstoodKeyPoints"];
            this.questionsOrConcerns = _data["questionsOrConcerns"];
            this.agreedActionItems = _data["agreedActionItems"];
        }
    }

    static fromJS(data: any): CreateOrUpdateBSARecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBSARecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["deliveredAt"] = this.deliveredAt ? this.deliveredAt.toString() : <any>undefined;
        data["deliveryMethod"] = this.deliveryMethod;
        data["deliveryMethodOther"] = this.deliveryMethodOther;
        data["bsaDeliveryReviewDocumentId"] = this.bsaDeliveryReviewDocumentId;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toString() : <any>undefined;
        data["beneficiaryUnderstoodKeyPoints"] = this.beneficiaryUnderstoodKeyPoints;
        data["questionsOrConcerns"] = this.questionsOrConcerns;
        data["agreedActionItems"] = this.agreedActionItems;
        return data;
    }
}

export interface ICreateOrUpdateBSARecordDto {
    id: number | undefined;
    benefitsCounselingCaseId: number;
    deliveredAt: DateTime | undefined;
    deliveryMethod: PreferredContactMethod;
    deliveryMethodOther: string | undefined;
    bsaDeliveryReviewDocumentId: number | undefined;
    reviewDate: DateTime;
    beneficiaryUnderstoodKeyPoints: boolean | undefined;
    questionsOrConcerns: string | undefined;
    agreedActionItems: string | undefined;
}

export class CreateOrUpdateBSAReportDto implements ICreateOrUpdateBSAReportDto {
    id!: number | undefined;
    benefitsCounselingCaseId!: number;
    reportDate!: DateTime;
    introText!: string | undefined;
    items!: BSAReportItemDto[] | undefined;

    constructor(data?: ICreateOrUpdateBSAReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : <any>undefined;
            this.introText = _data["introText"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BSAReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateBSAReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBSAReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : <any>undefined;
        data["introText"] = this.introText;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateBSAReportDto {
    id: number | undefined;
    benefitsCounselingCaseId: number;
    reportDate: DateTime;
    introText: string | undefined;
    items: BSAReportItemDto[] | undefined;
}

export class CreateOrUpdateENSettingDto implements ICreateOrUpdateENSettingDto {
    id!: number | undefined;
    uploadFileOutputDto!: UploadFileOutputDto;
    name!: string | undefined;
    pid!: string | undefined;
    address!: string | undefined;
    telePhone!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    ssaFax!: string | undefined;
    hasSSALogin!: boolean;
    hasServiceProvider!: boolean;
    serviceProviderName!: string | undefined;
    eligibilityNotificationEmailList!: string[] | undefined;

    constructor(data?: ICreateOrUpdateENSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uploadFileOutputDto = _data["uploadFileOutputDto"] ? UploadFileOutputDto.fromJS(_data["uploadFileOutputDto"]) : <any>undefined;
            this.name = _data["name"];
            this.pid = _data["pid"];
            this.address = _data["address"];
            this.telePhone = _data["telePhone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.ssaFax = _data["ssaFax"];
            this.hasSSALogin = _data["hasSSALogin"];
            this.hasServiceProvider = _data["hasServiceProvider"];
            this.serviceProviderName = _data["serviceProviderName"];
            if (Array.isArray(_data["eligibilityNotificationEmailList"])) {
                this.eligibilityNotificationEmailList = [] as any;
                for (let item of _data["eligibilityNotificationEmailList"])
                    this.eligibilityNotificationEmailList!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateENSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateENSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uploadFileOutputDto"] = this.uploadFileOutputDto ? this.uploadFileOutputDto.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["pid"] = this.pid;
        data["address"] = this.address;
        data["telePhone"] = this.telePhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["ssaFax"] = this.ssaFax;
        data["hasSSALogin"] = this.hasSSALogin;
        data["hasServiceProvider"] = this.hasServiceProvider;
        data["serviceProviderName"] = this.serviceProviderName;
        if (Array.isArray(this.eligibilityNotificationEmailList)) {
            data["eligibilityNotificationEmailList"] = [];
            for (let item of this.eligibilityNotificationEmailList)
                data["eligibilityNotificationEmailList"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateENSettingDto {
    id: number | undefined;
    uploadFileOutputDto: UploadFileOutputDto;
    name: string | undefined;
    pid: string | undefined;
    address: string | undefined;
    telePhone: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    ssaFax: string | undefined;
    hasSSALogin: boolean;
    hasServiceProvider: boolean;
    serviceProviderName: string | undefined;
    eligibilityNotificationEmailList: string[] | undefined;
}

export class CreateOrUpdateIntakeRecordDto implements ICreateOrUpdateIntakeRecordDto {
    id!: number | undefined;
    benefitsCounselingCaseId!: number;
    intakeDate!: DateTime;
    cwicUserId!: number;
    referralSource!: ReferralSource;
    referralSourceOther!: string | undefined;
    medicareClaimNumber!: string | undefined;
    medicaidNumber!: string | undefined;
    age18RedeterminationDone!: boolean | undefined;
    disabledPriorAge26!: boolean | undefined;
    hasABLEAccount!: boolean | undefined;
    primaryDisability!: string | undefined;
    statutoryBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    isVeteran!: boolean | undefined;
    maritalStatus!: MaritalStatus;
    householdMeansTestedBenefitDetail!: string | undefined;
    ssiIncomeInKindDetail!: string | undefined;
    hasMySSAAccount!: MySSAAccountStatus;
    bsaDeliveryMethod!: PreferredContactMethod;
    bsaDeliveryMethodOther!: string | undefined;
    highestGradeCompleted!: HighestGradeCompleted;
    educationalGoals!: string | undefined;
    wantsEliminateBenefits!: boolean | undefined;
    wantsReduceBenefitDependence!: boolean | undefined;
    neededEmploymentServices!: string | undefined;
    consentToShareBSA!: boolean | undefined;
    consentToShareBSADate!: DateTime | undefined;
    consentToShareBSAWith!: string | undefined;
    irweOrBWEExpenses!: string | undefined;
    specialEmploymentSupports!: string | undefined;
    notes!: string | undefined;
    currentEmployment!: CurrentEmploymentDto;
    householdMembers!: HouseholdMemberDto[] | undefined;
    contactInfos!: ContactInfoDto[] | undefined;
    earningsGoals!: EarningsGoalDto[] | undefined;
    employmentServices!: EmploymentServiceDto[] | undefined;
    excludedResources!: ExcludedResourceDto[] | undefined;
    pastEmployments!: PastEmploymentDto[] | undefined;
    benefitsAtIntake!: BenefitAtIntakeDto[] | undefined;
    additionalBenefits!: AdditionalBenefitDto[] | undefined;

    constructor(data?: ICreateOrUpdateIntakeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.intakeDate = _data["intakeDate"] ? DateTime.fromISO(_data["intakeDate"].toString()) : <any>undefined;
            this.cwicUserId = _data["cwicUserId"];
            this.referralSource = _data["referralSource"];
            this.referralSourceOther = _data["referralSourceOther"];
            this.medicareClaimNumber = _data["medicareClaimNumber"];
            this.medicaidNumber = _data["medicaidNumber"];
            this.age18RedeterminationDone = _data["age18RedeterminationDone"];
            this.disabledPriorAge26 = _data["disabledPriorAge26"];
            this.hasABLEAccount = _data["hasABLEAccount"];
            this.primaryDisability = _data["primaryDisability"];
            this.statutoryBlind = _data["statutoryBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.isVeteran = _data["isVeteran"];
            this.maritalStatus = _data["maritalStatus"];
            this.householdMeansTestedBenefitDetail = _data["householdMeansTestedBenefitDetail"];
            this.ssiIncomeInKindDetail = _data["ssiIncomeInKindDetail"];
            this.hasMySSAAccount = _data["hasMySSAAccount"];
            this.bsaDeliveryMethod = _data["bsaDeliveryMethod"];
            this.bsaDeliveryMethodOther = _data["bsaDeliveryMethodOther"];
            this.highestGradeCompleted = _data["highestGradeCompleted"];
            this.educationalGoals = _data["educationalGoals"];
            this.wantsEliminateBenefits = _data["wantsEliminateBenefits"];
            this.wantsReduceBenefitDependence = _data["wantsReduceBenefitDependence"];
            this.neededEmploymentServices = _data["neededEmploymentServices"];
            this.consentToShareBSA = _data["consentToShareBSA"];
            this.consentToShareBSADate = _data["consentToShareBSADate"] ? DateTime.fromISO(_data["consentToShareBSADate"].toString()) : <any>undefined;
            this.consentToShareBSAWith = _data["consentToShareBSAWith"];
            this.irweOrBWEExpenses = _data["irweOrBWEExpenses"];
            this.specialEmploymentSupports = _data["specialEmploymentSupports"];
            this.notes = _data["notes"];
            this.currentEmployment = _data["currentEmployment"] ? CurrentEmploymentDto.fromJS(_data["currentEmployment"]) : <any>undefined;
            if (Array.isArray(_data["householdMembers"])) {
                this.householdMembers = [] as any;
                for (let item of _data["householdMembers"])
                    this.householdMembers!.push(HouseholdMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(ContactInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["earningsGoals"])) {
                this.earningsGoals = [] as any;
                for (let item of _data["earningsGoals"])
                    this.earningsGoals!.push(EarningsGoalDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentServices"])) {
                this.employmentServices = [] as any;
                for (let item of _data["employmentServices"])
                    this.employmentServices!.push(EmploymentServiceDto.fromJS(item));
            }
            if (Array.isArray(_data["excludedResources"])) {
                this.excludedResources = [] as any;
                for (let item of _data["excludedResources"])
                    this.excludedResources!.push(ExcludedResourceDto.fromJS(item));
            }
            if (Array.isArray(_data["pastEmployments"])) {
                this.pastEmployments = [] as any;
                for (let item of _data["pastEmployments"])
                    this.pastEmployments!.push(PastEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["benefitsAtIntake"])) {
                this.benefitsAtIntake = [] as any;
                for (let item of _data["benefitsAtIntake"])
                    this.benefitsAtIntake!.push(BenefitAtIntakeDto.fromJS(item));
            }
            if (Array.isArray(_data["additionalBenefits"])) {
                this.additionalBenefits = [] as any;
                for (let item of _data["additionalBenefits"])
                    this.additionalBenefits!.push(AdditionalBenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateIntakeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateIntakeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["intakeDate"] = this.intakeDate ? this.intakeDate.toString() : <any>undefined;
        data["cwicUserId"] = this.cwicUserId;
        data["referralSource"] = this.referralSource;
        data["referralSourceOther"] = this.referralSourceOther;
        data["medicareClaimNumber"] = this.medicareClaimNumber;
        data["medicaidNumber"] = this.medicaidNumber;
        data["age18RedeterminationDone"] = this.age18RedeterminationDone;
        data["disabledPriorAge26"] = this.disabledPriorAge26;
        data["hasABLEAccount"] = this.hasABLEAccount;
        data["primaryDisability"] = this.primaryDisability;
        data["statutoryBlind"] = this.statutoryBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toString() : <any>undefined;
        data["isVeteran"] = this.isVeteran;
        data["maritalStatus"] = this.maritalStatus;
        data["householdMeansTestedBenefitDetail"] = this.householdMeansTestedBenefitDetail;
        data["ssiIncomeInKindDetail"] = this.ssiIncomeInKindDetail;
        data["hasMySSAAccount"] = this.hasMySSAAccount;
        data["bsaDeliveryMethod"] = this.bsaDeliveryMethod;
        data["bsaDeliveryMethodOther"] = this.bsaDeliveryMethodOther;
        data["highestGradeCompleted"] = this.highestGradeCompleted;
        data["educationalGoals"] = this.educationalGoals;
        data["wantsEliminateBenefits"] = this.wantsEliminateBenefits;
        data["wantsReduceBenefitDependence"] = this.wantsReduceBenefitDependence;
        data["neededEmploymentServices"] = this.neededEmploymentServices;
        data["consentToShareBSA"] = this.consentToShareBSA;
        data["consentToShareBSADate"] = this.consentToShareBSADate ? this.consentToShareBSADate.toString() : <any>undefined;
        data["consentToShareBSAWith"] = this.consentToShareBSAWith;
        data["irweOrBWEExpenses"] = this.irweOrBWEExpenses;
        data["specialEmploymentSupports"] = this.specialEmploymentSupports;
        data["notes"] = this.notes;
        data["currentEmployment"] = this.currentEmployment ? this.currentEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.householdMembers)) {
            data["householdMembers"] = [];
            for (let item of this.householdMembers)
                data["householdMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.earningsGoals)) {
            data["earningsGoals"] = [];
            for (let item of this.earningsGoals)
                data["earningsGoals"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentServices)) {
            data["employmentServices"] = [];
            for (let item of this.employmentServices)
                data["employmentServices"].push(item.toJSON());
        }
        if (Array.isArray(this.excludedResources)) {
            data["excludedResources"] = [];
            for (let item of this.excludedResources)
                data["excludedResources"].push(item.toJSON());
        }
        if (Array.isArray(this.pastEmployments)) {
            data["pastEmployments"] = [];
            for (let item of this.pastEmployments)
                data["pastEmployments"].push(item.toJSON());
        }
        if (Array.isArray(this.benefitsAtIntake)) {
            data["benefitsAtIntake"] = [];
            for (let item of this.benefitsAtIntake)
                data["benefitsAtIntake"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalBenefits)) {
            data["additionalBenefits"] = [];
            for (let item of this.additionalBenefits)
                data["additionalBenefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateIntakeRecordDto {
    id: number | undefined;
    benefitsCounselingCaseId: number;
    intakeDate: DateTime;
    cwicUserId: number;
    referralSource: ReferralSource;
    referralSourceOther: string | undefined;
    medicareClaimNumber: string | undefined;
    medicaidNumber: string | undefined;
    age18RedeterminationDone: boolean | undefined;
    disabledPriorAge26: boolean | undefined;
    hasABLEAccount: boolean | undefined;
    primaryDisability: string | undefined;
    statutoryBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    isVeteran: boolean | undefined;
    maritalStatus: MaritalStatus;
    householdMeansTestedBenefitDetail: string | undefined;
    ssiIncomeInKindDetail: string | undefined;
    hasMySSAAccount: MySSAAccountStatus;
    bsaDeliveryMethod: PreferredContactMethod;
    bsaDeliveryMethodOther: string | undefined;
    highestGradeCompleted: HighestGradeCompleted;
    educationalGoals: string | undefined;
    wantsEliminateBenefits: boolean | undefined;
    wantsReduceBenefitDependence: boolean | undefined;
    neededEmploymentServices: string | undefined;
    consentToShareBSA: boolean | undefined;
    consentToShareBSADate: DateTime | undefined;
    consentToShareBSAWith: string | undefined;
    irweOrBWEExpenses: string | undefined;
    specialEmploymentSupports: string | undefined;
    notes: string | undefined;
    currentEmployment: CurrentEmploymentDto;
    householdMembers: HouseholdMemberDto[] | undefined;
    contactInfos: ContactInfoDto[] | undefined;
    earningsGoals: EarningsGoalDto[] | undefined;
    employmentServices: EmploymentServiceDto[] | undefined;
    excludedResources: ExcludedResourceDto[] | undefined;
    pastEmployments: PastEmploymentDto[] | undefined;
    benefitsAtIntake: BenefitAtIntakeDto[] | undefined;
    additionalBenefits: AdditionalBenefitDto[] | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateMarketingCampaignDto implements ICreateOrUpdateMarketingCampaignDto {
    id!: number | undefined;
    name!: string;
    channel!: MarketingCampaignChannel;
    trackingCode!: string;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    budget!: number | undefined;
    isActive!: boolean;
    ownerUserId!: number | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateOrUpdateMarketingCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.channel = _data["channel"];
            this.trackingCode = _data["trackingCode"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.budget = _data["budget"];
            this.isActive = _data["isActive"];
            this.ownerUserId = _data["ownerUserId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channel"] = this.channel;
        data["trackingCode"] = this.trackingCode;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["budget"] = this.budget;
        data["isActive"] = this.isActive;
        data["ownerUserId"] = this.ownerUserId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateOrUpdateMarketingCampaignDto {
    id: number | undefined;
    name: string;
    channel: MarketingCampaignChannel;
    trackingCode: string;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    budget: number | undefined;
    isActive: boolean;
    ownerUserId: number | undefined;
    notes: string | undefined;
}

export class CreateOrUpdateMarketingContactDto implements ICreateOrUpdateMarketingContactDto {
    id!: number | undefined;
    organizationId!: number;
    name!: string;
    title!: string | undefined;
    role!: string | undefined;
    agencyCodes!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    address!: string | undefined;
    isPrimary!: boolean;
    isActive!: boolean;
    notes!: string | undefined;

    constructor(data?: ICreateOrUpdateMarketingContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.role = _data["role"];
            this.agencyCodes = _data["agencyCodes"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.address = _data["address"];
            this.isPrimary = _data["isPrimary"];
            this.isActive = _data["isActive"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["role"] = this.role;
        data["agencyCodes"] = this.agencyCodes;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["address"] = this.address;
        data["isPrimary"] = this.isPrimary;
        data["isActive"] = this.isActive;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateOrUpdateMarketingContactDto {
    id: number | undefined;
    organizationId: number;
    name: string;
    title: string | undefined;
    role: string | undefined;
    agencyCodes: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    address: string | undefined;
    isPrimary: boolean;
    isActive: boolean;
    notes: string | undefined;
}

export class CreateOrUpdateMarketingEventChecklistItemDto implements ICreateOrUpdateMarketingEventChecklistItemDto {
    id!: number | undefined;
    eventId!: number;
    category!: MarketingChecklistCategory;
    title!: string;
    assignedUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    notes!: string | undefined;
    sortOrder!: number;

    constructor(data?: ICreateOrUpdateMarketingEventChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.category = _data["category"];
            this.title = _data["title"];
            this.assignedUserId = _data["assignedUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingEventChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingEventChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["category"] = this.category;
        data["title"] = this.title;
        data["assignedUserId"] = this.assignedUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateOrUpdateMarketingEventChecklistItemDto {
    id: number | undefined;
    eventId: number;
    category: MarketingChecklistCategory;
    title: string;
    assignedUserId: number | undefined;
    dueDate: DateTime | undefined;
    notes: string | undefined;
    sortOrder: number;
}

export class CreateOrUpdateMarketingEventDto implements ICreateOrUpdateMarketingEventDto {
    id!: number | undefined;
    name!: string;
    eventType!: MarketingEventType;
    mode!: MarketingEventMode;
    format!: MarketingEventFormat;
    startDate!: DateTime;
    endDate!: DateTime;
    venue!: string | undefined;
    address!: string | undefined;
    state!: string | undefined;
    meetingLink!: string | undefined;
    organizerOrganizationId!: number | undefined;
    ownerUserId!: number | undefined;
    budget!: number | undefined;
    goals!: string | undefined;
    notes!: string | undefined;
    checklistTemplateId!: number | undefined;

    constructor(data?: ICreateOrUpdateMarketingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.eventType = _data["eventType"];
            this.mode = _data["mode"];
            this.format = _data["format"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.meetingLink = _data["meetingLink"];
            this.organizerOrganizationId = _data["organizerOrganizationId"];
            this.ownerUserId = _data["ownerUserId"];
            this.budget = _data["budget"];
            this.goals = _data["goals"];
            this.notes = _data["notes"];
            this.checklistTemplateId = _data["checklistTemplateId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["eventType"] = this.eventType;
        data["mode"] = this.mode;
        data["format"] = this.format;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["state"] = this.state;
        data["meetingLink"] = this.meetingLink;
        data["organizerOrganizationId"] = this.organizerOrganizationId;
        data["ownerUserId"] = this.ownerUserId;
        data["budget"] = this.budget;
        data["goals"] = this.goals;
        data["notes"] = this.notes;
        data["checklistTemplateId"] = this.checklistTemplateId;
        return data;
    }
}

export interface ICreateOrUpdateMarketingEventDto {
    id: number | undefined;
    name: string;
    eventType: MarketingEventType;
    mode: MarketingEventMode;
    format: MarketingEventFormat;
    startDate: DateTime;
    endDate: DateTime;
    venue: string | undefined;
    address: string | undefined;
    state: string | undefined;
    meetingLink: string | undefined;
    organizerOrganizationId: number | undefined;
    ownerUserId: number | undefined;
    budget: number | undefined;
    goals: string | undefined;
    notes: string | undefined;
    checklistTemplateId: number | undefined;
}

export class CreateOrUpdateMarketingEventRegistrationDto implements ICreateOrUpdateMarketingEventRegistrationDto {
    id!: number | undefined;
    eventId!: number;
    firstName!: string;
    lastName!: string;
    email!: string | undefined;
    phone!: string | undefined;
    organizationName!: string | undefined;
    isBeneficiary!: boolean;
    notes!: string | undefined;
    attended!: boolean | undefined;

    constructor(data?: ICreateOrUpdateMarketingEventRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.organizationName = _data["organizationName"];
            this.isBeneficiary = _data["isBeneficiary"];
            this.notes = _data["notes"];
            this.attended = _data["attended"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingEventRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingEventRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["organizationName"] = this.organizationName;
        data["isBeneficiary"] = this.isBeneficiary;
        data["notes"] = this.notes;
        data["attended"] = this.attended;
        return data;
    }
}

export interface ICreateOrUpdateMarketingEventRegistrationDto {
    id: number | undefined;
    eventId: number;
    firstName: string;
    lastName: string;
    email: string | undefined;
    phone: string | undefined;
    organizationName: string | undefined;
    isBeneficiary: boolean;
    notes: string | undefined;
    attended: boolean | undefined;
}

export class CreateOrUpdateMarketingInteractionDto implements ICreateOrUpdateMarketingInteractionDto {
    id!: number | undefined;
    organizationId!: number;
    contactId!: number | undefined;
    eventId!: number | undefined;
    interactionDate!: DateTime;
    method!: MarketingInteractionMethod;
    direction!: MarketingInteractionDirection;
    subject!: string | undefined;
    notes!: string | undefined;
    nextStep!: string | undefined;
    followUpDate!: DateTime | undefined;
    status!: MarketingInteractionStatus;

    constructor(data?: ICreateOrUpdateMarketingInteractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.contactId = _data["contactId"];
            this.eventId = _data["eventId"];
            this.interactionDate = _data["interactionDate"] ? DateTime.fromISO(_data["interactionDate"].toString()) : <any>undefined;
            this.method = _data["method"];
            this.direction = _data["direction"];
            this.subject = _data["subject"];
            this.notes = _data["notes"];
            this.nextStep = _data["nextStep"];
            this.followUpDate = _data["followUpDate"] ? DateTime.fromISO(_data["followUpDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingInteractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingInteractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["contactId"] = this.contactId;
        data["eventId"] = this.eventId;
        data["interactionDate"] = this.interactionDate ? this.interactionDate.toString() : <any>undefined;
        data["method"] = this.method;
        data["direction"] = this.direction;
        data["subject"] = this.subject;
        data["notes"] = this.notes;
        data["nextStep"] = this.nextStep;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrUpdateMarketingInteractionDto {
    id: number | undefined;
    organizationId: number;
    contactId: number | undefined;
    eventId: number | undefined;
    interactionDate: DateTime;
    method: MarketingInteractionMethod;
    direction: MarketingInteractionDirection;
    subject: string | undefined;
    notes: string | undefined;
    nextStep: string | undefined;
    followUpDate: DateTime | undefined;
    status: MarketingInteractionStatus;
}

export class CreateOrUpdateMarketingOrganizationDto implements ICreateOrUpdateMarketingOrganizationDto {
    id!: number | undefined;
    name!: string;
    type!: MarketingOrganizationType;
    agencyCode!: string | undefined;
    pid!: string | undefined;
    ssaRegion!: string | undefined;
    state!: string | undefined;
    address!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    fax!: string | undefined;
    relationshipStage!: MarketingRelationshipStage;
    ownerUserId!: number | undefined;
    notes!: string | undefined;
    contacts!: MarketingOrganizationContactDto[] | undefined;

    constructor(data?: ICreateOrUpdateMarketingOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.agencyCode = _data["agencyCode"];
            this.pid = _data["pid"];
            this.ssaRegion = _data["ssaRegion"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.fax = _data["fax"];
            this.relationshipStage = _data["relationshipStage"];
            this.ownerUserId = _data["ownerUserId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(MarketingOrganizationContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["agencyCode"] = this.agencyCode;
        data["pid"] = this.pid;
        data["ssaRegion"] = this.ssaRegion;
        data["state"] = this.state;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["fax"] = this.fax;
        data["relationshipStage"] = this.relationshipStage;
        data["ownerUserId"] = this.ownerUserId;
        data["notes"] = this.notes;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMarketingOrganizationDto {
    id: number | undefined;
    name: string;
    type: MarketingOrganizationType;
    agencyCode: string | undefined;
    pid: string | undefined;
    ssaRegion: string | undefined;
    state: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    website: string | undefined;
    fax: string | undefined;
    relationshipStage: MarketingRelationshipStage;
    ownerUserId: number | undefined;
    notes: string | undefined;
    contacts: MarketingOrganizationContactDto[] | undefined;
}

export class CreateOrUpdateMarketingOrganizationNoteDto implements ICreateOrUpdateMarketingOrganizationNoteDto {
    id!: number | undefined;
    organizationId!: number;
    note!: string;
    isPinned!: boolean;

    constructor(data?: ICreateOrUpdateMarketingOrganizationNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.note = _data["note"];
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMarketingOrganizationNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMarketingOrganizationNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["note"] = this.note;
        data["isPinned"] = this.isPinned;
        return data;
    }
}

export interface ICreateOrUpdateMarketingOrganizationNoteDto {
    id: number | undefined;
    organizationId: number;
    note: string;
    isPinned: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateTtw1619bThresholdDto implements ICreateOrUpdateTtw1619bThresholdDto {
    id!: number | undefined;
    year!: number;
    stateAbbreviation!: string;
    thresholdAmount!: number;
    is1634State!: boolean;
    isActive!: boolean;
    isAiSourced!: boolean;

    constructor(data?: ICreateOrUpdateTtw1619bThresholdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.thresholdAmount = _data["thresholdAmount"];
            this.is1634State = _data["is1634State"];
            this.isActive = _data["isActive"];
            this.isAiSourced = _data["isAiSourced"];
        }
    }

    static fromJS(data: any): CreateOrUpdateTtw1619bThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTtw1619bThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["thresholdAmount"] = this.thresholdAmount;
        data["is1634State"] = this.is1634State;
        data["isActive"] = this.isActive;
        data["isAiSourced"] = this.isAiSourced;
        return data;
    }
}

export interface ICreateOrUpdateTtw1619bThresholdDto {
    id: number | undefined;
    year: number;
    stateAbbreviation: string;
    thresholdAmount: number;
    is1634State: boolean;
    isActive: boolean;
    isAiSourced: boolean;
}

export class CreateOrUpdateTtwAnnualThresholdDto implements ICreateOrUpdateTtwAnnualThresholdDto {
    id!: number | undefined;
    year!: number;
    twlAmount!: number;
    sgaAmount!: number;
    blindSgaAmount!: number | undefined;
    isActive!: boolean;

    constructor(data?: ICreateOrUpdateTtwAnnualThresholdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.twlAmount = _data["twlAmount"];
            this.sgaAmount = _data["sgaAmount"];
            this.blindSgaAmount = _data["blindSgaAmount"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateTtwAnnualThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTtwAnnualThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["twlAmount"] = this.twlAmount;
        data["sgaAmount"] = this.sgaAmount;
        data["blindSgaAmount"] = this.blindSgaAmount;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateOrUpdateTtwAnnualThresholdDto {
    id: number | undefined;
    year: number;
    twlAmount: number;
    sgaAmount: number;
    blindSgaAmount: number | undefined;
    isActive: boolean;
}

export class CreateOrUpdateTtwSsiFederalBenefitRateDto implements ICreateOrUpdateTtwSsiFederalBenefitRateDto {
    id!: number | undefined;
    year!: number;
    eligibleIndividualAmount!: number;
    eligibleCoupleAmount!: number;
    essentialPersonAmount!: number;
    isActive!: boolean;
    isAiSourced!: boolean;

    constructor(data?: ICreateOrUpdateTtwSsiFederalBenefitRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.eligibleIndividualAmount = _data["eligibleIndividualAmount"];
            this.eligibleCoupleAmount = _data["eligibleCoupleAmount"];
            this.essentialPersonAmount = _data["essentialPersonAmount"];
            this.isActive = _data["isActive"];
            this.isAiSourced = _data["isAiSourced"];
        }
    }

    static fromJS(data: any): CreateOrUpdateTtwSsiFederalBenefitRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTtwSsiFederalBenefitRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["eligibleIndividualAmount"] = this.eligibleIndividualAmount;
        data["eligibleCoupleAmount"] = this.eligibleCoupleAmount;
        data["essentialPersonAmount"] = this.essentialPersonAmount;
        data["isActive"] = this.isActive;
        data["isAiSourced"] = this.isAiSourced;
        return data;
    }
}

export interface ICreateOrUpdateTtwSsiFederalBenefitRateDto {
    id: number | undefined;
    year: number;
    eligibleIndividualAmount: number;
    eligibleCoupleAmount: number;
    essentialPersonAmount: number;
    isActive: boolean;
    isAiSourced: boolean;
}

export class CreateOrUpdateTtwTrackingSheetMonthDto implements ICreateOrUpdateTtwTrackingSheetMonthDto {
    id!: number | undefined;
    ticketHolderId!: number;
    calendarYear!: number;
    calendarMonth!: number;
    grossSalary!: number | undefined;
    countableEarnings!: number | undefined;
    isTwlMet!: boolean;
    isSgaMet!: boolean;
    phaseMilestoneNumber!: number | undefined;
    isCessationMonth!: boolean;
    isGracePeriodMonth!: boolean;
    isEligibleForPayment!: boolean;
    hasPaystub!: boolean;
    wageVerified!: boolean;
    notes!: string | undefined;

    constructor(data?: ICreateOrUpdateTtwTrackingSheetMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.calendarYear = _data["calendarYear"];
            this.calendarMonth = _data["calendarMonth"];
            this.grossSalary = _data["grossSalary"];
            this.countableEarnings = _data["countableEarnings"];
            this.isTwlMet = _data["isTwlMet"];
            this.isSgaMet = _data["isSgaMet"];
            this.phaseMilestoneNumber = _data["phaseMilestoneNumber"];
            this.isCessationMonth = _data["isCessationMonth"];
            this.isGracePeriodMonth = _data["isGracePeriodMonth"];
            this.isEligibleForPayment = _data["isEligibleForPayment"];
            this.hasPaystub = _data["hasPaystub"];
            this.wageVerified = _data["wageVerified"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateOrUpdateTtwTrackingSheetMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTtwTrackingSheetMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["calendarYear"] = this.calendarYear;
        data["calendarMonth"] = this.calendarMonth;
        data["grossSalary"] = this.grossSalary;
        data["countableEarnings"] = this.countableEarnings;
        data["isTwlMet"] = this.isTwlMet;
        data["isSgaMet"] = this.isSgaMet;
        data["phaseMilestoneNumber"] = this.phaseMilestoneNumber;
        data["isCessationMonth"] = this.isCessationMonth;
        data["isGracePeriodMonth"] = this.isGracePeriodMonth;
        data["isEligibleForPayment"] = this.isEligibleForPayment;
        data["hasPaystub"] = this.hasPaystub;
        data["wageVerified"] = this.wageVerified;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateOrUpdateTtwTrackingSheetMonthDto {
    id: number | undefined;
    ticketHolderId: number;
    calendarYear: number;
    calendarMonth: number;
    grossSalary: number | undefined;
    countableEarnings: number | undefined;
    isTwlMet: boolean;
    isSgaMet: boolean;
    phaseMilestoneNumber: number | undefined;
    isCessationMonth: boolean;
    isGracePeriodMonth: boolean;
    isEligibleForPayment: boolean;
    hasPaystub: boolean;
    wageVerified: boolean;
    notes: string | undefined;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class CreatePayHistoryDto implements ICreatePayHistoryDto {
    employerId!: number;
    ticketHolderId!: number;
    payType!: PayType;
    grossPay!: number;
    hoursWorked!: number | undefined;
    payPeriodStart!: DateTime;
    payPeriodEnd!: DateTime;
    payDate!: DateTime;
    notes!: string | undefined;
    wageReportProcessingQId!: number;

    constructor(data?: ICreatePayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerId = _data["employerId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.payType = _data["payType"];
            this.grossPay = _data["grossPay"];
            this.hoursWorked = _data["hoursWorked"];
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.wageReportProcessingQId = _data["wageReportProcessingQId"];
        }
    }

    static fromJS(data: any): CreatePayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerId"] = this.employerId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["payType"] = this.payType;
        data["grossPay"] = this.grossPay;
        data["hoursWorked"] = this.hoursWorked;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["notes"] = this.notes;
        data["wageReportProcessingQId"] = this.wageReportProcessingQId;
        return data;
    }
}

export interface ICreatePayHistoryDto {
    employerId: number;
    ticketHolderId: number;
    payType: PayType;
    grossPay: number;
    hoursWorked: number | undefined;
    payPeriodStart: DateTime;
    payPeriodEnd: DateTime;
    payDate: DateTime;
    notes: string | undefined;
    wageReportProcessingQId: number;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    tenantId!: number;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean | undefined;
    isProrationPayment!: boolean | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    extraProperties!: { [key: string]: any; } | undefined;
    products!: CreatePaymentProductDto[] | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = _data["recurringPaymentEnabled"];
            this.isProrationPayment = _data["isProrationPayment"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            if (_data["extraProperties"]) {
                this.extraProperties = {} as any;
                for (let key in _data["extraProperties"]) {
                    if (_data["extraProperties"].hasOwnProperty(key))
                        (<any>this.extraProperties)![key] = _data["extraProperties"][key];
                }
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CreatePaymentProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["isProrationPayment"] = this.isProrationPayment;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    (<any>data["extraProperties"])[key] = (<any>this.extraProperties)[key];
            }
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePaymentDto {
    tenantId: number;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean | undefined;
    isProrationPayment: boolean | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    extraProperties: { [key: string]: any; } | undefined;
    products: CreatePaymentProductDto[] | undefined;
}

export class CreatePaymentProductDto implements ICreatePaymentProductDto {
    description!: string | undefined;
    amount!: number;
    count!: number;
    extraProperties!: { [key: string]: any; } | undefined;

    constructor(data?: ICreatePaymentProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.count = _data["count"];
            if (_data["extraProperties"]) {
                this.extraProperties = {} as any;
                for (let key in _data["extraProperties"]) {
                    if (_data["extraProperties"].hasOwnProperty(key))
                        (<any>this.extraProperties)![key] = _data["extraProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreatePaymentProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["count"] = this.count;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    (<any>data["extraProperties"])[key] = (<any>this.extraProperties)[key];
            }
        }
        return data;
    }
}

export interface ICreatePaymentProductDto {
    description: string | undefined;
    amount: number;
    count: number;
    extraProperties: { [key: string]: any; } | undefined;
}

export class CreateReferralPartnerDto implements ICreateReferralPartnerDto {
    organizationName!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    contactAddress!: string | undefined;
    rewardDescription!: string | undefined;
    contractDocument!: UploadFileOutputDto;
    notes!: string | undefined;
    partnerCode!: string | undefined;

    constructor(data?: ICreateReferralPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.contactAddress = _data["contactAddress"];
            this.rewardDescription = _data["rewardDescription"];
            this.contractDocument = _data["contractDocument"] ? UploadFileOutputDto.fromJS(_data["contractDocument"]) : <any>undefined;
            this.notes = _data["notes"];
            this.partnerCode = _data["partnerCode"];
        }
    }

    static fromJS(data: any): CreateReferralPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReferralPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["contactAddress"] = this.contactAddress;
        data["rewardDescription"] = this.rewardDescription;
        data["contractDocument"] = this.contractDocument ? this.contractDocument.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["partnerCode"] = this.partnerCode;
        return data;
    }
}

export interface ICreateReferralPartnerDto {
    organizationName: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    contactAddress: string | undefined;
    rewardDescription: string | undefined;
    contractDocument: UploadFileOutputDto;
    notes: string | undefined;
    partnerCode: string | undefined;
}

export class CreateReinstatementDto implements ICreateReinstatementDto {
    ticketHolderId!: number;
    notes!: string | undefined;

    constructor(data?: ICreateReinstatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateReinstatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReinstatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateReinstatementDto {
    ticketHolderId: number;
    notes: string | undefined;
}

export class CreateReinstatementHistoryDto implements ICreateReinstatementHistoryDto {
    ticketHolderReinstatementId!: number;
    status!: ReinstatementStatus;
    reasonOrNote!: string | undefined;

    constructor(data?: ICreateReinstatementHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderReinstatementId = _data["ticketHolderReinstatementId"];
            this.status = _data["status"];
            this.reasonOrNote = _data["reasonOrNote"];
        }
    }

    static fromJS(data: any): CreateReinstatementHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReinstatementHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderReinstatementId"] = this.ticketHolderReinstatementId;
        data["status"] = this.status;
        data["reasonOrNote"] = this.reasonOrNote;
        return data;
    }
}

export interface ICreateReinstatementHistoryDto {
    ticketHolderReinstatementId: number;
    status: ReinstatementStatus;
    reasonOrNote: string | undefined;
}

export class CreateReminderDto implements ICreateReminderDto {
    clientId!: string;
    ticketHolderId!: number;
    title!: string;
    description!: string | undefined;
    startTime!: DateTime;

    constructor(data?: ICreateReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateReminderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReminderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateReminderDto {
    clientId: string;
    ticketHolderId: number;
    title: string;
    description: string | undefined;
    startTime: DateTime;
}

export class CreateReportRequestDto implements ICreateReportRequestDto {
    title!: string;
    businessPurpose!: string | undefined;
    requiredColumns!: string | undefined;
    requiredFilters!: string | undefined;
    dateRangeRequirements!: string | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.businessPurpose = _data["businessPurpose"];
            this.requiredColumns = _data["requiredColumns"];
            this.requiredFilters = _data["requiredFilters"];
            this.dateRangeRequirements = _data["dateRangeRequirements"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["businessPurpose"] = this.businessPurpose;
        data["requiredColumns"] = this.requiredColumns;
        data["requiredFilters"] = this.requiredFilters;
        data["dateRangeRequirements"] = this.dateRangeRequirements;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateReportRequestDto {
    title: string;
    businessPurpose: string | undefined;
    requiredColumns: string | undefined;
    requiredFilters: string | undefined;
    dateRangeRequirements: string | undefined;
    notes: string | undefined;
}

export class CreateSsaContactRequestDto implements ICreateSsaContactRequestDto {
    role!: SsaContactRole;
    userId!: number;
    name!: string;
    phone!: string;
    tollFree!: string | undefined;
    fax!: string | undefined;
    tty!: string | undefined;
    email!: string;

    constructor(data?: ICreateSsaContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.tollFree = _data["tollFree"];
            this.fax = _data["fax"];
            this.tty = _data["tty"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateSsaContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSsaContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["tollFree"] = this.tollFree;
        data["fax"] = this.fax;
        data["tty"] = this.tty;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateSsaContactRequestDto {
    role: SsaContactRole;
    userId: number;
    name: string;
    phone: string;
    tollFree: string | undefined;
    fax: string | undefined;
    tty: string | undefined;
    email: string;
}

export class CreateSupportTicketDto implements ICreateSupportTicketDto {
    htmlDescription!: string;

    constructor(data?: ICreateSupportTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.htmlDescription = _data["htmlDescription"];
        }
    }

    static fromJS(data: any): CreateSupportTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupportTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmlDescription"] = this.htmlDescription;
        return data;
    }
}

export interface ICreateSupportTicketDto {
    htmlDescription: string;
}

export class CreateTaskTemplateRequestDto implements ICreateTaskTemplateRequestDto {
    title!: string;
    description!: string;
    expectedOutputs!: string;
    stage!: TTWTaskTemplateStage;
    orderInStage!: number;

    constructor(data?: ICreateTaskTemplateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.expectedOutputs = _data["expectedOutputs"];
            this.stage = _data["stage"];
            this.orderInStage = _data["orderInStage"];
        }
    }

    static fromJS(data: any): CreateTaskTemplateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskTemplateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["expectedOutputs"] = this.expectedOutputs;
        data["stage"] = this.stage;
        data["orderInStage"] = this.orderInStage;
        return data;
    }
}

export interface ICreateTaskTemplateRequestDto {
    title: string;
    description: string;
    expectedOutputs: string;
    stage: TTWTaskTemplateStage;
    orderInStage: number;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminName!: string | undefined;
    adminSurname!: string | undefined;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    address!: string | undefined;
    faxNumber!: string | undefined;
    pid!: string;
    telePhone!: string | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminName = _data["adminName"];
            this.adminSurname = _data["adminSurname"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.address = _data["address"];
            this.faxNumber = _data["faxNumber"];
            this.pid = _data["pid"];
            this.telePhone = _data["telePhone"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminName"] = this.adminName;
        data["adminSurname"] = this.adminSurname;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["address"] = this.address;
        data["faxNumber"] = this.faxNumber;
        data["pid"] = this.pid;
        data["telePhone"] = this.telePhone;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminName: string | undefined;
    adminSurname: string | undefined;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    address: string | undefined;
    faxNumber: string | undefined;
    pid: string;
    telePhone: string | undefined;
}

export class CreateTicketHolderDto implements ICreateTicketHolderDto {
    firstName!: string;
    middleName!: string | undefined;
    lastName!: string;
    email!: string | undefined;
    encryptedSSN!: string | undefined;
    doB!: DateTime | undefined;
    benefitType!: BenefitType;
    timeZone!: string | undefined;
    assigneeId!: number;
    spokenLanguages!: SpokenLanguageDto[] | undefined;
    addresses!: TicketHolderAddressDto[] | undefined;
    phoneNumbers!: TicketHolderPhoneNumberDto[] | undefined;

    constructor(data?: ICreateTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.benefitType = _data["benefitType"];
            this.timeZone = _data["timeZone"];
            this.assigneeId = _data["assigneeId"];
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(TicketHolderAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(TicketHolderPhoneNumberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["encryptedSSN"] = this.encryptedSSN;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["benefitType"] = this.benefitType;
        data["timeZone"] = this.timeZone;
        data["assigneeId"] = this.assigneeId;
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTicketHolderDto {
    firstName: string;
    middleName: string | undefined;
    lastName: string;
    email: string | undefined;
    encryptedSSN: string | undefined;
    doB: DateTime | undefined;
    benefitType: BenefitType;
    timeZone: string | undefined;
    assigneeId: number;
    spokenLanguages: SpokenLanguageDto[] | undefined;
    addresses: TicketHolderAddressDto[] | undefined;
    phoneNumbers: TicketHolderPhoneNumberDto[] | undefined;
}

export class CreateTicketHolderFollowupDto implements ICreateTicketHolderFollowupDto {
    ticketHolderId!: number;
    title!: string | undefined;
    description!: string | undefined;
    startDate!: DateTime;
    status!: CalendarEventStatus;
    followupType!: FollowupType;

    constructor(data?: ICreateTicketHolderFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.followupType = _data["followupType"];
        }
    }

    static fromJS(data: any): CreateTicketHolderFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketHolderFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["status"] = this.status;
        data["followupType"] = this.followupType;
        return data;
    }
}

export interface ICreateTicketHolderFollowupDto {
    ticketHolderId: number;
    title: string | undefined;
    description: string | undefined;
    startDate: DateTime;
    status: CalendarEventStatus;
    followupType: FollowupType;
}

export class CreateTicketHolderNoteDto implements ICreateTicketHolderNoteDto {
    ticketHolderId!: number;
    noteText!: string;
    isPinned!: boolean;

    constructor(data?: ICreateTicketHolderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.noteText = _data["noteText"];
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any): CreateTicketHolderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketHolderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["noteText"] = this.noteText;
        data["isPinned"] = this.isPinned;
        return data;
    }
}

export interface ICreateTicketHolderNoteDto {
    ticketHolderId: number;
    noteText: string;
    isPinned: boolean;
}

export class CreateTtwReferralDto implements ICreateTtwReferralDto {
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    consentToContact!: boolean;
    ageEligible!: boolean;
    benefitEligible!: boolean;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    isFullTimeEmployment!: boolean;
    rewardIssuedDate!: DateTime | undefined;
    notes!: string | undefined;
    partnerCode!: string | undefined;
    attribution!: ReferralAttributionDto;

    constructor(data?: ICreateTtwReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.consentToContact = _data["consentToContact"];
            this.ageEligible = _data["ageEligible"];
            this.benefitEligible = _data["benefitEligible"];
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.isFullTimeEmployment = _data["isFullTimeEmployment"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.partnerCode = _data["partnerCode"];
            this.attribution = _data["attribution"] ? ReferralAttributionDto.fromJS(_data["attribution"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTtwReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTtwReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["consentToContact"] = this.consentToContact;
        data["ageEligible"] = this.ageEligible;
        data["benefitEligible"] = this.benefitEligible;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["isFullTimeEmployment"] = this.isFullTimeEmployment;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["partnerCode"] = this.partnerCode;
        data["attribution"] = this.attribution ? this.attribution.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTtwReferralDto {
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    consentToContact: boolean;
    ageEligible: boolean;
    benefitEligible: boolean;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    isFullTimeEmployment: boolean;
    rewardIssuedDate: DateTime | undefined;
    notes: string | undefined;
    partnerCode: string | undefined;
    attribution: ReferralAttributionDto;
}

export class CreateTtwReferralWithTenantDto implements ICreateTtwReferralWithTenantDto {
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    consentToContact!: boolean;
    ageEligible!: boolean;
    benefitEligible!: boolean;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    isFullTimeEmployment!: boolean;
    rewardIssuedDate!: DateTime | undefined;
    notes!: string | undefined;
    partnerCode!: string | undefined;
    attribution!: ReferralAttributionDto;
    tenancyName!: string;

    constructor(data?: ICreateTtwReferralWithTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.consentToContact = _data["consentToContact"];
            this.ageEligible = _data["ageEligible"];
            this.benefitEligible = _data["benefitEligible"];
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.isFullTimeEmployment = _data["isFullTimeEmployment"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.partnerCode = _data["partnerCode"];
            this.attribution = _data["attribution"] ? ReferralAttributionDto.fromJS(_data["attribution"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): CreateTtwReferralWithTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTtwReferralWithTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["consentToContact"] = this.consentToContact;
        data["ageEligible"] = this.ageEligible;
        data["benefitEligible"] = this.benefitEligible;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["isFullTimeEmployment"] = this.isFullTimeEmployment;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["partnerCode"] = this.partnerCode;
        data["attribution"] = this.attribution ? this.attribution.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ICreateTtwReferralWithTenantDto {
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    consentToContact: boolean;
    ageEligible: boolean;
    benefitEligible: boolean;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    isFullTimeEmployment: boolean;
    rewardIssuedDate: DateTime | undefined;
    notes: string | undefined;
    partnerCode: string | undefined;
    attribution: ReferralAttributionDto;
    tenancyName: string;
}

export class CreateTtwReferralWithTenantsDto implements ICreateTtwReferralWithTenantsDto {
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    consentToContact!: boolean;
    ageEligible!: boolean;
    benefitEligible!: boolean;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    isFullTimeEmployment!: boolean;
    rewardIssuedDate!: DateTime | undefined;
    notes!: string | undefined;
    partnerReferralInfo!: ReferralPartnerDtoForReferral;
    attribution!: ReferralAttributionDto;
    tenancyName!: string;

    constructor(data?: ICreateTtwReferralWithTenantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.consentToContact = _data["consentToContact"];
            this.ageEligible = _data["ageEligible"];
            this.benefitEligible = _data["benefitEligible"];
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.isFullTimeEmployment = _data["isFullTimeEmployment"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.partnerReferralInfo = _data["partnerReferralInfo"] ? ReferralPartnerDtoForReferral.fromJS(_data["partnerReferralInfo"]) : <any>undefined;
            this.attribution = _data["attribution"] ? ReferralAttributionDto.fromJS(_data["attribution"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): CreateTtwReferralWithTenantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTtwReferralWithTenantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["consentToContact"] = this.consentToContact;
        data["ageEligible"] = this.ageEligible;
        data["benefitEligible"] = this.benefitEligible;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["isFullTimeEmployment"] = this.isFullTimeEmployment;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["partnerReferralInfo"] = this.partnerReferralInfo ? this.partnerReferralInfo.toJSON() : <any>undefined;
        data["attribution"] = this.attribution ? this.attribution.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ICreateTtwReferralWithTenantsDto {
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    consentToContact: boolean;
    ageEligible: boolean;
    benefitEligible: boolean;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    isFullTimeEmployment: boolean;
    rewardIssuedDate: DateTime | undefined;
    notes: string | undefined;
    partnerReferralInfo: ReferralPartnerDtoForReferral;
    attribution: ReferralAttributionDto;
    tenancyName: string;
}

export class CreateTtwReferralWithoutPartnerIdDto implements ICreateTtwReferralWithoutPartnerIdDto {
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    consentToContact!: boolean;
    ageEligible!: boolean;
    benefitEligible!: boolean;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    isFullTimeEmployment!: boolean;
    rewardIssuedDate!: DateTime | undefined;
    notes!: string | undefined;
    partnerReferralInfo!: ReferralPartnerDtoForReferral;
    attribution!: ReferralAttributionDto;

    constructor(data?: ICreateTtwReferralWithoutPartnerIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.consentToContact = _data["consentToContact"];
            this.ageEligible = _data["ageEligible"];
            this.benefitEligible = _data["benefitEligible"];
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.isFullTimeEmployment = _data["isFullTimeEmployment"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.partnerReferralInfo = _data["partnerReferralInfo"] ? ReferralPartnerDtoForReferral.fromJS(_data["partnerReferralInfo"]) : <any>undefined;
            this.attribution = _data["attribution"] ? ReferralAttributionDto.fromJS(_data["attribution"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTtwReferralWithoutPartnerIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTtwReferralWithoutPartnerIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["consentToContact"] = this.consentToContact;
        data["ageEligible"] = this.ageEligible;
        data["benefitEligible"] = this.benefitEligible;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["isFullTimeEmployment"] = this.isFullTimeEmployment;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["partnerReferralInfo"] = this.partnerReferralInfo ? this.partnerReferralInfo.toJSON() : <any>undefined;
        data["attribution"] = this.attribution ? this.attribution.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTtwReferralWithoutPartnerIdDto {
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    consentToContact: boolean;
    ageEligible: boolean;
    benefitEligible: boolean;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    isFullTimeEmployment: boolean;
    rewardIssuedDate: DateTime | undefined;
    notes: string | undefined;
    partnerReferralInfo: ReferralPartnerDtoForReferral;
    attribution: ReferralAttributionDto;
}

export class CreateUpdateAiVoiceAgentDto implements ICreateUpdateAiVoiceAgentDto {
    id!: number | undefined;
    name!: string | undefined;
    description!: string | undefined;
    provider!: AiVoiceAgentProvider;
    isActive!: boolean;
    tenantId!: number;
    outboundApiKey!: string | undefined;
    fromPhoneNumber!: string | undefined;

    constructor(data?: ICreateUpdateAiVoiceAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.provider = _data["provider"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.outboundApiKey = _data["outboundApiKey"];
            this.fromPhoneNumber = _data["fromPhoneNumber"];
        }
    }

    static fromJS(data: any): CreateUpdateAiVoiceAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateAiVoiceAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["provider"] = this.provider;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["outboundApiKey"] = this.outboundApiKey;
        data["fromPhoneNumber"] = this.fromPhoneNumber;
        return data;
    }
}

export interface ICreateUpdateAiVoiceAgentDto {
    id: number | undefined;
    name: string | undefined;
    description: string | undefined;
    provider: AiVoiceAgentProvider;
    isActive: boolean;
    tenantId: number;
    outboundApiKey: string | undefined;
    fromPhoneNumber: string | undefined;
}

export class CreateUpdateReportDto implements ICreateUpdateReportDto {
    id!: number | undefined;
    name!: string;
    description!: string | undefined;
    tsql!: string;
    userRoles!: string | undefined;
    isActive!: boolean;
    tenantId!: number | undefined;

    constructor(data?: ICreateUpdateReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tsql = _data["tsql"];
            this.userRoles = _data["userRoles"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateUpdateReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tsql"] = this.tsql;
        data["userRoles"] = this.userRoles;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateUpdateReportDto {
    id: number | undefined;
    name: string;
    description: string | undefined;
    tsql: string;
    userRoles: string | undefined;
    isActive: boolean;
    tenantId: number | undefined;
}

export class CreateUploadQrOutput implements ICreateUploadQrOutput {
    uploadId!: string | undefined;
    qrImageBase64!: string | undefined;

    constructor(data?: ICreateUploadQrOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.qrImageBase64 = _data["qrImageBase64"];
        }
    }

    static fromJS(data: any): CreateUploadQrOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUploadQrOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["qrImageBase64"] = this.qrImageBase64;
        return data;
    }
}

export interface ICreateUploadQrOutput {
    uploadId: string | undefined;
    qrImageBase64: string | undefined;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class CurrentEmploymentDto implements ICurrentEmploymentDto {
    id!: number | undefined;
    isCurrentlyEmployed!: boolean;
    employerOrBusinessName!: string | undefined;
    isSelfEmployed!: boolean | undefined;
    isFullTime!: boolean | undefined;
    grossWagesAmount!: number | undefined;
    wageFrequency!: WageFrequency;
    paydaySchedule!: string | undefined;
    selfEmploymentNature!: string | undefined;
    estNetProfit!: number | undefined;
    earningsReportedToSSA!: boolean | undefined;
    earningsReportDate!: DateTime | undefined;
    earningsReportMethod!: string | undefined;

    constructor(data?: ICurrentEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCurrentlyEmployed = _data["isCurrentlyEmployed"];
            this.employerOrBusinessName = _data["employerOrBusinessName"];
            this.isSelfEmployed = _data["isSelfEmployed"];
            this.isFullTime = _data["isFullTime"];
            this.grossWagesAmount = _data["grossWagesAmount"];
            this.wageFrequency = _data["wageFrequency"];
            this.paydaySchedule = _data["paydaySchedule"];
            this.selfEmploymentNature = _data["selfEmploymentNature"];
            this.estNetProfit = _data["estNetProfit"];
            this.earningsReportedToSSA = _data["earningsReportedToSSA"];
            this.earningsReportDate = _data["earningsReportDate"] ? DateTime.fromISO(_data["earningsReportDate"].toString()) : <any>undefined;
            this.earningsReportMethod = _data["earningsReportMethod"];
        }
    }

    static fromJS(data: any): CurrentEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCurrentlyEmployed"] = this.isCurrentlyEmployed;
        data["employerOrBusinessName"] = this.employerOrBusinessName;
        data["isSelfEmployed"] = this.isSelfEmployed;
        data["isFullTime"] = this.isFullTime;
        data["grossWagesAmount"] = this.grossWagesAmount;
        data["wageFrequency"] = this.wageFrequency;
        data["paydaySchedule"] = this.paydaySchedule;
        data["selfEmploymentNature"] = this.selfEmploymentNature;
        data["estNetProfit"] = this.estNetProfit;
        data["earningsReportedToSSA"] = this.earningsReportedToSSA;
        data["earningsReportDate"] = this.earningsReportDate ? this.earningsReportDate.toString() : <any>undefined;
        data["earningsReportMethod"] = this.earningsReportMethod;
        return data;
    }
}

export interface ICurrentEmploymentDto {
    id: number | undefined;
    isCurrentlyEmployed: boolean;
    employerOrBusinessName: string | undefined;
    isSelfEmployed: boolean | undefined;
    isFullTime: boolean | undefined;
    grossWagesAmount: number | undefined;
    wageFrequency: WageFrequency;
    paydaySchedule: string | undefined;
    selfEmploymentNature: string | undefined;
    estNetProfit: number | undefined;
    earningsReportedToSSA: boolean | undefined;
    earningsReportDate: DateTime | undefined;
    earningsReportMethod: string | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType!: Type;
    constructor_!: ConstructorInfo;
    readonly constructorArguments!: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments!: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : <any>undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType: Type;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo!: MemberInfo;
    typedValue!: CustomAttributeTypedArgument;
    readonly memberName!: string | undefined;
    readonly isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType!: Type;
    value!: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: Type;
    value: any | undefined;
}

export class CwicUserDto implements ICwicUserDto {
    id!: number;
    fullName!: string | undefined;

    constructor(data?: ICwicUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): CwicUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CwicUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ICwicUserDto {
    id: number;
    fullName: string | undefined;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

/** This class stores filtered dashboard information by user */
export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

/** This class stores filtered dashboard information by user */
export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DateFieldOutput implements IDateFieldOutput {
    date!: DateTime;

    constructor(data?: IDateFieldOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateFieldOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateFieldOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        return data;
    }
}

export interface IDateFieldOutput {
    date: DateTime;
}

export enum DateFilter {
    None = 0,
    Week = 1,
    Month = 2,
    SixMonths = 3,
    OneYear = 4,
    PreviousYear = 5,
}

export class DateRangeFieldOutput implements IDateRangeFieldOutput {
    startDate!: DateTime;
    endDate!: DateTime;

    constructor(data?: IDateRangeFieldOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeFieldOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeFieldOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface IDateRangeFieldOutput {
    startDate: DateTime;
    endDate: DateTime;
}

export class DateWithTextFieldOutput implements IDateWithTextFieldOutput {
    date!: DateTime;
    text!: string | undefined;

    constructor(data?: IDateWithTextFieldOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DateWithTextFieldOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateWithTextFieldOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["text"] = this.text;
        return data;
    }
}

export interface IDateWithTextFieldOutput {
    date: DateTime;
    text: string | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class DeclinePartnerRegistrationDto implements IDeclinePartnerRegistrationDto {
    partnerId!: number;
    reason!: string | undefined;

    constructor(data?: IDeclinePartnerRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DeclinePartnerRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclinePartnerRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IDeclinePartnerRegistrationDto {
    partnerId: number;
    reason: string | undefined;
}

export class DecoderFallback implements IDecoderFallback {
    readonly maxCharCount!: number;

    constructor(data?: IDecoderFallback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).maxCharCount = _data["maxCharCount"];
        }
    }

    static fromJS(data: any): DecoderFallback {
        data = typeof data === 'object' ? data : {};
        let result = new DecoderFallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCharCount"] = this.maxCharCount;
        return data;
    }
}

export interface IDecoderFallback {
    maxCharCount: number;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class DeleteLeadImportBatchResultDto implements IDeleteLeadImportBatchResultDto {
    importBatchId!: string | undefined;
    totalLeadsInBatch!: number;
    deletedLeads!: number;
    retainedLeads!: number;

    constructor(data?: IDeleteLeadImportBatchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importBatchId = _data["importBatchId"];
            this.totalLeadsInBatch = _data["totalLeadsInBatch"];
            this.deletedLeads = _data["deletedLeads"];
            this.retainedLeads = _data["retainedLeads"];
        }
    }

    static fromJS(data: any): DeleteLeadImportBatchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLeadImportBatchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importBatchId"] = this.importBatchId;
        data["totalLeadsInBatch"] = this.totalLeadsInBatch;
        data["deletedLeads"] = this.deletedLeads;
        data["retainedLeads"] = this.retainedLeads;
        return data;
    }
}

export interface IDeleteLeadImportBatchResultDto {
    importBatchId: string | undefined;
    totalLeadsInBatch: number;
    deletedLeads: number;
    retainedLeads: number;
}

export enum DeliveryNotificationOptions {
    None = 0,
    OnSuccess = 1,
    OnFailure = 2,
    Delay = 4,
    Never = 134217728,
}

export class DigiSignerWebHookUrlDto implements IDigiSignerWebHookUrlDto {
    provider!: UserApiTokenProvider;
    webHookUrl!: string | undefined;

    constructor(data?: IDigiSignerWebHookUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.webHookUrl = _data["webHookUrl"];
        }
    }

    static fromJS(data: any): DigiSignerWebHookUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new DigiSignerWebHookUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["webHookUrl"] = this.webHookUrl;
        return data;
    }
}

export interface IDigiSignerWebHookUrlDto {
    provider: UserApiTokenProvider;
    webHookUrl: string | undefined;
}

export class DigitalSignatureDto implements IDigitalSignatureDto {
    id!: number;
    envelopeId!: string | undefined;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    repId!: number;
    ticketHolderSignatureStatus!: DigitalSignatureStatus;
    repSignatureStatus!: DigitalSignatureStatus;
    fileName!: string | undefined;
    fileType!: string | undefined;
    originalDocumentUrl!: string | undefined;
    documentId!: string | undefined;
    signedDocumentUrl!: string | undefined;
    envelopeType!: DigitalSignatureEnvelopType;
    envelopeStatus!: DigitalSignatureEnvelopStatus;
    sentDate!: DateTime | undefined;
    completedDate!: DateTime | undefined;
    expirationDate!: DateTime | undefined;
    message!: string | undefined;

    constructor(data?: IDigitalSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.envelopeId = _data["envelopeId"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.repId = _data["repId"];
            this.ticketHolderSignatureStatus = _data["ticketHolderSignatureStatus"];
            this.repSignatureStatus = _data["repSignatureStatus"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.originalDocumentUrl = _data["originalDocumentUrl"];
            this.documentId = _data["documentId"];
            this.signedDocumentUrl = _data["signedDocumentUrl"];
            this.envelopeType = _data["envelopeType"];
            this.envelopeStatus = _data["envelopeStatus"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? DateTime.fromISO(_data["completedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DigitalSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new DigitalSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["envelopeId"] = this.envelopeId;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["repId"] = this.repId;
        data["ticketHolderSignatureStatus"] = this.ticketHolderSignatureStatus;
        data["repSignatureStatus"] = this.repSignatureStatus;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["originalDocumentUrl"] = this.originalDocumentUrl;
        data["documentId"] = this.documentId;
        data["signedDocumentUrl"] = this.signedDocumentUrl;
        data["envelopeType"] = this.envelopeType;
        data["envelopeStatus"] = this.envelopeStatus;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IDigitalSignatureDto {
    id: number;
    envelopeId: string | undefined;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    repId: number;
    ticketHolderSignatureStatus: DigitalSignatureStatus;
    repSignatureStatus: DigitalSignatureStatus;
    fileName: string | undefined;
    fileType: string | undefined;
    originalDocumentUrl: string | undefined;
    documentId: string | undefined;
    signedDocumentUrl: string | undefined;
    envelopeType: DigitalSignatureEnvelopType;
    envelopeStatus: DigitalSignatureEnvelopStatus;
    sentDate: DateTime | undefined;
    completedDate: DateTime | undefined;
    expirationDate: DateTime | undefined;
    message: string | undefined;
}

export enum DigitalSignatureEnvelopStatus {
    New = 0,
    Sent = 1,
    Viewed = 2,
    Signed = 3,
    Completed = 4,
    Declined = 5,
    Voided = 6,
    Abandoned = 7,
    Error = 8,
    Expired = 9,
}

export enum DigitalSignatureEnvelopType {
    IWP = 0,
    IWPAddendum = 1,
    Other = 2,
    PartnerAgreement = 3,
}

export enum DigitalSignatureStatus {
    New = 0,
    Sent = 1,
    Signed = 2,
    Rejected = 3,
}

export class DisabilityDto implements IDisabilityDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IDisabilityDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class DisabledFilterInfo implements IDisabledFilterInfo {
    filter!: string | undefined;
    reason!: string | undefined;
    message!: string | undefined;

    constructor(data?: IDisabledFilterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.reason = _data["reason"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DisabledFilterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DisabledFilterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["reason"] = this.reason;
        data["message"] = this.message;
        return data;
    }
}

export interface IDisabledFilterInfo {
    filter: string | undefined;
    reason: string | undefined;
    message: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    id!: number;
    documentName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    versionNumber!: string | undefined;
    isLatest!: boolean;
    isTemplate!: boolean;
    uploadDate!: DateTime;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    uploadedBy!: string | undefined;
    templateStatus!: TemplateStatus;
    documentType!: TicketHolderDocumentType;
    languageId!: number | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.versionNumber = _data["versionNumber"];
            this.isLatest = _data["isLatest"];
            this.isTemplate = _data["isTemplate"];
            this.uploadDate = _data["uploadDate"] ? DateTime.fromISO(_data["uploadDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.uploadedBy = _data["uploadedBy"];
            this.templateStatus = _data["templateStatus"];
            this.documentType = _data["documentType"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["versionNumber"] = this.versionNumber;
        data["isLatest"] = this.isLatest;
        data["isTemplate"] = this.isTemplate;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["uploadedBy"] = this.uploadedBy;
        data["templateStatus"] = this.templateStatus;
        data["documentType"] = this.documentType;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IDocumentDto {
    id: number;
    documentName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    versionNumber: string | undefined;
    isLatest: boolean;
    isTemplate: boolean;
    uploadDate: DateTime;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    uploadedBy: string | undefined;
    templateStatus: TemplateStatus;
    documentType: TicketHolderDocumentType;
    languageId: number | undefined;
}

export class DocumentFormGroupDto implements IDocumentFormGroupDto {
    groupName!: string | undefined;
    forms!: DocumentFormTemplateResponseDto[] | undefined;

    constructor(data?: IDocumentFormGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(DocumentFormTemplateResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentFormGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFormGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentFormGroupDto {
    groupName: string | undefined;
    forms: DocumentFormTemplateResponseDto[] | undefined;
}

export class DocumentFormTemplateResponseDto implements IDocumentFormTemplateResponseDto {
    id!: number;
    formId!: string | undefined;
    formName!: string | undefined;
    description!: string | undefined;
    documentId!: number | undefined;
    fileName!: string | undefined;
    templateStatus!: TemplateStatus;
    enumDisplayTemplateStatus!: string | undefined;
    documentType!: TicketHolderDocumentType;
    formsType!: TTWFormsType;
    enumDisplayFormType!: string | undefined;
    enumDisplayDocumentType!: string | undefined;
    fileInfo!: DocumentResponseDto;
    fields!: SaveDocumentTemplateFieldDto[] | undefined;

    constructor(data?: IDocumentFormTemplateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.description = _data["description"];
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
            this.templateStatus = _data["templateStatus"];
            this.enumDisplayTemplateStatus = _data["enumDisplayTemplateStatus"];
            this.documentType = _data["documentType"];
            this.formsType = _data["formsType"];
            this.enumDisplayFormType = _data["enumDisplayFormType"];
            this.enumDisplayDocumentType = _data["enumDisplayDocumentType"];
            this.fileInfo = _data["fileInfo"] ? DocumentResponseDto.fromJS(_data["fileInfo"]) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SaveDocumentTemplateFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentFormTemplateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFormTemplateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["description"] = this.description;
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["templateStatus"] = this.templateStatus;
        data["enumDisplayTemplateStatus"] = this.enumDisplayTemplateStatus;
        data["documentType"] = this.documentType;
        data["formsType"] = this.formsType;
        data["enumDisplayFormType"] = this.enumDisplayFormType;
        data["enumDisplayDocumentType"] = this.enumDisplayDocumentType;
        data["fileInfo"] = this.fileInfo ? this.fileInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentFormTemplateResponseDto {
    id: number;
    formId: string | undefined;
    formName: string | undefined;
    description: string | undefined;
    documentId: number | undefined;
    fileName: string | undefined;
    templateStatus: TemplateStatus;
    enumDisplayTemplateStatus: string | undefined;
    documentType: TicketHolderDocumentType;
    formsType: TTWFormsType;
    enumDisplayFormType: string | undefined;
    enumDisplayDocumentType: string | undefined;
    fileInfo: DocumentResponseDto;
    fields: SaveDocumentTemplateFieldDto[] | undefined;
}

export class DocumentResponseDto implements IDocumentResponseDto {
    fileName!: string | undefined;
    fileData!: string | undefined;
    documentId!: number | undefined;
    fileType!: string | undefined;
    fileSize!: string | undefined;
    uploadedAt!: DateTime;
    uploadedBy!: string | undefined;

    constructor(data?: IDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.documentId = _data["documentId"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.uploadedAt = _data["uploadedAt"] ? DateTime.fromISO(_data["uploadedAt"].toString()) : <any>undefined;
            this.uploadedBy = _data["uploadedBy"];
        }
    }

    static fromJS(data: any): DocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["documentId"] = this.documentId;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toString() : <any>undefined;
        data["uploadedBy"] = this.uploadedBy;
        return data;
    }
}

export interface IDocumentResponseDto {
    fileName: string | undefined;
    fileData: string | undefined;
    documentId: number | undefined;
    fileType: string | undefined;
    fileSize: string | undefined;
    uploadedAt: DateTime;
    uploadedBy: string | undefined;
}

export class DocumentShareLinkDto implements IDocumentShareLinkDto {
    id!: number;
    documentId!: number;
    shareUrl!: string | undefined;
    passcode!: string | undefined;
    status!: DocumentShareLinkStatus;
    expiresAt!: DateTime;
    creationTime!: DateTime;
    generatedByName!: string | undefined;
    failedAttemptCount!: number;
    consumedAt!: DateTime | undefined;
    emailSentAt!: DateTime | undefined;
    emailSentToAddress!: string | undefined;
    revokedAt!: DateTime | undefined;

    constructor(data?: IDocumentShareLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.shareUrl = _data["shareUrl"];
            this.passcode = _data["passcode"];
            this.status = _data["status"];
            this.expiresAt = _data["expiresAt"] ? DateTime.fromISO(_data["expiresAt"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.generatedByName = _data["generatedByName"];
            this.failedAttemptCount = _data["failedAttemptCount"];
            this.consumedAt = _data["consumedAt"] ? DateTime.fromISO(_data["consumedAt"].toString()) : <any>undefined;
            this.emailSentAt = _data["emailSentAt"] ? DateTime.fromISO(_data["emailSentAt"].toString()) : <any>undefined;
            this.emailSentToAddress = _data["emailSentToAddress"];
            this.revokedAt = _data["revokedAt"] ? DateTime.fromISO(_data["revokedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentShareLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentShareLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["shareUrl"] = this.shareUrl;
        data["passcode"] = this.passcode;
        data["status"] = this.status;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["generatedByName"] = this.generatedByName;
        data["failedAttemptCount"] = this.failedAttemptCount;
        data["consumedAt"] = this.consumedAt ? this.consumedAt.toString() : <any>undefined;
        data["emailSentAt"] = this.emailSentAt ? this.emailSentAt.toString() : <any>undefined;
        data["emailSentToAddress"] = this.emailSentToAddress;
        data["revokedAt"] = this.revokedAt ? this.revokedAt.toString() : <any>undefined;
        return data;
    }
}

export interface IDocumentShareLinkDto {
    id: number;
    documentId: number;
    shareUrl: string | undefined;
    passcode: string | undefined;
    status: DocumentShareLinkStatus;
    expiresAt: DateTime;
    creationTime: DateTime;
    generatedByName: string | undefined;
    failedAttemptCount: number;
    consumedAt: DateTime | undefined;
    emailSentAt: DateTime | undefined;
    emailSentToAddress: string | undefined;
    revokedAt: DateTime | undefined;
}

export enum DocumentShareLinkStatus {
    Active = 1,
    Expired = 2,
    Consumed = 3,
    Revoked = 4,
    Locked = 5,
}

export class DocumentStreamResponseDto implements IDocumentStreamResponseDto {
    fileType!: string | undefined;
    fileName!: string | undefined;
    fileSize!: string | undefined;
    uploadedAt!: DateTime;
    uploadedBy!: string | undefined;

    constructor(data?: IDocumentStreamResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.uploadedAt = _data["uploadedAt"] ? DateTime.fromISO(_data["uploadedAt"].toString()) : <any>undefined;
            this.uploadedBy = _data["uploadedBy"];
        }
    }

    static fromJS(data: any): DocumentStreamResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentStreamResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toString() : <any>undefined;
        data["uploadedBy"] = this.uploadedBy;
        return data;
    }
}

export interface IDocumentStreamResponseDto {
    fileType: string | undefined;
    fileName: string | undefined;
    fileSize: string | undefined;
    uploadedAt: DateTime;
    uploadedBy: string | undefined;
}

export class DocumentTemplateDetailsDto implements IDocumentTemplateDetailsDto {
    id!: number;
    templateId!: number;
    languageId!: number | undefined;
    subject!: string | undefined;
    bodyContent!: string;
    isBodyHtml!: boolean;
    attachmentDocumentIds!: number[] | undefined;
    compositeTemplateKey!: string | undefined;

    constructor(data?: IDocumentTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateId = _data["templateId"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
            if (Array.isArray(_data["attachmentDocumentIds"])) {
                this.attachmentDocumentIds = [] as any;
                for (let item of _data["attachmentDocumentIds"])
                    this.attachmentDocumentIds!.push(item);
            }
            this.compositeTemplateKey = _data["compositeTemplateKey"];
        }
    }

    static fromJS(data: any): DocumentTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateId"] = this.templateId;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        if (Array.isArray(this.attachmentDocumentIds)) {
            data["attachmentDocumentIds"] = [];
            for (let item of this.attachmentDocumentIds)
                data["attachmentDocumentIds"].push(item);
        }
        data["compositeTemplateKey"] = this.compositeTemplateKey;
        return data;
    }
}

export interface IDocumentTemplateDetailsDto {
    id: number;
    templateId: number;
    languageId: number | undefined;
    subject: string | undefined;
    bodyContent: string;
    isBodyHtml: boolean;
    attachmentDocumentIds: number[] | undefined;
    compositeTemplateKey: string | undefined;
}

export class DocumentTemplateDto implements IDocumentTemplateDto {
    id!: number;
    templateName!: string;
    clientType!: ClientType;
    type!: TicketHolderDocumentType;
    status!: TemplateStatus;
    createdDate!: DateTime;
    createdBy!: string | undefined;
    subject!: string | undefined;
    documentTemplateDetails!: DocumentTemplateDetailsDto;

    constructor(data?: IDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.clientType = _data["clientType"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? DateTime.fromISO(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.subject = _data["subject"];
            this.documentTemplateDetails = _data["documentTemplateDetails"] ? DocumentTemplateDetailsDto.fromJS(_data["documentTemplateDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["clientType"] = this.clientType;
        data["type"] = this.type;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["subject"] = this.subject;
        data["documentTemplateDetails"] = this.documentTemplateDetails ? this.documentTemplateDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentTemplateDto {
    id: number;
    templateName: string;
    clientType: ClientType;
    type: TicketHolderDocumentType;
    status: TemplateStatus;
    createdDate: DateTime;
    createdBy: string | undefined;
    subject: string | undefined;
    documentTemplateDetails: DocumentTemplateDetailsDto;
}

export class DocumentTemplateFilter implements IDocumentTemplateFilter {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filterText!: string | undefined;
    clientType!: ClientType[] | undefined;
    documentType!: TicketHolderDocumentType[] | undefined;
    creationStartDate!: DateTime | undefined;
    creationEndDate!: DateTime | undefined;

    constructor(data?: IDocumentTemplateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filterText = _data["filterText"];
            if (Array.isArray(_data["clientType"])) {
                this.clientType = [] as any;
                for (let item of _data["clientType"])
                    this.clientType!.push(item);
            }
            if (Array.isArray(_data["documentType"])) {
                this.documentType = [] as any;
                for (let item of _data["documentType"])
                    this.documentType!.push(item);
            }
            this.creationStartDate = _data["creationStartDate"] ? DateTime.fromISO(_data["creationStartDate"].toString()) : <any>undefined;
            this.creationEndDate = _data["creationEndDate"] ? DateTime.fromISO(_data["creationEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTemplateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filterText"] = this.filterText;
        if (Array.isArray(this.clientType)) {
            data["clientType"] = [];
            for (let item of this.clientType)
                data["clientType"].push(item);
        }
        if (Array.isArray(this.documentType)) {
            data["documentType"] = [];
            for (let item of this.documentType)
                data["documentType"].push(item);
        }
        data["creationStartDate"] = this.creationStartDate ? this.creationStartDate.toString() : <any>undefined;
        data["creationEndDate"] = this.creationEndDate ? this.creationEndDate.toString() : <any>undefined;
        return data;
    }
}

export interface IDocumentTemplateFilter {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filterText: string | undefined;
    clientType: ClientType[] | undefined;
    documentType: TicketHolderDocumentType[] | undefined;
    creationStartDate: DateTime | undefined;
    creationEndDate: DateTime | undefined;
}

export class DocumentTemplateLanguageDto implements IDocumentTemplateLanguageDto {
    id!: number;
    displayName!: string;
    englishName!: string;
    languageCode!: string | undefined;
    isTranslated!: boolean;

    constructor(data?: IDocumentTemplateLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.englishName = _data["englishName"];
            this.languageCode = _data["languageCode"];
            this.isTranslated = _data["isTranslated"];
        }
    }

    static fromJS(data: any): DocumentTemplateLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["englishName"] = this.englishName;
        data["languageCode"] = this.languageCode;
        data["isTranslated"] = this.isTranslated;
        return data;
    }
}

export interface IDocumentTemplateLanguageDto {
    id: number;
    displayName: string;
    englishName: string;
    languageCode: string | undefined;
    isTranslated: boolean;
}

export enum DocumentType {
    Lead = 1,
    Paystub = 2,
    EmailTemplate = 3,
    SMSTemplate = 4,
    OSM = 5,
    Unknown = 6,
}

export class DurationModalityDto implements IDurationModalityDto {
    iwpId!: number;
    workStatus!: WorkStatus;
    hasHighSchoolDiplomaOrEquivalent!: boolean | undefined;
    hasPostSecondaryEducation!: boolean | undefined;
    postSecondaryEducationDescription!: string | undefined;
    hasDriversLicense!: boolean | undefined;
    isJusticeInvolved!: boolean | undefined;
    benefitType!: BenefitType;

    constructor(data?: IDurationModalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.workStatus = _data["workStatus"];
            this.hasHighSchoolDiplomaOrEquivalent = _data["hasHighSchoolDiplomaOrEquivalent"];
            this.hasPostSecondaryEducation = _data["hasPostSecondaryEducation"];
            this.postSecondaryEducationDescription = _data["postSecondaryEducationDescription"];
            this.hasDriversLicense = _data["hasDriversLicense"];
            this.isJusticeInvolved = _data["isJusticeInvolved"];
            this.benefitType = _data["benefitType"];
        }
    }

    static fromJS(data: any): DurationModalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationModalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["workStatus"] = this.workStatus;
        data["hasHighSchoolDiplomaOrEquivalent"] = this.hasHighSchoolDiplomaOrEquivalent;
        data["hasPostSecondaryEducation"] = this.hasPostSecondaryEducation;
        data["postSecondaryEducationDescription"] = this.postSecondaryEducationDescription;
        data["hasDriversLicense"] = this.hasDriversLicense;
        data["isJusticeInvolved"] = this.isJusticeInvolved;
        data["benefitType"] = this.benefitType;
        return data;
    }
}

export interface IDurationModalityDto {
    iwpId: number;
    workStatus: WorkStatus;
    hasHighSchoolDiplomaOrEquivalent: boolean | undefined;
    hasPostSecondaryEducation: boolean | undefined;
    postSecondaryEducationDescription: string | undefined;
    hasDriversLicense: boolean | undefined;
    isJusticeInvolved: boolean | undefined;
    benefitType: BenefitType;
}

export class DynamicEntityPropertyDto implements IDynamicEntityPropertyDto {
    id!: number;
    entityFullName!: string | undefined;
    dynamicPropertyName!: string | undefined;
    dynamicPropertyId!: number;
    tenantId!: number | undefined;

    constructor(data?: IDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityFullName = _data["entityFullName"];
            this.dynamicPropertyName = _data["dynamicPropertyName"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityFullName"] = this.entityFullName;
        data["dynamicPropertyName"] = this.dynamicPropertyName;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IDynamicEntityPropertyDto {
    id: number;
    entityFullName: string | undefined;
    dynamicPropertyName: string | undefined;
    dynamicPropertyId: number;
    tenantId: number | undefined;
}

export class DynamicEntityPropertyValueDto implements IDynamicEntityPropertyValueDto {
    id!: number;
    value!: string | undefined;
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;

    constructor(data?: IDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        return data;
    }
}

export interface IDynamicEntityPropertyValueDto {
    id: number;
    value: string | undefined;
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
}

export class DynamicPropertyDto implements IDynamicPropertyDto {
    id!: number;
    propertyName!: string | undefined;
    displayName!: string | undefined;
    inputType!: string | undefined;
    permission!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyName = _data["propertyName"];
            this.displayName = _data["displayName"];
            this.inputType = _data["inputType"];
            this.permission = _data["permission"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): DynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyName"] = this.propertyName;
        data["displayName"] = this.displayName;
        data["inputType"] = this.inputType;
        data["permission"] = this.permission;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IDynamicPropertyDto {
    id: number;
    propertyName: string | undefined;
    displayName: string | undefined;
    inputType: string | undefined;
    permission: string | undefined;
    tenantId: number | undefined;
}

export class DynamicPropertyValueDto implements IDynamicPropertyValueDto {
    id!: number;
    value!: string | undefined;
    tenantId!: number | undefined;
    dynamicPropertyId!: number;

    constructor(data?: IDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
        }
    }

    static fromJS(data: any): DynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        return data;
    }
}

export interface IDynamicPropertyValueDto {
    id: number;
    value: string | undefined;
    tenantId: number | undefined;
    dynamicPropertyId: number;
}

export class ENSettingDto implements IENSettingDto {
    id!: number;
    name!: string | undefined;
    pid!: string | undefined;
    address!: string | undefined;
    telePhone!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    ssaFax!: string | undefined;
    enSignatureDocumentId!: number | undefined;
    hasSSALogin!: boolean;
    hasServiceProvider!: boolean;
    serviceProviderName!: string | undefined;
    readonly eligibilityNotificationEmailList!: string[] | undefined;

    constructor(data?: IENSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pid = _data["pid"];
            this.address = _data["address"];
            this.telePhone = _data["telePhone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.ssaFax = _data["ssaFax"];
            this.enSignatureDocumentId = _data["enSignatureDocumentId"];
            this.hasSSALogin = _data["hasSSALogin"];
            this.hasServiceProvider = _data["hasServiceProvider"];
            this.serviceProviderName = _data["serviceProviderName"];
            if (Array.isArray(_data["eligibilityNotificationEmailList"])) {
                (<any>this).eligibilityNotificationEmailList = [] as any;
                for (let item of _data["eligibilityNotificationEmailList"])
                    (<any>this).eligibilityNotificationEmailList!.push(item);
            }
        }
    }

    static fromJS(data: any): ENSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ENSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pid"] = this.pid;
        data["address"] = this.address;
        data["telePhone"] = this.telePhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["ssaFax"] = this.ssaFax;
        data["enSignatureDocumentId"] = this.enSignatureDocumentId;
        data["hasSSALogin"] = this.hasSSALogin;
        data["hasServiceProvider"] = this.hasServiceProvider;
        data["serviceProviderName"] = this.serviceProviderName;
        if (Array.isArray(this.eligibilityNotificationEmailList)) {
            data["eligibilityNotificationEmailList"] = [];
            for (let item of this.eligibilityNotificationEmailList)
                data["eligibilityNotificationEmailList"].push(item);
        }
        return data;
    }
}

export interface IENSettingDto {
    id: number;
    name: string | undefined;
    pid: string | undefined;
    address: string | undefined;
    telePhone: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    ssaFax: string | undefined;
    enSignatureDocumentId: number | undefined;
    hasSSALogin: boolean;
    hasServiceProvider: boolean;
    serviceProviderName: string | undefined;
    eligibilityNotificationEmailList: string[] | undefined;
}

export class EarningsGoalDto implements IEarningsGoalDto {
    id!: number | undefined;
    goalRank!: number;
    positionType!: string | undefined;
    hoursPerWeek!: number | undefined;
    hourlyWageOrSalary!: number | undefined;
    estMonthlyEarnings!: number | undefined;

    constructor(data?: IEarningsGoalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.goalRank = _data["goalRank"];
            this.positionType = _data["positionType"];
            this.hoursPerWeek = _data["hoursPerWeek"];
            this.hourlyWageOrSalary = _data["hourlyWageOrSalary"];
            this.estMonthlyEarnings = _data["estMonthlyEarnings"];
        }
    }

    static fromJS(data: any): EarningsGoalDto {
        data = typeof data === 'object' ? data : {};
        let result = new EarningsGoalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["goalRank"] = this.goalRank;
        data["positionType"] = this.positionType;
        data["hoursPerWeek"] = this.hoursPerWeek;
        data["hourlyWageOrSalary"] = this.hourlyWageOrSalary;
        data["estMonthlyEarnings"] = this.estMonthlyEarnings;
        return data;
    }
}

export interface IEarningsGoalDto {
    id: number | undefined;
    goalRank: number;
    positionType: string | undefined;
    hoursPerWeek: number | undefined;
    hourlyWageOrSalary: number | undefined;
    estMonthlyEarnings: number | undefined;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    id!: number;
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        return data;
    }
}

export interface IEditionInfoDto {
    id: number;
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
}

export class EditionListDto implements IEditionListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        return data;
    }
}

export interface IEditionListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class EducationServiceRequestDto implements IEducationServiceRequestDto {
    id!: number;
    ticketHolderId!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    programType!: string;
    desiredEducation!: string | undefined;
    enrollmentType!: string | undefined;
    needFinancialAid!: boolean;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: IEducationServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.programType = _data["programType"];
            this.desiredEducation = _data["desiredEducation"];
            this.enrollmentType = _data["enrollmentType"];
            this.needFinancialAid = _data["needFinancialAid"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EducationServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["programType"] = this.programType;
        data["desiredEducation"] = this.desiredEducation;
        data["enrollmentType"] = this.enrollmentType;
        data["needFinancialAid"] = this.needFinancialAid;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface IEducationServiceRequestDto {
    id: number;
    ticketHolderId: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    programType: string;
    desiredEducation: string | undefined;
    enrollmentType: string | undefined;
    needFinancialAid: boolean;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class EmailCampaignStatusSummaryDto implements IEmailCampaignStatusSummaryDto {
    draft!: number;
    active!: number;
    sent!: number;
    failed!: number;
    paused!: number;
    running!: number;
    total!: number;

    constructor(data?: IEmailCampaignStatusSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draft = _data["draft"];
            this.active = _data["active"];
            this.sent = _data["sent"];
            this.failed = _data["failed"];
            this.paused = _data["paused"];
            this.running = _data["running"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): EmailCampaignStatusSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailCampaignStatusSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draft"] = this.draft;
        data["active"] = this.active;
        data["sent"] = this.sent;
        data["failed"] = this.failed;
        data["paused"] = this.paused;
        data["running"] = this.running;
        data["total"] = this.total;
        return data;
    }
}

export interface IEmailCampaignStatusSummaryDto {
    draft: number;
    active: number;
    sent: number;
    failed: number;
    paused: number;
    running: number;
    total: number;
}

export class EmailLogDetailDto implements IEmailLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachEmail!: string | undefined;
    clientName!: string | undefined;
    clientEmail!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: DocumentDto[] | undefined;
    status!: ActivityStatus;
    creationTime!: DateTime;

    constructor(data?: IEmailLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachEmail = _data["careerCoachEmail"];
            this.clientName = _data["clientName"];
            this.clientEmail = _data["clientEmail"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(DocumentDto.fromJS(item));
            }
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachEmail"] = this.careerCoachEmail;
        data["clientName"] = this.clientName;
        data["clientEmail"] = this.clientEmail;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IEmailLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachEmail: string | undefined;
    clientName: string | undefined;
    clientEmail: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: DocumentDto[] | undefined;
    status: ActivityStatus;
    creationTime: DateTime;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseAuthentication!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseAuthentication = _data["smtpUseAuthentication"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseAuthentication"] = this.smtpUseAuthentication;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseAuthentication: boolean;
}

export enum EmploymentServiceAgency {
    EmploymentNetwork = 1,
    StateVR = 2,
    OtherEmploymentServices = 3,
    AmericanJobCenter = 4,
    VocationalTraining = 5,
    YouthTransitionProgram = 6,
    Other = 7,
}

export class EmploymentServiceDto implements IEmploymentServiceDto {
    id!: number | undefined;
    agency!: EmploymentServiceAgency;
    agencyOther!: string | undefined;
    serviceDescription!: string | undefined;

    constructor(data?: IEmploymentServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agency = _data["agency"];
            this.agencyOther = _data["agencyOther"];
            this.serviceDescription = _data["serviceDescription"];
        }
    }

    static fromJS(data: any): EmploymentServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agency"] = this.agency;
        data["agencyOther"] = this.agencyOther;
        data["serviceDescription"] = this.serviceDescription;
        return data;
    }
}

export interface IEmploymentServiceDto {
    id: number | undefined;
    agency: EmploymentServiceAgency;
    agencyOther: string | undefined;
    serviceDescription: string | undefined;
}

export class EnableMarketingEventRegistrationInput implements IEnableMarketingEventRegistrationInput {
    eventId!: number;
    registrationDeadline!: DateTime | undefined;
    maxRegistrations!: number | undefined;

    constructor(data?: IEnableMarketingEventRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.registrationDeadline = _data["registrationDeadline"] ? DateTime.fromISO(_data["registrationDeadline"].toString()) : <any>undefined;
            this.maxRegistrations = _data["maxRegistrations"];
        }
    }

    static fromJS(data: any): EnableMarketingEventRegistrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new EnableMarketingEventRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["registrationDeadline"] = this.registrationDeadline ? this.registrationDeadline.toString() : <any>undefined;
        data["maxRegistrations"] = this.maxRegistrations;
        return data;
    }
}

export interface IEnableMarketingEventRegistrationInput {
    eventId: number;
    registrationDeadline: DateTime | undefined;
    maxRegistrations: number | undefined;
}

export class EncoderFallback implements IEncoderFallback {
    readonly maxCharCount!: number;

    constructor(data?: IEncoderFallback) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).maxCharCount = _data["maxCharCount"];
        }
    }

    static fromJS(data: any): EncoderFallback {
        data = typeof data === 'object' ? data : {};
        let result = new EncoderFallback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCharCount"] = this.maxCharCount;
        return data;
    }
}

export interface IEncoderFallback {
    maxCharCount: number;
}

export class Encoding implements IEncoding {
    preamble!: ReadOnlySpanOfByte;
    readonly bodyName!: string | undefined;
    readonly encodingName!: string | undefined;
    readonly headerName!: string | undefined;
    readonly webName!: string | undefined;
    readonly windowsCodePage!: number;
    readonly isBrowserDisplay!: boolean;
    readonly isBrowserSave!: boolean;
    readonly isMailNewsDisplay!: boolean;
    readonly isMailNewsSave!: boolean;
    readonly isSingleByte!: boolean;
    encoderFallback!: EncoderFallback;
    decoderFallback!: DecoderFallback;
    readonly isReadOnly!: boolean;
    readonly codePage!: number;

    constructor(data?: IEncoding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preamble = _data["preamble"] ? ReadOnlySpanOfByte.fromJS(_data["preamble"]) : <any>undefined;
            (<any>this).bodyName = _data["bodyName"];
            (<any>this).encodingName = _data["encodingName"];
            (<any>this).headerName = _data["headerName"];
            (<any>this).webName = _data["webName"];
            (<any>this).windowsCodePage = _data["windowsCodePage"];
            (<any>this).isBrowserDisplay = _data["isBrowserDisplay"];
            (<any>this).isBrowserSave = _data["isBrowserSave"];
            (<any>this).isMailNewsDisplay = _data["isMailNewsDisplay"];
            (<any>this).isMailNewsSave = _data["isMailNewsSave"];
            (<any>this).isSingleByte = _data["isSingleByte"];
            this.encoderFallback = _data["encoderFallback"] ? EncoderFallback.fromJS(_data["encoderFallback"]) : <any>undefined;
            this.decoderFallback = _data["decoderFallback"] ? DecoderFallback.fromJS(_data["decoderFallback"]) : <any>undefined;
            (<any>this).isReadOnly = _data["isReadOnly"];
            (<any>this).codePage = _data["codePage"];
        }
    }

    static fromJS(data: any): Encoding {
        data = typeof data === 'object' ? data : {};
        let result = new Encoding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preamble"] = this.preamble ? this.preamble.toJSON() : <any>undefined;
        data["bodyName"] = this.bodyName;
        data["encodingName"] = this.encodingName;
        data["headerName"] = this.headerName;
        data["webName"] = this.webName;
        data["windowsCodePage"] = this.windowsCodePage;
        data["isBrowserDisplay"] = this.isBrowserDisplay;
        data["isBrowserSave"] = this.isBrowserSave;
        data["isMailNewsDisplay"] = this.isMailNewsDisplay;
        data["isMailNewsSave"] = this.isMailNewsSave;
        data["isSingleByte"] = this.isSingleByte;
        data["encoderFallback"] = this.encoderFallback ? this.encoderFallback.toJSON() : <any>undefined;
        data["decoderFallback"] = this.decoderFallback ? this.decoderFallback.toJSON() : <any>undefined;
        data["isReadOnly"] = this.isReadOnly;
        data["codePage"] = this.codePage;
        return data;
    }
}

export interface IEncoding {
    preamble: ReadOnlySpanOfByte;
    bodyName: string | undefined;
    encodingName: string | undefined;
    headerName: string | undefined;
    webName: string | undefined;
    windowsCodePage: number;
    isBrowserDisplay: boolean;
    isBrowserSave: boolean;
    isMailNewsDisplay: boolean;
    isMailNewsSave: boolean;
    isSingleByte: boolean;
    encoderFallback: EncoderFallback;
    decoderFallback: DecoderFallback;
    isReadOnly: boolean;
    codePage: number;
}

export class EntityAndPropertyChangeListDto implements IEntityAndPropertyChangeListDto {
    entityChange!: EntityChangeListDto;
    entityPropertyChanges!: EntityPropertyChangeDto[] | undefined;

    constructor(data?: IEntityAndPropertyChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChange = _data["entityChange"] ? EntityChangeListDto.fromJS(_data["entityChange"]) : <any>undefined;
            if (Array.isArray(_data["entityPropertyChanges"])) {
                this.entityPropertyChanges = [] as any;
                for (let item of _data["entityPropertyChanges"])
                    this.entityPropertyChanges!.push(EntityPropertyChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityAndPropertyChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityAndPropertyChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChange"] = this.entityChange ? this.entityChange.toJSON() : <any>undefined;
        if (Array.isArray(this.entityPropertyChanges)) {
            data["entityPropertyChanges"] = [];
            for (let item of this.entityPropertyChanges)
                data["entityPropertyChanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntityAndPropertyChangeListDto {
    entityChange: EntityChangeListDto;
    entityPropertyChanges: EntityPropertyChangeDto[] | undefined;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    id!: number;
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    entityId!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IEntityChangeListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    entityId: number;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    id!: number;
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    id: number;
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
}

export class EnumDropdownItem implements IEnumDropdownItem {
    value!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IEnumDropdownItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EnumDropdownItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDropdownItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEnumDropdownItem {
    value: string | undefined;
    displayName: string | undefined;
}

export class EnumInfoDto implements IEnumInfoDto {
    name!: string | undefined;
    value!: number;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IEnumInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EnumInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IEnumInfoDto {
    name: string | undefined;
    value: number;
    displayName: string | undefined;
    description: string | undefined;
}

export enum EventAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
}

export class EventInfo implements IEventInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    attributes!: EventAttributes;
    readonly isSpecialName!: boolean;
    addMethod!: MethodInfo;
    removeMethod!: MethodInfo;
    raiseMethod!: MethodInfo;
    readonly isMulticast!: boolean;
    eventHandlerType!: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            (<any>this).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod: MethodInfo;
    removeMethod: MethodInfo;
    raiseMethod: MethodInfo;
    isMulticast: boolean;
    eventHandlerType: Type;
}

export class ExcludedResourceDto implements IExcludedResourceDto {
    id!: number | undefined;
    resourceType!: ExcludedResourceType;
    receiving!: boolean;
    recommended!: boolean | undefined;
    comments!: string | undefined;

    constructor(data?: IExcludedResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceType = _data["resourceType"];
            this.receiving = _data["receiving"];
            this.recommended = _data["recommended"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ExcludedResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceType"] = this.resourceType;
        data["receiving"] = this.receiving;
        data["recommended"] = this.recommended;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IExcludedResourceDto {
    id: number | undefined;
    resourceType: ExcludedResourceType;
    receiving: boolean;
    recommended: boolean | undefined;
    comments: string | undefined;
}

export enum ExcludedResourceType {
    IDA = 1,
    ABLEAccount = 2,
    Trust = 3,
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class ExternalApiConnectInfo implements IExternalApiConnectInfo {
    nameOfExternalApi!: string | undefined;
    readonly displayNameOfExternalApi!: string | undefined;
    isConnected!: boolean;
    connectedUserInfo!: ExternalApiUserInfo;

    constructor(data?: IExternalApiConnectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameOfExternalApi = _data["nameOfExternalApi"];
            (<any>this).displayNameOfExternalApi = _data["displayNameOfExternalApi"];
            this.isConnected = _data["isConnected"];
            this.connectedUserInfo = _data["connectedUserInfo"] ? ExternalApiUserInfo.fromJS(_data["connectedUserInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalApiConnectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalApiConnectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameOfExternalApi"] = this.nameOfExternalApi;
        data["displayNameOfExternalApi"] = this.displayNameOfExternalApi;
        data["isConnected"] = this.isConnected;
        data["connectedUserInfo"] = this.connectedUserInfo ? this.connectedUserInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExternalApiConnectInfo {
    nameOfExternalApi: string | undefined;
    displayNameOfExternalApi: string | undefined;
    isConnected: boolean;
    connectedUserInfo: ExternalApiUserInfo;
}

export class ExternalApiUserInfo implements IExternalApiUserInfo {
    id!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    profileImageBase64!: string | undefined;
    profileImageType!: string | undefined;
    company!: string | undefined;
    address!: string | undefined;
    grantedScopes!: string[] | undefined;

    constructor(data?: IExternalApiUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.profileImageBase64 = _data["profileImageBase64"];
            this.profileImageType = _data["profileImageType"];
            this.company = _data["company"];
            this.address = _data["address"];
            if (Array.isArray(_data["grantedScopes"])) {
                this.grantedScopes = [] as any;
                for (let item of _data["grantedScopes"])
                    this.grantedScopes!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalApiUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalApiUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["profileImageBase64"] = this.profileImageBase64;
        data["profileImageType"] = this.profileImageType;
        data["company"] = this.company;
        data["address"] = this.address;
        if (Array.isArray(this.grantedScopes)) {
            data["grantedScopes"] = [];
            for (let item of this.grantedScopes)
                data["grantedScopes"].push(item);
        }
        return data;
    }
}

export interface IExternalApiUserInfo {
    id: string | undefined;
    name: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    profileImageBase64: string | undefined;
    profileImageType: string | undefined;
    company: string | undefined;
    address: string | undefined;
    grantedScopes: string[] | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class ExternalEventSubscription implements IExternalEventSubscription {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    tenantId!: number;
    userId!: number | undefined;
    subscriptionOrChannelId!: string;
    resourceId!: string | undefined;
    serviceProvider!: UserApiTokenProvider;
    resource!: string;
    changeType!: string;
    applicationId!: string | undefined;
    channelId!: string | undefined;
    userApiTokenId!: number | undefined;
    clientState!: string | undefined;
    notificationUrl!: string;
    lifecycleNotificationUrl!: string | undefined;
    includeResourceData!: boolean;
    encryptionCertificate!: string | undefined;
    expirationDateTime!: DateTime;
    latestSupportedTlsVersion!: string | undefined;
    notificationQueryOptions!: string | undefined;
    status!: string;

    constructor(data?: IExternalEventSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.subscriptionOrChannelId = _data["subscriptionOrChannelId"];
            this.resourceId = _data["resourceId"];
            this.serviceProvider = _data["serviceProvider"];
            this.resource = _data["resource"];
            this.changeType = _data["changeType"];
            this.applicationId = _data["applicationId"];
            this.channelId = _data["channelId"];
            this.userApiTokenId = _data["userApiTokenId"];
            this.clientState = _data["clientState"];
            this.notificationUrl = _data["notificationUrl"];
            this.lifecycleNotificationUrl = _data["lifecycleNotificationUrl"];
            this.includeResourceData = _data["includeResourceData"];
            this.encryptionCertificate = _data["encryptionCertificate"];
            this.expirationDateTime = _data["expirationDateTime"] ? DateTime.fromISO(_data["expirationDateTime"].toString()) : <any>undefined;
            this.latestSupportedTlsVersion = _data["latestSupportedTlsVersion"];
            this.notificationQueryOptions = _data["notificationQueryOptions"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExternalEventSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEventSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["subscriptionOrChannelId"] = this.subscriptionOrChannelId;
        data["resourceId"] = this.resourceId;
        data["serviceProvider"] = this.serviceProvider;
        data["resource"] = this.resource;
        data["changeType"] = this.changeType;
        data["applicationId"] = this.applicationId;
        data["channelId"] = this.channelId;
        data["userApiTokenId"] = this.userApiTokenId;
        data["clientState"] = this.clientState;
        data["notificationUrl"] = this.notificationUrl;
        data["lifecycleNotificationUrl"] = this.lifecycleNotificationUrl;
        data["includeResourceData"] = this.includeResourceData;
        data["encryptionCertificate"] = this.encryptionCertificate;
        data["expirationDateTime"] = this.expirationDateTime ? this.expirationDateTime.toString() : <any>undefined;
        data["latestSupportedTlsVersion"] = this.latestSupportedTlsVersion;
        data["notificationQueryOptions"] = this.notificationQueryOptions;
        data["status"] = this.status;
        return data;
    }
}

export interface IExternalEventSubscription {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    tenantId: number;
    userId: number | undefined;
    subscriptionOrChannelId: string;
    resourceId: string | undefined;
    serviceProvider: UserApiTokenProvider;
    resource: string;
    changeType: string;
    applicationId: string | undefined;
    channelId: string | undefined;
    userApiTokenId: number | undefined;
    clientState: string | undefined;
    notificationUrl: string;
    lifecycleNotificationUrl: string | undefined;
    includeResourceData: boolean;
    encryptionCertificate: string | undefined;
    expirationDateTime: DateTime;
    latestSupportedTlsVersion: string | undefined;
    notificationQueryOptions: string | undefined;
    status: string;
}

export class ExternalEventSubscriptionDto implements IExternalEventSubscriptionDto {
    id!: number;
    serviceProvider!: number;
    providerName!: string | undefined;
    channel!: string | undefined;
    resource!: string | undefined;
    subscriptionId!: string | undefined;
    notificationUrl!: string | undefined;
    status!: string | undefined;
    expirationDateTime!: DateTime;
    creationTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    isHealthy!: boolean;
    minutesToExpiry!: number | undefined;
    userId!: number | undefined;
    lastEventReceivedUtc!: DateTime | undefined;
    healthState!: string | undefined;
    healthReason!: string | undefined;
    lastErrorUtc!: DateTime | undefined;
    lastErrorMessage!: string | undefined;
    recentErrorCount!: number;

    constructor(data?: IExternalEventSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceProvider = _data["serviceProvider"];
            this.providerName = _data["providerName"];
            this.channel = _data["channel"];
            this.resource = _data["resource"];
            this.subscriptionId = _data["subscriptionId"];
            this.notificationUrl = _data["notificationUrl"];
            this.status = _data["status"];
            this.expirationDateTime = _data["expirationDateTime"] ? DateTime.fromISO(_data["expirationDateTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isHealthy = _data["isHealthy"];
            this.minutesToExpiry = _data["minutesToExpiry"];
            this.userId = _data["userId"];
            this.lastEventReceivedUtc = _data["lastEventReceivedUtc"] ? DateTime.fromISO(_data["lastEventReceivedUtc"].toString()) : <any>undefined;
            this.healthState = _data["healthState"];
            this.healthReason = _data["healthReason"];
            this.lastErrorUtc = _data["lastErrorUtc"] ? DateTime.fromISO(_data["lastErrorUtc"].toString()) : <any>undefined;
            this.lastErrorMessage = _data["lastErrorMessage"];
            this.recentErrorCount = _data["recentErrorCount"];
        }
    }

    static fromJS(data: any): ExternalEventSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEventSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceProvider"] = this.serviceProvider;
        data["providerName"] = this.providerName;
        data["channel"] = this.channel;
        data["resource"] = this.resource;
        data["subscriptionId"] = this.subscriptionId;
        data["notificationUrl"] = this.notificationUrl;
        data["status"] = this.status;
        data["expirationDateTime"] = this.expirationDateTime ? this.expirationDateTime.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["isHealthy"] = this.isHealthy;
        data["minutesToExpiry"] = this.minutesToExpiry;
        data["userId"] = this.userId;
        data["lastEventReceivedUtc"] = this.lastEventReceivedUtc ? this.lastEventReceivedUtc.toString() : <any>undefined;
        data["healthState"] = this.healthState;
        data["healthReason"] = this.healthReason;
        data["lastErrorUtc"] = this.lastErrorUtc ? this.lastErrorUtc.toString() : <any>undefined;
        data["lastErrorMessage"] = this.lastErrorMessage;
        data["recentErrorCount"] = this.recentErrorCount;
        return data;
    }
}

export interface IExternalEventSubscriptionDto {
    id: number;
    serviceProvider: number;
    providerName: string | undefined;
    channel: string | undefined;
    resource: string | undefined;
    subscriptionId: string | undefined;
    notificationUrl: string | undefined;
    status: string | undefined;
    expirationDateTime: DateTime;
    creationTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    isHealthy: boolean;
    minutesToExpiry: number | undefined;
    userId: number | undefined;
    lastEventReceivedUtc: DateTime | undefined;
    healthState: string | undefined;
    healthReason: string | undefined;
    lastErrorUtc: DateTime | undefined;
    lastErrorMessage: string | undefined;
    recentErrorCount: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : <any>undefined;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item.toJSON());
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export class ExtractIWPDto implements IExtractIWPDto {
    benefitType!: BenefitType;
    enrollmentCompletedDate!: DateTime | undefined;
    iwpInfo!: IWPDdto;
    iwpSectionOne!: IWPSectionOneDto;
    iwpSectionTwo!: IWPSectionTwoDto[] | undefined;
    iwpSectionThree!: IWPSectionThreeDto;
    iwpSectionFour!: IWPSectionFourDto;

    constructor(data?: IExtractIWPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitType = _data["benefitType"];
            this.enrollmentCompletedDate = _data["enrollmentCompletedDate"] ? DateTime.fromISO(_data["enrollmentCompletedDate"].toString()) : <any>undefined;
            this.iwpInfo = _data["iwpInfo"] ? IWPDdto.fromJS(_data["iwpInfo"]) : <any>undefined;
            this.iwpSectionOne = _data["iwpSectionOne"] ? IWPSectionOneDto.fromJS(_data["iwpSectionOne"]) : <any>undefined;
            if (Array.isArray(_data["iwpSectionTwo"])) {
                this.iwpSectionTwo = [] as any;
                for (let item of _data["iwpSectionTwo"])
                    this.iwpSectionTwo!.push(IWPSectionTwoDto.fromJS(item));
            }
            this.iwpSectionThree = _data["iwpSectionThree"] ? IWPSectionThreeDto.fromJS(_data["iwpSectionThree"]) : <any>undefined;
            this.iwpSectionFour = _data["iwpSectionFour"] ? IWPSectionFourDto.fromJS(_data["iwpSectionFour"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtractIWPDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractIWPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitType"] = this.benefitType;
        data["enrollmentCompletedDate"] = this.enrollmentCompletedDate ? this.enrollmentCompletedDate.toString() : <any>undefined;
        data["iwpInfo"] = this.iwpInfo ? this.iwpInfo.toJSON() : <any>undefined;
        data["iwpSectionOne"] = this.iwpSectionOne ? this.iwpSectionOne.toJSON() : <any>undefined;
        if (Array.isArray(this.iwpSectionTwo)) {
            data["iwpSectionTwo"] = [];
            for (let item of this.iwpSectionTwo)
                data["iwpSectionTwo"].push(item.toJSON());
        }
        data["iwpSectionThree"] = this.iwpSectionThree ? this.iwpSectionThree.toJSON() : <any>undefined;
        data["iwpSectionFour"] = this.iwpSectionFour ? this.iwpSectionFour.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtractIWPDto {
    benefitType: BenefitType;
    enrollmentCompletedDate: DateTime | undefined;
    iwpInfo: IWPDdto;
    iwpSectionOne: IWPSectionOneDto;
    iwpSectionTwo: IWPSectionTwoDto[] | undefined;
    iwpSectionThree: IWPSectionThreeDto;
    iwpSectionFour: IWPSectionFourDto;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class FailedTaskDto implements IFailedTaskDto {
    instanceId!: number;
    taskId!: number;
    taskName!: string | undefined;
    errorMessage!: string | undefined;
    endTime!: DateTime | undefined;

    constructor(data?: IFailedTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.errorMessage = _data["errorMessage"];
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FailedTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new FailedTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["errorMessage"] = this.errorMessage;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface IFailedTaskDto {
    instanceId: number;
    taskId: number;
    taskName: string | undefined;
    errorMessage: string | undefined;
    endTime: DateTime | undefined;
}

export class FaxLogDetailDto implements IFaxLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientFaxNumber!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: DocumentDto[] | undefined;
    status!: ActivityStatus;

    constructor(data?: IFaxLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientFaxNumber = _data["clientFaxNumber"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(DocumentDto.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FaxLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaxLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientFaxNumber"] = this.clientFaxNumber;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IFaxLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientFaxNumber: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: DocumentDto[] | undefined;
    status: ActivityStatus;
}

export enum FaxRecipientType {
    Unknown = 0,
    Lead = 1,
    TicketHolder = 2,
    SSAOffice = 3,
}

export class FaxResponse implements IFaxResponse {
    id!: number | undefined;
    uri!: string | undefined;
    type!: string | undefined;
    from!: MessageStoreCallerInfoResponseFrom;
    to!: FaxResponseTo[] | undefined;
    creationTime!: string | undefined;
    readStatus!: string | undefined;
    priority!: string | undefined;
    attachments!: MessageAttachmentInfoIntId[] | undefined;
    direction!: string | undefined;
    availability!: string | undefined;
    messageStatus!: string | undefined;
    faxResolution!: string | undefined;
    faxPageCount!: number | undefined;
    lastModifiedTime!: string | undefined;
    coverIndex!: number | undefined;
    coverPageText!: string | undefined;

    constructor(data?: IFaxResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.type = _data["type"];
            this.from = _data["from"] ? MessageStoreCallerInfoResponseFrom.fromJS(_data["from"]) : <any>undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(FaxResponseTo.fromJS(item));
            }
            this.creationTime = _data["creationTime"];
            this.readStatus = _data["readStatus"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(MessageAttachmentInfoIntId.fromJS(item));
            }
            this.direction = _data["direction"];
            this.availability = _data["availability"];
            this.messageStatus = _data["messageStatus"];
            this.faxResolution = _data["faxResolution"];
            this.faxPageCount = _data["faxPageCount"];
            this.lastModifiedTime = _data["lastModifiedTime"];
            this.coverIndex = _data["coverIndex"];
            this.coverPageText = _data["coverPageText"];
        }
    }

    static fromJS(data: any): FaxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FaxResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["type"] = this.type;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime;
        data["readStatus"] = this.readStatus;
        data["priority"] = this.priority;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["direction"] = this.direction;
        data["availability"] = this.availability;
        data["messageStatus"] = this.messageStatus;
        data["faxResolution"] = this.faxResolution;
        data["faxPageCount"] = this.faxPageCount;
        data["lastModifiedTime"] = this.lastModifiedTime;
        data["coverIndex"] = this.coverIndex;
        data["coverPageText"] = this.coverPageText;
        return data;
    }
}

export interface IFaxResponse {
    id: number | undefined;
    uri: string | undefined;
    type: string | undefined;
    from: MessageStoreCallerInfoResponseFrom;
    to: FaxResponseTo[] | undefined;
    creationTime: string | undefined;
    readStatus: string | undefined;
    priority: string | undefined;
    attachments: MessageAttachmentInfoIntId[] | undefined;
    direction: string | undefined;
    availability: string | undefined;
    messageStatus: string | undefined;
    faxResolution: string | undefined;
    faxPageCount: number | undefined;
    lastModifiedTime: string | undefined;
    coverIndex: number | undefined;
    coverPageText: string | undefined;
}

export class FaxResponseTo implements IFaxResponseTo {
    recipientId!: string | undefined;
    phoneNumber!: string | undefined;
    name!: string | undefined;
    messageStatus!: string | undefined;
    location!: string | undefined;

    constructor(data?: IFaxResponseTo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.phoneNumber = _data["phoneNumber"];
            this.name = _data["name"];
            this.messageStatus = _data["messageStatus"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): FaxResponseTo {
        data = typeof data === 'object' ? data : {};
        let result = new FaxResponseTo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["phoneNumber"] = this.phoneNumber;
        data["name"] = this.name;
        data["messageStatus"] = this.messageStatus;
        data["location"] = this.location;
        return data;
    }
}

export interface IFaxResponseTo {
    recipientId: string | undefined;
    phoneNumber: string | undefined;
    name: string | undefined;
    messageStatus: string | undefined;
    location: string | undefined;
}

export class FaxSummaryDto implements IFaxSummaryDto {
    totalAttempts!: number;
    lastFaxedAt!: DateTime | undefined;

    constructor(data?: IFaxSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAttempts = _data["totalAttempts"];
            this.lastFaxedAt = _data["lastFaxedAt"] ? DateTime.fromISO(_data["lastFaxedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FaxSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaxSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAttempts"] = this.totalAttempts;
        data["lastFaxedAt"] = this.lastFaxedAt ? this.lastFaxedAt.toString() : <any>undefined;
        return data;
    }
}

export interface IFaxSummaryDto {
    totalAttempts: number;
    lastFaxedAt: DateTime | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export enum FieldAttributes {
    PrivateScope = 0,
    Private = 1,
    FamANDAssem = 2,
    Assembly = 3,
    Family = 4,
    FamORAssem = 5,
    Public = 6,
    FieldAccessMask = 7,
    Static = 16,
    InitOnly = 32,
    Literal = 64,
    NotSerialized = 128,
    HasFieldRVA = 256,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasFieldMarshal = 4096,
    PinvokeImpl = 8192,
    HasDefault = 32768,
    ReservedMask = 38144,
}

export class FieldHelpDto implements IFieldHelpDto {
    fieldName!: string | undefined;
    helpText!: string | undefined;

    constructor(data?: IFieldHelpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.helpText = _data["helpText"];
        }
    }

    static fromJS(data: any): FieldHelpDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldHelpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["helpText"] = this.helpText;
        return data;
    }
}

export interface IFieldHelpDto {
    fieldName: string | undefined;
    helpText: string | undefined;
}

export class FieldInfo implements IFieldInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    attributes!: FieldAttributes;
    fieldType!: Type;
    readonly isInitOnly!: boolean;
    readonly isLiteral!: boolean;
    readonly isNotSerialized!: boolean;
    readonly isPinvokeImpl!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    fieldHandle!: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : <any>undefined;
            (<any>this).isInitOnly = _data["isInitOnly"];
            (<any>this).isLiteral = _data["isLiteral"];
            (<any>this).isNotSerialized = _data["isNotSerialized"];
            (<any>this).isPinvokeImpl = _data["isPinvokeImpl"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export class FileBase64Dto implements IFileBase64Dto {
    fileName!: string | undefined;
    base64!: string | undefined;

    constructor(data?: IFileBase64Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): FileBase64Dto {
        data = typeof data === 'object' ? data : {};
        let result = new FileBase64Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["base64"] = this.base64;
        return data;
    }
}

export interface IFileBase64Dto {
    fileName: string | undefined;
    base64: string | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;
    organizationUnitId!: number;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;
    organizationUnitId!: number;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersOutputDto implements IFindOrganizationUnitUsersOutputDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IFindOrganizationUnitUsersOutputDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        return data;
    }
}

export interface IFindUsersInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
}

export class FindUsersOutputDto implements IFindUsersOutputDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IFindUsersOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): FindUsersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IFindUsersOutputDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;
    level!: number;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        data["level"] = this.level;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
    level: number;
}

export enum FollowupType {
    PhoneCall = 1,
    Email = 2,
    SMS = 3,
    OnlineMeeting = 4,
    Others = 5,
}

export class FormDto implements IFormDto {
    form!: string | undefined;
    formNumber!: string | undefined;
    formName!: string | undefined;
    url!: string | undefined;

    constructor(data?: IFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"];
            this.formNumber = _data["formNumber"];
            this.formName = _data["formName"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form;
        data["formNumber"] = this.formNumber;
        data["formName"] = this.formName;
        data["url"] = this.url;
        return data;
    }
}

export interface IFormDto {
    form: string | undefined;
    formNumber: string | undefined;
    formName: string | undefined;
    url: string | undefined;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class GeTHUpcomingAppointmentDto implements IGeTHUpcomingAppointmentDto {
    id!: number;
    title!: string | undefined;
    notes!: string | undefined;
    startDate!: DateTime;
    dueDate!: DateTime | undefined;
    status!: CalendarEventStatus;
    enumStatusValue!: string | undefined;
    followupType!: FollowupType;
    enumFollowUpTypeValue!: string | undefined;
    assignedToUserId!: number | undefined;
    createdBy!: string | undefined;
    interviewDetails!: InterviewDetailsDto;

    constructor(data?: IGeTHUpcomingAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.notes = _data["notes"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.enumStatusValue = _data["enumStatusValue"];
            this.followupType = _data["followupType"];
            this.enumFollowUpTypeValue = _data["enumFollowUpTypeValue"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.createdBy = _data["createdBy"];
            this.interviewDetails = _data["interviewDetails"] ? InterviewDetailsDto.fromJS(_data["interviewDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeTHUpcomingAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeTHUpcomingAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["notes"] = this.notes;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["status"] = this.status;
        data["enumStatusValue"] = this.enumStatusValue;
        data["followupType"] = this.followupType;
        data["enumFollowUpTypeValue"] = this.enumFollowUpTypeValue;
        data["assignedToUserId"] = this.assignedToUserId;
        data["createdBy"] = this.createdBy;
        data["interviewDetails"] = this.interviewDetails ? this.interviewDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeTHUpcomingAppointmentDto {
    id: number;
    title: string | undefined;
    notes: string | undefined;
    startDate: DateTime;
    dueDate: DateTime | undefined;
    status: CalendarEventStatus;
    enumStatusValue: string | undefined;
    followupType: FollowupType;
    enumFollowUpTypeValue: string | undefined;
    assignedToUserId: number | undefined;
    createdBy: string | undefined;
    interviewDetails: InterviewDetailsDto;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class GenerateGoogleAuthenticatorKeyOutput implements IGenerateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;
    googleAuthenticatorKey!: string | undefined;

    constructor(data?: IGenerateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
        }
    }

    static fromJS(data: any): GenerateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        return data;
    }
}

export interface IGenerateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
    googleAuthenticatorKey: string | undefined;
}

export class GenerateIwpSectionsInput implements IGenerateIwpSectionsInput {
    name!: string;
    stOccupationType!: string;
    stPositionAndCompany!: string | undefined;
    stExpectedStartDate!: string | undefined;
    stWeeklyWorkHours!: string;
    stAnticipatedWages!: string;
    stEducationTrainingPlans!: string | undefined;
    stTransitionStatement!: string | undefined;
    skillsToDevelop!: string | undefined;
    accommodationNeeds!: string | undefined;
    ltOccupationType!: string;
    ltPositionAndCompany!: string | undefined;
    ltExpectedStartDate!: string | undefined;
    ltWeeklyWorkHours!: string;
    ltAnticipatedWages!: string;
    ltReasonForOccupationSelection!: string;
    ltEducationTrainingPlans!: string | undefined;
    captchaToken!: string | undefined;
    /** Optional: the Ticket Holder's previous employment experience relevant to the short-term goal, as entered in
IWP step 3. Used to answer IWP question 3. Not sent by the public IWP generator. */
    stPreviousEmploymentExperience!: string | undefined;
    /** Optional: previous employment experience relevant to the long-term goal (IWP step 3). */
    ltPreviousEmploymentExperience!: string | undefined;

    constructor(data?: IGenerateIwpSectionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.stOccupationType = _data["stOccupationType"];
            this.stPositionAndCompany = _data["stPositionAndCompany"];
            this.stExpectedStartDate = _data["stExpectedStartDate"];
            this.stWeeklyWorkHours = _data["stWeeklyWorkHours"];
            this.stAnticipatedWages = _data["stAnticipatedWages"];
            this.stEducationTrainingPlans = _data["stEducationTrainingPlans"];
            this.stTransitionStatement = _data["stTransitionStatement"];
            this.skillsToDevelop = _data["skillsToDevelop"];
            this.accommodationNeeds = _data["accommodationNeeds"];
            this.ltOccupationType = _data["ltOccupationType"];
            this.ltPositionAndCompany = _data["ltPositionAndCompany"];
            this.ltExpectedStartDate = _data["ltExpectedStartDate"];
            this.ltWeeklyWorkHours = _data["ltWeeklyWorkHours"];
            this.ltAnticipatedWages = _data["ltAnticipatedWages"];
            this.ltReasonForOccupationSelection = _data["ltReasonForOccupationSelection"];
            this.ltEducationTrainingPlans = _data["ltEducationTrainingPlans"];
            this.captchaToken = _data["captchaToken"];
            this.stPreviousEmploymentExperience = _data["stPreviousEmploymentExperience"];
            this.ltPreviousEmploymentExperience = _data["ltPreviousEmploymentExperience"];
        }
    }

    static fromJS(data: any): GenerateIwpSectionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateIwpSectionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stOccupationType"] = this.stOccupationType;
        data["stPositionAndCompany"] = this.stPositionAndCompany;
        data["stExpectedStartDate"] = this.stExpectedStartDate;
        data["stWeeklyWorkHours"] = this.stWeeklyWorkHours;
        data["stAnticipatedWages"] = this.stAnticipatedWages;
        data["stEducationTrainingPlans"] = this.stEducationTrainingPlans;
        data["stTransitionStatement"] = this.stTransitionStatement;
        data["skillsToDevelop"] = this.skillsToDevelop;
        data["accommodationNeeds"] = this.accommodationNeeds;
        data["ltOccupationType"] = this.ltOccupationType;
        data["ltPositionAndCompany"] = this.ltPositionAndCompany;
        data["ltExpectedStartDate"] = this.ltExpectedStartDate;
        data["ltWeeklyWorkHours"] = this.ltWeeklyWorkHours;
        data["ltAnticipatedWages"] = this.ltAnticipatedWages;
        data["ltReasonForOccupationSelection"] = this.ltReasonForOccupationSelection;
        data["ltEducationTrainingPlans"] = this.ltEducationTrainingPlans;
        data["captchaToken"] = this.captchaToken;
        data["stPreviousEmploymentExperience"] = this.stPreviousEmploymentExperience;
        data["ltPreviousEmploymentExperience"] = this.ltPreviousEmploymentExperience;
        return data;
    }
}

export interface IGenerateIwpSectionsInput {
    name: string;
    stOccupationType: string;
    stPositionAndCompany: string | undefined;
    stExpectedStartDate: string | undefined;
    stWeeklyWorkHours: string;
    stAnticipatedWages: string;
    stEducationTrainingPlans: string | undefined;
    stTransitionStatement: string | undefined;
    skillsToDevelop: string | undefined;
    accommodationNeeds: string | undefined;
    ltOccupationType: string;
    ltPositionAndCompany: string | undefined;
    ltExpectedStartDate: string | undefined;
    ltWeeklyWorkHours: string;
    ltAnticipatedWages: string;
    ltReasonForOccupationSelection: string;
    ltEducationTrainingPlans: string | undefined;
    captchaToken: string | undefined;
    /** Optional: the Ticket Holder's previous employment experience relevant to the short-term goal, as entered in
IWP step 3. Used to answer IWP question 3. Not sent by the public IWP generator. */
    stPreviousEmploymentExperience: string | undefined;
    /** Optional: previous employment experience relevant to the long-term goal (IWP step 3). */
    ltPreviousEmploymentExperience: string | undefined;
}

export class GenerateIwpSectionsOutput implements IGenerateIwpSectionsOutput {
    section1!: string | undefined;
    section2!: string | undefined;
    section3!: string | undefined;
    section4!: string | undefined;
    section5!: string | undefined;
    section6!: string | undefined;
    section7!: string | undefined;
    section8!: string | undefined;
    hasShortTermExperience!: boolean | undefined;
    shortTermExperienceExplanation!: string | undefined;
    hasLongTermExperience!: boolean | undefined;
    longTermExperienceExplanation!: string | undefined;
    requiresShortTermSupport!: boolean | undefined;
    shortTermSupportExplanation!: string | undefined;
    requiresLongTermSupport!: boolean | undefined;
    longTermSupportExplanation!: string | undefined;

    constructor(data?: IGenerateIwpSectionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.section1 = _data["section1"];
            this.section2 = _data["section2"];
            this.section3 = _data["section3"];
            this.section4 = _data["section4"];
            this.section5 = _data["section5"];
            this.section6 = _data["section6"];
            this.section7 = _data["section7"];
            this.section8 = _data["section8"];
            this.hasShortTermExperience = _data["hasShortTermExperience"];
            this.shortTermExperienceExplanation = _data["shortTermExperienceExplanation"];
            this.hasLongTermExperience = _data["hasLongTermExperience"];
            this.longTermExperienceExplanation = _data["longTermExperienceExplanation"];
            this.requiresShortTermSupport = _data["requiresShortTermSupport"];
            this.shortTermSupportExplanation = _data["shortTermSupportExplanation"];
            this.requiresLongTermSupport = _data["requiresLongTermSupport"];
            this.longTermSupportExplanation = _data["longTermSupportExplanation"];
        }
    }

    static fromJS(data: any): GenerateIwpSectionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateIwpSectionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section1"] = this.section1;
        data["section2"] = this.section2;
        data["section3"] = this.section3;
        data["section4"] = this.section4;
        data["section5"] = this.section5;
        data["section6"] = this.section6;
        data["section7"] = this.section7;
        data["section8"] = this.section8;
        data["hasShortTermExperience"] = this.hasShortTermExperience;
        data["shortTermExperienceExplanation"] = this.shortTermExperienceExplanation;
        data["hasLongTermExperience"] = this.hasLongTermExperience;
        data["longTermExperienceExplanation"] = this.longTermExperienceExplanation;
        data["requiresShortTermSupport"] = this.requiresShortTermSupport;
        data["shortTermSupportExplanation"] = this.shortTermSupportExplanation;
        data["requiresLongTermSupport"] = this.requiresLongTermSupport;
        data["longTermSupportExplanation"] = this.longTermSupportExplanation;
        return data;
    }
}

export interface IGenerateIwpSectionsOutput {
    section1: string | undefined;
    section2: string | undefined;
    section3: string | undefined;
    section4: string | undefined;
    section5: string | undefined;
    section6: string | undefined;
    section7: string | undefined;
    section8: string | undefined;
    hasShortTermExperience: boolean | undefined;
    shortTermExperienceExplanation: string | undefined;
    hasLongTermExperience: boolean | undefined;
    longTermExperienceExplanation: string | undefined;
    requiresShortTermSupport: boolean | undefined;
    shortTermSupportExplanation: string | undefined;
    requiresLongTermSupport: boolean | undefined;
    longTermSupportExplanation: string | undefined;
}

export class GeneratePartnerCodesResultDto implements IGeneratePartnerCodesResultDto {
    generated!: number;
    linked!: number;
    skipped!: string[] | undefined;

    constructor(data?: IGeneratePartnerCodesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generated = _data["generated"];
            this.linked = _data["linked"];
            if (Array.isArray(_data["skipped"])) {
                this.skipped = [] as any;
                for (let item of _data["skipped"])
                    this.skipped!.push(item);
            }
        }
    }

    static fromJS(data: any): GeneratePartnerCodesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePartnerCodesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generated"] = this.generated;
        data["linked"] = this.linked;
        if (Array.isArray(this.skipped)) {
            data["skipped"] = [];
            for (let item of this.skipped)
                data["skipped"].push(item);
        }
        return data;
    }
}

export interface IGeneratePartnerCodesResultDto {
    generated: number;
    linked: number;
    skipped: string[] | undefined;
}

export class GenerateResumeDraftInput implements IGenerateResumeDraftInput {
    ticketHolderId!: number;
    worksheetId!: number | undefined;

    constructor(data?: IGenerateResumeDraftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.worksheetId = _data["worksheetId"];
        }
    }

    static fromJS(data: any): GenerateResumeDraftInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateResumeDraftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["worksheetId"] = this.worksheetId;
        return data;
    }
}

export interface IGenerateResumeDraftInput {
    ticketHolderId: number;
    worksheetId: number | undefined;
}

export class GenerateRolloverRequestInput implements IGenerateRolloverRequestInput {
    persons!: RolloverPersonDto[];

    constructor(data?: IGenerateRolloverRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.persons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["persons"])) {
                this.persons = [] as any;
                for (let item of _data["persons"])
                    this.persons!.push(RolloverPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateRolloverRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateRolloverRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGenerateRolloverRequestInput {
    persons: RolloverPersonDto[];
}

export class GenerateSuitabilityPackageInput implements IGenerateSuitabilityPackageInput {
    id!: number;
    firstName!: string;
    middleName!: string | undefined;
    lastName!: string;
    email!: string;
    phone!: string | undefined;
    isUsCitizen!: boolean;
    startDate!: DateTime | undefined;
    fingerprintDate!: DateTime | undefined;
    eAppId!: string | undefined;

    constructor(data?: IGenerateSuitabilityPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.fingerprintDate = _data["fingerprintDate"] ? DateTime.fromISO(_data["fingerprintDate"].toString()) : <any>undefined;
            this.eAppId = _data["eAppId"];
        }
    }

    static fromJS(data: any): GenerateSuitabilityPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateSuitabilityPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["isUsCitizen"] = this.isUsCitizen;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["fingerprintDate"] = this.fingerprintDate ? this.fingerprintDate.toString() : <any>undefined;
        data["eAppId"] = this.eAppId;
        return data;
    }
}

export interface IGenerateSuitabilityPackageInput {
    id: number;
    firstName: string;
    middleName: string | undefined;
    lastName: string;
    email: string;
    phone: string | undefined;
    isUsCitizen: boolean;
    startDate: DateTime | undefined;
    fingerprintDate: DateTime | undefined;
    eAppId: string | undefined;
}

export enum GenericParameterAttributes {
    None = 0,
    Covariant = 1,
    Contravariant = 2,
    VarianceMask = 3,
    ReferenceTypeConstraint = 4,
    NotNullableValueTypeConstraint = 8,
    DefaultConstructorConstraint = 16,
    SpecialConstraintMask = 28,
    AllowByRefLike = 32,
}

export class GetActiveTicketHolderDto implements IGetActiveTicketHolderDto {
    ticketHolderName!: string | undefined;
    status!: TicketHolderStatus;
    statusValue!: string | undefined;
    employer!: string | undefined;
    latestPaymentRequest!: DateTime;
    phaseMilestone!: string | undefined;
    ticketHolderId!: string | undefined;
    hasPayStub!: boolean;

    constructor(data?: IGetActiveTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderName = _data["ticketHolderName"];
            this.status = _data["status"];
            this.statusValue = _data["statusValue"];
            this.employer = _data["employer"];
            this.latestPaymentRequest = _data["latestPaymentRequest"] ? DateTime.fromISO(_data["latestPaymentRequest"].toString()) : <any>undefined;
            this.phaseMilestone = _data["phaseMilestone"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.hasPayStub = _data["hasPayStub"];
        }
    }

    static fromJS(data: any): GetActiveTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderName"] = this.ticketHolderName;
        data["status"] = this.status;
        data["statusValue"] = this.statusValue;
        data["employer"] = this.employer;
        data["latestPaymentRequest"] = this.latestPaymentRequest ? this.latestPaymentRequest.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phaseMilestone"] = this.phaseMilestone;
        data["ticketHolderId"] = this.ticketHolderId;
        data["hasPayStub"] = this.hasPayStub;
        return data;
    }
}

export interface IGetActiveTicketHolderDto {
    ticketHolderName: string | undefined;
    status: TicketHolderStatus;
    statusValue: string | undefined;
    employer: string | undefined;
    latestPaymentRequest: DateTime;
    phaseMilestone: string | undefined;
    ticketHolderId: string | undefined;
    hasPayStub: boolean;
}

export class GetAiVoiceAgentsInput implements IGetAiVoiceAgentsInput {
    filter!: string | undefined;
    tenantId!: number | undefined;
    provider!: AiVoiceAgentProvider;
    isActive!: boolean | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetAiVoiceAgentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.tenantId = _data["tenantId"];
            this.provider = _data["provider"];
            this.isActive = _data["isActive"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAiVoiceAgentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAiVoiceAgentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        data["provider"] = this.provider;
        data["isActive"] = this.isActive;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAiVoiceAgentsInput {
    filter: string | undefined;
    tenantId: number | undefined;
    provider: AiVoiceAgentProvider;
    isActive: boolean | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class GetAllAvailableWebhooksOutput implements IGetAllAvailableWebhooksOutput {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetAllAvailableWebhooksOutput {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutput implements IGetAllDynamicEntityPropertyValuesOutput {
    items!: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllDynamicEntityPropertyValuesOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutput {
    items: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutputItem implements IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId!: number;
    propertyName!: string | undefined;
    inputType!: IInputType;
    selectedValues!: string[] | undefined;
    allValuesInputTypeHas!: string[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.propertyName = _data["propertyName"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            if (Array.isArray(_data["selectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["selectedValues"])
                    this.selectedValues!.push(item);
            }
            if (Array.isArray(_data["allValuesInputTypeHas"])) {
                this.allValuesInputTypeHas = [] as any;
                for (let item of _data["allValuesInputTypeHas"])
                    this.allValuesInputTypeHas!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["propertyName"] = this.propertyName;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedValues)) {
            data["selectedValues"] = [];
            for (let item of this.selectedValues)
                data["selectedValues"].push(item);
        }
        if (Array.isArray(this.allValuesInputTypeHas)) {
            data["allValuesInputTypeHas"] = [];
            for (let item of this.allValuesInputTypeHas)
                data["allValuesInputTypeHas"].push(item);
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId: number;
    propertyName: string | undefined;
    inputType: IInputType;
    selectedValues: string[] | undefined;
    allValuesInputTypeHas: string[] | undefined;
}

export class GetAllEntitiesHasDynamicPropertyOutput implements IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName!: string | undefined;

    constructor(data?: IGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
        }
    }

    static fromJS(data: any): GetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        return data;
    }
}

export interface IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName: string | undefined;
}

export class GetAllJobSearchRequestsResponseDto implements IGetAllJobSearchRequestsResponseDto {
    totalCount!: number;
    items!: AllJobSearchResponseDto[] | undefined;
    jobSummary!: JobSearchRoundStatusSummaryDto;

    constructor(data?: IGetAllJobSearchRequestsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AllJobSearchResponseDto.fromJS(item));
            }
            this.jobSummary = _data["jobSummary"] ? JobSearchRoundStatusSummaryDto.fromJS(_data["jobSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllJobSearchRequestsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllJobSearchRequestsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["jobSummary"] = this.jobSummary ? this.jobSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAllJobSearchRequestsResponseDto {
    totalCount: number;
    items: AllJobSearchResponseDto[] | undefined;
    jobSummary: JobSearchRoundStatusSummaryDto;
}

export class GetAllSendAttemptsOfWebhookEventOutput implements IGetAllSendAttemptsOfWebhookEventOutput {
    id!: string;
    webhookUri!: string | undefined;
    webhookSubscriptionId!: string;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: IGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookUri = _data["webhookUri"];
            this.webhookSubscriptionId = _data["webhookSubscriptionId"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookUri"] = this.webhookUri;
        data["webhookSubscriptionId"] = this.webhookSubscriptionId;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetAllSendAttemptsOfWebhookEventOutput {
    id: string;
    webhookUri: string | undefined;
    webhookSubscriptionId: string;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
}

export class GetAllSendAttemptsOutput implements IGetAllSendAttemptsOutput {
    id!: string;
    webhookEventId!: string;
    webhookName!: string | undefined;
    data!: string | undefined;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: DateTime;

    constructor(data?: IGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookEventId = _data["webhookEventId"];
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookEventId"] = this.webhookEventId;
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetAllSendAttemptsOutput {
    id: string;
    webhookEventId: string;
    webhookName: string | undefined;
    data: string | undefined;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: DateTime;
}

export class GetAllSubscriptionsOutput implements IGetAllSubscriptionsOutput {
    id!: string;
    webhookUri!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;

    constructor(data?: IGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookUri = _data["webhookUri"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookUri"] = this.webhookUri;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        return data;
    }
}

export interface IGetAllSubscriptionsOutput {
    id: string;
    webhookUri: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class GetCurrentMonthLeadsOutput implements IGetCurrentMonthLeadsOutput {
    dailyLeadCounts!: number[] | undefined;

    constructor(data?: IGetCurrentMonthLeadsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailyLeadCounts"])) {
                this.dailyLeadCounts = [] as any;
                for (let item of _data["dailyLeadCounts"])
                    this.dailyLeadCounts!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCurrentMonthLeadsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentMonthLeadsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailyLeadCounts)) {
            data["dailyLeadCounts"] = [];
            for (let item of this.dailyLeadCounts)
                data["dailyLeadCounts"].push(item);
        }
        return data;
    }
}

export interface IGetCurrentMonthLeadsOutput {
    dailyLeadCounts: number[] | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data;
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetDocumentTemplateDetailsDto implements IGetDocumentTemplateDetailsDto {
    templateId!: number;
    languageId!: number | undefined;
    bodyContent!: string;
    isBodyHtml!: boolean;
    attachmentDocumentIds!: number[] | undefined;
    compositeTemplateKey!: string | undefined;
    subject!: string | undefined;

    constructor(data?: IGetDocumentTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.languageId = _data["languageId"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
            if (Array.isArray(_data["attachmentDocumentIds"])) {
                this.attachmentDocumentIds = [] as any;
                for (let item of _data["attachmentDocumentIds"])
                    this.attachmentDocumentIds!.push(item);
            }
            this.compositeTemplateKey = _data["compositeTemplateKey"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): GetDocumentTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["languageId"] = this.languageId;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        if (Array.isArray(this.attachmentDocumentIds)) {
            data["attachmentDocumentIds"] = [];
            for (let item of this.attachmentDocumentIds)
                data["attachmentDocumentIds"].push(item);
        }
        data["compositeTemplateKey"] = this.compositeTemplateKey;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IGetDocumentTemplateDetailsDto {
    templateId: number;
    languageId: number | undefined;
    bodyContent: string;
    isBodyHtml: boolean;
    attachmentDocumentIds: number[] | undefined;
    compositeTemplateKey: string | undefined;
    subject: string | undefined;
}

export class GetDocumentTemplateDto implements IGetDocumentTemplateDto {
    id!: number;
    templateName!: string;
    clientType!: ClientType;
    type!: TicketHolderDocumentType;
    readonly enumDisplayTemplateType!: string | undefined;
    status!: TemplateStatus;
    createdDate!: DateTime;
    createdBy!: string | undefined;
    subject!: string | undefined;
    languageIds!: number[] | undefined;

    constructor(data?: IGetDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.clientType = _data["clientType"];
            this.type = _data["type"];
            (<any>this).enumDisplayTemplateType = _data["enumDisplayTemplateType"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? DateTime.fromISO(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["clientType"] = this.clientType;
        data["type"] = this.type;
        data["enumDisplayTemplateType"] = this.enumDisplayTemplateType;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["subject"] = this.subject;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        return data;
    }
}

export interface IGetDocumentTemplateDto {
    id: number;
    templateName: string;
    clientType: ClientType;
    type: TicketHolderDocumentType;
    enumDisplayTemplateType: string | undefined;
    status: TemplateStatus;
    createdDate: DateTime;
    createdBy: string | undefined;
    subject: string | undefined;
    languageIds: number[] | undefined;
}

export class GetESignProcessingDto implements IGetESignProcessingDto {
    id!: number;
    envelopeId!: string | undefined;
    iwpId!: number | undefined;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    clientId!: string | undefined;
    clientName!: string | undefined;
    repId!: number;
    repName!: string | undefined;
    ticketHolderSignatureStatus!: DigitalSignatureStatus;
    repSignatureStatus!: DigitalSignatureStatus;
    originalDocumentId!: number;
    signedDocumentId!: number | undefined;
    envelopeType!: DigitalSignatureEnvelopType;
    envelopeStatus!: DigitalSignatureEnvelopStatus;
    sentDate!: DateTime | undefined;
    completedDate!: DateTime | undefined;
    expirationDate!: DateTime | undefined;
    message!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    clientEmail!: string | undefined;
    representativeEmail!: string | undefined;

    constructor(data?: IGetESignProcessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.envelopeId = _data["envelopeId"];
            this.iwpId = _data["iwpId"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.repId = _data["repId"];
            this.repName = _data["repName"];
            this.ticketHolderSignatureStatus = _data["ticketHolderSignatureStatus"];
            this.repSignatureStatus = _data["repSignatureStatus"];
            this.originalDocumentId = _data["originalDocumentId"];
            this.signedDocumentId = _data["signedDocumentId"];
            this.envelopeType = _data["envelopeType"];
            this.envelopeStatus = _data["envelopeStatus"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? DateTime.fromISO(_data["completedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.clientEmail = _data["clientEmail"];
            this.representativeEmail = _data["representativeEmail"];
        }
    }

    static fromJS(data: any): GetESignProcessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetESignProcessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["envelopeId"] = this.envelopeId;
        data["iwpId"] = this.iwpId;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["repId"] = this.repId;
        data["repName"] = this.repName;
        data["ticketHolderSignatureStatus"] = this.ticketHolderSignatureStatus;
        data["repSignatureStatus"] = this.repSignatureStatus;
        data["originalDocumentId"] = this.originalDocumentId;
        data["signedDocumentId"] = this.signedDocumentId;
        data["envelopeType"] = this.envelopeType;
        data["envelopeStatus"] = this.envelopeStatus;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["message"] = this.message;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["clientEmail"] = this.clientEmail;
        data["representativeEmail"] = this.representativeEmail;
        return data;
    }
}

export interface IGetESignProcessingDto {
    id: number;
    envelopeId: string | undefined;
    iwpId: number | undefined;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    clientId: string | undefined;
    clientName: string | undefined;
    repId: number;
    repName: string | undefined;
    ticketHolderSignatureStatus: DigitalSignatureStatus;
    repSignatureStatus: DigitalSignatureStatus;
    originalDocumentId: number;
    signedDocumentId: number | undefined;
    envelopeType: DigitalSignatureEnvelopType;
    envelopeStatus: DigitalSignatureEnvelopStatus;
    sentDate: DateTime | undefined;
    completedDate: DateTime | undefined;
    expirationDate: DateTime | undefined;
    message: string | undefined;
    lastModificationTime: DateTime | undefined;
    clientEmail: string | undefined;
    representativeEmail: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetEligibilityCheckQueueDto implements IGetEligibilityCheckQueueDto {
    id!: number;
    leadId!: number;
    customLeadId!: string | undefined;
    leadName!: string | undefined;
    maskedSSN!: string | undefined;
    encryptedSSN!: string | undefined;
    benefitType!: BenefitType;
    requestedBy!: string | undefined;
    requestedDateTime!: DateTime;
    approvedBy!: string | undefined;
    approvedDateTime!: DateTime | undefined;
    assignabilityReasonCode!: AssignabilityReasonCode;
    readonly enumDisplayReasonCode!: string | undefined;
    assignabilityComments!: string | undefined;

    constructor(data?: IGetEligibilityCheckQueueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.customLeadId = _data["customLeadId"];
            this.leadName = _data["leadName"];
            this.maskedSSN = _data["maskedSSN"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.benefitType = _data["benefitType"];
            this.requestedBy = _data["requestedBy"];
            this.requestedDateTime = _data["requestedDateTime"] ? DateTime.fromISO(_data["requestedDateTime"].toString()) : <any>undefined;
            this.approvedBy = _data["approvedBy"];
            this.approvedDateTime = _data["approvedDateTime"] ? DateTime.fromISO(_data["approvedDateTime"].toString()) : <any>undefined;
            this.assignabilityReasonCode = _data["assignabilityReasonCode"];
            (<any>this).enumDisplayReasonCode = _data["enumDisplayReasonCode"];
            this.assignabilityComments = _data["assignabilityComments"];
        }
    }

    static fromJS(data: any): GetEligibilityCheckQueueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEligibilityCheckQueueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["customLeadId"] = this.customLeadId;
        data["leadName"] = this.leadName;
        data["maskedSSN"] = this.maskedSSN;
        data["encryptedSSN"] = this.encryptedSSN;
        data["benefitType"] = this.benefitType;
        data["requestedBy"] = this.requestedBy;
        data["requestedDateTime"] = this.requestedDateTime ? this.requestedDateTime.toString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toString() : <any>undefined;
        data["assignabilityReasonCode"] = this.assignabilityReasonCode;
        data["enumDisplayReasonCode"] = this.enumDisplayReasonCode;
        data["assignabilityComments"] = this.assignabilityComments;
        return data;
    }
}

export interface IGetEligibilityCheckQueueDto {
    id: number;
    leadId: number;
    customLeadId: string | undefined;
    leadName: string | undefined;
    maskedSSN: string | undefined;
    encryptedSSN: string | undefined;
    benefitType: BenefitType;
    requestedBy: string | undefined;
    requestedDateTime: DateTime;
    approvedBy: string | undefined;
    approvedDateTime: DateTime | undefined;
    assignabilityReasonCode: AssignabilityReasonCode;
    enumDisplayReasonCode: string | undefined;
    assignabilityComments: string | undefined;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetIWPQStatsOutput implements IGetIWPQStatsOutput {
    labels!: string[] | undefined;
    counts!: number[] | undefined;

    constructor(data?: IGetIWPQStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            if (Array.isArray(_data["counts"])) {
                this.counts = [] as any;
                for (let item of _data["counts"])
                    this.counts!.push(item);
            }
        }
    }

    static fromJS(data: any): GetIWPQStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIWPQStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        if (Array.isArray(this.counts)) {
            data["counts"] = [];
            for (let item of this.counts)
                data["counts"].push(item);
        }
        return data;
    }
}

export interface IGetIWPQStatsOutput {
    labels: string[] | undefined;
    counts: number[] | undefined;
}

export class GetInTouchDto implements IGetInTouchDto {
    leadId!: number;
    email!: string | undefined;
    isEmailVerified!: boolean | undefined;
    phoneNumbers!: PhoneDto[] | undefined;
    addresses!: AddressDto[] | undefined;

    constructor(data?: IGetInTouchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.email = _data["email"];
            this.isEmailVerified = _data["isEmailVerified"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(PhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInTouchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInTouchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["email"] = this.email;
        data["isEmailVerified"] = this.isEmailVerified;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInTouchDto {
    leadId: number;
    email: string | undefined;
    isEmailVerified: boolean | undefined;
    phoneNumbers: PhoneDto[] | undefined;
    addresses: AddressDto[] | undefined;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    items!: ApplicationLanguageListDto[] | undefined;
    defaultLanguageName!: string | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
            this.defaultLanguageName = _data["defaultLanguageName"];
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["defaultLanguageName"] = this.defaultLanguageName;
        return data;
    }
}

export interface IGetLanguagesOutput {
    items: ApplicationLanguageListDto[] | undefined;
    defaultLanguageName: string | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetMessageTemplate implements IGetMessageTemplate {
    id!: number;
    templateName!: string;
    templateType!: MessageTemplateType;
    subject!: string | undefined;
    body!: string | undefined;
    languageId!: number | undefined;
    versionNumber!: string | undefined;
    isLatest!: boolean;
    templateStatus!: TemplateStatus;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    uploadedBy!: string | undefined;
    isSystemTemplate!: boolean;
    readonly attachmentDocuments!: MessageTemplateAttachmentDto[] | undefined;

    constructor(data?: IGetMessageTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.templateType = _data["templateType"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.languageId = _data["languageId"];
            this.versionNumber = _data["versionNumber"];
            this.isLatest = _data["isLatest"];
            this.templateStatus = _data["templateStatus"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.uploadedBy = _data["uploadedBy"];
            this.isSystemTemplate = _data["isSystemTemplate"];
            if (Array.isArray(_data["attachmentDocuments"])) {
                (<any>this).attachmentDocuments = [] as any;
                for (let item of _data["attachmentDocuments"])
                    (<any>this).attachmentDocuments!.push(MessageTemplateAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessageTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["templateType"] = this.templateType;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["languageId"] = this.languageId;
        data["versionNumber"] = this.versionNumber;
        data["isLatest"] = this.isLatest;
        data["templateStatus"] = this.templateStatus;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["uploadedBy"] = this.uploadedBy;
        data["isSystemTemplate"] = this.isSystemTemplate;
        if (Array.isArray(this.attachmentDocuments)) {
            data["attachmentDocuments"] = [];
            for (let item of this.attachmentDocuments)
                data["attachmentDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessageTemplate {
    id: number;
    templateName: string;
    templateType: MessageTemplateType;
    subject: string | undefined;
    body: string | undefined;
    languageId: number | undefined;
    versionNumber: string | undefined;
    isLatest: boolean;
    templateStatus: TemplateStatus;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    uploadedBy: string | undefined;
    isSystemTemplate: boolean;
    attachmentDocuments: MessageTemplateAttachmentDto[] | undefined;
}

export class GetMyCalendarEventsFilter implements IGetMyCalendarEventsFilter {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    userId!: number[] | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    eventTypes!: CalendarEventType[] | undefined;

    constructor(data?: IGetMyCalendarEventsFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["userId"])) {
                this.userId = [] as any;
                for (let item of _data["userId"])
                    this.userId!.push(item);
            }
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["eventTypes"])) {
                this.eventTypes = [] as any;
                for (let item of _data["eventTypes"])
                    this.eventTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMyCalendarEventsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyCalendarEventsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.userId)) {
            data["userId"] = [];
            for (let item of this.userId)
                data["userId"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        if (Array.isArray(this.eventTypes)) {
            data["eventTypes"] = [];
            for (let item of this.eventTypes)
                data["eventTypes"].push(item);
        }
        return data;
    }
}

export interface IGetMyCalendarEventsFilter {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    userId: number[] | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    eventTypes: CalendarEventType[] | undefined;
}

export class GetNotificationOutput implements IGetNotificationOutput {
    totalCount!: number;
    unreadCount!: number;
    items!: SimpleNotificationItemDto[] | undefined;

    constructor(data?: IGetNotificationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.unreadCount = _data["unreadCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleNotificationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["unreadCount"] = this.unreadCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationOutput {
    totalCount: number;
    unreadCount: number;
    items: SimpleNotificationItemDto[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsCreatedByUserOutput implements IGetNotificationsCreatedByUserOutput {
    notificationName!: string | undefined;
    data!: string | undefined;
    dataTypeName!: string | undefined;
    severity!: NotificationSeverity;
    isPublished!: boolean;
    creationTime!: DateTime;

    constructor(data?: IGetNotificationsCreatedByUserOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationName = _data["notificationName"];
            this.data = _data["data"];
            this.dataTypeName = _data["dataTypeName"];
            this.severity = _data["severity"];
            this.isPublished = _data["isPublished"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotificationsCreatedByUserOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsCreatedByUserOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationName"] = this.notificationName;
        data["data"] = this.data;
        data["dataTypeName"] = this.dataTypeName;
        data["severity"] = this.severity;
        data["isPublished"] = this.isPublished;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetNotificationsCreatedByUserOutput {
    notificationName: string | undefined;
    data: string | undefined;
    dataTypeName: string | undefined;
    severity: NotificationSeverity;
    isPublished: boolean;
    creationTime: DateTime;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    items!: UserNotification[] | undefined;
    totalCount!: number;
    unreadCount!: number;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.unreadCount = _data["unreadCount"];
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["unreadCount"] = this.unreadCount;
        return data;
    }
}

export interface IGetNotificationsOutput {
    items: UserNotification[] | undefined;
    totalCount: number;
    unreadCount: number;
}

export class GetPartnerPortalReferralsInput implements IGetPartnerPortalReferralsInput {
    sessionToken!: string;
    skipCount!: number;
    maxResultCount!: number;
    filter!: string | undefined;
    sorting!: string | undefined;

    constructor(data?: IGetPartnerPortalReferralsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): GetPartnerPortalReferralsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerPortalReferralsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IGetPartnerPortalReferralsInput {
    sessionToken: string;
    skipCount: number;
    maxResultCount: number;
    filter: string | undefined;
    sorting: string | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetPublishedNotificationsOutput implements IGetPublishedNotificationsOutput {
    items!: GetNotificationsCreatedByUserOutput[] | undefined;
    totalCount!: number;

    constructor(data?: IGetPublishedNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNotificationsCreatedByUserOutput.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetPublishedNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishedNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetPublishedNotificationsOutput {
    items: GetNotificationsCreatedByUserOutput[] | undefined;
    totalCount: number;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : <any>undefined;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetReportRequestsInput implements IGetReportRequestsInput {
    filter!: string | undefined;
    tenantId!: number | undefined;
    status!: ReportRequestStatus;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetReportRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetReportRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetReportRequestsInput {
    filter: string | undefined;
    tenantId: number | undefined;
    status: ReportRequestStatus;
    skipCount: number;
    maxResultCount: number;
}

export class GetReportsInput implements IGetReportsInput {
    filter!: string | undefined;
    tenantId!: number | undefined;
    role!: string | undefined;
    isActive!: boolean | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetReportsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.tenantId = _data["tenantId"];
            this.role = _data["role"];
            this.isActive = _data["isActive"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetReportsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["tenantId"] = this.tenantId;
        data["role"] = this.role;
        data["isActive"] = this.isActive;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetReportsInput {
    filter: string | undefined;
    tenantId: number | undefined;
    role: string | undefined;
    isActive: boolean | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
    permissions!: string[] | undefined;

    constructor(data?: IGetRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IGetRolesInput {
    permissions: string[] | undefined;
}

export class GetSMSMessageInfoResponse implements IGetSMSMessageInfoResponse {
    id!: number | undefined;
    uri!: string | undefined;
    attachments!: MessageAttachmentInfo[] | undefined;
    availability!: string | undefined;
    conversationId!: number | undefined;
    conversation!: ConversationInfo;
    creationTime!: string | undefined;
    direction!: string | undefined;
    from!: MessageStoreCallerInfoResponseFrom;
    lastModifiedTime!: string | undefined;
    messageStatus!: string | undefined;
    priority!: string | undefined;
    readStatus!: string | undefined;
    smsDeliveryTime!: string | undefined;
    smsSendingAttemptsCount!: number | undefined;
    subject!: string | undefined;
    to!: MessageStoreCallerInfoResponseTo[] | undefined;
    type!: string | undefined;

    constructor(data?: IGetSMSMessageInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(MessageAttachmentInfo.fromJS(item));
            }
            this.availability = _data["availability"];
            this.conversationId = _data["conversationId"];
            this.conversation = _data["conversation"] ? ConversationInfo.fromJS(_data["conversation"]) : <any>undefined;
            this.creationTime = _data["creationTime"];
            this.direction = _data["direction"];
            this.from = _data["from"] ? MessageStoreCallerInfoResponseFrom.fromJS(_data["from"]) : <any>undefined;
            this.lastModifiedTime = _data["lastModifiedTime"];
            this.messageStatus = _data["messageStatus"];
            this.priority = _data["priority"];
            this.readStatus = _data["readStatus"];
            this.smsDeliveryTime = _data["smsDeliveryTime"];
            this.smsSendingAttemptsCount = _data["smsSendingAttemptsCount"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(MessageStoreCallerInfoResponseTo.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetSMSMessageInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMSMessageInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["availability"] = this.availability;
        data["conversationId"] = this.conversationId;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime;
        data["direction"] = this.direction;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["lastModifiedTime"] = this.lastModifiedTime;
        data["messageStatus"] = this.messageStatus;
        data["priority"] = this.priority;
        data["readStatus"] = this.readStatus;
        data["smsDeliveryTime"] = this.smsDeliveryTime;
        data["smsSendingAttemptsCount"] = this.smsSendingAttemptsCount;
        data["subject"] = this.subject;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data;
    }
}

export interface IGetSMSMessageInfoResponse {
    id: number | undefined;
    uri: string | undefined;
    attachments: MessageAttachmentInfo[] | undefined;
    availability: string | undefined;
    conversationId: number | undefined;
    conversation: ConversationInfo;
    creationTime: string | undefined;
    direction: string | undefined;
    from: MessageStoreCallerInfoResponseFrom;
    lastModifiedTime: string | undefined;
    messageStatus: string | undefined;
    priority: string | undefined;
    readStatus: string | undefined;
    smsDeliveryTime: string | undefined;
    smsSendingAttemptsCount: number | undefined;
    subject: string | undefined;
    to: MessageStoreCallerInfoResponseTo[] | undefined;
    type: string | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetTHCardSummary implements IGetTHCardSummary {
    totalPending!: number;
    totalApplied!: number;
    totalUnableToApply!: number;
    totalServiceRequest!: number;

    constructor(data?: IGetTHCardSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPending = _data["totalPending"];
            this.totalApplied = _data["totalApplied"];
            this.totalUnableToApply = _data["totalUnableToApply"];
            this.totalServiceRequest = _data["totalServiceRequest"];
        }
    }

    static fromJS(data: any): GetTHCardSummary {
        data = typeof data === 'object' ? data : {};
        let result = new GetTHCardSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPending"] = this.totalPending;
        data["totalApplied"] = this.totalApplied;
        data["totalUnableToApply"] = this.totalUnableToApply;
        data["totalServiceRequest"] = this.totalServiceRequest;
        return data;
    }
}

export interface IGetTHCardSummary {
    totalPending: number;
    totalApplied: number;
    totalUnableToApply: number;
    totalServiceRequest: number;
}

export class GetTHPhoneNumberFilterDto implements IGetTHPhoneNumberFilterDto {
    ticketHolderId!: number;
    phoneType!: PhoneType;

    constructor(data?: IGetTHPhoneNumberFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.phoneType = _data["phoneType"];
        }
    }

    static fromJS(data: any): GetTHPhoneNumberFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTHPhoneNumberFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["phoneType"] = this.phoneType;
        return data;
    }
}

export interface IGetTHPhoneNumberFilterDto {
    ticketHolderId: number;
    phoneType: PhoneType;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetTicketHolderMessengerOutput implements IGetTicketHolderMessengerOutput {
    message!: string | undefined;
    activityType!: ContactType;
    enumActivityTypeDisplay!: string | undefined;
    direction!: ActivityDirection;
    enumActivityDirection!: string | undefined;
    createdDate!: DateTime;

    constructor(data?: IGetTicketHolderMessengerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.activityType = _data["activityType"];
            this.enumActivityTypeDisplay = _data["enumActivityTypeDisplay"];
            this.direction = _data["direction"];
            this.enumActivityDirection = _data["enumActivityDirection"];
            this.createdDate = _data["createdDate"] ? DateTime.fromISO(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTicketHolderMessengerOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketHolderMessengerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["activityType"] = this.activityType;
        data["enumActivityTypeDisplay"] = this.enumActivityTypeDisplay;
        data["direction"] = this.direction;
        data["enumActivityDirection"] = this.enumActivityDirection;
        data["createdDate"] = this.createdDate ? this.createdDate.toString() : <any>undefined;
        return data;
    }
}

export interface IGetTicketHolderMessengerOutput {
    message: string | undefined;
    activityType: ContactType;
    enumActivityTypeDisplay: string | undefined;
    direction: ActivityDirection;
    enumActivityDirection: string | undefined;
    createdDate: DateTime;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: DateTime;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: DateTime;
    friends: FriendDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    allowedUserNameCharacters!: string | undefined;
    isSMTPSettingsProvided!: boolean;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
            this.allowedUserNameCharacters = _data["allowedUserNameCharacters"];
            this.isSMTPSettingsProvided = _data["isSMTPSettingsProvided"];
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["allowedUserNameCharacters"] = this.allowedUserNameCharacters;
        data["isSMTPSettingsProvided"] = this.isSMTPSettingsProvided;
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    allowedUserNameCharacters: string | undefined;
    isSMTPSettingsProvided: boolean;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUsersInput implements IGetUsersInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    permissions!: string[] | undefined;
    role!: number | undefined;
    onlyLockedUsers!: boolean;

    constructor(data?: IGetUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.role = _data["role"];
            this.onlyLockedUsers = _data["onlyLockedUsers"];
        }
    }

    static fromJS(data: any): GetUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["role"] = this.role;
        data["onlyLockedUsers"] = this.onlyLockedUsers;
        return data;
    }
}

export interface IGetUsersInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    permissions: string[] | undefined;
    role: number | undefined;
    onlyLockedUsers: boolean;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class GraphSubscription implements IGraphSubscription {
    id!: string | undefined;

    constructor(data?: IGraphSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GraphSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new GraphSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGraphSubscription {
    id: string | undefined;
}

export class GridColumnDto implements IGridColumnDto {
    key!: string | undefined;
    title!: string | undefined;
    isEditable!: boolean;
    selected!: boolean;
    isDefaultVisible!: boolean;
    defaultOrder!: number;

    constructor(data?: IGridColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.title = _data["title"];
            this.isEditable = _data["isEditable"];
            this.selected = _data["selected"];
            this.isDefaultVisible = _data["isDefaultVisible"];
            this.defaultOrder = _data["defaultOrder"];
        }
    }

    static fromJS(data: any): GridColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["title"] = this.title;
        data["isEditable"] = this.isEditable;
        data["selected"] = this.selected;
        data["isDefaultVisible"] = this.isDefaultVisible;
        data["defaultOrder"] = this.defaultOrder;
        return data;
    }
}

export interface IGridColumnDto {
    key: string | undefined;
    title: string | undefined;
    isEditable: boolean;
    selected: boolean;
    isDefaultVisible: boolean;
    defaultOrder: number;
}

export class GridConfigurationDto implements IGridConfigurationDto {
    columns!: GridColumnDto[] | undefined;

    constructor(data?: IGridConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(GridColumnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GridConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGridConfigurationDto {
    columns: GridColumnDto[] | undefined;
}

export enum HighestGradeCompleted {
    PrimaryOrSecondary = 1,
    Certificate = 2,
    GED = 3,
    HighSchool = 4,
    VocationalTechnical = 5,
    SomeCollege = 6,
    Undergrad = 7,
    GraduateDegree = 8,
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostContentTemplateDetailDto implements IHostContentTemplateDetailDto {
    id!: number;
    languageId!: number | undefined;
    subject!: string | undefined;
    bodyContent!: string | undefined;
    isBodyHtml!: boolean;

    constructor(data?: IHostContentTemplateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
        }
    }

    static fromJS(data: any): HostContentTemplateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostContentTemplateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        return data;
    }
}

export interface IHostContentTemplateDetailDto {
    id: number;
    languageId: number | undefined;
    subject: string | undefined;
    bodyContent: string | undefined;
    isBodyHtml: boolean;
}

export class HostContentTemplateDto implements IHostContentTemplateDto {
    id!: number;
    templateName!: string | undefined;
    type!: TicketHolderDocumentType;
    clientType!: ClientType;
    subject!: string | undefined;
    status!: TemplateStatus;
    creationTime!: DateTime;

    constructor(data?: IHostContentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.type = _data["type"];
            this.clientType = _data["clientType"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostContentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostContentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["type"] = this.type;
        data["clientType"] = this.clientType;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IHostContentTemplateDto {
    id: number;
    templateName: string | undefined;
    type: TicketHolderDocumentType;
    clientType: ClientType;
    subject: string | undefined;
    status: TemplateStatus;
    creationTime: DateTime;
}

export class HostContentTemplateEditDto implements IHostContentTemplateEditDto {
    id!: number;
    templateName!: string | undefined;
    clientType!: ClientType;
    type!: TicketHolderDocumentType;
    details!: HostContentTemplateDetailDto[] | undefined;

    constructor(data?: IHostContentTemplateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.clientType = _data["clientType"];
            this.type = _data["type"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(HostContentTemplateDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HostContentTemplateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostContentTemplateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["clientType"] = this.clientType;
        data["type"] = this.type;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHostContentTemplateEditDto {
    id: number;
    templateName: string | undefined;
    clientType: ClientType;
    type: TicketHolderDocumentType;
    details: HostContentTemplateDetailDto[] | undefined;
}

export class HostFormGroupDto implements IHostFormGroupDto {
    groupName!: string | undefined;
    forms!: HostFormTemplateDto[] | undefined;

    constructor(data?: IHostFormGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(HostFormTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HostFormGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostFormGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHostFormGroupDto {
    groupName: string | undefined;
    forms: HostFormTemplateDto[] | undefined;
}

export class HostFormTemplateDto implements IHostFormTemplateDto {
    id!: number;
    formName!: string | undefined;
    description!: string | undefined;
    formsType!: TTWFormsType;
    documentName!: string | undefined;
    fileType!: string | undefined;
    templateStatus!: TemplateStatus;
    hasFile!: boolean;

    constructor(data?: IHostFormTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formName = _data["formName"];
            this.description = _data["description"];
            this.formsType = _data["formsType"];
            this.documentName = _data["documentName"];
            this.fileType = _data["fileType"];
            this.templateStatus = _data["templateStatus"];
            this.hasFile = _data["hasFile"];
        }
    }

    static fromJS(data: any): HostFormTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostFormTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formName"] = this.formName;
        data["description"] = this.description;
        data["formsType"] = this.formsType;
        data["documentName"] = this.documentName;
        data["fileType"] = this.fileType;
        data["templateStatus"] = this.templateStatus;
        data["hasFile"] = this.hasFile;
        return data;
    }
}

export interface IHostFormTemplateDto {
    id: number;
    formName: string | undefined;
    description: string | undefined;
    formsType: TTWFormsType;
    documentName: string | undefined;
    fileType: string | undefined;
    templateStatus: TemplateStatus;
    hasFile: boolean;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    maxProfilePictureSizeInMB!: number;
    maxProfilePictureWidth!: number;
    maxProfilePictureHeight!: number;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;
    passwordlessLogin!: PasswordlessLoginSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.maxProfilePictureSizeInMB = _data["maxProfilePictureSizeInMB"];
            this.maxProfilePictureWidth = _data["maxProfilePictureWidth"];
            this.maxProfilePictureHeight = _data["maxProfilePictureHeight"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
            this.passwordlessLogin = _data["passwordlessLogin"] ? PasswordlessLoginSettingsEditDto.fromJS(_data["passwordlessLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["maxProfilePictureSizeInMB"] = this.maxProfilePictureSizeInMB;
        data["maxProfilePictureWidth"] = this.maxProfilePictureWidth;
        data["maxProfilePictureHeight"] = this.maxProfilePictureHeight;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        data["passwordlessLogin"] = this.passwordlessLogin ? this.passwordlessLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    maxProfilePictureSizeInMB: number;
    maxProfilePictureWidth: number;
    maxProfilePictureHeight: number;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
    passwordlessLogin: PasswordlessLoginSettingsEditDto;
}

export class HouseholdMemberDto implements IHouseholdMemberDto {
    id!: number | undefined;
    name!: string | undefined;
    age!: number | undefined;
    receivingBenefits!: boolean | undefined;
    benefitDetail!: string | undefined;

    constructor(data?: IHouseholdMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.age = _data["age"];
            this.receivingBenefits = _data["receivingBenefits"];
            this.benefitDetail = _data["benefitDetail"];
        }
    }

    static fromJS(data: any): HouseholdMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new HouseholdMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["age"] = this.age;
        data["receivingBenefits"] = this.receivingBenefits;
        data["benefitDetail"] = this.benefitDetail;
        return data;
    }
}

export interface IHouseholdMemberDto {
    id: number | undefined;
    name: string | undefined;
    age: number | undefined;
    receivingBenefits: boolean | undefined;
    benefitDetail: string | undefined;
}

export class HousingServiceRequestDto implements IHousingServiceRequestDto {
    id!: number;
    ticketHolderId!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    housingType!: string;
    relocate!: boolean;
    housingAssistanceType!: string | undefined;
    eligibility!: string | undefined;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: IHousingServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.housingType = _data["housingType"];
            this.relocate = _data["relocate"];
            this.housingAssistanceType = _data["housingAssistanceType"];
            this.eligibility = _data["eligibility"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HousingServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new HousingServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["housingType"] = this.housingType;
        data["relocate"] = this.relocate;
        data["housingAssistanceType"] = this.housingAssistanceType;
        data["eligibility"] = this.eligibility;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface IHousingServiceRequestDto {
    id: number;
    ticketHolderId: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    housingType: string;
    relocate: boolean;
    housingAssistanceType: string | undefined;
    eligibility: string | undefined;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    UnprocessableContent = 431,
    Locked = 451,
    FailedDependency = 500,
    UpgradeRequired = 501,
    PreconditionRequired = 502,
    TooManyRequests = 503,
    RequestHeaderFieldsTooLarge = 504,
    UnavailableForLegalReasons = 505,
    InternalServerError = 506,
    NotImplemented = 507,
    BadGateway = 508,
    ServiceUnavailable = 510,
    GatewayTimeout = 511,
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export enum IWPBusinessModel {
    TraditionalServices = 1,
    ConsumerDirectServices = 2,
    EmployerOrEmployerAgent = 3,
    Administrative = 4,
}

export class IWPDdto implements IIWPDdto {
    id!: number;
    leadId!: number | undefined;
    clientId!: string | undefined;
    ticketHolderId!: number | undefined;
    dateOfDiscussion!: DateTime;
    discussionModality!: IWPDiscussionModality;
    discussionModalityExplanation!: string | undefined;
    location!: string | undefined;
    durationInSeconds!: number;
    enInterviewerName!: string | undefined;
    enInterviewerPosition!: string | undefined;
    enInterviewerId!: number;
    workStatus!: WorkStatus;
    hasOtherTerm!: boolean;
    otherTerm!: string | undefined;
    iwpStatus!: IWPStatus;
    documentId!: number | undefined;
    reviewNotes!: string | undefined;
    userInputDurationInMinutes!: number;

    constructor(data?: IIWPDdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.clientId = _data["clientId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.dateOfDiscussion = _data["dateOfDiscussion"] ? DateTime.fromISO(_data["dateOfDiscussion"].toString()) : <any>undefined;
            this.discussionModality = _data["discussionModality"];
            this.discussionModalityExplanation = _data["discussionModalityExplanation"];
            this.location = _data["location"];
            this.durationInSeconds = _data["durationInSeconds"];
            this.enInterviewerName = _data["enInterviewerName"];
            this.enInterviewerPosition = _data["enInterviewerPosition"];
            this.enInterviewerId = _data["enInterviewerId"];
            this.workStatus = _data["workStatus"];
            this.hasOtherTerm = _data["hasOtherTerm"];
            this.otherTerm = _data["otherTerm"];
            this.iwpStatus = _data["iwpStatus"];
            this.documentId = _data["documentId"];
            this.reviewNotes = _data["reviewNotes"];
            this.userInputDurationInMinutes = _data["userInputDurationInMinutes"];
        }
    }

    static fromJS(data: any): IWPDdto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPDdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["clientId"] = this.clientId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["dateOfDiscussion"] = this.dateOfDiscussion ? this.dateOfDiscussion.toString() : <any>undefined;
        data["discussionModality"] = this.discussionModality;
        data["discussionModalityExplanation"] = this.discussionModalityExplanation;
        data["location"] = this.location;
        data["durationInSeconds"] = this.durationInSeconds;
        data["enInterviewerName"] = this.enInterviewerName;
        data["enInterviewerPosition"] = this.enInterviewerPosition;
        data["enInterviewerId"] = this.enInterviewerId;
        data["workStatus"] = this.workStatus;
        data["hasOtherTerm"] = this.hasOtherTerm;
        data["otherTerm"] = this.otherTerm;
        data["iwpStatus"] = this.iwpStatus;
        data["documentId"] = this.documentId;
        data["reviewNotes"] = this.reviewNotes;
        data["userInputDurationInMinutes"] = this.userInputDurationInMinutes;
        return data;
    }
}

export interface IIWPDdto {
    id: number;
    leadId: number | undefined;
    clientId: string | undefined;
    ticketHolderId: number | undefined;
    dateOfDiscussion: DateTime;
    discussionModality: IWPDiscussionModality;
    discussionModalityExplanation: string | undefined;
    location: string | undefined;
    durationInSeconds: number;
    enInterviewerName: string | undefined;
    enInterviewerPosition: string | undefined;
    enInterviewerId: number;
    workStatus: WorkStatus;
    hasOtherTerm: boolean;
    otherTerm: string | undefined;
    iwpStatus: IWPStatus;
    documentId: number | undefined;
    reviewNotes: string | undefined;
    userInputDurationInMinutes: number;
}

export class IWPDigiSignerEnvelopeDto implements IIWPDigiSignerEnvelopeDto {
    id!: number;
    envelopeId!: string | undefined;
    envelopeStatus!: DigitalSignatureEnvelopStatus;
    statusDisplay!: string | undefined;
    isVoided!: boolean;
    sentDate!: DateTime | undefined;
    completedDate!: DateTime | undefined;
    expirationDate!: DateTime | undefined;
    lastUpdated!: DateTime | undefined;
    signedDocumentId!: number | undefined;
    signers!: IWPDigiSignerSignerDto[] | undefined;
    events!: IWPDigiSignerEventDto[] | undefined;

    constructor(data?: IIWPDigiSignerEnvelopeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.envelopeId = _data["envelopeId"];
            this.envelopeStatus = _data["envelopeStatus"];
            this.statusDisplay = _data["statusDisplay"];
            this.isVoided = _data["isVoided"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? DateTime.fromISO(_data["completedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? DateTime.fromISO(_data["lastUpdated"].toString()) : <any>undefined;
            this.signedDocumentId = _data["signedDocumentId"];
            if (Array.isArray(_data["signers"])) {
                this.signers = [] as any;
                for (let item of _data["signers"])
                    this.signers!.push(IWPDigiSignerSignerDto.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(IWPDigiSignerEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IWPDigiSignerEnvelopeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPDigiSignerEnvelopeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["envelopeId"] = this.envelopeId;
        data["envelopeStatus"] = this.envelopeStatus;
        data["statusDisplay"] = this.statusDisplay;
        data["isVoided"] = this.isVoided;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toString() : <any>undefined;
        data["signedDocumentId"] = this.signedDocumentId;
        if (Array.isArray(this.signers)) {
            data["signers"] = [];
            for (let item of this.signers)
                data["signers"].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIWPDigiSignerEnvelopeDto {
    id: number;
    envelopeId: string | undefined;
    envelopeStatus: DigitalSignatureEnvelopStatus;
    statusDisplay: string | undefined;
    isVoided: boolean;
    sentDate: DateTime | undefined;
    completedDate: DateTime | undefined;
    expirationDate: DateTime | undefined;
    lastUpdated: DateTime | undefined;
    signedDocumentId: number | undefined;
    signers: IWPDigiSignerSignerDto[] | undefined;
    events: IWPDigiSignerEventDto[] | undefined;
}

export class IWPDigiSignerEventDto implements IIWPDigiSignerEventDto {
    eventTime!: DateTime;
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIWPDigiSignerEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? DateTime.fromISO(_data["eventTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IWPDigiSignerEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPDigiSignerEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IIWPDigiSignerEventDto {
    eventTime: DateTime;
    title: string | undefined;
    description: string | undefined;
}

export class IWPDigiSignerSignerDto implements IIWPDigiSignerSignerDto {
    role!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    status!: DigitalSignatureStatus;
    statusDisplay!: string | undefined;
    signedTime!: DateTime | undefined;

    constructor(data?: IIWPDigiSignerSignerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.statusDisplay = _data["statusDisplay"];
            this.signedTime = _data["signedTime"] ? DateTime.fromISO(_data["signedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IWPDigiSignerSignerDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPDigiSignerSignerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["name"] = this.name;
        data["email"] = this.email;
        data["status"] = this.status;
        data["statusDisplay"] = this.statusDisplay;
        data["signedTime"] = this.signedTime ? this.signedTime.toString() : <any>undefined;
        return data;
    }
}

export interface IIWPDigiSignerSignerDto {
    role: string | undefined;
    name: string | undefined;
    email: string | undefined;
    status: DigitalSignatureStatus;
    statusDisplay: string | undefined;
    signedTime: DateTime | undefined;
}

export enum IWPDiscussionModality {
    Telephone = 1,
    FaceToFace = 2,
    Other = 3,
}

export class IWPFaxCoverSheetDto implements IIWPFaxCoverSheetDto {
    iwpId!: number;
    enName!: string | undefined;
    enpid!: string | undefined;
    submittedBy!: string | undefined;
    phone!: string | undefined;
    date!: DateTime;
    submissionReason!: IWPFaxSubmissionReason;
    errorMessage!: string | undefined;
    recipientFax!: string;

    constructor(data?: IIWPFaxCoverSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.enName = _data["enName"];
            this.enpid = _data["enpid"];
            this.submittedBy = _data["submittedBy"];
            this.phone = _data["phone"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.submissionReason = _data["submissionReason"];
            this.errorMessage = _data["errorMessage"];
            this.recipientFax = _data["recipientFax"];
        }
    }

    static fromJS(data: any): IWPFaxCoverSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPFaxCoverSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["enName"] = this.enName;
        data["enpid"] = this.enpid;
        data["submittedBy"] = this.submittedBy;
        data["phone"] = this.phone;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["submissionReason"] = this.submissionReason;
        data["errorMessage"] = this.errorMessage;
        data["recipientFax"] = this.recipientFax;
        return data;
    }
}

export interface IIWPFaxCoverSheetDto {
    iwpId: number;
    enName: string | undefined;
    enpid: string | undefined;
    submittedBy: string | undefined;
    phone: string | undefined;
    date: DateTime;
    submissionReason: IWPFaxSubmissionReason;
    errorMessage: string | undefined;
    recipientFax: string;
}

export class IWPFaxHistoryDto implements IIWPFaxHistoryDto {
    id!: number;
    iwpId!: number;
    generatedAt!: DateTime;
    sentAt!: DateTime | undefined;
    sentByName!: string | undefined;
    submittedBy!: string | undefined;
    recipientFax!: string | undefined;
    totalPages!: number;
    submissionReason!: IWPFaxSubmissionReason;
    submissionReasonDisplay!: string | undefined;
    faxPacketDocumentId!: number | undefined;
    status!: ActivityStatus;
    statusDisplay!: string | undefined;

    constructor(data?: IIWPFaxHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.generatedAt = _data["generatedAt"] ? DateTime.fromISO(_data["generatedAt"].toString()) : <any>undefined;
            this.sentAt = _data["sentAt"] ? DateTime.fromISO(_data["sentAt"].toString()) : <any>undefined;
            this.sentByName = _data["sentByName"];
            this.submittedBy = _data["submittedBy"];
            this.recipientFax = _data["recipientFax"];
            this.totalPages = _data["totalPages"];
            this.submissionReason = _data["submissionReason"];
            this.submissionReasonDisplay = _data["submissionReasonDisplay"];
            this.faxPacketDocumentId = _data["faxPacketDocumentId"];
            this.status = _data["status"];
            this.statusDisplay = _data["statusDisplay"];
        }
    }

    static fromJS(data: any): IWPFaxHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPFaxHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toString() : <any>undefined;
        data["sentAt"] = this.sentAt ? this.sentAt.toString() : <any>undefined;
        data["sentByName"] = this.sentByName;
        data["submittedBy"] = this.submittedBy;
        data["recipientFax"] = this.recipientFax;
        data["totalPages"] = this.totalPages;
        data["submissionReason"] = this.submissionReason;
        data["submissionReasonDisplay"] = this.submissionReasonDisplay;
        data["faxPacketDocumentId"] = this.faxPacketDocumentId;
        data["status"] = this.status;
        data["statusDisplay"] = this.statusDisplay;
        return data;
    }
}

export interface IIWPFaxHistoryDto {
    id: number;
    iwpId: number;
    generatedAt: DateTime;
    sentAt: DateTime | undefined;
    sentByName: string | undefined;
    submittedBy: string | undefined;
    recipientFax: string | undefined;
    totalPages: number;
    submissionReason: IWPFaxSubmissionReason;
    submissionReasonDisplay: string | undefined;
    faxPacketDocumentId: number | undefined;
    status: ActivityStatus;
    statusDisplay: string | undefined;
}

export class IWPFaxPacketDto implements IIWPFaxPacketDto {
    faxHistoryId!: number;
    faxPacketDocumentId!: number;
    totalPages!: number;
    recipientFax!: string | undefined;

    constructor(data?: IIWPFaxPacketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faxHistoryId = _data["faxHistoryId"];
            this.faxPacketDocumentId = _data["faxPacketDocumentId"];
            this.totalPages = _data["totalPages"];
            this.recipientFax = _data["recipientFax"];
        }
    }

    static fromJS(data: any): IWPFaxPacketDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPFaxPacketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faxHistoryId"] = this.faxHistoryId;
        data["faxPacketDocumentId"] = this.faxPacketDocumentId;
        data["totalPages"] = this.totalPages;
        data["recipientFax"] = this.recipientFax;
        return data;
    }
}

export interface IIWPFaxPacketDto {
    faxHistoryId: number;
    faxPacketDocumentId: number;
    totalPages: number;
    recipientFax: string | undefined;
}

export enum IWPFaxStatusFilter {
    All = 0,
    NotFaxed = 1,
    InProgress = 2,
    Delivered = 3,
    Failed = 4,
}

export enum IWPFaxSubmissionReason {
    TicketAssignmentReview = 1,
    UnableToAssignViaPortal = 2,
    ServicesAndSupportsReview = 3,
    GeneralReview = 4,
}

export class IWPInterviewSessionDto implements IIWPInterviewSessionDto {
    id!: number | undefined;
    iwpId!: number;
    startTime!: DateTime;
    endTime!: DateTime | undefined;

    constructor(data?: IIWPInterviewSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IWPInterviewSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPInterviewSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface IIWPInterviewSessionDto {
    id: number | undefined;
    iwpId: number;
    startTime: DateTime;
    endTime: DateTime | undefined;
}

export class IWPInterviewSessionWithStatusDto implements IIWPInterviewSessionWithStatusDto {
    iwpStatus!: IWPStatus;
    iwpInterviewSession!: IWPInterviewSessionDto;

    constructor(data?: IIWPInterviewSessionWithStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpStatus = _data["iwpStatus"];
            this.iwpInterviewSession = _data["iwpInterviewSession"] ? IWPInterviewSessionDto.fromJS(_data["iwpInterviewSession"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IWPInterviewSessionWithStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPInterviewSessionWithStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpStatus"] = this.iwpStatus;
        data["iwpInterviewSession"] = this.iwpInterviewSession ? this.iwpInterviewSession.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIWPInterviewSessionWithStatusDto {
    iwpStatus: IWPStatus;
    iwpInterviewSession: IWPInterviewSessionDto;
}

export class IWPQDto implements IIWPQDto {
    iwpId!: number;
    leadId!: number | undefined;
    clientId!: string | undefined;
    ticketHolderId!: number | undefined;
    benefitType!: BenefitType;
    durationInSeconds!: number;
    ticketholderName!: string | undefined;
    ticketholderEncryptedSSN!: string | undefined;
    ticketholderMaskedSSN!: string | undefined;
    ticketholderFullAddress!: string | undefined;
    ticketholderTelephone!: string | undefined;
    iwpStatus!: IWPStatus;
    readonly iwpStatusDisplayName!: string | undefined;
    reviewNotes!: string | undefined;

    constructor(data?: IIWPQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.leadId = _data["leadId"];
            this.clientId = _data["clientId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.benefitType = _data["benefitType"];
            this.durationInSeconds = _data["durationInSeconds"];
            this.ticketholderName = _data["ticketholderName"];
            this.ticketholderEncryptedSSN = _data["ticketholderEncryptedSSN"];
            this.ticketholderMaskedSSN = _data["ticketholderMaskedSSN"];
            this.ticketholderFullAddress = _data["ticketholderFullAddress"];
            this.ticketholderTelephone = _data["ticketholderTelephone"];
            this.iwpStatus = _data["iwpStatus"];
            (<any>this).iwpStatusDisplayName = _data["iwpStatusDisplayName"];
            this.reviewNotes = _data["reviewNotes"];
        }
    }

    static fromJS(data: any): IWPQDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["leadId"] = this.leadId;
        data["clientId"] = this.clientId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["benefitType"] = this.benefitType;
        data["durationInSeconds"] = this.durationInSeconds;
        data["ticketholderName"] = this.ticketholderName;
        data["ticketholderEncryptedSSN"] = this.ticketholderEncryptedSSN;
        data["ticketholderMaskedSSN"] = this.ticketholderMaskedSSN;
        data["ticketholderFullAddress"] = this.ticketholderFullAddress;
        data["ticketholderTelephone"] = this.ticketholderTelephone;
        data["iwpStatus"] = this.iwpStatus;
        data["iwpStatusDisplayName"] = this.iwpStatusDisplayName;
        data["reviewNotes"] = this.reviewNotes;
        return data;
    }
}

export interface IIWPQDto {
    iwpId: number;
    leadId: number | undefined;
    clientId: string | undefined;
    ticketHolderId: number | undefined;
    benefitType: BenefitType;
    durationInSeconds: number;
    ticketholderName: string | undefined;
    ticketholderEncryptedSSN: string | undefined;
    ticketholderMaskedSSN: string | undefined;
    ticketholderFullAddress: string | undefined;
    ticketholderTelephone: string | undefined;
    iwpStatus: IWPStatus;
    iwpStatusDisplayName: string | undefined;
    reviewNotes: string | undefined;
}

export class IWPReviewDto implements IIWPReviewDto {
    iwpId!: number;
    reviewNotes!: string | undefined;
    iwpStatus!: IWPStatus;

    constructor(data?: IIWPReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.reviewNotes = _data["reviewNotes"];
            this.iwpStatus = _data["iwpStatus"];
        }
    }

    static fromJS(data: any): IWPReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["reviewNotes"] = this.reviewNotes;
        data["iwpStatus"] = this.iwpStatus;
        return data;
    }
}

export interface IIWPReviewDto {
    iwpId: number;
    reviewNotes: string | undefined;
    iwpStatus: IWPStatus;
}

export class IWPReviewQueueDto implements IIWPReviewQueueDto {
    iwpId!: number;
    clientId!: string | undefined;
    clientName!: string | undefined;
    careerCoachName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    documentId!: number | undefined;

    constructor(data?: IIWPReviewQueueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.careerCoachName = _data["careerCoachName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): IWPReviewQueueDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPReviewQueueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["careerCoachName"] = this.careerCoachName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IIWPReviewQueueDto {
    iwpId: number;
    clientId: string | undefined;
    clientName: string | undefined;
    careerCoachName: string | undefined;
    lastModificationTime: DateTime | undefined;
    documentId: number | undefined;
}

export class IWPSectionFourDto implements IIWPSectionFourDto {
    id!: number;
    iwpId!: number;
    careerPlanning_BenefitsCounseling!: boolean;
    benefitsCounselingExplanation!: string | undefined;
    careerPlanning_GoalSetting!: boolean;
    goalSettingExplanation!: string | undefined;
    careerPlanning_JobCoaching!: boolean;
    jobCoachingExplanation!: string | undefined;
    careerPlanning_JobDevelopment!: boolean;
    jobDevelopmentExplanation!: string | undefined;
    careerPlanning_Training!: boolean;
    trainingExplanation!: string | undefined;
    careerPlanning_Other!: boolean;
    otherCareerPlanningExplanation!: string | undefined;
    jobPlacement_JobSearch!: boolean;
    jobSearchExplanation!: string | undefined;
    jobPlacement_JobAccommodation!: boolean;
    jobAccommodationExplanation!: string | undefined;
    jobPlacement_JobPlacement!: boolean;
    jobPlacementExplanation!: string | undefined;
    jobPlacement_Other!: boolean;
    otherJobPlacementExplanation!: string | undefined;
    longTerm_FollowUp!: boolean;
    followUpExplanation!: string | undefined;
    longTerm_JobStabilization!: boolean;
    jobStabilizationExplanation!: string | undefined;
    longTerm_CareerAdvancement!: boolean;
    careerAdvancementExplanation!: string | undefined;
    longTerm_Other!: boolean;
    otherLongTermExplanation!: string | undefined;
    enProvidesSupport!: boolean;
    providerNames!: string | undefined;
    coordinatesHealthServices!: boolean;
    healthServicesExplanation!: string | undefined;

    constructor(data?: IIWPSectionFourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.careerPlanning_BenefitsCounseling = _data["careerPlanning_BenefitsCounseling"];
            this.benefitsCounselingExplanation = _data["benefitsCounselingExplanation"];
            this.careerPlanning_GoalSetting = _data["careerPlanning_GoalSetting"];
            this.goalSettingExplanation = _data["goalSettingExplanation"];
            this.careerPlanning_JobCoaching = _data["careerPlanning_JobCoaching"];
            this.jobCoachingExplanation = _data["jobCoachingExplanation"];
            this.careerPlanning_JobDevelopment = _data["careerPlanning_JobDevelopment"];
            this.jobDevelopmentExplanation = _data["jobDevelopmentExplanation"];
            this.careerPlanning_Training = _data["careerPlanning_Training"];
            this.trainingExplanation = _data["trainingExplanation"];
            this.careerPlanning_Other = _data["careerPlanning_Other"];
            this.otherCareerPlanningExplanation = _data["otherCareerPlanningExplanation"];
            this.jobPlacement_JobSearch = _data["jobPlacement_JobSearch"];
            this.jobSearchExplanation = _data["jobSearchExplanation"];
            this.jobPlacement_JobAccommodation = _data["jobPlacement_JobAccommodation"];
            this.jobAccommodationExplanation = _data["jobAccommodationExplanation"];
            this.jobPlacement_JobPlacement = _data["jobPlacement_JobPlacement"];
            this.jobPlacementExplanation = _data["jobPlacementExplanation"];
            this.jobPlacement_Other = _data["jobPlacement_Other"];
            this.otherJobPlacementExplanation = _data["otherJobPlacementExplanation"];
            this.longTerm_FollowUp = _data["longTerm_FollowUp"];
            this.followUpExplanation = _data["followUpExplanation"];
            this.longTerm_JobStabilization = _data["longTerm_JobStabilization"];
            this.jobStabilizationExplanation = _data["jobStabilizationExplanation"];
            this.longTerm_CareerAdvancement = _data["longTerm_CareerAdvancement"];
            this.careerAdvancementExplanation = _data["careerAdvancementExplanation"];
            this.longTerm_Other = _data["longTerm_Other"];
            this.otherLongTermExplanation = _data["otherLongTermExplanation"];
            this.enProvidesSupport = _data["enProvidesSupport"];
            this.providerNames = _data["providerNames"];
            this.coordinatesHealthServices = _data["coordinatesHealthServices"];
            this.healthServicesExplanation = _data["healthServicesExplanation"];
        }
    }

    static fromJS(data: any): IWPSectionFourDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPSectionFourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["careerPlanning_BenefitsCounseling"] = this.careerPlanning_BenefitsCounseling;
        data["benefitsCounselingExplanation"] = this.benefitsCounselingExplanation;
        data["careerPlanning_GoalSetting"] = this.careerPlanning_GoalSetting;
        data["goalSettingExplanation"] = this.goalSettingExplanation;
        data["careerPlanning_JobCoaching"] = this.careerPlanning_JobCoaching;
        data["jobCoachingExplanation"] = this.jobCoachingExplanation;
        data["careerPlanning_JobDevelopment"] = this.careerPlanning_JobDevelopment;
        data["jobDevelopmentExplanation"] = this.jobDevelopmentExplanation;
        data["careerPlanning_Training"] = this.careerPlanning_Training;
        data["trainingExplanation"] = this.trainingExplanation;
        data["careerPlanning_Other"] = this.careerPlanning_Other;
        data["otherCareerPlanningExplanation"] = this.otherCareerPlanningExplanation;
        data["jobPlacement_JobSearch"] = this.jobPlacement_JobSearch;
        data["jobSearchExplanation"] = this.jobSearchExplanation;
        data["jobPlacement_JobAccommodation"] = this.jobPlacement_JobAccommodation;
        data["jobAccommodationExplanation"] = this.jobAccommodationExplanation;
        data["jobPlacement_JobPlacement"] = this.jobPlacement_JobPlacement;
        data["jobPlacementExplanation"] = this.jobPlacementExplanation;
        data["jobPlacement_Other"] = this.jobPlacement_Other;
        data["otherJobPlacementExplanation"] = this.otherJobPlacementExplanation;
        data["longTerm_FollowUp"] = this.longTerm_FollowUp;
        data["followUpExplanation"] = this.followUpExplanation;
        data["longTerm_JobStabilization"] = this.longTerm_JobStabilization;
        data["jobStabilizationExplanation"] = this.jobStabilizationExplanation;
        data["longTerm_CareerAdvancement"] = this.longTerm_CareerAdvancement;
        data["careerAdvancementExplanation"] = this.careerAdvancementExplanation;
        data["longTerm_Other"] = this.longTerm_Other;
        data["otherLongTermExplanation"] = this.otherLongTermExplanation;
        data["enProvidesSupport"] = this.enProvidesSupport;
        data["providerNames"] = this.providerNames;
        data["coordinatesHealthServices"] = this.coordinatesHealthServices;
        data["healthServicesExplanation"] = this.healthServicesExplanation;
        return data;
    }
}

export interface IIWPSectionFourDto {
    id: number;
    iwpId: number;
    careerPlanning_BenefitsCounseling: boolean;
    benefitsCounselingExplanation: string | undefined;
    careerPlanning_GoalSetting: boolean;
    goalSettingExplanation: string | undefined;
    careerPlanning_JobCoaching: boolean;
    jobCoachingExplanation: string | undefined;
    careerPlanning_JobDevelopment: boolean;
    jobDevelopmentExplanation: string | undefined;
    careerPlanning_Training: boolean;
    trainingExplanation: string | undefined;
    careerPlanning_Other: boolean;
    otherCareerPlanningExplanation: string | undefined;
    jobPlacement_JobSearch: boolean;
    jobSearchExplanation: string | undefined;
    jobPlacement_JobAccommodation: boolean;
    jobAccommodationExplanation: string | undefined;
    jobPlacement_JobPlacement: boolean;
    jobPlacementExplanation: string | undefined;
    jobPlacement_Other: boolean;
    otherJobPlacementExplanation: string | undefined;
    longTerm_FollowUp: boolean;
    followUpExplanation: string | undefined;
    longTerm_JobStabilization: boolean;
    jobStabilizationExplanation: string | undefined;
    longTerm_CareerAdvancement: boolean;
    careerAdvancementExplanation: string | undefined;
    longTerm_Other: boolean;
    otherLongTermExplanation: string | undefined;
    enProvidesSupport: boolean;
    providerNames: string | undefined;
    coordinatesHealthServices: boolean;
    healthServicesExplanation: string | undefined;
}

export class IWPSectionOneDto implements IIWPSectionOneDto {
    id!: number;
    iwpId!: number;
    employmentNetworkName!: string | undefined;
    employmentNetworkPID!: string | undefined;
    employmentNetworkAddress!: string | undefined;
    employmentNetworkTelephone!: string | undefined;
    employmentNetworkEmail!: string | undefined;
    employmentNetworkBusinessModel!: IWPBusinessModel;
    ticketholderName!: string | undefined;
    ticketholderEncryptedSSN!: string | undefined;
    ticketholderMaskedSSN!: string | undefined;
    ticketholderRawSSN!: string | undefined;
    ticketholderAddressStreet!: string | undefined;
    ticketholderAddressCity!: string | undefined;
    ticketholderAddressState!: string | undefined;
    ticketholderAddressZipCode!: string | undefined;
    ticketholderTelephone!: string | undefined;
    ticketholderEmail!: string | undefined;
    readonly ticketHolderFullAddress!: string | undefined;
    alternateContactName!: string | undefined;
    alternateContactRelationship!: string | undefined;
    alternateContactAddressStreet!: string | undefined;
    alternateContactAddressCity!: string | undefined;
    alternateContactAddressState!: string | undefined;
    alternateContactAddressZipCode!: string | undefined;
    alternateContactTelephone!: string | undefined;
    alternateContactEmail!: string | undefined;
    readonly alternateFullAddress!: string | undefined;

    constructor(data?: IIWPSectionOneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.employmentNetworkName = _data["employmentNetworkName"];
            this.employmentNetworkPID = _data["employmentNetworkPID"];
            this.employmentNetworkAddress = _data["employmentNetworkAddress"];
            this.employmentNetworkTelephone = _data["employmentNetworkTelephone"];
            this.employmentNetworkEmail = _data["employmentNetworkEmail"];
            this.employmentNetworkBusinessModel = _data["employmentNetworkBusinessModel"];
            this.ticketholderName = _data["ticketholderName"];
            this.ticketholderEncryptedSSN = _data["ticketholderEncryptedSSN"];
            this.ticketholderMaskedSSN = _data["ticketholderMaskedSSN"];
            this.ticketholderRawSSN = _data["ticketholderRawSSN"];
            this.ticketholderAddressStreet = _data["ticketholderAddressStreet"];
            this.ticketholderAddressCity = _data["ticketholderAddressCity"];
            this.ticketholderAddressState = _data["ticketholderAddressState"];
            this.ticketholderAddressZipCode = _data["ticketholderAddressZipCode"];
            this.ticketholderTelephone = _data["ticketholderTelephone"];
            this.ticketholderEmail = _data["ticketholderEmail"];
            (<any>this).ticketHolderFullAddress = _data["ticketHolderFullAddress"];
            this.alternateContactName = _data["alternateContactName"];
            this.alternateContactRelationship = _data["alternateContactRelationship"];
            this.alternateContactAddressStreet = _data["alternateContactAddressStreet"];
            this.alternateContactAddressCity = _data["alternateContactAddressCity"];
            this.alternateContactAddressState = _data["alternateContactAddressState"];
            this.alternateContactAddressZipCode = _data["alternateContactAddressZipCode"];
            this.alternateContactTelephone = _data["alternateContactTelephone"];
            this.alternateContactEmail = _data["alternateContactEmail"];
            (<any>this).alternateFullAddress = _data["alternateFullAddress"];
        }
    }

    static fromJS(data: any): IWPSectionOneDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPSectionOneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["employmentNetworkName"] = this.employmentNetworkName;
        data["employmentNetworkPID"] = this.employmentNetworkPID;
        data["employmentNetworkAddress"] = this.employmentNetworkAddress;
        data["employmentNetworkTelephone"] = this.employmentNetworkTelephone;
        data["employmentNetworkEmail"] = this.employmentNetworkEmail;
        data["employmentNetworkBusinessModel"] = this.employmentNetworkBusinessModel;
        data["ticketholderName"] = this.ticketholderName;
        data["ticketholderEncryptedSSN"] = this.ticketholderEncryptedSSN;
        data["ticketholderMaskedSSN"] = this.ticketholderMaskedSSN;
        data["ticketholderRawSSN"] = this.ticketholderRawSSN;
        data["ticketholderAddressStreet"] = this.ticketholderAddressStreet;
        data["ticketholderAddressCity"] = this.ticketholderAddressCity;
        data["ticketholderAddressState"] = this.ticketholderAddressState;
        data["ticketholderAddressZipCode"] = this.ticketholderAddressZipCode;
        data["ticketholderTelephone"] = this.ticketholderTelephone;
        data["ticketholderEmail"] = this.ticketholderEmail;
        data["ticketHolderFullAddress"] = this.ticketHolderFullAddress;
        data["alternateContactName"] = this.alternateContactName;
        data["alternateContactRelationship"] = this.alternateContactRelationship;
        data["alternateContactAddressStreet"] = this.alternateContactAddressStreet;
        data["alternateContactAddressCity"] = this.alternateContactAddressCity;
        data["alternateContactAddressState"] = this.alternateContactAddressState;
        data["alternateContactAddressZipCode"] = this.alternateContactAddressZipCode;
        data["alternateContactTelephone"] = this.alternateContactTelephone;
        data["alternateContactEmail"] = this.alternateContactEmail;
        data["alternateFullAddress"] = this.alternateFullAddress;
        return data;
    }
}

export interface IIWPSectionOneDto {
    id: number;
    iwpId: number;
    employmentNetworkName: string | undefined;
    employmentNetworkPID: string | undefined;
    employmentNetworkAddress: string | undefined;
    employmentNetworkTelephone: string | undefined;
    employmentNetworkEmail: string | undefined;
    employmentNetworkBusinessModel: IWPBusinessModel;
    ticketholderName: string | undefined;
    ticketholderEncryptedSSN: string | undefined;
    ticketholderMaskedSSN: string | undefined;
    ticketholderRawSSN: string | undefined;
    ticketholderAddressStreet: string | undefined;
    ticketholderAddressCity: string | undefined;
    ticketholderAddressState: string | undefined;
    ticketholderAddressZipCode: string | undefined;
    ticketholderTelephone: string | undefined;
    ticketholderEmail: string | undefined;
    ticketHolderFullAddress: string | undefined;
    alternateContactName: string | undefined;
    alternateContactRelationship: string | undefined;
    alternateContactAddressStreet: string | undefined;
    alternateContactAddressCity: string | undefined;
    alternateContactAddressState: string | undefined;
    alternateContactAddressZipCode: string | undefined;
    alternateContactTelephone: string | undefined;
    alternateContactEmail: string | undefined;
    alternateFullAddress: string | undefined;
}

export class IWPSectionSixDto implements IIWPSectionSixDto {
    clientName!: string | undefined;
    clientEmail!: string | undefined;
    representativeName!: string | undefined;
    representativeEmail!: string | undefined;
    userInputDurationInMinutes!: number;

    constructor(data?: IIWPSectionSixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientEmail = _data["clientEmail"];
            this.representativeName = _data["representativeName"];
            this.representativeEmail = _data["representativeEmail"];
            this.userInputDurationInMinutes = _data["userInputDurationInMinutes"];
        }
    }

    static fromJS(data: any): IWPSectionSixDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPSectionSixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientEmail"] = this.clientEmail;
        data["representativeName"] = this.representativeName;
        data["representativeEmail"] = this.representativeEmail;
        data["userInputDurationInMinutes"] = this.userInputDurationInMinutes;
        return data;
    }
}

export interface IIWPSectionSixDto {
    clientName: string | undefined;
    clientEmail: string | undefined;
    representativeName: string | undefined;
    representativeEmail: string | undefined;
    userInputDurationInMinutes: number;
}

export class IWPSectionThreeDto implements IIWPSectionThreeDto {
    id!: number;
    iwpId!: number;
    shortTermGoal!: string | undefined;
    longTermGoal!: string | undefined;
    hasShortTermExperience!: boolean;
    shortTermExperienceExplanation!: string | undefined;
    hasLongTermExperience!: boolean;
    longTermExperienceExplanation!: string | undefined;
    requiresShortTermSupport!: boolean;
    shortTermSupportExplanation!: string | undefined;
    requiresLongTermSupport!: boolean;
    longTermSupportExplanation!: string | undefined;
    stOccupationType!: string | undefined;
    stPositionAndCompany!: string | undefined;
    stExpectedStartDate!: string | undefined;
    stWeeklyWorkHours!: string | undefined;
    stAnticipatedWages!: string | undefined;
    stEducationTrainingPlans!: string | undefined;
    stTransitionStatement!: string | undefined;
    skillsToDevelop!: string | undefined;
    accommodationNeeds!: string | undefined;
    ltOccupationType!: string | undefined;
    ltPositionAndCompany!: string | undefined;
    ltExpectedStartDate!: string | undefined;
    ltWeeklyWorkHours!: string | undefined;
    ltAnticipatedWages!: string | undefined;
    ltReasonForOccupationSelection!: string | undefined;
    ltEducationTrainingPlans!: string | undefined;

    constructor(data?: IIWPSectionThreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.shortTermGoal = _data["shortTermGoal"];
            this.longTermGoal = _data["longTermGoal"];
            this.hasShortTermExperience = _data["hasShortTermExperience"];
            this.shortTermExperienceExplanation = _data["shortTermExperienceExplanation"];
            this.hasLongTermExperience = _data["hasLongTermExperience"];
            this.longTermExperienceExplanation = _data["longTermExperienceExplanation"];
            this.requiresShortTermSupport = _data["requiresShortTermSupport"];
            this.shortTermSupportExplanation = _data["shortTermSupportExplanation"];
            this.requiresLongTermSupport = _data["requiresLongTermSupport"];
            this.longTermSupportExplanation = _data["longTermSupportExplanation"];
            this.stOccupationType = _data["stOccupationType"];
            this.stPositionAndCompany = _data["stPositionAndCompany"];
            this.stExpectedStartDate = _data["stExpectedStartDate"];
            this.stWeeklyWorkHours = _data["stWeeklyWorkHours"];
            this.stAnticipatedWages = _data["stAnticipatedWages"];
            this.stEducationTrainingPlans = _data["stEducationTrainingPlans"];
            this.stTransitionStatement = _data["stTransitionStatement"];
            this.skillsToDevelop = _data["skillsToDevelop"];
            this.accommodationNeeds = _data["accommodationNeeds"];
            this.ltOccupationType = _data["ltOccupationType"];
            this.ltPositionAndCompany = _data["ltPositionAndCompany"];
            this.ltExpectedStartDate = _data["ltExpectedStartDate"];
            this.ltWeeklyWorkHours = _data["ltWeeklyWorkHours"];
            this.ltAnticipatedWages = _data["ltAnticipatedWages"];
            this.ltReasonForOccupationSelection = _data["ltReasonForOccupationSelection"];
            this.ltEducationTrainingPlans = _data["ltEducationTrainingPlans"];
        }
    }

    static fromJS(data: any): IWPSectionThreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPSectionThreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["shortTermGoal"] = this.shortTermGoal;
        data["longTermGoal"] = this.longTermGoal;
        data["hasShortTermExperience"] = this.hasShortTermExperience;
        data["shortTermExperienceExplanation"] = this.shortTermExperienceExplanation;
        data["hasLongTermExperience"] = this.hasLongTermExperience;
        data["longTermExperienceExplanation"] = this.longTermExperienceExplanation;
        data["requiresShortTermSupport"] = this.requiresShortTermSupport;
        data["shortTermSupportExplanation"] = this.shortTermSupportExplanation;
        data["requiresLongTermSupport"] = this.requiresLongTermSupport;
        data["longTermSupportExplanation"] = this.longTermSupportExplanation;
        data["stOccupationType"] = this.stOccupationType;
        data["stPositionAndCompany"] = this.stPositionAndCompany;
        data["stExpectedStartDate"] = this.stExpectedStartDate;
        data["stWeeklyWorkHours"] = this.stWeeklyWorkHours;
        data["stAnticipatedWages"] = this.stAnticipatedWages;
        data["stEducationTrainingPlans"] = this.stEducationTrainingPlans;
        data["stTransitionStatement"] = this.stTransitionStatement;
        data["skillsToDevelop"] = this.skillsToDevelop;
        data["accommodationNeeds"] = this.accommodationNeeds;
        data["ltOccupationType"] = this.ltOccupationType;
        data["ltPositionAndCompany"] = this.ltPositionAndCompany;
        data["ltExpectedStartDate"] = this.ltExpectedStartDate;
        data["ltWeeklyWorkHours"] = this.ltWeeklyWorkHours;
        data["ltAnticipatedWages"] = this.ltAnticipatedWages;
        data["ltReasonForOccupationSelection"] = this.ltReasonForOccupationSelection;
        data["ltEducationTrainingPlans"] = this.ltEducationTrainingPlans;
        return data;
    }
}

export interface IIWPSectionThreeDto {
    id: number;
    iwpId: number;
    shortTermGoal: string | undefined;
    longTermGoal: string | undefined;
    hasShortTermExperience: boolean;
    shortTermExperienceExplanation: string | undefined;
    hasLongTermExperience: boolean;
    longTermExperienceExplanation: string | undefined;
    requiresShortTermSupport: boolean;
    shortTermSupportExplanation: string | undefined;
    requiresLongTermSupport: boolean;
    longTermSupportExplanation: string | undefined;
    stOccupationType: string | undefined;
    stPositionAndCompany: string | undefined;
    stExpectedStartDate: string | undefined;
    stWeeklyWorkHours: string | undefined;
    stAnticipatedWages: string | undefined;
    stEducationTrainingPlans: string | undefined;
    stTransitionStatement: string | undefined;
    skillsToDevelop: string | undefined;
    accommodationNeeds: string | undefined;
    ltOccupationType: string | undefined;
    ltPositionAndCompany: string | undefined;
    ltExpectedStartDate: string | undefined;
    ltWeeklyWorkHours: string | undefined;
    ltAnticipatedWages: string | undefined;
    ltReasonForOccupationSelection: string | undefined;
    ltEducationTrainingPlans: string | undefined;
}

export class IWPSectionTwoDto implements IIWPSectionTwoDto {
    id!: number;
    iwpId!: number;
    employer!: string | undefined;
    jobTitle!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    hourlyWage!: number;
    weeklyHours!: number;

    constructor(data?: IIWPSectionTwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.employer = _data["employer"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.hourlyWage = _data["hourlyWage"];
            this.weeklyHours = _data["weeklyHours"];
        }
    }

    static fromJS(data: any): IWPSectionTwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPSectionTwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["employer"] = this.employer;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["hourlyWage"] = this.hourlyWage;
        data["weeklyHours"] = this.weeklyHours;
        return data;
    }
}

export interface IIWPSectionTwoDto {
    id: number;
    iwpId: number;
    employer: string | undefined;
    jobTitle: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    hourlyWage: number;
    weeklyHours: number;
}

export class IWPSignSummaryDto implements IIWPSignSummaryDto {
    totalSigned!: number;
    totalUnsigned!: number;

    constructor(data?: IIWPSignSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSigned = _data["totalSigned"];
            this.totalUnsigned = _data["totalUnsigned"];
        }
    }

    static fromJS(data: any): IWPSignSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPSignSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSigned"] = this.totalSigned;
        data["totalUnsigned"] = this.totalUnsigned;
        return data;
    }
}

export interface IIWPSignSummaryDto {
    totalSigned: number;
    totalUnsigned: number;
}

export enum IWPStatus {
    ReadyForIWP = 1,
    WorkingOnIWP = 2,
    WaitingForSignatures = 3,
    WaitingForClientSignature = 4,
    WaitingForRepresentativeSignature = 5,
    SentToSSA = 6,
    DeclinedBySSA = 7,
    Completed = 8,
    SentForReview = 10,
    ApprovedByReviewer = 11,
    RejectedByReviewer = 12,
    Draft = 13,
    DeletedByCC = 14,
}

export class IWPTermsConditionsDto implements IIWPTermsConditionsDto {
    iwpId!: number;
    otherTermsConditions!: boolean;
    otherTermsConditionsExplanation!: string | undefined;

    constructor(data?: IIWPTermsConditionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.otherTermsConditions = _data["otherTermsConditions"];
            this.otherTermsConditionsExplanation = _data["otherTermsConditionsExplanation"];
        }
    }

    static fromJS(data: any): IWPTermsConditionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPTermsConditionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["otherTermsConditions"] = this.otherTermsConditions;
        data["otherTermsConditionsExplanation"] = this.otherTermsConditionsExplanation;
        return data;
    }
}

export interface IIWPTermsConditionsDto {
    iwpId: number;
    otherTermsConditions: boolean;
    otherTermsConditionsExplanation: string | undefined;
}

export class IWPWorkHistoryDto implements IIWPWorkHistoryDto {
    id!: number;
    iwpId!: number;
    employer!: string | undefined;
    jobTitle!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    hourlyWage!: number;
    weeklyHours!: number;

    constructor(data?: IIWPWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.iwpId = _data["iwpId"];
            this.employer = _data["employer"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.hourlyWage = _data["hourlyWage"];
            this.weeklyHours = _data["weeklyHours"];
        }
    }

    static fromJS(data: any): IWPWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IWPWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["iwpId"] = this.iwpId;
        data["employer"] = this.employer;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["hourlyWage"] = this.hourlyWage;
        data["weeklyHours"] = this.weeklyHours;
        return data;
    }
}

export interface IIWPWorkHistoryDto {
    id: number;
    iwpId: number;
    employer: string | undefined;
    jobTitle: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    hourlyWage: number;
    weeklyHours: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImpersonateTenantInput implements IImpersonateTenantInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateTenantInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateUserInput implements IImpersonateUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ImportLeadUploadDto implements IImportLeadUploadDto {
    fileQueueId!: number;
    fileName!: string | undefined;
    fileSize!: string | undefined;
    batchId!: string | undefined;

    constructor(data?: IImportLeadUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileQueueId = _data["fileQueueId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): ImportLeadUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportLeadUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileQueueId"] = this.fileQueueId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["batchId"] = this.batchId;
        return data;
    }
}

export interface IImportLeadUploadDto {
    fileQueueId: number;
    fileName: string | undefined;
    fileSize: string | undefined;
    batchId: string | undefined;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class IncomingEventDto implements IIncomingEventDto {
    id!: number;
    channel!: string | undefined;
    serviceName!: string | undefined;
    status!: string | undefined;
    attemptCount!: number;
    uniqueId!: string | undefined;
    errorMessage!: string | undefined;
    creationTime!: DateTime;
    processedTime!: DateTime | undefined;

    constructor(data?: IIncomingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channel = _data["channel"];
            this.serviceName = _data["serviceName"];
            this.status = _data["status"];
            this.attemptCount = _data["attemptCount"];
            this.uniqueId = _data["uniqueId"];
            this.errorMessage = _data["errorMessage"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.processedTime = _data["processedTime"] ? DateTime.fromISO(_data["processedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncomingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channel"] = this.channel;
        data["serviceName"] = this.serviceName;
        data["status"] = this.status;
        data["attemptCount"] = this.attemptCount;
        data["uniqueId"] = this.uniqueId;
        data["errorMessage"] = this.errorMessage;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["processedTime"] = this.processedTime ? this.processedTime.toString() : <any>undefined;
        return data;
    }
}

export interface IIncomingEventDto {
    id: number;
    channel: string | undefined;
    serviceName: string | undefined;
    status: string | undefined;
    attemptCount: number;
    uniqueId: string | undefined;
    errorMessage: string | undefined;
    creationTime: DateTime;
    processedTime: DateTime | undefined;
}

export class InsertOrUpdateAllValuesInput implements IInsertOrUpdateAllValuesInput {
    items!: InsertOrUpdateAllValuesInputItem[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InsertOrUpdateAllValuesInputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInput {
    items: InsertOrUpdateAllValuesInputItem[] | undefined;
}

export class InsertOrUpdateAllValuesInputItem implements IInsertOrUpdateAllValuesInputItem {
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    values!: string[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInputItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInputItem {
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    values: string[] | undefined;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {
}

export class IntakeRecordDto implements IIntakeRecordDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    maskedSSN!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    age!: number | undefined;
    intakeDate!: DateTime;
    cwicUserId!: number;
    cwicUserName!: string | undefined;
    referralSource!: ReferralSource;
    referralSourceOther!: string | undefined;
    medicareClaimNumber!: string | undefined;
    medicaidNumber!: string | undefined;
    age18RedeterminationDone!: boolean | undefined;
    disabledPriorAge26!: boolean | undefined;
    hasABLEAccount!: boolean | undefined;
    primaryDisability!: string | undefined;
    statutoryBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    isVeteran!: boolean | undefined;
    maritalStatus!: MaritalStatus;
    householdMeansTestedBenefitDetail!: string | undefined;
    ssiIncomeInKindDetail!: string | undefined;
    hasMySSAAccount!: MySSAAccountStatus;
    bsaDeliveryMethod!: PreferredContactMethod;
    bsaDeliveryMethodOther!: string | undefined;
    highestGradeCompleted!: HighestGradeCompleted;
    educationalGoals!: string | undefined;
    wantsEliminateBenefits!: boolean | undefined;
    wantsReduceBenefitDependence!: boolean | undefined;
    neededEmploymentServices!: string | undefined;
    consentToShareBSA!: boolean | undefined;
    consentToShareBSADate!: DateTime | undefined;
    consentToShareBSAWith!: string | undefined;
    irweOrBWEExpenses!: string | undefined;
    specialEmploymentSupports!: string | undefined;
    notes!: string | undefined;
    currentEmployment!: CurrentEmploymentDto;
    householdMembers!: HouseholdMemberDto[] | undefined;
    contactInfos!: ContactInfoDto[] | undefined;
    earningsGoals!: EarningsGoalDto[] | undefined;
    employmentServices!: EmploymentServiceDto[] | undefined;
    excludedResources!: ExcludedResourceDto[] | undefined;
    pastEmployments!: PastEmploymentDto[] | undefined;
    benefitsAtIntake!: BenefitAtIntakeDto[] | undefined;
    additionalBenefits!: AdditionalBenefitDto[] | undefined;

    constructor(data?: IIntakeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.maskedSSN = _data["maskedSSN"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.intakeDate = _data["intakeDate"] ? DateTime.fromISO(_data["intakeDate"].toString()) : <any>undefined;
            this.cwicUserId = _data["cwicUserId"];
            this.cwicUserName = _data["cwicUserName"];
            this.referralSource = _data["referralSource"];
            this.referralSourceOther = _data["referralSourceOther"];
            this.medicareClaimNumber = _data["medicareClaimNumber"];
            this.medicaidNumber = _data["medicaidNumber"];
            this.age18RedeterminationDone = _data["age18RedeterminationDone"];
            this.disabledPriorAge26 = _data["disabledPriorAge26"];
            this.hasABLEAccount = _data["hasABLEAccount"];
            this.primaryDisability = _data["primaryDisability"];
            this.statutoryBlind = _data["statutoryBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.isVeteran = _data["isVeteran"];
            this.maritalStatus = _data["maritalStatus"];
            this.householdMeansTestedBenefitDetail = _data["householdMeansTestedBenefitDetail"];
            this.ssiIncomeInKindDetail = _data["ssiIncomeInKindDetail"];
            this.hasMySSAAccount = _data["hasMySSAAccount"];
            this.bsaDeliveryMethod = _data["bsaDeliveryMethod"];
            this.bsaDeliveryMethodOther = _data["bsaDeliveryMethodOther"];
            this.highestGradeCompleted = _data["highestGradeCompleted"];
            this.educationalGoals = _data["educationalGoals"];
            this.wantsEliminateBenefits = _data["wantsEliminateBenefits"];
            this.wantsReduceBenefitDependence = _data["wantsReduceBenefitDependence"];
            this.neededEmploymentServices = _data["neededEmploymentServices"];
            this.consentToShareBSA = _data["consentToShareBSA"];
            this.consentToShareBSADate = _data["consentToShareBSADate"] ? DateTime.fromISO(_data["consentToShareBSADate"].toString()) : <any>undefined;
            this.consentToShareBSAWith = _data["consentToShareBSAWith"];
            this.irweOrBWEExpenses = _data["irweOrBWEExpenses"];
            this.specialEmploymentSupports = _data["specialEmploymentSupports"];
            this.notes = _data["notes"];
            this.currentEmployment = _data["currentEmployment"] ? CurrentEmploymentDto.fromJS(_data["currentEmployment"]) : <any>undefined;
            if (Array.isArray(_data["householdMembers"])) {
                this.householdMembers = [] as any;
                for (let item of _data["householdMembers"])
                    this.householdMembers!.push(HouseholdMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(ContactInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["earningsGoals"])) {
                this.earningsGoals = [] as any;
                for (let item of _data["earningsGoals"])
                    this.earningsGoals!.push(EarningsGoalDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentServices"])) {
                this.employmentServices = [] as any;
                for (let item of _data["employmentServices"])
                    this.employmentServices!.push(EmploymentServiceDto.fromJS(item));
            }
            if (Array.isArray(_data["excludedResources"])) {
                this.excludedResources = [] as any;
                for (let item of _data["excludedResources"])
                    this.excludedResources!.push(ExcludedResourceDto.fromJS(item));
            }
            if (Array.isArray(_data["pastEmployments"])) {
                this.pastEmployments = [] as any;
                for (let item of _data["pastEmployments"])
                    this.pastEmployments!.push(PastEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["benefitsAtIntake"])) {
                this.benefitsAtIntake = [] as any;
                for (let item of _data["benefitsAtIntake"])
                    this.benefitsAtIntake!.push(BenefitAtIntakeDto.fromJS(item));
            }
            if (Array.isArray(_data["additionalBenefits"])) {
                this.additionalBenefits = [] as any;
                for (let item of _data["additionalBenefits"])
                    this.additionalBenefits!.push(AdditionalBenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntakeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntakeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["maskedSSN"] = this.maskedSSN;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
        data["age"] = this.age;
        data["intakeDate"] = this.intakeDate ? this.intakeDate.toString() : <any>undefined;
        data["cwicUserId"] = this.cwicUserId;
        data["cwicUserName"] = this.cwicUserName;
        data["referralSource"] = this.referralSource;
        data["referralSourceOther"] = this.referralSourceOther;
        data["medicareClaimNumber"] = this.medicareClaimNumber;
        data["medicaidNumber"] = this.medicaidNumber;
        data["age18RedeterminationDone"] = this.age18RedeterminationDone;
        data["disabledPriorAge26"] = this.disabledPriorAge26;
        data["hasABLEAccount"] = this.hasABLEAccount;
        data["primaryDisability"] = this.primaryDisability;
        data["statutoryBlind"] = this.statutoryBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toString() : <any>undefined;
        data["isVeteran"] = this.isVeteran;
        data["maritalStatus"] = this.maritalStatus;
        data["householdMeansTestedBenefitDetail"] = this.householdMeansTestedBenefitDetail;
        data["ssiIncomeInKindDetail"] = this.ssiIncomeInKindDetail;
        data["hasMySSAAccount"] = this.hasMySSAAccount;
        data["bsaDeliveryMethod"] = this.bsaDeliveryMethod;
        data["bsaDeliveryMethodOther"] = this.bsaDeliveryMethodOther;
        data["highestGradeCompleted"] = this.highestGradeCompleted;
        data["educationalGoals"] = this.educationalGoals;
        data["wantsEliminateBenefits"] = this.wantsEliminateBenefits;
        data["wantsReduceBenefitDependence"] = this.wantsReduceBenefitDependence;
        data["neededEmploymentServices"] = this.neededEmploymentServices;
        data["consentToShareBSA"] = this.consentToShareBSA;
        data["consentToShareBSADate"] = this.consentToShareBSADate ? this.consentToShareBSADate.toString() : <any>undefined;
        data["consentToShareBSAWith"] = this.consentToShareBSAWith;
        data["irweOrBWEExpenses"] = this.irweOrBWEExpenses;
        data["specialEmploymentSupports"] = this.specialEmploymentSupports;
        data["notes"] = this.notes;
        data["currentEmployment"] = this.currentEmployment ? this.currentEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.householdMembers)) {
            data["householdMembers"] = [];
            for (let item of this.householdMembers)
                data["householdMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.earningsGoals)) {
            data["earningsGoals"] = [];
            for (let item of this.earningsGoals)
                data["earningsGoals"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentServices)) {
            data["employmentServices"] = [];
            for (let item of this.employmentServices)
                data["employmentServices"].push(item.toJSON());
        }
        if (Array.isArray(this.excludedResources)) {
            data["excludedResources"] = [];
            for (let item of this.excludedResources)
                data["excludedResources"].push(item.toJSON());
        }
        if (Array.isArray(this.pastEmployments)) {
            data["pastEmployments"] = [];
            for (let item of this.pastEmployments)
                data["pastEmployments"].push(item.toJSON());
        }
        if (Array.isArray(this.benefitsAtIntake)) {
            data["benefitsAtIntake"] = [];
            for (let item of this.benefitsAtIntake)
                data["benefitsAtIntake"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalBenefits)) {
            data["additionalBenefits"] = [];
            for (let item of this.additionalBenefits)
                data["additionalBenefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIntakeRecordDto {
    id: number;
    benefitsCounselingCaseId: number;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    maskedSSN: string | undefined;
    dateOfBirth: DateTime | undefined;
    age: number | undefined;
    intakeDate: DateTime;
    cwicUserId: number;
    cwicUserName: string | undefined;
    referralSource: ReferralSource;
    referralSourceOther: string | undefined;
    medicareClaimNumber: string | undefined;
    medicaidNumber: string | undefined;
    age18RedeterminationDone: boolean | undefined;
    disabledPriorAge26: boolean | undefined;
    hasABLEAccount: boolean | undefined;
    primaryDisability: string | undefined;
    statutoryBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    isVeteran: boolean | undefined;
    maritalStatus: MaritalStatus;
    householdMeansTestedBenefitDetail: string | undefined;
    ssiIncomeInKindDetail: string | undefined;
    hasMySSAAccount: MySSAAccountStatus;
    bsaDeliveryMethod: PreferredContactMethod;
    bsaDeliveryMethodOther: string | undefined;
    highestGradeCompleted: HighestGradeCompleted;
    educationalGoals: string | undefined;
    wantsEliminateBenefits: boolean | undefined;
    wantsReduceBenefitDependence: boolean | undefined;
    neededEmploymentServices: string | undefined;
    consentToShareBSA: boolean | undefined;
    consentToShareBSADate: DateTime | undefined;
    consentToShareBSAWith: string | undefined;
    irweOrBWEExpenses: string | undefined;
    specialEmploymentSupports: string | undefined;
    notes: string | undefined;
    currentEmployment: CurrentEmploymentDto;
    householdMembers: HouseholdMemberDto[] | undefined;
    contactInfos: ContactInfoDto[] | undefined;
    earningsGoals: EarningsGoalDto[] | undefined;
    employmentServices: EmploymentServiceDto[] | undefined;
    excludedResources: ExcludedResourceDto[] | undefined;
    pastEmployments: PastEmploymentDto[] | undefined;
    benefitsAtIntake: BenefitAtIntakeDto[] | undefined;
    additionalBenefits: AdditionalBenefitDto[] | undefined;
}

export class InterestedLeadManagementDto implements IInterestedLeadManagementDto {
    leadId!: number;
    clientId!: string | undefined;
    clientName!: string | undefined;
    benefitType!: BenefitType;
    leadStage!: LeadStage;
    assigneeId!: number | undefined;
    assigneeName!: string | undefined;
    assignedDate!: DateTime | undefined;
    acknowledgedByUserId!: number | undefined;
    acknowledgedByName!: string | undefined;
    acknowledgedDate!: DateTime | undefined;
    createdByName!: string | undefined;
    creationTime!: DateTime;
    isReferralLead!: boolean;
    readonly needsAcknowledgement!: boolean;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: IInterestedLeadManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.benefitType = _data["benefitType"];
            this.leadStage = _data["leadStage"];
            this.assigneeId = _data["assigneeId"];
            this.assigneeName = _data["assigneeName"];
            this.assignedDate = _data["assignedDate"] ? DateTime.fromISO(_data["assignedDate"].toString()) : <any>undefined;
            this.acknowledgedByUserId = _data["acknowledgedByUserId"];
            this.acknowledgedByName = _data["acknowledgedByName"];
            this.acknowledgedDate = _data["acknowledgedDate"] ? DateTime.fromISO(_data["acknowledgedDate"].toString()) : <any>undefined;
            this.createdByName = _data["createdByName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isReferralLead = _data["isReferralLead"];
            (<any>this).needsAcknowledgement = _data["needsAcknowledgement"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InterestedLeadManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterestedLeadManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["benefitType"] = this.benefitType;
        data["leadStage"] = this.leadStage;
        data["assigneeId"] = this.assigneeId;
        data["assigneeName"] = this.assigneeName;
        data["assignedDate"] = this.assignedDate ? this.assignedDate.toString() : <any>undefined;
        data["acknowledgedByUserId"] = this.acknowledgedByUserId;
        data["acknowledgedByName"] = this.acknowledgedByName;
        data["acknowledgedDate"] = this.acknowledgedDate ? this.acknowledgedDate.toString() : <any>undefined;
        data["createdByName"] = this.createdByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isReferralLead"] = this.isReferralLead;
        data["needsAcknowledgement"] = this.needsAcknowledgement;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IInterestedLeadManagementDto {
    leadId: number;
    clientId: string | undefined;
    clientName: string | undefined;
    benefitType: BenefitType;
    leadStage: LeadStage;
    assigneeId: number | undefined;
    assigneeName: string | undefined;
    assignedDate: DateTime | undefined;
    acknowledgedByUserId: number | undefined;
    acknowledgedByName: string | undefined;
    acknowledgedDate: DateTime | undefined;
    createdByName: string | undefined;
    creationTime: DateTime;
    isReferralLead: boolean;
    needsAcknowledgement: boolean;
    lastModificationTime: DateTime | undefined;
}

export enum InterestedLeadManagementTab {
    Interested = 1,
    IwpPending = 2,
    IwpCompleted = 3,
}

export class InterviewAssistanceServiceRequestDto implements IInterviewAssistanceServiceRequestDto {
    id!: number;
    ticketHolderId!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    interviewDateTime!: DateTime | undefined;
    interviewLocation!: string | undefined;
    interviewers!: string | undefined;
    interviewType!: InterviewType;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: IInterviewAssistanceServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.interviewDateTime = _data["interviewDateTime"] ? DateTime.fromISO(_data["interviewDateTime"].toString()) : <any>undefined;
            this.interviewLocation = _data["interviewLocation"];
            this.interviewers = _data["interviewers"];
            this.interviewType = _data["interviewType"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InterviewAssistanceServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterviewAssistanceServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["interviewDateTime"] = this.interviewDateTime ? this.interviewDateTime.toString() : <any>undefined;
        data["interviewLocation"] = this.interviewLocation;
        data["interviewers"] = this.interviewers;
        data["interviewType"] = this.interviewType;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface IInterviewAssistanceServiceRequestDto {
    id: number;
    ticketHolderId: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    interviewDateTime: DateTime | undefined;
    interviewLocation: string | undefined;
    interviewers: string | undefined;
    interviewType: InterviewType;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class InterviewDetailsDto implements IInterviewDetailsDto {
    method!: string | undefined;
    interviewRound!: string | undefined;
    localTime!: string | undefined;
    timeZone!: string | undefined;
    interviewerName!: string | undefined;
    interviewerContact!: string | undefined;

    constructor(data?: IInterviewDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
            this.interviewRound = _data["interviewRound"];
            this.localTime = _data["localTime"];
            this.timeZone = _data["timeZone"];
            this.interviewerName = _data["interviewerName"];
            this.interviewerContact = _data["interviewerContact"];
        }
    }

    static fromJS(data: any): InterviewDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterviewDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["interviewRound"] = this.interviewRound;
        data["localTime"] = this.localTime;
        data["timeZone"] = this.timeZone;
        data["interviewerName"] = this.interviewerName;
        data["interviewerContact"] = this.interviewerContact;
        return data;
    }
}

export interface IInterviewDetailsDto {
    method: string | undefined;
    interviewRound: string | undefined;
    localTime: string | undefined;
    timeZone: string | undefined;
    interviewerName: string | undefined;
    interviewerContact: string | undefined;
}

export enum InterviewMethod {
    NotSpecified = 0,
    Phone = 1,
    Video = 2,
    InPerson = 3,
}

export enum InterviewOutcome {
    Unknown = 0,
    Passed = 1,
    Failed = 2,
    Pending = 3,
    Rescheduled = 4,
    Canceled = 5,
}

export enum InterviewRound {
    Unknown = 0,
    First = 1,
    Second = 2,
    Final = 3,
    HrScreening = 4,
    Technical = 5,
    Managerial = 6,
}

export enum InterviewType {
    HRScreen = 0,
    TechnicalInterview = 1,
    DrugTest = 2,
    FinalRound = 3,
    BehavioralInterview = 4,
    Other = 5,
}

export enum InvitationStatus {
    Active = 1,
    Expired = 2,
    Accepted = 3,
    Revoked = 4,
}

export class InvitationStatusDto implements IInvitationStatusDto {
    id!: number;
    benefitsCounselingCaseId!: number;
    url!: string | undefined;
    status!: InvitationStatus;
    expiresAt!: DateTime;
    submittedDate!: DateTime | undefined;
    acceptedDate!: DateTime | undefined;

    constructor(data?: IInvitationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.url = _data["url"];
            this.status = _data["status"];
            this.expiresAt = _data["expiresAt"] ? DateTime.fromISO(_data["expiresAt"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.acceptedDate = _data["acceptedDate"] ? DateTime.fromISO(_data["acceptedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvitationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["url"] = this.url;
        data["status"] = this.status;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IInvitationStatusDto {
    id: number;
    benefitsCounselingCaseId: number;
    url: string | undefined;
    status: InvitationStatus;
    expiresAt: DateTime;
    submittedDate: DateTime | undefined;
    acceptedDate: DateTime | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    items!: SubscriptionPaymentProductDto[] | undefined;
    totalAmount!: number;
    invoiceNo!: string | undefined;
    invoiceDate!: DateTime;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentProductDto.fromJS(item));
            }
            this.totalAmount = _data["totalAmount"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalAmount"] = this.totalAmount;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    items: SubscriptionPaymentProductDto[] | undefined;
    totalAmount: number;
    invoiceNo: string | undefined;
    invoiceDate: DateTime;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class IwpGeneratorDraftDto implements IIwpGeneratorDraftDto {
    id!: number;
    name!: string | undefined;
    stOccupationType!: string | undefined;
    stPositionAndCompany!: string | undefined;
    stExpectedStartDate!: string | undefined;
    stWeeklyWorkHours!: string | undefined;
    stAnticipatedWages!: string | undefined;
    stEducationTrainingPlans!: string | undefined;
    stTransitionStatement!: string | undefined;
    skillsToDevelop!: string | undefined;
    accommodationNeeds!: string | undefined;
    ltOccupationType!: string | undefined;
    ltPositionAndCompany!: string | undefined;
    ltExpectedStartDate!: string | undefined;
    ltWeeklyWorkHours!: string | undefined;
    ltAnticipatedWages!: string | undefined;
    ltReasonForOccupationSelection!: string | undefined;
    ltEducationTrainingPlans!: string | undefined;

    constructor(data?: IIwpGeneratorDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stOccupationType = _data["stOccupationType"];
            this.stPositionAndCompany = _data["stPositionAndCompany"];
            this.stExpectedStartDate = _data["stExpectedStartDate"];
            this.stWeeklyWorkHours = _data["stWeeklyWorkHours"];
            this.stAnticipatedWages = _data["stAnticipatedWages"];
            this.stEducationTrainingPlans = _data["stEducationTrainingPlans"];
            this.stTransitionStatement = _data["stTransitionStatement"];
            this.skillsToDevelop = _data["skillsToDevelop"];
            this.accommodationNeeds = _data["accommodationNeeds"];
            this.ltOccupationType = _data["ltOccupationType"];
            this.ltPositionAndCompany = _data["ltPositionAndCompany"];
            this.ltExpectedStartDate = _data["ltExpectedStartDate"];
            this.ltWeeklyWorkHours = _data["ltWeeklyWorkHours"];
            this.ltAnticipatedWages = _data["ltAnticipatedWages"];
            this.ltReasonForOccupationSelection = _data["ltReasonForOccupationSelection"];
            this.ltEducationTrainingPlans = _data["ltEducationTrainingPlans"];
        }
    }

    static fromJS(data: any): IwpGeneratorDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new IwpGeneratorDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stOccupationType"] = this.stOccupationType;
        data["stPositionAndCompany"] = this.stPositionAndCompany;
        data["stExpectedStartDate"] = this.stExpectedStartDate;
        data["stWeeklyWorkHours"] = this.stWeeklyWorkHours;
        data["stAnticipatedWages"] = this.stAnticipatedWages;
        data["stEducationTrainingPlans"] = this.stEducationTrainingPlans;
        data["stTransitionStatement"] = this.stTransitionStatement;
        data["skillsToDevelop"] = this.skillsToDevelop;
        data["accommodationNeeds"] = this.accommodationNeeds;
        data["ltOccupationType"] = this.ltOccupationType;
        data["ltPositionAndCompany"] = this.ltPositionAndCompany;
        data["ltExpectedStartDate"] = this.ltExpectedStartDate;
        data["ltWeeklyWorkHours"] = this.ltWeeklyWorkHours;
        data["ltAnticipatedWages"] = this.ltAnticipatedWages;
        data["ltReasonForOccupationSelection"] = this.ltReasonForOccupationSelection;
        data["ltEducationTrainingPlans"] = this.ltEducationTrainingPlans;
        return data;
    }
}

export interface IIwpGeneratorDraftDto {
    id: number;
    name: string | undefined;
    stOccupationType: string | undefined;
    stPositionAndCompany: string | undefined;
    stExpectedStartDate: string | undefined;
    stWeeklyWorkHours: string | undefined;
    stAnticipatedWages: string | undefined;
    stEducationTrainingPlans: string | undefined;
    stTransitionStatement: string | undefined;
    skillsToDevelop: string | undefined;
    accommodationNeeds: string | undefined;
    ltOccupationType: string | undefined;
    ltPositionAndCompany: string | undefined;
    ltExpectedStartDate: string | undefined;
    ltWeeklyWorkHours: string | undefined;
    ltAnticipatedWages: string | undefined;
    ltReasonForOccupationSelection: string | undefined;
    ltEducationTrainingPlans: string | undefined;
}

export class JSACCDto implements IJSACCDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IJSACCDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): JSACCDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSACCDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IJSACCDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
}

export class JSACopiedToRequestDto implements IJSACopiedToRequestDto {
    jobLeadId!: number;
    jobSearchRequestId!: number | undefined;
    formattedJobSearchRequestId!: string | undefined;
    formattedTicketHolderId!: string | undefined;
    jobKeywords!: string | undefined;

    constructor(data?: IJSACopiedToRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLeadId = _data["jobLeadId"];
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.formattedJobSearchRequestId = _data["formattedJobSearchRequestId"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.jobKeywords = _data["jobKeywords"];
        }
    }

    static fromJS(data: any): JSACopiedToRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSACopiedToRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLeadId"] = this.jobLeadId;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["formattedJobSearchRequestId"] = this.formattedJobSearchRequestId;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["jobKeywords"] = this.jobKeywords;
        return data;
    }
}

export interface IJSACopiedToRequestDto {
    jobLeadId: number;
    jobSearchRequestId: number | undefined;
    formattedJobSearchRequestId: string | undefined;
    formattedTicketHolderId: string | undefined;
    jobKeywords: string | undefined;
}

export class JSACreateJobLeadDto implements IJSACreateJobLeadDto {
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    importantNotes!: string | undefined;
    locationDistance!: number | undefined;
    copiedFromJobLeadId!: number | undefined;

    constructor(data?: IJSACreateJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.importantNotes = _data["importantNotes"];
            this.locationDistance = _data["locationDistance"];
            this.copiedFromJobLeadId = _data["copiedFromJobLeadId"];
        }
    }

    static fromJS(data: any): JSACreateJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSACreateJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["importantNotes"] = this.importantNotes;
        data["locationDistance"] = this.locationDistance;
        data["copiedFromJobLeadId"] = this.copiedFromJobLeadId;
        return data;
    }
}

export interface IJSACreateJobLeadDto {
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    importantNotes: string | undefined;
    locationDistance: number | undefined;
    copiedFromJobLeadId: number | undefined;
}

export class JSAJobLeadDto implements IJSAJobLeadDto {
    id!: number;
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    readonly enumDisplayWorkArrangement!: string | undefined;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    status!: JobApplicationStatus;
    readonly formattedJobLeadId!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    importantNotes!: string | undefined;
    reason!: string | undefined;
    roundNumber!: number;
    isApplied!: boolean | undefined;
    locationDistance!: number | undefined;
    copiedFromJobLeadId!: number | undefined;
    copiedToRequests!: JSACopiedToRequestDto[] | undefined;

    constructor(data?: IJSAJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            (<any>this).enumDisplayWorkArrangement = _data["enumDisplayWorkArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.status = _data["status"];
            (<any>this).formattedJobLeadId = _data["formattedJobLeadId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.importantNotes = _data["importantNotes"];
            this.reason = _data["reason"];
            this.roundNumber = _data["roundNumber"];
            this.isApplied = _data["isApplied"];
            this.locationDistance = _data["locationDistance"];
            this.copiedFromJobLeadId = _data["copiedFromJobLeadId"];
            if (Array.isArray(_data["copiedToRequests"])) {
                this.copiedToRequests = [] as any;
                for (let item of _data["copiedToRequests"])
                    this.copiedToRequests!.push(JSACopiedToRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JSAJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["enumDisplayWorkArrangement"] = this.enumDisplayWorkArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["status"] = this.status;
        data["formattedJobLeadId"] = this.formattedJobLeadId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["importantNotes"] = this.importantNotes;
        data["reason"] = this.reason;
        data["roundNumber"] = this.roundNumber;
        data["isApplied"] = this.isApplied;
        data["locationDistance"] = this.locationDistance;
        data["copiedFromJobLeadId"] = this.copiedFromJobLeadId;
        if (Array.isArray(this.copiedToRequests)) {
            data["copiedToRequests"] = [];
            for (let item of this.copiedToRequests)
                data["copiedToRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJSAJobLeadDto {
    id: number;
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    enumDisplayWorkArrangement: string | undefined;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    status: JobApplicationStatus;
    formattedJobLeadId: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    importantNotes: string | undefined;
    reason: string | undefined;
    roundNumber: number;
    isApplied: boolean | undefined;
    locationDistance: number | undefined;
    copiedFromJobLeadId: number | undefined;
    copiedToRequests: JSACopiedToRequestDto[] | undefined;
}

export class JSAJobSearchRequestDropdownItemDto implements IJSAJobSearchRequestDropdownItemDto {
    id!: number;
    formattedJobSearchRequestId!: string | undefined;
    jobTitle!: string | undefined;
    formattedTicketHolderId!: string | undefined;
    status!: JobSearchRequestStatus;
    ticketHolderId!: number;

    constructor(data?: IJSAJobSearchRequestDropdownItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formattedJobSearchRequestId = _data["formattedJobSearchRequestId"];
            this.jobTitle = _data["jobTitle"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.status = _data["status"];
            this.ticketHolderId = _data["ticketHolderId"];
        }
    }

    static fromJS(data: any): JSAJobSearchRequestDropdownItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAJobSearchRequestDropdownItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formattedJobSearchRequestId"] = this.formattedJobSearchRequestId;
        data["jobTitle"] = this.jobTitle;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["status"] = this.status;
        data["ticketHolderId"] = this.ticketHolderId;
        return data;
    }
}

export interface IJSAJobSearchRequestDropdownItemDto {
    id: number;
    formattedJobSearchRequestId: string | undefined;
    jobTitle: string | undefined;
    formattedTicketHolderId: string | undefined;
    status: JobSearchRequestStatus;
    ticketHolderId: number;
}

export class JSAJobSearchRequestDto implements IJSAJobSearchRequestDto {
    id!: number;
    searchRequestedBy!: number;
    searchRequestedByName!: string | undefined;
    jobSearchKeywords!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    readonly enumDisplayWorkArrangement!: string | undefined;
    jobSearchType!: JobSearchType;
    readonly enumDisplayJobSearchType!: string | undefined;
    isSalaryRangeHourly!: boolean;
    salaryRangeStart!: number | undefined;
    salaryRangeEnd!: number | undefined;
    notes!: NoteEntry[] | undefined;
    status!: JobSearchRequestStatus;
    readonly enumDisplayJobSearchRequest!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    jobLeadsCount!: number;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    desiredJobCount!: number | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    jobSearchRequestId!: string | undefined;
    readonly formattedJobSearchRequestId!: string | undefined;
    sentJobLeadToTHCount!: number;
    formattedTicketHolderId!: string | undefined;
    currentRound!: number;
    preferredDayOfWeek!: WeekDays;
    skillsQualifications!: string | undefined;
    instructions!: string | undefined;
    maxTravelDistance!: number | undefined;
    maxTravelTime!: number | undefined;
    totalRounds!: number;
    ticketHolderStatus!: TicketHolderStatus;
    readonly enumDisplayTicketHolderStatus!: string | undefined;
    ticketHolderDoB!: DateTime | undefined;
    ticketHolderStateAbbreviation!: string | undefined;
    latestRoundCreationTime!: DateTime | undefined;
    roundSummaries!: RoundLeadSummaryDto[] | undefined;

    constructor(data?: IJSAJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchRequestedBy = _data["searchRequestedBy"];
            this.searchRequestedByName = _data["searchRequestedByName"];
            this.jobSearchKeywords = _data["jobSearchKeywords"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            (<any>this).enumDisplayWorkArrangement = _data["enumDisplayWorkArrangement"];
            this.jobSearchType = _data["jobSearchType"];
            (<any>this).enumDisplayJobSearchType = _data["enumDisplayJobSearchType"];
            this.isSalaryRangeHourly = _data["isSalaryRangeHourly"];
            this.salaryRangeStart = _data["salaryRangeStart"];
            this.salaryRangeEnd = _data["salaryRangeEnd"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteEntry.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).enumDisplayJobSearchRequest = _data["enumDisplayJobSearchRequest"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.jobLeadsCount = _data["jobLeadsCount"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.desiredJobCount = _data["desiredJobCount"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            (<any>this).formattedJobSearchRequestId = _data["formattedJobSearchRequestId"];
            this.sentJobLeadToTHCount = _data["sentJobLeadToTHCount"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.currentRound = _data["currentRound"];
            this.preferredDayOfWeek = _data["preferredDayOfWeek"];
            this.skillsQualifications = _data["skillsQualifications"];
            this.instructions = _data["instructions"];
            this.maxTravelDistance = _data["maxTravelDistance"];
            this.maxTravelTime = _data["maxTravelTime"];
            this.totalRounds = _data["totalRounds"];
            this.ticketHolderStatus = _data["ticketHolderStatus"];
            (<any>this).enumDisplayTicketHolderStatus = _data["enumDisplayTicketHolderStatus"];
            this.ticketHolderDoB = _data["ticketHolderDoB"] ? DateTime.fromISO(_data["ticketHolderDoB"].toString()) : <any>undefined;
            this.ticketHolderStateAbbreviation = _data["ticketHolderStateAbbreviation"];
            this.latestRoundCreationTime = _data["latestRoundCreationTime"] ? DateTime.fromISO(_data["latestRoundCreationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roundSummaries"])) {
                this.roundSummaries = [] as any;
                for (let item of _data["roundSummaries"])
                    this.roundSummaries!.push(RoundLeadSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JSAJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchRequestedBy"] = this.searchRequestedBy;
        data["searchRequestedByName"] = this.searchRequestedByName;
        data["jobSearchKeywords"] = this.jobSearchKeywords;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["enumDisplayWorkArrangement"] = this.enumDisplayWorkArrangement;
        data["jobSearchType"] = this.jobSearchType;
        data["enumDisplayJobSearchType"] = this.enumDisplayJobSearchType;
        data["isSalaryRangeHourly"] = this.isSalaryRangeHourly;
        data["salaryRangeStart"] = this.salaryRangeStart;
        data["salaryRangeEnd"] = this.salaryRangeEnd;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["enumDisplayJobSearchRequest"] = this.enumDisplayJobSearchRequest;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["jobLeadsCount"] = this.jobLeadsCount;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["desiredJobCount"] = this.desiredJobCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["formattedJobSearchRequestId"] = this.formattedJobSearchRequestId;
        data["sentJobLeadToTHCount"] = this.sentJobLeadToTHCount;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["currentRound"] = this.currentRound;
        data["preferredDayOfWeek"] = this.preferredDayOfWeek;
        data["skillsQualifications"] = this.skillsQualifications;
        data["instructions"] = this.instructions;
        data["maxTravelDistance"] = this.maxTravelDistance;
        data["maxTravelTime"] = this.maxTravelTime;
        data["totalRounds"] = this.totalRounds;
        data["ticketHolderStatus"] = this.ticketHolderStatus;
        data["enumDisplayTicketHolderStatus"] = this.enumDisplayTicketHolderStatus;
        data["ticketHolderDoB"] = this.ticketHolderDoB ? this.ticketHolderDoB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ticketHolderStateAbbreviation"] = this.ticketHolderStateAbbreviation;
        data["latestRoundCreationTime"] = this.latestRoundCreationTime ? this.latestRoundCreationTime.toString() : <any>undefined;
        if (Array.isArray(this.roundSummaries)) {
            data["roundSummaries"] = [];
            for (let item of this.roundSummaries)
                data["roundSummaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJSAJobSearchRequestDto {
    id: number;
    searchRequestedBy: number;
    searchRequestedByName: string | undefined;
    jobSearchKeywords: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    enumDisplayWorkArrangement: string | undefined;
    jobSearchType: JobSearchType;
    enumDisplayJobSearchType: string | undefined;
    isSalaryRangeHourly: boolean;
    salaryRangeStart: number | undefined;
    salaryRangeEnd: number | undefined;
    notes: NoteEntry[] | undefined;
    status: JobSearchRequestStatus;
    enumDisplayJobSearchRequest: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    jobLeadsCount: number;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    desiredJobCount: number | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    jobSearchRequestId: string | undefined;
    formattedJobSearchRequestId: string | undefined;
    sentJobLeadToTHCount: number;
    formattedTicketHolderId: string | undefined;
    currentRound: number;
    preferredDayOfWeek: WeekDays;
    skillsQualifications: string | undefined;
    instructions: string | undefined;
    maxTravelDistance: number | undefined;
    maxTravelTime: number | undefined;
    totalRounds: number;
    ticketHolderStatus: TicketHolderStatus;
    enumDisplayTicketHolderStatus: string | undefined;
    ticketHolderDoB: DateTime | undefined;
    ticketHolderStateAbbreviation: string | undefined;
    latestRoundCreationTime: DateTime | undefined;
    roundSummaries: RoundLeadSummaryDto[] | undefined;
}

export class JSAJobSearchRequestFilterDto implements IJSAJobSearchRequestFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    jobSearchRequestStatusFilters!: JobSearchRequestStatus[] | undefined;
    sentFrom!: DateTime | undefined;
    sentTo!: DateTime | undefined;

    constructor(data?: IJSAJobSearchRequestFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jobSearchRequestStatusFilters"])) {
                this.jobSearchRequestStatusFilters = [] as any;
                for (let item of _data["jobSearchRequestStatusFilters"])
                    this.jobSearchRequestStatusFilters!.push(item);
            }
            this.sentFrom = _data["sentFrom"] ? DateTime.fromISO(_data["sentFrom"].toString()) : <any>undefined;
            this.sentTo = _data["sentTo"] ? DateTime.fromISO(_data["sentTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JSAJobSearchRequestFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAJobSearchRequestFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        if (Array.isArray(this.jobSearchRequestStatusFilters)) {
            data["jobSearchRequestStatusFilters"] = [];
            for (let item of this.jobSearchRequestStatusFilters)
                data["jobSearchRequestStatusFilters"].push(item);
        }
        data["sentFrom"] = this.sentFrom ? this.sentFrom.toString() : <any>undefined;
        data["sentTo"] = this.sentTo ? this.sentTo.toString() : <any>undefined;
        return data;
    }
}

export interface IJSAJobSearchRequestFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    jobSearchRequestStatusFilters: JobSearchRequestStatus[] | undefined;
    sentFrom: DateTime | undefined;
    sentTo: DateTime | undefined;
}

export class JSAMJobSearchRequestFilterDto implements IJSAMJobSearchRequestFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    jobSearchRequestStatusFilters!: JobSearchRequestStatus[] | undefined;
    sentFrom!: DateTime | undefined;
    sentTo!: DateTime | undefined;
    isClosed!: boolean | undefined;
    assignedToUserIds!: number[] | undefined;
    preferredDayOfWeekFilters!: WeekDays[] | undefined;
    ticketHolderStatusFilters!: TicketHolderStatus[] | undefined;
    ticketHolderIds!: number[] | undefined;

    constructor(data?: IJSAMJobSearchRequestFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jobSearchRequestStatusFilters"])) {
                this.jobSearchRequestStatusFilters = [] as any;
                for (let item of _data["jobSearchRequestStatusFilters"])
                    this.jobSearchRequestStatusFilters!.push(item);
            }
            this.sentFrom = _data["sentFrom"] ? DateTime.fromISO(_data["sentFrom"].toString()) : <any>undefined;
            this.sentTo = _data["sentTo"] ? DateTime.fromISO(_data["sentTo"].toString()) : <any>undefined;
            this.isClosed = _data["isClosed"];
            if (Array.isArray(_data["assignedToUserIds"])) {
                this.assignedToUserIds = [] as any;
                for (let item of _data["assignedToUserIds"])
                    this.assignedToUserIds!.push(item);
            }
            if (Array.isArray(_data["preferredDayOfWeekFilters"])) {
                this.preferredDayOfWeekFilters = [] as any;
                for (let item of _data["preferredDayOfWeekFilters"])
                    this.preferredDayOfWeekFilters!.push(item);
            }
            if (Array.isArray(_data["ticketHolderStatusFilters"])) {
                this.ticketHolderStatusFilters = [] as any;
                for (let item of _data["ticketHolderStatusFilters"])
                    this.ticketHolderStatusFilters!.push(item);
            }
            if (Array.isArray(_data["ticketHolderIds"])) {
                this.ticketHolderIds = [] as any;
                for (let item of _data["ticketHolderIds"])
                    this.ticketHolderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): JSAMJobSearchRequestFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAMJobSearchRequestFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        if (Array.isArray(this.jobSearchRequestStatusFilters)) {
            data["jobSearchRequestStatusFilters"] = [];
            for (let item of this.jobSearchRequestStatusFilters)
                data["jobSearchRequestStatusFilters"].push(item);
        }
        data["sentFrom"] = this.sentFrom ? this.sentFrom.toString() : <any>undefined;
        data["sentTo"] = this.sentTo ? this.sentTo.toString() : <any>undefined;
        data["isClosed"] = this.isClosed;
        if (Array.isArray(this.assignedToUserIds)) {
            data["assignedToUserIds"] = [];
            for (let item of this.assignedToUserIds)
                data["assignedToUserIds"].push(item);
        }
        if (Array.isArray(this.preferredDayOfWeekFilters)) {
            data["preferredDayOfWeekFilters"] = [];
            for (let item of this.preferredDayOfWeekFilters)
                data["preferredDayOfWeekFilters"].push(item);
        }
        if (Array.isArray(this.ticketHolderStatusFilters)) {
            data["ticketHolderStatusFilters"] = [];
            for (let item of this.ticketHolderStatusFilters)
                data["ticketHolderStatusFilters"].push(item);
        }
        if (Array.isArray(this.ticketHolderIds)) {
            data["ticketHolderIds"] = [];
            for (let item of this.ticketHolderIds)
                data["ticketHolderIds"].push(item);
        }
        return data;
    }
}

export interface IJSAMJobSearchRequestFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    jobSearchRequestStatusFilters: JobSearchRequestStatus[] | undefined;
    sentFrom: DateTime | undefined;
    sentTo: DateTime | undefined;
    isClosed: boolean | undefined;
    assignedToUserIds: number[] | undefined;
    preferredDayOfWeekFilters: WeekDays[] | undefined;
    ticketHolderStatusFilters: TicketHolderStatus[] | undefined;
    ticketHolderIds: number[] | undefined;
}

export class JSAUpdateJobLeadDto implements IJSAUpdateJobLeadDto {
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    importantNotes!: string | undefined;
    locationDistance!: number | undefined;
    copiedFromJobLeadId!: number | undefined;
    id!: number;

    constructor(data?: IJSAUpdateJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.importantNotes = _data["importantNotes"];
            this.locationDistance = _data["locationDistance"];
            this.copiedFromJobLeadId = _data["copiedFromJobLeadId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JSAUpdateJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAUpdateJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["importantNotes"] = this.importantNotes;
        data["locationDistance"] = this.locationDistance;
        data["copiedFromJobLeadId"] = this.copiedFromJobLeadId;
        data["id"] = this.id;
        return data;
    }
}

export interface IJSAUpdateJobLeadDto {
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    importantNotes: string | undefined;
    locationDistance: number | undefined;
    copiedFromJobLeadId: number | undefined;
    id: number;
}

export class JSAUpdateJobSearchAsSearchCompleteReqDto implements IJSAUpdateJobSearchAsSearchCompleteReqDto {
    jobSearchRequestId!: number;
    note!: string | undefined;

    constructor(data?: IJSAUpdateJobSearchAsSearchCompleteReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): JSAUpdateJobSearchAsSearchCompleteReqDto {
        data = typeof data === 'object' ? data : {};
        let result = new JSAUpdateJobSearchAsSearchCompleteReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["note"] = this.note;
        return data;
    }
}

export interface IJSAUpdateJobSearchAsSearchCompleteReqDto {
    jobSearchRequestId: number;
    note: string | undefined;
}

export enum JobApplicationStatus {
    NewByCC = 0,
    NewBySearchAssistant = 1,
    PendingReviewByCC = 2,
    CanceledByCC = 3,
    PendingReviewByTH = 4,
    AppliedByTH = 5,
    PendingApplyByCC = 6,
    AppliedByCC = 7,
    InterviewScheduled = 8,
    Interviewed = 9,
    Offered = 10,
    OfferAccepted = 11,
    OfferRejected = 12,
    UnableToApply = 13,
    Archived = 14,
    Expired = 15,
}

export class JobApplicationStatusDto implements IJobApplicationStatusDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IJobApplicationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): JobApplicationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IJobApplicationStatusDto {
    id: number;
    name: string | undefined;
}

export class JobApplicationStatusGroupDto implements IJobApplicationStatusGroupDto {
    pendingReviewByTHCount!: number;
    pendingApplyByCCCount!: number;
    appliedCount!: number;
    rejectedCount!: number;
    archivedCount!: number;

    constructor(data?: IJobApplicationStatusGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingReviewByTHCount = _data["pendingReviewByTHCount"];
            this.pendingApplyByCCCount = _data["pendingApplyByCCCount"];
            this.appliedCount = _data["appliedCount"];
            this.rejectedCount = _data["rejectedCount"];
            this.archivedCount = _data["archivedCount"];
        }
    }

    static fromJS(data: any): JobApplicationStatusGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationStatusGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingReviewByTHCount"] = this.pendingReviewByTHCount;
        data["pendingApplyByCCCount"] = this.pendingApplyByCCCount;
        data["appliedCount"] = this.appliedCount;
        data["rejectedCount"] = this.rejectedCount;
        data["archivedCount"] = this.archivedCount;
        return data;
    }
}

export interface IJobApplicationStatusGroupDto {
    pendingReviewByTHCount: number;
    pendingApplyByCCCount: number;
    appliedCount: number;
    rejectedCount: number;
    archivedCount: number;
}

export class JobLeadFilterDto implements IJobLeadFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    filterText!: string | undefined;
    workArrangement!: WorkArrangement[] | undefined;
    postedStartDate!: DateTime | undefined;
    postedEndDate!: DateTime | undefined;
    appliedStartDate!: DateTime | undefined;
    appliedEndDate!: DateTime | undefined;
    roundNumber!: number | undefined;
    statuses!: JobApplicationStatus[] | undefined;

    constructor(data?: IJobLeadFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.filterText = _data["filterText"];
            if (Array.isArray(_data["workArrangement"])) {
                this.workArrangement = [] as any;
                for (let item of _data["workArrangement"])
                    this.workArrangement!.push(item);
            }
            this.postedStartDate = _data["postedStartDate"] ? DateTime.fromISO(_data["postedStartDate"].toString()) : <any>undefined;
            this.postedEndDate = _data["postedEndDate"] ? DateTime.fromISO(_data["postedEndDate"].toString()) : <any>undefined;
            this.appliedStartDate = _data["appliedStartDate"] ? DateTime.fromISO(_data["appliedStartDate"].toString()) : <any>undefined;
            this.appliedEndDate = _data["appliedEndDate"] ? DateTime.fromISO(_data["appliedEndDate"].toString()) : <any>undefined;
            this.roundNumber = _data["roundNumber"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static fromJS(data: any): JobLeadFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLeadFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["filterText"] = this.filterText;
        if (Array.isArray(this.workArrangement)) {
            data["workArrangement"] = [];
            for (let item of this.workArrangement)
                data["workArrangement"].push(item);
        }
        data["postedStartDate"] = this.postedStartDate ? this.postedStartDate.toString() : <any>undefined;
        data["postedEndDate"] = this.postedEndDate ? this.postedEndDate.toString() : <any>undefined;
        data["appliedStartDate"] = this.appliedStartDate ? this.appliedStartDate.toString() : <any>undefined;
        data["appliedEndDate"] = this.appliedEndDate ? this.appliedEndDate.toString() : <any>undefined;
        data["roundNumber"] = this.roundNumber;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        return data;
    }
}

export interface IJobLeadFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    filterText: string | undefined;
    workArrangement: WorkArrangement[] | undefined;
    postedStartDate: DateTime | undefined;
    postedEndDate: DateTime | undefined;
    appliedStartDate: DateTime | undefined;
    appliedEndDate: DateTime | undefined;
    roundNumber: number | undefined;
    statuses: JobApplicationStatus[] | undefined;
}

export class JobLeadSampleDto implements IJobLeadSampleDto {
    jobTitle!: string | undefined;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: string | undefined;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    importantNotes!: string | undefined;
    locationDistance!: number | undefined;

    constructor(data?: IJobLeadSampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.importantNotes = _data["importantNotes"];
            this.locationDistance = _data["locationDistance"];
        }
    }

    static fromJS(data: any): JobLeadSampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLeadSampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["importantNotes"] = this.importantNotes;
        data["locationDistance"] = this.locationDistance;
        return data;
    }
}

export interface IJobLeadSampleDto {
    jobTitle: string | undefined;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: string | undefined;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    importantNotes: string | undefined;
    locationDistance: number | undefined;
}

export enum JobProcessingStatus {
    Pending = 0,
    Running = 1,
    Completed = 2,
    Failed = 3,
    Canceled = 4,
    Scheduled = 5,
    Delayed = 6,
    Retry = 7,
    Paused = 8,
}

export class JobSearchRequestByCareerCoachFilterDto implements IJobSearchRequestByCareerCoachFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    isClosed!: boolean | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    jobSearchStatusFilters!: JobSearchRequestStatus[] | undefined;
    assignedToUserIds!: number[] | undefined;
    preferredDayOfWeekFilters!: WeekDays[] | undefined;

    constructor(data?: IJobSearchRequestByCareerCoachFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.isClosed = _data["isClosed"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["jobSearchStatusFilters"])) {
                this.jobSearchStatusFilters = [] as any;
                for (let item of _data["jobSearchStatusFilters"])
                    this.jobSearchStatusFilters!.push(item);
            }
            if (Array.isArray(_data["assignedToUserIds"])) {
                this.assignedToUserIds = [] as any;
                for (let item of _data["assignedToUserIds"])
                    this.assignedToUserIds!.push(item);
            }
            if (Array.isArray(_data["preferredDayOfWeekFilters"])) {
                this.preferredDayOfWeekFilters = [] as any;
                for (let item of _data["preferredDayOfWeekFilters"])
                    this.preferredDayOfWeekFilters!.push(item);
            }
        }
    }

    static fromJS(data: any): JobSearchRequestByCareerCoachFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchRequestByCareerCoachFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["isClosed"] = this.isClosed;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        if (Array.isArray(this.jobSearchStatusFilters)) {
            data["jobSearchStatusFilters"] = [];
            for (let item of this.jobSearchStatusFilters)
                data["jobSearchStatusFilters"].push(item);
        }
        if (Array.isArray(this.assignedToUserIds)) {
            data["assignedToUserIds"] = [];
            for (let item of this.assignedToUserIds)
                data["assignedToUserIds"].push(item);
        }
        if (Array.isArray(this.preferredDayOfWeekFilters)) {
            data["preferredDayOfWeekFilters"] = [];
            for (let item of this.preferredDayOfWeekFilters)
                data["preferredDayOfWeekFilters"].push(item);
        }
        return data;
    }
}

export interface IJobSearchRequestByCareerCoachFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    isClosed: boolean | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    jobSearchStatusFilters: JobSearchRequestStatus[] | undefined;
    assignedToUserIds: number[] | undefined;
    preferredDayOfWeekFilters: WeekDays[] | undefined;
}

export class JobSearchRequestDto implements IJobSearchRequestDto {
    id!: number;
    searchRequestedBy!: number;
    searchRequestedByName!: string | undefined;
    jobSearchKeywords!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    readonly enumDisplayWorkArrangement!: string | undefined;
    jobSearchType!: JobSearchType;
    readonly enumDisplayJobSearchType!: string | undefined;
    isSalaryRangeHourly!: boolean;
    salaryRangeStart!: number | undefined;
    salaryRangeEnd!: number | undefined;
    notes!: NoteEntry[] | undefined;
    status!: JobSearchRequestStatus;
    readonly enumDisplayJobSearchRequest!: string | undefined;
    assignedToUserId!: number | undefined;
    assignedToUserName!: string | undefined;
    jobLeadsCount!: number;
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    desiredJobCount!: number | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    jobSearchRequestId!: string | undefined;
    readonly formattedJobSearchRequestId!: string | undefined;
    sentJobLeadToTHCount!: number;
    formattedTicketHolderId!: string | undefined;
    currentRound!: number;
    latestRoundCreationTime!: DateTime | undefined;
    skillsQualifications!: string | undefined;
    instructions!: string | undefined;
    maxTravelDistance!: number | undefined;
    maxTravelTime!: number | undefined;
    totalRounds!: number;
    ticketHolderStatus!: TicketHolderStatus;
    readonly enumDisplayTicketHolderStatus!: string | undefined;
    ticketHolderDoB!: DateTime | undefined;
    ticketHolderStateAbbreviation!: string | undefined;
    ccNotes!: string | undefined;
    ticketHolderEmail!: string | undefined;
    preferredDayOfWeek!: WeekDays;
    enumPreferredDayOfWeek!: string | undefined;
    roundSummaries!: RoundLeadSummaryDto[] | undefined;

    constructor(data?: IJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchRequestedBy = _data["searchRequestedBy"];
            this.searchRequestedByName = _data["searchRequestedByName"];
            this.jobSearchKeywords = _data["jobSearchKeywords"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            (<any>this).enumDisplayWorkArrangement = _data["enumDisplayWorkArrangement"];
            this.jobSearchType = _data["jobSearchType"];
            (<any>this).enumDisplayJobSearchType = _data["enumDisplayJobSearchType"];
            this.isSalaryRangeHourly = _data["isSalaryRangeHourly"];
            this.salaryRangeStart = _data["salaryRangeStart"];
            this.salaryRangeEnd = _data["salaryRangeEnd"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteEntry.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).enumDisplayJobSearchRequest = _data["enumDisplayJobSearchRequest"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUserName = _data["assignedToUserName"];
            this.jobLeadsCount = _data["jobLeadsCount"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.desiredJobCount = _data["desiredJobCount"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            (<any>this).formattedJobSearchRequestId = _data["formattedJobSearchRequestId"];
            this.sentJobLeadToTHCount = _data["sentJobLeadToTHCount"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.currentRound = _data["currentRound"];
            this.latestRoundCreationTime = _data["latestRoundCreationTime"] ? DateTime.fromISO(_data["latestRoundCreationTime"].toString()) : <any>undefined;
            this.skillsQualifications = _data["skillsQualifications"];
            this.instructions = _data["instructions"];
            this.maxTravelDistance = _data["maxTravelDistance"];
            this.maxTravelTime = _data["maxTravelTime"];
            this.totalRounds = _data["totalRounds"];
            this.ticketHolderStatus = _data["ticketHolderStatus"];
            (<any>this).enumDisplayTicketHolderStatus = _data["enumDisplayTicketHolderStatus"];
            this.ticketHolderDoB = _data["ticketHolderDoB"] ? DateTime.fromISO(_data["ticketHolderDoB"].toString()) : <any>undefined;
            this.ticketHolderStateAbbreviation = _data["ticketHolderStateAbbreviation"];
            this.ccNotes = _data["ccNotes"];
            this.ticketHolderEmail = _data["ticketHolderEmail"];
            this.preferredDayOfWeek = _data["preferredDayOfWeek"];
            this.enumPreferredDayOfWeek = _data["enumPreferredDayOfWeek"];
            if (Array.isArray(_data["roundSummaries"])) {
                this.roundSummaries = [] as any;
                for (let item of _data["roundSummaries"])
                    this.roundSummaries!.push(RoundLeadSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchRequestedBy"] = this.searchRequestedBy;
        data["searchRequestedByName"] = this.searchRequestedByName;
        data["jobSearchKeywords"] = this.jobSearchKeywords;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["enumDisplayWorkArrangement"] = this.enumDisplayWorkArrangement;
        data["jobSearchType"] = this.jobSearchType;
        data["enumDisplayJobSearchType"] = this.enumDisplayJobSearchType;
        data["isSalaryRangeHourly"] = this.isSalaryRangeHourly;
        data["salaryRangeStart"] = this.salaryRangeStart;
        data["salaryRangeEnd"] = this.salaryRangeEnd;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["enumDisplayJobSearchRequest"] = this.enumDisplayJobSearchRequest;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUserName"] = this.assignedToUserName;
        data["jobLeadsCount"] = this.jobLeadsCount;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["desiredJobCount"] = this.desiredJobCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["formattedJobSearchRequestId"] = this.formattedJobSearchRequestId;
        data["sentJobLeadToTHCount"] = this.sentJobLeadToTHCount;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["currentRound"] = this.currentRound;
        data["latestRoundCreationTime"] = this.latestRoundCreationTime ? this.latestRoundCreationTime.toString() : <any>undefined;
        data["skillsQualifications"] = this.skillsQualifications;
        data["instructions"] = this.instructions;
        data["maxTravelDistance"] = this.maxTravelDistance;
        data["maxTravelTime"] = this.maxTravelTime;
        data["totalRounds"] = this.totalRounds;
        data["ticketHolderStatus"] = this.ticketHolderStatus;
        data["enumDisplayTicketHolderStatus"] = this.enumDisplayTicketHolderStatus;
        data["ticketHolderDoB"] = this.ticketHolderDoB ? this.ticketHolderDoB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ticketHolderStateAbbreviation"] = this.ticketHolderStateAbbreviation;
        data["ccNotes"] = this.ccNotes;
        data["ticketHolderEmail"] = this.ticketHolderEmail;
        data["preferredDayOfWeek"] = this.preferredDayOfWeek;
        data["enumPreferredDayOfWeek"] = this.enumPreferredDayOfWeek;
        if (Array.isArray(this.roundSummaries)) {
            data["roundSummaries"] = [];
            for (let item of this.roundSummaries)
                data["roundSummaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobSearchRequestDto {
    id: number;
    searchRequestedBy: number;
    searchRequestedByName: string | undefined;
    jobSearchKeywords: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    enumDisplayWorkArrangement: string | undefined;
    jobSearchType: JobSearchType;
    enumDisplayJobSearchType: string | undefined;
    isSalaryRangeHourly: boolean;
    salaryRangeStart: number | undefined;
    salaryRangeEnd: number | undefined;
    notes: NoteEntry[] | undefined;
    status: JobSearchRequestStatus;
    enumDisplayJobSearchRequest: string | undefined;
    assignedToUserId: number | undefined;
    assignedToUserName: string | undefined;
    jobLeadsCount: number;
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    desiredJobCount: number | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    jobSearchRequestId: string | undefined;
    formattedJobSearchRequestId: string | undefined;
    sentJobLeadToTHCount: number;
    formattedTicketHolderId: string | undefined;
    currentRound: number;
    latestRoundCreationTime: DateTime | undefined;
    skillsQualifications: string | undefined;
    instructions: string | undefined;
    maxTravelDistance: number | undefined;
    maxTravelTime: number | undefined;
    totalRounds: number;
    ticketHolderStatus: TicketHolderStatus;
    enumDisplayTicketHolderStatus: string | undefined;
    ticketHolderDoB: DateTime | undefined;
    ticketHolderStateAbbreviation: string | undefined;
    ccNotes: string | undefined;
    ticketHolderEmail: string | undefined;
    preferredDayOfWeek: WeekDays;
    enumPreferredDayOfWeek: string | undefined;
    roundSummaries: RoundLeadSummaryDto[] | undefined;
}

export class JobSearchRequestFilterDto implements IJobSearchRequestFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    ticketHolderId!: number;
    filter!: string | undefined;
    jobSearchStatusFilters!: JobSearchRequestStatus[] | undefined;
    sentFrom!: DateTime | undefined;
    sentTo!: DateTime | undefined;
    isClosed!: boolean | undefined;

    constructor(data?: IJobSearchRequestFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jobSearchStatusFilters"])) {
                this.jobSearchStatusFilters = [] as any;
                for (let item of _data["jobSearchStatusFilters"])
                    this.jobSearchStatusFilters!.push(item);
            }
            this.sentFrom = _data["sentFrom"] ? DateTime.fromISO(_data["sentFrom"].toString()) : <any>undefined;
            this.sentTo = _data["sentTo"] ? DateTime.fromISO(_data["sentTo"].toString()) : <any>undefined;
            this.isClosed = _data["isClosed"];
        }
    }

    static fromJS(data: any): JobSearchRequestFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchRequestFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["ticketHolderId"] = this.ticketHolderId;
        data["filter"] = this.filter;
        if (Array.isArray(this.jobSearchStatusFilters)) {
            data["jobSearchStatusFilters"] = [];
            for (let item of this.jobSearchStatusFilters)
                data["jobSearchStatusFilters"].push(item);
        }
        data["sentFrom"] = this.sentFrom ? this.sentFrom.toString() : <any>undefined;
        data["sentTo"] = this.sentTo ? this.sentTo.toString() : <any>undefined;
        data["isClosed"] = this.isClosed;
        return data;
    }
}

export interface IJobSearchRequestFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    ticketHolderId: number;
    filter: string | undefined;
    jobSearchStatusFilters: JobSearchRequestStatus[] | undefined;
    sentFrom: DateTime | undefined;
    sentTo: DateTime | undefined;
    isClosed: boolean | undefined;
}

export enum JobSearchRequestStatus {
    Pending = 0,
    SearchInProgress = 1,
    SearchCompleted = 2,
    Canceled = 3,
    ReviewInProgress = 4,
    Reopened = 5,
    Closed = 6,
    Paused = 7,
}

export class JobSearchRoundStatusSummaryDto implements IJobSearchRoundStatusSummaryDto {
    workingRounds!: number;
    pending!: number;
    searchInProgress!: number;
    searchCompleted!: number;
    paused!: number;

    constructor(data?: IJobSearchRoundStatusSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workingRounds = _data["workingRounds"];
            this.pending = _data["pending"];
            this.searchInProgress = _data["searchInProgress"];
            this.searchCompleted = _data["searchCompleted"];
            this.paused = _data["paused"];
        }
    }

    static fromJS(data: any): JobSearchRoundStatusSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchRoundStatusSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workingRounds"] = this.workingRounds;
        data["pending"] = this.pending;
        data["searchInProgress"] = this.searchInProgress;
        data["searchCompleted"] = this.searchCompleted;
        data["paused"] = this.paused;
        return data;
    }
}

export interface IJobSearchRoundStatusSummaryDto {
    workingRounds: number;
    pending: number;
    searchInProgress: number;
    searchCompleted: number;
    paused: number;
}

export enum JobSearchType {
    FullTime = 1,
    PartTime = 2,
    Contract = 4,
    Temporary = 8,
    Freelance = 16,
    Internship = 32,
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export enum Language {
    English = 1,
    EnglishUK = 2,
    Arabic = 3,
    German = 4,
    Italian = 5,
    French = 6,
    PortugueseBrazil = 7,
    Turkish = 8,
    Russian = 9,
    ChineseSimplified = 10,
    SpanishMexico = 11,
    Spanish = 12,
    Vietnamese = 13,
    Dutch = 14,
    Thai = 15,
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export enum LayoutKind {
    Sequential = 0,
    Explicit = 2,
    Auto = 3,
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;
    useSsl!: boolean;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.useSsl = _data["useSsl"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["useSsl"] = this.useSsl;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    useSsl: boolean;
}

export class LeadActivityAttachmentDto implements ILeadActivityAttachmentDto {
    id!: number;
    leadActivityId!: number;
    fileName!: string | undefined;
    filePath!: string | undefined;
    contentType!: string | undefined;

    constructor(data?: ILeadActivityAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadActivityId = _data["leadActivityId"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): LeadActivityAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadActivityAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadActivityId"] = this.leadActivityId;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ILeadActivityAttachmentDto {
    id: number;
    leadActivityId: number;
    fileName: string | undefined;
    filePath: string | undefined;
    contentType: string | undefined;
}

export class LeadActivityOutputDto implements ILeadActivityOutputDto {
    leadId!: number;
    activityType!: ContactType;
    direction!: ActivityDirection;
    contactInfo!: string | undefined;
    subject!: string | undefined;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    serviceType!: ActivityServiceType;
    enumDisplayServiceType!: string | undefined;
    startTime!: DateTime;
    attachments!: LeadActivityAttachmentDto[] | undefined;
    id!: number;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    logId!: number | undefined;
    hasAttachments!: boolean;

    constructor(data?: ILeadActivityOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.activityType = _data["activityType"];
            this.direction = _data["direction"];
            this.contactInfo = _data["contactInfo"];
            this.subject = _data["subject"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.enumDisplayServiceType = _data["enumDisplayServiceType"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(LeadActivityAttachmentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.logId = _data["logId"];
            this.hasAttachments = _data["hasAttachments"];
        }
    }

    static fromJS(data: any): LeadActivityOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadActivityOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["activityType"] = this.activityType;
        data["direction"] = this.direction;
        data["contactInfo"] = this.contactInfo;
        data["subject"] = this.subject;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["enumDisplayServiceType"] = this.enumDisplayServiceType;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["logId"] = this.logId;
        data["hasAttachments"] = this.hasAttachments;
        return data;
    }
}

export interface ILeadActivityOutputDto {
    leadId: number;
    activityType: ContactType;
    direction: ActivityDirection;
    contactInfo: string | undefined;
    subject: string | undefined;
    activityContent: string | undefined;
    status: ActivityStatus;
    serviceType: ActivityServiceType;
    enumDisplayServiceType: string | undefined;
    startTime: DateTime;
    attachments: LeadActivityAttachmentDto[] | undefined;
    id: number;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    logId: number | undefined;
    hasAttachments: boolean;
}

export class LeadApplicationLinkStatusDto implements ILeadApplicationLinkStatusDto {
    id!: number;
    leadId!: number;
    url!: string | undefined;
    status!: InvitationStatus;
    expiresAt!: DateTime;
    submittedDate!: DateTime | undefined;
    acceptedDate!: DateTime | undefined;

    constructor(data?: ILeadApplicationLinkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.url = _data["url"];
            this.status = _data["status"];
            this.expiresAt = _data["expiresAt"] ? DateTime.fromISO(_data["expiresAt"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.acceptedDate = _data["acceptedDate"] ? DateTime.fromISO(_data["acceptedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LeadApplicationLinkStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadApplicationLinkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["url"] = this.url;
        data["status"] = this.status;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toString() : <any>undefined;
        return data;
    }
}

export interface ILeadApplicationLinkStatusDto {
    id: number;
    leadId: number;
    url: string | undefined;
    status: InvitationStatus;
    expiresAt: DateTime;
    submittedDate: DateTime | undefined;
    acceptedDate: DateTime | undefined;
}

export class LeadApplicationSubmissionDto implements ILeadApplicationSubmissionDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    zipCode!: string | undefined;
    mobilePhone!: string | undefined;
    secondaryPhone!: string | undefined;
    email!: string | undefined;
    rawSSN!: string | undefined;
    doB!: DateTime | undefined;
    socialSecurityBenefitType!: BenefitType;
    highSchoolDiplomaOrEquivalent!: boolean | undefined;
    postSecondaryEducation!: boolean | undefined;
    driversLicense!: boolean | undefined;
    hasFelony!: boolean | undefined;
    careerGoals!: string | undefined;
    describePostSecondaryEducation!: string | undefined;
    desiredIncomeAndBenefits!: string | undefined;

    constructor(data?: ILeadApplicationSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.mobilePhone = _data["mobilePhone"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.email = _data["email"];
            this.rawSSN = _data["rawSSN"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.socialSecurityBenefitType = _data["socialSecurityBenefitType"];
            this.highSchoolDiplomaOrEquivalent = _data["highSchoolDiplomaOrEquivalent"];
            this.postSecondaryEducation = _data["postSecondaryEducation"];
            this.driversLicense = _data["driversLicense"];
            this.hasFelony = _data["hasFelony"];
            this.careerGoals = _data["careerGoals"];
            this.describePostSecondaryEducation = _data["describePostSecondaryEducation"];
            this.desiredIncomeAndBenefits = _data["desiredIncomeAndBenefits"];
        }
    }

    static fromJS(data: any): LeadApplicationSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadApplicationSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["mobilePhone"] = this.mobilePhone;
        data["secondaryPhone"] = this.secondaryPhone;
        data["email"] = this.email;
        data["rawSSN"] = this.rawSSN;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["socialSecurityBenefitType"] = this.socialSecurityBenefitType;
        data["highSchoolDiplomaOrEquivalent"] = this.highSchoolDiplomaOrEquivalent;
        data["postSecondaryEducation"] = this.postSecondaryEducation;
        data["driversLicense"] = this.driversLicense;
        data["hasFelony"] = this.hasFelony;
        data["careerGoals"] = this.careerGoals;
        data["describePostSecondaryEducation"] = this.describePostSecondaryEducation;
        data["desiredIncomeAndBenefits"] = this.desiredIncomeAndBenefits;
        return data;
    }
}

export interface ILeadApplicationSubmissionDto {
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    zipCode: string | undefined;
    mobilePhone: string | undefined;
    secondaryPhone: string | undefined;
    email: string | undefined;
    rawSSN: string | undefined;
    doB: DateTime | undefined;
    socialSecurityBenefitType: BenefitType;
    highSchoolDiplomaOrEquivalent: boolean | undefined;
    postSecondaryEducation: boolean | undefined;
    driversLicense: boolean | undefined;
    hasFelony: boolean | undefined;
    careerGoals: string | undefined;
    describePostSecondaryEducation: string | undefined;
    desiredIncomeAndBenefits: string | undefined;
}

export class LeadChatSMSDto implements ILeadChatSMSDto {
    direction!: ActivityDirection;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    logId!: number | undefined;
    startTime!: DateTime;
    contactInfo!: string | undefined;

    constructor(data?: ILeadChatSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.logId = _data["logId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.contactInfo = _data["contactInfo"];
        }
    }

    static fromJS(data: any): LeadChatSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadChatSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["logId"] = this.logId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["contactInfo"] = this.contactInfo;
        return data;
    }
}

export interface ILeadChatSMSDto {
    direction: ActivityDirection;
    activityContent: string | undefined;
    status: ActivityStatus;
    logId: number | undefined;
    startTime: DateTime;
    contactInfo: string | undefined;
}

export class LeadContactHistoryDto implements ILeadContactHistoryDto {
    leadId!: number;
    activityType!: ContactType;
    direction!: ActivityDirection;
    contactInfo!: string | undefined;
    subject!: string | undefined;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    serviceType!: ActivityServiceType;
    enumDisplayServiceType!: string | undefined;
    startTime!: DateTime;
    attachments!: LeadActivityAttachmentDto[] | undefined;
    id!: number;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    logId!: number | undefined;
    hasAttachments!: boolean;
    leadFullName!: string | undefined;
    formattedLeadId!: string | undefined;
    enumDisplayActivityType!: string | undefined;
    enumDisplayActivityStatus!: string | undefined;

    constructor(data?: ILeadContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.activityType = _data["activityType"];
            this.direction = _data["direction"];
            this.contactInfo = _data["contactInfo"];
            this.subject = _data["subject"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.enumDisplayServiceType = _data["enumDisplayServiceType"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(LeadActivityAttachmentDto.fromJS(item));
            }
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.logId = _data["logId"];
            this.hasAttachments = _data["hasAttachments"];
            this.leadFullName = _data["leadFullName"];
            this.formattedLeadId = _data["formattedLeadId"];
            this.enumDisplayActivityType = _data["enumDisplayActivityType"];
            this.enumDisplayActivityStatus = _data["enumDisplayActivityStatus"];
        }
    }

    static fromJS(data: any): LeadContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["activityType"] = this.activityType;
        data["direction"] = this.direction;
        data["contactInfo"] = this.contactInfo;
        data["subject"] = this.subject;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["enumDisplayServiceType"] = this.enumDisplayServiceType;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["logId"] = this.logId;
        data["hasAttachments"] = this.hasAttachments;
        data["leadFullName"] = this.leadFullName;
        data["formattedLeadId"] = this.formattedLeadId;
        data["enumDisplayActivityType"] = this.enumDisplayActivityType;
        data["enumDisplayActivityStatus"] = this.enumDisplayActivityStatus;
        return data;
    }
}

export interface ILeadContactHistoryDto {
    leadId: number;
    activityType: ContactType;
    direction: ActivityDirection;
    contactInfo: string | undefined;
    subject: string | undefined;
    activityContent: string | undefined;
    status: ActivityStatus;
    serviceType: ActivityServiceType;
    enumDisplayServiceType: string | undefined;
    startTime: DateTime;
    attachments: LeadActivityAttachmentDto[] | undefined;
    id: number;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    logId: number | undefined;
    hasAttachments: boolean;
    leadFullName: string | undefined;
    formattedLeadId: string | undefined;
    enumDisplayActivityType: string | undefined;
    enumDisplayActivityStatus: string | undefined;
}

export class LeadDto implements ILeadDto {
    id!: number;
    leadId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    doB!: DateTime | undefined;
    readonly fullName!: string | undefined;
    email!: string | undefined;
    encryptedSSN!: string | undefined;
    maskedSSN!: string | undefined;
    benefitType!: BenefitType;
    isFelony!: boolean | undefined;
    languagePreference!: Language;
    importBatchId!: string | undefined;
    assigneeName!: string | undefined;
    assigneeId!: number | undefined;
    assignedDate!: DateTime | undefined;
    acknowledgedByUserId!: number | undefined;
    acknowledgedDate!: DateTime | undefined;
    acknowledgedByName!: string | undefined;
    creationTime!: DateTime;
    createdByName!: string | undefined;
    isReferralLead!: boolean;
    readonly needsAcknowledgement!: boolean;
    phoneNumbers!: PhoneDto[] | undefined;
    addresses!: AddressDto[] | undefined;
    status!: ActivityStatus;
    readonly statusDisplayName!: string | undefined;
    leadType!: LeadType;
    notes!: string | undefined;
    leadStage!: LeadStage;
    readonly leadStageDisplayName!: string | undefined;
    jobAccommodationNote!: string | undefined;
    requestedServices!: SupportServices;
    disabilities!: DisabilityDto[] | undefined;
    spokenLanguages!: SpokenLanguageDto[] | undefined;
    lastModificationTime!: DateTime | undefined;
    itopssComments!: string | undefined;

    constructor(data?: ILeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            this.email = _data["email"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.benefitType = _data["benefitType"];
            this.isFelony = _data["isFelony"];
            this.languagePreference = _data["languagePreference"];
            this.importBatchId = _data["importBatchId"];
            this.assigneeName = _data["assigneeName"];
            this.assigneeId = _data["assigneeId"];
            this.assignedDate = _data["assignedDate"] ? DateTime.fromISO(_data["assignedDate"].toString()) : <any>undefined;
            this.acknowledgedByUserId = _data["acknowledgedByUserId"];
            this.acknowledgedDate = _data["acknowledgedDate"] ? DateTime.fromISO(_data["acknowledgedDate"].toString()) : <any>undefined;
            this.acknowledgedByName = _data["acknowledgedByName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.createdByName = _data["createdByName"];
            this.isReferralLead = _data["isReferralLead"];
            (<any>this).needsAcknowledgement = _data["needsAcknowledgement"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(PhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressDto.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).statusDisplayName = _data["statusDisplayName"];
            this.leadType = _data["leadType"];
            this.notes = _data["notes"];
            this.leadStage = _data["leadStage"];
            (<any>this).leadStageDisplayName = _data["leadStageDisplayName"];
            this.jobAccommodationNote = _data["jobAccommodationNote"];
            this.requestedServices = _data["requestedServices"];
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(DisabilityDto.fromJS(item));
            }
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.itopssComments = _data["itopssComments"];
        }
    }

    static fromJS(data: any): LeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["encryptedSSN"] = this.encryptedSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["benefitType"] = this.benefitType;
        data["isFelony"] = this.isFelony;
        data["languagePreference"] = this.languagePreference;
        data["importBatchId"] = this.importBatchId;
        data["assigneeName"] = this.assigneeName;
        data["assigneeId"] = this.assigneeId;
        data["assignedDate"] = this.assignedDate ? this.assignedDate.toString() : <any>undefined;
        data["acknowledgedByUserId"] = this.acknowledgedByUserId;
        data["acknowledgedDate"] = this.acknowledgedDate ? this.acknowledgedDate.toString() : <any>undefined;
        data["acknowledgedByName"] = this.acknowledgedByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["createdByName"] = this.createdByName;
        data["isReferralLead"] = this.isReferralLead;
        data["needsAcknowledgement"] = this.needsAcknowledgement;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        data["leadType"] = this.leadType;
        data["notes"] = this.notes;
        data["leadStage"] = this.leadStage;
        data["leadStageDisplayName"] = this.leadStageDisplayName;
        data["jobAccommodationNote"] = this.jobAccommodationNote;
        data["requestedServices"] = this.requestedServices;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["itopssComments"] = this.itopssComments;
        return data;
    }
}

export interface ILeadDto {
    id: number;
    leadId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    doB: DateTime | undefined;
    fullName: string | undefined;
    email: string | undefined;
    encryptedSSN: string | undefined;
    maskedSSN: string | undefined;
    benefitType: BenefitType;
    isFelony: boolean | undefined;
    languagePreference: Language;
    importBatchId: string | undefined;
    assigneeName: string | undefined;
    assigneeId: number | undefined;
    assignedDate: DateTime | undefined;
    acknowledgedByUserId: number | undefined;
    acknowledgedDate: DateTime | undefined;
    acknowledgedByName: string | undefined;
    creationTime: DateTime;
    createdByName: string | undefined;
    isReferralLead: boolean;
    needsAcknowledgement: boolean;
    phoneNumbers: PhoneDto[] | undefined;
    addresses: AddressDto[] | undefined;
    status: ActivityStatus;
    statusDisplayName: string | undefined;
    leadType: LeadType;
    notes: string | undefined;
    leadStage: LeadStage;
    leadStageDisplayName: string | undefined;
    jobAccommodationNote: string | undefined;
    requestedServices: SupportServices;
    disabilities: DisabilityDto[] | undefined;
    spokenLanguages: SpokenLanguageDto[] | undefined;
    lastModificationTime: DateTime | undefined;
    itopssComments: string | undefined;
}

export class LeadError implements ILeadError {
    errorMessage!: string | undefined;
    errorType!: LeadErrorType;
    readonly errorTypeDisplay!: string | undefined;

    constructor(data?: ILeadError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.errorType = _data["errorType"];
            (<any>this).errorTypeDisplay = _data["errorTypeDisplay"];
        }
    }

    static fromJS(data: any): LeadError {
        data = typeof data === 'object' ? data : {};
        let result = new LeadError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["errorType"] = this.errorType;
        data["errorTypeDisplay"] = this.errorTypeDisplay;
        return data;
    }
}

export interface ILeadError {
    errorMessage: string | undefined;
    errorType: LeadErrorType;
    errorTypeDisplay: string | undefined;
}

export enum LeadErrorType {
    Validation = 1,
    BusinessRule = 2,
    NotFound = 3,
    Duplicate = 4,
    ServerError = 5,
}

export class LeadFilterDto implements ILeadFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    leadId!: string | undefined;
    doBFilter!: DateTime | undefined;
    firstNameFilter!: string | undefined;
    lastNameFilter!: string | undefined;
    middleNameFilter!: string | undefined;
    emailIdFilter!: string | undefined;
    phoneNumberFilter!: string | undefined;
    importBatchIdFilter!: string | undefined;
    contactById!: number[] | undefined;
    timeZone!: USATimeZone;
    leadStage!: LeadStage[] | undefined;
    contactDateStart!: DateTime | undefined;
    contactDateEnd!: DateTime | undefined;
    noteFilter!: string | undefined;

    constructor(data?: ILeadFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.leadId = _data["leadId"];
            this.doBFilter = _data["doBFilter"] ? DateTime.fromISO(_data["doBFilter"].toString()) : <any>undefined;
            this.firstNameFilter = _data["firstNameFilter"];
            this.lastNameFilter = _data["lastNameFilter"];
            this.middleNameFilter = _data["middleNameFilter"];
            this.emailIdFilter = _data["emailIdFilter"];
            this.phoneNumberFilter = _data["phoneNumberFilter"];
            this.importBatchIdFilter = _data["importBatchIdFilter"];
            if (Array.isArray(_data["contactById"])) {
                this.contactById = [] as any;
                for (let item of _data["contactById"])
                    this.contactById!.push(item);
            }
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["leadStage"])) {
                this.leadStage = [] as any;
                for (let item of _data["leadStage"])
                    this.leadStage!.push(item);
            }
            this.contactDateStart = _data["contactDateStart"] ? DateTime.fromISO(_data["contactDateStart"].toString()) : <any>undefined;
            this.contactDateEnd = _data["contactDateEnd"] ? DateTime.fromISO(_data["contactDateEnd"].toString()) : <any>undefined;
            this.noteFilter = _data["noteFilter"];
        }
    }

    static fromJS(data: any): LeadFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["leadId"] = this.leadId;
        data["doBFilter"] = this.doBFilter ? this.doBFilter.toFormat('yyyy-MM-dd') : <any>undefined;
        data["firstNameFilter"] = this.firstNameFilter;
        data["lastNameFilter"] = this.lastNameFilter;
        data["middleNameFilter"] = this.middleNameFilter;
        data["emailIdFilter"] = this.emailIdFilter;
        data["phoneNumberFilter"] = this.phoneNumberFilter;
        data["importBatchIdFilter"] = this.importBatchIdFilter;
        if (Array.isArray(this.contactById)) {
            data["contactById"] = [];
            for (let item of this.contactById)
                data["contactById"].push(item);
        }
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.leadStage)) {
            data["leadStage"] = [];
            for (let item of this.leadStage)
                data["leadStage"].push(item);
        }
        data["contactDateStart"] = this.contactDateStart ? this.contactDateStart.toString() : <any>undefined;
        data["contactDateEnd"] = this.contactDateEnd ? this.contactDateEnd.toString() : <any>undefined;
        data["noteFilter"] = this.noteFilter;
        return data;
    }
}

export interface ILeadFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    leadId: string | undefined;
    doBFilter: DateTime | undefined;
    firstNameFilter: string | undefined;
    lastNameFilter: string | undefined;
    middleNameFilter: string | undefined;
    emailIdFilter: string | undefined;
    phoneNumberFilter: string | undefined;
    importBatchIdFilter: string | undefined;
    contactById: number[] | undefined;
    timeZone: USATimeZone;
    leadStage: LeadStage[] | undefined;
    contactDateStart: DateTime | undefined;
    contactDateEnd: DateTime | undefined;
    noteFilter: string | undefined;
}

export class LeadFollowupDto implements ILeadFollowupDto {
    id!: number;
    title!: string | undefined;
    leadId!: number;
    description!: string | undefined;
    startDate!: DateTime;
    dueDate!: DateTime | undefined;
    assignedToUserId!: number;
    status!: CalendarEventStatus;
    followupType!: FollowupType;

    constructor(data?: ILeadFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.leadId = _data["leadId"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.assignedToUserId = _data["assignedToUserId"];
            this.status = _data["status"];
            this.followupType = _data["followupType"];
        }
    }

    static fromJS(data: any): LeadFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["leadId"] = this.leadId;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["assignedToUserId"] = this.assignedToUserId;
        data["status"] = this.status;
        data["followupType"] = this.followupType;
        return data;
    }
}

export interface ILeadFollowupDto {
    id: number;
    title: string | undefined;
    leadId: number;
    description: string | undefined;
    startDate: DateTime;
    dueDate: DateTime | undefined;
    assignedToUserId: number;
    status: CalendarEventStatus;
    followupType: FollowupType;
}

export class LeadImportHistoryDto implements ILeadImportHistoryDto {
    id!: number;
    fileName!: string | undefined;
    fileSize!: string | undefined;
    status!: JobProcessingStatus;
    processedDate!: DateTime | undefined;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    creatorName!: string | undefined;
    actualStartTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    backgroundJobInstanceId!: number | undefined;
    totalProcessed!: number | undefined;
    totalFailed!: number | undefined;
    totalSucceeded!: number | undefined;
    importBatchId!: string | undefined;

    constructor(data?: ILeadImportHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.status = _data["status"];
            this.processedDate = _data["processedDate"] ? DateTime.fromISO(_data["processedDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.actualStartTime = _data["actualStartTime"] ? DateTime.fromISO(_data["actualStartTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.backgroundJobInstanceId = _data["backgroundJobInstanceId"];
            this.totalProcessed = _data["totalProcessed"];
            this.totalFailed = _data["totalFailed"];
            this.totalSucceeded = _data["totalSucceeded"];
            this.importBatchId = _data["importBatchId"];
        }
    }

    static fromJS(data: any): LeadImportHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadImportHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["status"] = this.status;
        data["processedDate"] = this.processedDate ? this.processedDate.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["backgroundJobInstanceId"] = this.backgroundJobInstanceId;
        data["totalProcessed"] = this.totalProcessed;
        data["totalFailed"] = this.totalFailed;
        data["totalSucceeded"] = this.totalSucceeded;
        data["importBatchId"] = this.importBatchId;
        return data;
    }
}

export interface ILeadImportHistoryDto {
    id: number;
    fileName: string | undefined;
    fileSize: string | undefined;
    status: JobProcessingStatus;
    processedDate: DateTime | undefined;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    actualStartTime: DateTime | undefined;
    endTime: DateTime | undefined;
    backgroundJobInstanceId: number | undefined;
    totalProcessed: number | undefined;
    totalFailed: number | undefined;
    totalSucceeded: number | undefined;
    importBatchId: string | undefined;
}

export class LeadOwnerChangeDto implements ILeadOwnerChangeDto {
    leadId!: number;
    assigneeName!: string | undefined;
    assigneeId!: number;

    constructor(data?: ILeadOwnerChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.assigneeName = _data["assigneeName"];
            this.assigneeId = _data["assigneeId"];
        }
    }

    static fromJS(data: any): LeadOwnerChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadOwnerChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["assigneeName"] = this.assigneeName;
        data["assigneeId"] = this.assigneeId;
        return data;
    }
}

export interface ILeadOwnerChangeDto {
    leadId: number;
    assigneeName: string | undefined;
    assigneeId: number;
}

export enum LeadStage {
    LeadPool = 1,
    LeadQueue = 2,
    Interested = 3,
    EligibilityChecking = 4,
    IWPPending = 5,
    IWPWaitingSignature = 6,
    IWPSigned = 7,
    NotInterested = 8,
    Disqualified = 9,
    SVRInUse = 10,
    OptOut = 11,
}

export class LeadStageDto implements ILeadStageDto {
    leadId!: number;
    leadStage!: LeadStage;

    constructor(data?: ILeadStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.leadStage = _data["leadStage"];
        }
    }

    static fromJS(data: any): LeadStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["leadStage"] = this.leadStage;
        return data;
    }
}

export interface ILeadStageDto {
    leadId: number;
    leadStage: LeadStage;
}

export class LeadStageOptionDto implements ILeadStageOptionDto {
    leadStage!: LeadStage;
    leadStageDisplayName!: string | undefined;

    constructor(data?: ILeadStageOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadStage = _data["leadStage"];
            this.leadStageDisplayName = _data["leadStageDisplayName"];
        }
    }

    static fromJS(data: any): LeadStageOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStageOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadStage"] = this.leadStage;
        data["leadStageDisplayName"] = this.leadStageDisplayName;
        return data;
    }
}

export interface ILeadStageOptionDto {
    leadStage: LeadStage;
    leadStageDisplayName: string | undefined;
}

export class LeadStatsDto implements ILeadStatsDto {
    totalLeads!: number;
    leadPool!: number;
    leadQueue!: number;
    interested!: number;

    constructor(data?: ILeadStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLeads = _data["totalLeads"];
            this.leadPool = _data["leadPool"];
            this.leadQueue = _data["leadQueue"];
            this.interested = _data["interested"];
        }
    }

    static fromJS(data: any): LeadStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLeads"] = this.totalLeads;
        data["leadPool"] = this.leadPool;
        data["leadQueue"] = this.leadQueue;
        data["interested"] = this.interested;
        return data;
    }
}

export interface ILeadStatsDto {
    totalLeads: number;
    leadPool: number;
    leadQueue: number;
    interested: number;
}

export enum LeadType {
    FromSSA = 1,
    FromEmploymentNetwork = 2,
}

export class LeadWorkHistoryDto implements ILeadWorkHistoryDto {
    id!: number;
    leadId!: number;
    employer!: string;
    employerAddress!: string | undefined;
    jobTitle!: string;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    hourlyWage!: number;
    weeklyHours!: number;

    constructor(data?: ILeadWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.employer = _data["employer"];
            this.employerAddress = _data["employerAddress"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.hourlyWage = _data["hourlyWage"];
            this.weeklyHours = _data["weeklyHours"];
        }
    }

    static fromJS(data: any): LeadWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeadWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["employer"] = this.employer;
        data["employerAddress"] = this.employerAddress;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["hourlyWage"] = this.hourlyWage;
        data["weeklyHours"] = this.weeklyHours;
        return data;
    }
}

export interface ILeadWorkHistoryDto {
    id: number;
    leadId: number;
    employer: string;
    employerAddress: string | undefined;
    jobTitle: string;
    startDate: DateTime;
    endDate: DateTime | undefined;
    hourlyWage: number;
    weeklyHours: number;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedResource implements ILinkedResource {
    readonly contentStream!: string | undefined;
    contentId!: string | undefined;
    contentType!: ContentType;
    transferEncoding!: TransferEncoding;
    contentLink!: string | undefined;

    constructor(data?: ILinkedResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).contentStream = _data["contentStream"];
            this.contentId = _data["contentId"];
            this.contentType = _data["contentType"] ? ContentType.fromJS(_data["contentType"]) : <any>undefined;
            this.transferEncoding = _data["transferEncoding"];
            this.contentLink = _data["contentLink"];
        }
    }

    static fromJS(data: any): LinkedResource {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentStream"] = this.contentStream;
        data["contentId"] = this.contentId;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        data["transferEncoding"] = this.transferEncoding;
        data["contentLink"] = this.contentLink;
        return data;
    }
}

export interface ILinkedResource {
    contentStream: string | undefined;
    contentId: string | undefined;
    contentType: ContentType;
    transferEncoding: TransferEncoding;
    contentLink: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    id!: number;
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        return data;
    }
}

export interface ILinkedUserDto {
    id: number;
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyDto implements IListResultDtoOfDynamicEntityPropertyDto {
    items!: DynamicEntityPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyDto {
    items: DynamicEntityPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicEntityPropertyValueDto implements IListResultDtoOfDynamicEntityPropertyValueDto {
    items!: DynamicEntityPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyValueDto {
    items: DynamicEntityPropertyValueDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyDto implements IListResultDtoOfDynamicPropertyDto {
    items!: DynamicPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyDto {
    items: DynamicPropertyDto[] | undefined;
}

export class ListResultDtoOfDynamicPropertyValueDto implements IListResultDtoOfDynamicPropertyValueDto {
    items!: DynamicPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyValueDto {
    items: DynamicPropertyValueDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfEntityAndPropertyChangeListDto implements IListResultDtoOfEntityAndPropertyChangeListDto {
    items!: EntityAndPropertyChangeListDto[] | undefined;

    constructor(data?: IListResultDtoOfEntityAndPropertyChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityAndPropertyChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEntityAndPropertyChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEntityAndPropertyChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEntityAndPropertyChangeListDto {
    items: EntityAndPropertyChangeListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfGetAllAvailableWebhooksOutput implements IListResultDtoOfGetAllAvailableWebhooksOutput {
    items!: GetAllAvailableWebhooksOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllAvailableWebhooksOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllAvailableWebhooksOutput {
    items: GetAllAvailableWebhooksOutput[] | undefined;
}

export class ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput implements IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items!: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllEntitiesHasDynamicPropertyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;
}

export class ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput implements IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items!: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;
}

export class ListResultDtoOfGetAllSubscriptionsOutput implements IListResultDtoOfGetAllSubscriptionsOutput {
    items!: GetAllSubscriptionsOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSubscriptionsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSubscriptionsOutput {
    items: GetAllSubscriptionsOutput[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class LogDto implements ILogDto {
    id!: number;
    logMessage!: string | undefined;
    logLevel!: string | undefined;
    creationTime!: DateTime | undefined;

    constructor(data?: ILogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logMessage = _data["logMessage"];
            this.logLevel = _data["logLevel"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LogDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logMessage"] = this.logMessage;
        data["logLevel"] = this.logLevel;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ILogDto {
    id: number;
    logMessage: string | undefined;
    logLevel: string | undefined;
    creationTime: DateTime | undefined;
}

export enum LogType {
    Lead = 1,
    TicketHolder = 2,
    Campaign = 3,
    Unknown = 4,
}

export class LoginDto implements ILoginDto {
    ticketHolderId!: number;
    accountName!: string;
    loginUrl!: string | undefined;
    userId!: string;
    encryptedAccessKey!: string;
    isTwoFactorEnabled!: boolean;
    pinDestination!: string | undefined;
    notes!: string | undefined;
    id!: number;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.accountName = _data["accountName"];
            this.loginUrl = _data["loginUrl"];
            this.userId = _data["userId"];
            this.encryptedAccessKey = _data["encryptedAccessKey"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.pinDestination = _data["pinDestination"];
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["accountName"] = this.accountName;
        data["loginUrl"] = this.loginUrl;
        data["userId"] = this.userId;
        data["encryptedAccessKey"] = this.encryptedAccessKey;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["pinDestination"] = this.pinDestination;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface ILoginDto {
    ticketHolderId: number;
    accountName: string;
    loginUrl: string | undefined;
    userId: string;
    encryptedAccessKey: string;
    isTwoFactorEnabled: boolean;
    pinDestination: string | undefined;
    notes: string | undefined;
    id: number;
}

export enum LoginType {
    Local = 0,
    External = 1,
}

export class Lookup1619bThresholdAiRequestDto implements ILookup1619bThresholdAiRequestDto {
    year!: number;
    stateAbbreviation!: string;

    constructor(data?: ILookup1619bThresholdAiRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.stateAbbreviation = _data["stateAbbreviation"];
        }
    }

    static fromJS(data: any): Lookup1619bThresholdAiRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new Lookup1619bThresholdAiRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["stateAbbreviation"] = this.stateAbbreviation;
        return data;
    }
}

export interface ILookup1619bThresholdAiRequestDto {
    year: number;
    stateAbbreviation: string;
}

export class LookupSsiFbrAiRequestDto implements ILookupSsiFbrAiRequestDto {
    year!: number;

    constructor(data?: ILookupSsiFbrAiRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): LookupSsiFbrAiRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupSsiFbrAiRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        return data;
    }
}

export interface ILookupSsiFbrAiRequestDto {
    year: number;
}

export class MailAddress implements IMailAddress {
    readonly displayName!: string | undefined;
    readonly user!: string | undefined;
    readonly host!: string | undefined;
    address!: string | undefined;

    constructor(data?: IMailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).displayName = _data["displayName"];
            (<any>this).user = _data["user"];
            (<any>this).host = _data["host"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): MailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new MailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["user"] = this.user;
        data["host"] = this.host;
        data["address"] = this.address;
        return data;
    }
}

export interface IMailAddress {
    displayName: string | undefined;
    user: string | undefined;
    host: string | undefined;
    address: string | undefined;
}

export class MailDto implements IMailDto {
    serviceType!: ActivityServiceType;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    attatchments!: UploadFileOutputDto[] | undefined;
    senderName!: string;
    senderAddress!: string;
    recipientName!: string;
    recipientAddress!: string;
    subject!: string | undefined;
    messageBody!: string | undefined;
    documentId!: number | undefined;
    needReturnEnvelope!: boolean | undefined;

    constructor(data?: IMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceType = _data["serviceType"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            if (Array.isArray(_data["attatchments"])) {
                this.attatchments = [] as any;
                for (let item of _data["attatchments"])
                    this.attatchments!.push(UploadFileOutputDto.fromJS(item));
            }
            this.senderName = _data["senderName"];
            this.senderAddress = _data["senderAddress"];
            this.recipientName = _data["recipientName"];
            this.recipientAddress = _data["recipientAddress"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            this.documentId = _data["documentId"];
            this.needReturnEnvelope = _data["needReturnEnvelope"];
        }
    }

    static fromJS(data: any): MailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceType"] = this.serviceType;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        if (Array.isArray(this.attatchments)) {
            data["attatchments"] = [];
            for (let item of this.attatchments)
                data["attatchments"].push(item.toJSON());
        }
        data["senderName"] = this.senderName;
        data["senderAddress"] = this.senderAddress;
        data["recipientName"] = this.recipientName;
        data["recipientAddress"] = this.recipientAddress;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        data["documentId"] = this.documentId;
        data["needReturnEnvelope"] = this.needReturnEnvelope;
        return data;
    }
}

export interface IMailDto {
    serviceType: ActivityServiceType;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    attatchments: UploadFileOutputDto[] | undefined;
    senderName: string;
    senderAddress: string;
    recipientName: string;
    recipientAddress: string;
    subject: string | undefined;
    messageBody: string | undefined;
    documentId: number | undefined;
    needReturnEnvelope: boolean | undefined;
}

export enum MailLetterClientType {
    Lead = 1,
    TicketHolder = 2,
}

export class MailLetterLookupDto implements IMailLetterLookupDto {
    letterId!: number;
    clientId!: string | undefined;
    clientName!: string | undefined;
    clientType!: MailLetterClientType;
    careerCoachName!: string | undefined;
    status!: ActivityStatus;

    constructor(data?: IMailLetterLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.letterId = _data["letterId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.clientType = _data["clientType"];
            this.careerCoachName = _data["careerCoachName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MailLetterLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailLetterLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["letterId"] = this.letterId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientType"] = this.clientType;
        data["careerCoachName"] = this.careerCoachName;
        data["status"] = this.status;
        return data;
    }
}

export interface IMailLetterLookupDto {
    letterId: number;
    clientId: string | undefined;
    clientName: string | undefined;
    clientType: MailLetterClientType;
    careerCoachName: string | undefined;
    status: ActivityStatus;
}

export class MailLogDetailDto implements IMailLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientAddress!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: DocumentDto[] | undefined;
    carrierName!: string | undefined;
    carrierTrackingNumber!: string | undefined;
    status!: ActivityStatus;

    constructor(data?: IMailLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(DocumentDto.fromJS(item));
            }
            this.carrierName = _data["carrierName"];
            this.carrierTrackingNumber = _data["carrierTrackingNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MailLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["carrierName"] = this.carrierName;
        data["carrierTrackingNumber"] = this.carrierTrackingNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface IMailLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: DocumentDto[] | undefined;
    carrierName: string | undefined;
    carrierTrackingNumber: string | undefined;
    status: ActivityStatus;
}

export class MailLogDto implements IMailLogDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientAddress!: string | undefined;
    clientId!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: string | undefined;
    attachmentIds!: number[] | undefined;
    carrierName!: string | undefined;
    carrierTrackingNumber!: string | undefined;
    status!: ActivityStatus;
    errorMessage!: string | undefined;
    mailId!: string | undefined;
    rawJson!: string | undefined;

    constructor(data?: IMailLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.clientId = _data["clientId"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            this.attachments = _data["attachments"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
            this.carrierName = _data["carrierName"];
            this.carrierTrackingNumber = _data["carrierTrackingNumber"];
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.mailId = _data["mailId"];
            this.rawJson = _data["rawJson"];
        }
    }

    static fromJS(data: any): MailLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["clientId"] = this.clientId;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        data["attachments"] = this.attachments;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        data["carrierName"] = this.carrierName;
        data["carrierTrackingNumber"] = this.carrierTrackingNumber;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["mailId"] = this.mailId;
        data["rawJson"] = this.rawJson;
        return data;
    }
}

export interface IMailLogDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    clientId: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: string | undefined;
    attachmentIds: number[] | undefined;
    carrierName: string | undefined;
    carrierTrackingNumber: string | undefined;
    status: ActivityStatus;
    errorMessage: string | undefined;
    mailId: string | undefined;
    rawJson: string | undefined;
}

export class MailMessage implements IMailMessage {
    from!: MailAddress;
    sender!: MailAddress;
    replyTo!: MailAddress;
    readonly replyToList!: MailAddress[] | undefined;
    readonly to!: MailAddress[] | undefined;
    readonly bcc!: MailAddress[] | undefined;
    readonly cc!: MailAddress[] | undefined;
    priority!: MailPriority;
    deliveryNotificationOptions!: DeliveryNotificationOptions;
    subject!: string | undefined;
    subjectEncoding!: Encoding;
    readonly headers!: any[] | undefined;
    headersEncoding!: Encoding;
    body!: string | undefined;
    bodyEncoding!: Encoding;
    bodyTransferEncoding!: TransferEncoding;
    isBodyHtml!: boolean;
    readonly attachments!: Attachment[] | undefined;
    readonly alternateViews!: AlternateView[] | undefined;

    constructor(data?: IMailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? MailAddress.fromJS(_data["from"]) : <any>undefined;
            this.sender = _data["sender"] ? MailAddress.fromJS(_data["sender"]) : <any>undefined;
            this.replyTo = _data["replyTo"] ? MailAddress.fromJS(_data["replyTo"]) : <any>undefined;
            if (Array.isArray(_data["replyToList"])) {
                (<any>this).replyToList = [] as any;
                for (let item of _data["replyToList"])
                    (<any>this).replyToList!.push(MailAddress.fromJS(item));
            }
            if (Array.isArray(_data["to"])) {
                (<any>this).to = [] as any;
                for (let item of _data["to"])
                    (<any>this).to!.push(MailAddress.fromJS(item));
            }
            if (Array.isArray(_data["bcc"])) {
                (<any>this).bcc = [] as any;
                for (let item of _data["bcc"])
                    (<any>this).bcc!.push(MailAddress.fromJS(item));
            }
            if (Array.isArray(_data["cc"])) {
                (<any>this).cc = [] as any;
                for (let item of _data["cc"])
                    (<any>this).cc!.push(MailAddress.fromJS(item));
            }
            this.priority = _data["priority"];
            this.deliveryNotificationOptions = _data["deliveryNotificationOptions"];
            this.subject = _data["subject"];
            this.subjectEncoding = _data["subjectEncoding"] ? Encoding.fromJS(_data["subjectEncoding"]) : <any>undefined;
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(item);
            }
            this.headersEncoding = _data["headersEncoding"] ? Encoding.fromJS(_data["headersEncoding"]) : <any>undefined;
            this.body = _data["body"];
            this.bodyEncoding = _data["bodyEncoding"] ? Encoding.fromJS(_data["bodyEncoding"]) : <any>undefined;
            this.bodyTransferEncoding = _data["bodyTransferEncoding"];
            this.isBodyHtml = _data["isBodyHtml"];
            if (Array.isArray(_data["attachments"])) {
                (<any>this).attachments = [] as any;
                for (let item of _data["attachments"])
                    (<any>this).attachments!.push(Attachment.fromJS(item));
            }
            if (Array.isArray(_data["alternateViews"])) {
                (<any>this).alternateViews = [] as any;
                for (let item of _data["alternateViews"])
                    (<any>this).alternateViews!.push(AlternateView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["replyTo"] = this.replyTo ? this.replyTo.toJSON() : <any>undefined;
        if (Array.isArray(this.replyToList)) {
            data["replyToList"] = [];
            for (let item of this.replyToList)
                data["replyToList"].push(item.toJSON());
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item.toJSON());
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item.toJSON());
        }
        data["priority"] = this.priority;
        data["deliveryNotificationOptions"] = this.deliveryNotificationOptions;
        data["subject"] = this.subject;
        data["subjectEncoding"] = this.subjectEncoding ? this.subjectEncoding.toJSON() : <any>undefined;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        data["headersEncoding"] = this.headersEncoding ? this.headersEncoding.toJSON() : <any>undefined;
        data["body"] = this.body;
        data["bodyEncoding"] = this.bodyEncoding ? this.bodyEncoding.toJSON() : <any>undefined;
        data["bodyTransferEncoding"] = this.bodyTransferEncoding;
        data["isBodyHtml"] = this.isBodyHtml;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.alternateViews)) {
            data["alternateViews"] = [];
            for (let item of this.alternateViews)
                data["alternateViews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailMessage {
    from: MailAddress;
    sender: MailAddress;
    replyTo: MailAddress;
    replyToList: MailAddress[] | undefined;
    to: MailAddress[] | undefined;
    bcc: MailAddress[] | undefined;
    cc: MailAddress[] | undefined;
    priority: MailPriority;
    deliveryNotificationOptions: DeliveryNotificationOptions;
    subject: string | undefined;
    subjectEncoding: Encoding;
    headers: any[] | undefined;
    headersEncoding: Encoding;
    body: string | undefined;
    bodyEncoding: Encoding;
    bodyTransferEncoding: TransferEncoding;
    isBodyHtml: boolean;
    attachments: Attachment[] | undefined;
    alternateViews: AlternateView[] | undefined;
}

export enum MailPriority {
    Normal = 0,
    Low = 1,
    High = 2,
}

export class MaintenanceConsoleServerDto implements IMaintenanceConsoleServerDto {
    id!: number;
    machineName!: string | undefined;
    ipAddress!: string | undefined;
    apiBaseUrl!: string | undefined;
    isActive!: boolean;
    lastHeartbeat!: DateTime;
    environment!: string | undefined;

    constructor(data?: IMaintenanceConsoleServerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.machineName = _data["machineName"];
            this.ipAddress = _data["ipAddress"];
            this.apiBaseUrl = _data["apiBaseUrl"];
            this.isActive = _data["isActive"];
            this.lastHeartbeat = _data["lastHeartbeat"] ? DateTime.fromISO(_data["lastHeartbeat"].toString()) : <any>undefined;
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): MaintenanceConsoleServerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceConsoleServerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["machineName"] = this.machineName;
        data["ipAddress"] = this.ipAddress;
        data["apiBaseUrl"] = this.apiBaseUrl;
        data["isActive"] = this.isActive;
        data["lastHeartbeat"] = this.lastHeartbeat ? this.lastHeartbeat.toString() : <any>undefined;
        data["environment"] = this.environment;
        return data;
    }
}

export interface IMaintenanceConsoleServerDto {
    id: number;
    machineName: string | undefined;
    ipAddress: string | undefined;
    apiBaseUrl: string | undefined;
    isActive: boolean;
    lastHeartbeat: DateTime;
    environment: string | undefined;
}

export class MaintenanceTaskDto implements IMaintenanceTaskDto {
    id!: number;
    taskName!: string | undefined;
    description!: string | undefined;
    isRecurring!: boolean;
    cronExpression!: string | undefined;
    futureRunTime!: DateTime | undefined;
    isImmediate!: boolean;
    isActive!: boolean;
    creationTime!: DateTime;
    lastInstanceId!: number | undefined;
    lastRunTime!: DateTime | undefined;
    lastEndTime!: DateTime | undefined;
    nextRunTime!: DateTime | undefined;
    lastRunStatus!: string | undefined;
    lastFailureReason!: string | undefined;
    healthStatus!: string | undefined;
    isOverdue!: boolean;
    executionCount!: number;

    constructor(data?: IMaintenanceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.isRecurring = _data["isRecurring"];
            this.cronExpression = _data["cronExpression"];
            this.futureRunTime = _data["futureRunTime"] ? DateTime.fromISO(_data["futureRunTime"].toString()) : <any>undefined;
            this.isImmediate = _data["isImmediate"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastInstanceId = _data["lastInstanceId"];
            this.lastRunTime = _data["lastRunTime"] ? DateTime.fromISO(_data["lastRunTime"].toString()) : <any>undefined;
            this.lastEndTime = _data["lastEndTime"] ? DateTime.fromISO(_data["lastEndTime"].toString()) : <any>undefined;
            this.nextRunTime = _data["nextRunTime"] ? DateTime.fromISO(_data["nextRunTime"].toString()) : <any>undefined;
            this.lastRunStatus = _data["lastRunStatus"];
            this.lastFailureReason = _data["lastFailureReason"];
            this.healthStatus = _data["healthStatus"];
            this.isOverdue = _data["isOverdue"];
            this.executionCount = _data["executionCount"];
        }
    }

    static fromJS(data: any): MaintenanceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["isRecurring"] = this.isRecurring;
        data["cronExpression"] = this.cronExpression;
        data["futureRunTime"] = this.futureRunTime ? this.futureRunTime.toString() : <any>undefined;
        data["isImmediate"] = this.isImmediate;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastInstanceId"] = this.lastInstanceId;
        data["lastRunTime"] = this.lastRunTime ? this.lastRunTime.toString() : <any>undefined;
        data["lastEndTime"] = this.lastEndTime ? this.lastEndTime.toString() : <any>undefined;
        data["nextRunTime"] = this.nextRunTime ? this.nextRunTime.toString() : <any>undefined;
        data["lastRunStatus"] = this.lastRunStatus;
        data["lastFailureReason"] = this.lastFailureReason;
        data["healthStatus"] = this.healthStatus;
        data["isOverdue"] = this.isOverdue;
        data["executionCount"] = this.executionCount;
        return data;
    }
}

export interface IMaintenanceTaskDto {
    id: number;
    taskName: string | undefined;
    description: string | undefined;
    isRecurring: boolean;
    cronExpression: string | undefined;
    futureRunTime: DateTime | undefined;
    isImmediate: boolean;
    isActive: boolean;
    creationTime: DateTime;
    lastInstanceId: number | undefined;
    lastRunTime: DateTime | undefined;
    lastEndTime: DateTime | undefined;
    nextRunTime: DateTime | undefined;
    lastRunStatus: string | undefined;
    lastFailureReason: string | undefined;
    healthStatus: string | undefined;
    isOverdue: boolean;
    executionCount: number;
}

export class MaintenanceTaskLogDto implements IMaintenanceTaskLogDto {
    id!: number;
    taskId!: number;
    instanceId!: number;
    taskName!: string | undefined;
    message!: string | undefined;
    logLevel!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IMaintenanceTaskLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.instanceId = _data["instanceId"];
            this.taskName = _data["taskName"];
            this.message = _data["message"];
            this.logLevel = _data["logLevel"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintenanceTaskLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTaskLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["instanceId"] = this.instanceId;
        data["taskName"] = this.taskName;
        data["message"] = this.message;
        data["logLevel"] = this.logLevel;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMaintenanceTaskLogDto {
    id: number;
    taskId: number;
    instanceId: number;
    taskName: string | undefined;
    message: string | undefined;
    logLevel: string | undefined;
    creationTime: DateTime;
}

export enum MaritalStatus {
    Single = 1,
    Married = 2,
    Divorced = 3,
    Separated = 4,
    Widowed = 5,
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class MarketingBusinessPartnerImportResultDto implements IMarketingBusinessPartnerImportResultDto {
    previewOnly!: boolean;
    rowsRead!: number;
    filtered!: number;
    outsideUs!: number;
    invalid!: number;
    created!: number;
    updated!: number;
    contactsCreated!: number;
    withPhone!: number;
    withEmail!: number;
    byState!: NameValueDtoOfInt32[] | undefined;
    warnings!: string[] | undefined;

    constructor(data?: IMarketingBusinessPartnerImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previewOnly = _data["previewOnly"];
            this.rowsRead = _data["rowsRead"];
            this.filtered = _data["filtered"];
            this.outsideUs = _data["outsideUs"];
            this.invalid = _data["invalid"];
            this.created = _data["created"];
            this.updated = _data["updated"];
            this.contactsCreated = _data["contactsCreated"];
            this.withPhone = _data["withPhone"];
            this.withEmail = _data["withEmail"];
            if (Array.isArray(_data["byState"])) {
                this.byState = [] as any;
                for (let item of _data["byState"])
                    this.byState!.push(NameValueDtoOfInt32.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): MarketingBusinessPartnerImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingBusinessPartnerImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previewOnly"] = this.previewOnly;
        data["rowsRead"] = this.rowsRead;
        data["filtered"] = this.filtered;
        data["outsideUs"] = this.outsideUs;
        data["invalid"] = this.invalid;
        data["created"] = this.created;
        data["updated"] = this.updated;
        data["contactsCreated"] = this.contactsCreated;
        data["withPhone"] = this.withPhone;
        data["withEmail"] = this.withEmail;
        if (Array.isArray(this.byState)) {
            data["byState"] = [];
            for (let item of this.byState)
                data["byState"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IMarketingBusinessPartnerImportResultDto {
    previewOnly: boolean;
    rowsRead: number;
    filtered: number;
    outsideUs: number;
    invalid: number;
    created: number;
    updated: number;
    contactsCreated: number;
    withPhone: number;
    withEmail: number;
    byState: NameValueDtoOfInt32[] | undefined;
    warnings: string[] | undefined;
}

export class MarketingBusinessPartnerSummaryDto implements IMarketingBusinessPartnerSummaryDto {
    totalPartners!: number;
    signedPartners!: number;
    activePartners!: number;
    withoutPartnerId!: number;
    overdueFollowUps!: number;
    totalReferrals!: number;
    enrolledReferrals!: number;
    hiredReferrals!: number;
    rewardsIssued!: number;
    stages!: MarketingStageCountDto[] | undefined;
    monthly!: MarketingMonthlyReferralDto[] | undefined;
    topPartners!: MarketingPartnerPerformanceDto[] | undefined;
    needsAttention!: MarketingPartnerAttentionDto[] | undefined;

    constructor(data?: IMarketingBusinessPartnerSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPartners = _data["totalPartners"];
            this.signedPartners = _data["signedPartners"];
            this.activePartners = _data["activePartners"];
            this.withoutPartnerId = _data["withoutPartnerId"];
            this.overdueFollowUps = _data["overdueFollowUps"];
            this.totalReferrals = _data["totalReferrals"];
            this.enrolledReferrals = _data["enrolledReferrals"];
            this.hiredReferrals = _data["hiredReferrals"];
            this.rewardsIssued = _data["rewardsIssued"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(MarketingStageCountDto.fromJS(item));
            }
            if (Array.isArray(_data["monthly"])) {
                this.monthly = [] as any;
                for (let item of _data["monthly"])
                    this.monthly!.push(MarketingMonthlyReferralDto.fromJS(item));
            }
            if (Array.isArray(_data["topPartners"])) {
                this.topPartners = [] as any;
                for (let item of _data["topPartners"])
                    this.topPartners!.push(MarketingPartnerPerformanceDto.fromJS(item));
            }
            if (Array.isArray(_data["needsAttention"])) {
                this.needsAttention = [] as any;
                for (let item of _data["needsAttention"])
                    this.needsAttention!.push(MarketingPartnerAttentionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketingBusinessPartnerSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingBusinessPartnerSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPartners"] = this.totalPartners;
        data["signedPartners"] = this.signedPartners;
        data["activePartners"] = this.activePartners;
        data["withoutPartnerId"] = this.withoutPartnerId;
        data["overdueFollowUps"] = this.overdueFollowUps;
        data["totalReferrals"] = this.totalReferrals;
        data["enrolledReferrals"] = this.enrolledReferrals;
        data["hiredReferrals"] = this.hiredReferrals;
        data["rewardsIssued"] = this.rewardsIssued;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        if (Array.isArray(this.monthly)) {
            data["monthly"] = [];
            for (let item of this.monthly)
                data["monthly"].push(item.toJSON());
        }
        if (Array.isArray(this.topPartners)) {
            data["topPartners"] = [];
            for (let item of this.topPartners)
                data["topPartners"].push(item.toJSON());
        }
        if (Array.isArray(this.needsAttention)) {
            data["needsAttention"] = [];
            for (let item of this.needsAttention)
                data["needsAttention"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarketingBusinessPartnerSummaryDto {
    totalPartners: number;
    signedPartners: number;
    activePartners: number;
    withoutPartnerId: number;
    overdueFollowUps: number;
    totalReferrals: number;
    enrolledReferrals: number;
    hiredReferrals: number;
    rewardsIssued: number;
    stages: MarketingStageCountDto[] | undefined;
    monthly: MarketingMonthlyReferralDto[] | undefined;
    topPartners: MarketingPartnerPerformanceDto[] | undefined;
    needsAttention: MarketingPartnerAttentionDto[] | undefined;
}

export enum MarketingCampaignChannel {
    Facebook = 0,
    Instagram = 1,
    LinkedIn = 2,
    X = 3,
    YouTube = 4,
    TikTok = 5,
    Email = 6,
    Print = 7,
    Other = 99,
}

export class MarketingCampaignDto implements IMarketingCampaignDto {
    id!: number | undefined;
    name!: string;
    channel!: MarketingCampaignChannel;
    trackingCode!: string;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    budget!: number | undefined;
    isActive!: boolean;
    ownerUserId!: number | undefined;
    notes!: string | undefined;
    ownerName!: string | undefined;
    referrals!: number;
    partnerSignups!: number;
    enrolled!: number;
    lastReferralDate!: DateTime | undefined;

    constructor(data?: IMarketingCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.channel = _data["channel"];
            this.trackingCode = _data["trackingCode"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.budget = _data["budget"];
            this.isActive = _data["isActive"];
            this.ownerUserId = _data["ownerUserId"];
            this.notes = _data["notes"];
            this.ownerName = _data["ownerName"];
            this.referrals = _data["referrals"];
            this.partnerSignups = _data["partnerSignups"];
            this.enrolled = _data["enrolled"];
            this.lastReferralDate = _data["lastReferralDate"] ? DateTime.fromISO(_data["lastReferralDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channel"] = this.channel;
        data["trackingCode"] = this.trackingCode;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["budget"] = this.budget;
        data["isActive"] = this.isActive;
        data["ownerUserId"] = this.ownerUserId;
        data["notes"] = this.notes;
        data["ownerName"] = this.ownerName;
        data["referrals"] = this.referrals;
        data["partnerSignups"] = this.partnerSignups;
        data["enrolled"] = this.enrolled;
        data["lastReferralDate"] = this.lastReferralDate ? this.lastReferralDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMarketingCampaignDto {
    id: number | undefined;
    name: string;
    channel: MarketingCampaignChannel;
    trackingCode: string;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    budget: number | undefined;
    isActive: boolean;
    ownerUserId: number | undefined;
    notes: string | undefined;
    ownerName: string | undefined;
    referrals: number;
    partnerSignups: number;
    enrolled: number;
    lastReferralDate: DateTime | undefined;
}

export enum MarketingChecklistCategory {
    Logistics = 0,
    Materials = 1,
    Registration = 2,
    Travel = 3,
    Staffing = 4,
    Marketing = 5,
    FollowUp = 6,
}

export class MarketingChecklistTemplateDto implements IMarketingChecklistTemplateDto {
    id!: number | undefined;
    name!: string;
    eventType!: MarketingEventType;
    mode!: MarketingEventMode;
    description!: string | undefined;
    isActive!: boolean;
    items!: MarketingChecklistTemplateItemDto[] | undefined;

    constructor(data?: IMarketingChecklistTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.eventType = _data["eventType"];
            this.mode = _data["mode"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketingChecklistTemplateItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketingChecklistTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingChecklistTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["eventType"] = this.eventType;
        data["mode"] = this.mode;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarketingChecklistTemplateDto {
    id: number | undefined;
    name: string;
    eventType: MarketingEventType;
    mode: MarketingEventMode;
    description: string | undefined;
    isActive: boolean;
    items: MarketingChecklistTemplateItemDto[] | undefined;
}

export class MarketingChecklistTemplateItemDto implements IMarketingChecklistTemplateItemDto {
    id!: number | undefined;
    category!: MarketingChecklistCategory;
    title!: string;
    daysFromEvent!: number;
    sortOrder!: number;

    constructor(data?: IMarketingChecklistTemplateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.title = _data["title"];
            this.daysFromEvent = _data["daysFromEvent"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): MarketingChecklistTemplateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingChecklistTemplateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["title"] = this.title;
        data["daysFromEvent"] = this.daysFromEvent;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IMarketingChecklistTemplateItemDto {
    id: number | undefined;
    category: MarketingChecklistCategory;
    title: string;
    daysFromEvent: number;
    sortOrder: number;
}

export class MarketingContactDto implements IMarketingContactDto {
    id!: number | undefined;
    organizationId!: number;
    name!: string;
    title!: string | undefined;
    role!: string | undefined;
    agencyCodes!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    address!: string | undefined;
    isPrimary!: boolean;
    isActive!: boolean;
    notes!: string | undefined;
    organizationName!: string | undefined;
    state!: string | undefined;
    ownerName!: string | undefined;

    constructor(data?: IMarketingContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.role = _data["role"];
            this.agencyCodes = _data["agencyCodes"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.address = _data["address"];
            this.isPrimary = _data["isPrimary"];
            this.isActive = _data["isActive"];
            this.notes = _data["notes"];
            this.organizationName = _data["organizationName"];
            this.state = _data["state"];
            this.ownerName = _data["ownerName"];
        }
    }

    static fromJS(data: any): MarketingContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["role"] = this.role;
        data["agencyCodes"] = this.agencyCodes;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["address"] = this.address;
        data["isPrimary"] = this.isPrimary;
        data["isActive"] = this.isActive;
        data["notes"] = this.notes;
        data["organizationName"] = this.organizationName;
        data["state"] = this.state;
        data["ownerName"] = this.ownerName;
        return data;
    }
}

export interface IMarketingContactDto {
    id: number | undefined;
    organizationId: number;
    name: string;
    title: string | undefined;
    role: string | undefined;
    agencyCodes: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    address: string | undefined;
    isPrimary: boolean;
    isActive: boolean;
    notes: string | undefined;
    organizationName: string | undefined;
    state: string | undefined;
    ownerName: string | undefined;
}

export class MarketingContactEmailDto implements IMarketingContactEmailDto {
    subject!: string | undefined;
    body!: string | undefined;

    constructor(data?: IMarketingContactEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): MarketingContactEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingContactEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IMarketingContactEmailDto {
    subject: string | undefined;
    body: string | undefined;
}

export class MarketingEmailTemplateDto implements IMarketingEmailTemplateDto {
    id!: number | undefined;
    name!: string;
    subject!: string;
    body!: string;
    isActive!: boolean;
    lastModifiedByName!: string | undefined;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: IMarketingEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isActive = _data["isActive"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isActive"] = this.isActive;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMarketingEmailTemplateDto {
    id: number | undefined;
    name: string;
    subject: string;
    body: string;
    isActive: boolean;
    lastModifiedByName: string | undefined;
    lastModificationTime: DateTime | undefined;
}

export class MarketingEventCalendarDto implements IMarketingEventCalendarDto {
    id!: number;
    name!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime;
    eventType!: MarketingEventType;
    mode!: MarketingEventMode;
    status!: MarketingEventStatus;
    venue!: string | undefined;
    state!: string | undefined;

    constructor(data?: IMarketingEventCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.eventType = _data["eventType"];
            this.mode = _data["mode"];
            this.status = _data["status"];
            this.venue = _data["venue"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): MarketingEventCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["eventType"] = this.eventType;
        data["mode"] = this.mode;
        data["status"] = this.status;
        data["venue"] = this.venue;
        data["state"] = this.state;
        return data;
    }
}

export interface IMarketingEventCalendarDto {
    id: number;
    name: string | undefined;
    startDate: DateTime;
    endDate: DateTime;
    eventType: MarketingEventType;
    mode: MarketingEventMode;
    status: MarketingEventStatus;
    venue: string | undefined;
    state: string | undefined;
}

export class MarketingEventChecklistItemDto implements IMarketingEventChecklistItemDto {
    id!: number | undefined;
    eventId!: number;
    category!: MarketingChecklistCategory;
    title!: string;
    assignedUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    notes!: string | undefined;
    sortOrder!: number;
    isDone!: boolean;
    assignedUserName!: string | undefined;
    completedByName!: string | undefined;
    completedTime!: DateTime | undefined;
    isOverdue!: boolean;

    constructor(data?: IMarketingEventChecklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.category = _data["category"];
            this.title = _data["title"];
            this.assignedUserId = _data["assignedUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.sortOrder = _data["sortOrder"];
            this.isDone = _data["isDone"];
            this.assignedUserName = _data["assignedUserName"];
            this.completedByName = _data["completedByName"];
            this.completedTime = _data["completedTime"] ? DateTime.fromISO(_data["completedTime"].toString()) : <any>undefined;
            this.isOverdue = _data["isOverdue"];
        }
    }

    static fromJS(data: any): MarketingEventChecklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventChecklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["category"] = this.category;
        data["title"] = this.title;
        data["assignedUserId"] = this.assignedUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["sortOrder"] = this.sortOrder;
        data["isDone"] = this.isDone;
        data["assignedUserName"] = this.assignedUserName;
        data["completedByName"] = this.completedByName;
        data["completedTime"] = this.completedTime ? this.completedTime.toString() : <any>undefined;
        data["isOverdue"] = this.isOverdue;
        return data;
    }
}

export interface IMarketingEventChecklistItemDto {
    id: number | undefined;
    eventId: number;
    category: MarketingChecklistCategory;
    title: string;
    assignedUserId: number | undefined;
    dueDate: DateTime | undefined;
    notes: string | undefined;
    sortOrder: number;
    isDone: boolean;
    assignedUserName: string | undefined;
    completedByName: string | undefined;
    completedTime: DateTime | undefined;
    isOverdue: boolean;
}

export class MarketingEventDecisionInput implements IMarketingEventDecisionInput {
    id!: number;
    comment!: string | undefined;

    constructor(data?: IMarketingEventDecisionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): MarketingEventDecisionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventDecisionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IMarketingEventDecisionInput {
    id: number;
    comment: string | undefined;
}

export class MarketingEventDto implements IMarketingEventDto {
    id!: number | undefined;
    name!: string;
    eventType!: MarketingEventType;
    mode!: MarketingEventMode;
    format!: MarketingEventFormat;
    startDate!: DateTime;
    endDate!: DateTime;
    venue!: string | undefined;
    address!: string | undefined;
    state!: string | undefined;
    meetingLink!: string | undefined;
    organizerOrganizationId!: number | undefined;
    ownerUserId!: number | undefined;
    budget!: number | undefined;
    goals!: string | undefined;
    notes!: string | undefined;
    checklistTemplateId!: number | undefined;
    status!: MarketingEventStatus;
    ownerName!: string | undefined;
    organizerOrganizationName!: string | undefined;
    outcome!: string | undefined;
    approvalRequestedByName!: string | undefined;
    approvalRequestedTime!: DateTime | undefined;
    approvalDecidedByName!: string | undefined;
    approvalDecidedTime!: DateTime | undefined;
    approvalComment!: string | undefined;
    registrationEnabled!: boolean;
    registrationToken!: string | undefined;
    registrationDeadline!: DateTime | undefined;
    maxRegistrations!: number | undefined;
    checklistTotal!: number;
    checklistDone!: number;
    participantCount!: number;
    attendedCount!: number;
    registrationCount!: number;
    leadCount!: number;
    interactionCount!: number;
    canApprove!: boolean;

    constructor(data?: IMarketingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.eventType = _data["eventType"];
            this.mode = _data["mode"];
            this.format = _data["format"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.meetingLink = _data["meetingLink"];
            this.organizerOrganizationId = _data["organizerOrganizationId"];
            this.ownerUserId = _data["ownerUserId"];
            this.budget = _data["budget"];
            this.goals = _data["goals"];
            this.notes = _data["notes"];
            this.checklistTemplateId = _data["checklistTemplateId"];
            this.status = _data["status"];
            this.ownerName = _data["ownerName"];
            this.organizerOrganizationName = _data["organizerOrganizationName"];
            this.outcome = _data["outcome"];
            this.approvalRequestedByName = _data["approvalRequestedByName"];
            this.approvalRequestedTime = _data["approvalRequestedTime"] ? DateTime.fromISO(_data["approvalRequestedTime"].toString()) : <any>undefined;
            this.approvalDecidedByName = _data["approvalDecidedByName"];
            this.approvalDecidedTime = _data["approvalDecidedTime"] ? DateTime.fromISO(_data["approvalDecidedTime"].toString()) : <any>undefined;
            this.approvalComment = _data["approvalComment"];
            this.registrationEnabled = _data["registrationEnabled"];
            this.registrationToken = _data["registrationToken"];
            this.registrationDeadline = _data["registrationDeadline"] ? DateTime.fromISO(_data["registrationDeadline"].toString()) : <any>undefined;
            this.maxRegistrations = _data["maxRegistrations"];
            this.checklistTotal = _data["checklistTotal"];
            this.checklistDone = _data["checklistDone"];
            this.participantCount = _data["participantCount"];
            this.attendedCount = _data["attendedCount"];
            this.registrationCount = _data["registrationCount"];
            this.leadCount = _data["leadCount"];
            this.interactionCount = _data["interactionCount"];
            this.canApprove = _data["canApprove"];
        }
    }

    static fromJS(data: any): MarketingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["eventType"] = this.eventType;
        data["mode"] = this.mode;
        data["format"] = this.format;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["state"] = this.state;
        data["meetingLink"] = this.meetingLink;
        data["organizerOrganizationId"] = this.organizerOrganizationId;
        data["ownerUserId"] = this.ownerUserId;
        data["budget"] = this.budget;
        data["goals"] = this.goals;
        data["notes"] = this.notes;
        data["checklistTemplateId"] = this.checklistTemplateId;
        data["status"] = this.status;
        data["ownerName"] = this.ownerName;
        data["organizerOrganizationName"] = this.organizerOrganizationName;
        data["outcome"] = this.outcome;
        data["approvalRequestedByName"] = this.approvalRequestedByName;
        data["approvalRequestedTime"] = this.approvalRequestedTime ? this.approvalRequestedTime.toString() : <any>undefined;
        data["approvalDecidedByName"] = this.approvalDecidedByName;
        data["approvalDecidedTime"] = this.approvalDecidedTime ? this.approvalDecidedTime.toString() : <any>undefined;
        data["approvalComment"] = this.approvalComment;
        data["registrationEnabled"] = this.registrationEnabled;
        data["registrationToken"] = this.registrationToken;
        data["registrationDeadline"] = this.registrationDeadline ? this.registrationDeadline.toString() : <any>undefined;
        data["maxRegistrations"] = this.maxRegistrations;
        data["checklistTotal"] = this.checklistTotal;
        data["checklistDone"] = this.checklistDone;
        data["participantCount"] = this.participantCount;
        data["attendedCount"] = this.attendedCount;
        data["registrationCount"] = this.registrationCount;
        data["leadCount"] = this.leadCount;
        data["interactionCount"] = this.interactionCount;
        data["canApprove"] = this.canApprove;
        return data;
    }
}

export interface IMarketingEventDto {
    id: number | undefined;
    name: string;
    eventType: MarketingEventType;
    mode: MarketingEventMode;
    format: MarketingEventFormat;
    startDate: DateTime;
    endDate: DateTime;
    venue: string | undefined;
    address: string | undefined;
    state: string | undefined;
    meetingLink: string | undefined;
    organizerOrganizationId: number | undefined;
    ownerUserId: number | undefined;
    budget: number | undefined;
    goals: string | undefined;
    notes: string | undefined;
    checklistTemplateId: number | undefined;
    status: MarketingEventStatus;
    ownerName: string | undefined;
    organizerOrganizationName: string | undefined;
    outcome: string | undefined;
    approvalRequestedByName: string | undefined;
    approvalRequestedTime: DateTime | undefined;
    approvalDecidedByName: string | undefined;
    approvalDecidedTime: DateTime | undefined;
    approvalComment: string | undefined;
    registrationEnabled: boolean;
    registrationToken: string | undefined;
    registrationDeadline: DateTime | undefined;
    maxRegistrations: number | undefined;
    checklistTotal: number;
    checklistDone: number;
    participantCount: number;
    attendedCount: number;
    registrationCount: number;
    leadCount: number;
    interactionCount: number;
    canApprove: boolean;
}

export enum MarketingEventFormat {
    InPerson = 0,
    Virtual = 1,
    Hybrid = 2,
}

export class MarketingEventListDto implements IMarketingEventListDto {
    id!: number;
    name!: string | undefined;
    eventType!: MarketingEventType;
    mode!: MarketingEventMode;
    format!: MarketingEventFormat;
    startDate!: DateTime;
    endDate!: DateTime;
    venue!: string | undefined;
    state!: string | undefined;
    status!: MarketingEventStatus;
    ownerUserId!: number | undefined;
    ownerName!: string | undefined;
    budget!: number | undefined;
    checklistTotal!: number;
    checklistDone!: number;
    overdueTasks!: number;
    participantCount!: number;
    registrationCount!: number;
    leadCount!: number;

    constructor(data?: IMarketingEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.eventType = _data["eventType"];
            this.mode = _data["mode"];
            this.format = _data["format"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.state = _data["state"];
            this.status = _data["status"];
            this.ownerUserId = _data["ownerUserId"];
            this.ownerName = _data["ownerName"];
            this.budget = _data["budget"];
            this.checklistTotal = _data["checklistTotal"];
            this.checklistDone = _data["checklistDone"];
            this.overdueTasks = _data["overdueTasks"];
            this.participantCount = _data["participantCount"];
            this.registrationCount = _data["registrationCount"];
            this.leadCount = _data["leadCount"];
        }
    }

    static fromJS(data: any): MarketingEventListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["eventType"] = this.eventType;
        data["mode"] = this.mode;
        data["format"] = this.format;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["venue"] = this.venue;
        data["state"] = this.state;
        data["status"] = this.status;
        data["ownerUserId"] = this.ownerUserId;
        data["ownerName"] = this.ownerName;
        data["budget"] = this.budget;
        data["checklistTotal"] = this.checklistTotal;
        data["checklistDone"] = this.checklistDone;
        data["overdueTasks"] = this.overdueTasks;
        data["participantCount"] = this.participantCount;
        data["registrationCount"] = this.registrationCount;
        data["leadCount"] = this.leadCount;
        return data;
    }
}

export interface IMarketingEventListDto {
    id: number;
    name: string | undefined;
    eventType: MarketingEventType;
    mode: MarketingEventMode;
    format: MarketingEventFormat;
    startDate: DateTime;
    endDate: DateTime;
    venue: string | undefined;
    state: string | undefined;
    status: MarketingEventStatus;
    ownerUserId: number | undefined;
    ownerName: string | undefined;
    budget: number | undefined;
    checklistTotal: number;
    checklistDone: number;
    overdueTasks: number;
    participantCount: number;
    registrationCount: number;
    leadCount: number;
}

export enum MarketingEventMode {
    Attending = 0,
    Hosting = 1,
}

export class MarketingEventParticipantDto implements IMarketingEventParticipantDto {
    id!: number;
    eventId!: number;
    organizationId!: number | undefined;
    organizationName!: string | undefined;
    state!: string | undefined;
    contactId!: number | undefined;
    contactName!: string | undefined;
    contactTitle!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    participationType!: MarketingParticipationType;
    status!: MarketingParticipantStatus;
    notes!: string | undefined;

    constructor(data?: IMarketingEventParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.state = _data["state"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.contactTitle = _data["contactTitle"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.participationType = _data["participationType"];
            this.status = _data["status"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): MarketingEventParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["state"] = this.state;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["contactTitle"] = this.contactTitle;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["participationType"] = this.participationType;
        data["status"] = this.status;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IMarketingEventParticipantDto {
    id: number;
    eventId: number;
    organizationId: number | undefined;
    organizationName: string | undefined;
    state: string | undefined;
    contactId: number | undefined;
    contactName: string | undefined;
    contactTitle: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    participationType: MarketingParticipationType;
    status: MarketingParticipantStatus;
    notes: string | undefined;
}

export class MarketingEventRegistrationDto implements IMarketingEventRegistrationDto {
    id!: number | undefined;
    eventId!: number;
    firstName!: string;
    lastName!: string;
    email!: string | undefined;
    phone!: string | undefined;
    organizationName!: string | undefined;
    isBeneficiary!: boolean;
    notes!: string | undefined;
    attended!: boolean | undefined;
    source!: MarketingRegistrationSource;
    creationTime!: DateTime;
    leadId!: number | undefined;
    leadDisplayId!: string | undefined;

    constructor(data?: IMarketingEventRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventId = _data["eventId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.organizationName = _data["organizationName"];
            this.isBeneficiary = _data["isBeneficiary"];
            this.notes = _data["notes"];
            this.attended = _data["attended"];
            this.source = _data["source"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.leadDisplayId = _data["leadDisplayId"];
        }
    }

    static fromJS(data: any): MarketingEventRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingEventRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventId"] = this.eventId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["organizationName"] = this.organizationName;
        data["isBeneficiary"] = this.isBeneficiary;
        data["notes"] = this.notes;
        data["attended"] = this.attended;
        data["source"] = this.source;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["leadDisplayId"] = this.leadDisplayId;
        return data;
    }
}

export interface IMarketingEventRegistrationDto {
    id: number | undefined;
    eventId: number;
    firstName: string;
    lastName: string;
    email: string | undefined;
    phone: string | undefined;
    organizationName: string | undefined;
    isBeneficiary: boolean;
    notes: string | undefined;
    attended: boolean | undefined;
    source: MarketingRegistrationSource;
    creationTime: DateTime;
    leadId: number | undefined;
    leadDisplayId: string | undefined;
}

export enum MarketingEventStatus {
    Draft = 0,
    PendingApproval = 1,
    Approved = 2,
    Rejected = 3,
    Ready = 4,
    Completed = 5,
    Cancelled = 6,
}

export enum MarketingEventType {
    Conference = 0,
    JobFair = 1,
    Webinar = 2,
    CommunityOutreach = 3,
    InfoSession = 4,
    Other = 99,
}

export class MarketingImportResultDto implements IMarketingImportResultDto {
    previewOnly!: boolean;
    sheetsRead!: number;
    organizationsCreated!: number;
    organizationsUpdated!: number;
    contactsCreated!: number;
    contactsUpdated!: number;
    interactionsCreated!: number;
    interactionsSkipped!: number;
    sheets!: MarketingImportSheetResultDto[] | undefined;
    warnings!: string[] | undefined;

    constructor(data?: IMarketingImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previewOnly = _data["previewOnly"];
            this.sheetsRead = _data["sheetsRead"];
            this.organizationsCreated = _data["organizationsCreated"];
            this.organizationsUpdated = _data["organizationsUpdated"];
            this.contactsCreated = _data["contactsCreated"];
            this.contactsUpdated = _data["contactsUpdated"];
            this.interactionsCreated = _data["interactionsCreated"];
            this.interactionsSkipped = _data["interactionsSkipped"];
            if (Array.isArray(_data["sheets"])) {
                this.sheets = [] as any;
                for (let item of _data["sheets"])
                    this.sheets!.push(MarketingImportSheetResultDto.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
        }
    }

    static fromJS(data: any): MarketingImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previewOnly"] = this.previewOnly;
        data["sheetsRead"] = this.sheetsRead;
        data["organizationsCreated"] = this.organizationsCreated;
        data["organizationsUpdated"] = this.organizationsUpdated;
        data["contactsCreated"] = this.contactsCreated;
        data["contactsUpdated"] = this.contactsUpdated;
        data["interactionsCreated"] = this.interactionsCreated;
        data["interactionsSkipped"] = this.interactionsSkipped;
        if (Array.isArray(this.sheets)) {
            data["sheets"] = [];
            for (let item of this.sheets)
                data["sheets"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IMarketingImportResultDto {
    previewOnly: boolean;
    sheetsRead: number;
    organizationsCreated: number;
    organizationsUpdated: number;
    contactsCreated: number;
    contactsUpdated: number;
    interactionsCreated: number;
    interactionsSkipped: number;
    sheets: MarketingImportSheetResultDto[] | undefined;
    warnings: string[] | undefined;
}

export class MarketingImportSheetResultDto implements IMarketingImportSheetResultDto {
    sheetName!: string | undefined;
    ssaRegion!: string | undefined;
    agencies!: number;
    contacts!: number;
    interactions!: number;

    constructor(data?: IMarketingImportSheetResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheetName = _data["sheetName"];
            this.ssaRegion = _data["ssaRegion"];
            this.agencies = _data["agencies"];
            this.contacts = _data["contacts"];
            this.interactions = _data["interactions"];
        }
    }

    static fromJS(data: any): MarketingImportSheetResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingImportSheetResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheetName"] = this.sheetName;
        data["ssaRegion"] = this.ssaRegion;
        data["agencies"] = this.agencies;
        data["contacts"] = this.contacts;
        data["interactions"] = this.interactions;
        return data;
    }
}

export interface IMarketingImportSheetResultDto {
    sheetName: string | undefined;
    ssaRegion: string | undefined;
    agencies: number;
    contacts: number;
    interactions: number;
}

export enum MarketingInteractionDirection {
    Outbound = 0,
    Inbound = 1,
}

export class MarketingInteractionDto implements IMarketingInteractionDto {
    id!: number | undefined;
    organizationId!: number;
    contactId!: number | undefined;
    eventId!: number | undefined;
    interactionDate!: DateTime;
    method!: MarketingInteractionMethod;
    direction!: MarketingInteractionDirection;
    subject!: string | undefined;
    notes!: string | undefined;
    nextStep!: string | undefined;
    followUpDate!: DateTime | undefined;
    status!: MarketingInteractionStatus;
    organizationName!: string | undefined;
    state!: string | undefined;
    contactName!: string | undefined;
    eventName!: string | undefined;
    loggedBy!: string | undefined;
    isOverdue!: boolean;
    emailBody!: string | undefined;

    constructor(data?: IMarketingInteractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.contactId = _data["contactId"];
            this.eventId = _data["eventId"];
            this.interactionDate = _data["interactionDate"] ? DateTime.fromISO(_data["interactionDate"].toString()) : <any>undefined;
            this.method = _data["method"];
            this.direction = _data["direction"];
            this.subject = _data["subject"];
            this.notes = _data["notes"];
            this.nextStep = _data["nextStep"];
            this.followUpDate = _data["followUpDate"] ? DateTime.fromISO(_data["followUpDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.organizationName = _data["organizationName"];
            this.state = _data["state"];
            this.contactName = _data["contactName"];
            this.eventName = _data["eventName"];
            this.loggedBy = _data["loggedBy"];
            this.isOverdue = _data["isOverdue"];
            this.emailBody = _data["emailBody"];
        }
    }

    static fromJS(data: any): MarketingInteractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingInteractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["contactId"] = this.contactId;
        data["eventId"] = this.eventId;
        data["interactionDate"] = this.interactionDate ? this.interactionDate.toString() : <any>undefined;
        data["method"] = this.method;
        data["direction"] = this.direction;
        data["subject"] = this.subject;
        data["notes"] = this.notes;
        data["nextStep"] = this.nextStep;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.toString() : <any>undefined;
        data["status"] = this.status;
        data["organizationName"] = this.organizationName;
        data["state"] = this.state;
        data["contactName"] = this.contactName;
        data["eventName"] = this.eventName;
        data["loggedBy"] = this.loggedBy;
        data["isOverdue"] = this.isOverdue;
        data["emailBody"] = this.emailBody;
        return data;
    }
}

export interface IMarketingInteractionDto {
    id: number | undefined;
    organizationId: number;
    contactId: number | undefined;
    eventId: number | undefined;
    interactionDate: DateTime;
    method: MarketingInteractionMethod;
    direction: MarketingInteractionDirection;
    subject: string | undefined;
    notes: string | undefined;
    nextStep: string | undefined;
    followUpDate: DateTime | undefined;
    status: MarketingInteractionStatus;
    organizationName: string | undefined;
    state: string | undefined;
    contactName: string | undefined;
    eventName: string | undefined;
    loggedBy: string | undefined;
    isOverdue: boolean;
    emailBody: string | undefined;
}

export enum MarketingInteractionMethod {
    Call = 0,
    Email = 1,
    Meeting = 2,
    Fax = 3,
    Event = 4,
    Letter = 5,
    Other = 99,
}

export enum MarketingInteractionStatus {
    Open = 0,
    Done = 1,
    Cancelled = 2,
}

export class MarketingMonthlyReferralDto implements IMarketingMonthlyReferralDto {
    month!: DateTime;
    referrals!: number;
    enrolled!: number;

    constructor(data?: IMarketingMonthlyReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"] ? DateTime.fromISO(_data["month"].toString()) : <any>undefined;
            this.referrals = _data["referrals"];
            this.enrolled = _data["enrolled"];
        }
    }

    static fromJS(data: any): MarketingMonthlyReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingMonthlyReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month ? this.month.toString() : <any>undefined;
        data["referrals"] = this.referrals;
        data["enrolled"] = this.enrolled;
        return data;
    }
}

export interface IMarketingMonthlyReferralDto {
    month: DateTime;
    referrals: number;
    enrolled: number;
}

export class MarketingOrganizationContactDto implements IMarketingOrganizationContactDto {
    id!: number | undefined;
    name!: string;
    title!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;

    constructor(data?: IMarketingOrganizationContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): MarketingOrganizationContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingOrganizationContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IMarketingOrganizationContactDto {
    id: number | undefined;
    name: string;
    title: string | undefined;
    email: string | undefined;
    phone: string | undefined;
}

export class MarketingOrganizationDto implements IMarketingOrganizationDto {
    id!: number | undefined;
    name!: string;
    type!: MarketingOrganizationType;
    agencyCode!: string | undefined;
    pid!: string | undefined;
    ssaRegion!: string | undefined;
    state!: string | undefined;
    address!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    fax!: string | undefined;
    relationshipStage!: MarketingRelationshipStage;
    ownerUserId!: number | undefined;
    notes!: string | undefined;
    contacts!: MarketingOrganizationContactDto[] | undefined;
    ownerName!: string | undefined;
    ein!: string | undefined;
    category!: string | undefined;
    annualRevenue!: number | undefined;
    partnerCode!: string | undefined;
    partnerLoginUserName!: string | undefined;
    partnerLoginEmail!: string | undefined;

    constructor(data?: IMarketingOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.agencyCode = _data["agencyCode"];
            this.pid = _data["pid"];
            this.ssaRegion = _data["ssaRegion"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.fax = _data["fax"];
            this.relationshipStage = _data["relationshipStage"];
            this.ownerUserId = _data["ownerUserId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(MarketingOrganizationContactDto.fromJS(item));
            }
            this.ownerName = _data["ownerName"];
            this.ein = _data["ein"];
            this.category = _data["category"];
            this.annualRevenue = _data["annualRevenue"];
            this.partnerCode = _data["partnerCode"];
            this.partnerLoginUserName = _data["partnerLoginUserName"];
            this.partnerLoginEmail = _data["partnerLoginEmail"];
        }
    }

    static fromJS(data: any): MarketingOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["agencyCode"] = this.agencyCode;
        data["pid"] = this.pid;
        data["ssaRegion"] = this.ssaRegion;
        data["state"] = this.state;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["fax"] = this.fax;
        data["relationshipStage"] = this.relationshipStage;
        data["ownerUserId"] = this.ownerUserId;
        data["notes"] = this.notes;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["ownerName"] = this.ownerName;
        data["ein"] = this.ein;
        data["category"] = this.category;
        data["annualRevenue"] = this.annualRevenue;
        data["partnerCode"] = this.partnerCode;
        data["partnerLoginUserName"] = this.partnerLoginUserName;
        data["partnerLoginEmail"] = this.partnerLoginEmail;
        return data;
    }
}

export interface IMarketingOrganizationDto {
    id: number | undefined;
    name: string;
    type: MarketingOrganizationType;
    agencyCode: string | undefined;
    pid: string | undefined;
    ssaRegion: string | undefined;
    state: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    website: string | undefined;
    fax: string | undefined;
    relationshipStage: MarketingRelationshipStage;
    ownerUserId: number | undefined;
    notes: string | undefined;
    contacts: MarketingOrganizationContactDto[] | undefined;
    ownerName: string | undefined;
    ein: string | undefined;
    category: string | undefined;
    annualRevenue: number | undefined;
    partnerCode: string | undefined;
    partnerLoginUserName: string | undefined;
    partnerLoginEmail: string | undefined;
}

export class MarketingOrganizationListDto implements IMarketingOrganizationListDto {
    id!: number;
    name!: string | undefined;
    type!: MarketingOrganizationType;
    agencyCode!: string | undefined;
    maskedPid!: string | undefined;
    partnerCode!: string | undefined;
    ein!: string | undefined;
    category!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    ssaRegion!: string | undefined;
    state!: string | undefined;
    relationshipStage!: MarketingRelationshipStage;
    ownerUserId!: number | undefined;
    ownerName!: string | undefined;
    contactCount!: number;
    interactionCount!: number;
    lastContactDate!: DateTime | undefined;
    openItems!: number;
    nextFollowUpDate!: DateTime | undefined;
    overdueFollowUps!: number;
    referralCount!: number;
    enrolledReferralCount!: number;

    constructor(data?: IMarketingOrganizationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.agencyCode = _data["agencyCode"];
            this.maskedPid = _data["maskedPid"];
            this.partnerCode = _data["partnerCode"];
            this.ein = _data["ein"];
            this.category = _data["category"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.ssaRegion = _data["ssaRegion"];
            this.state = _data["state"];
            this.relationshipStage = _data["relationshipStage"];
            this.ownerUserId = _data["ownerUserId"];
            this.ownerName = _data["ownerName"];
            this.contactCount = _data["contactCount"];
            this.interactionCount = _data["interactionCount"];
            this.lastContactDate = _data["lastContactDate"] ? DateTime.fromISO(_data["lastContactDate"].toString()) : <any>undefined;
            this.openItems = _data["openItems"];
            this.nextFollowUpDate = _data["nextFollowUpDate"] ? DateTime.fromISO(_data["nextFollowUpDate"].toString()) : <any>undefined;
            this.overdueFollowUps = _data["overdueFollowUps"];
            this.referralCount = _data["referralCount"];
            this.enrolledReferralCount = _data["enrolledReferralCount"];
        }
    }

    static fromJS(data: any): MarketingOrganizationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingOrganizationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["agencyCode"] = this.agencyCode;
        data["maskedPid"] = this.maskedPid;
        data["partnerCode"] = this.partnerCode;
        data["ein"] = this.ein;
        data["category"] = this.category;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["ssaRegion"] = this.ssaRegion;
        data["state"] = this.state;
        data["relationshipStage"] = this.relationshipStage;
        data["ownerUserId"] = this.ownerUserId;
        data["ownerName"] = this.ownerName;
        data["contactCount"] = this.contactCount;
        data["interactionCount"] = this.interactionCount;
        data["lastContactDate"] = this.lastContactDate ? this.lastContactDate.toString() : <any>undefined;
        data["openItems"] = this.openItems;
        data["nextFollowUpDate"] = this.nextFollowUpDate ? this.nextFollowUpDate.toString() : <any>undefined;
        data["overdueFollowUps"] = this.overdueFollowUps;
        data["referralCount"] = this.referralCount;
        data["enrolledReferralCount"] = this.enrolledReferralCount;
        return data;
    }
}

export interface IMarketingOrganizationListDto {
    id: number;
    name: string | undefined;
    type: MarketingOrganizationType;
    agencyCode: string | undefined;
    maskedPid: string | undefined;
    partnerCode: string | undefined;
    ein: string | undefined;
    category: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    website: string | undefined;
    ssaRegion: string | undefined;
    state: string | undefined;
    relationshipStage: MarketingRelationshipStage;
    ownerUserId: number | undefined;
    ownerName: string | undefined;
    contactCount: number;
    interactionCount: number;
    lastContactDate: DateTime | undefined;
    openItems: number;
    nextFollowUpDate: DateTime | undefined;
    overdueFollowUps: number;
    referralCount: number;
    enrolledReferralCount: number;
}

export class MarketingOrganizationNoteDto implements IMarketingOrganizationNoteDto {
    id!: number | undefined;
    organizationId!: number;
    note!: string;
    isPinned!: boolean;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    createdBy!: string | undefined;
    canEdit!: boolean;

    constructor(data?: IMarketingOrganizationNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.note = _data["note"];
            this.isPinned = _data["isPinned"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.canEdit = _data["canEdit"];
        }
    }

    static fromJS(data: any): MarketingOrganizationNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingOrganizationNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["note"] = this.note;
        data["isPinned"] = this.isPinned;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["canEdit"] = this.canEdit;
        return data;
    }
}

export interface IMarketingOrganizationNoteDto {
    id: number | undefined;
    organizationId: number;
    note: string;
    isPinned: boolean;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    createdBy: string | undefined;
    canEdit: boolean;
}

export class MarketingOrganizationReferralDto implements IMarketingOrganizationReferralDto {
    id!: number;
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    status!: ReferralStatus;
    statusName!: string | undefined;
    submittedDate!: DateTime;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    rewardAmount!: number;
    rewardIssuedDate!: DateTime | undefined;
    leadDisplayId!: string | undefined;
    activityCount!: number;
    lastActivityDate!: DateTime | undefined;

    constructor(data?: IMarketingOrganizationReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.rewardAmount = _data["rewardAmount"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.leadDisplayId = _data["leadDisplayId"];
            this.activityCount = _data["activityCount"];
            this.lastActivityDate = _data["lastActivityDate"] ? DateTime.fromISO(_data["lastActivityDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingOrganizationReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingOrganizationReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["rewardAmount"] = this.rewardAmount;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["leadDisplayId"] = this.leadDisplayId;
        data["activityCount"] = this.activityCount;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMarketingOrganizationReferralDto {
    id: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    status: ReferralStatus;
    statusName: string | undefined;
    submittedDate: DateTime;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    rewardAmount: number;
    rewardIssuedDate: DateTime | undefined;
    leadDisplayId: string | undefined;
    activityCount: number;
    lastActivityDate: DateTime | undefined;
}

export enum MarketingOrganizationType {
    StateVRAgency = 0,
    SsaOffice = 1,
    WorkforceCenter = 2,
    Employer = 3,
    BusinessPartner = 4,
    Nonprofit = 5,
    Other = 99,
}

export enum MarketingParticipantStatus {
    Planned = 0,
    Invited = 1,
    Confirmed = 2,
    Attended = 3,
    NoShow = 4,
}

export enum MarketingParticipationType {
    Target = 0,
    Invitee = 1,
    Organizer = 2,
    Exhibitor = 3,
    Speaker = 4,
    Attendee = 5,
}

export class MarketingPartnerAttentionDto implements IMarketingPartnerAttentionDto {
    organizationId!: number;
    name!: string | undefined;
    stage!: MarketingRelationshipStage;
    reason!: string | undefined;

    constructor(data?: IMarketingPartnerAttentionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.stage = _data["stage"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MarketingPartnerAttentionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingPartnerAttentionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["stage"] = this.stage;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMarketingPartnerAttentionDto {
    organizationId: number;
    name: string | undefined;
    stage: MarketingRelationshipStage;
    reason: string | undefined;
}

export class MarketingPartnerLoginDto implements IMarketingPartnerLoginDto {
    userId!: number;
    name!: string | undefined;
    email!: string | undefined;
    userName!: string | undefined;
    isAdmin!: boolean;
    isActive!: boolean;
    mustChangePassword!: boolean;
    creationTime!: DateTime;

    constructor(data?: IMarketingPartnerLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.isAdmin = _data["isAdmin"];
            this.isActive = _data["isActive"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingPartnerLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingPartnerLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["isAdmin"] = this.isAdmin;
        data["isActive"] = this.isActive;
        data["mustChangePassword"] = this.mustChangePassword;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMarketingPartnerLoginDto {
    userId: number;
    name: string | undefined;
    email: string | undefined;
    userName: string | undefined;
    isAdmin: boolean;
    isActive: boolean;
    mustChangePassword: boolean;
    creationTime: DateTime;
}

export class MarketingPartnerPerformanceDto implements IMarketingPartnerPerformanceDto {
    organizationId!: number;
    name!: string | undefined;
    state!: string | undefined;
    partnerCode!: string | undefined;
    stage!: MarketingRelationshipStage;
    referrals!: number;
    enrolled!: number;
    hired!: number;
    lastReferralDate!: DateTime | undefined;

    constructor(data?: IMarketingPartnerPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.partnerCode = _data["partnerCode"];
            this.stage = _data["stage"];
            this.referrals = _data["referrals"];
            this.enrolled = _data["enrolled"];
            this.hired = _data["hired"];
            this.lastReferralDate = _data["lastReferralDate"] ? DateTime.fromISO(_data["lastReferralDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingPartnerPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingPartnerPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["state"] = this.state;
        data["partnerCode"] = this.partnerCode;
        data["stage"] = this.stage;
        data["referrals"] = this.referrals;
        data["enrolled"] = this.enrolled;
        data["hired"] = this.hired;
        data["lastReferralDate"] = this.lastReferralDate ? this.lastReferralDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMarketingPartnerPerformanceDto {
    organizationId: number;
    name: string | undefined;
    state: string | undefined;
    partnerCode: string | undefined;
    stage: MarketingRelationshipStage;
    referrals: number;
    enrolled: number;
    hired: number;
    lastReferralDate: DateTime | undefined;
}

export class MarketingReferralHistoryItemDto implements IMarketingReferralHistoryItemDto {
    date!: DateTime;
    referralId!: number;
    referralName!: string | undefined;
    leadDisplayId!: string | undefined;
    type!: string | undefined;
    direction!: string | undefined;
    subject!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;

    constructor(data?: IMarketingReferralHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.referralId = _data["referralId"];
            this.referralName = _data["referralName"];
            this.leadDisplayId = _data["leadDisplayId"];
            this.type = _data["type"];
            this.direction = _data["direction"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MarketingReferralHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingReferralHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["referralId"] = this.referralId;
        data["referralName"] = this.referralName;
        data["leadDisplayId"] = this.leadDisplayId;
        data["type"] = this.type;
        data["direction"] = this.direction;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["status"] = this.status;
        return data;
    }
}

export interface IMarketingReferralHistoryItemDto {
    date: DateTime;
    referralId: number;
    referralName: string | undefined;
    leadDisplayId: string | undefined;
    type: string | undefined;
    direction: string | undefined;
    subject: string | undefined;
    content: string | undefined;
    status: string | undefined;
}

export enum MarketingRegistrationSource {
    Public = 0,
    Staff = 1,
}

export enum MarketingRelationshipStage {
    Identified = 0,
    Contacted = 1,
    Engaged = 2,
    MeetingHeld = 3,
    Contracted = 4,
    ActivePartner = 5,
    Inactive = 6,
    AgreementSent = 7,
}

export enum MarketingStageChangeSource {
    Manual = 0,
    Interaction = 1,
    Email = 2,
}

export class MarketingStageCountDto implements IMarketingStageCountDto {
    stage!: MarketingRelationshipStage;
    count!: number;
    reachedCount!: number;

    constructor(data?: IMarketingStageCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data["stage"];
            this.count = _data["count"];
            this.reachedCount = _data["reachedCount"];
        }
    }

    static fromJS(data: any): MarketingStageCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingStageCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["count"] = this.count;
        data["reachedCount"] = this.reachedCount;
        return data;
    }
}

export interface IMarketingStageCountDto {
    stage: MarketingRelationshipStage;
    count: number;
    reachedCount: number;
}

export class MarketingStageHistoryDto implements IMarketingStageHistoryDto {
    id!: number;
    fromStage!: MarketingRelationshipStage;
    toStage!: MarketingRelationshipStage;
    source!: MarketingStageChangeSource;
    note!: string | undefined;
    creationTime!: DateTime;
    changedBy!: string | undefined;

    constructor(data?: IMarketingStageHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromStage = _data["fromStage"];
            this.toStage = _data["toStage"];
            this.source = _data["source"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.changedBy = _data["changedBy"];
        }
    }

    static fromJS(data: any): MarketingStageHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingStageHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromStage"] = this.fromStage;
        data["toStage"] = this.toStage;
        data["source"] = this.source;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["changedBy"] = this.changedBy;
        return data;
    }
}

export interface IMarketingStageHistoryDto {
    id: number;
    fromStage: MarketingRelationshipStage;
    toStage: MarketingRelationshipStage;
    source: MarketingStageChangeSource;
    note: string | undefined;
    creationTime: DateTime;
    changedBy: string | undefined;
}

export class MarketingStateSummaryDto implements IMarketingStateSummaryDto {
    ssaRegion!: string | undefined;
    state!: string | undefined;
    agencyCodes!: string | undefined;
    contactCount!: number;
    interactionCount!: number;
    lastContactDate!: DateTime | undefined;
    openItems!: number;
    nextFollowUpDate!: DateTime | undefined;
    overdueFollowUps!: number;

    constructor(data?: IMarketingStateSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssaRegion = _data["ssaRegion"];
            this.state = _data["state"];
            this.agencyCodes = _data["agencyCodes"];
            this.contactCount = _data["contactCount"];
            this.interactionCount = _data["interactionCount"];
            this.lastContactDate = _data["lastContactDate"] ? DateTime.fromISO(_data["lastContactDate"].toString()) : <any>undefined;
            this.openItems = _data["openItems"];
            this.nextFollowUpDate = _data["nextFollowUpDate"] ? DateTime.fromISO(_data["nextFollowUpDate"].toString()) : <any>undefined;
            this.overdueFollowUps = _data["overdueFollowUps"];
        }
    }

    static fromJS(data: any): MarketingStateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingStateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssaRegion"] = this.ssaRegion;
        data["state"] = this.state;
        data["agencyCodes"] = this.agencyCodes;
        data["contactCount"] = this.contactCount;
        data["interactionCount"] = this.interactionCount;
        data["lastContactDate"] = this.lastContactDate ? this.lastContactDate.toString() : <any>undefined;
        data["openItems"] = this.openItems;
        data["nextFollowUpDate"] = this.nextFollowUpDate ? this.nextFollowUpDate.toString() : <any>undefined;
        data["overdueFollowUps"] = this.overdueFollowUps;
        return data;
    }
}

export interface IMarketingStateSummaryDto {
    ssaRegion: string | undefined;
    state: string | undefined;
    agencyCodes: string | undefined;
    contactCount: number;
    interactionCount: number;
    lastContactDate: DateTime | undefined;
    openItems: number;
    nextFollowUpDate: DateTime | undefined;
    overdueFollowUps: number;
}

export class MassNotificationOrganizationUnitLookupTableDto implements IMassNotificationOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMassNotificationOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MassNotificationOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassNotificationOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMassNotificationOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MassNotificationUserLookupTableDto implements IMassNotificationUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMassNotificationUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MassNotificationUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MassNotificationUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMassNotificationUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MedicaidDetail implements IMedicaidDetail {
    eligibilityType!: MedicaidEligibilityType;
    determination!: string | undefined;
    isBuyIn!: boolean | undefined;
    coverageStartDate!: DateTime | undefined;
    coverageEndDate!: DateTime | undefined;

    constructor(data?: IMedicaidDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligibilityType = _data["eligibilityType"];
            this.determination = _data["determination"];
            this.isBuyIn = _data["isBuyIn"];
            this.coverageStartDate = _data["coverageStartDate"] ? DateTime.fromISO(_data["coverageStartDate"].toString()) : <any>undefined;
            this.coverageEndDate = _data["coverageEndDate"] ? DateTime.fromISO(_data["coverageEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicaidDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MedicaidDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligibilityType"] = this.eligibilityType;
        data["determination"] = this.determination;
        data["isBuyIn"] = this.isBuyIn;
        data["coverageStartDate"] = this.coverageStartDate ? this.coverageStartDate.toString() : <any>undefined;
        data["coverageEndDate"] = this.coverageEndDate ? this.coverageEndDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMedicaidDetail {
    eligibilityType: MedicaidEligibilityType;
    determination: string | undefined;
    isBuyIn: boolean | undefined;
    coverageStartDate: DateTime | undefined;
    coverageEndDate: DateTime | undefined;
}

export class MedicaidDetailDto implements IMedicaidDetailDto {
    eligibilityType!: MedicaidEligibilityType;
    enumEligibilityTypeValue!: string | undefined;
    determination!: string | undefined;
    isBuyIn!: boolean | undefined;
    coverageStartDate!: DateTime | undefined;
    coverageEndDate!: DateTime | undefined;

    constructor(data?: IMedicaidDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligibilityType = _data["eligibilityType"];
            this.enumEligibilityTypeValue = _data["enumEligibilityTypeValue"];
            this.determination = _data["determination"];
            this.isBuyIn = _data["isBuyIn"];
            this.coverageStartDate = _data["coverageStartDate"] ? DateTime.fromISO(_data["coverageStartDate"].toString()) : <any>undefined;
            this.coverageEndDate = _data["coverageEndDate"] ? DateTime.fromISO(_data["coverageEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicaidDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicaidDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligibilityType"] = this.eligibilityType;
        data["enumEligibilityTypeValue"] = this.enumEligibilityTypeValue;
        data["determination"] = this.determination;
        data["isBuyIn"] = this.isBuyIn;
        data["coverageStartDate"] = this.coverageStartDate ? this.coverageStartDate.toString() : <any>undefined;
        data["coverageEndDate"] = this.coverageEndDate ? this.coverageEndDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMedicaidDetailDto {
    eligibilityType: MedicaidEligibilityType;
    enumEligibilityTypeValue: string | undefined;
    determination: string | undefined;
    isBuyIn: boolean | undefined;
    coverageStartDate: DateTime | undefined;
    coverageEndDate: DateTime | undefined;
}

export enum MedicaidEligibilityType {
    Unknown = 0,
    SSI = 1,
    MAGI = 2,
    DualEligible = 3,
    AgedBlindDisabled = 4,
}

export class MedicalInsuranceDto implements IMedicalInsuranceDto {
    ticketHolderId!: number;
    isMedicare!: boolean | undefined;
    medicareDescription!: MedicareDetail[] | undefined;
    isMedicaid!: boolean | undefined;
    medicaidDescription!: MedicaidDetail;

    constructor(data?: IMedicalInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.isMedicare = _data["isMedicare"];
            if (Array.isArray(_data["medicareDescription"])) {
                this.medicareDescription = [] as any;
                for (let item of _data["medicareDescription"])
                    this.medicareDescription!.push(MedicareDetail.fromJS(item));
            }
            this.isMedicaid = _data["isMedicaid"];
            this.medicaidDescription = _data["medicaidDescription"] ? MedicaidDetail.fromJS(_data["medicaidDescription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["isMedicare"] = this.isMedicare;
        if (Array.isArray(this.medicareDescription)) {
            data["medicareDescription"] = [];
            for (let item of this.medicareDescription)
                data["medicareDescription"].push(item.toJSON());
        }
        data["isMedicaid"] = this.isMedicaid;
        data["medicaidDescription"] = this.medicaidDescription ? this.medicaidDescription.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMedicalInsuranceDto {
    ticketHolderId: number;
    isMedicare: boolean | undefined;
    medicareDescription: MedicareDetail[] | undefined;
    isMedicaid: boolean | undefined;
    medicaidDescription: MedicaidDetail;
}

export class MedicalInsuranceResponseDto implements IMedicalInsuranceResponseDto {
    id!: number;
    ticketHolderId!: number;
    isMedicare!: boolean | undefined;
    creationTime!: DateTime;
    medicareDescription!: MedicareDetailDto[] | undefined;
    isMedicaid!: boolean | undefined;
    medicaidDescription!: MedicaidDetailDto;

    constructor(data?: IMedicalInsuranceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.isMedicare = _data["isMedicare"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["medicareDescription"])) {
                this.medicareDescription = [] as any;
                for (let item of _data["medicareDescription"])
                    this.medicareDescription!.push(MedicareDetailDto.fromJS(item));
            }
            this.isMedicaid = _data["isMedicaid"];
            this.medicaidDescription = _data["medicaidDescription"] ? MedicaidDetailDto.fromJS(_data["medicaidDescription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedicalInsuranceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalInsuranceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["isMedicare"] = this.isMedicare;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        if (Array.isArray(this.medicareDescription)) {
            data["medicareDescription"] = [];
            for (let item of this.medicareDescription)
                data["medicareDescription"].push(item.toJSON());
        }
        data["isMedicaid"] = this.isMedicaid;
        data["medicaidDescription"] = this.medicaidDescription ? this.medicaidDescription.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMedicalInsuranceResponseDto {
    id: number;
    ticketHolderId: number;
    isMedicare: boolean | undefined;
    creationTime: DateTime;
    medicareDescription: MedicareDetailDto[] | undefined;
    isMedicaid: boolean | undefined;
    medicaidDescription: MedicaidDetailDto;
}

export class MedicareDetail implements IMedicareDetail {
    medicarePart!: MedicarePart;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    isBuyIn!: boolean | undefined;

    constructor(data?: IMedicareDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicarePart = _data["medicarePart"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.isBuyIn = _data["isBuyIn"];
        }
    }

    static fromJS(data: any): MedicareDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MedicareDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicarePart"] = this.medicarePart;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["isBuyIn"] = this.isBuyIn;
        return data;
    }
}

export interface IMedicareDetail {
    medicarePart: MedicarePart;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    isBuyIn: boolean | undefined;
}

export class MedicareDetailDto implements IMedicareDetailDto {
    medicarePart!: MedicarePart;
    enumMedicarePartValue!: string | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    isBuyIn!: boolean | undefined;

    constructor(data?: IMedicareDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicarePart = _data["medicarePart"];
            this.enumMedicarePartValue = _data["enumMedicarePartValue"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.isBuyIn = _data["isBuyIn"];
        }
    }

    static fromJS(data: any): MedicareDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicareDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicarePart"] = this.medicarePart;
        data["enumMedicarePartValue"] = this.enumMedicarePartValue;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["isBuyIn"] = this.isBuyIn;
        return data;
    }
}

export interface IMedicareDetailDto {
    medicarePart: MedicarePart;
    enumMedicarePartValue: string | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    isBuyIn: boolean | undefined;
}

export enum MedicarePart {
    PartA = 1,
    PartB = 2,
    PartC = 3,
    PartD = 4,
}

export class MeetingJoinInfoDto implements IMeetingJoinInfoDto {
    joinedByUserId!: number | undefined;
    joinedByName!: string | undefined;
    joinedAtUtc!: DateTime | undefined;

    constructor(data?: IMeetingJoinInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.joinedByUserId = _data["joinedByUserId"];
            this.joinedByName = _data["joinedByName"];
            this.joinedAtUtc = _data["joinedAtUtc"] ? DateTime.fromISO(_data["joinedAtUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeetingJoinInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingJoinInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["joinedByUserId"] = this.joinedByUserId;
        data["joinedByName"] = this.joinedByName;
        data["joinedAtUtc"] = this.joinedAtUtc ? this.joinedAtUtc.toString() : <any>undefined;
        return data;
    }
}

export interface IMeetingJoinInfoDto {
    joinedByUserId: number | undefined;
    joinedByName: string | undefined;
    joinedAtUtc: DateTime | undefined;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;
    profilePictureName!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
            this.profilePictureName = _data["profilePictureName"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        data["profilePictureName"] = this.profilePictureName;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
    profilePictureName: string | undefined;
}

export class MemberInfo implements IMemberInfo {
    memberType!: MemberTypes;
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export class MessageAttachmentInfo implements IMessageAttachmentInfo {
    id!: number | undefined;
    uri!: string | undefined;
    type!: string | undefined;
    contentType!: string | undefined;
    vmDuration!: number | undefined;
    fileName!: string | undefined;
    size!: number | undefined;
    height!: number | undefined;
    width!: number | undefined;

    constructor(data?: IMessageAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.type = _data["type"];
            this.contentType = _data["contentType"];
            this.vmDuration = _data["vmDuration"];
            this.fileName = _data["fileName"];
            this.size = _data["size"];
            this.height = _data["height"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): MessageAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["type"] = this.type;
        data["contentType"] = this.contentType;
        data["vmDuration"] = this.vmDuration;
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        data["height"] = this.height;
        data["width"] = this.width;
        return data;
    }
}

export interface IMessageAttachmentInfo {
    id: number | undefined;
    uri: string | undefined;
    type: string | undefined;
    contentType: string | undefined;
    vmDuration: number | undefined;
    fileName: string | undefined;
    size: number | undefined;
    height: number | undefined;
    width: number | undefined;
}

export class MessageAttachmentInfoIntId implements IMessageAttachmentInfoIntId {
    id!: number | undefined;
    uri!: string | undefined;
    type!: string | undefined;
    contentType!: string | undefined;
    filename!: string | undefined;
    size!: number | undefined;

    constructor(data?: IMessageAttachmentInfoIntId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uri = _data["uri"];
            this.type = _data["type"];
            this.contentType = _data["contentType"];
            this.filename = _data["filename"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): MessageAttachmentInfoIntId {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAttachmentInfoIntId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uri"] = this.uri;
        data["type"] = this.type;
        data["contentType"] = this.contentType;
        data["filename"] = this.filename;
        data["size"] = this.size;
        return data;
    }
}

export interface IMessageAttachmentInfoIntId {
    id: number | undefined;
    uri: string | undefined;
    type: string | undefined;
    contentType: string | undefined;
    filename: string | undefined;
    size: number | undefined;
}

export class MessageStoreCallerInfoResponseFrom implements IMessageStoreCallerInfoResponseFrom {
    extensionNumber!: string | undefined;
    extensionId!: string | undefined;
    location!: string | undefined;
    name!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IMessageStoreCallerInfoResponseFrom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionNumber = _data["extensionNumber"];
            this.extensionId = _data["extensionId"];
            this.location = _data["location"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): MessageStoreCallerInfoResponseFrom {
        data = typeof data === 'object' ? data : {};
        let result = new MessageStoreCallerInfoResponseFrom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionNumber"] = this.extensionNumber;
        data["extensionId"] = this.extensionId;
        data["location"] = this.location;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IMessageStoreCallerInfoResponseFrom {
    extensionNumber: string | undefined;
    extensionId: string | undefined;
    location: string | undefined;
    name: string | undefined;
    phoneNumber: string | undefined;
}

export class MessageStoreCallerInfoResponseTo implements IMessageStoreCallerInfoResponseTo {
    extensionNumber!: string | undefined;
    extensionId!: string | undefined;
    location!: string | undefined;
    target!: boolean | undefined;
    messageStatus!: string | undefined;
    faxErrorCode!: string | undefined;
    name!: string | undefined;
    phoneNumber!: string | undefined;
    recipientId!: string | undefined;

    constructor(data?: IMessageStoreCallerInfoResponseTo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extensionNumber = _data["extensionNumber"];
            this.extensionId = _data["extensionId"];
            this.location = _data["location"];
            this.target = _data["target"];
            this.messageStatus = _data["messageStatus"];
            this.faxErrorCode = _data["faxErrorCode"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.recipientId = _data["recipientId"];
        }
    }

    static fromJS(data: any): MessageStoreCallerInfoResponseTo {
        data = typeof data === 'object' ? data : {};
        let result = new MessageStoreCallerInfoResponseTo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionNumber"] = this.extensionNumber;
        data["extensionId"] = this.extensionId;
        data["location"] = this.location;
        data["target"] = this.target;
        data["messageStatus"] = this.messageStatus;
        data["faxErrorCode"] = this.faxErrorCode;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["recipientId"] = this.recipientId;
        return data;
    }
}

export interface IMessageStoreCallerInfoResponseTo {
    extensionNumber: string | undefined;
    extensionId: string | undefined;
    location: string | undefined;
    target: boolean | undefined;
    messageStatus: string | undefined;
    faxErrorCode: string | undefined;
    name: string | undefined;
    phoneNumber: string | undefined;
    recipientId: string | undefined;
}

export class MessageTemplateAttachmentDto implements IMessageTemplateAttachmentDto {
    documentId!: number;
    documentName!: string | undefined;
    displayOrder!: number;

    constructor(data?: IMessageTemplateAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentName = _data["documentName"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): MessageTemplateAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTemplateAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentName"] = this.documentName;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IMessageTemplateAttachmentDto {
    documentId: number;
    documentName: string | undefined;
    displayOrder: number;
}

export enum MessageTemplateType {
    Email = 1,
    SMS = 2,
    Fax = 3,
    Mail = 4,
    Others = 5,
}

export enum MethodAttributes {
    PrivateScope = 0,
    ReuseSlot = 1,
    Private = 2,
    FamANDAssem = 3,
    Assembly = 4,
    Family = 5,
    FamORAssem = 6,
    Public = 7,
    MemberAccessMask = 8,
    UnmanagedExport = 16,
    Static = 32,
    Final = 64,
    Virtual = 128,
    HideBySig = 256,
    NewSlot = 512,
    VtableLayoutMask = 1024,
    CheckAccessOnOverride = 2048,
    Abstract = 4096,
    SpecialName = 8192,
    RTSpecialName = 16384,
    PinvokeImpl = 32768,
    HasSecurity = 53248,
}

export class MethodBase implements IMethodBase {
    memberType!: MemberTypes;
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }
}

export interface IMethodBase {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 1,
    Native = 2,
    OPTIL = 3,
    CodeTypeMask = 4,
    Runtime = 8,
    ManagedMask = 16,
    Unmanaged = 32,
    NoInlining = 64,
    ForwardRef = 128,
    Synchronized = 256,
    NoOptimization = 512,
    PreserveSig = 4096,
    AggressiveInlining = 65535,
}

export class MethodInfo implements IMethodInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    attributes!: MethodAttributes;
    methodImplementationFlags!: MethodImplAttributes;
    callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    memberType!: MemberTypes;
    returnParameter!: ParameterInfo;
    returnType!: Type;
    returnTypeCustomAttributes!: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : <any>undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMethodInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class MilestoneItemDto implements IMilestoneItemDto {
    milestoneId!: string | undefined;
    status!: string | undefined;
    eligibleDate!: DateTime | undefined;
    evidenceCount!: number;
    linkedRequest!: string | undefined;
    message!: string | undefined;

    constructor(data?: IMilestoneItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.milestoneId = _data["milestoneId"];
            this.status = _data["status"];
            this.eligibleDate = _data["eligibleDate"] ? DateTime.fromISO(_data["eligibleDate"].toString()) : <any>undefined;
            this.evidenceCount = _data["evidenceCount"];
            this.linkedRequest = _data["linkedRequest"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MilestoneItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["milestoneId"] = this.milestoneId;
        data["status"] = this.status;
        data["eligibleDate"] = this.eligibleDate ? this.eligibleDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["evidenceCount"] = this.evidenceCount;
        data["linkedRequest"] = this.linkedRequest;
        data["message"] = this.message;
        return data;
    }
}

export interface IMilestoneItemDto {
    milestoneId: string | undefined;
    status: string | undefined;
    eligibleDate: DateTime | undefined;
    evidenceCount: number;
    linkedRequest: string | undefined;
    message: string | undefined;
}

export class MilestoneTimelineDto implements IMilestoneTimelineDto {
    phase1!: MilestoneItemDto[] | undefined;
    phase2!: MilestoneItemDto[] | undefined;
    programType!: string | undefined;
    sgaYear!: number;

    constructor(data?: IMilestoneTimelineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phase1"])) {
                this.phase1 = [] as any;
                for (let item of _data["phase1"])
                    this.phase1!.push(MilestoneItemDto.fromJS(item));
            }
            if (Array.isArray(_data["phase2"])) {
                this.phase2 = [] as any;
                for (let item of _data["phase2"])
                    this.phase2!.push(MilestoneItemDto.fromJS(item));
            }
            this.programType = _data["programType"];
            this.sgaYear = _data["sgaYear"];
        }
    }

    static fromJS(data: any): MilestoneTimelineDto {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneTimelineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phase1)) {
            data["phase1"] = [];
            for (let item of this.phase1)
                data["phase1"].push(item.toJSON());
        }
        if (Array.isArray(this.phase2)) {
            data["phase2"] = [];
            for (let item of this.phase2)
                data["phase2"].push(item.toJSON());
        }
        data["programType"] = this.programType;
        data["sgaYear"] = this.sgaYear;
        return data;
    }
}

export interface IMilestoneTimelineDto {
    phase1: MilestoneItemDto[] | undefined;
    phase2: MilestoneItemDto[] | undefined;
    programType: string | undefined;
    sgaYear: number;
}

export class ModelUsageDto implements IModelUsageDto {
    model!: string | undefined;
    totalTokens!: number;
    totalDurationMs!: number;
    totalCost!: number;

    constructor(data?: IModelUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.totalTokens = _data["totalTokens"];
            this.totalDurationMs = _data["totalDurationMs"];
            this.totalCost = _data["totalCost"];
        }
    }

    static fromJS(data: any): ModelUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["totalTokens"] = this.totalTokens;
        data["totalDurationMs"] = this.totalDurationMs;
        data["totalCost"] = this.totalCost;
        return data;
    }
}

export interface IModelUsageDto {
    model: string | undefined;
    totalTokens: number;
    totalDurationMs: number;
    totalCost: number;
}

export class Module implements IModule {
    assembly!: Assembly;
    readonly fullyQualifiedName!: string | undefined;
    readonly name!: string | undefined;
    readonly mdStreamVersion!: number;
    readonly moduleVersionId!: string;
    readonly scopeName!: string | undefined;
    moduleHandle!: ModuleHandle;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class MonthPagedResultDtoOfTHContactHistoryDto implements IMonthPagedResultDtoOfTHContactHistoryDto {
    year!: number;
    month!: number;
    monthName!: string | undefined;
    items!: THContactHistoryDto[] | undefined;
    nextCursor!: DateTime | undefined;
    hasMore!: boolean;
    totalCount!: number;

    constructor(data?: IMonthPagedResultDtoOfTHContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THContactHistoryDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"] ? DateTime.fromISO(_data["nextCursor"].toString()) : <any>undefined;
            this.hasMore = _data["hasMore"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MonthPagedResultDtoOfTHContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthPagedResultDtoOfTHContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["nextCursor"] = this.nextCursor ? this.nextCursor.toString() : <any>undefined;
        data["hasMore"] = this.hasMore;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IMonthPagedResultDtoOfTHContactHistoryDto {
    year: number;
    month: number;
    monthName: string | undefined;
    items: THContactHistoryDto[] | undefined;
    nextCursor: DateTime | undefined;
    hasMore: boolean;
    totalCount: number;
}

export class MonthPagedResultDtoOfTicketHolderActivityDto implements IMonthPagedResultDtoOfTicketHolderActivityDto {
    year!: number;
    month!: number;
    monthName!: string | undefined;
    items!: TicketHolderActivityDto[] | undefined;
    nextCursor!: DateTime | undefined;
    hasMore!: boolean;
    totalCount!: number;
    hasTwowayCommunication!: boolean;
    lastTwowayCommunicationDate!: DateTime | undefined;

    constructor(data?: IMonthPagedResultDtoOfTicketHolderActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderActivityDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"] ? DateTime.fromISO(_data["nextCursor"].toString()) : <any>undefined;
            this.hasMore = _data["hasMore"];
            this.totalCount = _data["totalCount"];
            this.hasTwowayCommunication = _data["hasTwowayCommunication"];
            this.lastTwowayCommunicationDate = _data["lastTwowayCommunicationDate"] ? DateTime.fromISO(_data["lastTwowayCommunicationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthPagedResultDtoOfTicketHolderActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthPagedResultDtoOfTicketHolderActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["nextCursor"] = this.nextCursor ? this.nextCursor.toString() : <any>undefined;
        data["hasMore"] = this.hasMore;
        data["totalCount"] = this.totalCount;
        data["hasTwowayCommunication"] = this.hasTwowayCommunication;
        data["lastTwowayCommunicationDate"] = this.lastTwowayCommunicationDate ? this.lastTwowayCommunicationDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMonthPagedResultDtoOfTicketHolderActivityDto {
    year: number;
    month: number;
    monthName: string | undefined;
    items: TicketHolderActivityDto[] | undefined;
    nextCursor: DateTime | undefined;
    hasMore: boolean;
    totalCount: number;
    hasTwowayCommunication: boolean;
    lastTwowayCommunicationDate: DateTime | undefined;
}

export class MoveOptOutLeadInput implements IMoveOptOutLeadInput {
    leadId!: number;
    newLeadStage!: LeadStage;
    reason!: string;

    constructor(data?: IMoveOptOutLeadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.newLeadStage = _data["newLeadStage"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MoveOptOutLeadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOptOutLeadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["newLeadStage"] = this.newLeadStage;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMoveOptOutLeadInput {
    leadId: number;
    newLeadStage: LeadStage;
    reason: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class MyCalendarDto implements IMyCalendarDto {
    id!: number;
    eventType!: CalendarEventType;
    userId!: number;
    clientId!: string | undefined;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime | undefined;
    timeZone!: string | undefined;
    isAllDay!: boolean;
    location!: string | undefined;
    status!: CalendarEventStatus;
    syncProvider!: UserApiTokenProvider;
    externalEventId!: string | undefined;
    colorHex!: string | undefined;
    lastSyncedTime!: DateTime | undefined;
    changeKey!: string | undefined;
    isOrganizer!: boolean;
    isCancelled!: boolean;
    onlineMeetingUrl!: string | undefined;
    calendarAttendees!: CalendarAttendee[] | undefined;
    createdBy!: string | undefined;
    updatedBy!: string | undefined;
    followupType!: FollowupType;
    creationTime!: DateTime;

    constructor(data?: IMyCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventType = _data["eventType"];
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.isAllDay = _data["isAllDay"];
            this.location = _data["location"];
            this.status = _data["status"];
            this.syncProvider = _data["syncProvider"];
            this.externalEventId = _data["externalEventId"];
            this.colorHex = _data["colorHex"];
            this.lastSyncedTime = _data["lastSyncedTime"] ? DateTime.fromISO(_data["lastSyncedTime"].toString()) : <any>undefined;
            this.changeKey = _data["changeKey"];
            this.isOrganizer = _data["isOrganizer"];
            this.isCancelled = _data["isCancelled"];
            this.onlineMeetingUrl = _data["onlineMeetingUrl"];
            if (Array.isArray(_data["calendarAttendees"])) {
                this.calendarAttendees = [] as any;
                for (let item of _data["calendarAttendees"])
                    this.calendarAttendees!.push(CalendarAttendee.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.followupType = _data["followupType"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MyCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventType"] = this.eventType;
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["isAllDay"] = this.isAllDay;
        data["location"] = this.location;
        data["status"] = this.status;
        data["syncProvider"] = this.syncProvider;
        data["externalEventId"] = this.externalEventId;
        data["colorHex"] = this.colorHex;
        data["lastSyncedTime"] = this.lastSyncedTime ? this.lastSyncedTime.toString() : <any>undefined;
        data["changeKey"] = this.changeKey;
        data["isOrganizer"] = this.isOrganizer;
        data["isCancelled"] = this.isCancelled;
        data["onlineMeetingUrl"] = this.onlineMeetingUrl;
        if (Array.isArray(this.calendarAttendees)) {
            data["calendarAttendees"] = [];
            for (let item of this.calendarAttendees)
                data["calendarAttendees"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["followupType"] = this.followupType;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMyCalendarDto {
    id: number;
    eventType: CalendarEventType;
    userId: number;
    clientId: string | undefined;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    title: string | undefined;
    description: string | undefined;
    startTime: DateTime;
    endTime: DateTime | undefined;
    timeZone: string | undefined;
    isAllDay: boolean;
    location: string | undefined;
    status: CalendarEventStatus;
    syncProvider: UserApiTokenProvider;
    externalEventId: string | undefined;
    colorHex: string | undefined;
    lastSyncedTime: DateTime | undefined;
    changeKey: string | undefined;
    isOrganizer: boolean;
    isCancelled: boolean;
    onlineMeetingUrl: string | undefined;
    calendarAttendees: CalendarAttendee[] | undefined;
    createdBy: string | undefined;
    updatedBy: string | undefined;
    followupType: FollowupType;
    creationTime: DateTime;
}

export enum MySSAAccountStatus {
    No = 0,
    Yes = 1,
    Recommended = 2,
}

export class MyTasksDto implements IMyTasksDto {
    id!: number;
    assignedToUserId!: number | undefined;
    createDateTime!: DateTime;
    createdBy!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    dueDateTime!: DateTime;
    status!: CalendarEventStatus;

    constructor(data?: IMyTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.createDateTime = _data["createDateTime"] ? DateTime.fromISO(_data["createDateTime"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dueDateTime = _data["dueDateTime"] ? DateTime.fromISO(_data["dueDateTime"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MyTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["createDateTime"] = this.createDateTime ? this.createDateTime.toString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dueDateTime"] = this.dueDateTime ? this.dueDateTime.toString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IMyTasksDto {
    id: number;
    assignedToUserId: number | undefined;
    createDateTime: DateTime;
    createdBy: string | undefined;
    title: string | undefined;
    description: string | undefined;
    dueDateTime: DateTime;
    status: CalendarEventStatus;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDtoOfInt32 implements INameValueDtoOfInt32 {
    name!: string | undefined;
    value!: number;

    constructor(data?: INameValueDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDtoOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDtoOfInt32 {
    name: string | undefined;
    value: number;
}

export class NameValueDtoOfInt64 implements INameValueDtoOfInt64 {
    name!: string | undefined;
    value!: number;

    constructor(data?: INameValueDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDtoOfInt64 {
    name: string | undefined;
    value: number;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class NearbyLocationCandidateDto implements INearbyLocationCandidateDto {
    address!: string | undefined;
    sameStreet!: boolean;
    distanceMiles!: number;
    latitude!: number;
    longitude!: number;

    constructor(data?: INearbyLocationCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.sameStreet = _data["sameStreet"];
            this.distanceMiles = _data["distanceMiles"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): NearbyLocationCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NearbyLocationCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["sameStreet"] = this.sameStreet;
        data["distanceMiles"] = this.distanceMiles;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface INearbyLocationCandidateDto {
    address: string | undefined;
    sameStreet: boolean;
    distanceMiles: number;
    latitude: number;
    longitude: number;
}

export class NearbyLocationSuggestionDto implements INearbyLocationSuggestionDto {
    originLatitude!: number;
    originLongitude!: number;
    originAddress!: string | undefined;
    candidates!: NearbyLocationCandidateDto[] | undefined;

    constructor(data?: INearbyLocationSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originLatitude = _data["originLatitude"];
            this.originLongitude = _data["originLongitude"];
            this.originAddress = _data["originAddress"];
            if (Array.isArray(_data["candidates"])) {
                this.candidates = [] as any;
                for (let item of _data["candidates"])
                    this.candidates!.push(NearbyLocationCandidateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NearbyLocationSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NearbyLocationSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originLatitude"] = this.originLatitude;
        data["originLongitude"] = this.originLongitude;
        data["originAddress"] = this.originAddress;
        if (Array.isArray(this.candidates)) {
            data["candidates"] = [];
            for (let item of this.candidates)
                data["candidates"].push(item.toJSON());
        }
        return data;
    }
}

export interface INearbyLocationSuggestionDto {
    originLatitude: number;
    originLongitude: number;
    originAddress: string | undefined;
    candidates: NearbyLocationCandidateDto[] | undefined;
}

export enum NetworkType {
    Unknown = 0,
    AdministrativeEmploymentNetwork = 1,
    EmploymentNetwork = 2,
}

export class NewAddressDto implements INewAddressDto {
    street!: string;
    city!: string;
    stateAbbreviation!: string;
    zipCode!: string;
    timeZone!: USATimeZone;
    addressType!: AddressType;
    isVerifiedByUSPS!: boolean;

    constructor(data?: INewAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.timeZone = _data["timeZone"];
            this.addressType = _data["addressType"];
            this.isVerifiedByUSPS = _data["isVerifiedByUSPS"];
        }
    }

    static fromJS(data: any): NewAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["timeZone"] = this.timeZone;
        data["addressType"] = this.addressType;
        data["isVerifiedByUSPS"] = this.isVerifiedByUSPS;
        return data;
    }
}

export interface INewAddressDto {
    street: string;
    city: string;
    stateAbbreviation: string;
    zipCode: string;
    timeZone: USATimeZone;
    addressType: AddressType;
    isVerifiedByUSPS: boolean;
}

export class NewLeadByReferralIdDto implements INewLeadByReferralIdDto {
    firstName!: string;
    lastName!: string | undefined;
    middleName!: string | undefined;
    doB!: DateTime | undefined;
    email!: string | undefined;
    rawSSN!: string | undefined;
    benefitType!: BenefitType;
    isFelony!: boolean;
    leadType!: LeadType;
    status!: ContactResult;
    requestedServices!: SupportServices;
    phoneNumbers!: NewPhoneDto[] | undefined;
    addresses!: NewAddressDto[] | undefined;
    spokenLanguages!: SpokenLanguageDto[] | undefined;
    ttwReferralId!: number;
    assigneeId!: number | undefined;

    constructor(data?: INewLeadByReferralIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.rawSSN = _data["rawSSN"];
            this.benefitType = _data["benefitType"];
            this.isFelony = _data["isFelony"];
            this.leadType = _data["leadType"];
            this.status = _data["status"];
            this.requestedServices = _data["requestedServices"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(NewPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(NewAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
            this.ttwReferralId = _data["ttwReferralId"];
            this.assigneeId = _data["assigneeId"];
        }
    }

    static fromJS(data: any): NewLeadByReferralIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewLeadByReferralIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["email"] = this.email;
        data["rawSSN"] = this.rawSSN;
        data["benefitType"] = this.benefitType;
        data["isFelony"] = this.isFelony;
        data["leadType"] = this.leadType;
        data["status"] = this.status;
        data["requestedServices"] = this.requestedServices;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        data["ttwReferralId"] = this.ttwReferralId;
        data["assigneeId"] = this.assigneeId;
        return data;
    }
}

export interface INewLeadByReferralIdDto {
    firstName: string;
    lastName: string | undefined;
    middleName: string | undefined;
    doB: DateTime | undefined;
    email: string | undefined;
    rawSSN: string | undefined;
    benefitType: BenefitType;
    isFelony: boolean;
    leadType: LeadType;
    status: ContactResult;
    requestedServices: SupportServices;
    phoneNumbers: NewPhoneDto[] | undefined;
    addresses: NewAddressDto[] | undefined;
    spokenLanguages: SpokenLanguageDto[] | undefined;
    ttwReferralId: number;
    assigneeId: number | undefined;
}

export class NewLeadDto implements INewLeadDto {
    firstName!: string;
    lastName!: string | undefined;
    middleName!: string | undefined;
    doB!: DateTime | undefined;
    email!: string | undefined;
    rawSSN!: string | undefined;
    benefitType!: BenefitType;
    isFelony!: boolean;
    leadType!: LeadType;
    status!: ContactResult;
    requestedServices!: SupportServices;
    phoneNumbers!: NewPhoneDto[] | undefined;
    addresses!: NewAddressDto[] | undefined;
    spokenLanguages!: SpokenLanguageDto[] | undefined;

    constructor(data?: INewLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.rawSSN = _data["rawSSN"];
            this.benefitType = _data["benefitType"];
            this.isFelony = _data["isFelony"];
            this.leadType = _data["leadType"];
            this.status = _data["status"];
            this.requestedServices = _data["requestedServices"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(NewPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(NewAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["email"] = this.email;
        data["rawSSN"] = this.rawSSN;
        data["benefitType"] = this.benefitType;
        data["isFelony"] = this.isFelony;
        data["leadType"] = this.leadType;
        data["status"] = this.status;
        data["requestedServices"] = this.requestedServices;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewLeadDto {
    firstName: string;
    lastName: string | undefined;
    middleName: string | undefined;
    doB: DateTime | undefined;
    email: string | undefined;
    rawSSN: string | undefined;
    benefitType: BenefitType;
    isFelony: boolean;
    leadType: LeadType;
    status: ContactResult;
    requestedServices: SupportServices;
    phoneNumbers: NewPhoneDto[] | undefined;
    addresses: NewAddressDto[] | undefined;
    spokenLanguages: SpokenLanguageDto[] | undefined;
}

export class NewPhoneDto implements INewPhoneDto {
    leadId!: number;
    number!: string;
    phoneType!: PhoneType;
    isVerified!: boolean;

    constructor(data?: INewPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.number = _data["number"];
            this.phoneType = _data["phoneType"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): NewPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["number"] = this.number;
        data["phoneType"] = this.phoneType;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface INewPhoneDto {
    leadId: number;
    number: string;
    phoneType: PhoneType;
    isVerified: boolean;
}

export class NoteEntry implements INoteEntry {
    source!: string | undefined;
    note!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;

    constructor(data?: INoteEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
        }
    }

    static fromJS(data: any): NoteEntry {
        data = typeof data === 'object' ? data : {};
        let result = new NoteEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        return data;
    }
}

export interface INoteEntry {
    source: string | undefined;
    note: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export class NotificationDeliveryMode implements INotificationDeliveryMode {
    transportType!: string | undefined;
    address!: string | undefined;
    encryption!: boolean | undefined;
    certificateName!: string | undefined;
    registrationId!: string | undefined;
    subscriberKey!: string | undefined;
    secretKey!: string | undefined;
    encryptionAlgorithm!: string | undefined;
    encryptionKey!: string | undefined;
    configName!: string | undefined;

    constructor(data?: INotificationDeliveryMode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transportType = _data["transportType"];
            this.address = _data["address"];
            this.encryption = _data["encryption"];
            this.certificateName = _data["certificateName"];
            this.registrationId = _data["registrationId"];
            this.subscriberKey = _data["subscriberKey"];
            this.secretKey = _data["secretKey"];
            this.encryptionAlgorithm = _data["encryptionAlgorithm"];
            this.encryptionKey = _data["encryptionKey"];
            this.configName = _data["configName"];
        }
    }

    static fromJS(data: any): NotificationDeliveryMode {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDeliveryMode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportType"] = this.transportType;
        data["address"] = this.address;
        data["encryption"] = this.encryption;
        data["certificateName"] = this.certificateName;
        data["registrationId"] = this.registrationId;
        data["subscriberKey"] = this.subscriberKey;
        data["secretKey"] = this.secretKey;
        data["encryptionAlgorithm"] = this.encryptionAlgorithm;
        data["encryptionKey"] = this.encryptionKey;
        data["configName"] = this.configName;
        return data;
    }
}

export interface INotificationDeliveryMode {
    transportType: string | undefined;
    address: string | undefined;
    encryption: boolean | undefined;
    certificateName: string | undefined;
    registrationId: string | undefined;
    subscriberKey: string | undefined;
    secretKey: string | undefined;
    encryptionAlgorithm: string | undefined;
    encryptionKey: string | undefined;
    configName: string | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    name!: string;
    isSubscribed!: boolean;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    name: string;
    isSubscribed: boolean;
    displayName: string | undefined;
    description: string | undefined;
}

export class NotifyInboundMessageInput implements INotifyInboundMessageInput {
    tenantId!: number;
    coachUserId!: number;
    channel!: string;
    clientName!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: INotifyInboundMessageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.coachUserId = _data["coachUserId"];
            this.channel = _data["channel"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): NotifyInboundMessageInput {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyInboundMessageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["coachUserId"] = this.coachUserId;
        data["channel"] = this.channel;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface INotifyInboundMessageInput {
    tenantId: number;
    coachUserId: number;
    channel: string;
    clientName: string | undefined;
    clientId: string | undefined;
}

export class OAuthState implements IOAuthState {
    userid!: number;
    tenantid!: number;
    tokenprovider!: UserApiTokenProvider;
    serviceprovidername!: string | undefined;
    createdtime!: DateTime;

    constructor(data?: IOAuthState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userid = _data["userid"];
            this.tenantid = _data["tenantid"];
            this.tokenprovider = _data["tokenprovider"];
            this.serviceprovidername = _data["serviceprovidername"];
            this.createdtime = _data["createdtime"] ? DateTime.fromISO(_data["createdtime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OAuthState {
        data = typeof data === 'object' ? data : {};
        let result = new OAuthState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userid"] = this.userid;
        data["tenantid"] = this.tenantid;
        data["tokenprovider"] = this.tokenprovider;
        data["serviceprovidername"] = this.serviceprovidername;
        data["createdtime"] = this.createdtime ? this.createdtime.toString() : <any>undefined;
        return data;
    }
}

export interface IOAuthState {
    userid: number;
    tenantid: number;
    tokenprovider: UserApiTokenProvider;
    serviceprovidername: string | undefined;
    createdtime: DateTime;
}

export class OfficeOpenHours implements IOfficeOpenHours {
    day!: DayOfWeek;
    openTime!: string | undefined;
    closeTime!: string | undefined;
    isClosed!: boolean;

    constructor(data?: IOfficeOpenHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.openTime = _data["openTime"];
            this.closeTime = _data["closeTime"];
            this.isClosed = _data["isClosed"];
        }
    }

    static fromJS(data: any): OfficeOpenHours {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeOpenHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["openTime"] = this.openTime;
        data["closeTime"] = this.closeTime;
        data["isClosed"] = this.isClosed;
        return data;
    }
}

export interface IOfficeOpenHours {
    day: DayOfWeek;
    openTime: string | undefined;
    closeTime: string | undefined;
    isClosed: boolean;
}

export class OnDemandTaskInfoDto implements IOnDemandTaskInfoDto {
    taskId!: number;
    taskName!: string | undefined;
    description!: string | undefined;
    isActive!: boolean;
    requiresParameters!: boolean;
    allowConcurrentExecution!: boolean;
    parameterSchema!: { [key: string]: string; } | undefined;
    isRunning!: boolean;

    constructor(data?: IOnDemandTaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.requiresParameters = _data["requiresParameters"];
            this.allowConcurrentExecution = _data["allowConcurrentExecution"];
            if (_data["parameterSchema"]) {
                this.parameterSchema = {} as any;
                for (let key in _data["parameterSchema"]) {
                    if (_data["parameterSchema"].hasOwnProperty(key))
                        (<any>this.parameterSchema)![key] = _data["parameterSchema"][key];
                }
            }
            this.isRunning = _data["isRunning"];
        }
    }

    static fromJS(data: any): OnDemandTaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandTaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["requiresParameters"] = this.requiresParameters;
        data["allowConcurrentExecution"] = this.allowConcurrentExecution;
        if (this.parameterSchema) {
            data["parameterSchema"] = {};
            for (let key in this.parameterSchema) {
                if (this.parameterSchema.hasOwnProperty(key))
                    (<any>data["parameterSchema"])[key] = (<any>this.parameterSchema)[key];
            }
        }
        data["isRunning"] = this.isRunning;
        return data;
    }
}

export interface IOnDemandTaskInfoDto {
    taskId: number;
    taskName: string | undefined;
    description: string | undefined;
    isActive: boolean;
    requiresParameters: boolean;
    allowConcurrentExecution: boolean;
    parameterSchema: { [key: string]: string; } | undefined;
    isRunning: boolean;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;
    responseType!: string | undefined;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
            this.responseType = _data["responseType"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        data["responseType"] = this.responseType;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
    responseType: string | undefined;
}

export class OptOutHistoryEntryDto implements IOptOutHistoryEntryDto {
    changeDate!: DateTime;
    status!: OptStatus;
    contactPoints!: string[] | undefined;
    changedBy!: string | undefined;
    note!: string | undefined;

    constructor(data?: IOptOutHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeDate = _data["changeDate"] ? DateTime.fromISO(_data["changeDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(item);
            }
            this.changedBy = _data["changedBy"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): OptOutHistoryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptOutHistoryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeDate"] = this.changeDate ? this.changeDate.toString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item);
        }
        data["changedBy"] = this.changedBy;
        data["note"] = this.note;
        return data;
    }
}

export interface IOptOutHistoryEntryDto {
    changeDate: DateTime;
    status: OptStatus;
    contactPoints: string[] | undefined;
    changedBy: string | undefined;
    note: string | undefined;
}

export class OptOutLeadDto implements IOptOutLeadDto {
    leadId!: number;
    clientId!: string | undefined;
    clientName!: string | undefined;
    phoneNumber!: string | undefined;
    email!: string | undefined;
    benefitType!: BenefitType;
    assigneeId!: number | undefined;
    assigneeName!: string | undefined;
    optedOutTime!: DateTime;
    optedOutVia!: string | undefined;
    canMoveToLeadQueue!: boolean;
    optInRequestedTime!: DateTime | undefined;

    constructor(data?: IOptOutLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.benefitType = _data["benefitType"];
            this.assigneeId = _data["assigneeId"];
            this.assigneeName = _data["assigneeName"];
            this.optedOutTime = _data["optedOutTime"] ? DateTime.fromISO(_data["optedOutTime"].toString()) : <any>undefined;
            this.optedOutVia = _data["optedOutVia"];
            this.canMoveToLeadQueue = _data["canMoveToLeadQueue"];
            this.optInRequestedTime = _data["optInRequestedTime"] ? DateTime.fromISO(_data["optInRequestedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OptOutLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptOutLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["benefitType"] = this.benefitType;
        data["assigneeId"] = this.assigneeId;
        data["assigneeName"] = this.assigneeName;
        data["optedOutTime"] = this.optedOutTime ? this.optedOutTime.toString() : <any>undefined;
        data["optedOutVia"] = this.optedOutVia;
        data["canMoveToLeadQueue"] = this.canMoveToLeadQueue;
        data["optInRequestedTime"] = this.optInRequestedTime ? this.optInRequestedTime.toString() : <any>undefined;
        return data;
    }
}

export interface IOptOutLeadDto {
    leadId: number;
    clientId: string | undefined;
    clientName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    benefitType: BenefitType;
    assigneeId: number | undefined;
    assigneeName: string | undefined;
    optedOutTime: DateTime;
    optedOutVia: string | undefined;
    canMoveToLeadQueue: boolean;
    optInRequestedTime: DateTime | undefined;
}

export enum OptStatus {
    OptOut = 0,
    OptIn = 1,
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        return data;
    }
}

export interface IOrganizationUnitDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    id!: number;
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    id: number;
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: DateTime;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: DateTime;
}

export class OsmImportHistoryDto implements IOsmImportHistoryDto {
    id!: number;
    importBatchId!: string | undefined;
    fileName!: string | undefined;
    fileSize!: string | undefined;
    status!: JobProcessingStatus;
    processedDate!: DateTime | undefined;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    creatorName!: string | undefined;
    actualStartTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    backgroundJobInstanceId!: number | undefined;
    totalProcessed!: number | undefined;
    totalFailed!: number | undefined;
    totalSucceeded!: number | undefined;

    constructor(data?: IOsmImportHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.importBatchId = _data["importBatchId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.status = _data["status"];
            this.processedDate = _data["processedDate"] ? DateTime.fromISO(_data["processedDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.actualStartTime = _data["actualStartTime"] ? DateTime.fromISO(_data["actualStartTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.backgroundJobInstanceId = _data["backgroundJobInstanceId"];
            this.totalProcessed = _data["totalProcessed"];
            this.totalFailed = _data["totalFailed"];
            this.totalSucceeded = _data["totalSucceeded"];
        }
    }

    static fromJS(data: any): OsmImportHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OsmImportHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["importBatchId"] = this.importBatchId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["status"] = this.status;
        data["processedDate"] = this.processedDate ? this.processedDate.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["backgroundJobInstanceId"] = this.backgroundJobInstanceId;
        data["totalProcessed"] = this.totalProcessed;
        data["totalFailed"] = this.totalFailed;
        data["totalSucceeded"] = this.totalSucceeded;
        return data;
    }
}

export interface IOsmImportHistoryDto {
    id: number;
    importBatchId: string | undefined;
    fileName: string | undefined;
    fileSize: string | undefined;
    status: JobProcessingStatus;
    processedDate: DateTime | undefined;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    actualStartTime: DateTime | undefined;
    endTime: DateTime | undefined;
    backgroundJobInstanceId: number | undefined;
    totalProcessed: number | undefined;
    totalFailed: number | undefined;
    totalSucceeded: number | undefined;
}

export class OsmUploadQueueItemDto implements IOsmUploadQueueItemDto {
    fileQueueId!: number;
    fileName!: string | undefined;
    fileSize!: string | undefined;
    importBatchId!: string | undefined;

    constructor(data?: IOsmUploadQueueItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileQueueId = _data["fileQueueId"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.importBatchId = _data["importBatchId"];
        }
    }

    static fromJS(data: any): OsmUploadQueueItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OsmUploadQueueItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileQueueId"] = this.fileQueueId;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["importBatchId"] = this.importBatchId;
        return data;
    }
}

export interface IOsmUploadQueueItemDto {
    fileQueueId: number;
    fileName: string | undefined;
    fileSize: string | undefined;
    importBatchId: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class OutgoingFaxDto implements IOutgoingFaxDto {
    recipientType!: FaxRecipientType;
    clientId!: number | undefined;
    senderName!: string | undefined;
    senderAddress!: string | undefined;
    recipientName!: string | undefined;
    faxNumber!: string;
    subject!: string | undefined;
    messageBody!: string | undefined;
    files!: string[] | undefined;

    constructor(data?: IOutgoingFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientType = _data["recipientType"];
            this.clientId = _data["clientId"];
            this.senderName = _data["senderName"];
            this.senderAddress = _data["senderAddress"];
            this.recipientName = _data["recipientName"];
            this.faxNumber = _data["faxNumber"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
        }
    }

    static fromJS(data: any): OutgoingFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientType"] = this.recipientType;
        data["clientId"] = this.clientId;
        data["senderName"] = this.senderName;
        data["senderAddress"] = this.senderAddress;
        data["recipientName"] = this.recipientName;
        data["faxNumber"] = this.faxNumber;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        return data;
    }
}

export interface IOutgoingFaxDto {
    recipientType: FaxRecipientType;
    clientId: number | undefined;
    senderName: string | undefined;
    senderAddress: string | undefined;
    recipientName: string | undefined;
    faxNumber: string;
    subject: string | undefined;
    messageBody: string | undefined;
    files: string[] | undefined;
}

export class OutgoingFaxLogDto implements IOutgoingFaxLogDto {
    direction!: ActivityDirection;
    readonly enumDisplayDirection!: string | undefined;
    careerCoachName!: string | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientFaxNumber!: string | undefined;
    clientId!: string | undefined;
    subject!: string | undefined;
    status!: ActivityStatus;
    readonly enumDisplayStatus!: string | undefined;
    errorMessage!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IOutgoingFaxLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            (<any>this).enumDisplayDirection = _data["enumDisplayDirection"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientFaxNumber = _data["clientFaxNumber"];
            this.clientId = _data["clientId"];
            this.subject = _data["subject"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.errorMessage = _data["errorMessage"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OutgoingFaxLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingFaxLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["enumDisplayDirection"] = this.enumDisplayDirection;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientFaxNumber"] = this.clientFaxNumber;
        data["clientId"] = this.clientId;
        data["subject"] = this.subject;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["errorMessage"] = this.errorMessage;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IOutgoingFaxLogDto {
    direction: ActivityDirection;
    enumDisplayDirection: string | undefined;
    careerCoachName: string | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientFaxNumber: string | undefined;
    clientId: string | undefined;
    subject: string | undefined;
    status: ActivityStatus;
    enumDisplayStatus: string | undefined;
    errorMessage: string | undefined;
    creationTime: DateTime;
}

export class OutgoingMailDto implements IOutgoingMailDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientAddress!: string;
    clientId!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachmentsIds!: number[] | undefined;
    carrierName!: string | undefined;
    carrierTrackingNumber!: string | undefined;
    status!: ActivityStatus;
    readonly statusDisplayName!: string | undefined;
    errorMessage!: string | undefined;
    mailId!: string | undefined;
    creationTime!: DateTime;
    needReturnEnvelope!: boolean | undefined;

    constructor(data?: IOutgoingMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.clientId = _data["clientId"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachmentsIds"])) {
                this.attachmentsIds = [] as any;
                for (let item of _data["attachmentsIds"])
                    this.attachmentsIds!.push(item);
            }
            this.carrierName = _data["carrierName"];
            this.carrierTrackingNumber = _data["carrierTrackingNumber"];
            this.status = _data["status"];
            (<any>this).statusDisplayName = _data["statusDisplayName"];
            this.errorMessage = _data["errorMessage"];
            this.mailId = _data["mailId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.needReturnEnvelope = _data["needReturnEnvelope"];
        }
    }

    static fromJS(data: any): OutgoingMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["clientId"] = this.clientId;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachmentsIds)) {
            data["attachmentsIds"] = [];
            for (let item of this.attachmentsIds)
                data["attachmentsIds"].push(item);
        }
        data["carrierName"] = this.carrierName;
        data["carrierTrackingNumber"] = this.carrierTrackingNumber;
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        data["errorMessage"] = this.errorMessage;
        data["mailId"] = this.mailId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["needReturnEnvelope"] = this.needReturnEnvelope;
        return data;
    }
}

export interface IOutgoingMailDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientAddress: string;
    clientId: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachmentsIds: number[] | undefined;
    carrierName: string | undefined;
    carrierTrackingNumber: string | undefined;
    status: ActivityStatus;
    statusDisplayName: string | undefined;
    errorMessage: string | undefined;
    mailId: string | undefined;
    creationTime: DateTime;
    needReturnEnvelope: boolean | undefined;
}

export class OutgoingMailStatusCountDto implements IOutgoingMailStatusCountDto {
    total!: number;
    draft!: number;
    pending!: number;
    rejected!: number;
    approved!: number;
    sent!: number;
    canceled!: number;

    constructor(data?: IOutgoingMailStatusCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.draft = _data["draft"];
            this.pending = _data["pending"];
            this.rejected = _data["rejected"];
            this.approved = _data["approved"];
            this.sent = _data["sent"];
            this.canceled = _data["canceled"];
        }
    }

    static fromJS(data: any): OutgoingMailStatusCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingMailStatusCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["draft"] = this.draft;
        data["pending"] = this.pending;
        data["rejected"] = this.rejected;
        data["approved"] = this.approved;
        data["sent"] = this.sent;
        data["canceled"] = this.canceled;
        return data;
    }
}

export interface IOutgoingMailStatusCountDto {
    total: number;
    draft: number;
    pending: number;
    rejected: number;
    approved: number;
    sent: number;
    canceled: number;
}

export class OutgoingRequestFaxDto implements IOutgoingRequestFaxDto {
    recipientType!: FaxRecipientType;
    clientId!: number | undefined;
    senderName!: string | undefined;
    senderAddress!: string | undefined;
    recipientName!: string | undefined;
    faxNumber!: string;
    subject!: string | undefined;
    messageBody!: string | undefined;
    files!: UploadFileOutputDto[] | undefined;
    serviceType!: ActivityServiceType;

    constructor(data?: IOutgoingRequestFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientType = _data["recipientType"];
            this.clientId = _data["clientId"];
            this.senderName = _data["senderName"];
            this.senderAddress = _data["senderAddress"];
            this.recipientName = _data["recipientName"];
            this.faxNumber = _data["faxNumber"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(UploadFileOutputDto.fromJS(item));
            }
            this.serviceType = _data["serviceType"];
        }
    }

    static fromJS(data: any): OutgoingRequestFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingRequestFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientType"] = this.recipientType;
        data["clientId"] = this.clientId;
        data["senderName"] = this.senderName;
        data["senderAddress"] = this.senderAddress;
        data["recipientName"] = this.recipientName;
        data["faxNumber"] = this.faxNumber;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["serviceType"] = this.serviceType;
        return data;
    }
}

export interface IOutgoingRequestFaxDto {
    recipientType: FaxRecipientType;
    clientId: number | undefined;
    senderName: string | undefined;
    senderAddress: string | undefined;
    recipientName: string | undefined;
    faxNumber: string;
    subject: string | undefined;
    messageBody: string | undefined;
    files: UploadFileOutputDto[] | undefined;
    serviceType: ActivityServiceType;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class PagedResultDtoOfActiveTicketHolderDto implements IPagedResultDtoOfActiveTicketHolderDto {
    items!: ActiveTicketHolderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfActiveTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActiveTicketHolderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfActiveTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActiveTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfActiveTicketHolderDto {
    items: ActiveTicketHolderDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfAdminSurveyDto implements IPagedResultDtoOfAdminSurveyDto {
    items!: AdminSurveyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAdminSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminSurveyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAdminSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAdminSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAdminSurveyDto {
    items: AdminSurveyDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfAdvancedSearchResultDto implements IPagedResultDtoOfAdvancedSearchResultDto {
    items!: AdvancedSearchResultDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAdvancedSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdvancedSearchResultDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAdvancedSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAdvancedSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAdvancedSearchResultDto {
    items: AdvancedSearchResultDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfAiVoiceAgentDto implements IPagedResultDtoOfAiVoiceAgentDto {
    items!: AiVoiceAgentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAiVoiceAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AiVoiceAgentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAiVoiceAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAiVoiceAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAiVoiceAgentDto {
    items: AiVoiceAgentDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfAssignedWageReportDto implements IPagedResultDtoOfAssignedWageReportDto {
    items!: AssignedWageReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAssignedWageReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssignedWageReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAssignedWageReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAssignedWageReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAssignedWageReportDto {
    items: AssignedWageReportDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    items!: AuditLogListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    items: AuditLogListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfBPQYListDto implements IPagedResultDtoOfBPQYListDto {
    items!: BPQYListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfBPQYListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BPQYListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfBPQYListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBPQYListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfBPQYListDto {
    items: BPQYListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfBackgroundTaskMgmtDto implements IPagedResultDtoOfBackgroundTaskMgmtDto {
    items!: BackgroundTaskMgmtDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfBackgroundTaskMgmtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BackgroundTaskMgmtDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfBackgroundTaskMgmtDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBackgroundTaskMgmtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfBackgroundTaskMgmtDto {
    items: BackgroundTaskMgmtDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfBatchInstanceDto implements IPagedResultDtoOfBatchInstanceDto {
    items!: BatchInstanceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfBatchInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BatchInstanceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfBatchInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBatchInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfBatchInstanceDto {
    items: BatchInstanceDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfBatchRunDto implements IPagedResultDtoOfBatchRunDto {
    items!: BatchRunDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfBatchRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BatchRunDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfBatchRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBatchRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfBatchRunDto {
    items: BatchRunDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfBatchRunLogDto implements IPagedResultDtoOfBatchRunLogDto {
    items!: BatchRunLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfBatchRunLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BatchRunLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfBatchRunLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBatchRunLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfBatchRunLogDto {
    items: BatchRunLogDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfBenefitsCounselingCaseListDto implements IPagedResultDtoOfBenefitsCounselingCaseListDto {
    items!: BenefitsCounselingCaseListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfBenefitsCounselingCaseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BenefitsCounselingCaseListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfBenefitsCounselingCaseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBenefitsCounselingCaseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfBenefitsCounselingCaseListDto {
    items: BenefitsCounselingCaseListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfCampaignDto implements IPagedResultDtoOfCampaignDto {
    items!: CampaignDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CampaignDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfCampaignDto {
    items: CampaignDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfCampaignHistoryDto implements IPagedResultDtoOfCampaignHistoryDto {
    items!: CampaignHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfCampaignHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CampaignHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfCampaignHistoryDto {
    items: CampaignHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfCampaignRecipientDto implements IPagedResultDtoOfCampaignRecipientDto {
    items!: CampaignRecipientDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfCampaignRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CampaignRecipientDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfCampaignRecipientDto {
    items: CampaignRecipientDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfCampaignResponseDto implements IPagedResultDtoOfCampaignResponseDto {
    items!: CampaignResponseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfCampaignResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CampaignResponseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfCampaignResponseDto {
    items: CampaignResponseDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfCareerCoachOverviewDto implements IPagedResultDtoOfCareerCoachOverviewDto {
    items!: CareerCoachOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfCareerCoachOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CareerCoachOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfCareerCoachOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCareerCoachOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfCareerCoachOverviewDto {
    items: CareerCoachOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfCoachJobInterviewDto implements IPagedResultDtoOfCoachJobInterviewDto {
    items!: CoachJobInterviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfCoachJobInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CoachJobInterviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfCoachJobInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCoachJobInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfCoachJobInterviewDto {
    items: CoachJobInterviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfContactHistoryDto implements IPagedResultDtoOfContactHistoryDto {
    items!: ContactHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContactHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfContactHistoryDto {
    items: ContactHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfContactUsListDto implements IPagedResultDtoOfContactUsListDto {
    items!: ContactUsListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfContactUsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContactUsListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactUsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactUsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfContactUsListDto {
    items: ContactUsListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfDisabilityDto implements IPagedResultDtoOfDisabilityDto {
    items!: DisabilityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DisabilityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfDisabilityDto {
    items: DisabilityDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfDocumentDto implements IPagedResultDtoOfDocumentDto {
    items!: DocumentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfDocumentDto {
    items: DocumentDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfDocumentTemplateLanguageDto implements IPagedResultDtoOfDocumentTemplateLanguageDto {
    items!: DocumentTemplateLanguageDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfDocumentTemplateLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DocumentTemplateLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfDocumentTemplateLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDocumentTemplateLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfDocumentTemplateLanguageDto {
    items: DocumentTemplateLanguageDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    items!: EntityChangeListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    items: EntityChangeListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfFindOrganizationUnitUsersOutputDto implements IPagedResultDtoOfFindOrganizationUnitUsersOutputDto {
    items!: FindOrganizationUnitUsersOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfFindOrganizationUnitUsersOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FindOrganizationUnitUsersOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfFindOrganizationUnitUsersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFindOrganizationUnitUsersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfFindOrganizationUnitUsersOutputDto {
    items: FindOrganizationUnitUsersOutputDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfFindUsersOutputDto implements IPagedResultDtoOfFindUsersOutputDto {
    items!: FindUsersOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfFindUsersOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FindUsersOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfFindUsersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFindUsersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfFindUsersOutputDto {
    items: FindUsersOutputDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetActiveTicketHolderDto implements IPagedResultDtoOfGetActiveTicketHolderDto {
    items!: GetActiveTicketHolderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetActiveTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetActiveTicketHolderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActiveTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActiveTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetActiveTicketHolderDto {
    items: GetActiveTicketHolderDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetAllSendAttemptsOutput implements IPagedResultDtoOfGetAllSendAttemptsOutput {
    items!: GetAllSendAttemptsOutput[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOutput.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetAllSendAttemptsOutput {
    items: GetAllSendAttemptsOutput[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetDocumentTemplateDetailsDto implements IPagedResultDtoOfGetDocumentTemplateDetailsDto {
    items!: GetDocumentTemplateDetailsDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetDocumentTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDocumentTemplateDetailsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDocumentTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDocumentTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetDocumentTemplateDetailsDto {
    items: GetDocumentTemplateDetailsDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetDocumentTemplateDto implements IPagedResultDtoOfGetDocumentTemplateDto {
    items!: GetDocumentTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDocumentTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetDocumentTemplateDto {
    items: GetDocumentTemplateDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetESignProcessingDto implements IPagedResultDtoOfGetESignProcessingDto {
    items!: GetESignProcessingDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetESignProcessingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetESignProcessingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetESignProcessingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetESignProcessingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetESignProcessingDto {
    items: GetESignProcessingDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetEligibilityCheckQueueDto implements IPagedResultDtoOfGetEligibilityCheckQueueDto {
    items!: GetEligibilityCheckQueueDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetEligibilityCheckQueueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEligibilityCheckQueueDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEligibilityCheckQueueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEligibilityCheckQueueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetEligibilityCheckQueueDto {
    items: GetEligibilityCheckQueueDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfGetMessageTemplate implements IPagedResultDtoOfGetMessageTemplate {
    items!: GetMessageTemplate[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfGetMessageTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMessageTemplate.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMessageTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMessageTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfGetMessageTemplate {
    items: GetMessageTemplate[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfIWPDdto implements IPagedResultDtoOfIWPDdto {
    items!: IWPDdto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfIWPDdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IWPDdto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfIWPDdto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIWPDdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfIWPDdto {
    items: IWPDdto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfIWPQDto implements IPagedResultDtoOfIWPQDto {
    items!: IWPQDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfIWPQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IWPQDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfIWPQDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIWPQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfIWPQDto {
    items: IWPQDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfIWPReviewQueueDto implements IPagedResultDtoOfIWPReviewQueueDto {
    items!: IWPReviewQueueDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfIWPReviewQueueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IWPReviewQueueDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfIWPReviewQueueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIWPReviewQueueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfIWPReviewQueueDto {
    items: IWPReviewQueueDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfInterestedLeadManagementDto implements IPagedResultDtoOfInterestedLeadManagementDto {
    items!: InterestedLeadManagementDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfInterestedLeadManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InterestedLeadManagementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfInterestedLeadManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInterestedLeadManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfInterestedLeadManagementDto {
    items: InterestedLeadManagementDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfJSAJobLeadDto implements IPagedResultDtoOfJSAJobLeadDto {
    items!: JSAJobLeadDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfJSAJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JSAJobLeadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfJSAJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJSAJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfJSAJobLeadDto {
    items: JSAJobLeadDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfJSAJobSearchRequestDto implements IPagedResultDtoOfJSAJobSearchRequestDto {
    items!: JSAJobSearchRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfJSAJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JSAJobSearchRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfJSAJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJSAJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfJSAJobSearchRequestDto {
    items: JSAJobSearchRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfJobSearchRequestDto implements IPagedResultDtoOfJobSearchRequestDto {
    items!: JobSearchRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobSearchRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfJobSearchRequestDto {
    items: JobSearchRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    items!: LanguageTextListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    items: LanguageTextListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadActivityOutputDto implements IPagedResultDtoOfLeadActivityOutputDto {
    items!: LeadActivityOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadActivityOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadActivityOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadActivityOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadActivityOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadActivityOutputDto {
    items: LeadActivityOutputDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadChatSMSDto implements IPagedResultDtoOfLeadChatSMSDto {
    items!: LeadChatSMSDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadChatSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadChatSMSDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadChatSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadChatSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadChatSMSDto {
    items: LeadChatSMSDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadContactHistoryDto implements IPagedResultDtoOfLeadContactHistoryDto {
    items!: LeadContactHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadContactHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadContactHistoryDto {
    items: LeadContactHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadDto implements IPagedResultDtoOfLeadDto {
    items!: LeadDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadDto {
    items: LeadDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadFollowupDto implements IPagedResultDtoOfLeadFollowupDto {
    items!: LeadFollowupDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadFollowupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadFollowupDto {
    items: LeadFollowupDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadImportHistoryDto implements IPagedResultDtoOfLeadImportHistoryDto {
    items!: LeadImportHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadImportHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadImportHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadImportHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadImportHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadImportHistoryDto {
    items: LeadImportHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLeadWorkHistoryDto implements IPagedResultDtoOfLeadWorkHistoryDto {
    items!: LeadWorkHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLeadWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeadWorkHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeadWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeadWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLeadWorkHistoryDto {
    items: LeadWorkHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfLoginDto implements IPagedResultDtoOfLoginDto {
    items!: LoginDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LoginDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfLoginDto {
    items: LoginDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMaintenanceConsoleServerDto implements IPagedResultDtoOfMaintenanceConsoleServerDto {
    items!: MaintenanceConsoleServerDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMaintenanceConsoleServerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaintenanceConsoleServerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMaintenanceConsoleServerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMaintenanceConsoleServerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMaintenanceConsoleServerDto {
    items: MaintenanceConsoleServerDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMaintenanceTaskDto implements IPagedResultDtoOfMaintenanceTaskDto {
    items!: MaintenanceTaskDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMaintenanceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaintenanceTaskDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMaintenanceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMaintenanceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMaintenanceTaskDto {
    items: MaintenanceTaskDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMaintenanceTaskLogDto implements IPagedResultDtoOfMaintenanceTaskLogDto {
    items!: MaintenanceTaskLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMaintenanceTaskLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaintenanceTaskLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMaintenanceTaskLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMaintenanceTaskLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMaintenanceTaskLogDto {
    items: MaintenanceTaskLogDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMarketingContactDto implements IPagedResultDtoOfMarketingContactDto {
    items!: MarketingContactDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMarketingContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketingContactDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMarketingContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMarketingContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMarketingContactDto {
    items: MarketingContactDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMarketingEventListDto implements IPagedResultDtoOfMarketingEventListDto {
    items!: MarketingEventListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMarketingEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketingEventListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMarketingEventListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMarketingEventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMarketingEventListDto {
    items: MarketingEventListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMarketingInteractionDto implements IPagedResultDtoOfMarketingInteractionDto {
    items!: MarketingInteractionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMarketingInteractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketingInteractionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMarketingInteractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMarketingInteractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMarketingInteractionDto {
    items: MarketingInteractionDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMarketingOrganizationListDto implements IPagedResultDtoOfMarketingOrganizationListDto {
    items!: MarketingOrganizationListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMarketingOrganizationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketingOrganizationListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMarketingOrganizationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMarketingOrganizationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMarketingOrganizationListDto {
    items: MarketingOrganizationListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMarketingOrganizationNoteDto implements IPagedResultDtoOfMarketingOrganizationNoteDto {
    items!: MarketingOrganizationNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMarketingOrganizationNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MarketingOrganizationNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMarketingOrganizationNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMarketingOrganizationNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMarketingOrganizationNoteDto {
    items: MarketingOrganizationNoteDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto implements IPagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto {
    items!: MassNotificationOrganizationUnitLookupTableDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MassNotificationOrganizationUnitLookupTableDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMassNotificationOrganizationUnitLookupTableDto {
    items: MassNotificationOrganizationUnitLookupTableDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMassNotificationUserLookupTableDto implements IPagedResultDtoOfMassNotificationUserLookupTableDto {
    items!: MassNotificationUserLookupTableDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMassNotificationUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MassNotificationUserLookupTableDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMassNotificationUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMassNotificationUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMassNotificationUserLookupTableDto {
    items: MassNotificationUserLookupTableDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMyCalendarDto implements IPagedResultDtoOfMyCalendarDto {
    items!: MyCalendarDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMyCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MyCalendarDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMyCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMyCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMyCalendarDto {
    items: MyCalendarDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfMyTasksDto implements IPagedResultDtoOfMyTasksDto {
    items!: MyTasksDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfMyTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MyTasksDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfMyTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMyTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfMyTasksDto {
    items: MyTasksDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOptOutLeadDto implements IPagedResultDtoOfOptOutLeadDto {
    items!: OptOutLeadDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOptOutLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OptOutLeadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOptOutLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOptOutLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOptOutLeadDto {
    items: OptOutLeadDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    items!: OrganizationUnitRoleListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    items: OrganizationUnitRoleListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    items!: OrganizationUnitUserListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    items: OrganizationUnitUserListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOsmImportHistoryDto implements IPagedResultDtoOfOsmImportHistoryDto {
    items!: OsmImportHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOsmImportHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OsmImportHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOsmImportHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOsmImportHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOsmImportHistoryDto {
    items: OsmImportHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOutgoingFaxLogDto implements IPagedResultDtoOfOutgoingFaxLogDto {
    items!: OutgoingFaxLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOutgoingFaxLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutgoingFaxLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOutgoingFaxLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOutgoingFaxLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOutgoingFaxLogDto {
    items: OutgoingFaxLogDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfOutgoingMailDto implements IPagedResultDtoOfOutgoingMailDto {
    items!: OutgoingMailDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfOutgoingMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OutgoingMailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfOutgoingMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOutgoingMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfOutgoingMailDto {
    items: OutgoingMailDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPartnerPortalReferralDto implements IPagedResultDtoOfPartnerPortalReferralDto {
    items!: PartnerPortalReferralDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPartnerPortalReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PartnerPortalReferralDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPartnerPortalReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPartnerPortalReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPartnerPortalReferralDto {
    items: PartnerPortalReferralDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPaymentRequestDto implements IPagedResultDtoOfPaymentRequestDto {
    items!: PaymentRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPaymentRequestDto {
    items: PaymentRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPaymentRequestStatusDto implements IPagedResultDtoOfPaymentRequestStatusDto {
    items!: PaymentRequestStatusDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPaymentRequestStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentRequestStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPaymentRequestStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPaymentRequestStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPaymentRequestStatusDto {
    items: PaymentRequestStatusDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPdfSigningRequestDto implements IPagedResultDtoOfPdfSigningRequestDto {
    items!: PdfSigningRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPdfSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PdfSigningRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPdfSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPdfSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPdfSigningRequestDto {
    items: PdfSigningRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPhaseMilestoneDto implements IPagedResultDtoOfPhaseMilestoneDto {
    items!: PhaseMilestoneDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPhaseMilestoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PhaseMilestoneDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPhaseMilestoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPhaseMilestoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPhaseMilestoneDto {
    items: PhaseMilestoneDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPiiReviewQueueItemDto implements IPagedResultDtoOfPiiReviewQueueItemDto {
    items!: PiiReviewQueueItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPiiReviewQueueItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PiiReviewQueueItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPiiReviewQueueItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPiiReviewQueueItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPiiReviewQueueItemDto {
    items: PiiReviewQueueItemDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPortalBillQueueResponseDto implements IPagedResultDtoOfPortalBillQueueResponseDto {
    items!: PortalBillQueueResponseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPortalBillQueueResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PortalBillQueueResponseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPortalBillQueueResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPortalBillQueueResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPortalBillQueueResponseDto {
    items: PortalBillQueueResponseDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfPublicPartnerDto implements IPagedResultDtoOfPublicPartnerDto {
    items!: PublicPartnerDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfPublicPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PublicPartnerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfPublicPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPublicPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfPublicPartnerDto {
    items: PublicPartnerDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfReferralPartnerDto implements IPagedResultDtoOfReferralPartnerDto {
    items!: ReferralPartnerDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfReferralPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReferralPartnerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfReferralPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReferralPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfReferralPartnerDto {
    items: ReferralPartnerDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfReinstatementDto implements IPagedResultDtoOfReinstatementDto {
    items!: ReinstatementDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfReinstatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReinstatementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfReinstatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReinstatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfReinstatementDto {
    items: ReinstatementDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfReportDto implements IPagedResultDtoOfReportDto {
    items!: ReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfReportDto {
    items: ReportDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfReportRequestDto implements IPagedResultDtoOfReportRequestDto {
    items!: ReportRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfReportRequestDto {
    items: ReportRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfScheduleDemoListDto implements IPagedResultDtoOfScheduleDemoListDto {
    items!: ScheduleDemoListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfScheduleDemoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduleDemoListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfScheduleDemoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfScheduleDemoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfScheduleDemoListDto {
    items: ScheduleDemoListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSearchLeadDto implements IPagedResultDtoOfSearchLeadDto {
    items!: SearchLeadDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSearchLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchLeadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSearchLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSearchLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSearchLeadDto {
    items: SearchLeadDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSearchTicketHolderDto implements IPagedResultDtoOfSearchTicketHolderDto {
    items!: SearchTicketHolderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSearchTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchTicketHolderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSearchTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSearchTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSearchTicketHolderDto {
    items: SearchTicketHolderDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfShortMessageTemplate implements IPagedResultDtoOfShortMessageTemplate {
    items!: ShortMessageTemplate[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfShortMessageTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ShortMessageTemplate.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfShortMessageTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfShortMessageTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfShortMessageTemplate {
    items: ShortMessageTemplate[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSignedIWPListItemDto implements IPagedResultDtoOfSignedIWPListItemDto {
    items!: SignedIWPListItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSignedIWPListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SignedIWPListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSignedIWPListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSignedIWPListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSignedIWPListItemDto {
    items: SignedIWPListItemDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSpokenLanguageDto implements IPagedResultDtoOfSpokenLanguageDto {
    items!: SpokenLanguageDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSpokenLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpokenLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSpokenLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSpokenLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSpokenLanguageDto {
    items: SpokenLanguageDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSsaContactDto implements IPagedResultDtoOfSsaContactDto {
    items!: SsaContactDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSsaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SsaContactDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSsaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSsaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSsaContactDto {
    items: SsaContactDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSsaSuitabilityApplicantListDto implements IPagedResultDtoOfSsaSuitabilityApplicantListDto {
    items!: SsaSuitabilityApplicantListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSsaSuitabilityApplicantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SsaSuitabilityApplicantListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSsaSuitabilityApplicantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSsaSuitabilityApplicantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSsaSuitabilityApplicantListDto {
    items: SsaSuitabilityApplicantListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfString implements IPagedResultDtoOfString {
    items!: string[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfString {
    items: string[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    items!: SubscriptionPaymentListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    items: SubscriptionPaymentListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSupportTicketDto implements IPagedResultDtoOfSupportTicketDto {
    items!: SupportTicketDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSupportTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SupportTicketDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSupportTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSupportTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSupportTicketDto {
    items: SupportTicketDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHChatSMSDto implements IPagedResultDtoOfTHChatSMSDto {
    items!: THChatSMSDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHChatSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THChatSMSDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHChatSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHChatSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHChatSMSDto {
    items: THChatSMSDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHContactHistoryDto implements IPagedResultDtoOfTHContactHistoryDto {
    items!: THContactHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THContactHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHContactHistoryDto {
    items: THContactHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHDocumentDto implements IPagedResultDtoOfTHDocumentDto {
    items!: THDocumentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THDocumentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHDocumentDto {
    items: THDocumentDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHFollowupDto implements IPagedResultDtoOfTHFollowupDto {
    items!: THFollowupDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THFollowupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHFollowupDto {
    items: THFollowupDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHJobInterviewDto implements IPagedResultDtoOfTHJobInterviewDto {
    items!: THJobInterviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHJobInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THJobInterviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHJobInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHJobInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHJobInterviewDto {
    items: THJobInterviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHJobLeadDto implements IPagedResultDtoOfTHJobLeadDto {
    items!: THJobLeadDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THJobLeadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHJobLeadDto {
    items: THJobLeadDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHOutputPayHistoryDto implements IPagedResultDtoOfTHOutputPayHistoryDto {
    items!: THOutputPayHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHOutputPayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THOutputPayHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHOutputPayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHOutputPayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHOutputPayHistoryDto {
    items: THOutputPayHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHVwServiceRequestDto implements IPagedResultDtoOfTHVwServiceRequestDto {
    items!: THVwServiceRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHVwServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THVwServiceRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHVwServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHVwServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHVwServiceRequestDto {
    items: THVwServiceRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHWageReportProcessingQDto implements IPagedResultDtoOfTHWageReportProcessingQDto {
    items!: THWageReportProcessingQDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHWageReportProcessingQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THWageReportProcessingQDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHWageReportProcessingQDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHWageReportProcessingQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHWageReportProcessingQDto {
    items: THWageReportProcessingQDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTHWorkHistoryDto implements IPagedResultDtoOfTHWorkHistoryDto {
    items!: THWorkHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTHWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(THWorkHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTHWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTHWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTHWorkHistoryDto {
    items: THWorkHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTTWTaskTemplateDto implements IPagedResultDtoOfTTWTaskTemplateDto {
    items!: TTWTaskTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTTWTaskTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TTWTaskTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTTWTaskTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTTWTaskTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTTWTaskTemplateDto {
    items: TTWTaskTemplateDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTagGroupTicketHolderDto implements IPagedResultDtoOfTagGroupTicketHolderDto {
    items!: TagGroupTicketHolderDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTagGroupTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TagGroupTicketHolderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTagGroupTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTagGroupTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTagGroupTicketHolderDto {
    items: TagGroupTicketHolderDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTaskExecutionDto implements IPagedResultDtoOfTaskExecutionDto {
    items!: TaskExecutionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTaskExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskExecutionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTaskExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTaskExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTaskExecutionDto {
    items: TaskExecutionDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    items!: TenantListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    items: TenantListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketAssignmentListItemDto implements IPagedResultDtoOfTicketAssignmentListItemDto {
    items!: TicketAssignmentListItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketAssignmentListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketAssignmentListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketAssignmentListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketAssignmentListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketAssignmentListItemDto {
    items: TicketAssignmentListItemDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderActivityDto implements IPagedResultDtoOfTicketHolderActivityDto {
    items!: TicketHolderActivityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderActivityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderActivityDto {
    items: TicketHolderActivityDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderFollowupDto implements IPagedResultDtoOfTicketHolderFollowupDto {
    items!: TicketHolderFollowupDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderFollowupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderFollowupDto {
    items: TicketHolderFollowupDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderIWPDto implements IPagedResultDtoOfTicketHolderIWPDto {
    items!: TicketHolderIWPDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderIWPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderIWPDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderIWPDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderIWPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderIWPDto {
    items: TicketHolderIWPDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderJobLeadDto implements IPagedResultDtoOfTicketHolderJobLeadDto {
    items!: TicketHolderJobLeadDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderJobLeadDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderJobLeadDto {
    items: TicketHolderJobLeadDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderLoginRowDto implements IPagedResultDtoOfTicketHolderLoginRowDto {
    items!: TicketHolderLoginRowDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderLoginRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderLoginRowDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderLoginRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderLoginRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderLoginRowDto {
    items: TicketHolderLoginRowDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderOSMDto implements IPagedResultDtoOfTicketHolderOSMDto {
    items!: TicketHolderOSMDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderOSMDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderOSMDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderOSMDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderOSMDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderOSMDto {
    items: TicketHolderOSMDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderPayHistoryDto implements IPagedResultDtoOfTicketHolderPayHistoryDto {
    items!: TicketHolderPayHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderPayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderPayHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderPayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderPayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderPayHistoryDto {
    items: TicketHolderPayHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderPayRequestHistoryDto implements IPagedResultDtoOfTicketHolderPayRequestHistoryDto {
    items!: TicketHolderPayRequestHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderPayRequestHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderPayRequestHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderPayRequestHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderPayRequestHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderPayRequestHistoryDto {
    items: TicketHolderPayRequestHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderSearchDto implements IPagedResultDtoOfTicketHolderSearchDto {
    items!: TicketHolderSearchDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderSearchDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderSearchDto {
    items: TicketHolderSearchDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderStateCountDto implements IPagedResultDtoOfTicketHolderStateCountDto {
    items!: TicketHolderStateCountDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderStateCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderStateCountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderStateCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderStateCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderStateCountDto {
    items: TicketHolderStateCountDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderWageDataSearchResponseDto implements IPagedResultDtoOfTicketHolderWageDataSearchResponseDto {
    items!: TicketHolderWageDataSearchResponseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderWageDataSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderWageDataSearchResponseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderWageDataSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderWageDataSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderWageDataSearchResponseDto {
    items: TicketHolderWageDataSearchResponseDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketHolderWorkHistoryDto implements IPagedResultDtoOfTicketHolderWorkHistoryDto {
    items!: TicketHolderWorkHistoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketHolderWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderWorkHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketHolderWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketHolderWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketHolderWorkHistoryDto {
    items: TicketHolderWorkHistoryDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTicketUnassignmentListItemDto implements IPagedResultDtoOfTicketUnassignmentListItemDto {
    items!: TicketUnassignmentListItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTicketUnassignmentListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketUnassignmentListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTicketUnassignmentListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTicketUnassignmentListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTicketUnassignmentListItemDto {
    items: TicketUnassignmentListItemDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTranslationLanguageDto implements IPagedResultDtoOfTranslationLanguageDto {
    items!: TranslationLanguageDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTranslationLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TranslationLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTranslationLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTranslationLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTranslationLanguageDto {
    items: TranslationLanguageDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTtwReferralDto implements IPagedResultDtoOfTtwReferralDto {
    items!: TtwReferralDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTtwReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TtwReferralDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTtwReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTtwReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTtwReferralDto {
    items: TtwReferralDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUSAStateDto implements IPagedResultDtoOfUSAStateDto {
    items!: USAStateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUSAStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(USAStateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUSAStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUSAStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUSAStateDto {
    items: USAStateDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUnassignRequestDto implements IPagedResultDtoOfUnassignRequestDto {
    items!: UnassignRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUnassignRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UnassignRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUnassignRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUnassignRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUnassignRequestDto {
    items: UnassignRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUnknownIncomingFaxDto implements IPagedResultDtoOfUnknownIncomingFaxDto {
    items!: UnknownIncomingFaxDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUnknownIncomingFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UnknownIncomingFaxDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUnknownIncomingFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUnknownIncomingFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUnknownIncomingFaxDto {
    items: UnknownIncomingFaxDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUnknownIncomingSMSDto implements IPagedResultDtoOfUnknownIncomingSMSDto {
    items!: UnknownIncomingSMSDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUnknownIncomingSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UnknownIncomingSMSDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUnknownIncomingSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUnknownIncomingSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUnknownIncomingSMSDto {
    items: UnknownIncomingSMSDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    items!: UserDelegationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    items: UserDelegationDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    items!: UserListDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    items: UserListDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfVwServiceRequestDto implements IPagedResultDtoOfVwServiceRequestDto {
    items!: VwServiceRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfVwServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VwServiceRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfVwServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVwServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfVwServiceRequestDto {
    items: VwServiceRequestDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfWageReportProcessingQDto implements IPagedResultDtoOfWageReportProcessingQDto {
    items!: WageReportProcessingQDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfWageReportProcessingQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WageReportProcessingQDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfWageReportProcessingQDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWageReportProcessingQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfWageReportProcessingQDto {
    items: WageReportProcessingQDto[] | undefined;
    totalCount: number;
}

export class PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto implements IPagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto {
    totalCount!: number;
    items!: TicketHolderCareerCoachAssignedDto[] | undefined;
    grid!: GridConfigurationDto;

    constructor(data?: IPagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderCareerCoachAssignedDto.fromJS(item));
            }
            this.grid = _data["grid"] ? GridConfigurationDto.fromJS(_data["grid"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["grid"] = this.grid ? this.grid.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultWithGridDtoOfTicketHolderCareerCoachAssignedDto {
    totalCount: number;
    items: TicketHolderCareerCoachAssignedDto[] | undefined;
    grid: GridConfigurationDto;
}

export class PagedResultWithGridDtoOfTicketHolderDto implements IPagedResultWithGridDtoOfTicketHolderDto {
    totalCount!: number;
    items!: TicketHolderDto[] | undefined;
    grid!: GridConfigurationDto;

    constructor(data?: IPagedResultWithGridDtoOfTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderDto.fromJS(item));
            }
            this.grid = _data["grid"] ? GridConfigurationDto.fromJS(_data["grid"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PagedResultWithGridDtoOfTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultWithGridDtoOfTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["grid"] = this.grid ? this.grid.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedResultWithGridDtoOfTicketHolderDto {
    totalCount: number;
    items: TicketHolderDto[] | undefined;
    grid: GridConfigurationDto;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export class ParameterInfo implements IParameterInfo {
    attributes!: ParameterAttributes;
    member!: MemberInfo;
    readonly name!: string | undefined;
    parameterType!: Type;
    readonly position!: number;
    readonly isIn!: boolean;
    readonly isLcid!: boolean;
    readonly isOptional!: boolean;
    readonly isOut!: boolean;
    readonly isRetval!: boolean;
    readonly defaultValue!: any | undefined;
    readonly rawDefaultValue!: any | undefined;
    readonly hasDefaultValue!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : <any>undefined;
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | undefined;
    parameterType: Type;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class PartnerAgreementDto implements IPartnerAgreementDto {
    partnerId!: number;
    partnerCode!: string | undefined;
    organizationName!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    agreementStatus!: PartnerAgreementStatus;
    agreementText!: string | undefined;
    partnerSignatureStatus!: DigitalSignatureStatus;
    springUpSignatureStatus!: DigitalSignatureStatus;
    springUpSignerEmail!: string | undefined;
    sentDate!: DateTime | undefined;
    agreementSignedDate!: DateTime | undefined;
    signedDocumentId!: number | undefined;
    hasLogin!: boolean;

    constructor(data?: IPartnerAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerCode = _data["partnerCode"];
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.agreementStatus = _data["agreementStatus"];
            this.agreementText = _data["agreementText"];
            this.partnerSignatureStatus = _data["partnerSignatureStatus"];
            this.springUpSignatureStatus = _data["springUpSignatureStatus"];
            this.springUpSignerEmail = _data["springUpSignerEmail"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.agreementSignedDate = _data["agreementSignedDate"] ? DateTime.fromISO(_data["agreementSignedDate"].toString()) : <any>undefined;
            this.signedDocumentId = _data["signedDocumentId"];
            this.hasLogin = _data["hasLogin"];
        }
    }

    static fromJS(data: any): PartnerAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerCode"] = this.partnerCode;
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["agreementStatus"] = this.agreementStatus;
        data["agreementText"] = this.agreementText;
        data["partnerSignatureStatus"] = this.partnerSignatureStatus;
        data["springUpSignatureStatus"] = this.springUpSignatureStatus;
        data["springUpSignerEmail"] = this.springUpSignerEmail;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["agreementSignedDate"] = this.agreementSignedDate ? this.agreementSignedDate.toString() : <any>undefined;
        data["signedDocumentId"] = this.signedDocumentId;
        data["hasLogin"] = this.hasLogin;
        return data;
    }
}

export interface IPartnerAgreementDto {
    partnerId: number;
    partnerCode: string | undefined;
    organizationName: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    agreementStatus: PartnerAgreementStatus;
    agreementText: string | undefined;
    partnerSignatureStatus: DigitalSignatureStatus;
    springUpSignatureStatus: DigitalSignatureStatus;
    springUpSignerEmail: string | undefined;
    sentDate: DateTime | undefined;
    agreementSignedDate: DateTime | undefined;
    signedDocumentId: number | undefined;
    hasLogin: boolean;
}

export class PartnerAgreementFileDto implements IPartnerAgreementFileDto {
    fileName!: string | undefined;
    base64Content!: string | undefined;

    constructor(data?: IPartnerAgreementFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.base64Content = _data["base64Content"];
        }
    }

    static fromJS(data: any): PartnerAgreementFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAgreementFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["base64Content"] = this.base64Content;
        return data;
    }
}

export interface IPartnerAgreementFileDto {
    fileName: string | undefined;
    base64Content: string | undefined;
}

export enum PartnerAgreementStatus {
    NotRequired = 0,
    PendingReview = 1,
    AgreementSent = 2,
    Signed = 3,
    Declined = 4,
}

export class PartnerChangePasswordInputDto implements IPartnerChangePasswordInputDto {
    tenancyName!: string;
    email!: string;
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IPartnerChangePasswordInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.email = _data["email"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): PartnerChangePasswordInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerChangePasswordInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["email"] = this.email;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IPartnerChangePasswordInputDto {
    tenancyName: string;
    email: string;
    currentPassword: string;
    newPassword: string;
}

export class PartnerIdAndNameDto implements IPartnerIdAndNameDto {
    id!: number;
    name!: string | undefined;
    partnerCode!: string | undefined;

    constructor(data?: IPartnerIdAndNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.partnerCode = _data["partnerCode"];
        }
    }

    static fromJS(data: any): PartnerIdAndNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerIdAndNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["partnerCode"] = this.partnerCode;
        return data;
    }
}

export interface IPartnerIdAndNameDto {
    id: number;
    name: string | undefined;
    partnerCode: string | undefined;
}

export class PartnerLoginInputDto implements IPartnerLoginInputDto {
    tenancyName!: string;
    email!: string;
    password!: string;

    constructor(data?: IPartnerLoginInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): PartnerLoginInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLoginInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IPartnerLoginInputDto {
    tenancyName: string;
    email: string;
    password: string;
}

export class PartnerLoginResultDto implements IPartnerLoginResultDto {
    sessionToken!: string | undefined;
    contactName!: string | undefined;
    organizationName!: string | undefined;
    mustChangePassword!: boolean;
    isAdmin!: boolean;

    constructor(data?: IPartnerLoginResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.contactName = _data["contactName"];
            this.organizationName = _data["organizationName"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): PartnerLoginResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerLoginResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["contactName"] = this.contactName;
        data["organizationName"] = this.organizationName;
        data["mustChangePassword"] = this.mustChangePassword;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IPartnerLoginResultDto {
    sessionToken: string | undefined;
    contactName: string | undefined;
    organizationName: string | undefined;
    mustChangePassword: boolean;
    isAdmin: boolean;
}

export class PartnerPortalAddUserDto implements IPartnerPortalAddUserDto {
    sessionToken!: string;
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: IPartnerPortalAddUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PartnerPortalAddUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPortalAddUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IPartnerPortalAddUserDto {
    sessionToken: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class PartnerPortalDashboardDto implements IPartnerPortalDashboardDto {
    partnerId!: number;
    partnerCode!: string | undefined;
    organizationName!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    contactAddress!: string | undefined;
    website!: string | undefined;
    organizationDescription!: string | undefined;
    logoDataUrl!: string | undefined;
    agreementStatus!: PartnerAgreementStatus;
    agreementSignedDate!: DateTime | undefined;
    startDate!: DateTime;
    hasSignedAgreement!: boolean;
    showOnWebsite!: boolean;
    isAdmin!: boolean;
    totalReferrals!: number;
    openReferrals!: number;
    convertedReferrals!: number;

    constructor(data?: IPartnerPortalDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerCode = _data["partnerCode"];
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.contactAddress = _data["contactAddress"];
            this.website = _data["website"];
            this.organizationDescription = _data["organizationDescription"];
            this.logoDataUrl = _data["logoDataUrl"];
            this.agreementStatus = _data["agreementStatus"];
            this.agreementSignedDate = _data["agreementSignedDate"] ? DateTime.fromISO(_data["agreementSignedDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.hasSignedAgreement = _data["hasSignedAgreement"];
            this.showOnWebsite = _data["showOnWebsite"];
            this.isAdmin = _data["isAdmin"];
            this.totalReferrals = _data["totalReferrals"];
            this.openReferrals = _data["openReferrals"];
            this.convertedReferrals = _data["convertedReferrals"];
        }
    }

    static fromJS(data: any): PartnerPortalDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPortalDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerCode"] = this.partnerCode;
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["contactAddress"] = this.contactAddress;
        data["website"] = this.website;
        data["organizationDescription"] = this.organizationDescription;
        data["logoDataUrl"] = this.logoDataUrl;
        data["agreementStatus"] = this.agreementStatus;
        data["agreementSignedDate"] = this.agreementSignedDate ? this.agreementSignedDate.toString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["hasSignedAgreement"] = this.hasSignedAgreement;
        data["showOnWebsite"] = this.showOnWebsite;
        data["isAdmin"] = this.isAdmin;
        data["totalReferrals"] = this.totalReferrals;
        data["openReferrals"] = this.openReferrals;
        data["convertedReferrals"] = this.convertedReferrals;
        return data;
    }
}

export interface IPartnerPortalDashboardDto {
    partnerId: number;
    partnerCode: string | undefined;
    organizationName: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    contactAddress: string | undefined;
    website: string | undefined;
    organizationDescription: string | undefined;
    logoDataUrl: string | undefined;
    agreementStatus: PartnerAgreementStatus;
    agreementSignedDate: DateTime | undefined;
    startDate: DateTime;
    hasSignedAgreement: boolean;
    showOnWebsite: boolean;
    isAdmin: boolean;
    totalReferrals: number;
    openReferrals: number;
    convertedReferrals: number;
}

export class PartnerPortalReferralDto implements IPartnerPortalReferralDto {
    id!: number;
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    status!: ReferralStatus;
    statusDisplay!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IPartnerPortalReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.status = _data["status"];
            this.statusDisplay = _data["statusDisplay"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PartnerPortalReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPortalReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["status"] = this.status;
        data["statusDisplay"] = this.statusDisplay;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IPartnerPortalReferralDto {
    id: number;
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    status: ReferralStatus;
    statusDisplay: string | undefined;
    creationTime: DateTime;
}

export class PartnerPortalSendReferralDto implements IPartnerPortalSendReferralDto {
    sessionToken!: string;
    referralFirstName!: string;
    referralLastName!: string;
    referralEmail!: string;
    referralPhone!: string;
    benefitType!: string;
    ageEligible!: boolean;
    consentToContact!: boolean;
    notes!: string | undefined;

    constructor(data?: IPartnerPortalSendReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.benefitType = _data["benefitType"];
            this.ageEligible = _data["ageEligible"];
            this.consentToContact = _data["consentToContact"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PartnerPortalSendReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPortalSendReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["benefitType"] = this.benefitType;
        data["ageEligible"] = this.ageEligible;
        data["consentToContact"] = this.consentToContact;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPartnerPortalSendReferralDto {
    sessionToken: string;
    referralFirstName: string;
    referralLastName: string;
    referralEmail: string;
    referralPhone: string;
    benefitType: string;
    ageEligible: boolean;
    consentToContact: boolean;
    notes: string | undefined;
}

export class PartnerPortalUserActionDto implements IPartnerPortalUserActionDto {
    sessionToken!: string;
    userId!: number;

    constructor(data?: IPartnerPortalUserActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): PartnerPortalUserActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPortalUserActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IPartnerPortalUserActionDto {
    sessionToken: string;
    userId: number;
}

export class PartnerPortalUserDto implements IPartnerPortalUserDto {
    userId!: number;
    name!: string | undefined;
    email!: string | undefined;
    userName!: string | undefined;
    isAdmin!: boolean;
    isActive!: boolean;
    mustChangePassword!: boolean;
    creationTime!: DateTime;

    constructor(data?: IPartnerPortalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.isAdmin = _data["isAdmin"];
            this.isActive = _data["isActive"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PartnerPortalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerPortalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["isAdmin"] = this.isAdmin;
        data["isActive"] = this.isActive;
        data["mustChangePassword"] = this.mustChangePassword;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IPartnerPortalUserDto {
    userId: number;
    name: string | undefined;
    email: string | undefined;
    userName: string | undefined;
    isAdmin: boolean;
    isActive: boolean;
    mustChangePassword: boolean;
    creationTime: DateTime;
}

export class PartnerRegistrationInputDto implements IPartnerRegistrationInputDto {
    tenancyName!: string;
    organizationName!: string;
    contactName!: string;
    contactTitle!: string | undefined;
    contactEmail!: string;
    contactPhone!: string;
    contactAddress!: string | undefined;
    website!: string | undefined;
    organizationDescription!: string | undefined;
    consentToContact!: boolean;

    constructor(data?: IPartnerRegistrationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactTitle = _data["contactTitle"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.contactAddress = _data["contactAddress"];
            this.website = _data["website"];
            this.organizationDescription = _data["organizationDescription"];
            this.consentToContact = _data["consentToContact"];
        }
    }

    static fromJS(data: any): PartnerRegistrationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRegistrationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactTitle"] = this.contactTitle;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["contactAddress"] = this.contactAddress;
        data["website"] = this.website;
        data["organizationDescription"] = this.organizationDescription;
        data["consentToContact"] = this.consentToContact;
        return data;
    }
}

export interface IPartnerRegistrationInputDto {
    tenancyName: string;
    organizationName: string;
    contactName: string;
    contactTitle: string | undefined;
    contactEmail: string;
    contactPhone: string;
    contactAddress: string | undefined;
    website: string | undefined;
    organizationDescription: string | undefined;
    consentToContact: boolean;
}

export class PartnerRegistrationResultDto implements IPartnerRegistrationResultDto {
    partnerCode!: string | undefined;

    constructor(data?: IPartnerRegistrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerCode = _data["partnerCode"];
        }
    }

    static fromJS(data: any): PartnerRegistrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRegistrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerCode"] = this.partnerCode;
        return data;
    }
}

export interface IPartnerRegistrationResultDto {
    partnerCode: string | undefined;
}

export class PartnerSessionDto implements IPartnerSessionDto {
    sessionToken!: string;

    constructor(data?: IPartnerSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
        }
    }

    static fromJS(data: any): PartnerSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        return data;
    }
}

export interface IPartnerSessionDto {
    sessionToken: string;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    readonly allowedMinimumLength!: number;
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).allowedMinimumLength = _data["allowedMinimumLength"];
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedMinimumLength"] = this.allowedMinimumLength;
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    allowedMinimumLength: number;
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class PasswordlessAuthenticateModel implements IPasswordlessAuthenticateModel {
    provider!: string | undefined;
    providerValue!: string | undefined;
    verificationCode!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IPasswordlessAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.providerValue = _data["providerValue"];
            this.verificationCode = _data["verificationCode"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): PasswordlessAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordlessAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["providerValue"] = this.providerValue;
        data["verificationCode"] = this.verificationCode;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IPasswordlessAuthenticateModel {
    provider: string | undefined;
    providerValue: string | undefined;
    verificationCode: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class PasswordlessAuthenticateResultModel implements IPasswordlessAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;
    refreshToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IPasswordlessAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.refreshToken = _data["refreshToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): PasswordlessAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordlessAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["refreshToken"] = this.refreshToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IPasswordlessAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    refreshToken: string | undefined;
    returnUrl: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export enum PasswordlessLoginProviderType {
    Email = 1,
    Sms = 2,
}

export class PasswordlessLoginSettingsEditDto implements IPasswordlessLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEmailProviderEnabledForApplication!: boolean;
    isSmsProviderEnabledForApplication!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;

    constructor(data?: IPasswordlessLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEmailProviderEnabledForApplication = _data["isEmailProviderEnabledForApplication"];
            this.isSmsProviderEnabledForApplication = _data["isSmsProviderEnabledForApplication"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
        }
    }

    static fromJS(data: any): PasswordlessLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordlessLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEmailProviderEnabledForApplication"] = this.isEmailProviderEnabledForApplication;
        data["isSmsProviderEnabledForApplication"] = this.isSmsProviderEnabledForApplication;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        return data;
    }
}

export interface IPasswordlessLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEmailProviderEnabledForApplication: boolean;
    isSmsProviderEnabledForApplication: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
}

export class PastEmploymentDto implements IPastEmploymentDto {
    id!: number | undefined;
    employerOrBusinessName!: string | undefined;
    wasSelfEmployment!: boolean | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    averageGrossMonthlyEarnings!: number | undefined;
    earningsReportedToSSA!: boolean | undefined;
    notes!: string | undefined;

    constructor(data?: IPastEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employerOrBusinessName = _data["employerOrBusinessName"];
            this.wasSelfEmployment = _data["wasSelfEmployment"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.averageGrossMonthlyEarnings = _data["averageGrossMonthlyEarnings"];
            this.earningsReportedToSSA = _data["earningsReportedToSSA"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PastEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PastEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employerOrBusinessName"] = this.employerOrBusinessName;
        data["wasSelfEmployment"] = this.wasSelfEmployment;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["averageGrossMonthlyEarnings"] = this.averageGrossMonthlyEarnings;
        data["earningsReportedToSSA"] = this.earningsReportedToSSA;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPastEmploymentDto {
    id: number | undefined;
    employerOrBusinessName: string | undefined;
    wasSelfEmployment: boolean | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
    averageGrossMonthlyEarnings: number | undefined;
    earningsReportedToSSA: boolean | undefined;
    notes: string | undefined;
}

export class PayHistoryOverviewResultDto implements IPayHistoryOverviewResultDto {
    availableYears!: number[] | undefined;
    years!: PayHistoryOverviewYearDto[] | undefined;
    paySchedules!: PayScheduleOverviewDto[] | undefined;

    constructor(data?: IPayHistoryOverviewResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableYears"])) {
                this.availableYears = [] as any;
                for (let item of _data["availableYears"])
                    this.availableYears!.push(item);
            }
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(PayHistoryOverviewYearDto.fromJS(item));
            }
            if (Array.isArray(_data["paySchedules"])) {
                this.paySchedules = [] as any;
                for (let item of _data["paySchedules"])
                    this.paySchedules!.push(PayScheduleOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PayHistoryOverviewResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayHistoryOverviewResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableYears)) {
            data["availableYears"] = [];
            for (let item of this.availableYears)
                data["availableYears"].push(item);
        }
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        if (Array.isArray(this.paySchedules)) {
            data["paySchedules"] = [];
            for (let item of this.paySchedules)
                data["paySchedules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPayHistoryOverviewResultDto {
    availableYears: number[] | undefined;
    years: PayHistoryOverviewYearDto[] | undefined;
    paySchedules: PayScheduleOverviewDto[] | undefined;
}

export class PayHistoryOverviewRowDto implements IPayHistoryOverviewRowDto {
    payHistoryId!: number | undefined;
    payPeriodStart!: DateTime | undefined;
    payPeriodEnd!: DateTime | undefined;
    payDate!: DateTime;
    employerName!: string | undefined;
    grossPay!: number | undefined;
    isMissing!: boolean;
    paystubDocumentId!: number | undefined;

    constructor(data?: IPayHistoryOverviewRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payHistoryId = _data["payHistoryId"];
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.employerName = _data["employerName"];
            this.grossPay = _data["grossPay"];
            this.isMissing = _data["isMissing"];
            this.paystubDocumentId = _data["paystubDocumentId"];
        }
    }

    static fromJS(data: any): PayHistoryOverviewRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayHistoryOverviewRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payHistoryId"] = this.payHistoryId;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["employerName"] = this.employerName;
        data["grossPay"] = this.grossPay;
        data["isMissing"] = this.isMissing;
        data["paystubDocumentId"] = this.paystubDocumentId;
        return data;
    }
}

export interface IPayHistoryOverviewRowDto {
    payHistoryId: number | undefined;
    payPeriodStart: DateTime | undefined;
    payPeriodEnd: DateTime | undefined;
    payDate: DateTime;
    employerName: string | undefined;
    grossPay: number | undefined;
    isMissing: boolean;
    paystubDocumentId: number | undefined;
}

export class PayHistoryOverviewYearDto implements IPayHistoryOverviewYearDto {
    year!: number;
    twlAmount!: number | undefined;
    sgaAmount!: number | undefined;
    blindSgaAmount!: number | undefined;
    isStatutorilyBlind!: boolean;
    applicableSgaAmount!: number | undefined;
    stateAbbreviation!: string | undefined;
    is1634State!: boolean | undefined;
    oneSixOneNineBThreshold!: number | undefined;
    is1619bThresholdAiSourced!: boolean;
    fbrEligibleIndividualAmount!: number | undefined;
    fbrEligibleCoupleAmount!: number | undefined;
    fbrEssentialPersonAmount!: number | undefined;
    recordedEarnings!: number;
    benefitsImpactSummary!: string | undefined;
    reviewRecommended!: boolean;
    rows!: PayHistoryOverviewRowDto[] | undefined;

    constructor(data?: IPayHistoryOverviewYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.twlAmount = _data["twlAmount"];
            this.sgaAmount = _data["sgaAmount"];
            this.blindSgaAmount = _data["blindSgaAmount"];
            this.isStatutorilyBlind = _data["isStatutorilyBlind"];
            this.applicableSgaAmount = _data["applicableSgaAmount"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.is1634State = _data["is1634State"];
            this.oneSixOneNineBThreshold = _data["oneSixOneNineBThreshold"];
            this.is1619bThresholdAiSourced = _data["is1619bThresholdAiSourced"];
            this.fbrEligibleIndividualAmount = _data["fbrEligibleIndividualAmount"];
            this.fbrEligibleCoupleAmount = _data["fbrEligibleCoupleAmount"];
            this.fbrEssentialPersonAmount = _data["fbrEssentialPersonAmount"];
            this.recordedEarnings = _data["recordedEarnings"];
            this.benefitsImpactSummary = _data["benefitsImpactSummary"];
            this.reviewRecommended = _data["reviewRecommended"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PayHistoryOverviewRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PayHistoryOverviewYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayHistoryOverviewYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["twlAmount"] = this.twlAmount;
        data["sgaAmount"] = this.sgaAmount;
        data["blindSgaAmount"] = this.blindSgaAmount;
        data["isStatutorilyBlind"] = this.isStatutorilyBlind;
        data["applicableSgaAmount"] = this.applicableSgaAmount;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["is1634State"] = this.is1634State;
        data["oneSixOneNineBThreshold"] = this.oneSixOneNineBThreshold;
        data["is1619bThresholdAiSourced"] = this.is1619bThresholdAiSourced;
        data["fbrEligibleIndividualAmount"] = this.fbrEligibleIndividualAmount;
        data["fbrEligibleCoupleAmount"] = this.fbrEligibleCoupleAmount;
        data["fbrEssentialPersonAmount"] = this.fbrEssentialPersonAmount;
        data["recordedEarnings"] = this.recordedEarnings;
        data["benefitsImpactSummary"] = this.benefitsImpactSummary;
        data["reviewRecommended"] = this.reviewRecommended;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPayHistoryOverviewYearDto {
    year: number;
    twlAmount: number | undefined;
    sgaAmount: number | undefined;
    blindSgaAmount: number | undefined;
    isStatutorilyBlind: boolean;
    applicableSgaAmount: number | undefined;
    stateAbbreviation: string | undefined;
    is1634State: boolean | undefined;
    oneSixOneNineBThreshold: number | undefined;
    is1619bThresholdAiSourced: boolean;
    fbrEligibleIndividualAmount: number | undefined;
    fbrEligibleCoupleAmount: number | undefined;
    fbrEssentialPersonAmount: number | undefined;
    recordedEarnings: number;
    benefitsImpactSummary: string | undefined;
    reviewRecommended: boolean;
    rows: PayHistoryOverviewRowDto[] | undefined;
}

export class PayHistoryRequestDto implements IPayHistoryRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    ticketHolderId!: number;
    wageReportProcessingQId!: number | undefined;
    employerId!: number[] | undefined;
    isLinked!: boolean | undefined;
    status!: WageReportProcessingStatus[] | undefined;
    filter!: string | undefined;

    constructor(data?: IPayHistoryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.wageReportProcessingQId = _data["wageReportProcessingQId"];
            if (Array.isArray(_data["employerId"])) {
                this.employerId = [] as any;
                for (let item of _data["employerId"])
                    this.employerId!.push(item);
            }
            this.isLinked = _data["isLinked"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): PayHistoryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayHistoryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["ticketHolderId"] = this.ticketHolderId;
        data["wageReportProcessingQId"] = this.wageReportProcessingQId;
        if (Array.isArray(this.employerId)) {
            data["employerId"] = [];
            for (let item of this.employerId)
                data["employerId"].push(item);
        }
        data["isLinked"] = this.isLinked;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["filter"] = this.filter;
        return data;
    }
}

export interface IPayHistoryRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    ticketHolderId: number;
    wageReportProcessingQId: number | undefined;
    employerId: number[] | undefined;
    isLinked: boolean | undefined;
    status: WageReportProcessingStatus[] | undefined;
    filter: string | undefined;
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;
    disabledFundings!: string[] | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.demoUsername = _data["demoUsername"];
            this.demoPassword = _data["demoPassword"];
            if (Array.isArray(_data["disabledFundings"])) {
                this.disabledFundings = [] as any;
                for (let item of _data["disabledFundings"])
                    this.disabledFundings!.push(item);
            }
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        if (Array.isArray(this.disabledFundings)) {
            data["disabledFundings"] = [];
            for (let item of this.disabledFundings)
                data["disabledFundings"].push(item);
        }
        return data;
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
    disabledFundings: string[] | undefined;
}

export class PayScheduleOverviewDto implements IPayScheduleOverviewDto {
    employerName!: string | undefined;
    frequency!: string | undefined;
    summary!: string | undefined;
    missingCount!: number;
    latestPayDate!: DateTime;
    nextPayDate!: DateTime | undefined;
    nextPeriodStart!: DateTime | undefined;
    nextPeriodEnd!: DateTime | undefined;
    isCurrentJob!: boolean;

    constructor(data?: IPayScheduleOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerName = _data["employerName"];
            this.frequency = _data["frequency"];
            this.summary = _data["summary"];
            this.missingCount = _data["missingCount"];
            this.latestPayDate = _data["latestPayDate"] ? DateTime.fromISO(_data["latestPayDate"].toString()) : <any>undefined;
            this.nextPayDate = _data["nextPayDate"] ? DateTime.fromISO(_data["nextPayDate"].toString()) : <any>undefined;
            this.nextPeriodStart = _data["nextPeriodStart"] ? DateTime.fromISO(_data["nextPeriodStart"].toString()) : <any>undefined;
            this.nextPeriodEnd = _data["nextPeriodEnd"] ? DateTime.fromISO(_data["nextPeriodEnd"].toString()) : <any>undefined;
            this.isCurrentJob = _data["isCurrentJob"];
        }
    }

    static fromJS(data: any): PayScheduleOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayScheduleOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerName"] = this.employerName;
        data["frequency"] = this.frequency;
        data["summary"] = this.summary;
        data["missingCount"] = this.missingCount;
        data["latestPayDate"] = this.latestPayDate ? this.latestPayDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nextPayDate"] = this.nextPayDate ? this.nextPayDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nextPeriodStart"] = this.nextPeriodStart ? this.nextPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nextPeriodEnd"] = this.nextPeriodEnd ? this.nextPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isCurrentJob"] = this.isCurrentJob;
        return data;
    }
}

export interface IPayScheduleOverviewDto {
    employerName: string | undefined;
    frequency: string | undefined;
    summary: string | undefined;
    missingCount: number;
    latestPayDate: DateTime;
    nextPayDate: DateTime | undefined;
    nextPeriodStart: DateTime | undefined;
    nextPeriodEnd: DateTime | undefined;
    isCurrentJob: boolean;
}

export enum PayType {
    Hourly = 0,
    Salaried = 1,
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export enum PaymentPeriodType {
    Monthly = 30,
    Annual = 365,
}

export class PaymentRequestDto implements IPaymentRequestDto {
    id!: number;
    ticketHolderId!: number;
    customeTicketHolderId!: string | undefined;
    requestDate!: DateTime;
    requestedAmount!: number;
    approvedAmount!: number | undefined;
    paymentMethod!: string | undefined;
    approvalStatus!: PaymentRequestStatus;
    denialReason!: string | undefined;
    submissionDate!: DateTime | undefined;
    submissionReferenceId!: string | undefined;
    workCaseNumber!: string | undefined;
    phaseMilestoneId!: string | undefined;
    documentId!: number;
    responseReceivedDate!: DateTime | undefined;
    notes!: string | undefined;

    constructor(data?: IPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.customeTicketHolderId = _data["customeTicketHolderId"];
            this.requestDate = _data["requestDate"] ? DateTime.fromISO(_data["requestDate"].toString()) : <any>undefined;
            this.requestedAmount = _data["requestedAmount"];
            this.approvedAmount = _data["approvedAmount"];
            this.paymentMethod = _data["paymentMethod"];
            this.approvalStatus = _data["approvalStatus"];
            this.denialReason = _data["denialReason"];
            this.submissionDate = _data["submissionDate"] ? DateTime.fromISO(_data["submissionDate"].toString()) : <any>undefined;
            this.submissionReferenceId = _data["submissionReferenceId"];
            this.workCaseNumber = _data["workCaseNumber"];
            this.phaseMilestoneId = _data["phaseMilestoneId"];
            this.documentId = _data["documentId"];
            this.responseReceivedDate = _data["responseReceivedDate"] ? DateTime.fromISO(_data["responseReceivedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["customeTicketHolderId"] = this.customeTicketHolderId;
        data["requestDate"] = this.requestDate ? this.requestDate.toString() : <any>undefined;
        data["requestedAmount"] = this.requestedAmount;
        data["approvedAmount"] = this.approvedAmount;
        data["paymentMethod"] = this.paymentMethod;
        data["approvalStatus"] = this.approvalStatus;
        data["denialReason"] = this.denialReason;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toString() : <any>undefined;
        data["submissionReferenceId"] = this.submissionReferenceId;
        data["workCaseNumber"] = this.workCaseNumber;
        data["phaseMilestoneId"] = this.phaseMilestoneId;
        data["documentId"] = this.documentId;
        data["responseReceivedDate"] = this.responseReceivedDate ? this.responseReceivedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPaymentRequestDto {
    id: number;
    ticketHolderId: number;
    customeTicketHolderId: string | undefined;
    requestDate: DateTime;
    requestedAmount: number;
    approvedAmount: number | undefined;
    paymentMethod: string | undefined;
    approvalStatus: PaymentRequestStatus;
    denialReason: string | undefined;
    submissionDate: DateTime | undefined;
    submissionReferenceId: string | undefined;
    workCaseNumber: string | undefined;
    phaseMilestoneId: string | undefined;
    documentId: number;
    responseReceivedDate: DateTime | undefined;
    notes: string | undefined;
}

export class PaymentRequestInfoDto implements IPaymentRequestInfoDto {
    totalPaymentRequest!: number;
    totalNewPaymentRequest!: number;
    totalExpectedAmount!: number;
    totalTicketHolder!: number;
    totalPhase1!: number;
    totalPhase2!: number;
    totalPhase3!: number;

    constructor(data?: IPaymentRequestInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPaymentRequest = _data["totalPaymentRequest"];
            this.totalNewPaymentRequest = _data["totalNewPaymentRequest"];
            this.totalExpectedAmount = _data["totalExpectedAmount"];
            this.totalTicketHolder = _data["totalTicketHolder"];
            this.totalPhase1 = _data["totalPhase1"];
            this.totalPhase2 = _data["totalPhase2"];
            this.totalPhase3 = _data["totalPhase3"];
        }
    }

    static fromJS(data: any): PaymentRequestInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPaymentRequest"] = this.totalPaymentRequest;
        data["totalNewPaymentRequest"] = this.totalNewPaymentRequest;
        data["totalExpectedAmount"] = this.totalExpectedAmount;
        data["totalTicketHolder"] = this.totalTicketHolder;
        data["totalPhase1"] = this.totalPhase1;
        data["totalPhase2"] = this.totalPhase2;
        data["totalPhase3"] = this.totalPhase3;
        return data;
    }
}

export interface IPaymentRequestInfoDto {
    totalPaymentRequest: number;
    totalNewPaymentRequest: number;
    totalExpectedAmount: number;
    totalTicketHolder: number;
    totalPhase1: number;
    totalPhase2: number;
    totalPhase3: number;
}

export enum PaymentRequestStatus {
    Pending = 1,
    SentToSSA = 2,
    Approved = 3,
    Denied = 4,
}

export class PaymentRequestStatusDto implements IPaymentRequestStatusDto {
    id!: number;
    ticketHolderId!: number;
    customeTicketHolderId!: string | undefined;
    ticketHolderName!: string | undefined;
    requestDate!: DateTime;
    approvalStatus!: PaymentRequestStatus;
    readonly enumDisplayApprovalStatus!: string | undefined;
    requestedAmount!: number;

    constructor(data?: IPaymentRequestStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.customeTicketHolderId = _data["customeTicketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.requestDate = _data["requestDate"] ? DateTime.fromISO(_data["requestDate"].toString()) : <any>undefined;
            this.approvalStatus = _data["approvalStatus"];
            (<any>this).enumDisplayApprovalStatus = _data["enumDisplayApprovalStatus"];
            this.requestedAmount = _data["requestedAmount"];
        }
    }

    static fromJS(data: any): PaymentRequestStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["customeTicketHolderId"] = this.customeTicketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["requestDate"] = this.requestDate ? this.requestDate.toString() : <any>undefined;
        data["approvalStatus"] = this.approvalStatus;
        data["enumDisplayApprovalStatus"] = this.enumDisplayApprovalStatus;
        data["requestedAmount"] = this.requestedAmount;
        return data;
    }
}

export interface IPaymentRequestStatusDto {
    id: number;
    ticketHolderId: number;
    customeTicketHolderId: string | undefined;
    ticketHolderName: string | undefined;
    requestDate: DateTime;
    approvalStatus: PaymentRequestStatus;
    enumDisplayApprovalStatus: string | undefined;
    requestedAmount: number;
}

export class PaystubFaxContactInfoDto implements IPaystubFaxContactInfoDto {
    senderFaxInfo!: SenderFaxInfo;
    receiverFaxInfo!: ReceiverInfo;

    constructor(data?: IPaystubFaxContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderFaxInfo = _data["senderFaxInfo"] ? SenderFaxInfo.fromJS(_data["senderFaxInfo"]) : <any>undefined;
            this.receiverFaxInfo = _data["receiverFaxInfo"] ? ReceiverInfo.fromJS(_data["receiverFaxInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaystubFaxContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaystubFaxContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderFaxInfo"] = this.senderFaxInfo ? this.senderFaxInfo.toJSON() : <any>undefined;
        data["receiverFaxInfo"] = this.receiverFaxInfo ? this.receiverFaxInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaystubFaxContactInfoDto {
    senderFaxInfo: SenderFaxInfo;
    receiverFaxInfo: ReceiverInfo;
}

export class PaystubUploadLinkInfoDto implements IPaystubUploadLinkInfoDto {
    id!: number;
    uploadUrl!: string | undefined;
    passcode!: string | undefined;
    status!: PaystubUploadLinkStatus;
    failedAttemptCount!: number;
    lastAttemptAt!: DateTime | undefined;
    lastAttemptIp!: string | undefined;
    lastAttemptUserAgent!: string | undefined;
    lastSuccessAt!: DateTime | undefined;
    lastSuccessIp!: string | undefined;
    lastSuccessUserAgent!: string | undefined;
    uploadCount!: number;
    creationTime!: DateTime;
    emailSentAt!: DateTime | undefined;
    emailSentToAddress!: string | undefined;
    smsSentAt!: DateTime | undefined;
    smsSentToNumber!: string | undefined;
    ticketHolderEmail!: string | undefined;
    ticketHolderPhoneNumber!: string | undefined;
    revokedAt!: DateTime | undefined;

    constructor(data?: IPaystubUploadLinkInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uploadUrl = _data["uploadUrl"];
            this.passcode = _data["passcode"];
            this.status = _data["status"];
            this.failedAttemptCount = _data["failedAttemptCount"];
            this.lastAttemptAt = _data["lastAttemptAt"] ? DateTime.fromISO(_data["lastAttemptAt"].toString()) : <any>undefined;
            this.lastAttemptIp = _data["lastAttemptIp"];
            this.lastAttemptUserAgent = _data["lastAttemptUserAgent"];
            this.lastSuccessAt = _data["lastSuccessAt"] ? DateTime.fromISO(_data["lastSuccessAt"].toString()) : <any>undefined;
            this.lastSuccessIp = _data["lastSuccessIp"];
            this.lastSuccessUserAgent = _data["lastSuccessUserAgent"];
            this.uploadCount = _data["uploadCount"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.emailSentAt = _data["emailSentAt"] ? DateTime.fromISO(_data["emailSentAt"].toString()) : <any>undefined;
            this.emailSentToAddress = _data["emailSentToAddress"];
            this.smsSentAt = _data["smsSentAt"] ? DateTime.fromISO(_data["smsSentAt"].toString()) : <any>undefined;
            this.smsSentToNumber = _data["smsSentToNumber"];
            this.ticketHolderEmail = _data["ticketHolderEmail"];
            this.ticketHolderPhoneNumber = _data["ticketHolderPhoneNumber"];
            this.revokedAt = _data["revokedAt"] ? DateTime.fromISO(_data["revokedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaystubUploadLinkInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaystubUploadLinkInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uploadUrl"] = this.uploadUrl;
        data["passcode"] = this.passcode;
        data["status"] = this.status;
        data["failedAttemptCount"] = this.failedAttemptCount;
        data["lastAttemptAt"] = this.lastAttemptAt ? this.lastAttemptAt.toString() : <any>undefined;
        data["lastAttemptIp"] = this.lastAttemptIp;
        data["lastAttemptUserAgent"] = this.lastAttemptUserAgent;
        data["lastSuccessAt"] = this.lastSuccessAt ? this.lastSuccessAt.toString() : <any>undefined;
        data["lastSuccessIp"] = this.lastSuccessIp;
        data["lastSuccessUserAgent"] = this.lastSuccessUserAgent;
        data["uploadCount"] = this.uploadCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["emailSentAt"] = this.emailSentAt ? this.emailSentAt.toString() : <any>undefined;
        data["emailSentToAddress"] = this.emailSentToAddress;
        data["smsSentAt"] = this.smsSentAt ? this.smsSentAt.toString() : <any>undefined;
        data["smsSentToNumber"] = this.smsSentToNumber;
        data["ticketHolderEmail"] = this.ticketHolderEmail;
        data["ticketHolderPhoneNumber"] = this.ticketHolderPhoneNumber;
        data["revokedAt"] = this.revokedAt ? this.revokedAt.toString() : <any>undefined;
        return data;
    }
}

export interface IPaystubUploadLinkInfoDto {
    id: number;
    uploadUrl: string | undefined;
    passcode: string | undefined;
    status: PaystubUploadLinkStatus;
    failedAttemptCount: number;
    lastAttemptAt: DateTime | undefined;
    lastAttemptIp: string | undefined;
    lastAttemptUserAgent: string | undefined;
    lastSuccessAt: DateTime | undefined;
    lastSuccessIp: string | undefined;
    lastSuccessUserAgent: string | undefined;
    uploadCount: number;
    creationTime: DateTime;
    emailSentAt: DateTime | undefined;
    emailSentToAddress: string | undefined;
    smsSentAt: DateTime | undefined;
    smsSentToNumber: string | undefined;
    ticketHolderEmail: string | undefined;
    ticketHolderPhoneNumber: string | undefined;
    revokedAt: DateTime | undefined;
}

export enum PaystubUploadLinkStatus {
    Active = 1,
    Locked = 2,
    Revoked = 3,
}

export class PaystubUploadLinkStatusDto implements IPaystubUploadLinkStatusDto {
    status!: PaystubUploadLinkStatus;
    ticketHolderFirstName!: string | undefined;

    constructor(data?: IPaystubUploadLinkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.ticketHolderFirstName = _data["ticketHolderFirstName"];
        }
    }

    static fromJS(data: any): PaystubUploadLinkStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaystubUploadLinkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["ticketHolderFirstName"] = this.ticketHolderFirstName;
        return data;
    }
}

export interface IPaystubUploadLinkStatusDto {
    status: PaystubUploadLinkStatus;
    ticketHolderFirstName: string | undefined;
}

export class PaystubUploadResultDto implements IPaystubUploadResultDto {
    success!: boolean;
    uploadedFileNames!: string[] | undefined;

    constructor(data?: IPaystubUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["uploadedFileNames"])) {
                this.uploadedFileNames = [] as any;
                for (let item of _data["uploadedFileNames"])
                    this.uploadedFileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PaystubUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaystubUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.uploadedFileNames)) {
            data["uploadedFileNames"] = [];
            for (let item of this.uploadedFileNames)
                data["uploadedFileNames"].push(item);
        }
        return data;
    }
}

export interface IPaystubUploadResultDto {
    success: boolean;
    uploadedFileNames: string[] | undefined;
}

export class PaystubUploadVerifyResultDto implements IPaystubUploadVerifyResultDto {
    success!: boolean;
    ticketHolderFirstName!: string | undefined;
    ticketHolderFullName!: string | undefined;

    constructor(data?: IPaystubUploadVerifyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.ticketHolderFirstName = _data["ticketHolderFirstName"];
            this.ticketHolderFullName = _data["ticketHolderFullName"];
        }
    }

    static fromJS(data: any): PaystubUploadVerifyResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaystubUploadVerifyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["ticketHolderFirstName"] = this.ticketHolderFirstName;
        data["ticketHolderFullName"] = this.ticketHolderFullName;
        return data;
    }
}

export interface IPaystubUploadVerifyResultDto {
    success: boolean;
    ticketHolderFirstName: string | undefined;
    ticketHolderFullName: string | undefined;
}

export class PdfSigningRecipientDto implements IPdfSigningRecipientDto {
    id!: number;
    name!: string | undefined;
    email!: string | undefined;
    order!: number;
    isSigned!: boolean;
    signedDate!: DateTime | undefined;
    fieldCount!: number;

    constructor(data?: IPdfSigningRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.order = _data["order"];
            this.isSigned = _data["isSigned"];
            this.signedDate = _data["signedDate"] ? DateTime.fromISO(_data["signedDate"].toString()) : <any>undefined;
            this.fieldCount = _data["fieldCount"];
        }
    }

    static fromJS(data: any): PdfSigningRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfSigningRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["order"] = this.order;
        data["isSigned"] = this.isSigned;
        data["signedDate"] = this.signedDate ? this.signedDate.toString() : <any>undefined;
        data["fieldCount"] = this.fieldCount;
        return data;
    }
}

export interface IPdfSigningRecipientDto {
    id: number;
    name: string | undefined;
    email: string | undefined;
    order: number;
    isSigned: boolean;
    signedDate: DateTime | undefined;
    fieldCount: number;
}

export class PdfSigningRequestDto implements IPdfSigningRequestDto {
    id!: number;
    title!: string | undefined;
    fileName!: string | undefined;
    subject!: string | undefined;
    signInOrder!: boolean;
    status!: PdfSigningStatus;
    sentDate!: DateTime;
    completedDate!: DateTime | undefined;
    lastSyncTime!: DateTime | undefined;
    hasSignedDocument!: boolean;
    recipients!: PdfSigningRecipientDto[] | undefined;

    constructor(data?: IPdfSigningRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.fileName = _data["fileName"];
            this.subject = _data["subject"];
            this.signInOrder = _data["signInOrder"];
            this.status = _data["status"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? DateTime.fromISO(_data["completedDate"].toString()) : <any>undefined;
            this.lastSyncTime = _data["lastSyncTime"] ? DateTime.fromISO(_data["lastSyncTime"].toString()) : <any>undefined;
            this.hasSignedDocument = _data["hasSignedDocument"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(PdfSigningRecipientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PdfSigningRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfSigningRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["fileName"] = this.fileName;
        data["subject"] = this.subject;
        data["signInOrder"] = this.signInOrder;
        data["status"] = this.status;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toString() : <any>undefined;
        data["lastSyncTime"] = this.lastSyncTime ? this.lastSyncTime.toString() : <any>undefined;
        data["hasSignedDocument"] = this.hasSignedDocument;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPdfSigningRequestDto {
    id: number;
    title: string | undefined;
    fileName: string | undefined;
    subject: string | undefined;
    signInOrder: boolean;
    status: PdfSigningStatus;
    sentDate: DateTime;
    completedDate: DateTime | undefined;
    lastSyncTime: DateTime | undefined;
    hasSignedDocument: boolean;
    recipients: PdfSigningRecipientDto[] | undefined;
}

export enum PdfSigningStatus {
    Sent = 1,
    PartiallySigned = 2,
    Completed = 3,
    Cancelled = 4,
}

export enum Phase {
    Phase1 = 1,
    Phase2 = 2,
    Outcome = 3,
}

export class PhaseMilestoneDto implements IPhaseMilestoneDto {
    id!: number;
    programType!: ProgramType;
    year!: number;
    phase!: Phase;
    milestone!: number;
    grossEarningsThreshold!: number;
    grossEarningsThresholdForBlind!: number;
    grossEarningsThresholdRule!: string | undefined;
    paymentAmount!: number;
    readonly phaseMilestoneID!: string | undefined;

    constructor(data?: IPhaseMilestoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programType = _data["programType"];
            this.year = _data["year"];
            this.phase = _data["phase"];
            this.milestone = _data["milestone"];
            this.grossEarningsThreshold = _data["grossEarningsThreshold"];
            this.grossEarningsThresholdForBlind = _data["grossEarningsThresholdForBlind"];
            this.grossEarningsThresholdRule = _data["grossEarningsThresholdRule"];
            this.paymentAmount = _data["paymentAmount"];
            (<any>this).phaseMilestoneID = _data["phaseMilestoneID"];
        }
    }

    static fromJS(data: any): PhaseMilestoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhaseMilestoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programType"] = this.programType;
        data["year"] = this.year;
        data["phase"] = this.phase;
        data["milestone"] = this.milestone;
        data["grossEarningsThreshold"] = this.grossEarningsThreshold;
        data["grossEarningsThresholdForBlind"] = this.grossEarningsThresholdForBlind;
        data["grossEarningsThresholdRule"] = this.grossEarningsThresholdRule;
        data["paymentAmount"] = this.paymentAmount;
        data["phaseMilestoneID"] = this.phaseMilestoneID;
        return data;
    }
}

export interface IPhaseMilestoneDto {
    id: number;
    programType: ProgramType;
    year: number;
    phase: Phase;
    milestone: number;
    grossEarningsThreshold: number;
    grossEarningsThresholdForBlind: number;
    grossEarningsThresholdRule: string | undefined;
    paymentAmount: number;
    phaseMilestoneID: string | undefined;
}

export class PhaseMilestoneImportPreviewDto implements IPhaseMilestoneImportPreviewDto {
    year!: number;
    rows!: PhaseMilestoneImportRowDto[] | undefined;

    constructor(data?: IPhaseMilestoneImportPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PhaseMilestoneImportRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhaseMilestoneImportPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhaseMilestoneImportPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhaseMilestoneImportPreviewDto {
    year: number;
    rows: PhaseMilestoneImportRowDto[] | undefined;
}

export class PhaseMilestoneImportRowDto implements IPhaseMilestoneImportRowDto {
    programType!: ProgramType;
    phase!: Phase;
    milestone!: number;
    grossEarningsThresholdRule!: string | undefined;
    grossEarningsThreshold!: number;
    grossEarningsThresholdForBlind!: number;
    paymentAmount!: number;

    constructor(data?: IPhaseMilestoneImportRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programType = _data["programType"];
            this.phase = _data["phase"];
            this.milestone = _data["milestone"];
            this.grossEarningsThresholdRule = _data["grossEarningsThresholdRule"];
            this.grossEarningsThreshold = _data["grossEarningsThreshold"];
            this.grossEarningsThresholdForBlind = _data["grossEarningsThresholdForBlind"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): PhaseMilestoneImportRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhaseMilestoneImportRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programType"] = this.programType;
        data["phase"] = this.phase;
        data["milestone"] = this.milestone;
        data["grossEarningsThresholdRule"] = this.grossEarningsThresholdRule;
        data["grossEarningsThreshold"] = this.grossEarningsThreshold;
        data["grossEarningsThresholdForBlind"] = this.grossEarningsThresholdForBlind;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IPhaseMilestoneImportRowDto {
    programType: ProgramType;
    phase: Phase;
    milestone: number;
    grossEarningsThresholdRule: string | undefined;
    grossEarningsThreshold: number;
    grossEarningsThresholdForBlind: number;
    paymentAmount: number;
}

export enum PhaseMilestoneStage {
    None = 0,
    SSDI_Phase1Milestone1 = 100,
    SSDI_Phase1Milestone2 = 101,
    SSDI_Phase1Milestone3 = 102,
    SSDI_Phase1Milestone4 = 103,
    SSDI_Phase2Milestone1 = 104,
    SSDI_Phase2Milestone2 = 105,
    SSDI_Phase2Milestone3 = 106,
    SSDI_Phase2Milestone4 = 107,
    SSDI_Phase2Milestone5 = 108,
    SSDI_Phase2Milestone6 = 109,
    SSDI_Phase2Milestone7 = 110,
    SSDI_Phase2Milestone8 = 111,
    SSDI_Phase2Milestone9 = 112,
    SSDI_Phase2Milestone10 = 113,
    SSDI_Phase2Milestone11 = 114,
    SSDI_OutcomeMonth1 = 115,
    SSDI_OutcomeMonth2 = 116,
    SSDI_OutcomeMonth3 = 117,
    SSDI_OutcomeMonth4 = 118,
    SSDI_OutcomeMonth5 = 119,
    SSDI_OutcomeMonth6 = 120,
    SSDI_OutcomeMonth7 = 121,
    SSDI_OutcomeMonth8 = 122,
    SSDI_OutcomeMonth9 = 123,
    SSDI_OutcomeMonth10 = 124,
    SSDI_OutcomeMonth11 = 125,
    SSDI_OutcomeMonth12 = 126,
    SSDI_OutcomeMonth13 = 127,
    SSDI_OutcomeMonth14 = 128,
    SSDI_OutcomeMonth15 = 129,
    SSDI_OutcomeMonth16 = 130,
    SSDI_OutcomeMonth17 = 131,
    SSDI_OutcomeMonth18 = 132,
    SSDI_OutcomeMonth19 = 133,
    SSDI_OutcomeMonth20 = 134,
    SSDI_OutcomeMonth21 = 135,
    SSDI_OutcomeMonth22 = 136,
    SSDI_OutcomeMonth23 = 137,
    SSDI_OutcomeMonth24 = 138,
    SSDI_OutcomeMonth25 = 139,
    SSDI_OutcomeMonth26 = 140,
    SSDI_OutcomeMonth27 = 141,
    SSDI_OutcomeMonth28 = 142,
    SSDI_OutcomeMonth29 = 143,
    SSDI_OutcomeMonth30 = 144,
    SSDI_OutcomeMonth31 = 145,
    SSDI_OutcomeMonth32 = 146,
    SSDI_OutcomeMonth33 = 147,
    SSDI_OutcomeMonth34 = 148,
    SSDI_OutcomeMonth35 = 149,
    SSDI_OutcomeMonth36 = 150,
    SSI_Phase1Milestone1 = 300,
    SSI_Phase1Milestone2 = 301,
    SSI_Phase1Milestone3 = 302,
    SSI_Phase1Milestone4 = 303,
    SSI_Phase2Milestone1 = 304,
    SSI_Phase2Milestone2 = 305,
    SSI_Phase2Milestone3 = 306,
    SSI_Phase2Milestone4 = 307,
    SSI_Phase2Milestone5 = 308,
    SSI_Phase2Milestone6 = 309,
    SSI_Phase2Milestone7 = 310,
    SSI_Phase2Milestone8 = 311,
    SSI_Phase2Milestone9 = 312,
    SSI_Phase2Milestone10 = 313,
    SSI_Phase2Milestone11 = 314,
    SSI_Phase2Milestone12 = 315,
    SSI_Phase2Milestone13 = 316,
    SSI_Phase2Milestone14 = 317,
    SSI_Phase2Milestone15 = 318,
    SSI_Phase2Milestone16 = 319,
    SSI_Phase2Milestone17 = 320,
    SSI_Phase2Milestone18 = 321,
    SSI_OutcomeMonth1 = 322,
    SSI_OutcomeMonth2 = 323,
    SSI_OutcomeMonth3 = 324,
    SSI_OutcomeMonth4 = 325,
    SSI_OutcomeMonth5 = 326,
    SSI_OutcomeMonth6 = 327,
    SSI_OutcomeMonth7 = 328,
    SSI_OutcomeMonth8 = 329,
    SSI_OutcomeMonth9 = 330,
    SSI_OutcomeMonth10 = 331,
    SSI_OutcomeMonth11 = 332,
    SSI_OutcomeMonth12 = 333,
    SSI_OutcomeMonth13 = 334,
    SSI_OutcomeMonth14 = 335,
    SSI_OutcomeMonth15 = 336,
    SSI_OutcomeMonth16 = 337,
    SSI_OutcomeMonth17 = 338,
    SSI_OutcomeMonth18 = 339,
    SSI_OutcomeMonth19 = 340,
    SSI_OutcomeMonth20 = 341,
    SSI_OutcomeMonth21 = 342,
    SSI_OutcomeMonth22 = 343,
    SSI_OutcomeMonth23 = 344,
    SSI_OutcomeMonth24 = 345,
    SSI_OutcomeMonth25 = 346,
    SSI_OutcomeMonth26 = 347,
    SSI_OutcomeMonth27 = 348,
    SSI_OutcomeMonth28 = 349,
    SSI_OutcomeMonth29 = 350,
    SSI_OutcomeMonth30 = 351,
    SSI_OutcomeMonth31 = 352,
    SSI_OutcomeMonth32 = 353,
    SSI_OutcomeMonth33 = 354,
    SSI_OutcomeMonth34 = 355,
    SSI_OutcomeMonth35 = 356,
    SSI_OutcomeMonth36 = 357,
    SSI_OutcomeMonth37 = 358,
    SSI_OutcomeMonth38 = 359,
    SSI_OutcomeMonth39 = 360,
    SSI_OutcomeMonth40 = 361,
    SSI_OutcomeMonth41 = 362,
    SSI_OutcomeMonth42 = 363,
    SSI_OutcomeMonth43 = 364,
    SSI_OutcomeMonth44 = 365,
    SSI_OutcomeMonth45 = 366,
    SSI_OutcomeMonth46 = 367,
    SSI_OutcomeMonth47 = 368,
    SSI_OutcomeMonth48 = 369,
    SSI_OutcomeMonth49 = 370,
    SSI_OutcomeMonth50 = 371,
    SSI_OutcomeMonth51 = 372,
    SSI_OutcomeMonth52 = 373,
    SSI_OutcomeMonth53 = 374,
    SSI_OutcomeMonth54 = 375,
    SSI_OutcomeMonth55 = 376,
    SSI_OutcomeMonth56 = 377,
    SSI_OutcomeMonth57 = 378,
    SSI_OutcomeMonth58 = 379,
    SSI_OutcomeMonth59 = 380,
    SSI_OutcomeMonth60 = 381,
}

export class PhoneDto implements IPhoneDto {
    id!: number;
    leadId!: number;
    number!: string | undefined;
    phoneType!: PhoneType;
    isVerified!: boolean;

    constructor(data?: IPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.number = _data["number"];
            this.phoneType = _data["phoneType"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): PhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["number"] = this.number;
        data["phoneType"] = this.phoneType;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface IPhoneDto {
    id: number;
    leadId: number;
    number: string | undefined;
    phoneType: PhoneType;
    isVerified: boolean;
}

export class PhoneLogDetailDto implements IPhoneLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    clientName!: string | undefined;
    clientId!: string | undefined;
    startTime!: DateTime;
    durationInSeconds!: number | undefined;
    fromPhoneNumber!: string | undefined;
    toPhoneNumber!: string | undefined;
    status!: ActivityStatus;
    note!: string | undefined;

    constructor(data?: IPhoneLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.durationInSeconds = _data["durationInSeconds"];
            this.fromPhoneNumber = _data["fromPhoneNumber"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PhoneLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["durationInSeconds"] = this.durationInSeconds;
        data["fromPhoneNumber"] = this.fromPhoneNumber;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }
}

export interface IPhoneLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    clientName: string | undefined;
    clientId: string | undefined;
    startTime: DateTime;
    durationInSeconds: number | undefined;
    fromPhoneNumber: string | undefined;
    toPhoneNumber: string | undefined;
    status: ActivityStatus;
    note: string | undefined;
}

export class PhoneLogDto implements IPhoneLogDto {
    direction!: ActivityDirection;
    leadName!: string;
    leadId!: number;
    toPhoneNumber!: string;
    status!: ActivityStatus;
    serviceType!: ActivityServiceType;
    activityContent!: string | undefined;
    startTime!: DateTime;

    constructor(data?: IPhoneLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.leadName = _data["leadName"];
            this.leadId = _data["leadId"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.activityContent = _data["activityContent"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PhoneLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["leadName"] = this.leadName;
        data["leadId"] = this.leadId;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["activityContent"] = this.activityContent;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        return data;
    }
}

export interface IPhoneLogDto {
    direction: ActivityDirection;
    leadName: string;
    leadId: number;
    toPhoneNumber: string;
    status: ActivityStatus;
    serviceType: ActivityServiceType;
    activityContent: string | undefined;
    startTime: DateTime;
}

export enum PhoneType {
    Unknown = 0,
    Mobile = 1,
    Home = 2,
    Work = 4,
    Fax = 8,
    Other = 16,
}

export class PiiHeldMessageDto implements IPiiHeldMessageDto {
    id!: number;
    piiNumber!: string | undefined;
    channel!: PiiReviewChannel;
    status!: PiiReviewStatus;
    statusName!: string | undefined;
    sendStatus!: PiiSendStatus;
    recipient!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IPiiHeldMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.piiNumber = _data["piiNumber"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.sendStatus = _data["sendStatus"];
            this.recipient = _data["recipient"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PiiHeldMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PiiHeldMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["piiNumber"] = this.piiNumber;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["sendStatus"] = this.sendStatus;
        data["recipient"] = this.recipient;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IPiiHeldMessageDto {
    id: number;
    piiNumber: string | undefined;
    channel: PiiReviewChannel;
    status: PiiReviewStatus;
    statusName: string | undefined;
    sendStatus: PiiSendStatus;
    recipient: string | undefined;
    creationTime: DateTime;
}

export class PiiReviewAttachmentDto implements IPiiReviewAttachmentDto {
    fileName!: string | undefined;
    contentType!: string | undefined;
    size!: number;

    constructor(data?: IPiiReviewAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): PiiReviewAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PiiReviewAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        return data;
    }
}

export interface IPiiReviewAttachmentDto {
    fileName: string | undefined;
    contentType: string | undefined;
    size: number;
}

export enum PiiReviewChannel {
    Email = 1,
    Sms = 2,
}

export class PiiReviewDetailDto implements IPiiReviewDetailDto {
    id!: number;
    piiNumber!: string | undefined;
    channel!: PiiReviewChannel;
    channelName!: string | undefined;
    status!: PiiReviewStatus;
    statusName!: string | undefined;
    recipient!: string | undefined;
    ticketHolderId!: number | undefined;
    ticketHolderName!: string | undefined;
    formattedTicketHolderId!: string | undefined;
    detectedPii!: string | undefined;
    requestedByName!: string | undefined;
    creationTime!: DateTime;
    submittedForReviewTime!: DateTime | undefined;
    reviewedByName!: string | undefined;
    reviewedTime!: DateTime | undefined;
    reviewNotes!: string | undefined;
    sendStatus!: PiiSendStatus;
    sendStatusName!: string | undefined;
    sentTime!: DateTime | undefined;
    sendError!: string | undefined;
    canRetrySend!: boolean;
    subject!: string | undefined;
    body!: string | undefined;
    attachments!: PiiReviewAttachmentDto[] | undefined;

    constructor(data?: IPiiReviewDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.piiNumber = _data["piiNumber"];
            this.channel = _data["channel"];
            this.channelName = _data["channelName"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.recipient = _data["recipient"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.detectedPii = _data["detectedPii"];
            this.requestedByName = _data["requestedByName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.submittedForReviewTime = _data["submittedForReviewTime"] ? DateTime.fromISO(_data["submittedForReviewTime"].toString()) : <any>undefined;
            this.reviewedByName = _data["reviewedByName"];
            this.reviewedTime = _data["reviewedTime"] ? DateTime.fromISO(_data["reviewedTime"].toString()) : <any>undefined;
            this.reviewNotes = _data["reviewNotes"];
            this.sendStatus = _data["sendStatus"];
            this.sendStatusName = _data["sendStatusName"];
            this.sentTime = _data["sentTime"] ? DateTime.fromISO(_data["sentTime"].toString()) : <any>undefined;
            this.sendError = _data["sendError"];
            this.canRetrySend = _data["canRetrySend"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(PiiReviewAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PiiReviewDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PiiReviewDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["piiNumber"] = this.piiNumber;
        data["channel"] = this.channel;
        data["channelName"] = this.channelName;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["recipient"] = this.recipient;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["detectedPii"] = this.detectedPii;
        data["requestedByName"] = this.requestedByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["submittedForReviewTime"] = this.submittedForReviewTime ? this.submittedForReviewTime.toString() : <any>undefined;
        data["reviewedByName"] = this.reviewedByName;
        data["reviewedTime"] = this.reviewedTime ? this.reviewedTime.toString() : <any>undefined;
        data["reviewNotes"] = this.reviewNotes;
        data["sendStatus"] = this.sendStatus;
        data["sendStatusName"] = this.sendStatusName;
        data["sentTime"] = this.sentTime ? this.sentTime.toString() : <any>undefined;
        data["sendError"] = this.sendError;
        data["canRetrySend"] = this.canRetrySend;
        data["subject"] = this.subject;
        data["body"] = this.body;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPiiReviewDetailDto {
    id: number;
    piiNumber: string | undefined;
    channel: PiiReviewChannel;
    channelName: string | undefined;
    status: PiiReviewStatus;
    statusName: string | undefined;
    recipient: string | undefined;
    ticketHolderId: number | undefined;
    ticketHolderName: string | undefined;
    formattedTicketHolderId: string | undefined;
    detectedPii: string | undefined;
    requestedByName: string | undefined;
    creationTime: DateTime;
    submittedForReviewTime: DateTime | undefined;
    reviewedByName: string | undefined;
    reviewedTime: DateTime | undefined;
    reviewNotes: string | undefined;
    sendStatus: PiiSendStatus;
    sendStatusName: string | undefined;
    sentTime: DateTime | undefined;
    sendError: string | undefined;
    canRetrySend: boolean;
    subject: string | undefined;
    body: string | undefined;
    attachments: PiiReviewAttachmentDto[] | undefined;
}

export class PiiReviewQueueItemDto implements IPiiReviewQueueItemDto {
    id!: number;
    piiNumber!: string | undefined;
    channel!: PiiReviewChannel;
    channelName!: string | undefined;
    status!: PiiReviewStatus;
    statusName!: string | undefined;
    recipient!: string | undefined;
    ticketHolderId!: number | undefined;
    ticketHolderName!: string | undefined;
    formattedTicketHolderId!: string | undefined;
    detectedPii!: string | undefined;
    requestedByName!: string | undefined;
    creationTime!: DateTime;
    submittedForReviewTime!: DateTime | undefined;
    reviewedByName!: string | undefined;
    reviewedTime!: DateTime | undefined;
    reviewNotes!: string | undefined;
    sendStatus!: PiiSendStatus;
    sendStatusName!: string | undefined;
    sentTime!: DateTime | undefined;
    sendError!: string | undefined;
    canRetrySend!: boolean;

    constructor(data?: IPiiReviewQueueItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.piiNumber = _data["piiNumber"];
            this.channel = _data["channel"];
            this.channelName = _data["channelName"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.recipient = _data["recipient"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.detectedPii = _data["detectedPii"];
            this.requestedByName = _data["requestedByName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.submittedForReviewTime = _data["submittedForReviewTime"] ? DateTime.fromISO(_data["submittedForReviewTime"].toString()) : <any>undefined;
            this.reviewedByName = _data["reviewedByName"];
            this.reviewedTime = _data["reviewedTime"] ? DateTime.fromISO(_data["reviewedTime"].toString()) : <any>undefined;
            this.reviewNotes = _data["reviewNotes"];
            this.sendStatus = _data["sendStatus"];
            this.sendStatusName = _data["sendStatusName"];
            this.sentTime = _data["sentTime"] ? DateTime.fromISO(_data["sentTime"].toString()) : <any>undefined;
            this.sendError = _data["sendError"];
            this.canRetrySend = _data["canRetrySend"];
        }
    }

    static fromJS(data: any): PiiReviewQueueItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PiiReviewQueueItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["piiNumber"] = this.piiNumber;
        data["channel"] = this.channel;
        data["channelName"] = this.channelName;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["recipient"] = this.recipient;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["detectedPii"] = this.detectedPii;
        data["requestedByName"] = this.requestedByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["submittedForReviewTime"] = this.submittedForReviewTime ? this.submittedForReviewTime.toString() : <any>undefined;
        data["reviewedByName"] = this.reviewedByName;
        data["reviewedTime"] = this.reviewedTime ? this.reviewedTime.toString() : <any>undefined;
        data["reviewNotes"] = this.reviewNotes;
        data["sendStatus"] = this.sendStatus;
        data["sendStatusName"] = this.sendStatusName;
        data["sentTime"] = this.sentTime ? this.sentTime.toString() : <any>undefined;
        data["sendError"] = this.sendError;
        data["canRetrySend"] = this.canRetrySend;
        return data;
    }
}

export interface IPiiReviewQueueItemDto {
    id: number;
    piiNumber: string | undefined;
    channel: PiiReviewChannel;
    channelName: string | undefined;
    status: PiiReviewStatus;
    statusName: string | undefined;
    recipient: string | undefined;
    ticketHolderId: number | undefined;
    ticketHolderName: string | undefined;
    formattedTicketHolderId: string | undefined;
    detectedPii: string | undefined;
    requestedByName: string | undefined;
    creationTime: DateTime;
    submittedForReviewTime: DateTime | undefined;
    reviewedByName: string | undefined;
    reviewedTime: DateTime | undefined;
    reviewNotes: string | undefined;
    sendStatus: PiiSendStatus;
    sendStatusName: string | undefined;
    sentTime: DateTime | undefined;
    sendError: string | undefined;
    canRetrySend: boolean;
}

export enum PiiReviewStatus {
    Blocked = 0,
    PendingReview = 1,
    Approved = 2,
    Rejected = 3,
}

export enum PiiSendStatus {
    NotSent = 0,
    Sent = 1,
    Failed = 2,
    NotAutoSendable = 3,
    Sending = 4,
}

export class PiiSubmitResultDto implements IPiiSubmitResultDto {
    id!: number;
    piiNumber!: string | undefined;

    constructor(data?: IPiiSubmitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.piiNumber = _data["piiNumber"];
        }
    }

    static fromJS(data: any): PiiSubmitResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PiiSubmitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["piiNumber"] = this.piiNumber;
        return data;
    }
}

export interface IPiiSubmitResultDto {
    id: number;
    piiNumber: string | undefined;
}

export class PortalBillQueueResponseDto implements IPortalBillQueueResponseDto {
    id!: number;
    ticketHolderId!: string | undefined;
    ticketHolderName!: string | undefined;
    encryptedSSN!: string | undefined;
    maskedSSN!: string | undefined;
    workingPhaseMilestone!: string | undefined;
    lastWageReceived!: DateTime | undefined;
    lastPayDate!: DateTime | undefined;
    targetWageMonth!: number;
    targetWageYear!: number;
    status!: PortalBillQueueStatus;
    enumStatusDisplay!: string | undefined;
    portalCheckResult!: PortalBillVerificationResult;
    enumPortalCheckResult!: string | undefined;
    queueCreateDate!: DateTime;

    constructor(data?: IPortalBillQueueResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.workingPhaseMilestone = _data["workingPhaseMilestone"];
            this.lastWageReceived = _data["lastWageReceived"] ? DateTime.fromISO(_data["lastWageReceived"].toString()) : <any>undefined;
            this.lastPayDate = _data["lastPayDate"] ? DateTime.fromISO(_data["lastPayDate"].toString()) : <any>undefined;
            this.targetWageMonth = _data["targetWageMonth"];
            this.targetWageYear = _data["targetWageYear"];
            this.status = _data["status"];
            this.enumStatusDisplay = _data["enumStatusDisplay"];
            this.portalCheckResult = _data["portalCheckResult"];
            this.enumPortalCheckResult = _data["enumPortalCheckResult"];
            this.queueCreateDate = _data["queueCreateDate"] ? DateTime.fromISO(_data["queueCreateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PortalBillQueueResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalBillQueueResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["encryptedSSN"] = this.encryptedSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["workingPhaseMilestone"] = this.workingPhaseMilestone;
        data["lastWageReceived"] = this.lastWageReceived ? this.lastWageReceived.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastPayDate"] = this.lastPayDate ? this.lastPayDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["targetWageMonth"] = this.targetWageMonth;
        data["targetWageYear"] = this.targetWageYear;
        data["status"] = this.status;
        data["enumStatusDisplay"] = this.enumStatusDisplay;
        data["portalCheckResult"] = this.portalCheckResult;
        data["enumPortalCheckResult"] = this.enumPortalCheckResult;
        data["queueCreateDate"] = this.queueCreateDate ? this.queueCreateDate.toString() : <any>undefined;
        return data;
    }
}

export interface IPortalBillQueueResponseDto {
    id: number;
    ticketHolderId: string | undefined;
    ticketHolderName: string | undefined;
    encryptedSSN: string | undefined;
    maskedSSN: string | undefined;
    workingPhaseMilestone: string | undefined;
    lastWageReceived: DateTime | undefined;
    lastPayDate: DateTime | undefined;
    targetWageMonth: number;
    targetWageYear: number;
    status: PortalBillQueueStatus;
    enumStatusDisplay: string | undefined;
    portalCheckResult: PortalBillVerificationResult;
    enumPortalCheckResult: string | undefined;
    queueCreateDate: DateTime;
}

export enum PortalBillQueueStatus {
    New = 1,
    Recycled = 2,
    EligibleForBilling = 3,
}

export enum PortalBillVerificationResult {
    New = 0,
    SubmittedToSSA = 1,
    NoPORAvailable = 3,
}

export class PredefinedFieldResponseDto implements IPredefinedFieldResponseDto {
    fieldType!: PredefinedFieldType;
    displayName!: string | undefined;
    type!: string | undefined;
    color!: string | undefined;

    constructor(data?: IPredefinedFieldResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldType = _data["fieldType"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): PredefinedFieldResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedFieldResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["color"] = this.color;
        return data;
    }
}

export interface IPredefinedFieldResponseDto {
    fieldType: PredefinedFieldType;
    displayName: string | undefined;
    type: string | undefined;
    color: string | undefined;
}

export enum PredefinedFieldType {
    TicketHolderSignature = 1,
    TicketHolderFullName = 2,
    TicketHolderCreationDate = 3,
    CareerCoachCreationDate = 4,
    CareerCoachSignature = 5,
    CareerCoachFullName = 6,
    TicketHolderAddress = 7,
}

export enum PreferredContactMethod {
    Telephone = 1,
    Email = 2,
    InPerson = 3,
    VideoConferencing = 4,
    ViaInterpreter = 5,
    Other = 6,
}

export enum PreferredDemoTime {
    NotSpecified = 0,
    Morning_9_10 = 1,
    MidMorning_10_11 = 2,
    LateMorning_11_12 = 3,
    EarlyAfternoon_12_1 = 4,
    Afternoon_1_2 = 5,
    MidAfternoon_2_3 = 6,
    LateAfternoon_3_4 = 7,
    EarlyEvening_4_5 = 8,
    Evening_5_6 = 9,
}

export class PrepareFaxDto implements IPrepareFaxDto {
    senderCompany!: string | undefined;
    senderPhone!: string | undefined;
    senderFax!: string | undefined;
    senderEmail!: string | undefined;
    recipientOfficeName!: string | undefined;
    recipientFax!: string | undefined;
    recipientPhone!: string | undefined;
    recipientAttention!: string | undefined;

    constructor(data?: IPrepareFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderCompany = _data["senderCompany"];
            this.senderPhone = _data["senderPhone"];
            this.senderFax = _data["senderFax"];
            this.senderEmail = _data["senderEmail"];
            this.recipientOfficeName = _data["recipientOfficeName"];
            this.recipientFax = _data["recipientFax"];
            this.recipientPhone = _data["recipientPhone"];
            this.recipientAttention = _data["recipientAttention"];
        }
    }

    static fromJS(data: any): PrepareFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrepareFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderCompany"] = this.senderCompany;
        data["senderPhone"] = this.senderPhone;
        data["senderFax"] = this.senderFax;
        data["senderEmail"] = this.senderEmail;
        data["recipientOfficeName"] = this.recipientOfficeName;
        data["recipientFax"] = this.recipientFax;
        data["recipientPhone"] = this.recipientPhone;
        data["recipientAttention"] = this.recipientAttention;
        return data;
    }
}

export interface IPrepareFaxDto {
    senderCompany: string | undefined;
    senderPhone: string | undefined;
    senderFax: string | undefined;
    senderEmail: string | undefined;
    recipientOfficeName: string | undefined;
    recipientFax: string | undefined;
    recipientPhone: string | undefined;
    recipientAttention: string | undefined;
}

export class PrintMailSummaryDto implements IPrintMailSummaryDto {
    totalRequested!: number;
    successfulPrintCount!: number;
    failedPrintCount!: number;
    timeSpentInSeconds!: number;

    constructor(data?: IPrintMailSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRequested = _data["totalRequested"];
            this.successfulPrintCount = _data["successfulPrintCount"];
            this.failedPrintCount = _data["failedPrintCount"];
            this.timeSpentInSeconds = _data["timeSpentInSeconds"];
        }
    }

    static fromJS(data: any): PrintMailSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMailSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRequested"] = this.totalRequested;
        data["successfulPrintCount"] = this.successfulPrintCount;
        data["failedPrintCount"] = this.failedPrintCount;
        data["timeSpentInSeconds"] = this.timeSpentInSeconds;
        return data;
    }
}

export interface IPrintMailSummaryDto {
    totalRequested: number;
    successfulPrintCount: number;
    failedPrintCount: number;
    timeSpentInSeconds: number;
}

export class ProfileDto implements IProfileDto {
    leadId!: number;
    firstName!: string;
    lastName!: string | undefined;
    middleName!: string | undefined;
    doB!: DateTime | undefined;
    leadStage!: LeadStage;
    enumLeadStageValue!: string | undefined;
    status!: ActivityStatus;
    enumStatusValue!: string | undefined;
    assigneeName!: string | undefined;
    assigneeId!: number | undefined;
    spokenLanguages!: SpokenLanguageDto[] | undefined;
    maskedSSN!: string | undefined;
    rawSSN!: string | undefined;
    encryptedSSN!: string | undefined;
    isFelony!: boolean | undefined;
    disabilities!: DisabilityDto[] | undefined;

    constructor(data?: IProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.leadStage = _data["leadStage"];
            this.enumLeadStageValue = _data["enumLeadStageValue"];
            this.status = _data["status"];
            this.enumStatusValue = _data["enumStatusValue"];
            this.assigneeName = _data["assigneeName"];
            this.assigneeId = _data["assigneeId"];
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
            this.maskedSSN = _data["maskedSSN"];
            this.rawSSN = _data["rawSSN"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.isFelony = _data["isFelony"];
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(DisabilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["leadStage"] = this.leadStage;
        data["enumLeadStageValue"] = this.enumLeadStageValue;
        data["status"] = this.status;
        data["enumStatusValue"] = this.enumStatusValue;
        data["assigneeName"] = this.assigneeName;
        data["assigneeId"] = this.assigneeId;
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        data["maskedSSN"] = this.maskedSSN;
        data["rawSSN"] = this.rawSSN;
        data["encryptedSSN"] = this.encryptedSSN;
        data["isFelony"] = this.isFelony;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfileDto {
    leadId: number;
    firstName: string;
    lastName: string | undefined;
    middleName: string | undefined;
    doB: DateTime | undefined;
    leadStage: LeadStage;
    enumLeadStageValue: string | undefined;
    status: ActivityStatus;
    enumStatusValue: string | undefined;
    assigneeName: string | undefined;
    assigneeId: number | undefined;
    spokenLanguages: SpokenLanguageDto[] | undefined;
    maskedSSN: string | undefined;
    rawSSN: string | undefined;
    encryptedSSN: string | undefined;
    isFelony: boolean | undefined;
    disabilities: DisabilityDto[] | undefined;
}

export class ProgramIntegrityAuditPackageInput implements IProgramIntegrityAuditPackageInput {
    ticketHolderIds!: number[] | undefined;
    fromDate!: DateTime;
    toDate!: DateTime;
    includeReviewNotes!: boolean;

    constructor(data?: IProgramIntegrityAuditPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ticketHolderIds"])) {
                this.ticketHolderIds = [] as any;
                for (let item of _data["ticketHolderIds"])
                    this.ticketHolderIds!.push(item);
            }
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : <any>undefined;
            this.includeReviewNotes = _data["includeReviewNotes"];
        }
    }

    static fromJS(data: any): ProgramIntegrityAuditPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramIntegrityAuditPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ticketHolderIds)) {
            data["ticketHolderIds"] = [];
            for (let item of this.ticketHolderIds)
                data["ticketHolderIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toString() : <any>undefined;
        data["includeReviewNotes"] = this.includeReviewNotes;
        return data;
    }
}

export interface IProgramIntegrityAuditPackageInput {
    ticketHolderIds: number[] | undefined;
    fromDate: DateTime;
    toDate: DateTime;
    includeReviewNotes: boolean;
}

export enum ProgramType {
    SSDI = 0,
    SSI = 1,
}

export enum PropertyAttributes {
    None = 0,
    SpecialName = 512,
    RTSpecialName = 1024,
    HasDefault = 4096,
    Reserved2 = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 62464,
}

export class PropertyInfo implements IPropertyInfo {
    readonly name!: string | undefined;
    declaringType!: Type;
    reflectedType!: Type;
    module!: Module;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    propertyType!: Type;
    attributes!: PropertyAttributes;
    readonly isSpecialName!: boolean;
    readonly canRead!: boolean;
    readonly canWrite!: boolean;
    getMethod!: MethodInfo;
    setMethod!: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : <any>undefined;
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod: MethodInfo;
    setMethod: MethodInfo;
}

export class ProviderUsageDto implements IProviderUsageDto {
    provider!: string | undefined;
    totalTokens!: number;
    totalDurationMs!: number;
    totalCost!: number;
    models!: ModelUsageDto[] | undefined;

    constructor(data?: IProviderUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.totalTokens = _data["totalTokens"];
            this.totalDurationMs = _data["totalDurationMs"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(ModelUsageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["totalTokens"] = this.totalTokens;
        data["totalDurationMs"] = this.totalDurationMs;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProviderUsageDto {
    provider: string | undefined;
    totalTokens: number;
    totalDurationMs: number;
    totalCost: number;
    models: ModelUsageDto[] | undefined;
}

export class PublicBenefitAtIntakeDto implements IPublicBenefitAtIntakeDto {
    category!: BenefitAtIntakeCategory;
    rowType!: BenefitAtIntakeRowType;
    receiving!: boolean;
    comments!: string | undefined;

    constructor(data?: IPublicBenefitAtIntakeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.rowType = _data["rowType"];
            this.receiving = _data["receiving"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): PublicBenefitAtIntakeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicBenefitAtIntakeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["rowType"] = this.rowType;
        data["receiving"] = this.receiving;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IPublicBenefitAtIntakeDto {
    category: BenefitAtIntakeCategory;
    rowType: BenefitAtIntakeRowType;
    receiving: boolean;
    comments: string | undefined;
}

export class PublicDocumentShareInfoDto implements IPublicDocumentShareInfoDto {
    status!: DocumentShareLinkStatus;
    fileName!: string | undefined;
    fileSize!: string | undefined;

    constructor(data?: IPublicDocumentShareInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): PublicDocumentShareInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicDocumentShareInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IPublicDocumentShareInfoDto {
    status: DocumentShareLinkStatus;
    fileName: string | undefined;
    fileSize: string | undefined;
}

export enum PublicEventRegistrationState {
    Open = 0,
    Closed = 1,
    Full = 2,
    NotFound = 3,
}

export class PublicIntakeStateDto implements IPublicIntakeStateDto {
    status!: InvitationStatus;
    needsOtp!: boolean;
    otpSentToEmail!: string | undefined;
    ticketHolderFirstName!: string | undefined;
    ticketHolderName!: string | undefined;
    ticketHolderFormattedId!: string | undefined;
    draft!: PublicIntakeSubmissionDto;

    constructor(data?: IPublicIntakeStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.needsOtp = _data["needsOtp"];
            this.otpSentToEmail = _data["otpSentToEmail"];
            this.ticketHolderFirstName = _data["ticketHolderFirstName"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderFormattedId = _data["ticketHolderFormattedId"];
            this.draft = _data["draft"] ? PublicIntakeSubmissionDto.fromJS(_data["draft"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PublicIntakeStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicIntakeStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["needsOtp"] = this.needsOtp;
        data["otpSentToEmail"] = this.otpSentToEmail;
        data["ticketHolderFirstName"] = this.ticketHolderFirstName;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderFormattedId"] = this.ticketHolderFormattedId;
        data["draft"] = this.draft ? this.draft.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPublicIntakeStateDto {
    status: InvitationStatus;
    needsOtp: boolean;
    otpSentToEmail: string | undefined;
    ticketHolderFirstName: string | undefined;
    ticketHolderName: string | undefined;
    ticketHolderFormattedId: string | undefined;
    draft: PublicIntakeSubmissionDto;
}

export class PublicIntakeSubmissionDto implements IPublicIntakeSubmissionDto {
    medicareClaimNumber!: string | undefined;
    medicaidNumber!: string | undefined;
    age18RedeterminationDone!: boolean | undefined;
    disabledPriorAge26!: boolean | undefined;
    hasABLEAccount!: boolean | undefined;
    primaryDisability!: string | undefined;
    statutoryBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    isVeteran!: boolean | undefined;
    maritalStatus!: MaritalStatus;
    householdMeansTestedBenefitDetail!: string | undefined;
    ssiIncomeInKindDetail!: string | undefined;
    hasMySSAAccount!: MySSAAccountStatus;
    bsaDeliveryMethod!: PreferredContactMethod;
    bsaDeliveryMethodOther!: string | undefined;
    highestGradeCompleted!: HighestGradeCompleted;
    educationalGoals!: string | undefined;
    wantsEliminateBenefits!: boolean | undefined;
    wantsReduceBenefitDependence!: boolean | undefined;
    neededEmploymentServices!: string | undefined;
    consentToShareBSA!: boolean | undefined;
    consentToShareBSADate!: DateTime | undefined;
    consentToShareBSAWith!: string | undefined;
    irweOrBWEExpenses!: string | undefined;
    currentEmployment!: CurrentEmploymentDto;
    householdMembers!: HouseholdMemberDto[] | undefined;
    contactInfos!: ContactInfoDto[] | undefined;
    earningsGoals!: EarningsGoalDto[] | undefined;
    employmentServices!: EmploymentServiceDto[] | undefined;
    pastEmployments!: PastEmploymentDto[] | undefined;
    benefitsAtIntake!: PublicBenefitAtIntakeDto[] | undefined;
    additionalBenefits!: AdditionalBenefitDto[] | undefined;

    constructor(data?: IPublicIntakeSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicareClaimNumber = _data["medicareClaimNumber"];
            this.medicaidNumber = _data["medicaidNumber"];
            this.age18RedeterminationDone = _data["age18RedeterminationDone"];
            this.disabledPriorAge26 = _data["disabledPriorAge26"];
            this.hasABLEAccount = _data["hasABLEAccount"];
            this.primaryDisability = _data["primaryDisability"];
            this.statutoryBlind = _data["statutoryBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.isVeteran = _data["isVeteran"];
            this.maritalStatus = _data["maritalStatus"];
            this.householdMeansTestedBenefitDetail = _data["householdMeansTestedBenefitDetail"];
            this.ssiIncomeInKindDetail = _data["ssiIncomeInKindDetail"];
            this.hasMySSAAccount = _data["hasMySSAAccount"];
            this.bsaDeliveryMethod = _data["bsaDeliveryMethod"];
            this.bsaDeliveryMethodOther = _data["bsaDeliveryMethodOther"];
            this.highestGradeCompleted = _data["highestGradeCompleted"];
            this.educationalGoals = _data["educationalGoals"];
            this.wantsEliminateBenefits = _data["wantsEliminateBenefits"];
            this.wantsReduceBenefitDependence = _data["wantsReduceBenefitDependence"];
            this.neededEmploymentServices = _data["neededEmploymentServices"];
            this.consentToShareBSA = _data["consentToShareBSA"];
            this.consentToShareBSADate = _data["consentToShareBSADate"] ? DateTime.fromISO(_data["consentToShareBSADate"].toString()) : <any>undefined;
            this.consentToShareBSAWith = _data["consentToShareBSAWith"];
            this.irweOrBWEExpenses = _data["irweOrBWEExpenses"];
            this.currentEmployment = _data["currentEmployment"] ? CurrentEmploymentDto.fromJS(_data["currentEmployment"]) : <any>undefined;
            if (Array.isArray(_data["householdMembers"])) {
                this.householdMembers = [] as any;
                for (let item of _data["householdMembers"])
                    this.householdMembers!.push(HouseholdMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["contactInfos"])) {
                this.contactInfos = [] as any;
                for (let item of _data["contactInfos"])
                    this.contactInfos!.push(ContactInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["earningsGoals"])) {
                this.earningsGoals = [] as any;
                for (let item of _data["earningsGoals"])
                    this.earningsGoals!.push(EarningsGoalDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentServices"])) {
                this.employmentServices = [] as any;
                for (let item of _data["employmentServices"])
                    this.employmentServices!.push(EmploymentServiceDto.fromJS(item));
            }
            if (Array.isArray(_data["pastEmployments"])) {
                this.pastEmployments = [] as any;
                for (let item of _data["pastEmployments"])
                    this.pastEmployments!.push(PastEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["benefitsAtIntake"])) {
                this.benefitsAtIntake = [] as any;
                for (let item of _data["benefitsAtIntake"])
                    this.benefitsAtIntake!.push(PublicBenefitAtIntakeDto.fromJS(item));
            }
            if (Array.isArray(_data["additionalBenefits"])) {
                this.additionalBenefits = [] as any;
                for (let item of _data["additionalBenefits"])
                    this.additionalBenefits!.push(AdditionalBenefitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicIntakeSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicIntakeSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicareClaimNumber"] = this.medicareClaimNumber;
        data["medicaidNumber"] = this.medicaidNumber;
        data["age18RedeterminationDone"] = this.age18RedeterminationDone;
        data["disabledPriorAge26"] = this.disabledPriorAge26;
        data["hasABLEAccount"] = this.hasABLEAccount;
        data["primaryDisability"] = this.primaryDisability;
        data["statutoryBlind"] = this.statutoryBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toString() : <any>undefined;
        data["isVeteran"] = this.isVeteran;
        data["maritalStatus"] = this.maritalStatus;
        data["householdMeansTestedBenefitDetail"] = this.householdMeansTestedBenefitDetail;
        data["ssiIncomeInKindDetail"] = this.ssiIncomeInKindDetail;
        data["hasMySSAAccount"] = this.hasMySSAAccount;
        data["bsaDeliveryMethod"] = this.bsaDeliveryMethod;
        data["bsaDeliveryMethodOther"] = this.bsaDeliveryMethodOther;
        data["highestGradeCompleted"] = this.highestGradeCompleted;
        data["educationalGoals"] = this.educationalGoals;
        data["wantsEliminateBenefits"] = this.wantsEliminateBenefits;
        data["wantsReduceBenefitDependence"] = this.wantsReduceBenefitDependence;
        data["neededEmploymentServices"] = this.neededEmploymentServices;
        data["consentToShareBSA"] = this.consentToShareBSA;
        data["consentToShareBSADate"] = this.consentToShareBSADate ? this.consentToShareBSADate.toString() : <any>undefined;
        data["consentToShareBSAWith"] = this.consentToShareBSAWith;
        data["irweOrBWEExpenses"] = this.irweOrBWEExpenses;
        data["currentEmployment"] = this.currentEmployment ? this.currentEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.householdMembers)) {
            data["householdMembers"] = [];
            for (let item of this.householdMembers)
                data["householdMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.contactInfos)) {
            data["contactInfos"] = [];
            for (let item of this.contactInfos)
                data["contactInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.earningsGoals)) {
            data["earningsGoals"] = [];
            for (let item of this.earningsGoals)
                data["earningsGoals"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentServices)) {
            data["employmentServices"] = [];
            for (let item of this.employmentServices)
                data["employmentServices"].push(item.toJSON());
        }
        if (Array.isArray(this.pastEmployments)) {
            data["pastEmployments"] = [];
            for (let item of this.pastEmployments)
                data["pastEmployments"].push(item.toJSON());
        }
        if (Array.isArray(this.benefitsAtIntake)) {
            data["benefitsAtIntake"] = [];
            for (let item of this.benefitsAtIntake)
                data["benefitsAtIntake"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalBenefits)) {
            data["additionalBenefits"] = [];
            for (let item of this.additionalBenefits)
                data["additionalBenefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPublicIntakeSubmissionDto {
    medicareClaimNumber: string | undefined;
    medicaidNumber: string | undefined;
    age18RedeterminationDone: boolean | undefined;
    disabledPriorAge26: boolean | undefined;
    hasABLEAccount: boolean | undefined;
    primaryDisability: string | undefined;
    statutoryBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    isVeteran: boolean | undefined;
    maritalStatus: MaritalStatus;
    householdMeansTestedBenefitDetail: string | undefined;
    ssiIncomeInKindDetail: string | undefined;
    hasMySSAAccount: MySSAAccountStatus;
    bsaDeliveryMethod: PreferredContactMethod;
    bsaDeliveryMethodOther: string | undefined;
    highestGradeCompleted: HighestGradeCompleted;
    educationalGoals: string | undefined;
    wantsEliminateBenefits: boolean | undefined;
    wantsReduceBenefitDependence: boolean | undefined;
    neededEmploymentServices: string | undefined;
    consentToShareBSA: boolean | undefined;
    consentToShareBSADate: DateTime | undefined;
    consentToShareBSAWith: string | undefined;
    irweOrBWEExpenses: string | undefined;
    currentEmployment: CurrentEmploymentDto;
    householdMembers: HouseholdMemberDto[] | undefined;
    contactInfos: ContactInfoDto[] | undefined;
    earningsGoals: EarningsGoalDto[] | undefined;
    employmentServices: EmploymentServiceDto[] | undefined;
    pastEmployments: PastEmploymentDto[] | undefined;
    benefitsAtIntake: PublicBenefitAtIntakeDto[] | undefined;
    additionalBenefits: AdditionalBenefitDto[] | undefined;
}

export class PublicLeadApplicationStateDto implements IPublicLeadApplicationStateDto {
    status!: InvitationStatus;
    leadFirstName!: string | undefined;
    hasTicketToWorkRecord!: boolean;
    draft!: LeadApplicationSubmissionDto;

    constructor(data?: IPublicLeadApplicationStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.leadFirstName = _data["leadFirstName"];
            this.hasTicketToWorkRecord = _data["hasTicketToWorkRecord"];
            this.draft = _data["draft"] ? LeadApplicationSubmissionDto.fromJS(_data["draft"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PublicLeadApplicationStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicLeadApplicationStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["leadFirstName"] = this.leadFirstName;
        data["hasTicketToWorkRecord"] = this.hasTicketToWorkRecord;
        data["draft"] = this.draft ? this.draft.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPublicLeadApplicationStateDto {
    status: InvitationStatus;
    leadFirstName: string | undefined;
    hasTicketToWorkRecord: boolean;
    draft: LeadApplicationSubmissionDto;
}

export class PublicMarketingEventDto implements IPublicMarketingEventDto {
    state!: PublicEventRegistrationState;
    name!: string | undefined;
    eventType!: MarketingEventType;
    format!: MarketingEventFormat;
    startDate!: DateTime;
    endDate!: DateTime;
    venue!: string | undefined;
    address!: string | undefined;
    goals!: string | undefined;
    registrationDeadline!: DateTime | undefined;

    constructor(data?: IPublicMarketingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.name = _data["name"];
            this.eventType = _data["eventType"];
            this.format = _data["format"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.goals = _data["goals"];
            this.registrationDeadline = _data["registrationDeadline"] ? DateTime.fromISO(_data["registrationDeadline"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PublicMarketingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicMarketingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["name"] = this.name;
        data["eventType"] = this.eventType;
        data["format"] = this.format;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["goals"] = this.goals;
        data["registrationDeadline"] = this.registrationDeadline ? this.registrationDeadline.toString() : <any>undefined;
        return data;
    }
}

export interface IPublicMarketingEventDto {
    state: PublicEventRegistrationState;
    name: string | undefined;
    eventType: MarketingEventType;
    format: MarketingEventFormat;
    startDate: DateTime;
    endDate: DateTime;
    venue: string | undefined;
    address: string | undefined;
    goals: string | undefined;
    registrationDeadline: DateTime | undefined;
}

export class PublicMarketingEventRegistrationInput implements IPublicMarketingEventRegistrationInput {
    firstName!: string;
    lastName!: string;
    email!: string;
    phone!: string | undefined;
    organizationName!: string | undefined;
    isBeneficiary!: boolean;
    notes!: string | undefined;

    constructor(data?: IPublicMarketingEventRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.organizationName = _data["organizationName"];
            this.isBeneficiary = _data["isBeneficiary"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PublicMarketingEventRegistrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new PublicMarketingEventRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["organizationName"] = this.organizationName;
        data["isBeneficiary"] = this.isBeneficiary;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IPublicMarketingEventRegistrationInput {
    firstName: string;
    lastName: string;
    email: string;
    phone: string | undefined;
    organizationName: string | undefined;
    isBeneficiary: boolean;
    notes: string | undefined;
}

export class PublicMarketingEventRegistrationResultDto implements IPublicMarketingEventRegistrationResultDto {
    meetingLink!: string | undefined;

    constructor(data?: IPublicMarketingEventRegistrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingLink = _data["meetingLink"];
        }
    }

    static fromJS(data: any): PublicMarketingEventRegistrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicMarketingEventRegistrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingLink"] = this.meetingLink;
        return data;
    }
}

export interface IPublicMarketingEventRegistrationResultDto {
    meetingLink: string | undefined;
}

export class PublicPartnerDto implements IPublicPartnerDto {
    organizationName!: string | undefined;
    website!: string | undefined;
    organizationDescription!: string | undefined;
    logoDataUrl!: string | undefined;

    constructor(data?: IPublicPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.website = _data["website"];
            this.organizationDescription = _data["organizationDescription"];
            this.logoDataUrl = _data["logoDataUrl"];
        }
    }

    static fromJS(data: any): PublicPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["website"] = this.website;
        data["organizationDescription"] = this.organizationDescription;
        data["logoDataUrl"] = this.logoDataUrl;
        return data;
    }
}

export interface IPublicPartnerDto {
    organizationName: string | undefined;
    website: string | undefined;
    organizationDescription: string | undefined;
    logoDataUrl: string | undefined;
}

export class ReadOnlySpanOfByte implements IReadOnlySpanOfByte {
    readonly length!: number;
    readonly isEmpty!: boolean;

    constructor(data?: IReadOnlySpanOfByte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).length = _data["length"];
            (<any>this).isEmpty = _data["isEmpty"];
        }
    }

    static fromJS(data: any): ReadOnlySpanOfByte {
        data = typeof data === 'object' ? data : {};
        let result = new ReadOnlySpanOfByte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["isEmpty"] = this.isEmpty;
        return data;
    }
}

export interface IReadOnlySpanOfByte {
    length: number;
    isEmpty: boolean;
}

export class ReceiverInfo implements IReceiverInfo {
    ssaFax!: string | undefined;
    phone!: string | undefined;
    officeName!: string | undefined;
    addressLine!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;

    constructor(data?: IReceiverInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssaFax = _data["ssaFax"];
            this.phone = _data["phone"];
            this.officeName = _data["officeName"];
            this.addressLine = _data["addressLine"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): ReceiverInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssaFax"] = this.ssaFax;
        data["phone"] = this.phone;
        data["officeName"] = this.officeName;
        data["addressLine"] = this.addressLine;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface IReceiverInfo {
    ssaFax: string | undefined;
    phone: string | undefined;
    officeName: string | undefined;
    addressLine: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class RecipientsDto implements IRecipientsDto {
    id!: number;
    clientId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    readonly fullName!: string | undefined;
    emailId!: string | undefined;
    phoneNumber!: string | undefined;
    fullAddress!: string | undefined;

    constructor(data?: IRecipientsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.emailId = _data["emailId"];
            this.phoneNumber = _data["phoneNumber"];
            this.fullAddress = _data["fullAddress"];
        }
    }

    static fromJS(data: any): RecipientsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["emailId"] = this.emailId;
        data["phoneNumber"] = this.phoneNumber;
        data["fullAddress"] = this.fullAddress;
        return data;
    }
}

export interface IRecipientsDto {
    id: number;
    clientId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    fullName: string | undefined;
    emailId: string | undefined;
    phoneNumber: string | undefined;
    fullAddress: string | undefined;
}

export class ReferralAttributionDto implements IReferralAttributionDto {
    utmSource!: string | undefined;
    utmMedium!: string | undefined;
    utmCampaign!: string | undefined;
    utmContent!: string | undefined;

    constructor(data?: IReferralAttributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utmSource = _data["utmSource"];
            this.utmMedium = _data["utmMedium"];
            this.utmCampaign = _data["utmCampaign"];
            this.utmContent = _data["utmContent"];
        }
    }

    static fromJS(data: any): ReferralAttributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralAttributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utmSource"] = this.utmSource;
        data["utmMedium"] = this.utmMedium;
        data["utmCampaign"] = this.utmCampaign;
        data["utmContent"] = this.utmContent;
        return data;
    }
}

export interface IReferralAttributionDto {
    utmSource: string | undefined;
    utmMedium: string | undefined;
    utmCampaign: string | undefined;
    utmContent: string | undefined;
}

export class ReferralPartnerDto implements IReferralPartnerDto {
    id!: number;
    partnerCode!: string | undefined;
    organizationName!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    contactAddress!: string | undefined;
    rewardType!: ReferralRewardType;
    enumDisplayRewardType!: string | undefined;
    rewardDescription!: string | undefined;
    defaultRewardAmount!: number;
    isActive!: boolean;
    startDate!: DateTime;
    contractDocumentId!: number | undefined;
    isPersonalReferral!: boolean;
    isSelfReferred!: boolean | undefined;
    referralPartnerNotes!: string | undefined;
    deativateByUserID!: number | undefined;
    deativateTime!: DateTime | undefined;
    notes!: NoteEntry[] | undefined;
    agreementStatus!: PartnerAgreementStatus;
    enumDisplayAgreementStatus!: string | undefined;
    website!: string | undefined;
    organizationDescription!: string | undefined;
    agreementSignedDate!: DateTime | undefined;
    hasLogin!: boolean;

    constructor(data?: IReferralPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerCode = _data["partnerCode"];
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.contactAddress = _data["contactAddress"];
            this.rewardType = _data["rewardType"];
            this.enumDisplayRewardType = _data["enumDisplayRewardType"];
            this.rewardDescription = _data["rewardDescription"];
            this.defaultRewardAmount = _data["defaultRewardAmount"];
            this.isActive = _data["isActive"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.contractDocumentId = _data["contractDocumentId"];
            this.isPersonalReferral = _data["isPersonalReferral"];
            this.isSelfReferred = _data["isSelfReferred"];
            this.referralPartnerNotes = _data["referralPartnerNotes"];
            this.deativateByUserID = _data["deativateByUserID"];
            this.deativateTime = _data["deativateTime"] ? DateTime.fromISO(_data["deativateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteEntry.fromJS(item));
            }
            this.agreementStatus = _data["agreementStatus"];
            this.enumDisplayAgreementStatus = _data["enumDisplayAgreementStatus"];
            this.website = _data["website"];
            this.organizationDescription = _data["organizationDescription"];
            this.agreementSignedDate = _data["agreementSignedDate"] ? DateTime.fromISO(_data["agreementSignedDate"].toString()) : <any>undefined;
            this.hasLogin = _data["hasLogin"];
        }
    }

    static fromJS(data: any): ReferralPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerCode"] = this.partnerCode;
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["contactAddress"] = this.contactAddress;
        data["rewardType"] = this.rewardType;
        data["enumDisplayRewardType"] = this.enumDisplayRewardType;
        data["rewardDescription"] = this.rewardDescription;
        data["defaultRewardAmount"] = this.defaultRewardAmount;
        data["isActive"] = this.isActive;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["contractDocumentId"] = this.contractDocumentId;
        data["isPersonalReferral"] = this.isPersonalReferral;
        data["isSelfReferred"] = this.isSelfReferred;
        data["referralPartnerNotes"] = this.referralPartnerNotes;
        data["deativateByUserID"] = this.deativateByUserID;
        data["deativateTime"] = this.deativateTime ? this.deativateTime.toString() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["agreementStatus"] = this.agreementStatus;
        data["enumDisplayAgreementStatus"] = this.enumDisplayAgreementStatus;
        data["website"] = this.website;
        data["organizationDescription"] = this.organizationDescription;
        data["agreementSignedDate"] = this.agreementSignedDate ? this.agreementSignedDate.toString() : <any>undefined;
        data["hasLogin"] = this.hasLogin;
        return data;
    }
}

export interface IReferralPartnerDto {
    id: number;
    partnerCode: string | undefined;
    organizationName: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    contactAddress: string | undefined;
    rewardType: ReferralRewardType;
    enumDisplayRewardType: string | undefined;
    rewardDescription: string | undefined;
    defaultRewardAmount: number;
    isActive: boolean;
    startDate: DateTime;
    contractDocumentId: number | undefined;
    isPersonalReferral: boolean;
    isSelfReferred: boolean | undefined;
    referralPartnerNotes: string | undefined;
    deativateByUserID: number | undefined;
    deativateTime: DateTime | undefined;
    notes: NoteEntry[] | undefined;
    agreementStatus: PartnerAgreementStatus;
    enumDisplayAgreementStatus: string | undefined;
    website: string | undefined;
    organizationDescription: string | undefined;
    agreementSignedDate: DateTime | undefined;
    hasLogin: boolean;
}

export class ReferralPartnerDtoForReferral implements IReferralPartnerDtoForReferral {
    organizationName!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    isSelfReferred!: boolean | undefined;

    constructor(data?: IReferralPartnerDtoForReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.isSelfReferred = _data["isSelfReferred"];
        }
    }

    static fromJS(data: any): ReferralPartnerDtoForReferral {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralPartnerDtoForReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["isSelfReferred"] = this.isSelfReferred;
        return data;
    }
}

export interface IReferralPartnerDtoForReferral {
    organizationName: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    isSelfReferred: boolean | undefined;
}

export class ReferralPartnerRequestDto implements IReferralPartnerRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    isActive!: boolean | undefined;
    rewardType!: ReferralRewardType[] | undefined;
    filter!: string | undefined;
    agreementStatuses!: PartnerAgreementStatus[] | undefined;

    constructor(data?: IReferralPartnerRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["rewardType"])) {
                this.rewardType = [] as any;
                for (let item of _data["rewardType"])
                    this.rewardType!.push(item);
            }
            this.filter = _data["filter"];
            if (Array.isArray(_data["agreementStatuses"])) {
                this.agreementStatuses = [] as any;
                for (let item of _data["agreementStatuses"])
                    this.agreementStatuses!.push(item);
            }
        }
    }

    static fromJS(data: any): ReferralPartnerRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralPartnerRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.rewardType)) {
            data["rewardType"] = [];
            for (let item of this.rewardType)
                data["rewardType"].push(item);
        }
        data["filter"] = this.filter;
        if (Array.isArray(this.agreementStatuses)) {
            data["agreementStatuses"] = [];
            for (let item of this.agreementStatuses)
                data["agreementStatuses"].push(item);
        }
        return data;
    }
}

export interface IReferralPartnerRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    isActive: boolean | undefined;
    rewardType: ReferralRewardType[] | undefined;
    filter: string | undefined;
    agreementStatuses: PartnerAgreementStatus[] | undefined;
}

export class ReferralRequestDto implements IReferralRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    partnerId!: number | undefined;
    status!: ReferralStatus[] | undefined;
    filter!: string | undefined;

    constructor(data?: IReferralRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.partnerId = _data["partnerId"];
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ReferralRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["partnerId"] = this.partnerId;
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["filter"] = this.filter;
        return data;
    }
}

export interface IReferralRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    partnerId: number | undefined;
    status: ReferralStatus[] | undefined;
    filter: string | undefined;
}

export enum ReferralRewardType {
    None = 0,
    GiftCard = 1,
    CustomPartnerReward = 2,
}

export enum ReferralSource {
    SSALeads = 1,
    HelpLine = 2,
    StateVRAgency = 3,
    Other = 4,
}

export enum ReferralStatus {
    Submitted = 0,
    ReferralVerificationPending = 1,
    ContactAttempted = 2,
    Enrolled = 3,
    Hired = 4,
    RewardEligible = 5,
    RewardIssued = 6,
    Rejected = 9,
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminName!: string | undefined;
    adminSurname!: string | undefined;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    paymentPeriodType!: PaymentPeriodType;
    editionId!: number | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminName = _data["adminName"];
            this.adminSurname = _data["adminSurname"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.editionId = _data["editionId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminName"] = this.adminName;
        data["adminSurname"] = this.adminSurname;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["editionId"] = this.editionId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminName: string | undefined;
    adminSurname: string | undefined;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    paymentPeriodType: PaymentPeriodType;
    editionId: number | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;
    paymentId!: number | undefined;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
    paymentId: number | undefined;
}

export class ReinstatementDto implements IReinstatementDto {
    id!: number;
    ticketHolderId!: number;
    requestDate!: DateTime;
    requestedByUserName!: string | undefined;
    currentStatus!: ReinstatementStatus;
    readonly enumDisplayCurrentStatus!: string | undefined;
    decisionDate!: DateTime | undefined;
    decisionByUserName!: string | undefined;
    notes!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifiedUserName!: string | undefined;

    constructor(data?: IReinstatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.requestDate = _data["requestDate"] ? DateTime.fromISO(_data["requestDate"].toString()) : <any>undefined;
            this.requestedByUserName = _data["requestedByUserName"];
            this.currentStatus = _data["currentStatus"];
            (<any>this).enumDisplayCurrentStatus = _data["enumDisplayCurrentStatus"];
            this.decisionDate = _data["decisionDate"] ? DateTime.fromISO(_data["decisionDate"].toString()) : <any>undefined;
            this.decisionByUserName = _data["decisionByUserName"];
            this.notes = _data["notes"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifiedUserName = _data["lastModifiedUserName"];
        }
    }

    static fromJS(data: any): ReinstatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReinstatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["requestDate"] = this.requestDate ? this.requestDate.toString() : <any>undefined;
        data["requestedByUserName"] = this.requestedByUserName;
        data["currentStatus"] = this.currentStatus;
        data["enumDisplayCurrentStatus"] = this.enumDisplayCurrentStatus;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toString() : <any>undefined;
        data["decisionByUserName"] = this.decisionByUserName;
        data["notes"] = this.notes;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifiedUserName"] = this.lastModifiedUserName;
        return data;
    }
}

export interface IReinstatementDto {
    id: number;
    ticketHolderId: number;
    requestDate: DateTime;
    requestedByUserName: string | undefined;
    currentStatus: ReinstatementStatus;
    enumDisplayCurrentStatus: string | undefined;
    decisionDate: DateTime | undefined;
    decisionByUserName: string | undefined;
    notes: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifiedUserName: string | undefined;
}

export class ReinstatementHistoryDto implements IReinstatementHistoryDto {
    id!: number;
    ticketHolderReinstatementId!: number;
    status!: ReinstatementStatus;
    readonly enumDisplayName!: string | undefined;
    changedByUserId!: number;
    changedByUserName!: string | undefined;
    changeTime!: DateTime;
    reasonOrNote!: string | undefined;

    constructor(data?: IReinstatementHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderReinstatementId = _data["ticketHolderReinstatementId"];
            this.status = _data["status"];
            (<any>this).enumDisplayName = _data["enumDisplayName"];
            this.changedByUserId = _data["changedByUserId"];
            this.changedByUserName = _data["changedByUserName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.reasonOrNote = _data["reasonOrNote"];
        }
    }

    static fromJS(data: any): ReinstatementHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReinstatementHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderReinstatementId"] = this.ticketHolderReinstatementId;
        data["status"] = this.status;
        data["enumDisplayName"] = this.enumDisplayName;
        data["changedByUserId"] = this.changedByUserId;
        data["changedByUserName"] = this.changedByUserName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["reasonOrNote"] = this.reasonOrNote;
        return data;
    }
}

export interface IReinstatementHistoryDto {
    id: number;
    ticketHolderReinstatementId: number;
    status: ReinstatementStatus;
    enumDisplayName: string | undefined;
    changedByUserId: number;
    changedByUserName: string | undefined;
    changeTime: DateTime;
    reasonOrNote: string | undefined;
}

export enum ReinstatementStatus {
    Requested = 0,
    ApprovedByManager = 1,
    PendingBenefitsCounseling = 2,
    BenefitsCounselingFinished = 3,
    PendingToUnassign = 4,
    UnassignCompleted = 5,
}

export class RejectionWageReportDto implements IRejectionWageReportDto {
    id!: number;
    removeReason!: WageReportRemovalReason;

    constructor(data?: IRejectionWageReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.removeReason = _data["removeReason"];
        }
    }

    static fromJS(data: any): RejectionWageReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectionWageReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["removeReason"] = this.removeReason;
        return data;
    }
}

export interface IRejectionWageReportDto {
    id: number;
    removeReason: WageReportRemovalReason;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class ReportDto implements IReportDto {
    id!: number;
    name!: string;
    description!: string | undefined;
    tsql!: string | undefined;
    userRoles!: string | undefined;
    isActive!: boolean;
    tenantId!: number | undefined;
    tenantName!: string | undefined;
    creationTime!: string | undefined;

    constructor(data?: IReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tsql = _data["tsql"];
            this.userRoles = _data["userRoles"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.creationTime = _data["creationTime"];
        }
    }

    static fromJS(data: any): ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tsql"] = this.tsql;
        data["userRoles"] = this.userRoles;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["creationTime"] = this.creationTime;
        return data;
    }
}

export interface IReportDto {
    id: number;
    name: string;
    description: string | undefined;
    tsql: string | undefined;
    userRoles: string | undefined;
    isActive: boolean;
    tenantId: number | undefined;
    tenantName: string | undefined;
    creationTime: string | undefined;
}

export class ReportRequestDto implements IReportRequestDto {
    id!: number;
    tenantId!: number | undefined;
    tenantName!: string | undefined;
    requestedByUserId!: number;
    requestedByUserName!: string | undefined;
    title!: string;
    businessPurpose!: string | undefined;
    requiredColumns!: string | undefined;
    requiredFilters!: string | undefined;
    dateRangeRequirements!: string | undefined;
    notes!: string | undefined;
    status!: ReportRequestStatus;
    statusName!: string | undefined;
    adminNotes!: string | undefined;
    linkedReportId!: number | undefined;
    linkedReportName!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.requestedByUserId = _data["requestedByUserId"];
            this.requestedByUserName = _data["requestedByUserName"];
            this.title = _data["title"];
            this.businessPurpose = _data["businessPurpose"];
            this.requiredColumns = _data["requiredColumns"];
            this.requiredFilters = _data["requiredFilters"];
            this.dateRangeRequirements = _data["dateRangeRequirements"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.adminNotes = _data["adminNotes"];
            this.linkedReportId = _data["linkedReportId"];
            this.linkedReportName = _data["linkedReportName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["requestedByUserId"] = this.requestedByUserId;
        data["requestedByUserName"] = this.requestedByUserName;
        data["title"] = this.title;
        data["businessPurpose"] = this.businessPurpose;
        data["requiredColumns"] = this.requiredColumns;
        data["requiredFilters"] = this.requiredFilters;
        data["dateRangeRequirements"] = this.dateRangeRequirements;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["adminNotes"] = this.adminNotes;
        data["linkedReportId"] = this.linkedReportId;
        data["linkedReportName"] = this.linkedReportName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IReportRequestDto {
    id: number;
    tenantId: number | undefined;
    tenantName: string | undefined;
    requestedByUserId: number;
    requestedByUserName: string | undefined;
    title: string;
    businessPurpose: string | undefined;
    requiredColumns: string | undefined;
    requiredFilters: string | undefined;
    dateRangeRequirements: string | undefined;
    notes: string | undefined;
    status: ReportRequestStatus;
    statusName: string | undefined;
    adminNotes: string | undefined;
    linkedReportId: number | undefined;
    linkedReportName: string | undefined;
    creationTime: DateTime;
}

export enum ReportRequestStatus {
    New = 1,
    UnderReview = 2,
    Confirmed = 3,
    Rejected = 4,
    Completed = 5,
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    expireDate!: DateTime;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : <any>undefined;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    expireDate: DateTime;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class ResponseDto implements IResponseDto {
    selectedOptions!: SurveyResponseOptionDto[] | undefined;
    textAnswer!: string | undefined;

    constructor(data?: IResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedOptions"])) {
                this.selectedOptions = [] as any;
                for (let item of _data["selectedOptions"])
                    this.selectedOptions!.push(SurveyResponseOptionDto.fromJS(item));
            }
            this.textAnswer = _data["textAnswer"];
        }
    }

    static fromJS(data: any): ResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedOptions)) {
            data["selectedOptions"] = [];
            for (let item of this.selectedOptions)
                data["selectedOptions"].push(item.toJSON());
        }
        data["textAnswer"] = this.textAnswer;
        return data;
    }
}

export interface IResponseDto {
    selectedOptions: SurveyResponseOptionDto[] | undefined;
    textAnswer: string | undefined;
}

export enum ResumeAssistanceType {
    CreateNewResume = 0,
    ReviewAndEditExistingResume = 1,
    CompleteResumeBuildingWorksheet = 2,
}

export class ResumeContentDto implements IResumeContentDto {
    identity!: ResumeIdentityDto;
    professionalSummary!: string | undefined;
    skills!: string[] | undefined;
    experience!: ResumeJobDto[] | undefined;
    education!: ResumeSchoolDto[] | undefined;
    certifications!: string[] | undefined;
    additionalInfo!: string[] | undefined;

    constructor(data?: IResumeContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identity = _data["identity"] ? ResumeIdentityDto.fromJS(_data["identity"]) : <any>undefined;
            this.professionalSummary = _data["professionalSummary"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(item);
            }
            if (Array.isArray(_data["experience"])) {
                this.experience = [] as any;
                for (let item of _data["experience"])
                    this.experience!.push(ResumeJobDto.fromJS(item));
            }
            if (Array.isArray(_data["education"])) {
                this.education = [] as any;
                for (let item of _data["education"])
                    this.education!.push(ResumeSchoolDto.fromJS(item));
            }
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(item);
            }
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): ResumeContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identity"] = this.identity ? this.identity.toJSON() : <any>undefined;
        data["professionalSummary"] = this.professionalSummary;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item);
        }
        if (Array.isArray(this.experience)) {
            data["experience"] = [];
            for (let item of this.experience)
                data["experience"].push(item.toJSON());
        }
        if (Array.isArray(this.education)) {
            data["education"] = [];
            for (let item of this.education)
                data["education"].push(item.toJSON());
        }
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item);
        }
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item);
        }
        return data;
    }
}

export interface IResumeContentDto {
    identity: ResumeIdentityDto;
    professionalSummary: string | undefined;
    skills: string[] | undefined;
    experience: ResumeJobDto[] | undefined;
    education: ResumeSchoolDto[] | undefined;
    certifications: string[] | undefined;
    additionalInfo: string[] | undefined;
}

export class ResumeDraftDto implements IResumeDraftDto {
    id!: number;
    ticketHolderId!: number;
    status!: ResumeDraftStatus;
    statusName!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    sourceWorksheetId!: number | undefined;
    aiModel!: string | undefined;
    finalDocumentId!: number | undefined;
    finalizedTime!: DateTime | undefined;
    content!: ResumeContentDto;
    placeholders!: ResumeIdentityDto;

    constructor(data?: IResumeDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.sourceWorksheetId = _data["sourceWorksheetId"];
            this.aiModel = _data["aiModel"];
            this.finalDocumentId = _data["finalDocumentId"];
            this.finalizedTime = _data["finalizedTime"] ? DateTime.fromISO(_data["finalizedTime"].toString()) : <any>undefined;
            this.content = _data["content"] ? ResumeContentDto.fromJS(_data["content"]) : <any>undefined;
            this.placeholders = _data["placeholders"] ? ResumeIdentityDto.fromJS(_data["placeholders"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResumeDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["sourceWorksheetId"] = this.sourceWorksheetId;
        data["aiModel"] = this.aiModel;
        data["finalDocumentId"] = this.finalDocumentId;
        data["finalizedTime"] = this.finalizedTime ? this.finalizedTime.toString() : <any>undefined;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["placeholders"] = this.placeholders ? this.placeholders.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResumeDraftDto {
    id: number;
    ticketHolderId: number;
    status: ResumeDraftStatus;
    statusName: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    sourceWorksheetId: number | undefined;
    aiModel: string | undefined;
    finalDocumentId: number | undefined;
    finalizedTime: DateTime | undefined;
    content: ResumeContentDto;
    placeholders: ResumeIdentityDto;
}

export enum ResumeDraftStatus {
    Draft = 1,
    Finalized = 2,
}

export class ResumeDraftSummaryDto implements IResumeDraftSummaryDto {
    id!: number;
    ticketHolderId!: number;
    status!: ResumeDraftStatus;
    statusName!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    sourceWorksheetId!: number | undefined;
    aiModel!: string | undefined;
    finalDocumentId!: number | undefined;
    finalizedTime!: DateTime | undefined;

    constructor(data?: IResumeDraftSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.sourceWorksheetId = _data["sourceWorksheetId"];
            this.aiModel = _data["aiModel"];
            this.finalDocumentId = _data["finalDocumentId"];
            this.finalizedTime = _data["finalizedTime"] ? DateTime.fromISO(_data["finalizedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResumeDraftSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeDraftSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["sourceWorksheetId"] = this.sourceWorksheetId;
        data["aiModel"] = this.aiModel;
        data["finalDocumentId"] = this.finalDocumentId;
        data["finalizedTime"] = this.finalizedTime ? this.finalizedTime.toString() : <any>undefined;
        return data;
    }
}

export interface IResumeDraftSummaryDto {
    id: number;
    ticketHolderId: number;
    status: ResumeDraftStatus;
    statusName: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    sourceWorksheetId: number | undefined;
    aiModel: string | undefined;
    finalDocumentId: number | undefined;
    finalizedTime: DateTime | undefined;
}

export class ResumeIdentityDto implements IResumeIdentityDto {
    fullName!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zip!: string | undefined;
    dob!: string | undefined;
    ssn!: string | undefined;
    includeDob!: boolean;
    includeSsn!: boolean;

    constructor(data?: IResumeIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.dob = _data["dob"];
            this.ssn = _data["ssn"];
            this.includeDob = _data["includeDob"];
            this.includeSsn = _data["includeSsn"];
        }
    }

    static fromJS(data: any): ResumeIdentityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeIdentityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["dob"] = this.dob;
        data["ssn"] = this.ssn;
        data["includeDob"] = this.includeDob;
        data["includeSsn"] = this.includeSsn;
        return data;
    }
}

export interface IResumeIdentityDto {
    fullName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    dob: string | undefined;
    ssn: string | undefined;
    includeDob: boolean;
    includeSsn: boolean;
}

export class ResumeJobDto implements IResumeJobDto {
    jobTitle!: string | undefined;
    company!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    startDate!: string | undefined;
    endDate!: string | undefined;
    isCurrent!: boolean;
    bullets!: string[] | undefined;

    constructor(data?: IResumeJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobTitle = _data["jobTitle"];
            this.company = _data["company"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isCurrent = _data["isCurrent"];
            if (Array.isArray(_data["bullets"])) {
                this.bullets = [] as any;
                for (let item of _data["bullets"])
                    this.bullets!.push(item);
            }
        }
    }

    static fromJS(data: any): ResumeJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitle"] = this.jobTitle;
        data["company"] = this.company;
        data["city"] = this.city;
        data["state"] = this.state;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isCurrent"] = this.isCurrent;
        if (Array.isArray(this.bullets)) {
            data["bullets"] = [];
            for (let item of this.bullets)
                data["bullets"].push(item);
        }
        return data;
    }
}

export interface IResumeJobDto {
    jobTitle: string | undefined;
    company: string | undefined;
    city: string | undefined;
    state: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    isCurrent: boolean;
    bullets: string[] | undefined;
}

export class ResumePdfDto implements IResumePdfDto {
    documentId!: number;
    fileName!: string | undefined;
    contentType!: string | undefined;
    base64!: string | undefined;

    constructor(data?: IResumePdfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): ResumePdfDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumePdfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["base64"] = this.base64;
        return data;
    }
}

export interface IResumePdfDto {
    documentId: number;
    fileName: string | undefined;
    contentType: string | undefined;
    base64: string | undefined;
}

export class ResumeSchoolDto implements IResumeSchoolDto {
    school!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    credential!: string | undefined;
    details!: string | undefined;

    constructor(data?: IResumeSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.school = _data["school"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.credential = _data["credential"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): ResumeSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["school"] = this.school;
        data["city"] = this.city;
        data["state"] = this.state;
        data["credential"] = this.credential;
        data["details"] = this.details;
        return data;
    }
}

export interface IResumeSchoolDto {
    school: string | undefined;
    city: string | undefined;
    state: string | undefined;
    credential: string | undefined;
    details: string | undefined;
}

export class ResumeServiceRequestDto implements IResumeServiceRequestDto {
    id!: number;
    ticketHolderId!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    assistanceType!: ResumeAssistanceType;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: IResumeServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.assistanceType = _data["assistanceType"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResumeServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["assistanceType"] = this.assistanceType;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface IResumeServiceRequestDto {
    id: number;
    ticketHolderId: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    assistanceType: ResumeAssistanceType;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class ResumeWorksheetContactDto implements IResumeWorksheetContactDto {
    name!: string | undefined;
    aptPoBox!: string | undefined;
    street!: string | undefined;
    cityStateZip!: string | undefined;
    phone!: string | undefined;
    cell!: string | undefined;
    email!: string | undefined;

    constructor(data?: IResumeWorksheetContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.aptPoBox = _data["aptPoBox"];
            this.street = _data["street"];
            this.cityStateZip = _data["cityStateZip"];
            this.phone = _data["phone"];
            this.cell = _data["cell"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResumeWorksheetContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["aptPoBox"] = this.aptPoBox;
        data["street"] = this.street;
        data["cityStateZip"] = this.cityStateZip;
        data["phone"] = this.phone;
        data["cell"] = this.cell;
        data["email"] = this.email;
        return data;
    }
}

export interface IResumeWorksheetContactDto {
    name: string | undefined;
    aptPoBox: string | undefined;
    street: string | undefined;
    cityStateZip: string | undefined;
    phone: string | undefined;
    cell: string | undefined;
    email: string | undefined;
}

export class ResumeWorksheetDataDto implements IResumeWorksheetDataDto {
    contact!: ResumeWorksheetContactDto;
    jobObjective!: string | undefined;
    skills!: string[] | undefined;
    experience!: ResumeWorksheetExperienceDto[] | undefined;
    certifications!: string[] | undefined;
    additionalInfo!: string[] | undefined;
    education!: ResumeWorksheetEducationDto[] | undefined;
    references!: ResumeWorksheetReferenceDto[] | undefined;
    filledByCoachUserId!: number | undefined;

    constructor(data?: IResumeWorksheetDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? ResumeWorksheetContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.jobObjective = _data["jobObjective"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(item);
            }
            if (Array.isArray(_data["experience"])) {
                this.experience = [] as any;
                for (let item of _data["experience"])
                    this.experience!.push(ResumeWorksheetExperienceDto.fromJS(item));
            }
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(item);
            }
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(item);
            }
            if (Array.isArray(_data["education"])) {
                this.education = [] as any;
                for (let item of _data["education"])
                    this.education!.push(ResumeWorksheetEducationDto.fromJS(item));
            }
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(ResumeWorksheetReferenceDto.fromJS(item));
            }
            this.filledByCoachUserId = _data["filledByCoachUserId"];
        }
    }

    static fromJS(data: any): ResumeWorksheetDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["jobObjective"] = this.jobObjective;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item);
        }
        if (Array.isArray(this.experience)) {
            data["experience"] = [];
            for (let item of this.experience)
                data["experience"].push(item.toJSON());
        }
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item);
        }
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item);
        }
        if (Array.isArray(this.education)) {
            data["education"] = [];
            for (let item of this.education)
                data["education"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        data["filledByCoachUserId"] = this.filledByCoachUserId;
        return data;
    }
}

export interface IResumeWorksheetDataDto {
    contact: ResumeWorksheetContactDto;
    jobObjective: string | undefined;
    skills: string[] | undefined;
    experience: ResumeWorksheetExperienceDto[] | undefined;
    certifications: string[] | undefined;
    additionalInfo: string[] | undefined;
    education: ResumeWorksheetEducationDto[] | undefined;
    references: ResumeWorksheetReferenceDto[] | undefined;
    filledByCoachUserId: number | undefined;
}

export class ResumeWorksheetDto implements IResumeWorksheetDto {
    id!: number;
    ticketHolderId!: number;
    status!: ResumeWorksheetStatus;
    statusName!: string | undefined;
    linkStatus!: ResumeWorksheetLinkStatus;
    url!: string | undefined;
    passcode!: string | undefined;
    creationTime!: DateTime;
    sentByName!: string | undefined;
    emailSentAt!: DateTime | undefined;
    emailSentToAddress!: string | undefined;
    smsSentAt!: DateTime | undefined;
    smsSentToNumber!: string | undefined;
    draftSavedAt!: DateTime | undefined;
    submittedAt!: DateTime | undefined;
    filledByCoach!: boolean;
    filledByCoachName!: string | undefined;
    data!: ResumeWorksheetDataDto;
    ticketHolderEmail!: string | undefined;
    ticketHolderPhoneNumber!: string | undefined;

    constructor(data?: IResumeWorksheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.linkStatus = _data["linkStatus"];
            this.url = _data["url"];
            this.passcode = _data["passcode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.sentByName = _data["sentByName"];
            this.emailSentAt = _data["emailSentAt"] ? DateTime.fromISO(_data["emailSentAt"].toString()) : <any>undefined;
            this.emailSentToAddress = _data["emailSentToAddress"];
            this.smsSentAt = _data["smsSentAt"] ? DateTime.fromISO(_data["smsSentAt"].toString()) : <any>undefined;
            this.smsSentToNumber = _data["smsSentToNumber"];
            this.draftSavedAt = _data["draftSavedAt"] ? DateTime.fromISO(_data["draftSavedAt"].toString()) : <any>undefined;
            this.submittedAt = _data["submittedAt"] ? DateTime.fromISO(_data["submittedAt"].toString()) : <any>undefined;
            this.filledByCoach = _data["filledByCoach"];
            this.filledByCoachName = _data["filledByCoachName"];
            this.data = _data["data"] ? ResumeWorksheetDataDto.fromJS(_data["data"]) : <any>undefined;
            this.ticketHolderEmail = _data["ticketHolderEmail"];
            this.ticketHolderPhoneNumber = _data["ticketHolderPhoneNumber"];
        }
    }

    static fromJS(data: any): ResumeWorksheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["linkStatus"] = this.linkStatus;
        data["url"] = this.url;
        data["passcode"] = this.passcode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["sentByName"] = this.sentByName;
        data["emailSentAt"] = this.emailSentAt ? this.emailSentAt.toString() : <any>undefined;
        data["emailSentToAddress"] = this.emailSentToAddress;
        data["smsSentAt"] = this.smsSentAt ? this.smsSentAt.toString() : <any>undefined;
        data["smsSentToNumber"] = this.smsSentToNumber;
        data["draftSavedAt"] = this.draftSavedAt ? this.draftSavedAt.toString() : <any>undefined;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toString() : <any>undefined;
        data["filledByCoach"] = this.filledByCoach;
        data["filledByCoachName"] = this.filledByCoachName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["ticketHolderEmail"] = this.ticketHolderEmail;
        data["ticketHolderPhoneNumber"] = this.ticketHolderPhoneNumber;
        return data;
    }
}

export interface IResumeWorksheetDto {
    id: number;
    ticketHolderId: number;
    status: ResumeWorksheetStatus;
    statusName: string | undefined;
    linkStatus: ResumeWorksheetLinkStatus;
    url: string | undefined;
    passcode: string | undefined;
    creationTime: DateTime;
    sentByName: string | undefined;
    emailSentAt: DateTime | undefined;
    emailSentToAddress: string | undefined;
    smsSentAt: DateTime | undefined;
    smsSentToNumber: string | undefined;
    draftSavedAt: DateTime | undefined;
    submittedAt: DateTime | undefined;
    filledByCoach: boolean;
    filledByCoachName: string | undefined;
    data: ResumeWorksheetDataDto;
    ticketHolderEmail: string | undefined;
    ticketHolderPhoneNumber: string | undefined;
}

export class ResumeWorksheetEditDto implements IResumeWorksheetEditDto {
    worksheetId!: number | undefined;
    status!: ResumeWorksheetStatus;
    ticketHolderFullName!: string | undefined;
    data!: ResumeWorksheetDataDto;

    constructor(data?: IResumeWorksheetEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksheetId = _data["worksheetId"];
            this.status = _data["status"];
            this.ticketHolderFullName = _data["ticketHolderFullName"];
            this.data = _data["data"] ? ResumeWorksheetDataDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResumeWorksheetEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksheetId"] = this.worksheetId;
        data["status"] = this.status;
        data["ticketHolderFullName"] = this.ticketHolderFullName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResumeWorksheetEditDto {
    worksheetId: number | undefined;
    status: ResumeWorksheetStatus;
    ticketHolderFullName: string | undefined;
    data: ResumeWorksheetDataDto;
}

export class ResumeWorksheetEducationDto implements IResumeWorksheetEducationDto {
    schoolName!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    degree!: string | undefined;
    activities!: string | undefined;

    constructor(data?: IResumeWorksheetEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolName = _data["schoolName"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.degree = _data["degree"];
            this.activities = _data["activities"];
        }
    }

    static fromJS(data: any): ResumeWorksheetEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolName"] = this.schoolName;
        data["city"] = this.city;
        data["state"] = this.state;
        data["degree"] = this.degree;
        data["activities"] = this.activities;
        return data;
    }
}

export interface IResumeWorksheetEducationDto {
    schoolName: string | undefined;
    city: string | undefined;
    state: string | undefined;
    degree: string | undefined;
    activities: string | undefined;
}

export class ResumeWorksheetExperienceDto implements IResumeWorksheetExperienceDto {
    startDate!: string | undefined;
    endDate!: string | undefined;
    isCurrentEmployer!: boolean;
    jobTitle!: string | undefined;
    companyName!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    duties!: string[] | undefined;

    constructor(data?: IResumeWorksheetExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isCurrentEmployer = _data["isCurrentEmployer"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.city = _data["city"];
            this.state = _data["state"];
            if (Array.isArray(_data["duties"])) {
                this.duties = [] as any;
                for (let item of _data["duties"])
                    this.duties!.push(item);
            }
        }
    }

    static fromJS(data: any): ResumeWorksheetExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isCurrentEmployer"] = this.isCurrentEmployer;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["city"] = this.city;
        data["state"] = this.state;
        if (Array.isArray(this.duties)) {
            data["duties"] = [];
            for (let item of this.duties)
                data["duties"].push(item);
        }
        return data;
    }
}

export interface IResumeWorksheetExperienceDto {
    startDate: string | undefined;
    endDate: string | undefined;
    isCurrentEmployer: boolean;
    jobTitle: string | undefined;
    companyName: string | undefined;
    city: string | undefined;
    state: string | undefined;
    duties: string[] | undefined;
}

export enum ResumeWorksheetLinkStatus {
    Active = 1,
    Locked = 2,
    Revoked = 3,
}

export class ResumeWorksheetPublicStatusDto implements IResumeWorksheetPublicStatusDto {
    linkStatus!: ResumeWorksheetLinkStatus;
    status!: ResumeWorksheetStatus;
    ticketHolderFirstName!: string | undefined;

    constructor(data?: IResumeWorksheetPublicStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkStatus = _data["linkStatus"];
            this.status = _data["status"];
            this.ticketHolderFirstName = _data["ticketHolderFirstName"];
        }
    }

    static fromJS(data: any): ResumeWorksheetPublicStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetPublicStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkStatus"] = this.linkStatus;
        data["status"] = this.status;
        data["ticketHolderFirstName"] = this.ticketHolderFirstName;
        return data;
    }
}

export interface IResumeWorksheetPublicStatusDto {
    linkStatus: ResumeWorksheetLinkStatus;
    status: ResumeWorksheetStatus;
    ticketHolderFirstName: string | undefined;
}

export class ResumeWorksheetReferenceDto implements IResumeWorksheetReferenceDto {
    name!: string | undefined;
    jobTitle!: string | undefined;
    placeOfEmployment!: string | undefined;
    homeAddress!: string | undefined;
    homeAddress2!: string | undefined;
    cityStateZip!: string | undefined;
    residencePhone!: string | undefined;
    businessPhone!: string | undefined;

    constructor(data?: IResumeWorksheetReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jobTitle = _data["jobTitle"];
            this.placeOfEmployment = _data["placeOfEmployment"];
            this.homeAddress = _data["homeAddress"];
            this.homeAddress2 = _data["homeAddress2"];
            this.cityStateZip = _data["cityStateZip"];
            this.residencePhone = _data["residencePhone"];
            this.businessPhone = _data["businessPhone"];
        }
    }

    static fromJS(data: any): ResumeWorksheetReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jobTitle"] = this.jobTitle;
        data["placeOfEmployment"] = this.placeOfEmployment;
        data["homeAddress"] = this.homeAddress;
        data["homeAddress2"] = this.homeAddress2;
        data["cityStateZip"] = this.cityStateZip;
        data["residencePhone"] = this.residencePhone;
        data["businessPhone"] = this.businessPhone;
        return data;
    }
}

export interface IResumeWorksheetReferenceDto {
    name: string | undefined;
    jobTitle: string | undefined;
    placeOfEmployment: string | undefined;
    homeAddress: string | undefined;
    homeAddress2: string | undefined;
    cityStateZip: string | undefined;
    residencePhone: string | undefined;
    businessPhone: string | undefined;
}

export class ResumeWorksheetSaveInput implements IResumeWorksheetSaveInput {
    token!: string;
    passcode!: string;
    data!: ResumeWorksheetDataDto;

    constructor(data?: IResumeWorksheetSaveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new ResumeWorksheetDataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.passcode = _data["passcode"];
            this.data = _data["data"] ? ResumeWorksheetDataDto.fromJS(_data["data"]) : new ResumeWorksheetDataDto();
        }
    }

    static fromJS(data: any): ResumeWorksheetSaveInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetSaveInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["passcode"] = this.passcode;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResumeWorksheetSaveInput {
    token: string;
    passcode: string;
    data: ResumeWorksheetDataDto;
}

export class ResumeWorksheetSaveResultDto implements IResumeWorksheetSaveResultDto {
    success!: boolean;
    status!: ResumeWorksheetStatus;

    constructor(data?: IResumeWorksheetSaveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResumeWorksheetSaveResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetSaveResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        return data;
    }
}

export interface IResumeWorksheetSaveResultDto {
    success: boolean;
    status: ResumeWorksheetStatus;
}

export enum ResumeWorksheetStatus {
    Sent = 1,
    InProgress = 2,
    Submitted = 3,
}

export class ResumeWorksheetVerifyResultDto implements IResumeWorksheetVerifyResultDto {
    success!: boolean;
    ticketHolderFirstName!: string | undefined;
    ticketHolderFullName!: string | undefined;
    status!: ResumeWorksheetStatus;
    data!: ResumeWorksheetDataDto;

    constructor(data?: IResumeWorksheetVerifyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.ticketHolderFirstName = _data["ticketHolderFirstName"];
            this.ticketHolderFullName = _data["ticketHolderFullName"];
            this.status = _data["status"];
            this.data = _data["data"] ? ResumeWorksheetDataDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResumeWorksheetVerifyResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeWorksheetVerifyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["ticketHolderFirstName"] = this.ticketHolderFirstName;
        data["ticketHolderFullName"] = this.ticketHolderFullName;
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResumeWorksheetVerifyResultDto {
    success: boolean;
    ticketHolderFirstName: string | undefined;
    ticketHolderFullName: string | undefined;
    status: ResumeWorksheetStatus;
    data: ResumeWorksheetDataDto;
}

export class RetellCallQueueStatusDto implements IRetellCallQueueStatusDto {
    status!: string | undefined;
    currentLeadId!: number | undefined;
    isVoiceAgentConfigured!: boolean;

    constructor(data?: IRetellCallQueueStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.currentLeadId = _data["currentLeadId"];
            this.isVoiceAgentConfigured = _data["isVoiceAgentConfigured"];
        }
    }

    static fromJS(data: any): RetellCallQueueStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetellCallQueueStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["currentLeadId"] = this.currentLeadId;
        data["isVoiceAgentConfigured"] = this.isVoiceAgentConfigured;
        return data;
    }
}

export interface IRetellCallQueueStatusDto {
    status: string | undefined;
    currentLeadId: number | undefined;
    isVoiceAgentConfigured: boolean;
}

export class ReviewPiiRequestInput implements IReviewPiiRequestInput {
    id!: number;
    approve!: boolean;
    notes!: string | undefined;

    constructor(data?: IReviewPiiRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approve = _data["approve"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ReviewPiiRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewPiiRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approve"] = this.approve;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IReviewPiiRequestInput {
    id: number;
    approve: boolean;
    notes: string | undefined;
}

export class RevokeTicketHolderPortalAccessInput implements IRevokeTicketHolderPortalAccessInput {
    ticketHolderId!: number;
    reason!: string | undefined;

    constructor(data?: IRevokeTicketHolderPortalAccessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RevokeTicketHolderPortalAccessInput {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeTicketHolderPortalAccessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRevokeTicketHolderPortalAccessInput {
    ticketHolderId: number;
    reason: string | undefined;
}

export class RingCentralCallLogDto implements IRingCentralCallLogDto {
    id!: number;
    ringCentralId!: string | undefined;
    callType!: string | undefined;
    direction!: string | undefined;
    action!: string | undefined;
    result!: string | undefined;
    reason!: string | undefined;
    startTime!: DateTime | undefined;
    durationSeconds!: number | undefined;
    fromPhoneNumber!: string | undefined;
    fromName!: string | undefined;
    toPhoneNumber!: string | undefined;
    toName!: string | undefined;
    hasRecording!: boolean;
    userId!: number;

    constructor(data?: IRingCentralCallLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ringCentralId = _data["ringCentralId"];
            this.callType = _data["callType"];
            this.direction = _data["direction"];
            this.action = _data["action"];
            this.result = _data["result"];
            this.reason = _data["reason"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.durationSeconds = _data["durationSeconds"];
            this.fromPhoneNumber = _data["fromPhoneNumber"];
            this.fromName = _data["fromName"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.toName = _data["toName"];
            this.hasRecording = _data["hasRecording"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RingCentralCallLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RingCentralCallLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ringCentralId"] = this.ringCentralId;
        data["callType"] = this.callType;
        data["direction"] = this.direction;
        data["action"] = this.action;
        data["result"] = this.result;
        data["reason"] = this.reason;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["durationSeconds"] = this.durationSeconds;
        data["fromPhoneNumber"] = this.fromPhoneNumber;
        data["fromName"] = this.fromName;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["toName"] = this.toName;
        data["hasRecording"] = this.hasRecording;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IRingCentralCallLogDto {
    id: number;
    ringCentralId: string | undefined;
    callType: string | undefined;
    direction: string | undefined;
    action: string | undefined;
    result: string | undefined;
    reason: string | undefined;
    startTime: DateTime | undefined;
    durationSeconds: number | undefined;
    fromPhoneNumber: string | undefined;
    fromName: string | undefined;
    toPhoneNumber: string | undefined;
    toName: string | undefined;
    hasRecording: boolean;
    userId: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: DateTime;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: DateTime;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class RolloverPersonDto implements IRolloverPersonDto {
    lastName!: string;
    firstName!: string;
    middleName!: string;
    ssn!: string;
    dateOfBirth!: DateTime;
    fromAgreementNumber!: string;
    toAgreementNumber!: string;
    activeOnBoth!: boolean;

    constructor(data?: IRolloverPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.ssn = _data["ssn"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.fromAgreementNumber = _data["fromAgreementNumber"];
            this.toAgreementNumber = _data["toAgreementNumber"];
            this.activeOnBoth = _data["activeOnBoth"];
        }
    }

    static fromJS(data: any): RolloverPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolloverPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["ssn"] = this.ssn;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
        data["fromAgreementNumber"] = this.fromAgreementNumber;
        data["toAgreementNumber"] = this.toAgreementNumber;
        data["activeOnBoth"] = this.activeOnBoth;
        return data;
    }
}

export interface IRolloverPersonDto {
    lastName: string;
    firstName: string;
    middleName: string;
    ssn: string;
    dateOfBirth: DateTime;
    fromAgreementNumber: string;
    toAgreementNumber: string;
    activeOnBoth: boolean;
}

export class RoundLeadSummaryDto implements IRoundLeadSummaryDto {
    id!: number;
    roundNumber!: number;
    totalLeads!: number;
    sentJobLeadToTHCount!: number;
    completedOn!: DateTime | undefined;
    roundStatus!: JobSearchRequestStatus;
    creationTime!: DateTime | undefined;
    isCareerCoachOnly!: boolean;
    assignedToUserName!: string | undefined;
    readonly enumDisplayRoundStatus!: string | undefined;

    constructor(data?: IRoundLeadSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roundNumber = _data["roundNumber"];
            this.totalLeads = _data["totalLeads"];
            this.sentJobLeadToTHCount = _data["sentJobLeadToTHCount"];
            this.completedOn = _data["completedOn"] ? DateTime.fromISO(_data["completedOn"].toString()) : <any>undefined;
            this.roundStatus = _data["roundStatus"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isCareerCoachOnly = _data["isCareerCoachOnly"];
            this.assignedToUserName = _data["assignedToUserName"];
            (<any>this).enumDisplayRoundStatus = _data["enumDisplayRoundStatus"];
        }
    }

    static fromJS(data: any): RoundLeadSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoundLeadSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roundNumber"] = this.roundNumber;
        data["totalLeads"] = this.totalLeads;
        data["sentJobLeadToTHCount"] = this.sentJobLeadToTHCount;
        data["completedOn"] = this.completedOn ? this.completedOn.toString() : <any>undefined;
        data["roundStatus"] = this.roundStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isCareerCoachOnly"] = this.isCareerCoachOnly;
        data["assignedToUserName"] = this.assignedToUserName;
        data["enumDisplayRoundStatus"] = this.enumDisplayRoundStatus;
        return data;
    }
}

export interface IRoundLeadSummaryDto {
    id: number;
    roundNumber: number;
    totalLeads: number;
    sentJobLeadToTHCount: number;
    completedOn: DateTime | undefined;
    roundStatus: JobSearchRequestStatus;
    creationTime: DateTime | undefined;
    isCareerCoachOnly: boolean;
    assignedToUserName: string | undefined;
    enumDisplayRoundStatus: string | undefined;
}

export class RunReportInput implements IRunReportInput {
    reportId!: number;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IRunReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): RunReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new RunReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IRunReportInput {
    reportId: number;
    skipCount: number;
    maxResultCount: number;
}

export class RunTestInput implements IRunTestInput {
    projectName!: string;

    constructor(data?: IRunTestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): RunTestInput {
        data = typeof data === 'object' ? data : {};
        let result = new RunTestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IRunTestInput {
    projectName: string;
}

export class RunningTaskDto implements IRunningTaskDto {
    instanceId!: number;
    taskId!: number;
    taskName!: string | undefined;
    startTime!: DateTime | undefined;
    status!: JobProcessingStatus;
    enumDisplayStatusName!: string | undefined;
    serverName!: string | undefined;

    constructor(data?: IRunningTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.enumDisplayStatusName = _data["enumDisplayStatusName"];
            this.serverName = _data["serverName"];
        }
    }

    static fromJS(data: any): RunningTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new RunningTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["status"] = this.status;
        data["enumDisplayStatusName"] = this.enumDisplayStatusName;
        data["serverName"] = this.serverName;
        return data;
    }
}

export interface IRunningTaskDto {
    instanceId: number;
    taskId: number;
    taskName: string | undefined;
    startTime: DateTime | undefined;
    status: JobProcessingStatus;
    enumDisplayStatusName: string | undefined;
    serverName: string | undefined;
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value!: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeTypeHandle {
    value: IntPtr;
}

export class SMSCampaignStatusSummaryDto implements ISMSCampaignStatusSummaryDto {
    draft!: number;
    active!: number;
    sent!: number;
    failed!: number;
    paused!: number;
    running!: number;
    total!: number;

    constructor(data?: ISMSCampaignStatusSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draft = _data["draft"];
            this.active = _data["active"];
            this.sent = _data["sent"];
            this.failed = _data["failed"];
            this.paused = _data["paused"];
            this.running = _data["running"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): SMSCampaignStatusSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSCampaignStatusSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draft"] = this.draft;
        data["active"] = this.active;
        data["sent"] = this.sent;
        data["failed"] = this.failed;
        data["paused"] = this.paused;
        data["running"] = this.running;
        data["total"] = this.total;
        return data;
    }
}

export interface ISMSCampaignStatusSummaryDto {
    draft: number;
    active: number;
    sent: number;
    failed: number;
    paused: number;
    running: number;
    total: number;
}

export class SafeWaitHandle implements ISafeWaitHandle {
    readonly isClosed!: boolean;
    readonly isInvalid!: boolean;

    constructor(data?: ISafeWaitHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isClosed = _data["isClosed"];
            (<any>this).isInvalid = _data["isInvalid"];
        }
    }

    static fromJS(data: any): SafeWaitHandle {
        data = typeof data === 'object' ? data : {};
        let result = new SafeWaitHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isClosed"] = this.isClosed;
        data["isInvalid"] = this.isInvalid;
        return data;
    }
}

export interface ISafeWaitHandle {
    isClosed: boolean;
    isInvalid: boolean;
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SaveDocumentTemplateFieldDto implements ISaveDocumentTemplateFieldDto {
    fieldType!: PredefinedFieldType;
    pageNumber!: number;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: ISaveDocumentTemplateFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldType = _data["fieldType"];
            this.pageNumber = _data["pageNumber"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): SaveDocumentTemplateFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDocumentTemplateFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType;
        data["pageNumber"] = this.pageNumber;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface ISaveDocumentTemplateFieldDto {
    fieldType: PredefinedFieldType;
    pageNumber: number;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class SaveGridPreferenceInput implements ISaveGridPreferenceInput {
    gridKey!: string;
    columns!: string[];

    constructor(data?: ISaveGridPreferenceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.columns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gridKey = _data["gridKey"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveGridPreferenceInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGridPreferenceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridKey"] = this.gridKey;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }
}

export interface ISaveGridPreferenceInput {
    gridKey: string;
    columns: string[];
}

export class SaveHostContentTemplateDetailDto implements ISaveHostContentTemplateDetailDto {
    templateId!: number;
    languageId!: number | undefined;
    subject!: string | undefined;
    bodyContent!: string;
    isBodyHtml!: boolean;

    constructor(data?: ISaveHostContentTemplateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
        }
    }

    static fromJS(data: any): SaveHostContentTemplateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveHostContentTemplateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        return data;
    }
}

export interface ISaveHostContentTemplateDetailDto {
    templateId: number;
    languageId: number | undefined;
    subject: string | undefined;
    bodyContent: string;
    isBodyHtml: boolean;
}

export class SaveIwpGeneratorDraftInput implements ISaveIwpGeneratorDraftInput {
    name!: string;
    stOccupationType!: string;
    stPositionAndCompany!: string | undefined;
    stExpectedStartDate!: string | undefined;
    stWeeklyWorkHours!: string;
    stAnticipatedWages!: string;
    stEducationTrainingPlans!: string | undefined;
    stTransitionStatement!: string | undefined;
    skillsToDevelop!: string | undefined;
    accommodationNeeds!: string | undefined;
    ltOccupationType!: string;
    ltPositionAndCompany!: string | undefined;
    ltExpectedStartDate!: string | undefined;
    ltWeeklyWorkHours!: string;
    ltAnticipatedWages!: string;
    ltReasonForOccupationSelection!: string;
    ltEducationTrainingPlans!: string | undefined;

    constructor(data?: ISaveIwpGeneratorDraftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.stOccupationType = _data["stOccupationType"];
            this.stPositionAndCompany = _data["stPositionAndCompany"];
            this.stExpectedStartDate = _data["stExpectedStartDate"];
            this.stWeeklyWorkHours = _data["stWeeklyWorkHours"];
            this.stAnticipatedWages = _data["stAnticipatedWages"];
            this.stEducationTrainingPlans = _data["stEducationTrainingPlans"];
            this.stTransitionStatement = _data["stTransitionStatement"];
            this.skillsToDevelop = _data["skillsToDevelop"];
            this.accommodationNeeds = _data["accommodationNeeds"];
            this.ltOccupationType = _data["ltOccupationType"];
            this.ltPositionAndCompany = _data["ltPositionAndCompany"];
            this.ltExpectedStartDate = _data["ltExpectedStartDate"];
            this.ltWeeklyWorkHours = _data["ltWeeklyWorkHours"];
            this.ltAnticipatedWages = _data["ltAnticipatedWages"];
            this.ltReasonForOccupationSelection = _data["ltReasonForOccupationSelection"];
            this.ltEducationTrainingPlans = _data["ltEducationTrainingPlans"];
        }
    }

    static fromJS(data: any): SaveIwpGeneratorDraftInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIwpGeneratorDraftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stOccupationType"] = this.stOccupationType;
        data["stPositionAndCompany"] = this.stPositionAndCompany;
        data["stExpectedStartDate"] = this.stExpectedStartDate;
        data["stWeeklyWorkHours"] = this.stWeeklyWorkHours;
        data["stAnticipatedWages"] = this.stAnticipatedWages;
        data["stEducationTrainingPlans"] = this.stEducationTrainingPlans;
        data["stTransitionStatement"] = this.stTransitionStatement;
        data["skillsToDevelop"] = this.skillsToDevelop;
        data["accommodationNeeds"] = this.accommodationNeeds;
        data["ltOccupationType"] = this.ltOccupationType;
        data["ltPositionAndCompany"] = this.ltPositionAndCompany;
        data["ltExpectedStartDate"] = this.ltExpectedStartDate;
        data["ltWeeklyWorkHours"] = this.ltWeeklyWorkHours;
        data["ltAnticipatedWages"] = this.ltAnticipatedWages;
        data["ltReasonForOccupationSelection"] = this.ltReasonForOccupationSelection;
        data["ltEducationTrainingPlans"] = this.ltEducationTrainingPlans;
        return data;
    }
}

export interface ISaveIwpGeneratorDraftInput {
    name: string;
    stOccupationType: string;
    stPositionAndCompany: string | undefined;
    stExpectedStartDate: string | undefined;
    stWeeklyWorkHours: string;
    stAnticipatedWages: string;
    stEducationTrainingPlans: string | undefined;
    stTransitionStatement: string | undefined;
    skillsToDevelop: string | undefined;
    accommodationNeeds: string | undefined;
    ltOccupationType: string;
    ltPositionAndCompany: string | undefined;
    ltExpectedStartDate: string | undefined;
    ltWeeklyWorkHours: string;
    ltAnticipatedWages: string;
    ltReasonForOccupationSelection: string;
    ltEducationTrainingPlans: string | undefined;
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.application = _data["application"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export class SavePartnerAgreementTextDto implements ISavePartnerAgreementTextDto {
    partnerId!: number;
    agreementText!: string;

    constructor(data?: ISavePartnerAgreementTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.agreementText = _data["agreementText"];
        }
    }

    static fromJS(data: any): SavePartnerAgreementTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePartnerAgreementTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["agreementText"] = this.agreementText;
        return data;
    }
}

export interface ISavePartnerAgreementTextDto {
    partnerId: number;
    agreementText: string;
}

export class SaveResumeDraftInput implements ISaveResumeDraftInput {
    id!: number;
    content!: ResumeContentDto;

    constructor(data?: ISaveResumeDraftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new ResumeContentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"] ? ResumeContentDto.fromJS(_data["content"]) : new ResumeContentDto();
        }
    }

    static fromJS(data: any): SaveResumeDraftInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResumeDraftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveResumeDraftInput {
    id: number;
    content: ResumeContentDto;
}

export class SaveResumeWorksheetForTicketHolderInput implements ISaveResumeWorksheetForTicketHolderInput {
    ticketHolderId!: number;
    worksheetId!: number | undefined;
    data!: ResumeWorksheetDataDto;
    submit!: boolean;

    constructor(data?: ISaveResumeWorksheetForTicketHolderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new ResumeWorksheetDataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.worksheetId = _data["worksheetId"];
            this.data = _data["data"] ? ResumeWorksheetDataDto.fromJS(_data["data"]) : new ResumeWorksheetDataDto();
            this.submit = _data["submit"];
        }
    }

    static fromJS(data: any): SaveResumeWorksheetForTicketHolderInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveResumeWorksheetForTicketHolderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["worksheetId"] = this.worksheetId;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["submit"] = this.submit;
        return data;
    }
}

export interface ISaveResumeWorksheetForTicketHolderInput {
    ticketHolderId: number;
    worksheetId: number | undefined;
    data: ResumeWorksheetDataDto;
    submit: boolean;
}

export class SaveTicketHolderIWPInput implements ISaveTicketHolderIWPInput {
    ticketHolderId!: number;
    isComplete!: boolean;
    saveAsDraft!: boolean;
    iwp!: IWPDdto;
    sectionOne!: IWPSectionOneDto;
    background!: DurationModalityDto;
    workHistories!: IWPWorkHistoryDto[] | undefined;
    sectionThree!: IWPSectionThreeDto;
    sectionFour!: IWPSectionFourDto;
    otherTermsConditions!: boolean;
    otherTermsConditionsExplanation!: string | undefined;
    userInputDurationInMinutes!: number;

    constructor(data?: ISaveTicketHolderIWPInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.iwp = new IWPDdto();
            this.sectionOne = new IWPSectionOneDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.isComplete = _data["isComplete"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.iwp = _data["iwp"] ? IWPDdto.fromJS(_data["iwp"]) : new IWPDdto();
            this.sectionOne = _data["sectionOne"] ? IWPSectionOneDto.fromJS(_data["sectionOne"]) : new IWPSectionOneDto();
            this.background = _data["background"] ? DurationModalityDto.fromJS(_data["background"]) : <any>undefined;
            if (Array.isArray(_data["workHistories"])) {
                this.workHistories = [] as any;
                for (let item of _data["workHistories"])
                    this.workHistories!.push(IWPWorkHistoryDto.fromJS(item));
            }
            this.sectionThree = _data["sectionThree"] ? IWPSectionThreeDto.fromJS(_data["sectionThree"]) : <any>undefined;
            this.sectionFour = _data["sectionFour"] ? IWPSectionFourDto.fromJS(_data["sectionFour"]) : <any>undefined;
            this.otherTermsConditions = _data["otherTermsConditions"];
            this.otherTermsConditionsExplanation = _data["otherTermsConditionsExplanation"];
            this.userInputDurationInMinutes = _data["userInputDurationInMinutes"];
        }
    }

    static fromJS(data: any): SaveTicketHolderIWPInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTicketHolderIWPInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["isComplete"] = this.isComplete;
        data["saveAsDraft"] = this.saveAsDraft;
        data["iwp"] = this.iwp ? this.iwp.toJSON() : <any>undefined;
        data["sectionOne"] = this.sectionOne ? this.sectionOne.toJSON() : <any>undefined;
        data["background"] = this.background ? this.background.toJSON() : <any>undefined;
        if (Array.isArray(this.workHistories)) {
            data["workHistories"] = [];
            for (let item of this.workHistories)
                data["workHistories"].push(item.toJSON());
        }
        data["sectionThree"] = this.sectionThree ? this.sectionThree.toJSON() : <any>undefined;
        data["sectionFour"] = this.sectionFour ? this.sectionFour.toJSON() : <any>undefined;
        data["otherTermsConditions"] = this.otherTermsConditions;
        data["otherTermsConditionsExplanation"] = this.otherTermsConditionsExplanation;
        data["userInputDurationInMinutes"] = this.userInputDurationInMinutes;
        return data;
    }
}

export interface ISaveTicketHolderIWPInput {
    ticketHolderId: number;
    isComplete: boolean;
    saveAsDraft: boolean;
    iwp: IWPDdto;
    sectionOne: IWPSectionOneDto;
    background: DurationModalityDto;
    workHistories: IWPWorkHistoryDto[] | undefined;
    sectionThree: IWPSectionThreeDto;
    sectionFour: IWPSectionFourDto;
    otherTermsConditions: boolean;
    otherTermsConditionsExplanation: string | undefined;
    userInputDurationInMinutes: number;
}

export class ScheduleDemoListDto implements IScheduleDemoListDto {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    organizationName!: string | undefined;
    role!: string | undefined;
    preferredTime!: PreferredDemoTime;
    preferredTimeDisplay!: string | undefined;
    preferredDate!: DateTime | undefined;
    note!: string | undefined;
    networkType!: NetworkType;
    networkTypeDisplay!: string | undefined;
    meetingLink!: string | undefined;
    scheduledStartTimeUtc!: DateTime | undefined;
    scheduledEndTimeUtc!: DateTime | undefined;
    meetingSubject!: string | undefined;
    meetingBody!: string | undefined;
    isRead!: boolean;
    status!: ScheduleDemoStatus;
    statusDisplay!: string | undefined;
    creationTime!: DateTime;
    joinedByUserId!: number | undefined;
    joinedByName!: string | undefined;
    joinedAtUtc!: DateTime | undefined;

    constructor(data?: IScheduleDemoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.organizationName = _data["organizationName"];
            this.role = _data["role"];
            this.preferredTime = _data["preferredTime"];
            this.preferredTimeDisplay = _data["preferredTimeDisplay"];
            this.preferredDate = _data["preferredDate"] ? DateTime.fromISO(_data["preferredDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.networkType = _data["networkType"];
            this.networkTypeDisplay = _data["networkTypeDisplay"];
            this.meetingLink = _data["meetingLink"];
            this.scheduledStartTimeUtc = _data["scheduledStartTimeUtc"] ? DateTime.fromISO(_data["scheduledStartTimeUtc"].toString()) : <any>undefined;
            this.scheduledEndTimeUtc = _data["scheduledEndTimeUtc"] ? DateTime.fromISO(_data["scheduledEndTimeUtc"].toString()) : <any>undefined;
            this.meetingSubject = _data["meetingSubject"];
            this.meetingBody = _data["meetingBody"];
            this.isRead = _data["isRead"];
            this.status = _data["status"];
            this.statusDisplay = _data["statusDisplay"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.joinedByUserId = _data["joinedByUserId"];
            this.joinedByName = _data["joinedByName"];
            this.joinedAtUtc = _data["joinedAtUtc"] ? DateTime.fromISO(_data["joinedAtUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleDemoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDemoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["organizationName"] = this.organizationName;
        data["role"] = this.role;
        data["preferredTime"] = this.preferredTime;
        data["preferredTimeDisplay"] = this.preferredTimeDisplay;
        data["preferredDate"] = this.preferredDate ? this.preferredDate.toString() : <any>undefined;
        data["note"] = this.note;
        data["networkType"] = this.networkType;
        data["networkTypeDisplay"] = this.networkTypeDisplay;
        data["meetingLink"] = this.meetingLink;
        data["scheduledStartTimeUtc"] = this.scheduledStartTimeUtc ? this.scheduledStartTimeUtc.toString() : <any>undefined;
        data["scheduledEndTimeUtc"] = this.scheduledEndTimeUtc ? this.scheduledEndTimeUtc.toString() : <any>undefined;
        data["meetingSubject"] = this.meetingSubject;
        data["meetingBody"] = this.meetingBody;
        data["isRead"] = this.isRead;
        data["status"] = this.status;
        data["statusDisplay"] = this.statusDisplay;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["joinedByUserId"] = this.joinedByUserId;
        data["joinedByName"] = this.joinedByName;
        data["joinedAtUtc"] = this.joinedAtUtc ? this.joinedAtUtc.toString() : <any>undefined;
        return data;
    }
}

export interface IScheduleDemoListDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    organizationName: string | undefined;
    role: string | undefined;
    preferredTime: PreferredDemoTime;
    preferredTimeDisplay: string | undefined;
    preferredDate: DateTime | undefined;
    note: string | undefined;
    networkType: NetworkType;
    networkTypeDisplay: string | undefined;
    meetingLink: string | undefined;
    scheduledStartTimeUtc: DateTime | undefined;
    scheduledEndTimeUtc: DateTime | undefined;
    meetingSubject: string | undefined;
    meetingBody: string | undefined;
    isRead: boolean;
    status: ScheduleDemoStatus;
    statusDisplay: string | undefined;
    creationTime: DateTime;
    joinedByUserId: number | undefined;
    joinedByName: string | undefined;
    joinedAtUtc: DateTime | undefined;
}

export enum ScheduleDemoStatus {
    New = 0,
    Read = 1,
    Presented = 2,
    Cancelled = 3,
}

/** What a Host Admin submits from the Outlook-style "Schedule Meeting" form in Administration > Schedule Demo to finalize and send a demo meeting. */
export class ScheduleMeetingInputDto implements IScheduleMeetingInputDto {
    id!: number;
    subject!: string;
    startTimeUtc!: DateTime;
    endTimeUtc!: DateTime;
    body!: string | undefined;
    location!: string | undefined;
    /** Extra recipients beyond the original requester, added by the Host Admin in the "To" field. */
    additionalToEmails!: string[] | undefined;

    constructor(data?: IScheduleMeetingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startTimeUtc = _data["startTimeUtc"] ? DateTime.fromISO(_data["startTimeUtc"].toString()) : <any>undefined;
            this.endTimeUtc = _data["endTimeUtc"] ? DateTime.fromISO(_data["endTimeUtc"].toString()) : <any>undefined;
            this.body = _data["body"];
            this.location = _data["location"];
            if (Array.isArray(_data["additionalToEmails"])) {
                this.additionalToEmails = [] as any;
                for (let item of _data["additionalToEmails"])
                    this.additionalToEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): ScheduleMeetingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleMeetingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startTimeUtc"] = this.startTimeUtc ? this.startTimeUtc.toString() : <any>undefined;
        data["endTimeUtc"] = this.endTimeUtc ? this.endTimeUtc.toString() : <any>undefined;
        data["body"] = this.body;
        data["location"] = this.location;
        if (Array.isArray(this.additionalToEmails)) {
            data["additionalToEmails"] = [];
            for (let item of this.additionalToEmails)
                data["additionalToEmails"].push(item);
        }
        return data;
    }
}

/** What a Host Admin submits from the Outlook-style "Schedule Meeting" form in Administration > Schedule Demo to finalize and send a demo meeting. */
export interface IScheduleMeetingInputDto {
    id: number;
    subject: string;
    startTimeUtc: DateTime;
    endTimeUtc: DateTime;
    body: string | undefined;
    location: string | undefined;
    /** Extra recipients beyond the original requester, added by the Host Admin in the "To" field. */
    additionalToEmails: string[] | undefined;
}

export class ScheduleTaskInput implements IScheduleTaskInput {
    taskId!: number;
    futureRunTime!: DateTime;

    constructor(data?: IScheduleTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.futureRunTime = _data["futureRunTime"] ? DateTime.fromISO(_data["futureRunTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["futureRunTime"] = this.futureRunTime ? this.futureRunTime.toString() : <any>undefined;
        return data;
    }
}

export interface IScheduleTaskInput {
    taskId: number;
    futureRunTime: DateTime;
}

export class SearchAvailableTwilioNumbersInput implements ISearchAvailableTwilioNumbersInput {
    partOfPhoneNumber!: string | undefined;

    constructor(data?: ISearchAvailableTwilioNumbersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partOfPhoneNumber = _data["partOfPhoneNumber"];
        }
    }

    static fromJS(data: any): SearchAvailableTwilioNumbersInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAvailableTwilioNumbersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partOfPhoneNumber"] = this.partOfPhoneNumber;
        return data;
    }
}

export interface ISearchAvailableTwilioNumbersInput {
    partOfPhoneNumber: string | undefined;
}

export class SearchLeadDto implements ISearchLeadDto {
    id!: number;
    leadId!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: ISearchLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SearchLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISearchLeadDto {
    id: number;
    leadId: string | undefined;
    fullName: string | undefined;
}

export class SearchTicketHolderDto implements ISearchTicketHolderDto {
    id!: number;
    ticketHolderId!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: ISearchTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SearchTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISearchTicketHolderDto {
    id: number;
    ticketHolderId: string | undefined;
    fullName: string | undefined;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;
    userPasswordSettings!: UserPasswordSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
            this.userPasswordSettings = _data["userPasswordSettings"] ? UserPasswordSettingsEditDto.fromJS(_data["userPasswordSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        data["userPasswordSettings"] = this.userPasswordSettings ? this.userPasswordSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
    userPasswordSettings: UserPasswordSettingsEditDto;
}

export class SendAndGetDateWithTextInput implements ISendAndGetDateWithTextInput {
    text!: string | undefined;
    date!: DateTime;

    constructor(data?: ISendAndGetDateWithTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SendAndGetDateWithTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendAndGetDateWithTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        return data;
    }
}

export interface ISendAndGetDateWithTextInput {
    text: string | undefined;
    date: DateTime;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;
    captchaResponse!: string | undefined;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
    captchaResponse: string | undefined;
}

export class SendMarketingContactEmailInput implements ISendMarketingContactEmailInput {
    contactId!: number;
    templateId!: number | undefined;
    subject!: string;
    body!: string;
    cc!: string | undefined;
    copyMe!: boolean;

    constructor(data?: ISendMarketingContactEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.templateId = _data["templateId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.cc = _data["cc"];
            this.copyMe = _data["copyMe"];
        }
    }

    static fromJS(data: any): SendMarketingContactEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendMarketingContactEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["templateId"] = this.templateId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["cc"] = this.cc;
        data["copyMe"] = this.copyMe;
        return data;
    }
}

export interface ISendMarketingContactEmailInput {
    contactId: number;
    templateId: number | undefined;
    subject: string;
    body: string;
    cc: string | undefined;
    copyMe: boolean;
}

export class SendMassSmsInput implements ISendMassSmsInput {
    message!: string;
    userId!: number | undefined;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    recipients!: SmsRecipientDto[];

    constructor(data?: ISendMassSmsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recipients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.userId = _data["userId"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(SmsRecipientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendMassSmsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendMassSmsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["userId"] = this.userId;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendMassSmsInput {
    message: string;
    userId: number | undefined;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    recipients: SmsRecipientDto[];
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SendPasswordlessLoginCodeInput implements ISendPasswordlessLoginCodeInput {
    providerValue!: string | undefined;
    providerType!: PasswordlessLoginProviderType;

    constructor(data?: ISendPasswordlessLoginCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerValue = _data["providerValue"];
            this.providerType = _data["providerType"];
        }
    }

    static fromJS(data: any): SendPasswordlessLoginCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordlessLoginCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerValue"] = this.providerValue;
        data["providerType"] = this.providerType;
        return data;
    }
}

export interface ISendPasswordlessLoginCodeInput {
    providerValue: string | undefined;
    providerType: PasswordlessLoginProviderType;
}

export class SendPaystubsToSSAFaxDto implements ISendPaystubsToSSAFaxDto {
    ticketHolderId!: number;
    payHistoryIds!: number[];

    constructor(data?: ISendPaystubsToSSAFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payHistoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            if (Array.isArray(_data["payHistoryIds"])) {
                this.payHistoryIds = [] as any;
                for (let item of _data["payHistoryIds"])
                    this.payHistoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendPaystubsToSSAFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendPaystubsToSSAFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        if (Array.isArray(this.payHistoryIds)) {
            data["payHistoryIds"] = [];
            for (let item of this.payHistoryIds)
                data["payHistoryIds"].push(item);
        }
        return data;
    }
}

export interface ISendPaystubsToSSAFaxDto {
    ticketHolderId: number;
    payHistoryIds: number[];
}

export class SendPreparedPaystubFaxDto implements ISendPreparedPaystubFaxDto {
    ticketHolderId!: number;
    faxPacketDocumentId!: number;
    payHistoryIds!: number[] | undefined;

    constructor(data?: ISendPreparedPaystubFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.faxPacketDocumentId = _data["faxPacketDocumentId"];
            if (Array.isArray(_data["payHistoryIds"])) {
                this.payHistoryIds = [] as any;
                for (let item of _data["payHistoryIds"])
                    this.payHistoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendPreparedPaystubFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendPreparedPaystubFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["faxPacketDocumentId"] = this.faxPacketDocumentId;
        if (Array.isArray(this.payHistoryIds)) {
            data["payHistoryIds"] = [];
            for (let item of this.payHistoryIds)
                data["payHistoryIds"].push(item);
        }
        return data;
    }
}

export interface ISendPreparedPaystubFaxDto {
    ticketHolderId: number;
    faxPacketDocumentId: number;
    payHistoryIds: number[] | undefined;
}

export class SendSmsInput implements ISendSmsInput {
    serviceType!: ActivityServiceType;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    clientName!: string | undefined;
    clientId!: string;
    mobilePhoneNumber!: string;
    message!: string;

    constructor(data?: ISendSmsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceType = _data["serviceType"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendSmsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceType"] = this.serviceType;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendSmsInput {
    serviceType: ActivityServiceType;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    clientName: string | undefined;
    clientId: string;
    mobilePhoneNumber: string;
    message: string;
}

export class SendSmsResultDto implements ISendSmsResultDto {
    messageId!: string | undefined;
    status!: string | undefined;
    to!: string | undefined;
    from!: string | undefined;
    sentDate!: DateTime | undefined;
    errorMessage!: string | undefined;
    errorCode!: number | undefined;
    rawJson!: string | undefined;

    constructor(data?: ISendSmsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.status = _data["status"];
            this.to = _data["to"];
            this.from = _data["from"];
            this.sentDate = _data["sentDate"] ? DateTime.fromISO(_data["sentDate"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            this.rawJson = _data["rawJson"];
        }
    }

    static fromJS(data: any): SendSmsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["status"] = this.status;
        data["to"] = this.to;
        data["from"] = this.from;
        data["sentDate"] = this.sentDate ? this.sentDate.toString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        data["rawJson"] = this.rawJson;
        return data;
    }
}

export interface ISendSmsResultDto {
    messageId: string | undefined;
    status: string | undefined;
    to: string | undefined;
    from: string | undefined;
    sentDate: DateTime | undefined;
    errorMessage: string | undefined;
    errorCode: number | undefined;
    rawJson: string | undefined;
}

export class SendSuitabilityInstructionsInput implements ISendSuitabilityInstructionsInput {
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: ISendSuitabilityInstructionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendSuitabilityInstructionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendSuitabilityInstructionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface ISendSuitabilityInstructionsInput {
    firstName: string;
    lastName: string;
    email: string;
}

export class SendSuitabilityPackageInput implements ISendSuitabilityPackageInput {
    requestId!: number;
    subject!: string;
    body!: string;

    constructor(data?: ISendSuitabilityPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendSuitabilityPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendSuitabilityPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface ISendSuitabilityPackageInput {
    requestId: number;
    subject: string;
    body: string;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class SenderFaxInfo implements ISenderFaxInfo {
    name!: string | undefined;
    ssaFax!: string | undefined;
    address!: string | undefined;
    telePhone!: string | undefined;
    email!: string | undefined;

    constructor(data?: ISenderFaxInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ssaFax = _data["ssaFax"];
            this.address = _data["address"];
            this.telePhone = _data["telePhone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SenderFaxInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SenderFaxInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ssaFax"] = this.ssaFax;
        data["address"] = this.address;
        data["telePhone"] = this.telePhone;
        data["email"] = this.email;
        return data;
    }
}

export interface ISenderFaxInfo {
    name: string | undefined;
    ssaFax: string | undefined;
    address: string | undefined;
    telePhone: string | undefined;
    email: string | undefined;
}

export class ServiceRequestFilter implements IServiceRequestFilter {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    ticketHolderId!: number;
    startDueDate!: DateTime | undefined;
    endDueDate!: DateTime | undefined;
    serviceType!: ServiceType[] | undefined;
    status!: ServiceRequestStatus[] | undefined;

    constructor(data?: IServiceRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.startDueDate = _data["startDueDate"] ? DateTime.fromISO(_data["startDueDate"].toString()) : <any>undefined;
            this.endDueDate = _data["endDueDate"] ? DateTime.fromISO(_data["endDueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["serviceType"])) {
                this.serviceType = [] as any;
                for (let item of _data["serviceType"])
                    this.serviceType!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceRequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["ticketHolderId"] = this.ticketHolderId;
        data["startDueDate"] = this.startDueDate ? this.startDueDate.toString() : <any>undefined;
        data["endDueDate"] = this.endDueDate ? this.endDueDate.toString() : <any>undefined;
        if (Array.isArray(this.serviceType)) {
            data["serviceType"] = [];
            for (let item of this.serviceType)
                data["serviceType"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        return data;
    }
}

export interface IServiceRequestFilter {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    ticketHolderId: number;
    startDueDate: DateTime | undefined;
    endDueDate: DateTime | undefined;
    serviceType: ServiceType[] | undefined;
    status: ServiceRequestStatus[] | undefined;
}

export enum ServiceRequestStatus {
    Pending = 0,
    Approved = 1,
    InProgress = 2,
    Completed = 3,
    Closed = 4,
}

export enum ServiceType {
    Transportation = 0,
    Education = 1,
    Housing = 2,
    Resume = 3,
    Advocacy = 4,
    InterviewAssistance = 5,
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class SetChecklistItemDoneInput implements ISetChecklistItemDoneInput {
    id!: number;
    isDone!: boolean;

    constructor(data?: ISetChecklistItemDoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDone = _data["isDone"];
        }
    }

    static fromJS(data: any): SetChecklistItemDoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetChecklistItemDoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDone"] = this.isDone;
        return data;
    }
}

export interface ISetChecklistItemDoneInput {
    id: number;
    isDone: boolean;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class SetMarketingOrganizationStageInput implements ISetMarketingOrganizationStageInput {
    organizationIds!: number[];
    stage!: MarketingRelationshipStage;
    note!: string | undefined;

    constructor(data?: ISetMarketingOrganizationStageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organizationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            this.stage = _data["stage"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SetMarketingOrganizationStageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetMarketingOrganizationStageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        data["stage"] = this.stage;
        data["note"] = this.note;
        return data;
    }
}

export interface ISetMarketingOrganizationStageInput {
    organizationIds: number[];
    stage: MarketingRelationshipStage;
    note: string | undefined;
}

export class SetNotificationAsReadOutput implements ISetNotificationAsReadOutput {
    success!: boolean;

    constructor(data?: ISetNotificationAsReadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SetNotificationAsReadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SetNotificationAsReadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISetNotificationAsReadOutput {
    success: boolean;
}

export class SetPartnerShowOnWebsiteDto implements ISetPartnerShowOnWebsiteDto {
    sessionToken!: string;
    showOnWebsite!: boolean;

    constructor(data?: ISetPartnerShowOnWebsiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.showOnWebsite = _data["showOnWebsite"];
        }
    }

    static fromJS(data: any): SetPartnerShowOnWebsiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetPartnerShowOnWebsiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["showOnWebsite"] = this.showOnWebsite;
        return data;
    }
}

export interface ISetPartnerShowOnWebsiteDto {
    sessionToken: string;
    showOnWebsite: boolean;
}

export class Setting implements ISetting {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISetting {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class ShortMessageTemplate implements IShortMessageTemplate {
    templateName!: string;
    templateType!: MessageTemplateType;
    subject!: string | undefined;
    body!: string | undefined;

    constructor(data?: IShortMessageTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["templateName"];
            this.templateType = _data["templateType"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): ShortMessageTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ShortMessageTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["templateType"] = this.templateType;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IShortMessageTemplate {
    templateName: string;
    templateType: MessageTemplateType;
    subject: string | undefined;
    body: string | undefined;
}

export class SignedIWPListItemDto implements ISignedIWPListItemDto {
    iwpId!: number;
    ticketHolderId!: number;
    ticketHolderDisplayId!: string | undefined;
    ticketHolderName!: string | undefined;
    enInterviewerName!: string | undefined;
    amendedFromIWPId!: number | undefined;
    signedDate!: DateTime;
    signedDocumentId!: number;
    ticketAssignmentDate!: DateTime | undefined;
    faxSentCount!: number;
    lastFaxSentAt!: DateTime | undefined;
    lastFaxSentByName!: string | undefined;
    lastFaxStatus!: ActivityStatus;
    lastFaxStatusDisplay!: string | undefined;

    constructor(data?: ISignedIWPListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderDisplayId = _data["ticketHolderDisplayId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.enInterviewerName = _data["enInterviewerName"];
            this.amendedFromIWPId = _data["amendedFromIWPId"];
            this.signedDate = _data["signedDate"] ? DateTime.fromISO(_data["signedDate"].toString()) : <any>undefined;
            this.signedDocumentId = _data["signedDocumentId"];
            this.ticketAssignmentDate = _data["ticketAssignmentDate"] ? DateTime.fromISO(_data["ticketAssignmentDate"].toString()) : <any>undefined;
            this.faxSentCount = _data["faxSentCount"];
            this.lastFaxSentAt = _data["lastFaxSentAt"] ? DateTime.fromISO(_data["lastFaxSentAt"].toString()) : <any>undefined;
            this.lastFaxSentByName = _data["lastFaxSentByName"];
            this.lastFaxStatus = _data["lastFaxStatus"];
            this.lastFaxStatusDisplay = _data["lastFaxStatusDisplay"];
        }
    }

    static fromJS(data: any): SignedIWPListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignedIWPListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderDisplayId"] = this.ticketHolderDisplayId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["enInterviewerName"] = this.enInterviewerName;
        data["amendedFromIWPId"] = this.amendedFromIWPId;
        data["signedDate"] = this.signedDate ? this.signedDate.toString() : <any>undefined;
        data["signedDocumentId"] = this.signedDocumentId;
        data["ticketAssignmentDate"] = this.ticketAssignmentDate ? this.ticketAssignmentDate.toString() : <any>undefined;
        data["faxSentCount"] = this.faxSentCount;
        data["lastFaxSentAt"] = this.lastFaxSentAt ? this.lastFaxSentAt.toString() : <any>undefined;
        data["lastFaxSentByName"] = this.lastFaxSentByName;
        data["lastFaxStatus"] = this.lastFaxStatus;
        data["lastFaxStatusDisplay"] = this.lastFaxStatusDisplay;
        return data;
    }
}

export interface ISignedIWPListItemDto {
    iwpId: number;
    ticketHolderId: number;
    ticketHolderDisplayId: string | undefined;
    ticketHolderName: string | undefined;
    enInterviewerName: string | undefined;
    amendedFromIWPId: number | undefined;
    signedDate: DateTime;
    signedDocumentId: number;
    ticketAssignmentDate: DateTime | undefined;
    faxSentCount: number;
    lastFaxSentAt: DateTime | undefined;
    lastFaxSentByName: string | undefined;
    lastFaxStatus: ActivityStatus;
    lastFaxStatusDisplay: string | undefined;
}

export class SimpleNotificationItemDto implements ISimpleNotificationItemDto {
    creationTime!: DateTime;
    type!: string | undefined;
    message!: string | undefined;

    constructor(data?: ISimpleNotificationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SimpleNotificationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleNotificationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["type"] = this.type;
        data["message"] = this.message;
        return data;
    }
}

export interface ISimpleNotificationItemDto {
    creationTime: DateTime;
    type: string | undefined;
    message: string | undefined;
}

export class SmartSetupJobSearchRequestDto implements ISmartSetupJobSearchRequestDto {
    jobSearchKeywords!: string | undefined;
    workArrangement!: number | undefined;
    jobSearchType!: number | undefined;
    isSalaryRangeHourly!: boolean;
    salaryRangeStart!: number | undefined;
    salaryRangeEnd!: number | undefined;
    desiredJobCount!: number | undefined;
    maxTravelDistance!: number | undefined;
    maxTravelTime!: number | undefined;
    skillsQualifications!: string | undefined;
    instructions!: string | undefined;
    sources!: SmartSetupSourcesDto;
    benefitWarning!: string | undefined;
    aiRationale!: string | undefined;

    constructor(data?: ISmartSetupJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchKeywords = _data["jobSearchKeywords"];
            this.workArrangement = _data["workArrangement"];
            this.jobSearchType = _data["jobSearchType"];
            this.isSalaryRangeHourly = _data["isSalaryRangeHourly"];
            this.salaryRangeStart = _data["salaryRangeStart"];
            this.salaryRangeEnd = _data["salaryRangeEnd"];
            this.desiredJobCount = _data["desiredJobCount"];
            this.maxTravelDistance = _data["maxTravelDistance"];
            this.maxTravelTime = _data["maxTravelTime"];
            this.skillsQualifications = _data["skillsQualifications"];
            this.instructions = _data["instructions"];
            this.sources = _data["sources"] ? SmartSetupSourcesDto.fromJS(_data["sources"]) : <any>undefined;
            this.benefitWarning = _data["benefitWarning"];
            this.aiRationale = _data["aiRationale"];
        }
    }

    static fromJS(data: any): SmartSetupJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartSetupJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchKeywords"] = this.jobSearchKeywords;
        data["workArrangement"] = this.workArrangement;
        data["jobSearchType"] = this.jobSearchType;
        data["isSalaryRangeHourly"] = this.isSalaryRangeHourly;
        data["salaryRangeStart"] = this.salaryRangeStart;
        data["salaryRangeEnd"] = this.salaryRangeEnd;
        data["desiredJobCount"] = this.desiredJobCount;
        data["maxTravelDistance"] = this.maxTravelDistance;
        data["maxTravelTime"] = this.maxTravelTime;
        data["skillsQualifications"] = this.skillsQualifications;
        data["instructions"] = this.instructions;
        data["sources"] = this.sources ? this.sources.toJSON() : <any>undefined;
        data["benefitWarning"] = this.benefitWarning;
        data["aiRationale"] = this.aiRationale;
        return data;
    }
}

export interface ISmartSetupJobSearchRequestDto {
    jobSearchKeywords: string | undefined;
    workArrangement: number | undefined;
    jobSearchType: number | undefined;
    isSalaryRangeHourly: boolean;
    salaryRangeStart: number | undefined;
    salaryRangeEnd: number | undefined;
    desiredJobCount: number | undefined;
    maxTravelDistance: number | undefined;
    maxTravelTime: number | undefined;
    skillsQualifications: string | undefined;
    instructions: string | undefined;
    sources: SmartSetupSourcesDto;
    benefitWarning: string | undefined;
    aiRationale: string | undefined;
}

export class SmartSetupSourcesDto implements ISmartSetupSourcesDto {
    hasTicketToWork!: boolean;
    hasIwp!: boolean;
    hasResume!: boolean;

    constructor(data?: ISmartSetupSourcesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTicketToWork = _data["hasTicketToWork"];
            this.hasIwp = _data["hasIwp"];
            this.hasResume = _data["hasResume"];
        }
    }

    static fromJS(data: any): SmartSetupSourcesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartSetupSourcesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTicketToWork"] = this.hasTicketToWork;
        data["hasIwp"] = this.hasIwp;
        data["hasResume"] = this.hasResume;
        return data;
    }
}

export interface ISmartSetupSourcesDto {
    hasTicketToWork: boolean;
    hasIwp: boolean;
    hasResume: boolean;
}

export class SmsLogDto implements ISmsLogDto {
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    clientName!: string | undefined;
    clientId!: string | undefined;
    mobilePhoneNumber!: string | undefined;
    messageContent!: string | undefined;
    status!: ActivityStatus;
    readonly statusDisplayName!: string | undefined;
    attachmentsIds!: number[] | undefined;
    errorMessage!: string | undefined;
    messageId!: string | undefined;
    rawData!: string | undefined;
    logType!: LogType;

    constructor(data?: ISmsLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.messageContent = _data["messageContent"];
            this.status = _data["status"];
            (<any>this).statusDisplayName = _data["statusDisplayName"];
            if (Array.isArray(_data["attachmentsIds"])) {
                this.attachmentsIds = [] as any;
                for (let item of _data["attachmentsIds"])
                    this.attachmentsIds!.push(item);
            }
            this.errorMessage = _data["errorMessage"];
            this.messageId = _data["messageId"];
            this.rawData = _data["rawData"];
            this.logType = _data["logType"];
        }
    }

    static fromJS(data: any): SmsLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["messageContent"] = this.messageContent;
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        if (Array.isArray(this.attachmentsIds)) {
            data["attachmentsIds"] = [];
            for (let item of this.attachmentsIds)
                data["attachmentsIds"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        data["messageId"] = this.messageId;
        data["rawData"] = this.rawData;
        data["logType"] = this.logType;
        return data;
    }
}

export interface ISmsLogDto {
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    clientName: string | undefined;
    clientId: string | undefined;
    mobilePhoneNumber: string | undefined;
    messageContent: string | undefined;
    status: ActivityStatus;
    statusDisplayName: string | undefined;
    attachmentsIds: number[] | undefined;
    errorMessage: string | undefined;
    messageId: string | undefined;
    rawData: string | undefined;
    logType: LogType;
}

export class SmsRecipientDto implements ISmsRecipientDto {
    phoneNumber!: string;
    clientName!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: ISmsRecipientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): SmsRecipientDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsRecipientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ISmsRecipientDto {
    phoneNumber: string;
    clientName: string | undefined;
    clientId: string | undefined;
}

export class SpokenLanguage implements ISpokenLanguage {
    id!: number;
    name!: string;
    cultureName!: string;
    englishName!: string;
    nativeName!: string | undefined;
    languageCode!: string | undefined;

    constructor(data?: ISpokenLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cultureName = _data["cultureName"];
            this.englishName = _data["englishName"];
            this.nativeName = _data["nativeName"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): SpokenLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new SpokenLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cultureName"] = this.cultureName;
        data["englishName"] = this.englishName;
        data["nativeName"] = this.nativeName;
        data["languageCode"] = this.languageCode;
        return data;
    }
}

export interface ISpokenLanguage {
    id: number;
    name: string;
    cultureName: string;
    englishName: string;
    nativeName: string | undefined;
    languageCode: string | undefined;
}

export class SpokenLanguageDto implements ISpokenLanguageDto {
    id!: number;
    name!: string;
    cultureName!: string;
    englishName!: string;
    nativeName!: string | undefined;
    languageCode!: string | undefined;

    constructor(data?: ISpokenLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cultureName = _data["cultureName"];
            this.englishName = _data["englishName"];
            this.nativeName = _data["nativeName"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): SpokenLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpokenLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cultureName"] = this.cultureName;
        data["englishName"] = this.englishName;
        data["nativeName"] = this.nativeName;
        data["languageCode"] = this.languageCode;
        return data;
    }
}

export interface ISpokenLanguageDto {
    id: number;
    name: string;
    cultureName: string;
    englishName: string;
    nativeName: string | undefined;
    languageCode: string | undefined;
}

export class SqlReportResultDto implements ISqlReportResultDto {
    reportId!: number;
    reportName!: string | undefined;
    durationMs!: number;
    totalRows!: number;
    resultSets!: SqlResultSetDto[] | undefined;

    constructor(data?: ISqlReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.durationMs = _data["durationMs"];
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["resultSets"])) {
                this.resultSets = [] as any;
                for (let item of _data["resultSets"])
                    this.resultSets!.push(SqlResultSetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SqlReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["durationMs"] = this.durationMs;
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.resultSets)) {
            data["resultSets"] = [];
            for (let item of this.resultSets)
                data["resultSets"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISqlReportResultDto {
    reportId: number;
    reportName: string | undefined;
    durationMs: number;
    totalRows: number;
    resultSets: SqlResultSetDto[] | undefined;
}

export class SqlResultSetDto implements ISqlResultSetDto {
    setIndex!: number;
    columns!: string[] | undefined;
    rows!: any[][] | undefined;
    totalCount!: number;

    constructor(data?: ISqlResultSetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setIndex = _data["setIndex"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SqlResultSetDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlResultSetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setIndex"] = this.setIndex;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ISqlResultSetDto {
    setIndex: number;
    columns: string[] | undefined;
    rows: any[][] | undefined;
    totalCount: number;
}

export class SsaContactDto implements ISsaContactDto {
    id!: number;
    role!: SsaContactRole;
    enumDisplayRole!: string | undefined;
    userId!: number;
    name!: string | undefined;
    phone!: string | undefined;
    tollFree!: string | undefined;
    fax!: string | undefined;
    tty!: string | undefined;
    email!: string | undefined;

    constructor(data?: ISsaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.enumDisplayRole = _data["enumDisplayRole"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.tollFree = _data["tollFree"];
            this.fax = _data["fax"];
            this.tty = _data["tty"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SsaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SsaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["enumDisplayRole"] = this.enumDisplayRole;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["tollFree"] = this.tollFree;
        data["fax"] = this.fax;
        data["tty"] = this.tty;
        data["email"] = this.email;
        return data;
    }
}

export interface ISsaContactDto {
    id: number;
    role: SsaContactRole;
    enumDisplayRole: string | undefined;
    userId: number;
    name: string | undefined;
    phone: string | undefined;
    tollFree: string | undefined;
    fax: string | undefined;
    tty: string | undefined;
    email: string | undefined;
}

export enum SsaContactRole {
    SignatoryAuthority = 0,
    ProgramContact = 1,
    SuitabilityContact = 2,
    PaymentsContact = 3,
    TicketholderContact = 4,
    DirectoryWebContact = 5,
    TicketPortalUser = 6,
}

export class SsaSuitabilityApplicantDto implements ISsaSuitabilityApplicantDto {
    id!: number;
    firstName!: string | undefined;
    middleName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    status!: SsaSuitabilityRequestStatus;
    isLinkExpired!: boolean;
    uploadLinkExpiresAt!: DateTime | undefined;
    instructionsSentAt!: DateTime | undefined;
    documentsReceivedAt!: DateTime | undefined;
    packageGeneratedAt!: DateTime | undefined;
    sentToSsaAt!: DateTime | undefined;
    fileCount!: number;
    phone!: string | undefined;
    isUsCitizen!: boolean;
    fingerprintDate!: DateTime | undefined;
    startDate!: DateTime | undefined;
    eAppId!: string | undefined;
    uploadUrl!: string | undefined;
    packageZipName!: string | undefined;
    files!: SsaSuitabilityFileDto[] | undefined;

    constructor(data?: ISsaSuitabilityApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.isLinkExpired = _data["isLinkExpired"];
            this.uploadLinkExpiresAt = _data["uploadLinkExpiresAt"] ? DateTime.fromISO(_data["uploadLinkExpiresAt"].toString()) : <any>undefined;
            this.instructionsSentAt = _data["instructionsSentAt"] ? DateTime.fromISO(_data["instructionsSentAt"].toString()) : <any>undefined;
            this.documentsReceivedAt = _data["documentsReceivedAt"] ? DateTime.fromISO(_data["documentsReceivedAt"].toString()) : <any>undefined;
            this.packageGeneratedAt = _data["packageGeneratedAt"] ? DateTime.fromISO(_data["packageGeneratedAt"].toString()) : <any>undefined;
            this.sentToSsaAt = _data["sentToSsaAt"] ? DateTime.fromISO(_data["sentToSsaAt"].toString()) : <any>undefined;
            this.fileCount = _data["fileCount"];
            this.phone = _data["phone"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.fingerprintDate = _data["fingerprintDate"] ? DateTime.fromISO(_data["fingerprintDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.eAppId = _data["eAppId"];
            this.uploadUrl = _data["uploadUrl"];
            this.packageZipName = _data["packageZipName"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(SsaSuitabilityFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SsaSuitabilityApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new SsaSuitabilityApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["isLinkExpired"] = this.isLinkExpired;
        data["uploadLinkExpiresAt"] = this.uploadLinkExpiresAt ? this.uploadLinkExpiresAt.toString() : <any>undefined;
        data["instructionsSentAt"] = this.instructionsSentAt ? this.instructionsSentAt.toString() : <any>undefined;
        data["documentsReceivedAt"] = this.documentsReceivedAt ? this.documentsReceivedAt.toString() : <any>undefined;
        data["packageGeneratedAt"] = this.packageGeneratedAt ? this.packageGeneratedAt.toString() : <any>undefined;
        data["sentToSsaAt"] = this.sentToSsaAt ? this.sentToSsaAt.toString() : <any>undefined;
        data["fileCount"] = this.fileCount;
        data["phone"] = this.phone;
        data["isUsCitizen"] = this.isUsCitizen;
        data["fingerprintDate"] = this.fingerprintDate ? this.fingerprintDate.toString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["eAppId"] = this.eAppId;
        data["uploadUrl"] = this.uploadUrl;
        data["packageZipName"] = this.packageZipName;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISsaSuitabilityApplicantDto {
    id: number;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    status: SsaSuitabilityRequestStatus;
    isLinkExpired: boolean;
    uploadLinkExpiresAt: DateTime | undefined;
    instructionsSentAt: DateTime | undefined;
    documentsReceivedAt: DateTime | undefined;
    packageGeneratedAt: DateTime | undefined;
    sentToSsaAt: DateTime | undefined;
    fileCount: number;
    phone: string | undefined;
    isUsCitizen: boolean;
    fingerprintDate: DateTime | undefined;
    startDate: DateTime | undefined;
    eAppId: string | undefined;
    uploadUrl: string | undefined;
    packageZipName: string | undefined;
    files: SsaSuitabilityFileDto[] | undefined;
}

export class SsaSuitabilityApplicantListDto implements ISsaSuitabilityApplicantListDto {
    id!: number;
    firstName!: string | undefined;
    middleName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    status!: SsaSuitabilityRequestStatus;
    isLinkExpired!: boolean;
    uploadLinkExpiresAt!: DateTime | undefined;
    instructionsSentAt!: DateTime | undefined;
    documentsReceivedAt!: DateTime | undefined;
    packageGeneratedAt!: DateTime | undefined;
    sentToSsaAt!: DateTime | undefined;
    fileCount!: number;

    constructor(data?: ISsaSuitabilityApplicantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.isLinkExpired = _data["isLinkExpired"];
            this.uploadLinkExpiresAt = _data["uploadLinkExpiresAt"] ? DateTime.fromISO(_data["uploadLinkExpiresAt"].toString()) : <any>undefined;
            this.instructionsSentAt = _data["instructionsSentAt"] ? DateTime.fromISO(_data["instructionsSentAt"].toString()) : <any>undefined;
            this.documentsReceivedAt = _data["documentsReceivedAt"] ? DateTime.fromISO(_data["documentsReceivedAt"].toString()) : <any>undefined;
            this.packageGeneratedAt = _data["packageGeneratedAt"] ? DateTime.fromISO(_data["packageGeneratedAt"].toString()) : <any>undefined;
            this.sentToSsaAt = _data["sentToSsaAt"] ? DateTime.fromISO(_data["sentToSsaAt"].toString()) : <any>undefined;
            this.fileCount = _data["fileCount"];
        }
    }

    static fromJS(data: any): SsaSuitabilityApplicantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SsaSuitabilityApplicantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["isLinkExpired"] = this.isLinkExpired;
        data["uploadLinkExpiresAt"] = this.uploadLinkExpiresAt ? this.uploadLinkExpiresAt.toString() : <any>undefined;
        data["instructionsSentAt"] = this.instructionsSentAt ? this.instructionsSentAt.toString() : <any>undefined;
        data["documentsReceivedAt"] = this.documentsReceivedAt ? this.documentsReceivedAt.toString() : <any>undefined;
        data["packageGeneratedAt"] = this.packageGeneratedAt ? this.packageGeneratedAt.toString() : <any>undefined;
        data["sentToSsaAt"] = this.sentToSsaAt ? this.sentToSsaAt.toString() : <any>undefined;
        data["fileCount"] = this.fileCount;
        return data;
    }
}

export interface ISsaSuitabilityApplicantListDto {
    id: number;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    status: SsaSuitabilityRequestStatus;
    isLinkExpired: boolean;
    uploadLinkExpiresAt: DateTime | undefined;
    instructionsSentAt: DateTime | undefined;
    documentsReceivedAt: DateTime | undefined;
    packageGeneratedAt: DateTime | undefined;
    sentToSsaAt: DateTime | undefined;
    fileCount: number;
}

export class SsaSuitabilityFileDto implements ISsaSuitabilityFileDto {
    id!: number;
    fileType!: SsaSuitabilityFileType;
    fileName!: string | undefined;
    fileSize!: number;

    constructor(data?: ISsaSuitabilityFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): SsaSuitabilityFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SsaSuitabilityFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface ISsaSuitabilityFileDto {
    id: number;
    fileType: SsaSuitabilityFileType;
    fileName: string | undefined;
    fileSize: number;
}

export enum SsaSuitabilityFileType {
    Form306 = 1,
    WorkAuthorization = 2,
    FingerprintConfirmation = 3,
    DriversLicense = 4,
    Other = 5,
}

export enum SsaSuitabilityRequestStatus {
    InvitationSent = 1,
    DocumentsReceived = 2,
    PackageGenerated = 3,
    SentToSsa = 4,
}

export class SsaSuitabilitySettingsDto implements ISsaSuitabilitySettingsDto {
    recipientEmails!: string | undefined;
    isPasscodeConfigured!: boolean;
    zipPassword!: string | undefined;
    awardNumber!: string | undefined;
    perSecPoc!: string | undefined;
    isPerSecPocCustom!: boolean;
    suitabilityContacts!: string[] | undefined;

    constructor(data?: ISsaSuitabilitySettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientEmails = _data["recipientEmails"];
            this.isPasscodeConfigured = _data["isPasscodeConfigured"];
            this.zipPassword = _data["zipPassword"];
            this.awardNumber = _data["awardNumber"];
            this.perSecPoc = _data["perSecPoc"];
            this.isPerSecPocCustom = _data["isPerSecPocCustom"];
            if (Array.isArray(_data["suitabilityContacts"])) {
                this.suitabilityContacts = [] as any;
                for (let item of _data["suitabilityContacts"])
                    this.suitabilityContacts!.push(item);
            }
        }
    }

    static fromJS(data: any): SsaSuitabilitySettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SsaSuitabilitySettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientEmails"] = this.recipientEmails;
        data["isPasscodeConfigured"] = this.isPasscodeConfigured;
        data["zipPassword"] = this.zipPassword;
        data["awardNumber"] = this.awardNumber;
        data["perSecPoc"] = this.perSecPoc;
        data["isPerSecPocCustom"] = this.isPerSecPocCustom;
        if (Array.isArray(this.suitabilityContacts)) {
            data["suitabilityContacts"] = [];
            for (let item of this.suitabilityContacts)
                data["suitabilityContacts"].push(item);
        }
        return data;
    }
}

export interface ISsaSuitabilitySettingsDto {
    recipientEmails: string | undefined;
    isPasscodeConfigured: boolean;
    zipPassword: string | undefined;
    awardNumber: string | undefined;
    perSecPoc: string | undefined;
    isPerSecPocCustom: boolean;
    suitabilityContacts: string[] | undefined;
}

export class StartExtendSubscriptionInput implements IStartExtendSubscriptionInput {
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: IStartExtendSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): StartExtendSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StartExtendSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface IStartExtendSubscriptionInput {
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class StartTrialToBuySubscriptionInput implements IStartTrialToBuySubscriptionInput {
    paymentPeriodType!: PaymentPeriodType;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: IStartTrialToBuySubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): StartTrialToBuySubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StartTrialToBuySubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface IStartTrialToBuySubscriptionInput {
    paymentPeriodType: PaymentPeriodType;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class StartUpgradeSubscriptionInput implements IStartUpgradeSubscriptionInput {
    targetEditionId!: number;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    paymentPeriodType!: PaymentPeriodType;

    constructor(data?: IStartUpgradeSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetEditionId = _data["targetEditionId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            this.paymentPeriodType = _data["paymentPeriodType"];
        }
    }

    static fromJS(data: any): StartUpgradeSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StartUpgradeSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEditionId"] = this.targetEditionId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["paymentPeriodType"] = this.paymentPeriodType;
        return data;
    }
}

export interface IStartUpgradeSubscriptionInput {
    targetEditionId: number;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    paymentPeriodType: PaymentPeriodType;
}

export class StartUpgradeSubscriptionOutput implements IStartUpgradeSubscriptionOutput {
    paymentId!: number | undefined;
    upgraded!: boolean;

    constructor(data?: IStartUpgradeSubscriptionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.upgraded = _data["upgraded"];
        }
    }

    static fromJS(data: any): StartUpgradeSubscriptionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StartUpgradeSubscriptionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["upgraded"] = this.upgraded;
        return data;
    }
}

export interface IStartUpgradeSubscriptionOutput {
    paymentId: number | undefined;
    upgraded: boolean;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
    paymentId!: number;
    successUrl!: string | undefined;
    cancelUrl!: string | undefined;

    constructor(data?: IStripeCreatePaymentSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    }

    static fromJS(data: any): StripeCreatePaymentSessionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    }
}

export interface IStripeCreatePaymentSessionInput {
    paymentId: number;
    successUrl: string | undefined;
    cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
    paymentDone!: boolean;
    callbackUrl!: string | undefined;

    constructor(data?: IStripePaymentResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDone = _data["paymentDone"];
            this.callbackUrl = _data["callbackUrl"];
        }
    }

    static fromJS(data: any): StripePaymentResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        data["callbackUrl"] = this.callbackUrl;
        return data;
    }
}

export interface IStripePaymentResultOutput {
    paymentDone: boolean;
    callbackUrl: string | undefined;
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId!: any | undefined;
    value!: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }
}

export interface IStructLayoutAttribute {
    typeId: any | undefined;
    value: LayoutKind;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;
    isFree!: boolean | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
            this.isFree = _data["isFree"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        data["isFree"] = this.isFree;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
    isFree: boolean | undefined;
}

export class SubscriptionInfo implements ISubscriptionInfo {
    uri!: string | undefined;
    id!: string | undefined;
    eventFilters!: string[] | undefined;
    disabledFilters!: DisabledFilterInfo[] | undefined;
    expirationTime!: string | undefined;
    expiresIn!: number | undefined;
    status!: string | undefined;
    creationTime!: string | undefined;
    deliveryMode!: NotificationDeliveryMode;
    blacklistedData!: SubscriptionInfoBlacklistedData;

    constructor(data?: ISubscriptionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.id = _data["id"];
            if (Array.isArray(_data["eventFilters"])) {
                this.eventFilters = [] as any;
                for (let item of _data["eventFilters"])
                    this.eventFilters!.push(item);
            }
            if (Array.isArray(_data["disabledFilters"])) {
                this.disabledFilters = [] as any;
                for (let item of _data["disabledFilters"])
                    this.disabledFilters!.push(DisabledFilterInfo.fromJS(item));
            }
            this.expirationTime = _data["expirationTime"];
            this.expiresIn = _data["expiresIn"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"];
            this.deliveryMode = _data["deliveryMode"] ? NotificationDeliveryMode.fromJS(_data["deliveryMode"]) : <any>undefined;
            this.blacklistedData = _data["blacklistedData"] ? SubscriptionInfoBlacklistedData.fromJS(_data["blacklistedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["id"] = this.id;
        if (Array.isArray(this.eventFilters)) {
            data["eventFilters"] = [];
            for (let item of this.eventFilters)
                data["eventFilters"].push(item);
        }
        if (Array.isArray(this.disabledFilters)) {
            data["disabledFilters"] = [];
            for (let item of this.disabledFilters)
                data["disabledFilters"].push(item.toJSON());
        }
        data["expirationTime"] = this.expirationTime;
        data["expiresIn"] = this.expiresIn;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime;
        data["deliveryMode"] = this.deliveryMode ? this.deliveryMode.toJSON() : <any>undefined;
        data["blacklistedData"] = this.blacklistedData ? this.blacklistedData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscriptionInfo {
    uri: string | undefined;
    id: string | undefined;
    eventFilters: string[] | undefined;
    disabledFilters: DisabledFilterInfo[] | undefined;
    expirationTime: string | undefined;
    expiresIn: number | undefined;
    status: string | undefined;
    creationTime: string | undefined;
    deliveryMode: NotificationDeliveryMode;
    blacklistedData: SubscriptionInfoBlacklistedData;
}

export class SubscriptionInfoBlacklistedData implements ISubscriptionInfoBlacklistedData {
    blacklistedAt!: string | undefined;
    reason!: string | undefined;

    constructor(data?: ISubscriptionInfoBlacklistedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blacklistedAt = _data["blacklistedAt"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): SubscriptionInfoBlacklistedData {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInfoBlacklistedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blacklistedAt"] = this.blacklistedAt;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ISubscriptionInfoBlacklistedData {
    blacklistedAt: string | undefined;
    reason: string | undefined;
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    id!: number;
    gateway!: SubscriptionPaymentGatewayType;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean | undefined;
    isProrationPayment!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    subscriptionPaymentProducts!: SubscriptionPaymentProductDto[] | undefined;
    extraProperties!: { [key: string]: any; } | undefined;
    totalAmount!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gateway = _data["gateway"];
            this.tenantId = _data["tenantId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.invoiceNo = _data["invoiceNo"];
            this.status = _data["status"];
            this.isRecurring = _data["isRecurring"];
            this.isProrationPayment = _data["isProrationPayment"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            if (Array.isArray(_data["subscriptionPaymentProducts"])) {
                this.subscriptionPaymentProducts = [] as any;
                for (let item of _data["subscriptionPaymentProducts"])
                    this.subscriptionPaymentProducts!.push(SubscriptionPaymentProductDto.fromJS(item));
            }
            if (_data["extraProperties"]) {
                this.extraProperties = {} as any;
                for (let key in _data["extraProperties"]) {
                    if (_data["extraProperties"].hasOwnProperty(key))
                        (<any>this.extraProperties)![key] = _data["extraProperties"][key];
                }
            }
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gateway"] = this.gateway;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["isProrationPayment"] = this.isProrationPayment;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        if (Array.isArray(this.subscriptionPaymentProducts)) {
            data["subscriptionPaymentProducts"] = [];
            for (let item of this.subscriptionPaymentProducts)
                data["subscriptionPaymentProducts"].push(item.toJSON());
        }
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    (<any>data["extraProperties"])[key] = (<any>this.extraProperties)[key];
            }
        }
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface ISubscriptionPaymentDto {
    id: number;
    gateway: SubscriptionPaymentGatewayType;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean | undefined;
    isProrationPayment: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    subscriptionPaymentProducts: SubscriptionPaymentProductDto[] | undefined;
    extraProperties: { [key: string]: any; } | undefined;
    totalAmount: number;
}

export enum SubscriptionPaymentGatewayType {
    Paypal = 1,
    Stripe = 2,
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    gateway!: string | undefined;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    externalPaymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    readonly totalAmount!: number;
    subscriptionPaymentProducts!: SubscriptionPaymentProductDto[] | undefined;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.gateway = _data["gateway"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.payerId = _data["payerId"];
            this.status = _data["status"];
            this.tenantId = _data["tenantId"];
            this.invoiceNo = _data["invoiceNo"];
            (<any>this).totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["subscriptionPaymentProducts"])) {
                this.subscriptionPaymentProducts = [] as any;
                for (let item of _data["subscriptionPaymentProducts"])
                    this.subscriptionPaymentProducts!.push(SubscriptionPaymentProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["gateway"] = this.gateway;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.subscriptionPaymentProducts)) {
            data["subscriptionPaymentProducts"] = [];
            for (let item of this.subscriptionPaymentProducts)
                data["subscriptionPaymentProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    gateway: string | undefined;
    dayCount: number;
    paymentPeriodType: string | undefined;
    externalPaymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    totalAmount: number;
    subscriptionPaymentProducts: SubscriptionPaymentProductDto[] | undefined;
}

export class SubscriptionPaymentProductDto implements ISubscriptionPaymentProductDto {
    id!: number;
    description!: string | undefined;
    amount!: number;
    count!: number;
    extraProperties!: { [key: string]: any; } | undefined;

    constructor(data?: ISubscriptionPaymentProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.count = _data["count"];
            if (_data["extraProperties"]) {
                this.extraProperties = {} as any;
                for (let key in _data["extraProperties"]) {
                    if (_data["extraProperties"].hasOwnProperty(key))
                        (<any>this.extraProperties)![key] = _data["extraProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): SubscriptionPaymentProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["count"] = this.count;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    (<any>data["extraProperties"])[key] = (<any>this.extraProperties)[key];
            }
        }
        return data;
    }
}

export interface ISubscriptionPaymentProductDto {
    id: number;
    description: string | undefined;
    amount: number;
    count: number;
    extraProperties: { [key: string]: any; } | undefined;
}

export enum SubscriptionPaymentStatus {
    NotPaid = 1,
    Paid = 2,
    Failed = 3,
    Cancelled = 4,
    Completed = 5,
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class SuitabilityEmailPreviewDto implements ISuitabilityEmailPreviewDto {
    from!: string | undefined;
    to!: string[] | undefined;
    subject!: string | undefined;
    bodyHtml!: string | undefined;

    constructor(data?: ISuitabilityEmailPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            this.subject = _data["subject"];
            this.bodyHtml = _data["bodyHtml"];
        }
    }

    static fromJS(data: any): SuitabilityEmailPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuitabilityEmailPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        data["subject"] = this.subject;
        data["bodyHtml"] = this.bodyHtml;
        return data;
    }
}

export interface ISuitabilityEmailPreviewDto {
    from: string | undefined;
    to: string[] | undefined;
    subject: string | undefined;
    bodyHtml: string | undefined;
}

export class SuitabilitySendDraftDto implements ISuitabilitySendDraftDto {
    requestId!: number;
    from!: string | undefined;
    to!: string[] | undefined;
    cc!: string[] | undefined;
    subject!: string | undefined;
    body!: string | undefined;
    zipName!: string | undefined;
    zipContents!: string[] | undefined;
    summaryText!: string | undefined;

    constructor(data?: ISuitabilitySendDraftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.from = _data["from"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.zipName = _data["zipName"];
            if (Array.isArray(_data["zipContents"])) {
                this.zipContents = [] as any;
                for (let item of _data["zipContents"])
                    this.zipContents!.push(item);
            }
            this.summaryText = _data["summaryText"];
        }
    }

    static fromJS(data: any): SuitabilitySendDraftDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuitabilitySendDraftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["from"] = this.from;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["zipName"] = this.zipName;
        if (Array.isArray(this.zipContents)) {
            data["zipContents"] = [];
            for (let item of this.zipContents)
                data["zipContents"].push(item);
        }
        data["summaryText"] = this.summaryText;
        return data;
    }
}

export interface ISuitabilitySendDraftDto {
    requestId: number;
    from: string | undefined;
    to: string[] | undefined;
    cc: string[] | undefined;
    subject: string | undefined;
    body: string | undefined;
    zipName: string | undefined;
    zipContents: string[] | undefined;
    summaryText: string | undefined;
}

export class SuitabilityUploadInfoDto implements ISuitabilityUploadInfoDto {
    state!: SuitabilityUploadLinkState;
    enName!: string | undefined;
    firstName!: string | undefined;
    middleName!: string | undefined;
    lastName!: string | undefined;
    phone!: string | undefined;
    isUsCitizen!: boolean;
    fingerprintDate!: DateTime | undefined;
    expiresAt!: DateTime | undefined;
    files!: SsaSuitabilityFileDto[] | undefined;

    constructor(data?: ISuitabilityUploadInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.enName = _data["enName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.isUsCitizen = _data["isUsCitizen"];
            this.fingerprintDate = _data["fingerprintDate"] ? DateTime.fromISO(_data["fingerprintDate"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? DateTime.fromISO(_data["expiresAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(SsaSuitabilityFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuitabilityUploadInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuitabilityUploadInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["enName"] = this.enName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["isUsCitizen"] = this.isUsCitizen;
        data["fingerprintDate"] = this.fingerprintDate ? this.fingerprintDate.toString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toString() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISuitabilityUploadInfoDto {
    state: SuitabilityUploadLinkState;
    enName: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    phone: string | undefined;
    isUsCitizen: boolean;
    fingerprintDate: DateTime | undefined;
    expiresAt: DateTime | undefined;
    files: SsaSuitabilityFileDto[] | undefined;
}

export enum SuitabilityUploadLinkState {
    Invalid = 0,
    Active = 1,
    Expired = 2,
    Completed = 3,
}

export enum SupportServices {
    None = 0,
    ResumeAssistance = 1,
    JobSearch = 2,
    JobApplication = 4,
    InterviewPreparation = 8,
    Transportation = 16,
    Education = 32,
    Housing = 64,
    CareerCoachingGuidance = 128,
    BenefitsCounseling = 256,
}

export class SupportServicesDto implements ISupportServicesDto {
    leadId!: number;
    requestedServices!: SupportServices;

    constructor(data?: ISupportServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.requestedServices = _data["requestedServices"];
        }
    }

    static fromJS(data: any): SupportServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["requestedServices"] = this.requestedServices;
        return data;
    }
}

export interface ISupportServicesDto {
    leadId: number;
    requestedServices: SupportServices;
}

export class SupportTicketCommentDto implements ISupportTicketCommentDto {
    id!: number;
    supportTicketId!: number;
    htmlContent!: string | undefined;
    creatorUserId!: number;
    creatorUserName!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: ISupportTicketCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportTicketId = _data["supportTicketId"];
            this.htmlContent = _data["htmlContent"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SupportTicketCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportTicketCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportTicketId"] = this.supportTicketId;
        data["htmlContent"] = this.htmlContent;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ISupportTicketCommentDto {
    id: number;
    supportTicketId: number;
    htmlContent: string | undefined;
    creatorUserId: number;
    creatorUserName: string | undefined;
    creationTime: DateTime;
}

export class SupportTicketDto implements ISupportTicketDto {
    id!: number;
    htmlDescription!: string | undefined;
    status!: SupportTicketStatus;
    statusList!: EnumInfoDto[] | undefined;
    readonly statusDisplayName!: string | undefined;
    ticketCreatorId!: number;
    ticketCreatorName!: string | undefined;
    ticketAssignedToId!: number | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime;
    comments!: SupportTicketCommentDto[] | undefined;

    constructor(data?: ISupportTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.htmlDescription = _data["htmlDescription"];
            this.status = _data["status"];
            if (Array.isArray(_data["statusList"])) {
                this.statusList = [] as any;
                for (let item of _data["statusList"])
                    this.statusList!.push(EnumInfoDto.fromJS(item));
            }
            (<any>this).statusDisplayName = _data["statusDisplayName"];
            this.ticketCreatorId = _data["ticketCreatorId"];
            this.ticketCreatorName = _data["ticketCreatorName"];
            this.ticketAssignedToId = _data["ticketAssignedToId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(SupportTicketCommentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupportTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["htmlDescription"] = this.htmlDescription;
        data["status"] = this.status;
        if (Array.isArray(this.statusList)) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item.toJSON());
        }
        data["statusDisplayName"] = this.statusDisplayName;
        data["ticketCreatorId"] = this.ticketCreatorId;
        data["ticketCreatorName"] = this.ticketCreatorName;
        data["ticketAssignedToId"] = this.ticketAssignedToId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupportTicketDto {
    id: number;
    htmlDescription: string | undefined;
    status: SupportTicketStatus;
    statusList: EnumInfoDto[] | undefined;
    statusDisplayName: string | undefined;
    ticketCreatorId: number;
    ticketCreatorName: string | undefined;
    ticketAssignedToId: number | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime;
    comments: SupportTicketCommentDto[] | undefined;
}

export enum SupportTicketStatus {
    Open = 1,
    InProgress = 2,
    Done = 3,
    Reopen = 4,
    Resolved = 5,
}

export class SurveyDto implements ISurveyDto {
    id!: number;
    surveyType!: SurveyType;
    title!: string;
    description!: string | undefined;
    isActive!: boolean;
    questions!: SurveyQuestionDto[] | undefined;
    hasAnyAnswerProvided!: boolean;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyType = _data["surveyType"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyQuestionDto.fromJS(item));
            }
            this.hasAnyAnswerProvided = _data["hasAnyAnswerProvided"];
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyType"] = this.surveyType;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        data["hasAnyAnswerProvided"] = this.hasAnyAnswerProvided;
        return data;
    }
}

export interface ISurveyDto {
    id: number;
    surveyType: SurveyType;
    title: string;
    description: string | undefined;
    isActive: boolean;
    questions: SurveyQuestionDto[] | undefined;
    hasAnyAnswerProvided: boolean;
}

export class SurveyQuestionDto implements ISurveyQuestionDto {
    id!: number;
    text!: string | undefined;
    section!: string | undefined;
    type!: SurveyQuestionType;
    surveyId!: number;
    isMandatory!: boolean;
    placeHolder!: string | undefined;
    options!: SurveyQuestionOptionDto[] | undefined;
    response!: ResponseDto;

    constructor(data?: ISurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.section = _data["section"];
            this.type = _data["type"];
            this.surveyId = _data["surveyId"];
            this.isMandatory = _data["isMandatory"];
            this.placeHolder = _data["placeHolder"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SurveyQuestionOptionDto.fromJS(item));
            }
            this.response = _data["response"] ? ResponseDto.fromJS(_data["response"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["section"] = this.section;
        data["type"] = this.type;
        data["surveyId"] = this.surveyId;
        data["isMandatory"] = this.isMandatory;
        data["placeHolder"] = this.placeHolder;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyQuestionDto {
    id: number;
    text: string | undefined;
    section: string | undefined;
    type: SurveyQuestionType;
    surveyId: number;
    isMandatory: boolean;
    placeHolder: string | undefined;
    options: SurveyQuestionOptionDto[] | undefined;
    response: ResponseDto;
}

export class SurveyQuestionOptionDto implements ISurveyQuestionOptionDto {
    id!: number;
    text!: string | undefined;
    questionId!: number;
    isRequiresExplanation!: boolean;

    constructor(data?: ISurveyQuestionOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.questionId = _data["questionId"];
            this.isRequiresExplanation = _data["isRequiresExplanation"];
        }
    }

    static fromJS(data: any): SurveyQuestionOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["questionId"] = this.questionId;
        data["isRequiresExplanation"] = this.isRequiresExplanation;
        return data;
    }
}

export interface ISurveyQuestionOptionDto {
    id: number;
    text: string | undefined;
    questionId: number;
    isRequiresExplanation: boolean;
}

export enum SurveyQuestionType {
    SingleSelection = 0,
    MultipleSelection = 1,
    TextInput = 2,
}

export class SurveyResponseDetailDto implements ISurveyResponseDetailDto {
    questionId!: number;
    textAnswer!: string | undefined;
    selectedOptions!: SurveyResponseDetailOptionDto[] | undefined;

    constructor(data?: ISurveyResponseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.textAnswer = _data["textAnswer"];
            if (Array.isArray(_data["selectedOptions"])) {
                this.selectedOptions = [] as any;
                for (let item of _data["selectedOptions"])
                    this.selectedOptions!.push(SurveyResponseDetailOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["textAnswer"] = this.textAnswer;
        if (Array.isArray(this.selectedOptions)) {
            data["selectedOptions"] = [];
            for (let item of this.selectedOptions)
                data["selectedOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResponseDetailDto {
    questionId: number;
    textAnswer: string | undefined;
    selectedOptions: SurveyResponseDetailOptionDto[] | undefined;
}

export class SurveyResponseDetailOptionDto implements ISurveyResponseDetailOptionDto {
    surveyQuestionOptionId!: number;
    textAnswer!: string | undefined;

    constructor(data?: ISurveyResponseDetailOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyQuestionOptionId = _data["surveyQuestionOptionId"];
            this.textAnswer = _data["textAnswer"];
        }
    }

    static fromJS(data: any): SurveyResponseDetailOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseDetailOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestionOptionId"] = this.surveyQuestionOptionId;
        data["textAnswer"] = this.textAnswer;
        return data;
    }
}

export interface ISurveyResponseDetailOptionDto {
    surveyQuestionOptionId: number;
    textAnswer: string | undefined;
}

export class SurveyResponseDto implements ISurveyResponseDto {
    id!: number;
    surveyId!: number;
    clientId!: string | undefined;
    responseDetails!: SurveyResponseDetailDto[] | undefined;

    constructor(data?: ISurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["responseDetails"])) {
                this.responseDetails = [] as any;
                for (let item of _data["responseDetails"])
                    this.responseDetails!.push(SurveyResponseDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["clientId"] = this.clientId;
        if (Array.isArray(this.responseDetails)) {
            data["responseDetails"] = [];
            for (let item of this.responseDetails)
                data["responseDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResponseDto {
    id: number;
    surveyId: number;
    clientId: string | undefined;
    responseDetails: SurveyResponseDetailDto[] | undefined;
}

export class SurveyResponseOptionDto implements ISurveyResponseOptionDto {
    selectedOptionId!: number;
    textAnswer!: string | undefined;

    constructor(data?: ISurveyResponseOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedOptionId = _data["selectedOptionId"];
            this.textAnswer = _data["textAnswer"];
        }
    }

    static fromJS(data: any): SurveyResponseOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedOptionId"] = this.selectedOptionId;
        data["textAnswer"] = this.textAnswer;
        return data;
    }
}

export interface ISurveyResponseOptionDto {
    selectedOptionId: number;
    textAnswer: string | undefined;
}

export enum SurveyType {
    General = 0,
    Suitability = 1,
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class THAddressDto implements ITHAddressDto {
    id!: number;
    street!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    zipCode!: string | undefined;
    timeZone!: USATimeZone;
    addressType!: AddressType;
    isVerifiedByUSPS!: boolean | undefined;

    constructor(data?: ITHAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.timeZone = _data["timeZone"];
            this.addressType = _data["addressType"];
            this.isVerifiedByUSPS = _data["isVerifiedByUSPS"];
        }
    }

    static fromJS(data: any): THAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new THAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["timeZone"] = this.timeZone;
        data["addressType"] = this.addressType;
        data["isVerifiedByUSPS"] = this.isVerifiedByUSPS;
        return data;
    }
}

export interface ITHAddressDto {
    id: number;
    street: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    zipCode: string | undefined;
    timeZone: USATimeZone;
    addressType: AddressType;
    isVerifiedByUSPS: boolean | undefined;
}

export class THAdvocacyServiceRequestDto implements ITHAdvocacyServiceRequestDto {
    id!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    requestState!: string;
    sendToEmail!: boolean;
    email!: string | undefined;
    sendToMailbox!: boolean;
    mailAddressLine1!: string | undefined;
    mailAddressLine2!: string | undefined;
    mailCity!: string | undefined;
    mailState!: string | undefined;
    mailZip!: string | undefined;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITHAdvocacyServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.requestState = _data["requestState"];
            this.sendToEmail = _data["sendToEmail"];
            this.email = _data["email"];
            this.sendToMailbox = _data["sendToMailbox"];
            this.mailAddressLine1 = _data["mailAddressLine1"];
            this.mailAddressLine2 = _data["mailAddressLine2"];
            this.mailCity = _data["mailCity"];
            this.mailState = _data["mailState"];
            this.mailZip = _data["mailZip"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THAdvocacyServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THAdvocacyServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["requestState"] = this.requestState;
        data["sendToEmail"] = this.sendToEmail;
        data["email"] = this.email;
        data["sendToMailbox"] = this.sendToMailbox;
        data["mailAddressLine1"] = this.mailAddressLine1;
        data["mailAddressLine2"] = this.mailAddressLine2;
        data["mailCity"] = this.mailCity;
        data["mailState"] = this.mailState;
        data["mailZip"] = this.mailZip;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHAdvocacyServiceRequestDto {
    id: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    requestState: string;
    sendToEmail: boolean;
    email: string | undefined;
    sendToMailbox: boolean;
    mailAddressLine1: string | undefined;
    mailAddressLine2: string | undefined;
    mailCity: string | undefined;
    mailState: string | undefined;
    mailZip: string | undefined;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class THBenefitTypeDto implements ITHBenefitTypeDto {
    benefitType!: BenefitType;
    rawSSN!: string | undefined;
    maskedSSN!: string | undefined;
    encryptedSSN!: string | undefined;
    isFelony!: boolean | undefined;
    disabilities!: THDisabilityDto[] | undefined;

    constructor(data?: ITHBenefitTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitType = _data["benefitType"];
            this.rawSSN = _data["rawSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.isFelony = _data["isFelony"];
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(THDisabilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): THBenefitTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new THBenefitTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitType"] = this.benefitType;
        data["rawSSN"] = this.rawSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["encryptedSSN"] = this.encryptedSSN;
        data["isFelony"] = this.isFelony;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITHBenefitTypeDto {
    benefitType: BenefitType;
    rawSSN: string | undefined;
    maskedSSN: string | undefined;
    encryptedSSN: string | undefined;
    isFelony: boolean | undefined;
    disabilities: THDisabilityDto[] | undefined;
}

export class THChatChannelInfoDto implements ITHChatChannelInfoDto {
    tenantId!: number;
    ticketHolderUserId!: number;
    ticketHolderName!: string | undefined;
    careerCoachUserId!: number;
    careerCoachName!: string | undefined;
    chatSessionId!: string | undefined;
    isFromTicketHolder!: boolean;
    initialMessages!: ThChatMessageDto[] | undefined;

    constructor(data?: ITHChatChannelInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.ticketHolderUserId = _data["ticketHolderUserId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachName = _data["careerCoachName"];
            this.chatSessionId = _data["chatSessionId"];
            this.isFromTicketHolder = _data["isFromTicketHolder"];
            if (Array.isArray(_data["initialMessages"])) {
                this.initialMessages = [] as any;
                for (let item of _data["initialMessages"])
                    this.initialMessages!.push(ThChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): THChatChannelInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new THChatChannelInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["ticketHolderUserId"] = this.ticketHolderUserId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachName"] = this.careerCoachName;
        data["chatSessionId"] = this.chatSessionId;
        data["isFromTicketHolder"] = this.isFromTicketHolder;
        if (Array.isArray(this.initialMessages)) {
            data["initialMessages"] = [];
            for (let item of this.initialMessages)
                data["initialMessages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITHChatChannelInfoDto {
    tenantId: number;
    ticketHolderUserId: number;
    ticketHolderName: string | undefined;
    careerCoachUserId: number;
    careerCoachName: string | undefined;
    chatSessionId: string | undefined;
    isFromTicketHolder: boolean;
    initialMessages: ThChatMessageDto[] | undefined;
}

export class THChatFileDto implements ITHChatFileDto {
    documentId!: number;
    fileName!: string | undefined;
    fileData!: string | undefined;
    fileType!: string | undefined;
    fileSize!: string | undefined;

    constructor(data?: ITHChatFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): THChatFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new THChatFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface ITHChatFileDto {
    documentId: number;
    fileName: string | undefined;
    fileData: string | undefined;
    fileType: string | undefined;
    fileSize: string | undefined;
}

export class THChatSMSDto implements ITHChatSMSDto {
    direction!: ActivityDirection;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    logId!: number | undefined;
    startTime!: DateTime;

    constructor(data?: ITHChatSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.logId = _data["logId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): THChatSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new THChatSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["logId"] = this.logId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITHChatSMSDto {
    direction: ActivityDirection;
    activityContent: string | undefined;
    status: ActivityStatus;
    logId: number | undefined;
    startTime: DateTime;
}

export class THContactHistoryDto implements ITHContactHistoryDto {
    activityType!: ContactType;
    readonly enumDisplayActivityType!: string | undefined;
    direction!: ActivityDirection;
    enumDisplayDirection!: string | undefined;
    contactInfo!: string | undefined;
    subject!: string | undefined;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    enumDisplayStatus!: string | undefined;
    startTime!: DateTime;
    logId!: number | undefined;
    creatorUserId!: number | undefined;
    hasAttachments!: boolean;

    constructor(data?: ITHContactHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityType = _data["activityType"];
            (<any>this).enumDisplayActivityType = _data["enumDisplayActivityType"];
            this.direction = _data["direction"];
            this.enumDisplayDirection = _data["enumDisplayDirection"];
            this.contactInfo = _data["contactInfo"];
            this.subject = _data["subject"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.enumDisplayStatus = _data["enumDisplayStatus"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.logId = _data["logId"];
            this.creatorUserId = _data["creatorUserId"];
            this.hasAttachments = _data["hasAttachments"];
        }
    }

    static fromJS(data: any): THContactHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new THContactHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType;
        data["enumDisplayActivityType"] = this.enumDisplayActivityType;
        data["direction"] = this.direction;
        data["enumDisplayDirection"] = this.enumDisplayDirection;
        data["contactInfo"] = this.contactInfo;
        data["subject"] = this.subject;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["logId"] = this.logId;
        data["creatorUserId"] = this.creatorUserId;
        data["hasAttachments"] = this.hasAttachments;
        return data;
    }
}

export interface ITHContactHistoryDto {
    activityType: ContactType;
    enumDisplayActivityType: string | undefined;
    direction: ActivityDirection;
    enumDisplayDirection: string | undefined;
    contactInfo: string | undefined;
    subject: string | undefined;
    activityContent: string | undefined;
    status: ActivityStatus;
    enumDisplayStatus: string | undefined;
    startTime: DateTime;
    logId: number | undefined;
    creatorUserId: number | undefined;
    hasAttachments: boolean;
}

export class THCreateInterviewSchedule implements ITHCreateInterviewSchedule {
    title!: string;
    description!: string | undefined;
    startTime!: DateTime;
    location!: string | undefined;

    constructor(data?: ITHCreateInterviewSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): THCreateInterviewSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new THCreateInterviewSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["location"] = this.location;
        return data;
    }
}

export interface ITHCreateInterviewSchedule {
    title: string;
    description: string | undefined;
    startTime: DateTime;
    location: string | undefined;
}

export class THCreateOrUpdateJobInterviewDto implements ITHCreateOrUpdateJobInterviewDto {
    id!: number | undefined;
    ticketHolderId!: number;
    jobLeadId!: number | undefined;
    companyName!: string | undefined;
    overallOutcome!: InterviewOutcome;
    notes!: string | undefined;
    sessions!: BaseCreateOrUpdateJobInterviewSessionDto[] | undefined;

    constructor(data?: ITHCreateOrUpdateJobInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobLeadId = _data["jobLeadId"];
            this.companyName = _data["companyName"];
            this.overallOutcome = _data["overallOutcome"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(BaseCreateOrUpdateJobInterviewSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): THCreateOrUpdateJobInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new THCreateOrUpdateJobInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobLeadId"] = this.jobLeadId;
        data["companyName"] = this.companyName;
        data["overallOutcome"] = this.overallOutcome;
        data["notes"] = this.notes;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITHCreateOrUpdateJobInterviewDto {
    id: number | undefined;
    ticketHolderId: number;
    jobLeadId: number | undefined;
    companyName: string | undefined;
    overallOutcome: InterviewOutcome;
    notes: string | undefined;
    sessions: BaseCreateOrUpdateJobInterviewSessionDto[] | undefined;
}

export class THCreateOrUpdateJobInterviewSessionDto implements ITHCreateOrUpdateJobInterviewSessionDto {
    id!: number | undefined;
    interviewRound!: InterviewRound;
    interviewMethod!: InterviewMethod;
    interviewDate!: DateTime;
    timeZone!: string;
    locationAddress!: string | undefined;
    interviewerName!: string | undefined;
    interviewerContact!: string | undefined;
    outcome!: InterviewOutcome;
    notes!: string | undefined;

    constructor(data?: ITHCreateOrUpdateJobInterviewSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interviewRound = _data["interviewRound"];
            this.interviewMethod = _data["interviewMethod"];
            this.interviewDate = _data["interviewDate"] ? DateTime.fromISO(_data["interviewDate"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.locationAddress = _data["locationAddress"];
            this.interviewerName = _data["interviewerName"];
            this.interviewerContact = _data["interviewerContact"];
            this.outcome = _data["outcome"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): THCreateOrUpdateJobInterviewSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new THCreateOrUpdateJobInterviewSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interviewRound"] = this.interviewRound;
        data["interviewMethod"] = this.interviewMethod;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["locationAddress"] = this.locationAddress;
        data["interviewerName"] = this.interviewerName;
        data["interviewerContact"] = this.interviewerContact;
        data["outcome"] = this.outcome;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ITHCreateOrUpdateJobInterviewSessionDto {
    id: number | undefined;
    interviewRound: InterviewRound;
    interviewMethod: InterviewMethod;
    interviewDate: DateTime;
    timeZone: string;
    locationAddress: string | undefined;
    interviewerName: string | undefined;
    interviewerContact: string | undefined;
    outcome: InterviewOutcome;
    notes: string | undefined;
}

export class THCreateReminderDto implements ITHCreateReminderDto {
    title!: string;
    description!: string | undefined;
    startTime!: DateTime;

    constructor(data?: ITHCreateReminderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): THCreateReminderDto {
        data = typeof data === 'object' ? data : {};
        let result = new THCreateReminderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITHCreateReminderDto {
    title: string;
    description: string | undefined;
    startTime: DateTime;
}

export class THDisabilityDto implements ITHDisabilityDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITHDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): THDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new THDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ITHDisabilityDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class THDocumentDto implements ITHDocumentDto {
    id!: number;
    documentName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    versionNumber!: string | undefined;
    isLatest!: boolean;
    isTemplate!: boolean;
    uploadDate!: DateTime;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    uploadedBy!: string | undefined;
    templateStatus!: TemplateStatus;
    documentType!: TicketHolderDocumentType;
    languageId!: number | undefined;

    constructor(data?: ITHDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.versionNumber = _data["versionNumber"];
            this.isLatest = _data["isLatest"];
            this.isTemplate = _data["isTemplate"];
            this.uploadDate = _data["uploadDate"] ? DateTime.fromISO(_data["uploadDate"].toString()) : <any>undefined;
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.uploadedBy = _data["uploadedBy"];
            this.templateStatus = _data["templateStatus"];
            this.documentType = _data["documentType"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): THDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new THDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["versionNumber"] = this.versionNumber;
        data["isLatest"] = this.isLatest;
        data["isTemplate"] = this.isTemplate;
        data["uploadDate"] = this.uploadDate ? this.uploadDate.toString() : <any>undefined;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["uploadedBy"] = this.uploadedBy;
        data["templateStatus"] = this.templateStatus;
        data["documentType"] = this.documentType;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface ITHDocumentDto {
    id: number;
    documentName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    versionNumber: string | undefined;
    isLatest: boolean;
    isTemplate: boolean;
    uploadDate: DateTime;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    uploadedBy: string | undefined;
    templateStatus: TemplateStatus;
    documentType: TicketHolderDocumentType;
    languageId: number | undefined;
}

export class THDocumentResponseDto implements ITHDocumentResponseDto {
    fileName!: string | undefined;
    fileData!: string | undefined;
    fileType!: string | undefined;
    fileSize!: string | undefined;
    uploadedAt!: DateTime;
    uploadedBy!: string | undefined;

    constructor(data?: ITHDocumentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.fileType = _data["fileType"];
            this.fileSize = _data["fileSize"];
            this.uploadedAt = _data["uploadedAt"] ? DateTime.fromISO(_data["uploadedAt"].toString()) : <any>undefined;
            this.uploadedBy = _data["uploadedBy"];
        }
    }

    static fromJS(data: any): THDocumentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new THDocumentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["fileType"] = this.fileType;
        data["fileSize"] = this.fileSize;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toString() : <any>undefined;
        data["uploadedBy"] = this.uploadedBy;
        return data;
    }
}

export interface ITHDocumentResponseDto {
    fileName: string | undefined;
    fileData: string | undefined;
    fileType: string | undefined;
    fileSize: string | undefined;
    uploadedAt: DateTime;
    uploadedBy: string | undefined;
}

export class THEducationServiceRequestDto implements ITHEducationServiceRequestDto {
    id!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    programType!: string;
    desiredEducation!: string | undefined;
    enrollmentType!: string | undefined;
    needFinancialAid!: boolean;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITHEducationServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.programType = _data["programType"];
            this.desiredEducation = _data["desiredEducation"];
            this.enrollmentType = _data["enrollmentType"];
            this.needFinancialAid = _data["needFinancialAid"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THEducationServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THEducationServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["programType"] = this.programType;
        data["desiredEducation"] = this.desiredEducation;
        data["enrollmentType"] = this.enrollmentType;
        data["needFinancialAid"] = this.needFinancialAid;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHEducationServiceRequestDto {
    id: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    programType: string;
    desiredEducation: string | undefined;
    enrollmentType: string | undefined;
    needFinancialAid: boolean;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class THEmailLogDetailDto implements ITHEmailLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachEmail!: string | undefined;
    clientName!: string | undefined;
    clientEmail!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: THDocumentDto[] | undefined;
    status!: ActivityStatus;
    creationTime!: DateTime;

    constructor(data?: ITHEmailLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachEmail = _data["careerCoachEmail"];
            this.clientName = _data["clientName"];
            this.clientEmail = _data["clientEmail"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(THDocumentDto.fromJS(item));
            }
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): THEmailLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new THEmailLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachEmail"] = this.careerCoachEmail;
        data["clientName"] = this.clientName;
        data["clientEmail"] = this.clientEmail;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITHEmailLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachEmail: string | undefined;
    clientName: string | undefined;
    clientEmail: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: THDocumentDto[] | undefined;
    status: ActivityStatus;
    creationTime: DateTime;
}

export class THFaxLogDetailDto implements ITHFaxLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientFaxNumber!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: THDocumentDto[] | undefined;
    status!: ActivityStatus;

    constructor(data?: ITHFaxLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientFaxNumber = _data["clientFaxNumber"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(THDocumentDto.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THFaxLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new THFaxLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientFaxNumber"] = this.clientFaxNumber;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface ITHFaxLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientFaxNumber: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: THDocumentDto[] | undefined;
    status: ActivityStatus;
}

export class THFollowupDto implements ITHFollowupDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    startDate!: DateTime;
    dueDate!: DateTime | undefined;
    reminderDate!: DateTime | undefined;
    assignedToUserId!: number;
    status!: CalendarEventStatus;
    followupType!: FollowupType;

    constructor(data?: ITHFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
            this.assignedToUserId = _data["assignedToUserId"];
            this.status = _data["status"];
            this.followupType = _data["followupType"];
        }
    }

    static fromJS(data: any): THFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new THFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toString() : <any>undefined;
        data["assignedToUserId"] = this.assignedToUserId;
        data["status"] = this.status;
        data["followupType"] = this.followupType;
        return data;
    }
}

export interface ITHFollowupDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    startDate: DateTime;
    dueDate: DateTime | undefined;
    reminderDate: DateTime | undefined;
    assignedToUserId: number;
    status: CalendarEventStatus;
    followupType: FollowupType;
}

export class THHousingServiceRequestDto implements ITHHousingServiceRequestDto {
    id!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    housingType!: string;
    relocate!: boolean;
    housingAssistanceType!: string | undefined;
    eligibility!: string | undefined;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITHHousingServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.housingType = _data["housingType"];
            this.relocate = _data["relocate"];
            this.housingAssistanceType = _data["housingAssistanceType"];
            this.eligibility = _data["eligibility"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THHousingServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THHousingServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["housingType"] = this.housingType;
        data["relocate"] = this.relocate;
        data["housingAssistanceType"] = this.housingAssistanceType;
        data["eligibility"] = this.eligibility;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHHousingServiceRequestDto {
    id: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    housingType: string;
    relocate: boolean;
    housingAssistanceType: string | undefined;
    eligibility: string | undefined;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class THInputDocumentDto implements ITHInputDocumentDto {
    uploadFileOutputDto!: UploadFileOutputDto;
    documentType!: TicketHolderDocumentType;

    constructor(data?: ITHInputDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadFileOutputDto = _data["uploadFileOutputDto"] ? UploadFileOutputDto.fromJS(_data["uploadFileOutputDto"]) : <any>undefined;
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): THInputDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new THInputDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadFileOutputDto"] = this.uploadFileOutputDto ? this.uploadFileOutputDto.toJSON() : <any>undefined;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface ITHInputDocumentDto {
    uploadFileOutputDto: UploadFileOutputDto;
    documentType: TicketHolderDocumentType;
}

export class THInterviewAssistanceServiceRequestDto implements ITHInterviewAssistanceServiceRequestDto {
    id!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    interviewDateTime!: DateTime | undefined;
    interviewLocation!: string | undefined;
    interviewers!: string | undefined;
    interviewType!: InterviewType;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITHInterviewAssistanceServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.interviewDateTime = _data["interviewDateTime"] ? DateTime.fromISO(_data["interviewDateTime"].toString()) : <any>undefined;
            this.interviewLocation = _data["interviewLocation"];
            this.interviewers = _data["interviewers"];
            this.interviewType = _data["interviewType"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THInterviewAssistanceServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THInterviewAssistanceServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["interviewDateTime"] = this.interviewDateTime ? this.interviewDateTime.toString() : <any>undefined;
        data["interviewLocation"] = this.interviewLocation;
        data["interviewers"] = this.interviewers;
        data["interviewType"] = this.interviewType;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHInterviewAssistanceServiceRequestDto {
    id: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    interviewDateTime: DateTime | undefined;
    interviewLocation: string | undefined;
    interviewers: string | undefined;
    interviewType: InterviewType;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class THJobActivityDto implements ITHJobActivityDto {
    ticketHolderId!: number;
    jobLeadId!: number;
    status!: JobApplicationStatus;
    readonly enumDisplayStatus!: string | undefined;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    creatorUserName!: string | undefined;
    readonly formattedJobLeadId!: string | undefined;

    constructor(data?: ITHJobActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobLeadId = _data["jobLeadId"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            (<any>this).formattedJobLeadId = _data["formattedJobLeadId"];
        }
    }

    static fromJS(data: any): THJobActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new THJobActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobLeadId"] = this.jobLeadId;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["formattedJobLeadId"] = this.formattedJobLeadId;
        return data;
    }
}

export interface ITHJobActivityDto {
    ticketHolderId: number;
    jobLeadId: number;
    status: JobApplicationStatus;
    enumDisplayStatus: string | undefined;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    formattedJobLeadId: string | undefined;
}

export class THJobInterviewDto implements ITHJobInterviewDto {
    id!: number;
    jobLeadId!: number | undefined;
    companyName!: string | undefined;
    overallOutcome!: InterviewOutcome;
    notes!: string | undefined;
    sessions!: THJobInterviewSessionDto[] | undefined;

    constructor(data?: ITHJobInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobLeadId = _data["jobLeadId"];
            this.companyName = _data["companyName"];
            this.overallOutcome = _data["overallOutcome"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(THJobInterviewSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): THJobInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new THJobInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobLeadId"] = this.jobLeadId;
        data["companyName"] = this.companyName;
        data["overallOutcome"] = this.overallOutcome;
        data["notes"] = this.notes;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITHJobInterviewDto {
    id: number;
    jobLeadId: number | undefined;
    companyName: string | undefined;
    overallOutcome: InterviewOutcome;
    notes: string | undefined;
    sessions: THJobInterviewSessionDto[] | undefined;
}

export class THJobInterviewSessionDto implements ITHJobInterviewSessionDto {
    id!: number;
    interviewRound!: InterviewRound;
    interviewMethod!: InterviewMethod;
    interviewDate!: DateTime;
    timeZone!: string | undefined;
    outcome!: InterviewOutcome;
    notes!: string | undefined;
    locationAddress!: string | undefined;
    interviewerName!: string | undefined;
    interviewerContact!: string | undefined;

    constructor(data?: ITHJobInterviewSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interviewRound = _data["interviewRound"];
            this.interviewMethod = _data["interviewMethod"];
            this.interviewDate = _data["interviewDate"] ? DateTime.fromISO(_data["interviewDate"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.outcome = _data["outcome"];
            this.notes = _data["notes"];
            this.locationAddress = _data["locationAddress"];
            this.interviewerName = _data["interviewerName"];
            this.interviewerContact = _data["interviewerContact"];
        }
    }

    static fromJS(data: any): THJobInterviewSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new THJobInterviewSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interviewRound"] = this.interviewRound;
        data["interviewMethod"] = this.interviewMethod;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.toString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["outcome"] = this.outcome;
        data["notes"] = this.notes;
        data["locationAddress"] = this.locationAddress;
        data["interviewerName"] = this.interviewerName;
        data["interviewerContact"] = this.interviewerContact;
        return data;
    }
}

export interface ITHJobInterviewSessionDto {
    id: number;
    interviewRound: InterviewRound;
    interviewMethod: InterviewMethod;
    interviewDate: DateTime;
    timeZone: string | undefined;
    outcome: InterviewOutcome;
    notes: string | undefined;
    locationAddress: string | undefined;
    interviewerName: string | undefined;
    interviewerContact: string | undefined;
}

export class THJobLeadDto implements ITHJobLeadDto {
    id!: number;
    ticketHolderId!: number | undefined;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    readonly enumDisplayWorkArrangement!: string | undefined;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    appliedDate!: DateTime | undefined;
    appliedBy!: string | undefined;
    status!: JobApplicationStatus;
    readonly enumDisplayStatus!: string | undefined;
    changeHistory!: THJobActivityDto[] | undefined;
    readonly formattedJobLeadId!: string | undefined;
    reason!: string | undefined;
    importantNotes!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: ITHJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            (<any>this).enumDisplayWorkArrangement = _data["enumDisplayWorkArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.appliedDate = _data["appliedDate"] ? DateTime.fromISO(_data["appliedDate"].toString()) : <any>undefined;
            this.appliedBy = _data["appliedBy"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            if (Array.isArray(_data["changeHistory"])) {
                this.changeHistory = [] as any;
                for (let item of _data["changeHistory"])
                    this.changeHistory!.push(THJobActivityDto.fromJS(item));
            }
            (<any>this).formattedJobLeadId = _data["formattedJobLeadId"];
            this.reason = _data["reason"];
            this.importantNotes = _data["importantNotes"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): THJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new THJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["enumDisplayWorkArrangement"] = this.enumDisplayWorkArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["appliedDate"] = this.appliedDate ? this.appliedDate.toString() : <any>undefined;
        data["appliedBy"] = this.appliedBy;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        if (Array.isArray(this.changeHistory)) {
            data["changeHistory"] = [];
            for (let item of this.changeHistory)
                data["changeHistory"].push(item.toJSON());
        }
        data["formattedJobLeadId"] = this.formattedJobLeadId;
        data["reason"] = this.reason;
        data["importantNotes"] = this.importantNotes;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITHJobLeadDto {
    id: number;
    ticketHolderId: number | undefined;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    enumDisplayWorkArrangement: string | undefined;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    appliedDate: DateTime | undefined;
    appliedBy: string | undefined;
    status: JobApplicationStatus;
    enumDisplayStatus: string | undefined;
    changeHistory: THJobActivityDto[] | undefined;
    formattedJobLeadId: string | undefined;
    reason: string | undefined;
    importantNotes: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
}

export class THMailLogDetailDto implements ITHMailLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string | undefined;
    clientAddress!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: THDocumentDto[] | undefined;
    carrierName!: string | undefined;
    carrierTrackingNumber!: string | undefined;
    status!: ActivityStatus;

    constructor(data?: ITHMailLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(THDocumentDto.fromJS(item));
            }
            this.carrierName = _data["carrierName"];
            this.carrierTrackingNumber = _data["carrierTrackingNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THMailLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new THMailLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["carrierName"] = this.carrierName;
        data["carrierTrackingNumber"] = this.carrierTrackingNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHMailLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: THDocumentDto[] | undefined;
    carrierName: string | undefined;
    carrierTrackingNumber: string | undefined;
    status: ActivityStatus;
}

export class THMeetingWithCareerCoachDto implements ITHMeetingWithCareerCoachDto {
    title!: string;
    description!: string | undefined;
    startTime!: DateTime;

    constructor(data?: ITHMeetingWithCareerCoachDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): THMeetingWithCareerCoachDto {
        data = typeof data === 'object' ? data : {};
        let result = new THMeetingWithCareerCoachDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITHMeetingWithCareerCoachDto {
    title: string;
    description: string | undefined;
    startTime: DateTime;
}

export class THNewAddressDto implements ITHNewAddressDto {
    street!: string;
    city!: string;
    stateAbbreviation!: string;
    zipCode!: string;
    timeZone!: USATimeZone;
    addressType!: AddressType;
    isVerifiedByUSPS!: boolean | undefined;

    constructor(data?: ITHNewAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.timeZone = _data["timeZone"];
            this.addressType = _data["addressType"];
            this.isVerifiedByUSPS = _data["isVerifiedByUSPS"];
        }
    }

    static fromJS(data: any): THNewAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new THNewAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["timeZone"] = this.timeZone;
        data["addressType"] = this.addressType;
        data["isVerifiedByUSPS"] = this.isVerifiedByUSPS;
        return data;
    }
}

export interface ITHNewAddressDto {
    street: string;
    city: string;
    stateAbbreviation: string;
    zipCode: string;
    timeZone: USATimeZone;
    addressType: AddressType;
    isVerifiedByUSPS: boolean | undefined;
}

export class THNewPhoneDto implements ITHNewPhoneDto {
    number!: string;
    phoneType!: PhoneType;
    isVerified!: boolean;

    constructor(data?: ITHNewPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.phoneType = _data["phoneType"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): THNewPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new THNewPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["phoneType"] = this.phoneType;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface ITHNewPhoneDto {
    number: string;
    phoneType: PhoneType;
    isVerified: boolean;
}

export class THNewWorkHistoryDto implements ITHNewWorkHistoryDto {
    employer!: string | undefined;
    jobTitle!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    hourlyWage!: number;
    weeklyHours!: number;

    constructor(data?: ITHNewWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employer = _data["employer"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.hourlyWage = _data["hourlyWage"];
            this.weeklyHours = _data["weeklyHours"];
        }
    }

    static fromJS(data: any): THNewWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new THNewWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employer"] = this.employer;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["hourlyWage"] = this.hourlyWage;
        data["weeklyHours"] = this.weeklyHours;
        return data;
    }
}

export interface ITHNewWorkHistoryDto {
    employer: string | undefined;
    jobTitle: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    hourlyWage: number;
    weeklyHours: number;
}

export class THOtherDetailsDto implements ITHOtherDetailsDto {
    pendingBpQyCount!: number;
    workingRoundsJobSearch!: number;
    pendingJobSearch!: number;
    inProgressJobSearch!: number;
    searchCompletedJobSearch!: number;
    totalActiveSearchRequests!: number;

    constructor(data?: ITHOtherDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingBpQyCount = _data["pendingBpQyCount"];
            this.workingRoundsJobSearch = _data["workingRoundsJobSearch"];
            this.pendingJobSearch = _data["pendingJobSearch"];
            this.inProgressJobSearch = _data["inProgressJobSearch"];
            this.searchCompletedJobSearch = _data["searchCompletedJobSearch"];
            this.totalActiveSearchRequests = _data["totalActiveSearchRequests"];
        }
    }

    static fromJS(data: any): THOtherDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new THOtherDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingBpQyCount"] = this.pendingBpQyCount;
        data["workingRoundsJobSearch"] = this.workingRoundsJobSearch;
        data["pendingJobSearch"] = this.pendingJobSearch;
        data["inProgressJobSearch"] = this.inProgressJobSearch;
        data["searchCompletedJobSearch"] = this.searchCompletedJobSearch;
        data["totalActiveSearchRequests"] = this.totalActiveSearchRequests;
        return data;
    }
}

export interface ITHOtherDetailsDto {
    pendingBpQyCount: number;
    workingRoundsJobSearch: number;
    pendingJobSearch: number;
    inProgressJobSearch: number;
    searchCompletedJobSearch: number;
    totalActiveSearchRequests: number;
}

export class THOutputPayHistoryDto implements ITHOutputPayHistoryDto {
    id!: number;
    employerId!: number;
    employerName!: string | undefined;
    ticketHolderId!: number;
    payType!: PayType;
    readonly enumDisplayPayType!: string | undefined;
    grossPay!: number;
    hoursWorked!: number | undefined;
    payPeriodStart!: DateTime;
    payPeriodEnd!: DateTime;
    payDate!: DateTime;
    notes!: string | undefined;
    paystubDocumentId!: number;

    constructor(data?: ITHOutputPayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.payType = _data["payType"];
            (<any>this).enumDisplayPayType = _data["enumDisplayPayType"];
            this.grossPay = _data["grossPay"];
            this.hoursWorked = _data["hoursWorked"];
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.paystubDocumentId = _data["paystubDocumentId"];
        }
    }

    static fromJS(data: any): THOutputPayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new THOutputPayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["payType"] = this.payType;
        data["enumDisplayPayType"] = this.enumDisplayPayType;
        data["grossPay"] = this.grossPay;
        data["hoursWorked"] = this.hoursWorked;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["notes"] = this.notes;
        data["paystubDocumentId"] = this.paystubDocumentId;
        return data;
    }
}

export interface ITHOutputPayHistoryDto {
    id: number;
    employerId: number;
    employerName: string | undefined;
    ticketHolderId: number;
    payType: PayType;
    enumDisplayPayType: string | undefined;
    grossPay: number;
    hoursWorked: number | undefined;
    payPeriodStart: DateTime;
    payPeriodEnd: DateTime;
    payDate: DateTime;
    notes: string | undefined;
    paystubDocumentId: number;
}

export class THPhoneLogDetailDto implements ITHPhoneLogDetailDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    clientName!: string | undefined;
    clientId!: string | undefined;
    startTime!: DateTime;
    durationInSeconds!: number | undefined;
    fromPhoneNumber!: string | undefined;
    toPhoneNumber!: string | undefined;
    status!: ActivityStatus;
    note!: string | undefined;

    constructor(data?: ITHPhoneLogDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.durationInSeconds = _data["durationInSeconds"];
            this.fromPhoneNumber = _data["fromPhoneNumber"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): THPhoneLogDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new THPhoneLogDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["durationInSeconds"] = this.durationInSeconds;
        data["fromPhoneNumber"] = this.fromPhoneNumber;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }
}

export interface ITHPhoneLogDetailDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    clientName: string | undefined;
    clientId: string | undefined;
    startTime: DateTime;
    durationInSeconds: number | undefined;
    fromPhoneNumber: string | undefined;
    toPhoneNumber: string | undefined;
    status: ActivityStatus;
    note: string | undefined;
}

export class THPhoneNumberDto implements ITHPhoneNumberDto {
    id!: number;
    readonly nonFormattedNumber!: string | undefined;
    number!: string | undefined;
    phoneType!: PhoneType;
    isVerified!: boolean;

    constructor(data?: ITHPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).nonFormattedNumber = _data["nonFormattedNumber"];
            this.number = _data["number"];
            this.phoneType = _data["phoneType"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): THPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new THPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nonFormattedNumber"] = this.nonFormattedNumber;
        data["number"] = this.number;
        data["phoneType"] = this.phoneType;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface ITHPhoneNumberDto {
    id: number;
    nonFormattedNumber: string | undefined;
    number: string | undefined;
    phoneType: PhoneType;
    isVerified: boolean;
}

export class THResumeServiceRequestDto implements ITHResumeServiceRequestDto {
    id!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    assistanceType!: ResumeAssistanceType;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITHResumeServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.assistanceType = _data["assistanceType"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THResumeServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THResumeServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["assistanceType"] = this.assistanceType;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHResumeServiceRequestDto {
    id: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    assistanceType: ResumeAssistanceType;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class THTransportationServiceRequestDto implements ITHTransportationServiceRequestDto {
    id!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    startAddress!: string;
    endAddress!: string;
    purpose!: string;
    adaAccessibility!: boolean;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITHTransportationServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.startAddress = _data["startAddress"];
            this.endAddress = _data["endAddress"];
            this.purpose = _data["purpose"];
            this.adaAccessibility = _data["adaAccessibility"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): THTransportationServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THTransportationServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["startAddress"] = this.startAddress;
        data["endAddress"] = this.endAddress;
        data["purpose"] = this.purpose;
        data["adaAccessibility"] = this.adaAccessibility;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITHTransportationServiceRequestDto {
    id: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    startAddress: string;
    endAddress: string;
    purpose: string;
    adaAccessibility: boolean;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class THVwServiceRequestDto implements ITHVwServiceRequestDto {
    readonly id!: string | undefined;
    idRaw!: number;
    tenantId!: number;
    ticketHolderId!: number;
    serviceType!: ServiceType;
    readonly enumDisplayServiceType!: string | undefined;
    status!: ServiceRequestStatus;
    readonly enumDisplayStatus!: string | undefined;
    dueDate!: DateTime | undefined;
    creationTime!: DateTime;

    constructor(data?: ITHVwServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.idRaw = _data["idRaw"];
            this.tenantId = _data["tenantId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.serviceType = _data["serviceType"];
            (<any>this).enumDisplayServiceType = _data["enumDisplayServiceType"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): THVwServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new THVwServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idRaw"] = this.idRaw;
        data["tenantId"] = this.tenantId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["serviceType"] = this.serviceType;
        data["enumDisplayServiceType"] = this.enumDisplayServiceType;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITHVwServiceRequestDto {
    id: string | undefined;
    idRaw: number;
    tenantId: number;
    ticketHolderId: number;
    serviceType: ServiceType;
    enumDisplayServiceType: string | undefined;
    status: ServiceRequestStatus;
    enumDisplayStatus: string | undefined;
    dueDate: DateTime | undefined;
    creationTime: DateTime;
}

export class THWageReportProcessingQDto implements ITHWageReportProcessingQDto {
    id!: number;
    wageFileName!: string | undefined;
    documentId!: number;
    fromSource!: TicketHolderFileSource;
    readonly enumDisplayFromSource!: string | undefined;
    processingStatus!: WageReportProcessingStatus;
    readonly enumDisplayProcessingStatus!: string | undefined;
    ticketHolderId!: number | undefined;
    formattedTicketHolderId!: string | undefined;
    isPaystub!: boolean;
    creatorUserId!: number | undefined;
    createdBy!: string | undefined;

    constructor(data?: ITHWageReportProcessingQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wageFileName = _data["wageFileName"];
            this.documentId = _data["documentId"];
            this.fromSource = _data["fromSource"];
            (<any>this).enumDisplayFromSource = _data["enumDisplayFromSource"];
            this.processingStatus = _data["processingStatus"];
            (<any>this).enumDisplayProcessingStatus = _data["enumDisplayProcessingStatus"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.isPaystub = _data["isPaystub"];
            this.creatorUserId = _data["creatorUserId"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): THWageReportProcessingQDto {
        data = typeof data === 'object' ? data : {};
        let result = new THWageReportProcessingQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wageFileName"] = this.wageFileName;
        data["documentId"] = this.documentId;
        data["fromSource"] = this.fromSource;
        data["enumDisplayFromSource"] = this.enumDisplayFromSource;
        data["processingStatus"] = this.processingStatus;
        data["enumDisplayProcessingStatus"] = this.enumDisplayProcessingStatus;
        data["ticketHolderId"] = this.ticketHolderId;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["isPaystub"] = this.isPaystub;
        data["creatorUserId"] = this.creatorUserId;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ITHWageReportProcessingQDto {
    id: number;
    wageFileName: string | undefined;
    documentId: number;
    fromSource: TicketHolderFileSource;
    enumDisplayFromSource: string | undefined;
    processingStatus: WageReportProcessingStatus;
    enumDisplayProcessingStatus: string | undefined;
    ticketHolderId: number | undefined;
    formattedTicketHolderId: string | undefined;
    isPaystub: boolean;
    creatorUserId: number | undefined;
    createdBy: string | undefined;
}

export class THWorkHistoryDto implements ITHWorkHistoryDto {
    employer!: string | undefined;
    jobTitle!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    hourlyWage!: number;
    weeklyHours!: number;
    id!: number;
    ticketHolderId!: number;

    constructor(data?: ITHWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employer = _data["employer"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.hourlyWage = _data["hourlyWage"];
            this.weeklyHours = _data["weeklyHours"];
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
        }
    }

    static fromJS(data: any): THWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new THWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employer"] = this.employer;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["hourlyWage"] = this.hourlyWage;
        data["weeklyHours"] = this.weeklyHours;
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        return data;
    }
}

export interface ITHWorkHistoryDto {
    employer: string | undefined;
    jobTitle: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    hourlyWage: number;
    weeklyHours: number;
    id: number;
    ticketHolderId: number;
}

export class THWorkingStatusDto implements ITHWorkingStatusDto {
    belowTWL!: number;
    betweenTWLAndSGA!: number;
    aboveSGA!: number;

    constructor(data?: ITHWorkingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.belowTWL = _data["belowTWL"];
            this.betweenTWLAndSGA = _data["betweenTWLAndSGA"];
            this.aboveSGA = _data["aboveSGA"];
        }
    }

    static fromJS(data: any): THWorkingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new THWorkingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["belowTWL"] = this.belowTWL;
        data["betweenTWLAndSGA"] = this.betweenTWLAndSGA;
        data["aboveSGA"] = this.aboveSGA;
        return data;
    }
}

export interface ITHWorkingStatusDto {
    belowTWL: number;
    betweenTWLAndSGA: number;
    aboveSGA: number;
}

export enum TTWFormsType {
    None = 0,
    TPAChange = 1,
    SecurityAwareness = 2,
    SecurityAwarenessAddendum = 3,
    TPATermination = 4,
    WorkFromHomeRequest = 5,
    WorkFromHomeRequestAddendum = 6,
    ENSecurityGuide = 7,
    ElectronicApplication = 8,
    FederalEmploymentDeclaration = 9,
    ContractorRolloverRequest = 10,
    FingerprintInstructions = 11,
    I9ApprovedDocs = 12,
    StandardForm85 = 13,
    IWP = 14,
    ProofOfRelationship = 15,
    ENSupplementalEarnings = 16,
    ENPaymentRequest = 17,
    ENSplitPaymentRequest = 18,
    ENCertificationOfServices = 19,
    EmployerPreparedEarnings = 20,
    ENUnassignmentRequest = 21,
    SSA3288Form = 22,
    EnAuthorization = 23,
    BPQYCoverLetter = 24,
    IWPFaxCoverSheet = 25,
}

export class TTWTaskTemplateDto implements ITTWTaskTemplateDto {
    id!: number;
    taskCodeWithTitle!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    expectedOutputs!: string | undefined;
    stage!: TTWTaskTemplateStage;
    enumDisplayStage!: string | undefined;
    orderInStage!: number;
    taskCode!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: ITTWTaskTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskCodeWithTitle = _data["taskCodeWithTitle"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.expectedOutputs = _data["expectedOutputs"];
            this.stage = _data["stage"];
            this.enumDisplayStage = _data["enumDisplayStage"];
            this.orderInStage = _data["orderInStage"];
            this.taskCode = _data["taskCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TTWTaskTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TTWTaskTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskCodeWithTitle"] = this.taskCodeWithTitle;
        data["title"] = this.title;
        data["description"] = this.description;
        data["expectedOutputs"] = this.expectedOutputs;
        data["stage"] = this.stage;
        data["enumDisplayStage"] = this.enumDisplayStage;
        data["orderInStage"] = this.orderInStage;
        data["taskCode"] = this.taskCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITTWTaskTemplateDto {
    id: number;
    taskCodeWithTitle: string | undefined;
    title: string | undefined;
    description: string | undefined;
    expectedOutputs: string | undefined;
    stage: TTWTaskTemplateStage;
    enumDisplayStage: string | undefined;
    orderInStage: number;
    taskCode: string | undefined;
    creationTime: DateTime;
}

export enum TTWTaskTemplateStage {
    Intake = 0,
    EngagementAndReadiness = 1,
    JobPreparation = 2,
    ActiveJobSearchAndPlacement = 3,
    OngoingSupport = 4,
}

export class TagGroupTicketHolderDto implements ITagGroupTicketHolderDto {
    id!: number;
    ticketHolderId!: string | undefined;
    fullName!: string | undefined;
    email!: string | undefined;
    status!: TicketHolderStatus;
    enumDisplayStatus!: string | undefined;
    latestContactResult!: ActivityStatus;
    tag!: string | undefined;

    constructor(data?: ITagGroupTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.enumDisplayStatus = _data["enumDisplayStatus"];
            this.latestContactResult = _data["latestContactResult"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): TagGroupTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroupTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["latestContactResult"] = this.latestContactResult;
        data["tag"] = this.tag;
        return data;
    }
}

export interface ITagGroupTicketHolderDto {
    id: number;
    ticketHolderId: string | undefined;
    fullName: string | undefined;
    email: string | undefined;
    status: TicketHolderStatus;
    enumDisplayStatus: string | undefined;
    latestContactResult: ActivityStatus;
    tag: string | undefined;
}

export class TaskExecutionDto implements ITaskExecutionDto {
    id!: number;
    taskId!: number;
    taskName!: string | undefined;
    instanceName!: string | undefined;
    status!: string | undefined;
    isRunning!: boolean;
    isFailed!: boolean;
    scheduledStartTime!: DateTime;
    actualStartTime!: DateTime | undefined;
    endTime!: DateTime | undefined;
    durationSeconds!: number | undefined;
    errorMessage!: string | undefined;
    progressPercentage!: number | undefined;
    totalItems!: number | undefined;
    processedItems!: number | undefined;
    logCount!: number;
    creationTime!: DateTime;

    constructor(data?: ITaskExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.instanceName = _data["instanceName"];
            this.status = _data["status"];
            this.isRunning = _data["isRunning"];
            this.isFailed = _data["isFailed"];
            this.scheduledStartTime = _data["scheduledStartTime"] ? DateTime.fromISO(_data["scheduledStartTime"].toString()) : <any>undefined;
            this.actualStartTime = _data["actualStartTime"] ? DateTime.fromISO(_data["actualStartTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.durationSeconds = _data["durationSeconds"];
            this.errorMessage = _data["errorMessage"];
            this.progressPercentage = _data["progressPercentage"];
            this.totalItems = _data["totalItems"];
            this.processedItems = _data["processedItems"];
            this.logCount = _data["logCount"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["instanceName"] = this.instanceName;
        data["status"] = this.status;
        data["isRunning"] = this.isRunning;
        data["isFailed"] = this.isFailed;
        data["scheduledStartTime"] = this.scheduledStartTime ? this.scheduledStartTime.toString() : <any>undefined;
        data["actualStartTime"] = this.actualStartTime ? this.actualStartTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["durationSeconds"] = this.durationSeconds;
        data["errorMessage"] = this.errorMessage;
        data["progressPercentage"] = this.progressPercentage;
        data["totalItems"] = this.totalItems;
        data["processedItems"] = this.processedItems;
        data["logCount"] = this.logCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITaskExecutionDto {
    id: number;
    taskId: number;
    taskName: string | undefined;
    instanceName: string | undefined;
    status: string | undefined;
    isRunning: boolean;
    isFailed: boolean;
    scheduledStartTime: DateTime;
    actualStartTime: DateTime | undefined;
    endTime: DateTime | undefined;
    durationSeconds: number | undefined;
    errorMessage: string | undefined;
    progressPercentage: number | undefined;
    totalItems: number | undefined;
    processedItems: number | undefined;
    logCount: number;
    creationTime: DateTime;
}

export enum TaskQueueTypeDto {
    Critical = 1,
    Default = 2,
    Background = 3,
    Campaign = 4,
    Import = 5,
}

export class TaskTemplateRequestDto implements ITaskTemplateRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    stages!: TTWTaskTemplateStage[] | undefined;

    constructor(data?: ITaskTemplateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskTemplateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTemplateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item);
        }
        return data;
    }
}

export interface ITaskTemplateRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    stages: TTWTaskTemplateStage[] | undefined;
}

export class TemplateFieldInfo implements ITemplateFieldInfo {
    fieldName!: string | undefined;
    fieldType!: string | undefined;

    constructor(data?: ITemplateFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
        }
    }

    static fromJS(data: any): TemplateFieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        return data;
    }
}

export interface ITemplateFieldInfo {
    fieldName: string | undefined;
    fieldType: string | undefined;
}

export class TemplateFilterDto implements ITemplateFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    clientType!: ClientType;
    type!: TicketHolderDocumentType;
    clientId!: number | undefined;

    constructor(data?: ITemplateFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            this.clientType = _data["clientType"];
            this.type = _data["type"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): TemplateFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        data["clientType"] = this.clientType;
        data["type"] = this.type;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ITemplateFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    clientType: ClientType;
    type: TicketHolderDocumentType;
    clientId: number | undefined;
}

export enum TemplateStatus {
    None = 0,
    Active = 1,
    InActive = 2,
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ITenantEditDto {
    id: number;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseAuthentication!: boolean;
    useHostDefaultEmailSettings!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseAuthentication = _data["smtpUseAuthentication"];
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseAuthentication"] = this.smtpUseAuthentication;
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseAuthentication: boolean;
    useHostDefaultEmailSettings: boolean;
}

export class TenantListDto implements ITenantListDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ITenantListDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    darkLogoId!: string | undefined;
    darkLogoFileType!: string | undefined;
    darkLogoMinimalId!: string | undefined;
    darkLogoMinimalFileType!: string | undefined;
    lightLogoId!: string | undefined;
    lightLogoFileType!: string | undefined;
    lightLogoMinimalId!: string | undefined;
    lightLogoMinimalFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    featureValues!: NameValueDto[] | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.darkLogoId = _data["darkLogoId"];
            this.darkLogoFileType = _data["darkLogoFileType"];
            this.darkLogoMinimalId = _data["darkLogoMinimalId"];
            this.darkLogoMinimalFileType = _data["darkLogoMinimalFileType"];
            this.lightLogoId = _data["lightLogoId"];
            this.lightLogoFileType = _data["lightLogoFileType"];
            this.lightLogoMinimalId = _data["lightLogoMinimalId"];
            this.lightLogoMinimalFileType = _data["lightLogoMinimalFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["darkLogoId"] = this.darkLogoId;
        data["darkLogoFileType"] = this.darkLogoFileType;
        data["darkLogoMinimalId"] = this.darkLogoMinimalId;
        data["darkLogoMinimalFileType"] = this.darkLogoMinimalFileType;
        data["lightLogoId"] = this.lightLogoId;
        data["lightLogoFileType"] = this.lightLogoFileType;
        data["lightLogoMinimalId"] = this.lightLogoMinimalId;
        data["lightLogoMinimalFileType"] = this.lightLogoMinimalFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    darkLogoId: string | undefined;
    darkLogoFileType: string | undefined;
    darkLogoMinimalId: string | undefined;
    darkLogoMinimalFileType: string | undefined;
    lightLogoId: string | undefined;
    lightLogoFileType: string | undefined;
    lightLogoMinimalId: string | undefined;
    lightLogoMinimalFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    featureValues: NameValueDto[] | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    defaultEditionId!: number | undefined;
    captchaSettings!: CaptchaSettingsEditDto;
    isRestrictedEmailDomainEnabled!: boolean;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.defaultEditionId = _data["defaultEditionId"];
            this.captchaSettings = _data["captchaSettings"] ? CaptchaSettingsEditDto.fromJS(_data["captchaSettings"]) : <any>undefined;
            this.isRestrictedEmailDomainEnabled = _data["isRestrictedEmailDomainEnabled"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["defaultEditionId"] = this.defaultEditionId;
        data["captchaSettings"] = this.captchaSettings ? this.captchaSettings.toJSON() : <any>undefined;
        data["isRestrictedEmailDomainEnabled"] = this.isRestrictedEmailDomainEnabled;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    defaultEditionId: number | undefined;
    captchaSettings: CaptchaSettingsEditDto;
    isRestrictedEmailDomainEnabled: boolean;
}

export class TenantNotification implements ITenantNotification {
    id!: string;
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: Type;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: DateTime;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"] ? Type.fromJS(_data["entityType"]) : <any>undefined;
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITenantNotification {
    id: string;
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: Type;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: DateTime;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    captchaSettings!: CaptchaSettingsEditDto;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;
    passwordlessLogin!: PasswordlessLoginSettingsEditDto;
    restrictedEmailDomain!: string | undefined;
    isRestrictedEmailDomainEnabled!: boolean;
    isRestrictedEmailDomainEnabledForApplication!: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.captchaSettings = _data["captchaSettings"] ? CaptchaSettingsEditDto.fromJS(_data["captchaSettings"]) : <any>undefined;
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
            this.passwordlessLogin = _data["passwordlessLogin"] ? PasswordlessLoginSettingsEditDto.fromJS(_data["passwordlessLogin"]) : <any>undefined;
            this.restrictedEmailDomain = _data["restrictedEmailDomain"];
            this.isRestrictedEmailDomainEnabled = _data["isRestrictedEmailDomainEnabled"];
            this.isRestrictedEmailDomainEnabledForApplication = _data["isRestrictedEmailDomainEnabledForApplication"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["captchaSettings"] = this.captchaSettings ? this.captchaSettings.toJSON() : <any>undefined;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        data["passwordlessLogin"] = this.passwordlessLogin ? this.passwordlessLogin.toJSON() : <any>undefined;
        data["restrictedEmailDomain"] = this.restrictedEmailDomain;
        data["isRestrictedEmailDomainEnabled"] = this.isRestrictedEmailDomainEnabled;
        data["isRestrictedEmailDomainEnabledForApplication"] = this.isRestrictedEmailDomainEnabledForApplication;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    captchaSettings: CaptchaSettingsEditDto;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
    passwordlessLogin: PasswordlessLoginSettingsEditDto;
    restrictedEmailDomain: string | undefined;
    isRestrictedEmailDomainEnabled: boolean;
    isRestrictedEmailDomainEnabledForApplication: boolean;
}

export class TestRunDto implements ITestRunDto {
    runId!: string;
    projectName!: string | undefined;
    status!: string | undefined;
    startedAt!: DateTime;
    finishedAt!: DateTime | undefined;
    output!: string | undefined;
    reportUrl!: string | undefined;
    groupRuns!: TestRunDto[] | undefined;

    constructor(data?: ITestRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runId = _data["runId"];
            this.projectName = _data["projectName"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? DateTime.fromISO(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? DateTime.fromISO(_data["finishedAt"].toString()) : <any>undefined;
            this.output = _data["output"];
            this.reportUrl = _data["reportUrl"];
            if (Array.isArray(_data["groupRuns"])) {
                this.groupRuns = [] as any;
                for (let item of _data["groupRuns"])
                    this.groupRuns!.push(TestRunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId;
        data["projectName"] = this.projectName;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toString() : <any>undefined;
        data["output"] = this.output;
        data["reportUrl"] = this.reportUrl;
        if (Array.isArray(this.groupRuns)) {
            data["groupRuns"] = [];
            for (let item of this.groupRuns)
                data["groupRuns"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITestRunDto {
    runId: string;
    projectName: string | undefined;
    status: string | undefined;
    startedAt: DateTime;
    finishedAt: DateTime | undefined;
    output: string | undefined;
    reportUrl: string | undefined;
    groupRuns: TestRunDto[] | undefined;
}

export class ThChatMessageDto implements IThChatMessageDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number;
    ticketHolderName!: string | undefined;
    ticketHolderId!: number;
    chatSessionId!: string | undefined;
    messageContent!: string | undefined;
    status!: ActivityStatus;
    readonly statusName!: string | undefined;
    attachmentIds!: number[] | undefined;
    attachments!: THChatFileDto[] | undefined;
    isRead!: boolean;
    readTime!: DateTime | undefined;
    tenantId!: number | undefined;
    creationTime!: DateTime;
    isFromTicketHolder!: boolean;

    constructor(data?: IThChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.chatSessionId = _data["chatSessionId"];
            this.messageContent = _data["messageContent"];
            this.status = _data["status"];
            (<any>this).statusName = _data["statusName"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(THChatFileDto.fromJS(item));
            }
            this.isRead = _data["isRead"];
            this.readTime = _data["readTime"] ? DateTime.fromISO(_data["readTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isFromTicketHolder = _data["isFromTicketHolder"];
        }
    }

    static fromJS(data: any): ThChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["chatSessionId"] = this.chatSessionId;
        data["messageContent"] = this.messageContent;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["isRead"] = this.isRead;
        data["readTime"] = this.readTime ? this.readTime.toString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isFromTicketHolder"] = this.isFromTicketHolder;
        return data;
    }
}

export interface IThChatMessageDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number;
    ticketHolderName: string | undefined;
    ticketHolderId: number;
    chatSessionId: string | undefined;
    messageContent: string | undefined;
    status: ActivityStatus;
    statusName: string | undefined;
    attachmentIds: number[] | undefined;
    attachments: THChatFileDto[] | undefined;
    isRead: boolean;
    readTime: DateTime | undefined;
    tenantId: number | undefined;
    creationTime: DateTime;
    isFromTicketHolder: boolean;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    desktopFixedFooter!: boolean;
    mobileFixedFooter!: boolean;
    footerWidthType!: string | undefined;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedFooter = _data["desktopFixedFooter"];
            this.mobileFixedFooter = _data["mobileFixedFooter"];
            this.footerWidthType = _data["footerWidthType"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedFooter"] = this.desktopFixedFooter;
        data["mobileFixedFooter"] = this.mobileFixedFooter;
        data["footerWidthType"] = this.footerWidthType;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    desktopFixedFooter: boolean;
    mobileFixedFooter: boolean;
    footerWidthType: string | undefined;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    readonly desktopFixedHeader!: boolean;
    readonly mobileFixedHeader!: boolean;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).desktopFixedHeader = _data["desktopFixedHeader"];
            (<any>this).mobileFixedHeader = _data["mobileFixedHeader"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;
    darkMode!: boolean;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
            this.darkMode = _data["darkMode"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["darkMode"] = this.darkMode;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
    darkMode: boolean;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;
    toolbar!: ThemeToolbarSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
            this.toolbar = _data["toolbar"] ? ThemeToolbarSettingsDto.fromJS(_data["toolbar"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        data["toolbar"] = this.toolbar ? this.toolbar.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
    toolbar: ThemeToolbarSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStyle!: string | undefined;
    containerStyle!: string | undefined;
    subContainerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStyle = _data["titleStyle"];
            this.containerStyle = _data["containerStyle"];
            this.subContainerStyle = _data["subContainerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStyle"] = this.titleStyle;
        data["containerStyle"] = this.containerStyle;
        data["subContainerStyle"] = this.subContainerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStyle: string | undefined;
    containerStyle: string | undefined;
    subContainerStyle: string | undefined;
}

export class ThemeToolbarSettingsDto implements IThemeToolbarSettingsDto {
    desktopFixedToolbar!: boolean;
    mobileFixedToolbar!: boolean;

    constructor(data?: IThemeToolbarSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedToolbar = _data["desktopFixedToolbar"];
            this.mobileFixedToolbar = _data["mobileFixedToolbar"];
        }
    }

    static fromJS(data: any): ThemeToolbarSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeToolbarSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedToolbar"] = this.desktopFixedToolbar;
        data["mobileFixedToolbar"] = this.mobileFixedToolbar;
        return data;
    }
}

export interface IThemeToolbarSettingsDto {
    desktopFixedToolbar: boolean;
    mobileFixedToolbar: boolean;
}

export class TicketAssignabilityVerificationDto implements ITicketAssignabilityVerificationDto {
    id!: number;
    leadId!: number;
    benefitType!: BenefitType;
    assignabilityReasonCode!: AssignabilityReasonCode;
    assignabilityComments!: string | undefined;

    constructor(data?: ITicketAssignabilityVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.benefitType = _data["benefitType"];
            this.assignabilityReasonCode = _data["assignabilityReasonCode"];
            this.assignabilityComments = _data["assignabilityComments"];
        }
    }

    static fromJS(data: any): TicketAssignabilityVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignabilityVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["benefitType"] = this.benefitType;
        data["assignabilityReasonCode"] = this.assignabilityReasonCode;
        data["assignabilityComments"] = this.assignabilityComments;
        return data;
    }
}

export interface ITicketAssignabilityVerificationDto {
    id: number;
    leadId: number;
    benefitType: BenefitType;
    assignabilityReasonCode: AssignabilityReasonCode;
    assignabilityComments: string | undefined;
}

export class TicketAssignabilityVerificationOutputDto implements ITicketAssignabilityVerificationOutputDto {
    id!: number;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    benefitType!: BenefitType;
    assignabilityReasonCode!: AssignabilityReasonCode;
    readonly enumDisplayAssignabilityReasonCode!: string | undefined;
    assignabilityComments!: string | undefined;
    requestedDate!: DateTime | undefined;
    requestedByUserId!: number | undefined;
    requestedBy!: string | undefined;
    verificationDate!: DateTime | undefined;
    verifiedByUserId!: number | undefined;
    verifiedBy!: string | undefined;
    readonly assignabilityReasonCodeDescription!: string | undefined;

    constructor(data?: ITicketAssignabilityVerificationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.benefitType = _data["benefitType"];
            this.assignabilityReasonCode = _data["assignabilityReasonCode"];
            (<any>this).enumDisplayAssignabilityReasonCode = _data["enumDisplayAssignabilityReasonCode"];
            this.assignabilityComments = _data["assignabilityComments"];
            this.requestedDate = _data["requestedDate"] ? DateTime.fromISO(_data["requestedDate"].toString()) : <any>undefined;
            this.requestedByUserId = _data["requestedByUserId"];
            this.requestedBy = _data["requestedBy"];
            this.verificationDate = _data["verificationDate"] ? DateTime.fromISO(_data["verificationDate"].toString()) : <any>undefined;
            this.verifiedByUserId = _data["verifiedByUserId"];
            this.verifiedBy = _data["verifiedBy"];
            (<any>this).assignabilityReasonCodeDescription = _data["assignabilityReasonCodeDescription"];
        }
    }

    static fromJS(data: any): TicketAssignabilityVerificationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignabilityVerificationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["benefitType"] = this.benefitType;
        data["assignabilityReasonCode"] = this.assignabilityReasonCode;
        data["enumDisplayAssignabilityReasonCode"] = this.enumDisplayAssignabilityReasonCode;
        data["assignabilityComments"] = this.assignabilityComments;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toString() : <any>undefined;
        data["requestedByUserId"] = this.requestedByUserId;
        data["requestedBy"] = this.requestedBy;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toString() : <any>undefined;
        data["verifiedByUserId"] = this.verifiedByUserId;
        data["verifiedBy"] = this.verifiedBy;
        data["assignabilityReasonCodeDescription"] = this.assignabilityReasonCodeDescription;
        return data;
    }
}

export interface ITicketAssignabilityVerificationOutputDto {
    id: number;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    benefitType: BenefitType;
    assignabilityReasonCode: AssignabilityReasonCode;
    enumDisplayAssignabilityReasonCode: string | undefined;
    assignabilityComments: string | undefined;
    requestedDate: DateTime | undefined;
    requestedByUserId: number | undefined;
    requestedBy: string | undefined;
    verificationDate: DateTime | undefined;
    verifiedByUserId: number | undefined;
    verifiedBy: string | undefined;
    assignabilityReasonCodeDescription: string | undefined;
}

export class TicketAssignmentDocumentDto implements ITicketAssignmentDocumentDto {
    fileName!: string | undefined;
    fileContent!: string | undefined;
    isAmendment!: boolean;

    constructor(data?: ITicketAssignmentDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.isAmendment = _data["isAmendment"];
        }
    }

    static fromJS(data: any): TicketAssignmentDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignmentDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["isAmendment"] = this.isAmendment;
        return data;
    }
}

export interface ITicketAssignmentDocumentDto {
    fileName: string | undefined;
    fileContent: string | undefined;
    isAmendment: boolean;
}

export class TicketAssignmentListItemDto implements ITicketAssignmentListItemDto {
    ticketHolderId!: number;
    ticketHolderDisplayId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    iwpId!: number | undefined;
    status!: TicketHolderStatus;
    statusDisplayName!: string | undefined;
    creationTime!: DateTime;
    encryptedSSN!: string | undefined;
    maskedSSN!: string | undefined;
    doB!: DateTime | undefined;
    ssaUploadedDate!: DateTime | undefined;

    constructor(data?: ITicketAssignmentListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderDisplayId = _data["ticketHolderDisplayId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.iwpId = _data["iwpId"];
            this.status = _data["status"];
            this.statusDisplayName = _data["statusDisplayName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.encryptedSSN = _data["encryptedSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.ssaUploadedDate = _data["ssaUploadedDate"] ? DateTime.fromISO(_data["ssaUploadedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketAssignmentListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignmentListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderDisplayId"] = this.ticketHolderDisplayId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["iwpId"] = this.iwpId;
        data["status"] = this.status;
        data["statusDisplayName"] = this.statusDisplayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["encryptedSSN"] = this.encryptedSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ssaUploadedDate"] = this.ssaUploadedDate ? this.ssaUploadedDate.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketAssignmentListItemDto {
    ticketHolderId: number;
    ticketHolderDisplayId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    iwpId: number | undefined;
    status: TicketHolderStatus;
    statusDisplayName: string | undefined;
    creationTime: DateTime;
    encryptedSSN: string | undefined;
    maskedSSN: string | undefined;
    doB: DateTime | undefined;
    ssaUploadedDate: DateTime | undefined;
}

export class TicketHolderActivityDto implements ITicketHolderActivityDto {
    id!: number;
    ticketHolderId!: number;
    activityType!: ContactType;
    enumDisplayActivityType!: string | undefined;
    direction!: ActivityDirection;
    contactInfo!: string | undefined;
    subject!: string | undefined;
    activityContent!: string | undefined;
    status!: ActivityStatus;
    enumDisplayActivityStatus!: string | undefined;
    serviceType!: ActivityServiceType;
    enumDisplayServiceType!: string | undefined;
    startTime!: DateTime;
    logId!: number | undefined;
    creationTime!: DateTime | undefined;
    creatorUserId!: number | undefined;
    hasAttachments!: boolean;
    piiReviewRequestId!: number | undefined;
    piiNumber!: string | undefined;
    piiSendStatus!: PiiSendStatus;

    constructor(data?: ITicketHolderActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.activityType = _data["activityType"];
            this.enumDisplayActivityType = _data["enumDisplayActivityType"];
            this.direction = _data["direction"];
            this.contactInfo = _data["contactInfo"];
            this.subject = _data["subject"];
            this.activityContent = _data["activityContent"];
            this.status = _data["status"];
            this.enumDisplayActivityStatus = _data["enumDisplayActivityStatus"];
            this.serviceType = _data["serviceType"];
            this.enumDisplayServiceType = _data["enumDisplayServiceType"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.logId = _data["logId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.hasAttachments = _data["hasAttachments"];
            this.piiReviewRequestId = _data["piiReviewRequestId"];
            this.piiNumber = _data["piiNumber"];
            this.piiSendStatus = _data["piiSendStatus"];
        }
    }

    static fromJS(data: any): TicketHolderActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["activityType"] = this.activityType;
        data["enumDisplayActivityType"] = this.enumDisplayActivityType;
        data["direction"] = this.direction;
        data["contactInfo"] = this.contactInfo;
        data["subject"] = this.subject;
        data["activityContent"] = this.activityContent;
        data["status"] = this.status;
        data["enumDisplayActivityStatus"] = this.enumDisplayActivityStatus;
        data["serviceType"] = this.serviceType;
        data["enumDisplayServiceType"] = this.enumDisplayServiceType;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["logId"] = this.logId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["hasAttachments"] = this.hasAttachments;
        data["piiReviewRequestId"] = this.piiReviewRequestId;
        data["piiNumber"] = this.piiNumber;
        data["piiSendStatus"] = this.piiSendStatus;
        return data;
    }
}

export interface ITicketHolderActivityDto {
    id: number;
    ticketHolderId: number;
    activityType: ContactType;
    enumDisplayActivityType: string | undefined;
    direction: ActivityDirection;
    contactInfo: string | undefined;
    subject: string | undefined;
    activityContent: string | undefined;
    status: ActivityStatus;
    enumDisplayActivityStatus: string | undefined;
    serviceType: ActivityServiceType;
    enumDisplayServiceType: string | undefined;
    startTime: DateTime;
    logId: number | undefined;
    creationTime: DateTime | undefined;
    creatorUserId: number | undefined;
    hasAttachments: boolean;
    piiReviewRequestId: number | undefined;
    piiNumber: string | undefined;
    piiSendStatus: PiiSendStatus;
}

export class TicketHolderAddressDto implements ITicketHolderAddressDto {
    id!: number;
    ticketHolderId!: number;
    street!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    zipCode!: string | undefined;
    timeZone!: USATimeZone;
    addressType!: AddressType;
    isVerifiedByUSPS!: boolean | undefined;

    constructor(data?: ITicketHolderAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.timeZone = _data["timeZone"];
            this.addressType = _data["addressType"];
            this.isVerifiedByUSPS = _data["isVerifiedByUSPS"];
        }
    }

    static fromJS(data: any): TicketHolderAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["timeZone"] = this.timeZone;
        data["addressType"] = this.addressType;
        data["isVerifiedByUSPS"] = this.isVerifiedByUSPS;
        return data;
    }
}

export interface ITicketHolderAddressDto {
    id: number;
    ticketHolderId: number;
    street: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    zipCode: string | undefined;
    timeZone: USATimeZone;
    addressType: AddressType;
    isVerifiedByUSPS: boolean | undefined;
}

export class TicketHolderAuthenticateModel implements ITicketHolderAuthenticateModel {
    emailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    deviceToken!: string | undefined;
    deviceName!: string | undefined;

    constructor(data?: ITicketHolderAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.deviceToken = _data["deviceToken"];
            this.deviceName = _data["deviceName"];
        }
    }

    static fromJS(data: any): TicketHolderAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["deviceToken"] = this.deviceToken;
        data["deviceName"] = this.deviceName;
        return data;
    }
}

export interface ITicketHolderAuthenticateModel {
    emailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    deviceToken: string | undefined;
    deviceName: string | undefined;
}

export class TicketHolderAuthenticateResultModel implements ITicketHolderAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    userId!: number;
    tenantId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorReason!: TicketHolderTwoFactorReason;
    deviceToken!: string | undefined;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;

    constructor(data?: ITicketHolderAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            this.twoFactorReason = _data["twoFactorReason"];
            this.deviceToken = _data["deviceToken"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
        }
    }

    static fromJS(data: any): TicketHolderAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        data["twoFactorReason"] = this.twoFactorReason;
        data["deviceToken"] = this.deviceToken;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        return data;
    }
}

export interface ITicketHolderAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    userId: number;
    tenantId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorReason: TicketHolderTwoFactorReason;
    deviceToken: string | undefined;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
}

export class TicketHolderBenefitResponseDto implements ITicketHolderBenefitResponseDto {
    id!: number;
    ticketHolderId!: number;
    benefitType!: BenefitType;
    enumBenefitTypeValue!: string | undefined;
    currentStatus!: BenefitPaymentStatus;
    enumCurrentStatusValue!: string | undefined;
    isStatutorilyBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    entitlementDate!: DateTime | undefined;
    fullAmount!: number | undefined;
    netAmount!: number | undefined;
    othersPaid!: boolean | undefined;
    totalFamilyCashBenifit!: number | undefined;
    overPaymentBalance!: number | undefined;
    monthlyAmountWithHeld!: number | undefined;
    isRepresentativePayee!: boolean | undefined;
    isAuthorisedRepresentative!: boolean | undefined;
    nextMedicalReviewDate!: DateTime | undefined;
    medicalReExamCycle!: string | undefined;

    constructor(data?: ITicketHolderBenefitResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.benefitType = _data["benefitType"];
            this.enumBenefitTypeValue = _data["enumBenefitTypeValue"];
            this.currentStatus = _data["currentStatus"];
            this.enumCurrentStatusValue = _data["enumCurrentStatusValue"];
            this.isStatutorilyBlind = _data["isStatutorilyBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.entitlementDate = _data["entitlementDate"] ? DateTime.fromISO(_data["entitlementDate"].toString()) : <any>undefined;
            this.fullAmount = _data["fullAmount"];
            this.netAmount = _data["netAmount"];
            this.othersPaid = _data["othersPaid"];
            this.totalFamilyCashBenifit = _data["totalFamilyCashBenifit"];
            this.overPaymentBalance = _data["overPaymentBalance"];
            this.monthlyAmountWithHeld = _data["monthlyAmountWithHeld"];
            this.isRepresentativePayee = _data["isRepresentativePayee"];
            this.isAuthorisedRepresentative = _data["isAuthorisedRepresentative"];
            this.nextMedicalReviewDate = _data["nextMedicalReviewDate"] ? DateTime.fromISO(_data["nextMedicalReviewDate"].toString()) : <any>undefined;
            this.medicalReExamCycle = _data["medicalReExamCycle"];
        }
    }

    static fromJS(data: any): TicketHolderBenefitResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderBenefitResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["benefitType"] = this.benefitType;
        data["enumBenefitTypeValue"] = this.enumBenefitTypeValue;
        data["currentStatus"] = this.currentStatus;
        data["enumCurrentStatusValue"] = this.enumCurrentStatusValue;
        data["isStatutorilyBlind"] = this.isStatutorilyBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toString() : <any>undefined;
        data["entitlementDate"] = this.entitlementDate ? this.entitlementDate.toString() : <any>undefined;
        data["fullAmount"] = this.fullAmount;
        data["netAmount"] = this.netAmount;
        data["othersPaid"] = this.othersPaid;
        data["totalFamilyCashBenifit"] = this.totalFamilyCashBenifit;
        data["overPaymentBalance"] = this.overPaymentBalance;
        data["monthlyAmountWithHeld"] = this.monthlyAmountWithHeld;
        data["isRepresentativePayee"] = this.isRepresentativePayee;
        data["isAuthorisedRepresentative"] = this.isAuthorisedRepresentative;
        data["nextMedicalReviewDate"] = this.nextMedicalReviewDate ? this.nextMedicalReviewDate.toString() : <any>undefined;
        data["medicalReExamCycle"] = this.medicalReExamCycle;
        return data;
    }
}

export interface ITicketHolderBenefitResponseDto {
    id: number;
    ticketHolderId: number;
    benefitType: BenefitType;
    enumBenefitTypeValue: string | undefined;
    currentStatus: BenefitPaymentStatus;
    enumCurrentStatusValue: string | undefined;
    isStatutorilyBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    entitlementDate: DateTime | undefined;
    fullAmount: number | undefined;
    netAmount: number | undefined;
    othersPaid: boolean | undefined;
    totalFamilyCashBenifit: number | undefined;
    overPaymentBalance: number | undefined;
    monthlyAmountWithHeld: number | undefined;
    isRepresentativePayee: boolean | undefined;
    isAuthorisedRepresentative: boolean | undefined;
    nextMedicalReviewDate: DateTime | undefined;
    medicalReExamCycle: string | undefined;
}

export class TicketHolderBillingDashboardDto implements ITicketHolderBillingDashboardDto {
    ticketHolderId!: string | undefined;
    ticketHolderName!: string | undefined;
    enStartDate!: DateTime | undefined;
    employer!: string | undefined;
    paymentsYtd!: number;
    lifetime!: number;
    lastSsaPayment!: DateTime | undefined;
    lastPaystubReceived!: DateTime | undefined;
    requestsPending!: number;
    phaseMilestoneId!: string | undefined;
    nextMilestoneCode!: string | undefined;
    phaseMilestoneUpdated!: DateTime | undefined;
    nextMilestoneStatus!: string | undefined;
    targetMonth!: DateTime | undefined;
    totalPaystubs!: number;
    hasEmployerEin!: boolean;
    evidenceCompletionPercent!: number;
    status!: TicketHolderStatus;
    statusValue!: string | undefined;
    programType!: string | undefined;
    missingItems!: string[] | undefined;

    constructor(data?: ITicketHolderBillingDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.enStartDate = _data["enStartDate"] ? DateTime.fromISO(_data["enStartDate"].toString()) : <any>undefined;
            this.employer = _data["employer"];
            this.paymentsYtd = _data["paymentsYtd"];
            this.lifetime = _data["lifetime"];
            this.lastSsaPayment = _data["lastSsaPayment"] ? DateTime.fromISO(_data["lastSsaPayment"].toString()) : <any>undefined;
            this.lastPaystubReceived = _data["lastPaystubReceived"] ? DateTime.fromISO(_data["lastPaystubReceived"].toString()) : <any>undefined;
            this.requestsPending = _data["requestsPending"];
            this.phaseMilestoneId = _data["phaseMilestoneId"];
            this.nextMilestoneCode = _data["nextMilestoneCode"];
            this.phaseMilestoneUpdated = _data["phaseMilestoneUpdated"] ? DateTime.fromISO(_data["phaseMilestoneUpdated"].toString()) : <any>undefined;
            this.nextMilestoneStatus = _data["nextMilestoneStatus"];
            this.targetMonth = _data["targetMonth"] ? DateTime.fromISO(_data["targetMonth"].toString()) : <any>undefined;
            this.totalPaystubs = _data["totalPaystubs"];
            this.hasEmployerEin = _data["hasEmployerEin"];
            this.evidenceCompletionPercent = _data["evidenceCompletionPercent"];
            this.status = _data["status"];
            this.statusValue = _data["statusValue"];
            this.programType = _data["programType"];
            if (Array.isArray(_data["missingItems"])) {
                this.missingItems = [] as any;
                for (let item of _data["missingItems"])
                    this.missingItems!.push(item);
            }
        }
    }

    static fromJS(data: any): TicketHolderBillingDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderBillingDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["enStartDate"] = this.enStartDate ? this.enStartDate.toString() : <any>undefined;
        data["employer"] = this.employer;
        data["paymentsYtd"] = this.paymentsYtd;
        data["lifetime"] = this.lifetime;
        data["lastSsaPayment"] = this.lastSsaPayment ? this.lastSsaPayment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastPaystubReceived"] = this.lastPaystubReceived ? this.lastPaystubReceived.toString() : <any>undefined;
        data["requestsPending"] = this.requestsPending;
        data["phaseMilestoneId"] = this.phaseMilestoneId;
        data["nextMilestoneCode"] = this.nextMilestoneCode;
        data["phaseMilestoneUpdated"] = this.phaseMilestoneUpdated ? this.phaseMilestoneUpdated.toString() : <any>undefined;
        data["nextMilestoneStatus"] = this.nextMilestoneStatus;
        data["targetMonth"] = this.targetMonth ? this.targetMonth.toString() : <any>undefined;
        data["totalPaystubs"] = this.totalPaystubs;
        data["hasEmployerEin"] = this.hasEmployerEin;
        data["evidenceCompletionPercent"] = this.evidenceCompletionPercent;
        data["status"] = this.status;
        data["statusValue"] = this.statusValue;
        data["programType"] = this.programType;
        if (Array.isArray(this.missingItems)) {
            data["missingItems"] = [];
            for (let item of this.missingItems)
                data["missingItems"].push(item);
        }
        return data;
    }
}

export interface ITicketHolderBillingDashboardDto {
    ticketHolderId: string | undefined;
    ticketHolderName: string | undefined;
    enStartDate: DateTime | undefined;
    employer: string | undefined;
    paymentsYtd: number;
    lifetime: number;
    lastSsaPayment: DateTime | undefined;
    lastPaystubReceived: DateTime | undefined;
    requestsPending: number;
    phaseMilestoneId: string | undefined;
    nextMilestoneCode: string | undefined;
    phaseMilestoneUpdated: DateTime | undefined;
    nextMilestoneStatus: string | undefined;
    targetMonth: DateTime | undefined;
    totalPaystubs: number;
    hasEmployerEin: boolean;
    evidenceCompletionPercent: number;
    status: TicketHolderStatus;
    statusValue: string | undefined;
    programType: string | undefined;
    missingItems: string[] | undefined;
}

export class TicketHolderCareerCoachAssignedDto implements ITicketHolderCareerCoachAssignedDto {
    id!: number;
    ticketHolderId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    readonly fullName!: string | undefined;
    assigneeName!: string | undefined;
    assigneeId!: number | undefined;
    latestContactResult!: ActivityStatus;
    readonly latestContactEnumDisplay!: string | undefined;
    status!: TicketHolderStatus;
    readonly enumDisplayStatus!: string | undefined;
    iwpEnrollmentDate!: DateTime | undefined;
    shortNotes!: string | undefined;
    jobSearchScheduleDays!: string | undefined;

    constructor(data?: ITicketHolderCareerCoachAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.assigneeName = _data["assigneeName"];
            this.assigneeId = _data["assigneeId"];
            this.latestContactResult = _data["latestContactResult"];
            (<any>this).latestContactEnumDisplay = _data["latestContactEnumDisplay"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.iwpEnrollmentDate = _data["iwpEnrollmentDate"] ? DateTime.fromISO(_data["iwpEnrollmentDate"].toString()) : <any>undefined;
            this.shortNotes = _data["shortNotes"];
            this.jobSearchScheduleDays = _data["jobSearchScheduleDays"];
        }
    }

    static fromJS(data: any): TicketHolderCareerCoachAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderCareerCoachAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["assigneeName"] = this.assigneeName;
        data["assigneeId"] = this.assigneeId;
        data["latestContactResult"] = this.latestContactResult;
        data["latestContactEnumDisplay"] = this.latestContactEnumDisplay;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["iwpEnrollmentDate"] = this.iwpEnrollmentDate ? this.iwpEnrollmentDate.toString() : <any>undefined;
        data["shortNotes"] = this.shortNotes;
        data["jobSearchScheduleDays"] = this.jobSearchScheduleDays;
        return data;
    }
}

export interface ITicketHolderCareerCoachAssignedDto {
    id: number;
    ticketHolderId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    fullName: string | undefined;
    assigneeName: string | undefined;
    assigneeId: number | undefined;
    latestContactResult: ActivityStatus;
    latestContactEnumDisplay: string | undefined;
    status: TicketHolderStatus;
    enumDisplayStatus: string | undefined;
    iwpEnrollmentDate: DateTime | undefined;
    shortNotes: string | undefined;
    jobSearchScheduleDays: string | undefined;
}

export class TicketHolderDisabilityDto implements ITicketHolderDisabilityDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITicketHolderDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TicketHolderDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ITicketHolderDisabilityDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export enum TicketHolderDocumentType {
    TemplateEmail = 1,
    TemplateMail = 2,
    TemplateFax = 3,
    TemplateForms = 4,
    TemplateSMS = 9,
    TemplateDigiSign = 10,
    Paystub = 11,
    Resume = 12,
    Other = 13,
    BPQY = 14,
    IWP = 15,
    IWPAddendum = 16,
    CareerCoachDocument = 21,
    TicketHolderDocument = 31,
    BSAPlanningAttachment = 32,
    BSAReportAttachment = 33,
    BSAReportGenerated = 34,
    IntakeGenerated = 35,
}

export class TicketHolderDto implements ITicketHolderDto {
    id!: number;
    ticketHolderId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    readonly fullName!: string | undefined;
    doB!: DateTime | undefined;
    email!: string | undefined;
    isEmailVerified!: boolean | undefined;
    encryptedSSN!: string | undefined;
    maskedSSN!: string | undefined;
    benefitType!: BenefitType;
    languagePreference!: SpokenLanguage;
    importBatchId!: string | undefined;
    importGroupId!: number | undefined;
    assigneeName!: string | undefined;
    assigneeId!: number | undefined;
    latestContactResult!: ActivityStatus;
    readonly latestContactEnumDisplay!: string | undefined;
    phoneNumbers!: TicketHolderPhoneNumberDto[] | undefined;
    addresses!: TicketHolderAddressDto[] | undefined;
    isFelony!: boolean | undefined;
    jobAccommodationNote!: string | undefined;
    disabilities!: DisabilityDto[] | undefined;
    phaseMilestoneId!: string | undefined;
    notes!: string | undefined;
    workStatus!: WorkStatus;
    enumWorkStatusValue!: string | undefined;
    requestedServices!: SupportServices;
    spokenLanguages!: SpokenLanguageDto[] | undefined;
    status!: TicketHolderStatus;
    readonly enumDisplayStatus!: string | undefined;
    shortNotes!: string | undefined;
    tag!: string | undefined;
    hasResume!: boolean;
    scheduledJobSearch!: string | undefined;
    ticketAssignedDate!: DateTime | undefined;
    lastActivityDate!: DateTime | undefined;
    hasTwowayCommunication!: boolean | undefined;
    lastTwowayCommunicationDate!: DateTime | undefined;

    constructor(data?: ITicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.isEmailVerified = _data["isEmailVerified"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.benefitType = _data["benefitType"];
            this.languagePreference = _data["languagePreference"] ? SpokenLanguage.fromJS(_data["languagePreference"]) : <any>undefined;
            this.importBatchId = _data["importBatchId"];
            this.importGroupId = _data["importGroupId"];
            this.assigneeName = _data["assigneeName"];
            this.assigneeId = _data["assigneeId"];
            this.latestContactResult = _data["latestContactResult"];
            (<any>this).latestContactEnumDisplay = _data["latestContactEnumDisplay"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(TicketHolderPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(TicketHolderAddressDto.fromJS(item));
            }
            this.isFelony = _data["isFelony"];
            this.jobAccommodationNote = _data["jobAccommodationNote"];
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(DisabilityDto.fromJS(item));
            }
            this.phaseMilestoneId = _data["phaseMilestoneId"];
            this.notes = _data["notes"];
            this.workStatus = _data["workStatus"];
            this.enumWorkStatusValue = _data["enumWorkStatusValue"];
            this.requestedServices = _data["requestedServices"];
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.shortNotes = _data["shortNotes"];
            this.tag = _data["tag"];
            this.hasResume = _data["hasResume"];
            this.scheduledJobSearch = _data["scheduledJobSearch"];
            this.ticketAssignedDate = _data["ticketAssignedDate"] ? DateTime.fromISO(_data["ticketAssignedDate"].toString()) : <any>undefined;
            this.lastActivityDate = _data["lastActivityDate"] ? DateTime.fromISO(_data["lastActivityDate"].toString()) : <any>undefined;
            this.hasTwowayCommunication = _data["hasTwowayCommunication"];
            this.lastTwowayCommunicationDate = _data["lastTwowayCommunicationDate"] ? DateTime.fromISO(_data["lastTwowayCommunicationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["email"] = this.email;
        data["isEmailVerified"] = this.isEmailVerified;
        data["encryptedSSN"] = this.encryptedSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["benefitType"] = this.benefitType;
        data["languagePreference"] = this.languagePreference ? this.languagePreference.toJSON() : <any>undefined;
        data["importBatchId"] = this.importBatchId;
        data["importGroupId"] = this.importGroupId;
        data["assigneeName"] = this.assigneeName;
        data["assigneeId"] = this.assigneeId;
        data["latestContactResult"] = this.latestContactResult;
        data["latestContactEnumDisplay"] = this.latestContactEnumDisplay;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["isFelony"] = this.isFelony;
        data["jobAccommodationNote"] = this.jobAccommodationNote;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        data["phaseMilestoneId"] = this.phaseMilestoneId;
        data["notes"] = this.notes;
        data["workStatus"] = this.workStatus;
        data["enumWorkStatusValue"] = this.enumWorkStatusValue;
        data["requestedServices"] = this.requestedServices;
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["shortNotes"] = this.shortNotes;
        data["tag"] = this.tag;
        data["hasResume"] = this.hasResume;
        data["scheduledJobSearch"] = this.scheduledJobSearch;
        data["ticketAssignedDate"] = this.ticketAssignedDate ? this.ticketAssignedDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["hasTwowayCommunication"] = this.hasTwowayCommunication;
        data["lastTwowayCommunicationDate"] = this.lastTwowayCommunicationDate ? this.lastTwowayCommunicationDate.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketHolderDto {
    id: number;
    ticketHolderId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    fullName: string | undefined;
    doB: DateTime | undefined;
    email: string | undefined;
    isEmailVerified: boolean | undefined;
    encryptedSSN: string | undefined;
    maskedSSN: string | undefined;
    benefitType: BenefitType;
    languagePreference: SpokenLanguage;
    importBatchId: string | undefined;
    importGroupId: number | undefined;
    assigneeName: string | undefined;
    assigneeId: number | undefined;
    latestContactResult: ActivityStatus;
    latestContactEnumDisplay: string | undefined;
    phoneNumbers: TicketHolderPhoneNumberDto[] | undefined;
    addresses: TicketHolderAddressDto[] | undefined;
    isFelony: boolean | undefined;
    jobAccommodationNote: string | undefined;
    disabilities: DisabilityDto[] | undefined;
    phaseMilestoneId: string | undefined;
    notes: string | undefined;
    workStatus: WorkStatus;
    enumWorkStatusValue: string | undefined;
    requestedServices: SupportServices;
    spokenLanguages: SpokenLanguageDto[] | undefined;
    status: TicketHolderStatus;
    enumDisplayStatus: string | undefined;
    shortNotes: string | undefined;
    tag: string | undefined;
    hasResume: boolean;
    scheduledJobSearch: string | undefined;
    ticketAssignedDate: DateTime | undefined;
    lastActivityDate: DateTime | undefined;
    hasTwowayCommunication: boolean | undefined;
    lastTwowayCommunicationDate: DateTime | undefined;
}

export class TicketHolderEmployerIdAndNameDto implements ITicketHolderEmployerIdAndNameDto {
    id!: number;
    employer!: string | undefined;
    employerAddress!: string | undefined;
    employerPhoneNumber!: string | undefined;

    constructor(data?: ITicketHolderEmployerIdAndNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employer = _data["employer"];
            this.employerAddress = _data["employerAddress"];
            this.employerPhoneNumber = _data["employerPhoneNumber"];
        }
    }

    static fromJS(data: any): TicketHolderEmployerIdAndNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderEmployerIdAndNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employer"] = this.employer;
        data["employerAddress"] = this.employerAddress;
        data["employerPhoneNumber"] = this.employerPhoneNumber;
        return data;
    }
}

export interface ITicketHolderEmployerIdAndNameDto {
    id: number;
    employer: string | undefined;
    employerAddress: string | undefined;
    employerPhoneNumber: string | undefined;
}

export class TicketHolderEmployerList implements ITicketHolderEmployerList {
    id!: number;
    employer!: string | undefined;

    constructor(data?: ITicketHolderEmployerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employer = _data["employer"];
        }
    }

    static fromJS(data: any): TicketHolderEmployerList {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderEmployerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employer"] = this.employer;
        return data;
    }
}

export interface ITicketHolderEmployerList {
    id: number;
    employer: string | undefined;
}

export enum TicketHolderFileSource {
    SMS = 0,
    WebApi = 1,
    Email = 2,
    Fax = 3,
    Chat = 4,
    MeasureOne = 5,
    UploadFromCC = 6,
    TicketHolder = 7,
    Other = 8,
}

export class TicketHolderFollowupDto implements ITicketHolderFollowupDto {
    id!: number;
    ticketHolderId!: number;
    title!: string | undefined;
    description!: string | undefined;
    startDate!: DateTime;
    dueDate!: DateTime | undefined;
    reminderDate!: DateTime | undefined;
    assignedToUserId!: number;
    status!: CalendarEventStatus;
    followupType!: FollowupType;

    constructor(data?: ITicketHolderFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
            this.assignedToUserId = _data["assignedToUserId"];
            this.status = _data["status"];
            this.followupType = _data["followupType"];
        }
    }

    static fromJS(data: any): TicketHolderFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toString() : <any>undefined;
        data["assignedToUserId"] = this.assignedToUserId;
        data["status"] = this.status;
        data["followupType"] = this.followupType;
        return data;
    }
}

export interface ITicketHolderFollowupDto {
    id: number;
    ticketHolderId: number;
    title: string | undefined;
    description: string | undefined;
    startDate: DateTime;
    dueDate: DateTime | undefined;
    reminderDate: DateTime | undefined;
    assignedToUserId: number;
    status: CalendarEventStatus;
    followupType: FollowupType;
}

export class TicketHolderGetInTouchDto implements ITicketHolderGetInTouchDto {
    ticketHolderId!: number;
    email!: string | undefined;
    isEmailVerified!: boolean | undefined;
    phoneNumbers!: TicketHolderPhoneNumberDto[] | undefined;
    addresses!: TicketHolderAddressDto[] | undefined;

    constructor(data?: ITicketHolderGetInTouchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.email = _data["email"];
            this.isEmailVerified = _data["isEmailVerified"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(TicketHolderPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(TicketHolderAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHolderGetInTouchDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderGetInTouchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["email"] = this.email;
        data["isEmailVerified"] = this.isEmailVerified;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketHolderGetInTouchDto {
    ticketHolderId: number;
    email: string | undefined;
    isEmailVerified: boolean | undefined;
    phoneNumbers: TicketHolderPhoneNumberDto[] | undefined;
    addresses: TicketHolderAddressDto[] | undefined;
}

export class TicketHolderGlanceDto implements ITicketHolderGlanceDto {
    readonly currentMonth!: string | undefined;
    status!: TicketHolderStatus;
    readonly enumDisplayStatus!: string | undefined;
    ticketAssignedDate!: DateTime | undefined;
    iwpDate!: DateTime | undefined;
    phaseMilestoneId!: string | undefined;
    workStatus!: WorkStatus;
    readonly enumDisplayWorkStatus!: string | undefined;
    currentMonthTwoWay!: boolean;
    currentMonthSalary!: number;
    lastMonthSalary!: number;

    constructor(data?: ITicketHolderGlanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).currentMonth = _data["currentMonth"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.ticketAssignedDate = _data["ticketAssignedDate"] ? DateTime.fromISO(_data["ticketAssignedDate"].toString()) : <any>undefined;
            this.iwpDate = _data["iwpDate"] ? DateTime.fromISO(_data["iwpDate"].toString()) : <any>undefined;
            this.phaseMilestoneId = _data["phaseMilestoneId"];
            this.workStatus = _data["workStatus"];
            (<any>this).enumDisplayWorkStatus = _data["enumDisplayWorkStatus"];
            this.currentMonthTwoWay = _data["currentMonthTwoWay"];
            this.currentMonthSalary = _data["currentMonthSalary"];
            this.lastMonthSalary = _data["lastMonthSalary"];
        }
    }

    static fromJS(data: any): TicketHolderGlanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderGlanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentMonth"] = this.currentMonth;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["ticketAssignedDate"] = this.ticketAssignedDate ? this.ticketAssignedDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["iwpDate"] = this.iwpDate ? this.iwpDate.toString() : <any>undefined;
        data["phaseMilestoneId"] = this.phaseMilestoneId;
        data["workStatus"] = this.workStatus;
        data["enumDisplayWorkStatus"] = this.enumDisplayWorkStatus;
        data["currentMonthTwoWay"] = this.currentMonthTwoWay;
        data["currentMonthSalary"] = this.currentMonthSalary;
        data["lastMonthSalary"] = this.lastMonthSalary;
        return data;
    }
}

export interface ITicketHolderGlanceDto {
    currentMonth: string | undefined;
    status: TicketHolderStatus;
    enumDisplayStatus: string | undefined;
    ticketAssignedDate: DateTime | undefined;
    iwpDate: DateTime | undefined;
    phaseMilestoneId: string | undefined;
    workStatus: WorkStatus;
    enumDisplayWorkStatus: string | undefined;
    currentMonthTwoWay: boolean;
    currentMonthSalary: number;
    lastMonthSalary: number;
}

export class TicketHolderIWPDetailsDto implements ITicketHolderIWPDetailsDto {
    iwp!: IWPDdto;
    iwpStatusDisplay!: string | undefined;
    documentName!: string | undefined;
    amendedFromIWPId!: number | undefined;
    isEditable!: boolean;
    sectionOne!: IWPSectionOneDto;
    background!: DurationModalityDto;
    workHistories!: IWPWorkHistoryDto[] | undefined;
    sectionThree!: IWPSectionThreeDto;
    sectionFour!: IWPSectionFourDto;
    termsConditions!: IWPTermsConditionsDto;
    signatureReview!: IWPSectionSixDto;

    constructor(data?: ITicketHolderIWPDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwp = _data["iwp"] ? IWPDdto.fromJS(_data["iwp"]) : <any>undefined;
            this.iwpStatusDisplay = _data["iwpStatusDisplay"];
            this.documentName = _data["documentName"];
            this.amendedFromIWPId = _data["amendedFromIWPId"];
            this.isEditable = _data["isEditable"];
            this.sectionOne = _data["sectionOne"] ? IWPSectionOneDto.fromJS(_data["sectionOne"]) : <any>undefined;
            this.background = _data["background"] ? DurationModalityDto.fromJS(_data["background"]) : <any>undefined;
            if (Array.isArray(_data["workHistories"])) {
                this.workHistories = [] as any;
                for (let item of _data["workHistories"])
                    this.workHistories!.push(IWPWorkHistoryDto.fromJS(item));
            }
            this.sectionThree = _data["sectionThree"] ? IWPSectionThreeDto.fromJS(_data["sectionThree"]) : <any>undefined;
            this.sectionFour = _data["sectionFour"] ? IWPSectionFourDto.fromJS(_data["sectionFour"]) : <any>undefined;
            this.termsConditions = _data["termsConditions"] ? IWPTermsConditionsDto.fromJS(_data["termsConditions"]) : <any>undefined;
            this.signatureReview = _data["signatureReview"] ? IWPSectionSixDto.fromJS(_data["signatureReview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderIWPDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderIWPDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwp"] = this.iwp ? this.iwp.toJSON() : <any>undefined;
        data["iwpStatusDisplay"] = this.iwpStatusDisplay;
        data["documentName"] = this.documentName;
        data["amendedFromIWPId"] = this.amendedFromIWPId;
        data["isEditable"] = this.isEditable;
        data["sectionOne"] = this.sectionOne ? this.sectionOne.toJSON() : <any>undefined;
        data["background"] = this.background ? this.background.toJSON() : <any>undefined;
        if (Array.isArray(this.workHistories)) {
            data["workHistories"] = [];
            for (let item of this.workHistories)
                data["workHistories"].push(item.toJSON());
        }
        data["sectionThree"] = this.sectionThree ? this.sectionThree.toJSON() : <any>undefined;
        data["sectionFour"] = this.sectionFour ? this.sectionFour.toJSON() : <any>undefined;
        data["termsConditions"] = this.termsConditions ? this.termsConditions.toJSON() : <any>undefined;
        data["signatureReview"] = this.signatureReview ? this.signatureReview.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITicketHolderIWPDetailsDto {
    iwp: IWPDdto;
    iwpStatusDisplay: string | undefined;
    documentName: string | undefined;
    amendedFromIWPId: number | undefined;
    isEditable: boolean;
    sectionOne: IWPSectionOneDto;
    background: DurationModalityDto;
    workHistories: IWPWorkHistoryDto[] | undefined;
    sectionThree: IWPSectionThreeDto;
    sectionFour: IWPSectionFourDto;
    termsConditions: IWPTermsConditionsDto;
    signatureReview: IWPSectionSixDto;
}

export class TicketHolderIWPDto implements ITicketHolderIWPDto {
    iwpId!: number;
    ticketHolderId!: number;
    iwpStatus!: IWPStatus;
    readonly enumDisplayIWPStatus!: string | undefined;
    documentName!: string | undefined;
    documentId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    creationTime!: DateTime;
    enInterviewerName!: string | undefined;
    amendedFromIWPId!: number | undefined;
    isEditable!: boolean;

    constructor(data?: ITicketHolderIWPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.iwpStatus = _data["iwpStatus"];
            (<any>this).enumDisplayIWPStatus = _data["enumDisplayIWPStatus"];
            this.documentName = _data["documentName"];
            this.documentId = _data["documentId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.enInterviewerName = _data["enInterviewerName"];
            this.amendedFromIWPId = _data["amendedFromIWPId"];
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): TicketHolderIWPDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderIWPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["iwpStatus"] = this.iwpStatus;
        data["enumDisplayIWPStatus"] = this.enumDisplayIWPStatus;
        data["documentName"] = this.documentName;
        data["documentId"] = this.documentId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["enInterviewerName"] = this.enInterviewerName;
        data["amendedFromIWPId"] = this.amendedFromIWPId;
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface ITicketHolderIWPDto {
    iwpId: number;
    ticketHolderId: number;
    iwpStatus: IWPStatus;
    enumDisplayIWPStatus: string | undefined;
    documentName: string | undefined;
    documentId: number | undefined;
    lastModificationTime: DateTime | undefined;
    creationTime: DateTime;
    enInterviewerName: string | undefined;
    amendedFromIWPId: number | undefined;
    isEditable: boolean;
}

export class TicketHolderIdAndNameDto implements ITicketHolderIdAndNameDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ITicketHolderIdAndNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TicketHolderIdAndNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderIdAndNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITicketHolderIdAndNameDto {
    id: number;
    name: string | undefined;
}

export class TicketHolderInfo implements ITicketHolderInfo {
    ticketHolderId!: number;
    clientId!: string | undefined;

    constructor(data?: ITicketHolderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): TicketHolderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ITicketHolderInfo {
    ticketHolderId: number;
    clientId: string | undefined;
}

export class TicketHolderInfoDto implements ITicketHolderInfoDto {
    id!: number;
    ticketHolderId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    readonly fullName!: string | undefined;
    encryptedSSN!: string | undefined;
    maskedSSN!: string | undefined;
    benefitType!: BenefitType;
    workStatus!: WorkStatus;

    constructor(data?: ITicketHolderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.benefitType = _data["benefitType"];
            this.workStatus = _data["workStatus"];
        }
    }

    static fromJS(data: any): TicketHolderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["encryptedSSN"] = this.encryptedSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["benefitType"] = this.benefitType;
        data["workStatus"] = this.workStatus;
        return data;
    }
}

export interface ITicketHolderInfoDto {
    id: number;
    ticketHolderId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    fullName: string | undefined;
    encryptedSSN: string | undefined;
    maskedSSN: string | undefined;
    benefitType: BenefitType;
    workStatus: WorkStatus;
}

export class TicketHolderInputDocumentDto implements ITicketHolderInputDocumentDto {
    id!: number;
    attachments!: UploadFileOutputDto;
    ticketHolderId!: number;
    documentType!: TicketHolderDocumentType;

    constructor(data?: ITicketHolderInputDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachments = _data["attachments"] ? UploadFileOutputDto.fromJS(_data["attachments"]) : <any>undefined;
            this.ticketHolderId = _data["ticketHolderId"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): TicketHolderInputDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderInputDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachments"] = this.attachments ? this.attachments.toJSON() : <any>undefined;
        data["ticketHolderId"] = this.ticketHolderId;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface ITicketHolderInputDocumentDto {
    id: number;
    attachments: UploadFileOutputDto;
    ticketHolderId: number;
    documentType: TicketHolderDocumentType;
}

export class TicketHolderJobActivityDto implements ITicketHolderJobActivityDto {
    ticketHolderId!: number;
    jobLeadId!: number;
    status!: JobApplicationStatus;
    readonly enumDisplayStatus!: string | undefined;
    creationTime!: DateTime | undefined;
    creatorUserId!: number;
    creatorUserName!: string | undefined;
    readonly formattedJobLeadId!: string | undefined;

    constructor(data?: ITicketHolderJobActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobLeadId = _data["jobLeadId"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            (<any>this).formattedJobLeadId = _data["formattedJobLeadId"];
        }
    }

    static fromJS(data: any): TicketHolderJobActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderJobActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobLeadId"] = this.jobLeadId;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["formattedJobLeadId"] = this.formattedJobLeadId;
        return data;
    }
}

export interface ITicketHolderJobActivityDto {
    ticketHolderId: number;
    jobLeadId: number;
    status: JobApplicationStatus;
    enumDisplayStatus: string | undefined;
    creationTime: DateTime | undefined;
    creatorUserId: number;
    creatorUserName: string | undefined;
    formattedJobLeadId: string | undefined;
}

export class TicketHolderJobLeadDto implements ITicketHolderJobLeadDto {
    id!: number;
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    readonly enumDisplayWorkArrangement!: string | undefined;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    appliedDate!: DateTime | undefined;
    appliedBy!: string | undefined;
    deliveryMethod!: TikcetHolderJobLeadDeliveryMethod;
    status!: JobApplicationStatus;
    readonly enumDisplayStatus!: string | undefined;
    changeHistory!: TicketHolderJobActivityDto[] | undefined;
    jobInterviewId!: number | undefined;
    latestInterviewSession!: CoachCreateOrUpdateJobInterviewSessionDto;
    readonly formattedJobLeadId!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    importantNotes!: string | undefined;
    reason!: string | undefined;
    roundNumber!: number;
    locationDistance!: number | undefined;
    formattedTicketHolderId!: string | undefined;

    constructor(data?: ITicketHolderJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            (<any>this).enumDisplayWorkArrangement = _data["enumDisplayWorkArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.appliedDate = _data["appliedDate"] ? DateTime.fromISO(_data["appliedDate"].toString()) : <any>undefined;
            this.appliedBy = _data["appliedBy"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            if (Array.isArray(_data["changeHistory"])) {
                this.changeHistory = [] as any;
                for (let item of _data["changeHistory"])
                    this.changeHistory!.push(TicketHolderJobActivityDto.fromJS(item));
            }
            this.jobInterviewId = _data["jobInterviewId"];
            this.latestInterviewSession = _data["latestInterviewSession"] ? CoachCreateOrUpdateJobInterviewSessionDto.fromJS(_data["latestInterviewSession"]) : <any>undefined;
            (<any>this).formattedJobLeadId = _data["formattedJobLeadId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.importantNotes = _data["importantNotes"];
            this.reason = _data["reason"];
            this.roundNumber = _data["roundNumber"];
            this.locationDistance = _data["locationDistance"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
        }
    }

    static fromJS(data: any): TicketHolderJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["enumDisplayWorkArrangement"] = this.enumDisplayWorkArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["appliedDate"] = this.appliedDate ? this.appliedDate.toString() : <any>undefined;
        data["appliedBy"] = this.appliedBy;
        data["deliveryMethod"] = this.deliveryMethod;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        if (Array.isArray(this.changeHistory)) {
            data["changeHistory"] = [];
            for (let item of this.changeHistory)
                data["changeHistory"].push(item.toJSON());
        }
        data["jobInterviewId"] = this.jobInterviewId;
        data["latestInterviewSession"] = this.latestInterviewSession ? this.latestInterviewSession.toJSON() : <any>undefined;
        data["formattedJobLeadId"] = this.formattedJobLeadId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["importantNotes"] = this.importantNotes;
        data["reason"] = this.reason;
        data["roundNumber"] = this.roundNumber;
        data["locationDistance"] = this.locationDistance;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        return data;
    }
}

export interface ITicketHolderJobLeadDto {
    id: number;
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    enumDisplayWorkArrangement: string | undefined;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    appliedDate: DateTime | undefined;
    appliedBy: string | undefined;
    deliveryMethod: TikcetHolderJobLeadDeliveryMethod;
    status: JobApplicationStatus;
    enumDisplayStatus: string | undefined;
    changeHistory: TicketHolderJobActivityDto[] | undefined;
    jobInterviewId: number | undefined;
    latestInterviewSession: CoachCreateOrUpdateJobInterviewSessionDto;
    formattedJobLeadId: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    importantNotes: string | undefined;
    reason: string | undefined;
    roundNumber: number;
    locationDistance: number | undefined;
    formattedTicketHolderId: string | undefined;
}

export class TicketHolderLoginAttempts implements ITicketHolderLoginAttempts {
    clientIpAddress!: string | undefined;
    device!: string | undefined;
    result!: string | undefined;
    loginTime!: DateTime;

    constructor(data?: ITicketHolderLoginAttempts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientIpAddress = _data["clientIpAddress"];
            this.device = _data["device"];
            this.result = _data["result"];
            this.loginTime = _data["loginTime"] ? DateTime.fromISO(_data["loginTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderLoginAttempts {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderLoginAttempts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientIpAddress"] = this.clientIpAddress;
        data["device"] = this.device;
        data["result"] = this.result;
        data["loginTime"] = this.loginTime ? this.loginTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketHolderLoginAttempts {
    clientIpAddress: string | undefined;
    device: string | undefined;
    result: string | undefined;
    loginTime: DateTime;
}

export class TicketHolderLoginInfo implements ITicketHolderLoginInfo {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    creationTime!: DateTime;
    portalAccessRevoked!: boolean;
    portalAccessRevokedTime!: DateTime | undefined;
    portalAccessRevokedByUserName!: string | undefined;
    portalAccessRevokeReason!: string | undefined;

    constructor(data?: ITicketHolderLoginInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.portalAccessRevoked = _data["portalAccessRevoked"];
            this.portalAccessRevokedTime = _data["portalAccessRevokedTime"] ? DateTime.fromISO(_data["portalAccessRevokedTime"].toString()) : <any>undefined;
            this.portalAccessRevokedByUserName = _data["portalAccessRevokedByUserName"];
            this.portalAccessRevokeReason = _data["portalAccessRevokeReason"];
        }
    }

    static fromJS(data: any): TicketHolderLoginInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderLoginInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["portalAccessRevoked"] = this.portalAccessRevoked;
        data["portalAccessRevokedTime"] = this.portalAccessRevokedTime ? this.portalAccessRevokedTime.toString() : <any>undefined;
        data["portalAccessRevokedByUserName"] = this.portalAccessRevokedByUserName;
        data["portalAccessRevokeReason"] = this.portalAccessRevokeReason;
        return data;
    }
}

export interface ITicketHolderLoginInfo {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    creationTime: DateTime;
    portalAccessRevoked: boolean;
    portalAccessRevokedTime: DateTime | undefined;
    portalAccessRevokedByUserName: string | undefined;
    portalAccessRevokeReason: string | undefined;
}

export class TicketHolderLoginRowDto implements ITicketHolderLoginRowDto {
    ticketHolderId!: number;
    clientId!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    assigneeName!: string | undefined;
    status!: TicketHolderLoginStatus;
    loginUserId!: number | undefined;
    loginEmail!: string | undefined;
    isEmailConfirmed!: boolean;
    loginCreationTime!: DateTime | undefined;
    lastLoginTime!: DateTime | undefined;
    trustedDeviceCount!: number;
    lockoutEndDateUtc!: DateTime | undefined;
    portalAccessRevokedTime!: DateTime | undefined;
    portalAccessRevokedByUserName!: string | undefined;
    portalAccessRevokeReason!: string | undefined;

    constructor(data?: ITicketHolderLoginRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.assigneeName = _data["assigneeName"];
            this.status = _data["status"];
            this.loginUserId = _data["loginUserId"];
            this.loginEmail = _data["loginEmail"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.loginCreationTime = _data["loginCreationTime"] ? DateTime.fromISO(_data["loginCreationTime"].toString()) : <any>undefined;
            this.lastLoginTime = _data["lastLoginTime"] ? DateTime.fromISO(_data["lastLoginTime"].toString()) : <any>undefined;
            this.trustedDeviceCount = _data["trustedDeviceCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.portalAccessRevokedTime = _data["portalAccessRevokedTime"] ? DateTime.fromISO(_data["portalAccessRevokedTime"].toString()) : <any>undefined;
            this.portalAccessRevokedByUserName = _data["portalAccessRevokedByUserName"];
            this.portalAccessRevokeReason = _data["portalAccessRevokeReason"];
        }
    }

    static fromJS(data: any): TicketHolderLoginRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderLoginRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["assigneeName"] = this.assigneeName;
        data["status"] = this.status;
        data["loginUserId"] = this.loginUserId;
        data["loginEmail"] = this.loginEmail;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["loginCreationTime"] = this.loginCreationTime ? this.loginCreationTime.toString() : <any>undefined;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toString() : <any>undefined;
        data["trustedDeviceCount"] = this.trustedDeviceCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["portalAccessRevokedTime"] = this.portalAccessRevokedTime ? this.portalAccessRevokedTime.toString() : <any>undefined;
        data["portalAccessRevokedByUserName"] = this.portalAccessRevokedByUserName;
        data["portalAccessRevokeReason"] = this.portalAccessRevokeReason;
        return data;
    }
}

export interface ITicketHolderLoginRowDto {
    ticketHolderId: number;
    clientId: string | undefined;
    name: string | undefined;
    email: string | undefined;
    assigneeName: string | undefined;
    status: TicketHolderLoginStatus;
    loginUserId: number | undefined;
    loginEmail: string | undefined;
    isEmailConfirmed: boolean;
    loginCreationTime: DateTime | undefined;
    lastLoginTime: DateTime | undefined;
    trustedDeviceCount: number;
    lockoutEndDateUtc: DateTime | undefined;
    portalAccessRevokedTime: DateTime | undefined;
    portalAccessRevokedByUserName: string | undefined;
    portalAccessRevokeReason: string | undefined;
}

export enum TicketHolderLoginStatus {
    NoLogin = 0,
    Active = 1,
    Revoked = 2,
    Inactive = 3,
    LockedOut = 4,
    LinkedToStaffAccount = 5,
}

export class TicketHolderLoginSummaryDto implements ITicketHolderLoginSummaryDto {
    noLogin!: number;
    active!: number;
    revoked!: number;
    inactive!: number;
    lockedOut!: number;
    linkedToStaffAccount!: number;
    readonly withLogin!: number;

    constructor(data?: ITicketHolderLoginSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noLogin = _data["noLogin"];
            this.active = _data["active"];
            this.revoked = _data["revoked"];
            this.inactive = _data["inactive"];
            this.lockedOut = _data["lockedOut"];
            this.linkedToStaffAccount = _data["linkedToStaffAccount"];
            (<any>this).withLogin = _data["withLogin"];
        }
    }

    static fromJS(data: any): TicketHolderLoginSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderLoginSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noLogin"] = this.noLogin;
        data["active"] = this.active;
        data["revoked"] = this.revoked;
        data["inactive"] = this.inactive;
        data["lockedOut"] = this.lockedOut;
        data["linkedToStaffAccount"] = this.linkedToStaffAccount;
        data["withLogin"] = this.withLogin;
        return data;
    }
}

export interface ITicketHolderLoginSummaryDto {
    noLogin: number;
    active: number;
    revoked: number;
    inactive: number;
    lockedOut: number;
    linkedToStaffAccount: number;
    withLogin: number;
}

export class TicketHolderNewAddressDto implements ITicketHolderNewAddressDto {
    ticketHolderId!: number;
    street!: string;
    city!: string;
    stateAbbreviation!: string;
    zipCode!: string;
    timeZone!: USATimeZone;
    addressType!: AddressType;
    isVerifiedByUSPS!: boolean | undefined;

    constructor(data?: ITicketHolderNewAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.zipCode = _data["zipCode"];
            this.timeZone = _data["timeZone"];
            this.addressType = _data["addressType"];
            this.isVerifiedByUSPS = _data["isVerifiedByUSPS"];
        }
    }

    static fromJS(data: any): TicketHolderNewAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderNewAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["zipCode"] = this.zipCode;
        data["timeZone"] = this.timeZone;
        data["addressType"] = this.addressType;
        data["isVerifiedByUSPS"] = this.isVerifiedByUSPS;
        return data;
    }
}

export interface ITicketHolderNewAddressDto {
    ticketHolderId: number;
    street: string;
    city: string;
    stateAbbreviation: string;
    zipCode: string;
    timeZone: USATimeZone;
    addressType: AddressType;
    isVerifiedByUSPS: boolean | undefined;
}

export class TicketHolderNewPhoneDto implements ITicketHolderNewPhoneDto {
    ticketHolderId!: number;
    number!: string;
    phoneType!: PhoneType;
    isVerified!: boolean;

    constructor(data?: ITicketHolderNewPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.number = _data["number"];
            this.phoneType = _data["phoneType"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): TicketHolderNewPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderNewPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["number"] = this.number;
        data["phoneType"] = this.phoneType;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface ITicketHolderNewPhoneDto {
    ticketHolderId: number;
    number: string;
    phoneType: PhoneType;
    isVerified: boolean;
}

export class TicketHolderNoteDto implements ITicketHolderNoteDto {
    id!: number;
    ticketHolderId!: number;
    noteText!: string;
    isPinned!: boolean;
    createdByName!: string | undefined;
    creationTime!: DateTime | undefined;
    lastModifiedByName!: string | undefined;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: ITicketHolderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.noteText = _data["noteText"];
            this.isPinned = _data["isPinned"];
            this.createdByName = _data["createdByName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["noteText"] = this.noteText;
        data["isPinned"] = this.isPinned;
        data["createdByName"] = this.createdByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketHolderNoteDto {
    id: number;
    ticketHolderId: number;
    noteText: string;
    isPinned: boolean;
    createdByName: string | undefined;
    creationTime: DateTime | undefined;
    lastModifiedByName: string | undefined;
    lastModificationTime: DateTime | undefined;
}

export class TicketHolderNotesDto implements ITicketHolderNotesDto {
    ticketHolderId!: number;
    notes!: string | undefined;
    createdByName!: string | undefined;
    creationTime!: DateTime | undefined;
    lastModifiedByName!: string | undefined;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: ITicketHolderNotesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.notes = _data["notes"];
            this.createdByName = _data["createdByName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderNotesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderNotesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["notes"] = this.notes;
        data["createdByName"] = this.createdByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketHolderNotesDto {
    ticketHolderId: number;
    notes: string | undefined;
    createdByName: string | undefined;
    creationTime: DateTime | undefined;
    lastModifiedByName: string | undefined;
    lastModificationTime: DateTime | undefined;
}

export class TicketHolderOSMDto implements ITicketHolderOSMDto {
    name!: string | undefined;
    phaseMilestone!: string | undefined;
    submissionDate!: DateTime | undefined;
    paymentDate!: DateTime | undefined;
    paymentAmount!: number;
    paymentType!: string | undefined;
    denialCode!: string | undefined;
    rejectionDate!: DateTime | undefined;

    constructor(data?: ITicketHolderOSMDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phaseMilestone = _data["phaseMilestone"];
            this.submissionDate = _data["submissionDate"] ? DateTime.fromISO(_data["submissionDate"].toString()) : <any>undefined;
            this.paymentDate = _data["paymentDate"] ? DateTime.fromISO(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentAmount = _data["paymentAmount"];
            this.paymentType = _data["paymentType"];
            this.denialCode = _data["denialCode"];
            this.rejectionDate = _data["rejectionDate"] ? DateTime.fromISO(_data["rejectionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderOSMDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderOSMDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phaseMilestone"] = this.phaseMilestone;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toString() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentType"] = this.paymentType;
        data["denialCode"] = this.denialCode;
        data["rejectionDate"] = this.rejectionDate ? this.rejectionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ITicketHolderOSMDto {
    name: string | undefined;
    phaseMilestone: string | undefined;
    submissionDate: DateTime | undefined;
    paymentDate: DateTime | undefined;
    paymentAmount: number;
    paymentType: string | undefined;
    denialCode: string | undefined;
    rejectionDate: DateTime | undefined;
}

export class TicketHolderOSMDtos implements ITicketHolderOSMDtos {
    id!: number;
    ticketNumber!: string | undefined;
    partnerName!: string | undefined;
    name!: string | undefined;
    ssn!: string | undefined;
    workCaseNumber!: string | undefined;
    paymentAmount!: number;
    claimMonth!: string | undefined;
    paymentDate!: DateTime | undefined;
    phaseMilestone!: string | undefined;
    paymentType!: string | undefined;
    paymentStatus!: string | undefined;
    denialCode!: string | undefined;
    submissionDate!: DateTime | undefined;
    rejectionDate!: DateTime | undefined;
    associatedTicketHolderId!: number | undefined;
    associatedPhaseMilestoneId!: string | undefined;
    associatedPaymentRequestId!: number | undefined;
    paidTo!: string | undefined;
    paymentRestriction!: string | undefined;
    lastTPR!: string | undefined;
    pendingTPR!: boolean | undefined;
    residenceState!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    importBatchId!: string | undefined;

    constructor(data?: ITicketHolderOSMDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketNumber = _data["ticketNumber"];
            this.partnerName = _data["partnerName"];
            this.name = _data["name"];
            this.ssn = _data["ssn"];
            this.workCaseNumber = _data["workCaseNumber"];
            this.paymentAmount = _data["paymentAmount"];
            this.claimMonth = _data["claimMonth"];
            this.paymentDate = _data["paymentDate"] ? DateTime.fromISO(_data["paymentDate"].toString()) : <any>undefined;
            this.phaseMilestone = _data["phaseMilestone"];
            this.paymentType = _data["paymentType"];
            this.paymentStatus = _data["paymentStatus"];
            this.denialCode = _data["denialCode"];
            this.submissionDate = _data["submissionDate"] ? DateTime.fromISO(_data["submissionDate"].toString()) : <any>undefined;
            this.rejectionDate = _data["rejectionDate"] ? DateTime.fromISO(_data["rejectionDate"].toString()) : <any>undefined;
            this.associatedTicketHolderId = _data["associatedTicketHolderId"];
            this.associatedPhaseMilestoneId = _data["associatedPhaseMilestoneId"];
            this.associatedPaymentRequestId = _data["associatedPaymentRequestId"];
            this.paidTo = _data["paidTo"];
            this.paymentRestriction = _data["paymentRestriction"];
            this.lastTPR = _data["lastTPR"];
            this.pendingTPR = _data["pendingTPR"];
            this.residenceState = _data["residenceState"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.importBatchId = _data["importBatchId"];
        }
    }

    static fromJS(data: any): TicketHolderOSMDtos {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderOSMDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketNumber"] = this.ticketNumber;
        data["partnerName"] = this.partnerName;
        data["name"] = this.name;
        data["ssn"] = this.ssn;
        data["workCaseNumber"] = this.workCaseNumber;
        data["paymentAmount"] = this.paymentAmount;
        data["claimMonth"] = this.claimMonth;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toString() : <any>undefined;
        data["phaseMilestone"] = this.phaseMilestone;
        data["paymentType"] = this.paymentType;
        data["paymentStatus"] = this.paymentStatus;
        data["denialCode"] = this.denialCode;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rejectionDate"] = this.rejectionDate ? this.rejectionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["associatedTicketHolderId"] = this.associatedTicketHolderId;
        data["associatedPhaseMilestoneId"] = this.associatedPhaseMilestoneId;
        data["associatedPaymentRequestId"] = this.associatedPaymentRequestId;
        data["paidTo"] = this.paidTo;
        data["paymentRestriction"] = this.paymentRestriction;
        data["lastTPR"] = this.lastTPR;
        data["pendingTPR"] = this.pendingTPR;
        data["residenceState"] = this.residenceState;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["importBatchId"] = this.importBatchId;
        return data;
    }
}

export interface ITicketHolderOSMDtos {
    id: number;
    ticketNumber: string | undefined;
    partnerName: string | undefined;
    name: string | undefined;
    ssn: string | undefined;
    workCaseNumber: string | undefined;
    paymentAmount: number;
    claimMonth: string | undefined;
    paymentDate: DateTime | undefined;
    phaseMilestone: string | undefined;
    paymentType: string | undefined;
    paymentStatus: string | undefined;
    denialCode: string | undefined;
    submissionDate: DateTime | undefined;
    rejectionDate: DateTime | undefined;
    associatedTicketHolderId: number | undefined;
    associatedPhaseMilestoneId: string | undefined;
    associatedPaymentRequestId: number | undefined;
    paidTo: string | undefined;
    paymentRestriction: string | undefined;
    lastTPR: string | undefined;
    pendingTPR: boolean | undefined;
    residenceState: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    importBatchId: string | undefined;
}

export class TicketHolderPayHistoryDto implements ITicketHolderPayHistoryDto {
    id!: number;
    employerId!: number;
    employerName!: string | undefined;
    ticketHolderId!: number;
    payType!: PayType;
    readonly enumDisplayPayType!: string | undefined;
    grossPay!: number;
    hoursWorked!: number | undefined;
    payPeriodStart!: DateTime;
    payPeriodEnd!: DateTime;
    payDate!: DateTime;
    notes!: string | undefined;
    paystubDocumentId!: number;
    faxedToSSATime!: DateTime | undefined;
    readonly isFaxedToSSA!: boolean;
    evidence!: string | undefined;
    wageReportProcessingStatus!: string | undefined;

    constructor(data?: ITicketHolderPayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.payType = _data["payType"];
            (<any>this).enumDisplayPayType = _data["enumDisplayPayType"];
            this.grossPay = _data["grossPay"];
            this.hoursWorked = _data["hoursWorked"];
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.paystubDocumentId = _data["paystubDocumentId"];
            this.faxedToSSATime = _data["faxedToSSATime"] ? DateTime.fromISO(_data["faxedToSSATime"].toString()) : <any>undefined;
            (<any>this).isFaxedToSSA = _data["isFaxedToSSA"];
            this.evidence = _data["evidence"];
            this.wageReportProcessingStatus = _data["wageReportProcessingStatus"];
        }
    }

    static fromJS(data: any): TicketHolderPayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderPayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["payType"] = this.payType;
        data["enumDisplayPayType"] = this.enumDisplayPayType;
        data["grossPay"] = this.grossPay;
        data["hoursWorked"] = this.hoursWorked;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["notes"] = this.notes;
        data["paystubDocumentId"] = this.paystubDocumentId;
        data["faxedToSSATime"] = this.faxedToSSATime ? this.faxedToSSATime.toString() : <any>undefined;
        data["isFaxedToSSA"] = this.isFaxedToSSA;
        data["evidence"] = this.evidence;
        data["wageReportProcessingStatus"] = this.wageReportProcessingStatus;
        return data;
    }
}

export interface ITicketHolderPayHistoryDto {
    id: number;
    employerId: number;
    employerName: string | undefined;
    ticketHolderId: number;
    payType: PayType;
    enumDisplayPayType: string | undefined;
    grossPay: number;
    hoursWorked: number | undefined;
    payPeriodStart: DateTime;
    payPeriodEnd: DateTime;
    payDate: DateTime;
    notes: string | undefined;
    paystubDocumentId: number;
    faxedToSSATime: DateTime | undefined;
    isFaxedToSSA: boolean;
    evidence: string | undefined;
    wageReportProcessingStatus: string | undefined;
}

export class TicketHolderPayHistoryResultDto implements ITicketHolderPayHistoryResultDto {
    items!: TicketHolderPayHistoryDto[] | undefined;
    totalCount!: number;
    totalGrossPay!: number;

    constructor(data?: ITicketHolderPayHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHolderPayHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalGrossPay = _data["totalGrossPay"];
        }
    }

    static fromJS(data: any): TicketHolderPayHistoryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderPayHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalGrossPay"] = this.totalGrossPay;
        return data;
    }
}

export interface ITicketHolderPayHistoryResultDto {
    items: TicketHolderPayHistoryDto[] | undefined;
    totalCount: number;
    totalGrossPay: number;
}

export class TicketHolderPayRequestHistoryDto implements ITicketHolderPayRequestHistoryDto {
    ticketHolderId!: number;
    requestDate!: DateTime;
    requestedAmount!: number;
    approvedAmount!: number | undefined;
    paymentMethod!: string | undefined;
    approvalStatus!: PaymentRequestStatus;
    denialReason!: string | undefined;
    submissionDate!: DateTime | undefined;
    submissionReferenceId!: string | undefined;
    phaseMilestoneId!: string | undefined;
    documentId!: number;
    responseReceivedDate!: DateTime | undefined;
    notes!: string | undefined;

    constructor(data?: ITicketHolderPayRequestHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.requestDate = _data["requestDate"] ? DateTime.fromISO(_data["requestDate"].toString()) : <any>undefined;
            this.requestedAmount = _data["requestedAmount"];
            this.approvedAmount = _data["approvedAmount"];
            this.paymentMethod = _data["paymentMethod"];
            this.approvalStatus = _data["approvalStatus"];
            this.denialReason = _data["denialReason"];
            this.submissionDate = _data["submissionDate"] ? DateTime.fromISO(_data["submissionDate"].toString()) : <any>undefined;
            this.submissionReferenceId = _data["submissionReferenceId"];
            this.phaseMilestoneId = _data["phaseMilestoneId"];
            this.documentId = _data["documentId"];
            this.responseReceivedDate = _data["responseReceivedDate"] ? DateTime.fromISO(_data["responseReceivedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): TicketHolderPayRequestHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderPayRequestHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["requestDate"] = this.requestDate ? this.requestDate.toString() : <any>undefined;
        data["requestedAmount"] = this.requestedAmount;
        data["approvedAmount"] = this.approvedAmount;
        data["paymentMethod"] = this.paymentMethod;
        data["approvalStatus"] = this.approvalStatus;
        data["denialReason"] = this.denialReason;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toString() : <any>undefined;
        data["submissionReferenceId"] = this.submissionReferenceId;
        data["phaseMilestoneId"] = this.phaseMilestoneId;
        data["documentId"] = this.documentId;
        data["responseReceivedDate"] = this.responseReceivedDate ? this.responseReceivedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ITicketHolderPayRequestHistoryDto {
    ticketHolderId: number;
    requestDate: DateTime;
    requestedAmount: number;
    approvedAmount: number | undefined;
    paymentMethod: string | undefined;
    approvalStatus: PaymentRequestStatus;
    denialReason: string | undefined;
    submissionDate: DateTime | undefined;
    submissionReferenceId: string | undefined;
    phaseMilestoneId: string | undefined;
    documentId: number;
    responseReceivedDate: DateTime | undefined;
    notes: string | undefined;
}

export class TicketHolderPhoneLogDto implements ITicketHolderPhoneLogDto {
    direction!: ActivityDirection;
    ticketHolderName!: string;
    ticketHolderId!: number;
    toPhoneNumber!: string;
    status!: ActivityStatus;
    serviceType!: ActivityServiceType;
    activityContent!: string;
    startTime!: DateTime;

    constructor(data?: ITicketHolderPhoneLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.activityContent = _data["activityContent"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketHolderPhoneLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderPhoneLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["activityContent"] = this.activityContent;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketHolderPhoneLogDto {
    direction: ActivityDirection;
    ticketHolderName: string;
    ticketHolderId: number;
    toPhoneNumber: string;
    status: ActivityStatus;
    serviceType: ActivityServiceType;
    activityContent: string;
    startTime: DateTime;
}

export class TicketHolderPhoneNumberDto implements ITicketHolderPhoneNumberDto {
    id!: number;
    ticketHolderId!: number;
    readonly nonFormattedNumber!: string | undefined;
    number!: string | undefined;
    phoneType!: PhoneType;
    isVerified!: boolean;
    isDuplicated!: boolean;

    constructor(data?: ITicketHolderPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            (<any>this).nonFormattedNumber = _data["nonFormattedNumber"];
            this.number = _data["number"];
            this.phoneType = _data["phoneType"];
            this.isVerified = _data["isVerified"];
            this.isDuplicated = _data["isDuplicated"];
        }
    }

    static fromJS(data: any): TicketHolderPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["nonFormattedNumber"] = this.nonFormattedNumber;
        data["number"] = this.number;
        data["phoneType"] = this.phoneType;
        data["isVerified"] = this.isVerified;
        data["isDuplicated"] = this.isDuplicated;
        return data;
    }
}

export interface ITicketHolderPhoneNumberDto {
    id: number;
    ticketHolderId: number;
    nonFormattedNumber: string | undefined;
    number: string | undefined;
    phoneType: PhoneType;
    isVerified: boolean;
    isDuplicated: boolean;
}

export class TicketHolderProfileDto implements ITicketHolderProfileDto {
    id!: number;
    firstName!: string;
    lastName!: string | undefined;
    middleName!: string | undefined;
    doB!: DateTime | undefined;
    spokenLanguages!: SpokenLanguageDto[] | undefined;
    assigneeName!: string | undefined;
    assigneeId!: number | undefined;
    status!: TicketHolderStatus;
    readonly ticketHolderStatusEnumDisplay!: string | undefined;
    loginUserId!: number | undefined;
    timeZone!: string | undefined;
    jobApplicationEmail!: string | undefined;
    jobSearchCcEmail!: string | undefined;
    rawSSN!: string | undefined;
    maskedSSN!: string | undefined;
    encryptedSSN!: string | undefined;
    isFelony!: boolean | undefined;
    disabilities!: TicketHolderDisabilityDto[] | undefined;
    tag!: string | undefined;

    constructor(data?: ITicketHolderProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            if (Array.isArray(_data["spokenLanguages"])) {
                this.spokenLanguages = [] as any;
                for (let item of _data["spokenLanguages"])
                    this.spokenLanguages!.push(SpokenLanguageDto.fromJS(item));
            }
            this.assigneeName = _data["assigneeName"];
            this.assigneeId = _data["assigneeId"];
            this.status = _data["status"];
            (<any>this).ticketHolderStatusEnumDisplay = _data["ticketHolderStatusEnumDisplay"];
            this.loginUserId = _data["loginUserId"];
            this.timeZone = _data["timeZone"];
            this.jobApplicationEmail = _data["jobApplicationEmail"];
            this.jobSearchCcEmail = _data["jobSearchCcEmail"];
            this.rawSSN = _data["rawSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.isFelony = _data["isFelony"];
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(TicketHolderDisabilityDto.fromJS(item));
            }
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): TicketHolderProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.spokenLanguages)) {
            data["spokenLanguages"] = [];
            for (let item of this.spokenLanguages)
                data["spokenLanguages"].push(item.toJSON());
        }
        data["assigneeName"] = this.assigneeName;
        data["assigneeId"] = this.assigneeId;
        data["status"] = this.status;
        data["ticketHolderStatusEnumDisplay"] = this.ticketHolderStatusEnumDisplay;
        data["loginUserId"] = this.loginUserId;
        data["timeZone"] = this.timeZone;
        data["jobApplicationEmail"] = this.jobApplicationEmail;
        data["jobSearchCcEmail"] = this.jobSearchCcEmail;
        data["rawSSN"] = this.rawSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["encryptedSSN"] = this.encryptedSSN;
        data["isFelony"] = this.isFelony;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        data["tag"] = this.tag;
        return data;
    }
}

export interface ITicketHolderProfileDto {
    id: number;
    firstName: string;
    lastName: string | undefined;
    middleName: string | undefined;
    doB: DateTime | undefined;
    spokenLanguages: SpokenLanguageDto[] | undefined;
    assigneeName: string | undefined;
    assigneeId: number | undefined;
    status: TicketHolderStatus;
    ticketHolderStatusEnumDisplay: string | undefined;
    loginUserId: number | undefined;
    timeZone: string | undefined;
    jobApplicationEmail: string | undefined;
    jobSearchCcEmail: string | undefined;
    rawSSN: string | undefined;
    maskedSSN: string | undefined;
    encryptedSSN: string | undefined;
    isFelony: boolean | undefined;
    disabilities: TicketHolderDisabilityDto[] | undefined;
    tag: string | undefined;
}

export class TicketHolderRefreshTokenResultModel implements ITicketHolderRefreshTokenResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ITicketHolderRefreshTokenResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): TicketHolderRefreshTokenResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderRefreshTokenResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ITicketHolderRefreshTokenResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class TicketHolderResetPasswordModel implements ITicketHolderResetPasswordModel {
    emailAddress!: string;
    resetCode!: string;
    newPassword!: string;

    constructor(data?: ITicketHolderResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.resetCode = _data["resetCode"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): TicketHolderResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["resetCode"] = this.resetCode;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface ITicketHolderResetPasswordModel {
    emailAddress: string;
    resetCode: string;
    newPassword: string;
}

export class TicketHolderSSAOfficeAIInfoDto implements ITicketHolderSSAOfficeAIInfoDto {
    id!: number;
    ticketHolderId!: number;
    officeName!: string | undefined;
    physicalAddress!: string | undefined;
    phone!: string | undefined;
    tty!: string | undefined;
    fax!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    hours!: OfficeOpenHours[] | undefined;

    constructor(data?: ITicketHolderSSAOfficeAIInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.officeName = _data["officeName"];
            this.physicalAddress = _data["physicalAddress"];
            this.phone = _data["phone"];
            this.tty = _data["tty"];
            this.fax = _data["fax"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(OfficeOpenHours.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHolderSSAOfficeAIInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSSAOfficeAIInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["officeName"] = this.officeName;
        data["physicalAddress"] = this.physicalAddress;
        data["phone"] = this.phone;
        data["tty"] = this.tty;
        data["fax"] = this.fax;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketHolderSSAOfficeAIInfoDto {
    id: number;
    ticketHolderId: number;
    officeName: string | undefined;
    physicalAddress: string | undefined;
    phone: string | undefined;
    tty: string | undefined;
    fax: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    hours: OfficeOpenHours[] | undefined;
}

export class TicketHolderSSOOfficeRequestDto implements ITicketHolderSSOOfficeRequestDto {
    id!: number;
    ticketHolderId!: number;
    officeName!: string | undefined;
    physicalAddress!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    phone!: string | undefined;
    tty!: string | undefined;
    fax!: string | undefined;
    hours!: OfficeOpenHours[] | undefined;

    constructor(data?: ITicketHolderSSOOfficeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.officeName = _data["officeName"];
            this.physicalAddress = _data["physicalAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.phone = _data["phone"];
            this.tty = _data["tty"];
            this.fax = _data["fax"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [] as any;
                for (let item of _data["hours"])
                    this.hours!.push(OfficeOpenHours.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHolderSSOOfficeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSSOOfficeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["officeName"] = this.officeName;
        data["physicalAddress"] = this.physicalAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["phone"] = this.phone;
        data["tty"] = this.tty;
        data["fax"] = this.fax;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (let item of this.hours)
                data["hours"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketHolderSSOOfficeRequestDto {
    id: number;
    ticketHolderId: number;
    officeName: string | undefined;
    physicalAddress: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    phone: string | undefined;
    tty: string | undefined;
    fax: string | undefined;
    hours: OfficeOpenHours[] | undefined;
}

export class TicketHolderSearchDto implements ITicketHolderSearchDto {
    id!: number;
    ticketHolderId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    middleName!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: ITicketHolderSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): TicketHolderSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ITicketHolderSearchDto {
    id: number;
    ticketHolderId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    fullName: string | undefined;
}

export class TicketHolderSendPasswordResetCodeModel implements ITicketHolderSendPasswordResetCodeModel {
    emailAddress!: string;

    constructor(data?: ITicketHolderSendPasswordResetCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): TicketHolderSendPasswordResetCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSendPasswordResetCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ITicketHolderSendPasswordResetCodeModel {
    emailAddress: string;
}

export class TicketHolderStateCountDto implements ITicketHolderStateCountDto {
    state!: string | undefined;
    count!: number;

    constructor(data?: ITicketHolderStateCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TicketHolderStateCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderStateCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["count"] = this.count;
        return data;
    }
}

export interface ITicketHolderStateCountDto {
    state: string | undefined;
    count: number;
}

export enum TicketHolderStatus {
    PendingCoachReview = 0,
    ActiveInPreparation = 1,
    ActiveInTraining = 2,
    ActiveJobSearching = 3,
    ActiveWorking = 4,
    ReinstatementProcess = 5,
    ClosedCompleted = 7,
    ClosedWithdrawn = 8,
    ClosedTerminated = 9,
    ActiveJobSearchingPaused = 10,
}

export class TicketHolderSummaryDto implements ITicketHolderSummaryDto {
    total!: number;
    jobSearching!: number;
    working!: number;
    waitingForResume!: number;
    activeInPreparation!: number;
    inactive!: number;
    pendingCoachReview!: number;
    reinstatementProcess!: number;

    constructor(data?: ITicketHolderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.jobSearching = _data["jobSearching"];
            this.working = _data["working"];
            this.waitingForResume = _data["waitingForResume"];
            this.activeInPreparation = _data["activeInPreparation"];
            this.inactive = _data["inactive"];
            this.pendingCoachReview = _data["pendingCoachReview"];
            this.reinstatementProcess = _data["reinstatementProcess"];
        }
    }

    static fromJS(data: any): TicketHolderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["jobSearching"] = this.jobSearching;
        data["working"] = this.working;
        data["waitingForResume"] = this.waitingForResume;
        data["activeInPreparation"] = this.activeInPreparation;
        data["inactive"] = this.inactive;
        data["pendingCoachReview"] = this.pendingCoachReview;
        data["reinstatementProcess"] = this.reinstatementProcess;
        return data;
    }
}

export interface ITicketHolderSummaryDto {
    total: number;
    jobSearching: number;
    working: number;
    waitingForResume: number;
    activeInPreparation: number;
    inactive: number;
    pendingCoachReview: number;
    reinstatementProcess: number;
}

export class TicketHolderSurveyResponseDetailDto implements ITicketHolderSurveyResponseDetailDto {
    questionId!: number;
    textAnswer!: string | undefined;
    selectedOptions!: TicketHolderSurveyResponseDetailOptionDto[] | undefined;

    constructor(data?: ITicketHolderSurveyResponseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.textAnswer = _data["textAnswer"];
            if (Array.isArray(_data["selectedOptions"])) {
                this.selectedOptions = [] as any;
                for (let item of _data["selectedOptions"])
                    this.selectedOptions!.push(TicketHolderSurveyResponseDetailOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHolderSurveyResponseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSurveyResponseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["textAnswer"] = this.textAnswer;
        if (Array.isArray(this.selectedOptions)) {
            data["selectedOptions"] = [];
            for (let item of this.selectedOptions)
                data["selectedOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketHolderSurveyResponseDetailDto {
    questionId: number;
    textAnswer: string | undefined;
    selectedOptions: TicketHolderSurveyResponseDetailOptionDto[] | undefined;
}

export class TicketHolderSurveyResponseDetailOptionDto implements ITicketHolderSurveyResponseDetailOptionDto {
    surveyQuestionOptionId!: number;
    textAnswer!: string | undefined;

    constructor(data?: ITicketHolderSurveyResponseDetailOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyQuestionOptionId = _data["surveyQuestionOptionId"];
            this.textAnswer = _data["textAnswer"];
        }
    }

    static fromJS(data: any): TicketHolderSurveyResponseDetailOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSurveyResponseDetailOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestionOptionId"] = this.surveyQuestionOptionId;
        data["textAnswer"] = this.textAnswer;
        return data;
    }
}

export interface ITicketHolderSurveyResponseDetailOptionDto {
    surveyQuestionOptionId: number;
    textAnswer: string | undefined;
}

export class TicketHolderSurveyResponseDto implements ITicketHolderSurveyResponseDto {
    id!: number;
    surveyId!: number;
    clientId!: string | undefined;
    responseDetails!: TicketHolderSurveyResponseDetailDto[] | undefined;

    constructor(data?: ITicketHolderSurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["responseDetails"])) {
                this.responseDetails = [] as any;
                for (let item of _data["responseDetails"])
                    this.responseDetails!.push(TicketHolderSurveyResponseDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHolderSurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderSurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["clientId"] = this.clientId;
        if (Array.isArray(this.responseDetails)) {
            data["responseDetails"] = [];
            for (let item of this.responseDetails)
                data["responseDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketHolderSurveyResponseDto {
    id: number;
    surveyId: number;
    clientId: string | undefined;
    responseDetails: TicketHolderSurveyResponseDetailDto[] | undefined;
}

export class TicketHolderTimeZoneDto implements ITicketHolderTimeZoneDto {
    ticketHolderId!: number;
    timeZone!: string | undefined;

    constructor(data?: ITicketHolderTimeZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): TicketHolderTimeZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderTimeZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface ITicketHolderTimeZoneDto {
    ticketHolderId: number;
    timeZone: string | undefined;
}

export enum TicketHolderTwoFactorReason {
    None = 0,
    NewDevice = 1,
    SecurityCheck = 2,
}

export enum TicketHolderUnassignStatus {
    Requested = 0,
    UnderReview = 1,
    Approved = 2,
    Rejected = 3,
    SubmittedToSSA = 4,
    SSAConfirmed = 5,
    Completed = 6,
    Canceled = 7,
}

export class TicketHolderWageDataSearchRequestDto implements ITicketHolderWageDataSearchRequestDto {
    ticketHolderId!: number;
    provider!: WageDataSearchProvider;
    status!: WageDataRequestStatus;
    employerId!: number;
    note!: string | undefined;
    documentId!: number | undefined;

    constructor(data?: ITicketHolderWageDataSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.provider = _data["provider"];
            this.status = _data["status"];
            this.employerId = _data["employerId"];
            this.note = _data["note"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): TicketHolderWageDataSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderWageDataSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["provider"] = this.provider;
        data["status"] = this.status;
        data["employerId"] = this.employerId;
        data["note"] = this.note;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ITicketHolderWageDataSearchRequestDto {
    ticketHolderId: number;
    provider: WageDataSearchProvider;
    status: WageDataRequestStatus;
    employerId: number;
    note: string | undefined;
    documentId: number | undefined;
}

export class TicketHolderWageDataSearchRequestFilterDto implements ITicketHolderWageDataSearchRequestFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    statuses!: WageDataRequestStatus[] | undefined;
    ticketHolderId!: number;

    constructor(data?: ITicketHolderWageDataSearchRequestFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.ticketHolderId = _data["ticketHolderId"];
        }
    }

    static fromJS(data: any): TicketHolderWageDataSearchRequestFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderWageDataSearchRequestFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["ticketHolderId"] = this.ticketHolderId;
        return data;
    }
}

export interface ITicketHolderWageDataSearchRequestFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    statuses: WageDataRequestStatus[] | undefined;
    ticketHolderId: number;
}

export class TicketHolderWageDataSearchResponseDto implements ITicketHolderWageDataSearchResponseDto {
    ticketHolderId!: number;
    provider!: WageDataSearchProvider;
    status!: WageDataRequestStatus;
    employerId!: number;
    note!: string | undefined;
    documentId!: number | undefined;
    id!: number;
    employerName!: string | undefined;
    enumStatusName!: string | undefined;
    enumWageDataSearchProviderName!: string | undefined;
    ticketHolderName!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    clientId!: string | undefined;

    constructor(data?: ITicketHolderWageDataSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.provider = _data["provider"];
            this.status = _data["status"];
            this.employerId = _data["employerId"];
            this.note = _data["note"];
            this.documentId = _data["documentId"];
            this.id = _data["id"];
            this.employerName = _data["employerName"];
            this.enumStatusName = _data["enumStatusName"];
            this.enumWageDataSearchProviderName = _data["enumWageDataSearchProviderName"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): TicketHolderWageDataSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderWageDataSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["provider"] = this.provider;
        data["status"] = this.status;
        data["employerId"] = this.employerId;
        data["note"] = this.note;
        data["documentId"] = this.documentId;
        data["id"] = this.id;
        data["employerName"] = this.employerName;
        data["enumStatusName"] = this.enumStatusName;
        data["enumWageDataSearchProviderName"] = this.enumWageDataSearchProviderName;
        data["ticketHolderName"] = this.ticketHolderName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ITicketHolderWageDataSearchResponseDto {
    ticketHolderId: number;
    provider: WageDataSearchProvider;
    status: WageDataRequestStatus;
    employerId: number;
    note: string | undefined;
    documentId: number | undefined;
    id: number;
    employerName: string | undefined;
    enumStatusName: string | undefined;
    enumWageDataSearchProviderName: string | undefined;
    ticketHolderName: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    clientId: string | undefined;
}

export class TicketHolderWorkHistoryDto implements ITicketHolderWorkHistoryDto {
    id!: number;
    ticketHolderId!: number;
    employer!: string | undefined;
    employerAddress!: string | undefined;
    employerPhoneNumber!: string | undefined;
    jobTitle!: string | undefined;
    startDate!: DateTime;
    endDate!: DateTime | undefined;
    hourlyWage!: number;
    weeklyHours!: number;

    constructor(data?: ITicketHolderWorkHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.employer = _data["employer"];
            this.employerAddress = _data["employerAddress"];
            this.employerPhoneNumber = _data["employerPhoneNumber"];
            this.jobTitle = _data["jobTitle"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.hourlyWage = _data["hourlyWage"];
            this.weeklyHours = _data["weeklyHours"];
        }
    }

    static fromJS(data: any): TicketHolderWorkHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHolderWorkHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["employer"] = this.employer;
        data["employerAddress"] = this.employerAddress;
        data["employerPhoneNumber"] = this.employerPhoneNumber;
        data["jobTitle"] = this.jobTitle;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["hourlyWage"] = this.hourlyWage;
        data["weeklyHours"] = this.weeklyHours;
        return data;
    }
}

export interface ITicketHolderWorkHistoryDto {
    id: number;
    ticketHolderId: number;
    employer: string | undefined;
    employerAddress: string | undefined;
    employerPhoneNumber: string | undefined;
    jobTitle: string | undefined;
    startDate: DateTime;
    endDate: DateTime | undefined;
    hourlyWage: number;
    weeklyHours: number;
}

export class TicketToWorkDto implements ITicketToWorkDto {
    id!: number | undefined;
    ticketHolderId!: number | undefined;
    ticketHolderDisplayId!: string | undefined;
    ticketAssignmentDate!: DateTime | undefined;
    highSchoolDiplomaOrEquivalent!: boolean | undefined;
    socialSecurityBenefitType!: BenefitType;
    postSecondaryEducation!: boolean | undefined;
    driversLicense!: boolean | undefined;
    careerGoals!: string | undefined;
    describePostSecondaryEducation!: string | undefined;
    desiredIncomeAndBenefits!: string | undefined;
    hasFelony!: boolean | undefined;
    disabilities!: TicketHolderDisabilityDto[] | undefined;

    constructor(data?: ITicketToWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderDisplayId = _data["ticketHolderDisplayId"];
            this.ticketAssignmentDate = _data["ticketAssignmentDate"] ? DateTime.fromISO(_data["ticketAssignmentDate"].toString()) : <any>undefined;
            this.highSchoolDiplomaOrEquivalent = _data["highSchoolDiplomaOrEquivalent"];
            this.socialSecurityBenefitType = _data["socialSecurityBenefitType"];
            this.postSecondaryEducation = _data["postSecondaryEducation"];
            this.driversLicense = _data["driversLicense"];
            this.careerGoals = _data["careerGoals"];
            this.describePostSecondaryEducation = _data["describePostSecondaryEducation"];
            this.desiredIncomeAndBenefits = _data["desiredIncomeAndBenefits"];
            this.hasFelony = _data["hasFelony"];
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(TicketHolderDisabilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketToWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketToWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderDisplayId"] = this.ticketHolderDisplayId;
        data["ticketAssignmentDate"] = this.ticketAssignmentDate ? this.ticketAssignmentDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["highSchoolDiplomaOrEquivalent"] = this.highSchoolDiplomaOrEquivalent;
        data["socialSecurityBenefitType"] = this.socialSecurityBenefitType;
        data["postSecondaryEducation"] = this.postSecondaryEducation;
        data["driversLicense"] = this.driversLicense;
        data["careerGoals"] = this.careerGoals;
        data["describePostSecondaryEducation"] = this.describePostSecondaryEducation;
        data["desiredIncomeAndBenefits"] = this.desiredIncomeAndBenefits;
        data["hasFelony"] = this.hasFelony;
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITicketToWorkDto {
    id: number | undefined;
    ticketHolderId: number | undefined;
    ticketHolderDisplayId: string | undefined;
    ticketAssignmentDate: DateTime | undefined;
    highSchoolDiplomaOrEquivalent: boolean | undefined;
    socialSecurityBenefitType: BenefitType;
    postSecondaryEducation: boolean | undefined;
    driversLicense: boolean | undefined;
    careerGoals: string | undefined;
    describePostSecondaryEducation: string | undefined;
    desiredIncomeAndBenefits: string | undefined;
    hasFelony: boolean | undefined;
    disabilities: TicketHolderDisabilityDto[] | undefined;
}

export class TicketUnassignmentListItemDto implements ITicketUnassignmentListItemDto {
    unassignRequestId!: number;
    ticketHolderId!: number;
    ticketHolderDisplayId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    encryptedSSN!: string | undefined;
    maskedSSN!: string | undefined;
    doB!: DateTime | undefined;
    unassignStatus!: TicketHolderUnassignStatus;
    unassignStatusDisplayName!: string | undefined;
    unassignReason!: string | undefined;
    unassignRequestedByUserName!: string | undefined;
    requestedDate!: DateTime;

    constructor(data?: ITicketUnassignmentListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unassignRequestId = _data["unassignRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderDisplayId = _data["ticketHolderDisplayId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.encryptedSSN = _data["encryptedSSN"];
            this.maskedSSN = _data["maskedSSN"];
            this.doB = _data["doB"] ? DateTime.fromISO(_data["doB"].toString()) : <any>undefined;
            this.unassignStatus = _data["unassignStatus"];
            this.unassignStatusDisplayName = _data["unassignStatusDisplayName"];
            this.unassignReason = _data["unassignReason"];
            this.unassignRequestedByUserName = _data["unassignRequestedByUserName"];
            this.requestedDate = _data["requestedDate"] ? DateTime.fromISO(_data["requestedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TicketUnassignmentListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketUnassignmentListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unassignRequestId"] = this.unassignRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderDisplayId"] = this.ticketHolderDisplayId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["encryptedSSN"] = this.encryptedSSN;
        data["maskedSSN"] = this.maskedSSN;
        data["doB"] = this.doB ? this.doB.toFormat('yyyy-MM-dd') : <any>undefined;
        data["unassignStatus"] = this.unassignStatus;
        data["unassignStatusDisplayName"] = this.unassignStatusDisplayName;
        data["unassignReason"] = this.unassignReason;
        data["unassignRequestedByUserName"] = this.unassignRequestedByUserName;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toString() : <any>undefined;
        return data;
    }
}

export interface ITicketUnassignmentListItemDto {
    unassignRequestId: number;
    ticketHolderId: number;
    ticketHolderDisplayId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    encryptedSSN: string | undefined;
    maskedSSN: string | undefined;
    doB: DateTime | undefined;
    unassignStatus: TicketHolderUnassignStatus;
    unassignStatusDisplayName: string | undefined;
    unassignReason: string | undefined;
    unassignRequestedByUserName: string | undefined;
    requestedDate: DateTime;
}

export enum TikcetHolderJobLeadDeliveryMethod {
    NotSpecified = 0,
    Email = 1,
    SMS = 2,
    PhoneCall = 3,
    InternalSystem = 4,
    InPerson = 5,
}

export class TokenExtenderDailyStatusDto implements ITokenExtenderDailyStatusDto {
    taskName!: string | undefined;
    serviceLabel!: string | undefined;
    date!: DateTime;
    totalRuns!: number;
    successfulRuns!: number;
    hadSuccessfulRun!: boolean;
    firstFailureReason!: string | undefined;

    constructor(data?: ITokenExtenderDailyStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.serviceLabel = _data["serviceLabel"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.totalRuns = _data["totalRuns"];
            this.successfulRuns = _data["successfulRuns"];
            this.hadSuccessfulRun = _data["hadSuccessfulRun"];
            this.firstFailureReason = _data["firstFailureReason"];
        }
    }

    static fromJS(data: any): TokenExtenderDailyStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenExtenderDailyStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["serviceLabel"] = this.serviceLabel;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["totalRuns"] = this.totalRuns;
        data["successfulRuns"] = this.successfulRuns;
        data["hadSuccessfulRun"] = this.hadSuccessfulRun;
        data["firstFailureReason"] = this.firstFailureReason;
        return data;
    }
}

export interface ITokenExtenderDailyStatusDto {
    taskName: string | undefined;
    serviceLabel: string | undefined;
    date: DateTime;
    totalRuns: number;
    successfulRuns: number;
    hadSuccessfulRun: boolean;
    firstFailureReason: string | undefined;
}

export class TokenExtenderRunDetailDto implements ITokenExtenderRunDetailDto {
    startTime!: DateTime;
    endTime!: DateTime | undefined;
    durationInSeconds!: number | undefined;
    isSuccess!: boolean;
    message!: string | undefined;
    exception!: string | undefined;
    batchId!: string | undefined;

    constructor(data?: ITokenExtenderRunDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.durationInSeconds = _data["durationInSeconds"];
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.exception = _data["exception"];
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): TokenExtenderRunDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenExtenderRunDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["durationInSeconds"] = this.durationInSeconds;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["exception"] = this.exception;
        data["batchId"] = this.batchId;
        return data;
    }
}

export interface ITokenExtenderRunDetailDto {
    startTime: DateTime;
    endTime: DateTime | undefined;
    durationInSeconds: number | undefined;
    isSuccess: boolean;
    message: string | undefined;
    exception: string | undefined;
    batchId: string | undefined;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export enum TransferEncoding {
    QuotedPrintable = 0,
    Base64 = 1,
    SevenBit = 2,
    EightBit = 3,
    Unknown = -1,
}

export class TranslateTemplateInputDto implements ITranslateTemplateInputDto {
    subject!: string | undefined;
    bodyHtml!: string | undefined;
    isBodyHtml!: boolean;
    targetLanguage!: string | undefined;

    constructor(data?: ITranslateTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.bodyHtml = _data["bodyHtml"];
            this.isBodyHtml = _data["isBodyHtml"];
            this.targetLanguage = _data["targetLanguage"];
        }
    }

    static fromJS(data: any): TranslateTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["bodyHtml"] = this.bodyHtml;
        data["isBodyHtml"] = this.isBodyHtml;
        data["targetLanguage"] = this.targetLanguage;
        return data;
    }
}

export interface ITranslateTemplateInputDto {
    subject: string | undefined;
    bodyHtml: string | undefined;
    isBodyHtml: boolean;
    targetLanguage: string | undefined;
}

export class TranslateTextInput implements ITranslateTextInput {
    text!: string;
    targetLanguage!: string;
    isHtml!: boolean;

    constructor(data?: ITranslateTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.targetLanguage = _data["targetLanguage"];
            this.isHtml = _data["isHtml"];
        }
    }

    static fromJS(data: any): TranslateTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["targetLanguage"] = this.targetLanguage;
        data["isHtml"] = this.isHtml;
        return data;
    }
}

export interface ITranslateTextInput {
    text: string;
    targetLanguage: string;
    isHtml: boolean;
}

export class TranslatedTemplateDto implements ITranslatedTemplateDto {
    translatedSubject!: string | undefined;
    translatedBodyHtml!: string | undefined;

    constructor(data?: ITranslatedTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translatedSubject = _data["translatedSubject"];
            this.translatedBodyHtml = _data["translatedBodyHtml"];
        }
    }

    static fromJS(data: any): TranslatedTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslatedTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translatedSubject"] = this.translatedSubject;
        data["translatedBodyHtml"] = this.translatedBodyHtml;
        return data;
    }
}

export interface ITranslatedTemplateDto {
    translatedSubject: string | undefined;
    translatedBodyHtml: string | undefined;
}

export class TranslationLanguageDto implements ITranslationLanguageDto {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITranslationLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TranslationLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ITranslationLanguageDto {
    code: string | undefined;
    name: string | undefined;
}

export class TransportationServiceRequestDto implements ITransportationServiceRequestDto {
    id!: number;
    ticketHolderId!: number;
    assignedToUserId!: number | undefined;
    dueDate!: DateTime | undefined;
    startAddress!: string;
    endAddress!: string;
    purpose!: string;
    adaAccessibility!: boolean;
    notes!: string | undefined;
    status!: ServiceRequestStatus;

    constructor(data?: ITransportationServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.startAddress = _data["startAddress"];
            this.endAddress = _data["endAddress"];
            this.purpose = _data["purpose"];
            this.adaAccessibility = _data["adaAccessibility"];
            this.notes = _data["notes"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TransportationServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["startAddress"] = this.startAddress;
        data["endAddress"] = this.endAddress;
        data["purpose"] = this.purpose;
        data["adaAccessibility"] = this.adaAccessibility;
        data["notes"] = this.notes;
        data["status"] = this.status;
        return data;
    }
}

export interface ITransportationServiceRequestDto {
    id: number;
    ticketHolderId: number;
    assignedToUserId: number | undefined;
    dueDate: DateTime | undefined;
    startAddress: string;
    endAddress: string;
    purpose: string;
    adaAccessibility: boolean;
    notes: string | undefined;
    status: ServiceRequestStatus;
}

export class TriggerOnDemandTaskInput implements ITriggerOnDemandTaskInput {
    taskId!: number;
    parameters!: { [key: string]: any; } | undefined;
    scheduledTime!: DateTime | undefined;
    triggeredBy!: string | undefined;
    queueType!: TaskQueueTypeDto;

    constructor(data?: ITriggerOnDemandTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.scheduledTime = _data["scheduledTime"] ? DateTime.fromISO(_data["scheduledTime"].toString()) : <any>undefined;
            this.triggeredBy = _data["triggeredBy"];
            this.queueType = _data["queueType"];
        }
    }

    static fromJS(data: any): TriggerOnDemandTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerOnDemandTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["scheduledTime"] = this.scheduledTime ? this.scheduledTime.toString() : <any>undefined;
        data["triggeredBy"] = this.triggeredBy;
        data["queueType"] = this.queueType;
        return data;
    }
}

export interface ITriggerOnDemandTaskInput {
    taskId: number;
    parameters: { [key: string]: any; } | undefined;
    scheduledTime: DateTime | undefined;
    triggeredBy: string | undefined;
    queueType: TaskQueueTypeDto;
}

export class TriggerTaskOutput implements ITriggerTaskOutput {
    success!: boolean;
    taskId!: number;
    taskName!: string | undefined;
    instanceId!: number | undefined;
    hangfireJobId!: string | undefined;
    estimatedExecutionTime!: DateTime | undefined;
    executionMode!: string | undefined;
    errorMessage!: string | undefined;
    message!: string | undefined;

    constructor(data?: ITriggerTaskOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.instanceId = _data["instanceId"];
            this.hangfireJobId = _data["hangfireJobId"];
            this.estimatedExecutionTime = _data["estimatedExecutionTime"] ? DateTime.fromISO(_data["estimatedExecutionTime"].toString()) : <any>undefined;
            this.executionMode = _data["executionMode"];
            this.errorMessage = _data["errorMessage"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TriggerTaskOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerTaskOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["instanceId"] = this.instanceId;
        data["hangfireJobId"] = this.hangfireJobId;
        data["estimatedExecutionTime"] = this.estimatedExecutionTime ? this.estimatedExecutionTime.toString() : <any>undefined;
        data["executionMode"] = this.executionMode;
        data["errorMessage"] = this.errorMessage;
        data["message"] = this.message;
        return data;
    }
}

export interface ITriggerTaskOutput {
    success: boolean;
    taskId: number;
    taskName: string | undefined;
    instanceId: number | undefined;
    hangfireJobId: string | undefined;
    estimatedExecutionTime: DateTime | undefined;
    executionMode: string | undefined;
    errorMessage: string | undefined;
    message: string | undefined;
}

export class Ttw1619bAiLookupResultDto implements ITtw1619bAiLookupResultDto {
    thresholdAmount!: number | undefined;
    is1634State!: boolean | undefined;
    confident!: boolean;

    constructor(data?: ITtw1619bAiLookupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thresholdAmount = _data["thresholdAmount"];
            this.is1634State = _data["is1634State"];
            this.confident = _data["confident"];
        }
    }

    static fromJS(data: any): Ttw1619bAiLookupResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new Ttw1619bAiLookupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thresholdAmount"] = this.thresholdAmount;
        data["is1634State"] = this.is1634State;
        data["confident"] = this.confident;
        return data;
    }
}

export interface ITtw1619bAiLookupResultDto {
    thresholdAmount: number | undefined;
    is1634State: boolean | undefined;
    confident: boolean;
}

export class Ttw1619bThresholdDto implements ITtw1619bThresholdDto {
    id!: number;
    year!: number;
    stateAbbreviation!: string | undefined;
    thresholdAmount!: number;
    is1634State!: boolean;
    isActive!: boolean;
    isAiSourced!: boolean;

    constructor(data?: ITtw1619bThresholdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.stateAbbreviation = _data["stateAbbreviation"];
            this.thresholdAmount = _data["thresholdAmount"];
            this.is1634State = _data["is1634State"];
            this.isActive = _data["isActive"];
            this.isAiSourced = _data["isAiSourced"];
        }
    }

    static fromJS(data: any): Ttw1619bThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new Ttw1619bThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["thresholdAmount"] = this.thresholdAmount;
        data["is1634State"] = this.is1634State;
        data["isActive"] = this.isActive;
        data["isAiSourced"] = this.isAiSourced;
        return data;
    }
}

export interface ITtw1619bThresholdDto {
    id: number;
    year: number;
    stateAbbreviation: string | undefined;
    thresholdAmount: number;
    is1634State: boolean;
    isActive: boolean;
    isAiSourced: boolean;
}

export class TtwAnnualThresholdDto implements ITtwAnnualThresholdDto {
    id!: number;
    year!: number;
    twlAmount!: number;
    sgaAmount!: number;
    blindSgaAmount!: number | undefined;
    isActive!: boolean;

    constructor(data?: ITtwAnnualThresholdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.twlAmount = _data["twlAmount"];
            this.sgaAmount = _data["sgaAmount"];
            this.blindSgaAmount = _data["blindSgaAmount"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TtwAnnualThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwAnnualThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["twlAmount"] = this.twlAmount;
        data["sgaAmount"] = this.sgaAmount;
        data["blindSgaAmount"] = this.blindSgaAmount;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITtwAnnualThresholdDto {
    id: number;
    year: number;
    twlAmount: number;
    sgaAmount: number;
    blindSgaAmount: number | undefined;
    isActive: boolean;
}

export class TtwReferralDto implements ITtwReferralDto {
    id!: number;
    partnerId!: number | undefined;
    partnerCode!: string | undefined;
    partnerName!: string | undefined;
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    consentToContact!: boolean;
    ageEligible!: boolean;
    benefitEligible!: boolean;
    status!: ReferralStatus;
    enumDisplayStatus!: string | undefined;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    isFullTimeEmployment!: boolean;
    rewardType!: ReferralRewardType;
    enumDisplayRewardType!: string | undefined;
    rewardDescription!: string | undefined;
    rewardAmount!: number;
    rewardIssuedDate!: DateTime | undefined;
    referralNotes!: string | undefined;
    isLeadExist!: boolean;
    notes!: NoteEntry[] | undefined;

    constructor(data?: ITtwReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerId = _data["partnerId"];
            this.partnerCode = _data["partnerCode"];
            this.partnerName = _data["partnerName"];
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.consentToContact = _data["consentToContact"];
            this.ageEligible = _data["ageEligible"];
            this.benefitEligible = _data["benefitEligible"];
            this.status = _data["status"];
            this.enumDisplayStatus = _data["enumDisplayStatus"];
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.isFullTimeEmployment = _data["isFullTimeEmployment"];
            this.rewardType = _data["rewardType"];
            this.enumDisplayRewardType = _data["enumDisplayRewardType"];
            this.rewardDescription = _data["rewardDescription"];
            this.rewardAmount = _data["rewardAmount"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.referralNotes = _data["referralNotes"];
            this.isLeadExist = _data["isLeadExist"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TtwReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerId"] = this.partnerId;
        data["partnerCode"] = this.partnerCode;
        data["partnerName"] = this.partnerName;
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["consentToContact"] = this.consentToContact;
        data["ageEligible"] = this.ageEligible;
        data["benefitEligible"] = this.benefitEligible;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["isFullTimeEmployment"] = this.isFullTimeEmployment;
        data["rewardType"] = this.rewardType;
        data["enumDisplayRewardType"] = this.enumDisplayRewardType;
        data["rewardDescription"] = this.rewardDescription;
        data["rewardAmount"] = this.rewardAmount;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["referralNotes"] = this.referralNotes;
        data["isLeadExist"] = this.isLeadExist;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITtwReferralDto {
    id: number;
    partnerId: number | undefined;
    partnerCode: string | undefined;
    partnerName: string | undefined;
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    consentToContact: boolean;
    ageEligible: boolean;
    benefitEligible: boolean;
    status: ReferralStatus;
    enumDisplayStatus: string | undefined;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    isFullTimeEmployment: boolean;
    rewardType: ReferralRewardType;
    enumDisplayRewardType: string | undefined;
    rewardDescription: string | undefined;
    rewardAmount: number;
    rewardIssuedDate: DateTime | undefined;
    referralNotes: string | undefined;
    isLeadExist: boolean;
    notes: NoteEntry[] | undefined;
}

export class TtwSsiFbrAiLookupResultDto implements ITtwSsiFbrAiLookupResultDto {
    eligibleIndividualAmount!: number | undefined;
    eligibleCoupleAmount!: number | undefined;
    essentialPersonAmount!: number | undefined;
    confident!: boolean;

    constructor(data?: ITtwSsiFbrAiLookupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligibleIndividualAmount = _data["eligibleIndividualAmount"];
            this.eligibleCoupleAmount = _data["eligibleCoupleAmount"];
            this.essentialPersonAmount = _data["essentialPersonAmount"];
            this.confident = _data["confident"];
        }
    }

    static fromJS(data: any): TtwSsiFbrAiLookupResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwSsiFbrAiLookupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligibleIndividualAmount"] = this.eligibleIndividualAmount;
        data["eligibleCoupleAmount"] = this.eligibleCoupleAmount;
        data["essentialPersonAmount"] = this.essentialPersonAmount;
        data["confident"] = this.confident;
        return data;
    }
}

export interface ITtwSsiFbrAiLookupResultDto {
    eligibleIndividualAmount: number | undefined;
    eligibleCoupleAmount: number | undefined;
    essentialPersonAmount: number | undefined;
    confident: boolean;
}

export class TtwSsiFederalBenefitRateDto implements ITtwSsiFederalBenefitRateDto {
    id!: number;
    year!: number;
    eligibleIndividualAmount!: number;
    eligibleCoupleAmount!: number;
    essentialPersonAmount!: number;
    isActive!: boolean;
    isAiSourced!: boolean;

    constructor(data?: ITtwSsiFederalBenefitRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.eligibleIndividualAmount = _data["eligibleIndividualAmount"];
            this.eligibleCoupleAmount = _data["eligibleCoupleAmount"];
            this.essentialPersonAmount = _data["essentialPersonAmount"];
            this.isActive = _data["isActive"];
            this.isAiSourced = _data["isAiSourced"];
        }
    }

    static fromJS(data: any): TtwSsiFederalBenefitRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwSsiFederalBenefitRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["eligibleIndividualAmount"] = this.eligibleIndividualAmount;
        data["eligibleCoupleAmount"] = this.eligibleCoupleAmount;
        data["essentialPersonAmount"] = this.essentialPersonAmount;
        data["isActive"] = this.isActive;
        data["isAiSourced"] = this.isAiSourced;
        return data;
    }
}

export interface ITtwSsiFederalBenefitRateDto {
    id: number;
    year: number;
    eligibleIndividualAmount: number;
    eligibleCoupleAmount: number;
    essentialPersonAmount: number;
    isActive: boolean;
    isAiSourced: boolean;
}

export class TtwTrackingSheetDto implements ITtwTrackingSheetDto {
    ticketHolderId!: number;
    ticketHolderName!: string | undefined;
    ticketHolderCode!: string | undefined;
    benefitType!: BenefitType;
    iwpDate!: DateTime | undefined;
    iwpMonth!: DateTime | undefined;
    currentEmploymentStatus!: WorkStatus;
    currentEmploymentStatusText!: string | undefined;
    currentTtwStage!: string | undefined;
    currentPhaseMilestone!: string | undefined;
    currentOutcomeMonthNumber!: number | undefined;
    summary!: TtwTrackingSheetSummaryDto;
    years!: TtwTrackingSheetYearRowDto[] | undefined;
    thresholds!: TtwAnnualThresholdDto[] | undefined;

    constructor(data?: ITtwTrackingSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderCode = _data["ticketHolderCode"];
            this.benefitType = _data["benefitType"];
            this.iwpDate = _data["iwpDate"] ? DateTime.fromISO(_data["iwpDate"].toString()) : <any>undefined;
            this.iwpMonth = _data["iwpMonth"] ? DateTime.fromISO(_data["iwpMonth"].toString()) : <any>undefined;
            this.currentEmploymentStatus = _data["currentEmploymentStatus"];
            this.currentEmploymentStatusText = _data["currentEmploymentStatusText"];
            this.currentTtwStage = _data["currentTtwStage"];
            this.currentPhaseMilestone = _data["currentPhaseMilestone"];
            this.currentOutcomeMonthNumber = _data["currentOutcomeMonthNumber"];
            this.summary = _data["summary"] ? TtwTrackingSheetSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(TtwTrackingSheetYearRowDto.fromJS(item));
            }
            if (Array.isArray(_data["thresholds"])) {
                this.thresholds = [] as any;
                for (let item of _data["thresholds"])
                    this.thresholds!.push(TtwAnnualThresholdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TtwTrackingSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwTrackingSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderCode"] = this.ticketHolderCode;
        data["benefitType"] = this.benefitType;
        data["iwpDate"] = this.iwpDate ? this.iwpDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["iwpMonth"] = this.iwpMonth ? this.iwpMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["currentEmploymentStatus"] = this.currentEmploymentStatus;
        data["currentEmploymentStatusText"] = this.currentEmploymentStatusText;
        data["currentTtwStage"] = this.currentTtwStage;
        data["currentPhaseMilestone"] = this.currentPhaseMilestone;
        data["currentOutcomeMonthNumber"] = this.currentOutcomeMonthNumber;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        if (Array.isArray(this.thresholds)) {
            data["thresholds"] = [];
            for (let item of this.thresholds)
                data["thresholds"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITtwTrackingSheetDto {
    ticketHolderId: number;
    ticketHolderName: string | undefined;
    ticketHolderCode: string | undefined;
    benefitType: BenefitType;
    iwpDate: DateTime | undefined;
    iwpMonth: DateTime | undefined;
    currentEmploymentStatus: WorkStatus;
    currentEmploymentStatusText: string | undefined;
    currentTtwStage: string | undefined;
    currentPhaseMilestone: string | undefined;
    currentOutcomeMonthNumber: number | undefined;
    summary: TtwTrackingSheetSummaryDto;
    years: TtwTrackingSheetYearRowDto[] | undefined;
    thresholds: TtwAnnualThresholdDto[] | undefined;
}

export class TtwTrackingSheetMonthDto implements ITtwTrackingSheetMonthDto {
    id!: number;
    calendarYear!: number;
    calendarMonth!: number;
    monthStartDate!: DateTime | undefined;
    monthEndDate!: DateTime | undefined;
    grossSalary!: number | undefined;
    countableEarnings!: number | undefined;
    twlAmount!: number | undefined;
    sgaAmount!: number | undefined;
    isTwlMet!: boolean;
    isSgaMet!: boolean;
    phaseMilestoneNumber!: number | undefined;
    phaseMilestoneDisplay!: string | undefined;
    isCessationMonth!: boolean;
    isGracePeriodMonth!: boolean;
    isEligibleForPayment!: boolean;
    hasPaystub!: boolean;
    wageVerified!: boolean;
    notes!: string | undefined;

    constructor(data?: ITtwTrackingSheetMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calendarYear = _data["calendarYear"];
            this.calendarMonth = _data["calendarMonth"];
            this.monthStartDate = _data["monthStartDate"] ? DateTime.fromISO(_data["monthStartDate"].toString()) : <any>undefined;
            this.monthEndDate = _data["monthEndDate"] ? DateTime.fromISO(_data["monthEndDate"].toString()) : <any>undefined;
            this.grossSalary = _data["grossSalary"];
            this.countableEarnings = _data["countableEarnings"];
            this.twlAmount = _data["twlAmount"];
            this.sgaAmount = _data["sgaAmount"];
            this.isTwlMet = _data["isTwlMet"];
            this.isSgaMet = _data["isSgaMet"];
            this.phaseMilestoneNumber = _data["phaseMilestoneNumber"];
            this.phaseMilestoneDisplay = _data["phaseMilestoneDisplay"];
            this.isCessationMonth = _data["isCessationMonth"];
            this.isGracePeriodMonth = _data["isGracePeriodMonth"];
            this.isEligibleForPayment = _data["isEligibleForPayment"];
            this.hasPaystub = _data["hasPaystub"];
            this.wageVerified = _data["wageVerified"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): TtwTrackingSheetMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwTrackingSheetMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calendarYear"] = this.calendarYear;
        data["calendarMonth"] = this.calendarMonth;
        data["monthStartDate"] = this.monthStartDate ? this.monthStartDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["monthEndDate"] = this.monthEndDate ? this.monthEndDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["grossSalary"] = this.grossSalary;
        data["countableEarnings"] = this.countableEarnings;
        data["twlAmount"] = this.twlAmount;
        data["sgaAmount"] = this.sgaAmount;
        data["isTwlMet"] = this.isTwlMet;
        data["isSgaMet"] = this.isSgaMet;
        data["phaseMilestoneNumber"] = this.phaseMilestoneNumber;
        data["phaseMilestoneDisplay"] = this.phaseMilestoneDisplay;
        data["isCessationMonth"] = this.isCessationMonth;
        data["isGracePeriodMonth"] = this.isGracePeriodMonth;
        data["isEligibleForPayment"] = this.isEligibleForPayment;
        data["hasPaystub"] = this.hasPaystub;
        data["wageVerified"] = this.wageVerified;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ITtwTrackingSheetMonthDto {
    id: number;
    calendarYear: number;
    calendarMonth: number;
    monthStartDate: DateTime | undefined;
    monthEndDate: DateTime | undefined;
    grossSalary: number | undefined;
    countableEarnings: number | undefined;
    twlAmount: number | undefined;
    sgaAmount: number | undefined;
    isTwlMet: boolean;
    isSgaMet: boolean;
    phaseMilestoneNumber: number | undefined;
    phaseMilestoneDisplay: string | undefined;
    isCessationMonth: boolean;
    isGracePeriodMonth: boolean;
    isEligibleForPayment: boolean;
    hasPaystub: boolean;
    wageVerified: boolean;
    notes: string | undefined;
}

export class TtwTrackingSheetSummaryDto implements ITtwTrackingSheetSummaryDto {
    iwpDate!: DateTime | undefined;
    iwpMonth!: DateTime | undefined;
    calendarStartMonth!: DateTime | undefined;
    calendarEndMonth!: DateTime | undefined;
    benefitType!: BenefitType;
    currentTtwStage!: string | undefined;
    currentPhaseMilestone!: string | undefined;
    currentOutcomeMonthNumber!: number | undefined;
    totalTwlMonths!: number;
    totalSgaMonths!: number;
    cessationMonth!: DateTime | undefined;
    gracePeriodStartMonth!: DateTime | undefined;
    gracePeriodEndMonth!: DateTime | undefined;
    lastWageMonth!: DateTime | undefined;
    lastGrossSalary!: number | undefined;
    lastCountableEarnings!: number | undefined;
    lastCalculatedTime!: DateTime | undefined;

    constructor(data?: ITtwTrackingSheetSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpDate = _data["iwpDate"] ? DateTime.fromISO(_data["iwpDate"].toString()) : <any>undefined;
            this.iwpMonth = _data["iwpMonth"] ? DateTime.fromISO(_data["iwpMonth"].toString()) : <any>undefined;
            this.calendarStartMonth = _data["calendarStartMonth"] ? DateTime.fromISO(_data["calendarStartMonth"].toString()) : <any>undefined;
            this.calendarEndMonth = _data["calendarEndMonth"] ? DateTime.fromISO(_data["calendarEndMonth"].toString()) : <any>undefined;
            this.benefitType = _data["benefitType"];
            this.currentTtwStage = _data["currentTtwStage"];
            this.currentPhaseMilestone = _data["currentPhaseMilestone"];
            this.currentOutcomeMonthNumber = _data["currentOutcomeMonthNumber"];
            this.totalTwlMonths = _data["totalTwlMonths"];
            this.totalSgaMonths = _data["totalSgaMonths"];
            this.cessationMonth = _data["cessationMonth"] ? DateTime.fromISO(_data["cessationMonth"].toString()) : <any>undefined;
            this.gracePeriodStartMonth = _data["gracePeriodStartMonth"] ? DateTime.fromISO(_data["gracePeriodStartMonth"].toString()) : <any>undefined;
            this.gracePeriodEndMonth = _data["gracePeriodEndMonth"] ? DateTime.fromISO(_data["gracePeriodEndMonth"].toString()) : <any>undefined;
            this.lastWageMonth = _data["lastWageMonth"] ? DateTime.fromISO(_data["lastWageMonth"].toString()) : <any>undefined;
            this.lastGrossSalary = _data["lastGrossSalary"];
            this.lastCountableEarnings = _data["lastCountableEarnings"];
            this.lastCalculatedTime = _data["lastCalculatedTime"] ? DateTime.fromISO(_data["lastCalculatedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TtwTrackingSheetSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwTrackingSheetSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpDate"] = this.iwpDate ? this.iwpDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["iwpMonth"] = this.iwpMonth ? this.iwpMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["calendarStartMonth"] = this.calendarStartMonth ? this.calendarStartMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["calendarEndMonth"] = this.calendarEndMonth ? this.calendarEndMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["benefitType"] = this.benefitType;
        data["currentTtwStage"] = this.currentTtwStage;
        data["currentPhaseMilestone"] = this.currentPhaseMilestone;
        data["currentOutcomeMonthNumber"] = this.currentOutcomeMonthNumber;
        data["totalTwlMonths"] = this.totalTwlMonths;
        data["totalSgaMonths"] = this.totalSgaMonths;
        data["cessationMonth"] = this.cessationMonth ? this.cessationMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gracePeriodStartMonth"] = this.gracePeriodStartMonth ? this.gracePeriodStartMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gracePeriodEndMonth"] = this.gracePeriodEndMonth ? this.gracePeriodEndMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastWageMonth"] = this.lastWageMonth ? this.lastWageMonth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastGrossSalary"] = this.lastGrossSalary;
        data["lastCountableEarnings"] = this.lastCountableEarnings;
        data["lastCalculatedTime"] = this.lastCalculatedTime ? this.lastCalculatedTime.toString() : <any>undefined;
        return data;
    }
}

export interface ITtwTrackingSheetSummaryDto {
    iwpDate: DateTime | undefined;
    iwpMonth: DateTime | undefined;
    calendarStartMonth: DateTime | undefined;
    calendarEndMonth: DateTime | undefined;
    benefitType: BenefitType;
    currentTtwStage: string | undefined;
    currentPhaseMilestone: string | undefined;
    currentOutcomeMonthNumber: number | undefined;
    totalTwlMonths: number;
    totalSgaMonths: number;
    cessationMonth: DateTime | undefined;
    gracePeriodStartMonth: DateTime | undefined;
    gracePeriodEndMonth: DateTime | undefined;
    lastWageMonth: DateTime | undefined;
    lastGrossSalary: number | undefined;
    lastCountableEarnings: number | undefined;
    lastCalculatedTime: DateTime | undefined;
}

export class TtwTrackingSheetYearRowDto implements ITtwTrackingSheetYearRowDto {
    year!: number;
    twlAmount!: number | undefined;
    sgaAmount!: number | undefined;
    months!: TtwTrackingSheetMonthDto[] | undefined;

    constructor(data?: ITtwTrackingSheetYearRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.twlAmount = _data["twlAmount"];
            this.sgaAmount = _data["sgaAmount"];
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(TtwTrackingSheetMonthDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TtwTrackingSheetYearRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new TtwTrackingSheetYearRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["twlAmount"] = this.twlAmount;
        data["sgaAmount"] = this.sgaAmount;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITtwTrackingSheetYearRowDto {
    year: number;
    twlAmount: number | undefined;
    sgaAmount: number | undefined;
    months: TtwTrackingSheetMonthDto[] | undefined;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
    accessToken!: string | undefined;
    accessTokenSecret!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ITwitterGetAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenSecret = _data["accessTokenSecret"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): TwitterGetAccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetAccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenSecret"] = this.accessTokenSecret;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITwitterGetAccessTokenResponse {
    accessToken: string | undefined;
    accessTokenSecret: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
    token!: string | undefined;
    secret!: string | undefined;
    confirmed!: boolean;
    redirectUrl!: string | undefined;

    constructor(data?: ITwitterGetRequestTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.secret = _data["secret"];
            this.confirmed = _data["confirmed"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TwitterGetRequestTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetRequestTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["secret"] = this.secret;
        data["confirmed"] = this.confirmed;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITwitterGetRequestTokenResponse {
    token: string | undefined;
    secret: string | undefined;
    confirmed: boolean;
    redirectUrl: string | undefined;
}

export class TwoFactorEnabledDto implements ITwoFactorEnabledDto {
    id!: number;
    isTwoFactorEnabled!: boolean;

    constructor(data?: ITwoFactorEnabledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorEnabledDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorEnabledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        return data;
    }
}

export interface ITwoFactorEnabledDto {
    id: number;
    isTwoFactorEnabled: boolean;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class TwoWayChannelCountDto implements ITwoWayChannelCountDto {
    contactType!: ContactType;
    channelName!: string | undefined;
    incoming!: number;
    outgoing!: number;

    constructor(data?: ITwoWayChannelCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactType = _data["contactType"];
            this.channelName = _data["channelName"];
            this.incoming = _data["incoming"];
            this.outgoing = _data["outgoing"];
        }
    }

    static fromJS(data: any): TwoWayChannelCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoWayChannelCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactType"] = this.contactType;
        data["channelName"] = this.channelName;
        data["incoming"] = this.incoming;
        data["outgoing"] = this.outgoing;
        return data;
    }
}

export interface ITwoWayChannelCountDto {
    contactType: ContactType;
    channelName: string | undefined;
    incoming: number;
    outgoing: number;
}

export class TwoWayCommunicationBucketDto implements ITwoWayCommunicationBucketDto {
    thresholdDays!: number;
    ticketHolders!: TwoWayCommunicationTicketHolderDto[] | undefined;
    careerCoachGroups!: TwoWayCommunicationCareerCoachGroupDto[] | undefined;

    constructor(data?: ITwoWayCommunicationBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thresholdDays = _data["thresholdDays"];
            if (Array.isArray(_data["ticketHolders"])) {
                this.ticketHolders = [] as any;
                for (let item of _data["ticketHolders"])
                    this.ticketHolders!.push(TwoWayCommunicationTicketHolderDto.fromJS(item));
            }
            if (Array.isArray(_data["careerCoachGroups"])) {
                this.careerCoachGroups = [] as any;
                for (let item of _data["careerCoachGroups"])
                    this.careerCoachGroups!.push(TwoWayCommunicationCareerCoachGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TwoWayCommunicationBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoWayCommunicationBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thresholdDays"] = this.thresholdDays;
        if (Array.isArray(this.ticketHolders)) {
            data["ticketHolders"] = [];
            for (let item of this.ticketHolders)
                data["ticketHolders"].push(item.toJSON());
        }
        if (Array.isArray(this.careerCoachGroups)) {
            data["careerCoachGroups"] = [];
            for (let item of this.careerCoachGroups)
                data["careerCoachGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITwoWayCommunicationBucketDto {
    thresholdDays: number;
    ticketHolders: TwoWayCommunicationTicketHolderDto[] | undefined;
    careerCoachGroups: TwoWayCommunicationCareerCoachGroupDto[] | undefined;
}

export class TwoWayCommunicationCareerCoachGroupDto implements ITwoWayCommunicationCareerCoachGroupDto {
    careerCoachId!: number | undefined;
    careerCoachName!: string | undefined;
    ticketHolders!: TwoWayCommunicationTicketHolderDto[] | undefined;

    constructor(data?: ITwoWayCommunicationCareerCoachGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerCoachId = _data["careerCoachId"];
            this.careerCoachName = _data["careerCoachName"];
            if (Array.isArray(_data["ticketHolders"])) {
                this.ticketHolders = [] as any;
                for (let item of _data["ticketHolders"])
                    this.ticketHolders!.push(TwoWayCommunicationTicketHolderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TwoWayCommunicationCareerCoachGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoWayCommunicationCareerCoachGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerCoachId"] = this.careerCoachId;
        data["careerCoachName"] = this.careerCoachName;
        if (Array.isArray(this.ticketHolders)) {
            data["ticketHolders"] = [];
            for (let item of this.ticketHolders)
                data["ticketHolders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITwoWayCommunicationCareerCoachGroupDto {
    careerCoachId: number | undefined;
    careerCoachName: string | undefined;
    ticketHolders: TwoWayCommunicationTicketHolderDto[] | undefined;
}

export class TwoWayCommunicationNextRunDto implements ITwoWayCommunicationNextRunDto {
    nextRunUtc!: DateTime | undefined;
    timeZoneIana!: string | undefined;

    constructor(data?: ITwoWayCommunicationNextRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextRunUtc = _data["nextRunUtc"] ? DateTime.fromISO(_data["nextRunUtc"].toString()) : <any>undefined;
            this.timeZoneIana = _data["timeZoneIana"];
        }
    }

    static fromJS(data: any): TwoWayCommunicationNextRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoWayCommunicationNextRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextRunUtc"] = this.nextRunUtc ? this.nextRunUtc.toString() : <any>undefined;
        data["timeZoneIana"] = this.timeZoneIana;
        return data;
    }
}

export interface ITwoWayCommunicationNextRunDto {
    nextRunUtc: DateTime | undefined;
    timeZoneIana: string | undefined;
}

export class TwoWayCommunicationRefreshResultDto implements ITwoWayCommunicationRefreshResultDto {
    success!: boolean;
    estimatedCompletionTime!: DateTime | undefined;
    errorMessage!: string | undefined;

    constructor(data?: ITwoWayCommunicationRefreshResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.estimatedCompletionTime = _data["estimatedCompletionTime"] ? DateTime.fromISO(_data["estimatedCompletionTime"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): TwoWayCommunicationRefreshResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoWayCommunicationRefreshResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["estimatedCompletionTime"] = this.estimatedCompletionTime ? this.estimatedCompletionTime.toString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ITwoWayCommunicationRefreshResultDto {
    success: boolean;
    estimatedCompletionTime: DateTime | undefined;
    errorMessage: string | undefined;
}

export class TwoWayCommunicationTicketHolderDto implements ITwoWayCommunicationTicketHolderDto {
    ticketHolderId!: number;
    formattedTicketHolderId!: string | undefined;
    ticketHolderName!: string | undefined;
    lastSuccessTwoWay!: DateTime | undefined;
    daysSinceLastSuccessTwoWay!: number;
    channelCounts!: TwoWayChannelCountDto[] | undefined;
    totalIncoming!: number;
    totalOutgoing!: number;

    constructor(data?: ITwoWayCommunicationTicketHolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.formattedTicketHolderId = _data["formattedTicketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.lastSuccessTwoWay = _data["lastSuccessTwoWay"] ? DateTime.fromISO(_data["lastSuccessTwoWay"].toString()) : <any>undefined;
            this.daysSinceLastSuccessTwoWay = _data["daysSinceLastSuccessTwoWay"];
            if (Array.isArray(_data["channelCounts"])) {
                this.channelCounts = [] as any;
                for (let item of _data["channelCounts"])
                    this.channelCounts!.push(TwoWayChannelCountDto.fromJS(item));
            }
            this.totalIncoming = _data["totalIncoming"];
            this.totalOutgoing = _data["totalOutgoing"];
        }
    }

    static fromJS(data: any): TwoWayCommunicationTicketHolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoWayCommunicationTicketHolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["formattedTicketHolderId"] = this.formattedTicketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["lastSuccessTwoWay"] = this.lastSuccessTwoWay ? this.lastSuccessTwoWay.toString() : <any>undefined;
        data["daysSinceLastSuccessTwoWay"] = this.daysSinceLastSuccessTwoWay;
        if (Array.isArray(this.channelCounts)) {
            data["channelCounts"] = [];
            for (let item of this.channelCounts)
                data["channelCounts"].push(item.toJSON());
        }
        data["totalIncoming"] = this.totalIncoming;
        data["totalOutgoing"] = this.totalOutgoing;
        return data;
    }
}

export interface ITwoWayCommunicationTicketHolderDto {
    ticketHolderId: number;
    formattedTicketHolderId: string | undefined;
    ticketHolderName: string | undefined;
    lastSuccessTwoWay: DateTime | undefined;
    daysSinceLastSuccessTwoWay: number;
    channelCounts: TwoWayChannelCountDto[] | undefined;
    totalIncoming: number;
    totalOutgoing: number;
}

export class Type implements IType {
    readonly name!: string | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    readonly namespace!: string | undefined;
    readonly assemblyQualifiedName!: string | undefined;
    readonly fullName!: string | undefined;
    assembly!: Assembly;
    module!: Module;
    readonly isInterface!: boolean;
    readonly isNested!: boolean;
    declaringType!: Type;
    declaringMethod!: MethodBase;
    reflectedType!: Type;
    underlyingSystemType!: Type;
    readonly isTypeDefinition!: boolean;
    readonly isArray!: boolean;
    readonly isByRef!: boolean;
    readonly isPointer!: boolean;
    readonly isConstructedGenericType!: boolean;
    readonly isGenericParameter!: boolean;
    readonly isGenericTypeParameter!: boolean;
    readonly isGenericMethodParameter!: boolean;
    readonly isGenericType!: boolean;
    readonly isGenericTypeDefinition!: boolean;
    readonly isSZArray!: boolean;
    readonly isVariableBoundArray!: boolean;
    readonly isByRefLike!: boolean;
    readonly isFunctionPointer!: boolean;
    readonly isUnmanagedFunctionPointer!: boolean;
    readonly hasElementType!: boolean;
    readonly genericTypeArguments!: Type[] | undefined;
    readonly genericParameterPosition!: number;
    genericParameterAttributes!: GenericParameterAttributes;
    attributes!: TypeAttributes;
    readonly isAbstract!: boolean;
    readonly isImport!: boolean;
    readonly isSealed!: boolean;
    readonly isSpecialName!: boolean;
    readonly isClass!: boolean;
    readonly isNestedAssembly!: boolean;
    readonly isNestedFamANDAssem!: boolean;
    readonly isNestedFamily!: boolean;
    readonly isNestedFamORAssem!: boolean;
    readonly isNestedPrivate!: boolean;
    readonly isNestedPublic!: boolean;
    readonly isNotPublic!: boolean;
    readonly isPublic!: boolean;
    readonly isAutoLayout!: boolean;
    readonly isExplicitLayout!: boolean;
    readonly isLayoutSequential!: boolean;
    readonly isAnsiClass!: boolean;
    readonly isAutoClass!: boolean;
    readonly isUnicodeClass!: boolean;
    readonly isCOMObject!: boolean;
    readonly isContextful!: boolean;
    readonly isEnum!: boolean;
    readonly isMarshalByRef!: boolean;
    readonly isPrimitive!: boolean;
    readonly isValueType!: boolean;
    readonly isSignatureType!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    structLayoutAttribute!: StructLayoutAttribute;
    typeInitializer!: ConstructorInfo;
    typeHandle!: RuntimeTypeHandle;
    readonly guid!: string;
    baseType!: Type;
    readonly isSerializable!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly isVisible!: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isInterface = _data["isInterface"];
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).isFunctionPointer = _data["isFunctionPointer"];
            (<any>this).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isInterface"] = this.isInterface;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IType {
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isInterface: boolean;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    isFunctionPointer: boolean;
    isUnmanagedFunctionPointer: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
}

export enum TypeAttributes {
    NotPublic = 0,
    AutoLayout = 1,
    AnsiClass = 2,
    Class = 3,
    Public = 4,
    NestedPublic = 5,
    NestedPrivate = 6,
    NestedFamily = 7,
    NestedAssembly = 8,
    NestedFamANDAssem = 16,
    VisibilityMask = 24,
    NestedFamORAssem = 32,
    SequentialLayout = 128,
    ExplicitLayout = 256,
    LayoutMask = 1024,
    Interface = 2048,
    ClassSemanticsMask = 4096,
    Abstract = 8192,
    Sealed = 16384,
    SpecialName = 65536,
    RTSpecialName = 131072,
    Import = 196608,
    Serializable = 262144,
    WindowsRuntime = 264192,
    UnicodeClass = 1048576,
    AutoClass = 12582912,
}

export class TypeInfo implements ITypeInfo {
    readonly name!: string | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;
    memberType!: MemberTypes;
    readonly namespace!: string | undefined;
    readonly assemblyQualifiedName!: string | undefined;
    readonly fullName!: string | undefined;
    assembly!: Assembly;
    module!: Module;
    readonly isInterface!: boolean;
    readonly isNested!: boolean;
    declaringType!: Type;
    declaringMethod!: MethodBase;
    reflectedType!: Type;
    underlyingSystemType!: Type;
    readonly isTypeDefinition!: boolean;
    readonly isArray!: boolean;
    readonly isByRef!: boolean;
    readonly isPointer!: boolean;
    readonly isConstructedGenericType!: boolean;
    readonly isGenericParameter!: boolean;
    readonly isGenericTypeParameter!: boolean;
    readonly isGenericMethodParameter!: boolean;
    readonly isGenericType!: boolean;
    readonly isGenericTypeDefinition!: boolean;
    readonly isSZArray!: boolean;
    readonly isVariableBoundArray!: boolean;
    readonly isByRefLike!: boolean;
    readonly isFunctionPointer!: boolean;
    readonly isUnmanagedFunctionPointer!: boolean;
    readonly hasElementType!: boolean;
    readonly genericTypeArguments!: Type[] | undefined;
    readonly genericParameterPosition!: number;
    genericParameterAttributes!: GenericParameterAttributes;
    attributes!: TypeAttributes;
    readonly isAbstract!: boolean;
    readonly isImport!: boolean;
    readonly isSealed!: boolean;
    readonly isSpecialName!: boolean;
    readonly isClass!: boolean;
    readonly isNestedAssembly!: boolean;
    readonly isNestedFamANDAssem!: boolean;
    readonly isNestedFamily!: boolean;
    readonly isNestedFamORAssem!: boolean;
    readonly isNestedPrivate!: boolean;
    readonly isNestedPublic!: boolean;
    readonly isNotPublic!: boolean;
    readonly isPublic!: boolean;
    readonly isAutoLayout!: boolean;
    readonly isExplicitLayout!: boolean;
    readonly isLayoutSequential!: boolean;
    readonly isAnsiClass!: boolean;
    readonly isAutoClass!: boolean;
    readonly isUnicodeClass!: boolean;
    readonly isCOMObject!: boolean;
    readonly isContextful!: boolean;
    readonly isEnum!: boolean;
    readonly isMarshalByRef!: boolean;
    readonly isPrimitive!: boolean;
    readonly isValueType!: boolean;
    readonly isSignatureType!: boolean;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    structLayoutAttribute!: StructLayoutAttribute;
    typeInitializer!: ConstructorInfo;
    typeHandle!: RuntimeTypeHandle;
    readonly guid!: string;
    baseType!: Type;
    readonly isSerializable!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly isVisible!: boolean;
    readonly genericTypeParameters!: Type[] | undefined;
    readonly declaredConstructors!: ConstructorInfo[] | undefined;
    readonly declaredEvents!: EventInfo[] | undefined;
    readonly declaredFields!: FieldInfo[] | undefined;
    readonly declaredMembers!: MemberInfo[] | undefined;
    readonly declaredMethods!: MethodInfo[] | undefined;
    readonly declaredNestedTypes!: TypeInfo[] | undefined;
    readonly declaredProperties!: PropertyInfo[] | undefined;
    readonly implementedInterfaces!: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isInterface = _data["isInterface"];
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).isFunctionPointer = _data["isFunctionPointer"];
            (<any>this).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (<any>this).genericTypeParameters!.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (<any>this).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (<any>this).declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (<any>this).declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (<any>this).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (<any>this).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (<any>this).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (<any>this).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (<any>this).implementedInterfaces!.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isInterface"] = this.isInterface;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeInfo {
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isInterface: boolean;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    isFunctionPointer: boolean;
    isUnmanagedFunctionPointer: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
    genericTypeParameters: Type[] | undefined;
    declaredConstructors: ConstructorInfo[] | undefined;
    declaredEvents: EventInfo[] | undefined;
    declaredFields: FieldInfo[] | undefined;
    declaredMembers: MemberInfo[] | undefined;
    declaredMethods: MethodInfo[] | undefined;
    declaredNestedTypes: TypeInfo[] | undefined;
    declaredProperties: PropertyInfo[] | undefined;
    implementedInterfaces: Type[] | undefined;
}

export class USAStateDto implements IUSAStateDto {
    id!: number;
    stateCode!: string | undefined;
    stateName!: string | undefined;

    constructor(data?: IUSAStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateCode = _data["stateCode"];
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): USAStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new USAStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateCode"] = this.stateCode;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IUSAStateDto {
    id: number;
    stateCode: string | undefined;
    stateName: string | undefined;
}

export enum USATimeZone {
    Unknown = 0,
    Hawaii = -10,
    Alaska = -9,
    Pacific = -8,
    Mountain = -7,
    Central = -6,
    Eastern = -5,
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class UnassignRequestDto implements IUnassignRequestDto {
    id!: number;
    ticketHolderId!: number;
    ticketHolderAssigneeUserId!: number | undefined;
    ticketHolderAssigneeName!: string | undefined;
    unassignRequestedByUserId!: number;
    unassignRequestedByUserName!: string | undefined;
    unassignRequestNotifiedUserEmail!: string | undefined;
    unassignSentToSSAByUserId!: number | undefined;
    unassignReason!: string | undefined;
    startTime!: DateTime;
    submittedToSSATime!: DateTime;
    unassignStatus!: TicketHolderUnassignStatus;
    readonly enumDisplayName!: string | undefined;
    ticketHolderPhoneNumber!: string | undefined;

    constructor(data?: IUnassignRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderAssigneeUserId = _data["ticketHolderAssigneeUserId"];
            this.ticketHolderAssigneeName = _data["ticketHolderAssigneeName"];
            this.unassignRequestedByUserId = _data["unassignRequestedByUserId"];
            this.unassignRequestedByUserName = _data["unassignRequestedByUserName"];
            this.unassignRequestNotifiedUserEmail = _data["unassignRequestNotifiedUserEmail"];
            this.unassignSentToSSAByUserId = _data["unassignSentToSSAByUserId"];
            this.unassignReason = _data["unassignReason"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.submittedToSSATime = _data["submittedToSSATime"] ? DateTime.fromISO(_data["submittedToSSATime"].toString()) : <any>undefined;
            this.unassignStatus = _data["unassignStatus"];
            (<any>this).enumDisplayName = _data["enumDisplayName"];
            this.ticketHolderPhoneNumber = _data["ticketHolderPhoneNumber"];
        }
    }

    static fromJS(data: any): UnassignRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderAssigneeUserId"] = this.ticketHolderAssigneeUserId;
        data["ticketHolderAssigneeName"] = this.ticketHolderAssigneeName;
        data["unassignRequestedByUserId"] = this.unassignRequestedByUserId;
        data["unassignRequestedByUserName"] = this.unassignRequestedByUserName;
        data["unassignRequestNotifiedUserEmail"] = this.unassignRequestNotifiedUserEmail;
        data["unassignSentToSSAByUserId"] = this.unassignSentToSSAByUserId;
        data["unassignReason"] = this.unassignReason;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["submittedToSSATime"] = this.submittedToSSATime ? this.submittedToSSATime.toString() : <any>undefined;
        data["unassignStatus"] = this.unassignStatus;
        data["enumDisplayName"] = this.enumDisplayName;
        data["ticketHolderPhoneNumber"] = this.ticketHolderPhoneNumber;
        return data;
    }
}

export interface IUnassignRequestDto {
    id: number;
    ticketHolderId: number;
    ticketHolderAssigneeUserId: number | undefined;
    ticketHolderAssigneeName: string | undefined;
    unassignRequestedByUserId: number;
    unassignRequestedByUserName: string | undefined;
    unassignRequestNotifiedUserEmail: string | undefined;
    unassignSentToSSAByUserId: number | undefined;
    unassignReason: string | undefined;
    startTime: DateTime;
    submittedToSSATime: DateTime;
    unassignStatus: TicketHolderUnassignStatus;
    enumDisplayName: string | undefined;
    ticketHolderPhoneNumber: string | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnknownFaxAssignDto implements IUnknownFaxAssignDto {
    faxLogId!: number;
    isTicketHolder!: boolean;
    isLead!: boolean;
    clientId!: string;
    ticketHolderId!: number | undefined;
    leadId!: number | undefined;

    constructor(data?: IUnknownFaxAssignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faxLogId = _data["faxLogId"];
            this.isTicketHolder = _data["isTicketHolder"];
            this.isLead = _data["isLead"];
            this.clientId = _data["clientId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.leadId = _data["leadId"];
        }
    }

    static fromJS(data: any): UnknownFaxAssignDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnknownFaxAssignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faxLogId"] = this.faxLogId;
        data["isTicketHolder"] = this.isTicketHolder;
        data["isLead"] = this.isLead;
        data["clientId"] = this.clientId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["leadId"] = this.leadId;
        return data;
    }
}

export interface IUnknownFaxAssignDto {
    faxLogId: number;
    isTicketHolder: boolean;
    isLead: boolean;
    clientId: string;
    ticketHolderId: number | undefined;
    leadId: number | undefined;
}

export class UnknownIncomingFaxDto implements IUnknownIncomingFaxDto {
    faxLogId!: number;
    direction!: ActivityDirection;
    clientFaxNumber!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: string | undefined;
    status!: ActivityStatus;
    receivedDate!: DateTime;

    constructor(data?: IUnknownIncomingFaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faxLogId = _data["faxLogId"];
            this.direction = _data["direction"];
            this.clientFaxNumber = _data["clientFaxNumber"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            this.attachments = _data["attachments"];
            this.status = _data["status"];
            this.receivedDate = _data["receivedDate"] ? DateTime.fromISO(_data["receivedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnknownIncomingFaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnknownIncomingFaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faxLogId"] = this.faxLogId;
        data["direction"] = this.direction;
        data["clientFaxNumber"] = this.clientFaxNumber;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        data["attachments"] = this.attachments;
        data["status"] = this.status;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IUnknownIncomingFaxDto {
    faxLogId: number;
    direction: ActivityDirection;
    clientFaxNumber: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: string | undefined;
    status: ActivityStatus;
    receivedDate: DateTime;
}

export class UnknownIncomingSMSDto implements IUnknownIncomingSMSDto {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    clientName!: string | undefined;
    mobilePhoneNumber!: string | undefined;
    messageContent!: string | undefined;
    status!: ActivityStatus;
    attachments!: string | undefined;
    attachmentIds!: number[] | undefined;
    errorMessage!: string | undefined;
    messageId!: string | undefined;
    rawData!: string | undefined;

    constructor(data?: IUnknownIncomingSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.clientName = _data["clientName"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.messageContent = _data["messageContent"];
            this.status = _data["status"];
            this.attachments = _data["attachments"];
            if (Array.isArray(_data["attachmentIds"])) {
                this.attachmentIds = [] as any;
                for (let item of _data["attachmentIds"])
                    this.attachmentIds!.push(item);
            }
            this.errorMessage = _data["errorMessage"];
            this.messageId = _data["messageId"];
            this.rawData = _data["rawData"];
        }
    }

    static fromJS(data: any): UnknownIncomingSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnknownIncomingSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["clientName"] = this.clientName;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["messageContent"] = this.messageContent;
        data["status"] = this.status;
        data["attachments"] = this.attachments;
        if (Array.isArray(this.attachmentIds)) {
            data["attachmentIds"] = [];
            for (let item of this.attachmentIds)
                data["attachmentIds"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        data["messageId"] = this.messageId;
        data["rawData"] = this.rawData;
        return data;
    }
}

export interface IUnknownIncomingSMSDto {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    clientName: string | undefined;
    mobilePhoneNumber: string | undefined;
    messageContent: string | undefined;
    status: ActivityStatus;
    attachments: string | undefined;
    attachmentIds: number[] | undefined;
    errorMessage: string | undefined;
    messageId: string | undefined;
    rawData: string | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateBenefitsCounselingCaseDto implements IUpdateBenefitsCounselingCaseDto {
    id!: number;
    stage!: BenefitsCounselingStage;
    status!: BenefitsCounselingCaseStatus;
    assignedCpwicUserId!: number | undefined;
    openedAt!: DateTime;
    closedAt!: DateTime | undefined;
    closeReason!: string | undefined;
    bpqyDocumentId!: number | undefined;

    constructor(data?: IUpdateBenefitsCounselingCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stage = _data["stage"];
            this.status = _data["status"];
            this.assignedCpwicUserId = _data["assignedCpwicUserId"];
            this.openedAt = _data["openedAt"] ? DateTime.fromISO(_data["openedAt"].toString()) : <any>undefined;
            this.closedAt = _data["closedAt"] ? DateTime.fromISO(_data["closedAt"].toString()) : <any>undefined;
            this.closeReason = _data["closeReason"];
            this.bpqyDocumentId = _data["bpqyDocumentId"];
        }
    }

    static fromJS(data: any): UpdateBenefitsCounselingCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBenefitsCounselingCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stage"] = this.stage;
        data["status"] = this.status;
        data["assignedCpwicUserId"] = this.assignedCpwicUserId;
        data["openedAt"] = this.openedAt ? this.openedAt.toString() : <any>undefined;
        data["closedAt"] = this.closedAt ? this.closedAt.toString() : <any>undefined;
        data["closeReason"] = this.closeReason;
        data["bpqyDocumentId"] = this.bpqyDocumentId;
        return data;
    }
}

export interface IUpdateBenefitsCounselingCaseDto {
    id: number;
    stage: BenefitsCounselingStage;
    status: BenefitsCounselingCaseStatus;
    assignedCpwicUserId: number | undefined;
    openedAt: DateTime;
    closedAt: DateTime | undefined;
    closeReason: string | undefined;
    bpqyDocumentId: number | undefined;
}

export class UpdateBenefitsFollowUpRecordIdsInput implements IUpdateBenefitsFollowUpRecordIdsInput {
    benefitsCounselingCaseId!: number;
    calendarEventIds!: number[] | undefined;

    constructor(data?: IUpdateBenefitsFollowUpRecordIdsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            if (Array.isArray(_data["calendarEventIds"])) {
                this.calendarEventIds = [] as any;
                for (let item of _data["calendarEventIds"])
                    this.calendarEventIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBenefitsFollowUpRecordIdsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBenefitsFollowUpRecordIdsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        if (Array.isArray(this.calendarEventIds)) {
            data["calendarEventIds"] = [];
            for (let item of this.calendarEventIds)
                data["calendarEventIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateBenefitsFollowUpRecordIdsInput {
    benefitsCounselingCaseId: number;
    calendarEventIds: number[] | undefined;
}

export class UpdateBenefitsFollowUpRecordInput implements IUpdateBenefitsFollowUpRecordInput {
    benefitsCounselingCaseId!: number;
    calendarEventId!: number;

    constructor(data?: IUpdateBenefitsFollowUpRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.calendarEventId = _data["calendarEventId"];
        }
    }

    static fromJS(data: any): UpdateBenefitsFollowUpRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBenefitsFollowUpRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["calendarEventId"] = this.calendarEventId;
        return data;
    }
}

export interface IUpdateBenefitsFollowUpRecordInput {
    benefitsCounselingCaseId: number;
    calendarEventId: number;
}

export class UpdateBenefitsVerificationRecordDto implements IUpdateBenefitsVerificationRecordDto {
    id!: number;
    source!: BenefitsVerificationSource;
    benefitName!: string | undefined;
    requestedAt!: DateTime | undefined;
    receivedAt!: DateTime | undefined;
    isVerified!: boolean;
    verificationNotes!: string | undefined;
    verificationDocumentId!: number | undefined;

    constructor(data?: IUpdateBenefitsVerificationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.source = _data["source"];
            this.benefitName = _data["benefitName"];
            this.requestedAt = _data["requestedAt"] ? DateTime.fromISO(_data["requestedAt"].toString()) : <any>undefined;
            this.receivedAt = _data["receivedAt"] ? DateTime.fromISO(_data["receivedAt"].toString()) : <any>undefined;
            this.isVerified = _data["isVerified"];
            this.verificationNotes = _data["verificationNotes"];
            this.verificationDocumentId = _data["verificationDocumentId"];
        }
    }

    static fromJS(data: any): UpdateBenefitsVerificationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBenefitsVerificationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["source"] = this.source;
        data["benefitName"] = this.benefitName;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toString() : <any>undefined;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toString() : <any>undefined;
        data["isVerified"] = this.isVerified;
        data["verificationNotes"] = this.verificationNotes;
        data["verificationDocumentId"] = this.verificationDocumentId;
        return data;
    }
}

export interface IUpdateBenefitsVerificationRecordDto {
    id: number;
    source: BenefitsVerificationSource;
    benefitName: string | undefined;
    requestedAt: DateTime | undefined;
    receivedAt: DateTime | undefined;
    isVerified: boolean;
    verificationNotes: string | undefined;
    verificationDocumentId: number | undefined;
}

export class UpdateDocumentDto implements IUpdateDocumentDto {
    id!: number;
    documentName!: string | undefined;
    filePath!: string | undefined;
    fileType!: string | undefined;
    versionNumber!: string | undefined;
    isLatest!: boolean;
    isTemplate!: boolean;
    leadId!: number | undefined;
    ticketHolderId!: number | undefined;
    uploadedBy!: string | undefined;
    templateStatus!: TemplateStatus;
    documentType!: TicketHolderDocumentType;
    languageId!: number | undefined;

    constructor(data?: IUpdateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.filePath = _data["filePath"];
            this.fileType = _data["fileType"];
            this.versionNumber = _data["versionNumber"];
            this.isLatest = _data["isLatest"];
            this.isTemplate = _data["isTemplate"];
            this.leadId = _data["leadId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.uploadedBy = _data["uploadedBy"];
            this.templateStatus = _data["templateStatus"];
            this.documentType = _data["documentType"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): UpdateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["filePath"] = this.filePath;
        data["fileType"] = this.fileType;
        data["versionNumber"] = this.versionNumber;
        data["isLatest"] = this.isLatest;
        data["isTemplate"] = this.isTemplate;
        data["leadId"] = this.leadId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["uploadedBy"] = this.uploadedBy;
        data["templateStatus"] = this.templateStatus;
        data["documentType"] = this.documentType;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IUpdateDocumentDto {
    id: number;
    documentName: string | undefined;
    filePath: string | undefined;
    fileType: string | undefined;
    versionNumber: string | undefined;
    isLatest: boolean;
    isTemplate: boolean;
    leadId: number | undefined;
    ticketHolderId: number | undefined;
    uploadedBy: string | undefined;
    templateStatus: TemplateStatus;
    documentType: TicketHolderDocumentType;
    languageId: number | undefined;
}

export class UpdateDocumentTemplateDetailsDto implements IUpdateDocumentTemplateDetailsDto {
    id!: number;
    subject!: string | undefined;
    bodyContent!: string;
    isBodyHtml!: boolean;
    attachments!: string[] | undefined;

    constructor(data?: IUpdateDocumentTemplateDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.bodyContent = _data["bodyContent"];
            this.isBodyHtml = _data["isBodyHtml"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDocumentTemplateDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentTemplateDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["bodyContent"] = this.bodyContent;
        data["isBodyHtml"] = this.isBodyHtml;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        return data;
    }
}

export interface IUpdateDocumentTemplateDetailsDto {
    id: number;
    subject: string | undefined;
    bodyContent: string;
    isBodyHtml: boolean;
    attachments: string[] | undefined;
}

export class UpdateDocumentTemplateDto implements IUpdateDocumentTemplateDto {
    id!: number;
    templateName!: string;
    clientType!: ClientType;
    type!: TicketHolderDocumentType;
    status!: TemplateStatus;
    subject!: string | undefined;
    documentTemplateDetails!: CreateDocumentTemplateDetailsDto;

    constructor(data?: IUpdateDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.clientType = _data["clientType"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.subject = _data["subject"];
            this.documentTemplateDetails = _data["documentTemplateDetails"] ? CreateDocumentTemplateDetailsDto.fromJS(_data["documentTemplateDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["clientType"] = this.clientType;
        data["type"] = this.type;
        data["status"] = this.status;
        data["subject"] = this.subject;
        data["documentTemplateDetails"] = this.documentTemplateDetails ? this.documentTemplateDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateDocumentTemplateDto {
    id: number;
    templateName: string;
    clientType: ClientType;
    type: TicketHolderDocumentType;
    status: TemplateStatus;
    subject: string | undefined;
    documentTemplateDetails: CreateDocumentTemplateDetailsDto;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class UpdateFollowupDto implements IUpdateFollowupDto {
    relatedToLeadId!: number | undefined;
    relatedTicketHolderId!: number | undefined;
    title!: string | undefined;
    followupNote!: string | undefined;
    followupDateTime!: DateTime;
    followupType!: FollowupType;
    id!: number;
    status!: CalendarEventStatus;

    constructor(data?: IUpdateFollowupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedToLeadId = _data["relatedToLeadId"];
            this.relatedTicketHolderId = _data["relatedTicketHolderId"];
            this.title = _data["title"];
            this.followupNote = _data["followupNote"];
            this.followupDateTime = _data["followupDateTime"] ? DateTime.fromISO(_data["followupDateTime"].toString()) : <any>undefined;
            this.followupType = _data["followupType"];
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateFollowupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFollowupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedToLeadId"] = this.relatedToLeadId;
        data["relatedTicketHolderId"] = this.relatedTicketHolderId;
        data["title"] = this.title;
        data["followupNote"] = this.followupNote;
        data["followupDateTime"] = this.followupDateTime ? this.followupDateTime.toString() : <any>undefined;
        data["followupType"] = this.followupType;
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateFollowupDto {
    relatedToLeadId: number | undefined;
    relatedTicketHolderId: number | undefined;
    title: string | undefined;
    followupNote: string | undefined;
    followupDateTime: DateTime;
    followupType: FollowupType;
    id: number;
    status: CalendarEventStatus;
}

export class UpdateGoogleAuthenticatorKeyInput implements IUpdateGoogleAuthenticatorKeyInput {
    googleAuthenticatorKey!: string | undefined;
    authenticatorCode!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            this.authenticatorCode = _data["authenticatorCode"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["authenticatorCode"] = this.authenticatorCode;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyInput {
    googleAuthenticatorKey: string | undefined;
    authenticatorCode: string | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    recoveryCodes!: string[] | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    recoveryCodes: string[] | undefined;
}

export class UpdateIWPDto implements IUpdateIWPDto {
    id!: number;
    dateOfDiscussion!: DateTime;
    discussionModality!: IWPDiscussionModality;
    discussionModalityExplanation!: string | undefined;
    location!: string | undefined;
    enInterviewerName!: string | undefined;
    enInterviewerPosition!: string | undefined;
    enInterviewerId!: number;
    workStatus!: WorkStatus;
    hasOtherTerm!: boolean;
    otherTerm!: string | undefined;
    iwpStatus!: IWPStatus;
    documentId!: number | undefined;
    reviewNotes!: string | undefined;

    constructor(data?: IUpdateIWPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfDiscussion = _data["dateOfDiscussion"] ? DateTime.fromISO(_data["dateOfDiscussion"].toString()) : <any>undefined;
            this.discussionModality = _data["discussionModality"];
            this.discussionModalityExplanation = _data["discussionModalityExplanation"];
            this.location = _data["location"];
            this.enInterviewerName = _data["enInterviewerName"];
            this.enInterviewerPosition = _data["enInterviewerPosition"];
            this.enInterviewerId = _data["enInterviewerId"];
            this.workStatus = _data["workStatus"];
            this.hasOtherTerm = _data["hasOtherTerm"];
            this.otherTerm = _data["otherTerm"];
            this.iwpStatus = _data["iwpStatus"];
            this.documentId = _data["documentId"];
            this.reviewNotes = _data["reviewNotes"];
        }
    }

    static fromJS(data: any): UpdateIWPDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIWPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfDiscussion"] = this.dateOfDiscussion ? this.dateOfDiscussion.toString() : <any>undefined;
        data["discussionModality"] = this.discussionModality;
        data["discussionModalityExplanation"] = this.discussionModalityExplanation;
        data["location"] = this.location;
        data["enInterviewerName"] = this.enInterviewerName;
        data["enInterviewerPosition"] = this.enInterviewerPosition;
        data["enInterviewerId"] = this.enInterviewerId;
        data["workStatus"] = this.workStatus;
        data["hasOtherTerm"] = this.hasOtherTerm;
        data["otherTerm"] = this.otherTerm;
        data["iwpStatus"] = this.iwpStatus;
        data["documentId"] = this.documentId;
        data["reviewNotes"] = this.reviewNotes;
        return data;
    }
}

export interface IUpdateIWPDto {
    id: number;
    dateOfDiscussion: DateTime;
    discussionModality: IWPDiscussionModality;
    discussionModalityExplanation: string | undefined;
    location: string | undefined;
    enInterviewerName: string | undefined;
    enInterviewerPosition: string | undefined;
    enInterviewerId: number;
    workStatus: WorkStatus;
    hasOtherTerm: boolean;
    otherTerm: string | undefined;
    iwpStatus: IWPStatus;
    documentId: number | undefined;
    reviewNotes: string | undefined;
}

export class UpdateIWPSectionSixDto implements IUpdateIWPSectionSixDto {
    iwpId!: number;
    clientName!: string;
    clientEmail!: string;
    representativeEmail!: string;
    userInputDurationInMinutes!: number;

    constructor(data?: IUpdateIWPSectionSixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.clientName = _data["clientName"];
            this.clientEmail = _data["clientEmail"];
            this.representativeEmail = _data["representativeEmail"];
            this.userInputDurationInMinutes = _data["userInputDurationInMinutes"];
        }
    }

    static fromJS(data: any): UpdateIWPSectionSixDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIWPSectionSixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["clientName"] = this.clientName;
        data["clientEmail"] = this.clientEmail;
        data["representativeEmail"] = this.representativeEmail;
        data["userInputDurationInMinutes"] = this.userInputDurationInMinutes;
        return data;
    }
}

export interface IUpdateIWPSectionSixDto {
    iwpId: number;
    clientName: string;
    clientEmail: string;
    representativeEmail: string;
    userInputDurationInMinutes: number;
}

export class UpdateIWPStatusDto implements IUpdateIWPStatusDto {
    iwpId!: number;
    iwpStatus!: IWPStatus;

    constructor(data?: IUpdateIWPStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iwpId = _data["iwpId"];
            this.iwpStatus = _data["iwpStatus"];
        }
    }

    static fromJS(data: any): UpdateIWPStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIWPStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iwpId"] = this.iwpId;
        data["iwpStatus"] = this.iwpStatus;
        return data;
    }
}

export interface IUpdateIWPStatusDto {
    iwpId: number;
    iwpStatus: IWPStatus;
}

export class UpdateJobLeadCompanyNameDto implements IUpdateJobLeadCompanyNameDto {
    leadId!: number;
    companyName!: string | undefined;

    constructor(data?: IUpdateJobLeadCompanyNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): UpdateJobLeadCompanyNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobLeadCompanyNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IUpdateJobLeadCompanyNameDto {
    leadId: number;
    companyName: string | undefined;
}

export class UpdateJobLeadDto implements IUpdateJobLeadDto {
    jobSearchRequestId!: number | undefined;
    ticketHolderId!: number;
    jobTitle!: string;
    companyName!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobUrl!: string | undefined;
    postedDate!: DateTime | undefined;
    jobLeadSource!: string | undefined;
    jobDescription!: string | undefined;
    minAnnualSalary!: number | undefined;
    maxAnnualSalary!: number | undefined;
    minHourlyRate!: number | undefined;
    maxHourlyRate!: number | undefined;
    deliveryMethod!: TikcetHolderJobLeadDeliveryMethod;
    importantNotes!: string | undefined;
    id!: number;

    constructor(data?: IUpdateJobLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSearchRequestId = _data["jobSearchRequestId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.jobTitle = _data["jobTitle"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobUrl = _data["jobUrl"];
            this.postedDate = _data["postedDate"] ? DateTime.fromISO(_data["postedDate"].toString()) : <any>undefined;
            this.jobLeadSource = _data["jobLeadSource"];
            this.jobDescription = _data["jobDescription"];
            this.minAnnualSalary = _data["minAnnualSalary"];
            this.maxAnnualSalary = _data["maxAnnualSalary"];
            this.minHourlyRate = _data["minHourlyRate"];
            this.maxHourlyRate = _data["maxHourlyRate"];
            this.deliveryMethod = _data["deliveryMethod"];
            this.importantNotes = _data["importantNotes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateJobLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSearchRequestId"] = this.jobSearchRequestId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["jobTitle"] = this.jobTitle;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobUrl"] = this.jobUrl;
        data["postedDate"] = this.postedDate ? this.postedDate.toString() : <any>undefined;
        data["jobLeadSource"] = this.jobLeadSource;
        data["jobDescription"] = this.jobDescription;
        data["minAnnualSalary"] = this.minAnnualSalary;
        data["maxAnnualSalary"] = this.maxAnnualSalary;
        data["minHourlyRate"] = this.minHourlyRate;
        data["maxHourlyRate"] = this.maxHourlyRate;
        data["deliveryMethod"] = this.deliveryMethod;
        data["importantNotes"] = this.importantNotes;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateJobLeadDto {
    jobSearchRequestId: number | undefined;
    ticketHolderId: number;
    jobTitle: string;
    companyName: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobUrl: string | undefined;
    postedDate: DateTime | undefined;
    jobLeadSource: string | undefined;
    jobDescription: string | undefined;
    minAnnualSalary: number | undefined;
    maxAnnualSalary: number | undefined;
    minHourlyRate: number | undefined;
    maxHourlyRate: number | undefined;
    deliveryMethod: TikcetHolderJobLeadDeliveryMethod;
    importantNotes: string | undefined;
    id: number;
}

export class UpdateJobLeadLocationDto implements IUpdateJobLeadLocationDto {
    id!: number;
    location!: string | undefined;
    locationDistance!: number | undefined;

    constructor(data?: IUpdateJobLeadLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"];
            this.locationDistance = _data["locationDistance"];
        }
    }

    static fromJS(data: any): UpdateJobLeadLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobLeadLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location;
        data["locationDistance"] = this.locationDistance;
        return data;
    }
}

export interface IUpdateJobLeadLocationDto {
    id: number;
    location: string | undefined;
    locationDistance: number | undefined;
}

export class UpdateJobLeadStatusAsync implements IUpdateJobLeadStatusAsync {
    jobLeadId!: number;
    status!: JobApplicationStatus;
    reason!: string | undefined;

    constructor(data?: IUpdateJobLeadStatusAsync) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLeadId = _data["jobLeadId"];
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateJobLeadStatusAsync {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobLeadStatusAsync();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLeadId"] = this.jobLeadId;
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUpdateJobLeadStatusAsync {
    jobLeadId: number;
    status: JobApplicationStatus;
    reason: string | undefined;
}

export class UpdateJobLeadStatusRequest implements IUpdateJobLeadStatusRequest {
    jobLeadId!: number;
    status!: JobApplicationStatus;
    reason!: string | undefined;

    constructor(data?: IUpdateJobLeadStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLeadId = _data["jobLeadId"];
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateJobLeadStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobLeadStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLeadId"] = this.jobLeadId;
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUpdateJobLeadStatusRequest {
    jobLeadId: number;
    status: JobApplicationStatus;
    reason: string | undefined;
}

export class UpdateJobSearchRequestDto implements IUpdateJobSearchRequestDto {
    ticketHolderId!: number;
    desiredJobCount!: number | undefined;
    preferredDayOfWeek!: WeekDays;
    runNow!: boolean;
    skillsQualifications!: string | undefined;
    instructions!: string | undefined;
    maxTravelDistance!: number | undefined;
    maxTravelTime!: number | undefined;
    id!: number;
    jobSearchKeywords!: string | undefined;
    location!: string | undefined;
    workArrangement!: WorkArrangement;
    jobSearchType!: JobSearchType;
    isSalaryRangeHourly!: boolean;
    salaryRangeStart!: number | undefined;
    salaryRangeEnd!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateJobSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.desiredJobCount = _data["desiredJobCount"];
            this.preferredDayOfWeek = _data["preferredDayOfWeek"];
            this.runNow = _data["runNow"];
            this.skillsQualifications = _data["skillsQualifications"];
            this.instructions = _data["instructions"];
            this.maxTravelDistance = _data["maxTravelDistance"];
            this.maxTravelTime = _data["maxTravelTime"];
            this.id = _data["id"];
            this.jobSearchKeywords = _data["jobSearchKeywords"];
            this.location = _data["location"];
            this.workArrangement = _data["workArrangement"];
            this.jobSearchType = _data["jobSearchType"];
            this.isSalaryRangeHourly = _data["isSalaryRangeHourly"];
            this.salaryRangeStart = _data["salaryRangeStart"];
            this.salaryRangeEnd = _data["salaryRangeEnd"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateJobSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["desiredJobCount"] = this.desiredJobCount;
        data["preferredDayOfWeek"] = this.preferredDayOfWeek;
        data["runNow"] = this.runNow;
        data["skillsQualifications"] = this.skillsQualifications;
        data["instructions"] = this.instructions;
        data["maxTravelDistance"] = this.maxTravelDistance;
        data["maxTravelTime"] = this.maxTravelTime;
        data["id"] = this.id;
        data["jobSearchKeywords"] = this.jobSearchKeywords;
        data["location"] = this.location;
        data["workArrangement"] = this.workArrangement;
        data["jobSearchType"] = this.jobSearchType;
        data["isSalaryRangeHourly"] = this.isSalaryRangeHourly;
        data["salaryRangeStart"] = this.salaryRangeStart;
        data["salaryRangeEnd"] = this.salaryRangeEnd;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateJobSearchRequestDto {
    ticketHolderId: number;
    desiredJobCount: number | undefined;
    preferredDayOfWeek: WeekDays;
    runNow: boolean;
    skillsQualifications: string | undefined;
    instructions: string | undefined;
    maxTravelDistance: number | undefined;
    maxTravelTime: number | undefined;
    id: number;
    jobSearchKeywords: string | undefined;
    location: string | undefined;
    workArrangement: WorkArrangement;
    jobSearchType: JobSearchType;
    isSalaryRangeHourly: boolean;
    salaryRangeStart: number | undefined;
    salaryRangeEnd: number | undefined;
    notes: string | undefined;
}

export class UpdateJobSearchStatusDto implements IUpdateJobSearchStatusDto {
    id!: number;
    status!: JobSearchRequestStatus;

    constructor(data?: IUpdateJobSearchStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateJobSearchStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobSearchStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateJobSearchStatusDto {
    id: number;
    status: JobSearchRequestStatus;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateLeadStageDto implements IUpdateLeadStageDto {
    leadId!: number;
    currentLeadStage!: LeadStage;
    newLeadStage!: LeadStage;

    constructor(data?: IUpdateLeadStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.currentLeadStage = _data["currentLeadStage"];
            this.newLeadStage = _data["newLeadStage"];
        }
    }

    static fromJS(data: any): UpdateLeadStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLeadStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["currentLeadStage"] = this.currentLeadStage;
        data["newLeadStage"] = this.newLeadStage;
        return data;
    }
}

export interface IUpdateLeadStageDto {
    leadId: number;
    currentLeadStage: LeadStage;
    newLeadStage: LeadStage;
}

export class UpdateLogAndActivityStatus implements IUpdateLogAndActivityStatus {
    activityId!: number;
    status!: ActivityStatus;
    contactType!: ContactType;

    constructor(data?: IUpdateLogAndActivityStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.status = _data["status"];
            this.contactType = _data["contactType"];
        }
    }

    static fromJS(data: any): UpdateLogAndActivityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLogAndActivityStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        data["contactType"] = this.contactType;
        return data;
    }
}

export interface IUpdateLogAndActivityStatus {
    activityId: number;
    status: ActivityStatus;
    contactType: ContactType;
}

export class UpdateMailLogInput implements IUpdateMailLogInput {
    id!: number;
    direction!: ActivityDirection;
    careerCoachName!: string | undefined;
    careerCoachUserId!: number | undefined;
    careerCoachAddress!: string | undefined;
    clientName!: string;
    clientAddress!: string;
    clientId!: string | undefined;
    subject!: string | undefined;
    messageBody!: string | undefined;
    attachments!: string[] | undefined;
    status!: ActivityStatus;

    constructor(data?: IUpdateMailLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.careerCoachName = _data["careerCoachName"];
            this.careerCoachUserId = _data["careerCoachUserId"];
            this.careerCoachAddress = _data["careerCoachAddress"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.clientId = _data["clientId"];
            this.subject = _data["subject"];
            this.messageBody = _data["messageBody"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateMailLogInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["careerCoachName"] = this.careerCoachName;
        data["careerCoachUserId"] = this.careerCoachUserId;
        data["careerCoachAddress"] = this.careerCoachAddress;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["clientId"] = this.clientId;
        data["subject"] = this.subject;
        data["messageBody"] = this.messageBody;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateMailLogInput {
    id: number;
    direction: ActivityDirection;
    careerCoachName: string | undefined;
    careerCoachUserId: number | undefined;
    careerCoachAddress: string | undefined;
    clientName: string;
    clientAddress: string;
    clientId: string | undefined;
    subject: string | undefined;
    messageBody: string | undefined;
    attachments: string[] | undefined;
    status: ActivityStatus;
}

export class UpdateMailLogStatusInput implements IUpdateMailLogStatusInput {
    mailLogIds!: number[] | undefined;
    status!: ActivityStatus;

    constructor(data?: IUpdateMailLogStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mailLogIds"])) {
                this.mailLogIds = [] as any;
                for (let item of _data["mailLogIds"])
                    this.mailLogIds!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateMailLogStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailLogStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mailLogIds)) {
            data["mailLogIds"] = [];
            for (let item of this.mailLogIds)
                data["mailLogIds"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateMailLogStatusInput {
    mailLogIds: number[] | undefined;
    status: ActivityStatus;
}

export class UpdateMarketingEventParticipantDto implements IUpdateMarketingEventParticipantDto {
    id!: number;
    participationType!: MarketingParticipationType;
    status!: MarketingParticipantStatus;
    notes!: string | undefined;

    constructor(data?: IUpdateMarketingEventParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participationType = _data["participationType"];
            this.status = _data["status"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateMarketingEventParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarketingEventParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participationType"] = this.participationType;
        data["status"] = this.status;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateMarketingEventParticipantDto {
    id: number;
    participationType: MarketingParticipationType;
    status: MarketingParticipantStatus;
    notes: string | undefined;
}

export class UpdateMedicalInsuranceDto implements IUpdateMedicalInsuranceDto {
    ticketHolderId!: number;
    isMedicare!: boolean | undefined;
    medicareDescription!: MedicareDetail[] | undefined;
    isMedicaid!: boolean | undefined;
    medicaidDescription!: MedicaidDetail;
    id!: number;

    constructor(data?: IUpdateMedicalInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.isMedicare = _data["isMedicare"];
            if (Array.isArray(_data["medicareDescription"])) {
                this.medicareDescription = [] as any;
                for (let item of _data["medicareDescription"])
                    this.medicareDescription!.push(MedicareDetail.fromJS(item));
            }
            this.isMedicaid = _data["isMedicaid"];
            this.medicaidDescription = _data["medicaidDescription"] ? MedicaidDetail.fromJS(_data["medicaidDescription"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMedicalInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["isMedicare"] = this.isMedicare;
        if (Array.isArray(this.medicareDescription)) {
            data["medicareDescription"] = [];
            for (let item of this.medicareDescription)
                data["medicareDescription"].push(item.toJSON());
        }
        data["isMedicaid"] = this.isMedicaid;
        data["medicaidDescription"] = this.medicaidDescription ? this.medicaidDescription.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateMedicalInsuranceDto {
    ticketHolderId: number;
    isMedicare: boolean | undefined;
    medicareDescription: MedicareDetail[] | undefined;
    isMedicaid: boolean | undefined;
    medicaidDescription: MedicaidDetail;
    id: number;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UpdatePayHistoryDto implements IUpdatePayHistoryDto {
    employerId!: number;
    ticketHolderId!: number;
    payType!: PayType;
    grossPay!: number;
    hoursWorked!: number | undefined;
    payPeriodStart!: DateTime;
    payPeriodEnd!: DateTime;
    payDate!: DateTime;
    notes!: string | undefined;
    id!: number;

    constructor(data?: IUpdatePayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerId = _data["employerId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.payType = _data["payType"];
            this.grossPay = _data["grossPay"];
            this.hoursWorked = _data["hoursWorked"];
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerId"] = this.employerId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["payType"] = this.payType;
        data["grossPay"] = this.grossPay;
        data["hoursWorked"] = this.hoursWorked;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePayHistoryDto {
    employerId: number;
    ticketHolderId: number;
    payType: PayType;
    grossPay: number;
    hoursWorked: number | undefined;
    payPeriodStart: DateTime;
    payPeriodEnd: DateTime;
    payDate: DateTime;
    notes: string | undefined;
    id: number;
}

export class UpdatePaymentDto implements IUpdatePaymentDto {
    paymentId!: number;
    gateway!: string | undefined;
    isRecurring!: boolean;
    extraProperties!: { [key: string]: any; } | undefined;

    constructor(data?: IUpdatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.gateway = _data["gateway"];
            this.isRecurring = _data["isRecurring"];
            if (_data["extraProperties"]) {
                this.extraProperties = {} as any;
                for (let key in _data["extraProperties"]) {
                    if (_data["extraProperties"].hasOwnProperty(key))
                        (<any>this.extraProperties)![key] = _data["extraProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        data["isRecurring"] = this.isRecurring;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    (<any>data["extraProperties"])[key] = (<any>this.extraProperties)[key];
            }
        }
        return data;
    }
}

export interface IUpdatePaymentDto {
    paymentId: number;
    gateway: string | undefined;
    isRecurring: boolean;
    extraProperties: { [key: string]: any; } | undefined;
}

export class UpdatePaymentRequestDto implements IUpdatePaymentRequestDto {
    id!: number;
    approvedAmount!: number | undefined;
    paymentMethod!: string | undefined;
    approvalStatus!: PaymentRequestStatus;
    denialReason!: string | undefined;
    responseReceivedDate!: DateTime | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdatePaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approvedAmount = _data["approvedAmount"];
            this.paymentMethod = _data["paymentMethod"];
            this.approvalStatus = _data["approvalStatus"];
            this.denialReason = _data["denialReason"];
            this.responseReceivedDate = _data["responseReceivedDate"] ? DateTime.fromISO(_data["responseReceivedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdatePaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approvedAmount"] = this.approvedAmount;
        data["paymentMethod"] = this.paymentMethod;
        data["approvalStatus"] = this.approvalStatus;
        data["denialReason"] = this.denialReason;
        data["responseReceivedDate"] = this.responseReceivedDate ? this.responseReceivedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdatePaymentRequestDto {
    id: number;
    approvedAmount: number | undefined;
    paymentMethod: string | undefined;
    approvalStatus: PaymentRequestStatus;
    denialReason: string | undefined;
    responseReceivedDate: DateTime | undefined;
    notes: string | undefined;
}

export class UpdatePhoneLogDto implements IUpdatePhoneLogDto {
    direction!: ActivityDirection;
    leadName!: string;
    leadId!: number;
    toPhoneNumber!: string;
    status!: ActivityStatus;
    serviceType!: ActivityServiceType;
    activityContent!: string | undefined;
    startTime!: DateTime;
    id!: number;

    constructor(data?: IUpdatePhoneLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.leadName = _data["leadName"];
            this.leadId = _data["leadId"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.activityContent = _data["activityContent"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePhoneLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["leadName"] = this.leadName;
        data["leadId"] = this.leadId;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["activityContent"] = this.activityContent;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePhoneLogDto {
    direction: ActivityDirection;
    leadName: string;
    leadId: number;
    toPhoneNumber: string;
    status: ActivityStatus;
    serviceType: ActivityServiceType;
    activityContent: string | undefined;
    startTime: DateTime;
    id: number;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    useGravatarProfilePicture!: boolean;
    userId!: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    useGravatarProfilePicture: boolean;
    userId: number | undefined;
}

export class UpdateReferralPartnerDto implements IUpdateReferralPartnerDto {
    id!: number;
    organizationName!: string | undefined;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone!: string | undefined;
    contactAddress!: string | undefined;
    rewardDescription!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateReferralPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationName = _data["organizationName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.contactAddress = _data["contactAddress"];
            this.rewardDescription = _data["rewardDescription"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateReferralPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReferralPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationName"] = this.organizationName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["contactAddress"] = this.contactAddress;
        data["rewardDescription"] = this.rewardDescription;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateReferralPartnerDto {
    id: number;
    organizationName: string | undefined;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactPhone: string | undefined;
    contactAddress: string | undefined;
    rewardDescription: string | undefined;
    notes: string | undefined;
}

export class UpdateReferralPartnerStatusDto implements IUpdateReferralPartnerStatusDto {
    id!: number;
    isActive!: boolean;
    reason!: string | undefined;

    constructor(data?: IUpdateReferralPartnerStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateReferralPartnerStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReferralPartnerStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IUpdateReferralPartnerStatusDto {
    id: number;
    isActive: boolean;
    reason: string | undefined;
}

export class UpdateReferralStatusDto implements IUpdateReferralStatusDto {
    id!: number;
    status!: ReferralStatus;
    notes!: string | undefined;

    constructor(data?: IUpdateReferralStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateReferralStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReferralStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateReferralStatusDto {
    id: number;
    status: ReferralStatus;
    notes: string | undefined;
}

export class UpdateReinstatementStatusDto implements IUpdateReinstatementStatusDto {
    reinstatementId!: number;
    reasonOrNote!: string | undefined;
    status!: ReinstatementStatus;

    constructor(data?: IUpdateReinstatementStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reinstatementId = _data["reinstatementId"];
            this.reasonOrNote = _data["reasonOrNote"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateReinstatementStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReinstatementStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reinstatementId"] = this.reinstatementId;
        data["reasonOrNote"] = this.reasonOrNote;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateReinstatementStatusDto {
    reinstatementId: number;
    reasonOrNote: string | undefined;
    status: ReinstatementStatus;
}

export class UpdateReportRequestDto implements IUpdateReportRequestDto {
    id!: number;
    status!: ReportRequestStatus;
    adminNotes!: string | undefined;
    linkedReportId!: number | undefined;

    constructor(data?: IUpdateReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.adminNotes = _data["adminNotes"];
            this.linkedReportId = _data["linkedReportId"];
        }
    }

    static fromJS(data: any): UpdateReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["adminNotes"] = this.adminNotes;
        data["linkedReportId"] = this.linkedReportId;
        return data;
    }
}

export interface IUpdateReportRequestDto {
    id: number;
    status: ReportRequestStatus;
    adminNotes: string | undefined;
    linkedReportId: number | undefined;
}

export class UpdateSsaContactRequestDto implements IUpdateSsaContactRequestDto {
    role!: SsaContactRole;
    userId!: number;
    name!: string;
    phone!: string;
    tollFree!: string | undefined;
    fax!: string | undefined;
    tty!: string | undefined;
    email!: string;
    id!: number;

    constructor(data?: IUpdateSsaContactRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.tollFree = _data["tollFree"];
            this.fax = _data["fax"];
            this.tty = _data["tty"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateSsaContactRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSsaContactRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["tollFree"] = this.tollFree;
        data["fax"] = this.fax;
        data["tty"] = this.tty;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateSsaContactRequestDto {
    role: SsaContactRole;
    userId: number;
    name: string;
    phone: string;
    tollFree: string | undefined;
    fax: string | undefined;
    tty: string | undefined;
    email: string;
    id: number;
}

export class UpdateSsaSuitabilitySettingsInput implements IUpdateSsaSuitabilitySettingsInput {
    recipientEmails!: string;
    awardNumber!: string | undefined;
    perSecPoc!: string | undefined;

    constructor(data?: IUpdateSsaSuitabilitySettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientEmails = _data["recipientEmails"];
            this.awardNumber = _data["awardNumber"];
            this.perSecPoc = _data["perSecPoc"];
        }
    }

    static fromJS(data: any): UpdateSsaSuitabilitySettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSsaSuitabilitySettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientEmails"] = this.recipientEmails;
        data["awardNumber"] = this.awardNumber;
        data["perSecPoc"] = this.perSecPoc;
        return data;
    }
}

export interface IUpdateSsaSuitabilitySettingsInput {
    recipientEmails: string;
    awardNumber: string | undefined;
    perSecPoc: string | undefined;
}

export class UpdateSsaUploadStatusInput implements IUpdateSsaUploadStatusInput {
    ticketHolderId!: number;
    isUploaded!: boolean;
    uploadedDate!: DateTime | undefined;

    constructor(data?: IUpdateSsaUploadStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.isUploaded = _data["isUploaded"];
            this.uploadedDate = _data["uploadedDate"] ? DateTime.fromISO(_data["uploadedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSsaUploadStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSsaUploadStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["isUploaded"] = this.isUploaded;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IUpdateSsaUploadStatusInput {
    ticketHolderId: number;
    isUploaded: boolean;
    uploadedDate: DateTime | undefined;
}

export class UpdateSupportTicketStatusDto implements IUpdateSupportTicketStatusDto {
    ticketId!: number;
    status!: SupportTicketStatus;

    constructor(data?: IUpdateSupportTicketStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSupportTicketStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupportTicketStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateSupportTicketStatusDto {
    ticketId: number;
    status: SupportTicketStatus;
}

export class UpdateTHPhoneLogDto implements IUpdateTHPhoneLogDto {
    direction!: ActivityDirection;
    ticketHolderName!: string;
    ticketHolderId!: number;
    toPhoneNumber!: string;
    status!: ActivityStatus;
    serviceType!: ActivityServiceType;
    activityContent!: string;
    startTime!: DateTime;
    id!: number;

    constructor(data?: IUpdateTHPhoneLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.toPhoneNumber = _data["toPhoneNumber"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.activityContent = _data["activityContent"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTHPhoneLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTHPhoneLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["ticketHolderName"] = this.ticketHolderName;
        data["ticketHolderId"] = this.ticketHolderId;
        data["toPhoneNumber"] = this.toPhoneNumber;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["activityContent"] = this.activityContent;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTHPhoneLogDto {
    direction: ActivityDirection;
    ticketHolderName: string;
    ticketHolderId: number;
    toPhoneNumber: string;
    status: ActivityStatus;
    serviceType: ActivityServiceType;
    activityContent: string;
    startTime: DateTime;
    id: number;
}

export class UpdateTHShortNotesRequestDto implements IUpdateTHShortNotesRequestDto {
    id!: number;
    shortNotes!: string | undefined;

    constructor(data?: IUpdateTHShortNotesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortNotes = _data["shortNotes"];
        }
    }

    static fromJS(data: any): UpdateTHShortNotesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTHShortNotesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortNotes"] = this.shortNotes;
        return data;
    }
}

export interface IUpdateTHShortNotesRequestDto {
    id: number;
    shortNotes: string | undefined;
}

export class UpdateTaskTemplateRequestDto implements IUpdateTaskTemplateRequestDto {
    title!: string;
    description!: string;
    expectedOutputs!: string;
    stage!: TTWTaskTemplateStage;
    orderInStage!: number;
    id!: number;

    constructor(data?: IUpdateTaskTemplateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.expectedOutputs = _data["expectedOutputs"];
            this.stage = _data["stage"];
            this.orderInStage = _data["orderInStage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTaskTemplateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskTemplateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["expectedOutputs"] = this.expectedOutputs;
        data["stage"] = this.stage;
        data["orderInStage"] = this.orderInStage;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTaskTemplateRequestDto {
    title: string;
    description: string;
    expectedOutputs: string;
    stage: TTWTaskTemplateStage;
    orderInStage: number;
    id: number;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UpdateTicketHolderBenifitType implements IUpdateTicketHolderBenifitType {
    ticketHolderId!: number;
    benefitType!: BenefitType;
    currentStatus!: BenefitPaymentStatus;
    isStatutorilyBlind!: boolean | undefined;
    disabilityOnsetDate!: DateTime | undefined;
    entitlementDate!: DateTime | undefined;
    fullAmount!: number | undefined;
    netAmount!: number | undefined;
    othersPaid!: boolean | undefined;
    totalFamilyCashBenifit!: number | undefined;
    overPaymentBalance!: number | undefined;
    monthlyAmountWithHeld!: number | undefined;
    isRepresentativePayee!: boolean | undefined;
    isAuthorisedRepresentative!: boolean | undefined;
    nextMedicalReviewDate!: DateTime | undefined;
    medicalReExamCycle!: string | undefined;
    id!: number;

    constructor(data?: IUpdateTicketHolderBenifitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.benefitType = _data["benefitType"];
            this.currentStatus = _data["currentStatus"];
            this.isStatutorilyBlind = _data["isStatutorilyBlind"];
            this.disabilityOnsetDate = _data["disabilityOnsetDate"] ? DateTime.fromISO(_data["disabilityOnsetDate"].toString()) : <any>undefined;
            this.entitlementDate = _data["entitlementDate"] ? DateTime.fromISO(_data["entitlementDate"].toString()) : <any>undefined;
            this.fullAmount = _data["fullAmount"];
            this.netAmount = _data["netAmount"];
            this.othersPaid = _data["othersPaid"];
            this.totalFamilyCashBenifit = _data["totalFamilyCashBenifit"];
            this.overPaymentBalance = _data["overPaymentBalance"];
            this.monthlyAmountWithHeld = _data["monthlyAmountWithHeld"];
            this.isRepresentativePayee = _data["isRepresentativePayee"];
            this.isAuthorisedRepresentative = _data["isAuthorisedRepresentative"];
            this.nextMedicalReviewDate = _data["nextMedicalReviewDate"] ? DateTime.fromISO(_data["nextMedicalReviewDate"].toString()) : <any>undefined;
            this.medicalReExamCycle = _data["medicalReExamCycle"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTicketHolderBenifitType {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketHolderBenifitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["benefitType"] = this.benefitType;
        data["currentStatus"] = this.currentStatus;
        data["isStatutorilyBlind"] = this.isStatutorilyBlind;
        data["disabilityOnsetDate"] = this.disabilityOnsetDate ? this.disabilityOnsetDate.toString() : <any>undefined;
        data["entitlementDate"] = this.entitlementDate ? this.entitlementDate.toString() : <any>undefined;
        data["fullAmount"] = this.fullAmount;
        data["netAmount"] = this.netAmount;
        data["othersPaid"] = this.othersPaid;
        data["totalFamilyCashBenifit"] = this.totalFamilyCashBenifit;
        data["overPaymentBalance"] = this.overPaymentBalance;
        data["monthlyAmountWithHeld"] = this.monthlyAmountWithHeld;
        data["isRepresentativePayee"] = this.isRepresentativePayee;
        data["isAuthorisedRepresentative"] = this.isAuthorisedRepresentative;
        data["nextMedicalReviewDate"] = this.nextMedicalReviewDate ? this.nextMedicalReviewDate.toString() : <any>undefined;
        data["medicalReExamCycle"] = this.medicalReExamCycle;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTicketHolderBenifitType {
    ticketHolderId: number;
    benefitType: BenefitType;
    currentStatus: BenefitPaymentStatus;
    isStatutorilyBlind: boolean | undefined;
    disabilityOnsetDate: DateTime | undefined;
    entitlementDate: DateTime | undefined;
    fullAmount: number | undefined;
    netAmount: number | undefined;
    othersPaid: boolean | undefined;
    totalFamilyCashBenifit: number | undefined;
    overPaymentBalance: number | undefined;
    monthlyAmountWithHeld: number | undefined;
    isRepresentativePayee: boolean | undefined;
    isAuthorisedRepresentative: boolean | undefined;
    nextMedicalReviewDate: DateTime | undefined;
    medicalReExamCycle: string | undefined;
    id: number;
}

export class UpdateTicketHolderNoteDto implements IUpdateTicketHolderNoteDto {
    id!: number;
    noteText!: string;
    isPinned!: boolean;

    constructor(data?: IUpdateTicketHolderNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noteText = _data["noteText"];
            this.isPinned = _data["isPinned"];
        }
    }

    static fromJS(data: any): UpdateTicketHolderNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketHolderNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noteText"] = this.noteText;
        data["isPinned"] = this.isPinned;
        return data;
    }
}

export interface IUpdateTicketHolderNoteDto {
    id: number;
    noteText: string;
    isPinned: boolean;
}

export class UpdateTicketHolderStatusDto implements IUpdateTicketHolderStatusDto {
    ticketHolderId!: number;
    ticketHolderStatus!: TicketHolderStatus;

    constructor(data?: IUpdateTicketHolderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderStatus = _data["ticketHolderStatus"];
        }
    }

    static fromJS(data: any): UpdateTicketHolderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketHolderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderStatus"] = this.ticketHolderStatus;
        return data;
    }
}

export interface IUpdateTicketHolderStatusDto {
    ticketHolderId: number;
    ticketHolderStatus: TicketHolderStatus;
}

export class UpdateTicketHolderWageDataSearchRequestDto implements IUpdateTicketHolderWageDataSearchRequestDto {
    ticketHolderId!: number;
    provider!: WageDataSearchProvider;
    status!: WageDataRequestStatus;
    employerId!: number;
    note!: string | undefined;
    documentId!: number | undefined;
    id!: number;

    constructor(data?: IUpdateTicketHolderWageDataSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.provider = _data["provider"];
            this.status = _data["status"];
            this.employerId = _data["employerId"];
            this.note = _data["note"];
            this.documentId = _data["documentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTicketHolderWageDataSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketHolderWageDataSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["provider"] = this.provider;
        data["status"] = this.status;
        data["employerId"] = this.employerId;
        data["note"] = this.note;
        data["documentId"] = this.documentId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTicketHolderWageDataSearchRequestDto {
    ticketHolderId: number;
    provider: WageDataSearchProvider;
    status: WageDataRequestStatus;
    employerId: number;
    note: string | undefined;
    documentId: number | undefined;
    id: number;
}

export class UpdateTicketHolderWorkStatusDto implements IUpdateTicketHolderWorkStatusDto {
    ticketHolderId!: number;
    workStatus!: WorkStatus;

    constructor(data?: IUpdateTicketHolderWorkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketHolderId = _data["ticketHolderId"];
            this.workStatus = _data["workStatus"];
        }
    }

    static fromJS(data: any): UpdateTicketHolderWorkStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketHolderWorkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketHolderId"] = this.ticketHolderId;
        data["workStatus"] = this.workStatus;
        return data;
    }
}

export interface IUpdateTicketHolderWorkStatusDto {
    ticketHolderId: number;
    workStatus: WorkStatus;
}

export class UpdateTtwReferralDto implements IUpdateTtwReferralDto {
    referralFirstName!: string | undefined;
    referralLastName!: string | undefined;
    referralEmail!: string | undefined;
    referralPhone!: string | undefined;
    consentToContact!: boolean;
    ageEligible!: boolean;
    benefitEligible!: boolean;
    enrollmentDate!: DateTime | undefined;
    hiredDate!: DateTime | undefined;
    isFullTimeEmployment!: boolean;
    rewardIssuedDate!: DateTime | undefined;
    notes!: string | undefined;
    partnerId!: number | undefined;
    id!: number;

    constructor(data?: IUpdateTtwReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralFirstName = _data["referralFirstName"];
            this.referralLastName = _data["referralLastName"];
            this.referralEmail = _data["referralEmail"];
            this.referralPhone = _data["referralPhone"];
            this.consentToContact = _data["consentToContact"];
            this.ageEligible = _data["ageEligible"];
            this.benefitEligible = _data["benefitEligible"];
            this.enrollmentDate = _data["enrollmentDate"] ? DateTime.fromISO(_data["enrollmentDate"].toString()) : <any>undefined;
            this.hiredDate = _data["hiredDate"] ? DateTime.fromISO(_data["hiredDate"].toString()) : <any>undefined;
            this.isFullTimeEmployment = _data["isFullTimeEmployment"];
            this.rewardIssuedDate = _data["rewardIssuedDate"] ? DateTime.fromISO(_data["rewardIssuedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.partnerId = _data["partnerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTtwReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTtwReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralFirstName"] = this.referralFirstName;
        data["referralLastName"] = this.referralLastName;
        data["referralEmail"] = this.referralEmail;
        data["referralPhone"] = this.referralPhone;
        data["consentToContact"] = this.consentToContact;
        data["ageEligible"] = this.ageEligible;
        data["benefitEligible"] = this.benefitEligible;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toString() : <any>undefined;
        data["hiredDate"] = this.hiredDate ? this.hiredDate.toString() : <any>undefined;
        data["isFullTimeEmployment"] = this.isFullTimeEmployment;
        data["rewardIssuedDate"] = this.rewardIssuedDate ? this.rewardIssuedDate.toString() : <any>undefined;
        data["notes"] = this.notes;
        data["partnerId"] = this.partnerId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTtwReferralDto {
    referralFirstName: string | undefined;
    referralLastName: string | undefined;
    referralEmail: string | undefined;
    referralPhone: string | undefined;
    consentToContact: boolean;
    ageEligible: boolean;
    benefitEligible: boolean;
    enrollmentDate: DateTime | undefined;
    hiredDate: DateTime | undefined;
    isFullTimeEmployment: boolean;
    rewardIssuedDate: DateTime | undefined;
    notes: string | undefined;
    partnerId: number | undefined;
    id: number;
}

export class UpdateUnassignRequestDto implements IUpdateUnassignRequestDto {
    id!: number;
    unassignStatus!: TicketHolderUnassignStatus;
    unassignReason!: string | undefined;

    constructor(data?: IUpdateUnassignRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unassignStatus = _data["unassignStatus"];
            this.unassignReason = _data["unassignReason"];
        }
    }

    static fromJS(data: any): UpdateUnassignRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnassignRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unassignStatus"] = this.unassignStatus;
        data["unassignReason"] = this.unassignReason;
        return data;
    }
}

export interface IUpdateUnassignRequestDto {
    id: number;
    unassignStatus: TicketHolderUnassignStatus;
    unassignReason: string | undefined;
}

export class UpdateUnknownIncomingSMSDto implements IUpdateUnknownIncomingSMSDto {
    id!: number;
    clientId!: string | undefined;

    constructor(data?: IUpdateUnknownIncomingSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UpdateUnknownIncomingSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnknownIncomingSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUpdateUnknownIncomingSMSDto {
    id: number;
    clientId: string | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UpdateWageDataSearchRequestDto implements IUpdateWageDataSearchRequestDto {
    id!: number;
    note!: string | undefined;
    status!: WageDataRequestStatus;

    constructor(data?: IUpdateWageDataSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateWageDataSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWageDataSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateWageDataSearchRequestDto {
    id: number;
    note: string | undefined;
    status: WageDataRequestStatus;
}

export class UpdateWageReportStatusDto implements IUpdateWageReportStatusDto {
    id!: number;
    processingStatus!: WageReportProcessingStatus;

    constructor(data?: IUpdateWageReportStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processingStatus = _data["processingStatus"];
        }
    }

    static fromJS(data: any): UpdateWageReportStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWageReportStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processingStatus"] = this.processingStatus;
        return data;
    }
}

export interface IUpdateWageReportStatusDto {
    id: number;
    processingStatus: WageReportProcessingStatus;
}

export class UpdateWebsitePartnerLoginUrlInput implements IUpdateWebsitePartnerLoginUrlInput {
    /** Empty clears it (the email then uses Website:PartnerLoginUrl from appsettings, if any). */
    partnerLoginUrl!: string | undefined;

    constructor(data?: IUpdateWebsitePartnerLoginUrlInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerLoginUrl = _data["partnerLoginUrl"];
        }
    }

    static fromJS(data: any): UpdateWebsitePartnerLoginUrlInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWebsitePartnerLoginUrlInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerLoginUrl"] = this.partnerLoginUrl;
        return data;
    }
}

export interface IUpdateWebsitePartnerLoginUrlInput {
    /** Empty clears it (the email then uses Website:PartnerLoginUrl from appsettings, if any). */
    partnerLoginUrl: string | undefined;
}

export class UploadBSAPlanningAttachmentDto implements IUploadBSAPlanningAttachmentDto {
    benefitsCounselingCaseId!: number;
    file!: UploadFileOutputDto;

    constructor(data?: IUploadBSAPlanningAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.file = new UploadFileOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.file = _data["file"] ? UploadFileOutputDto.fromJS(_data["file"]) : new UploadFileOutputDto();
        }
    }

    static fromJS(data: any): UploadBSAPlanningAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBSAPlanningAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadBSAPlanningAttachmentDto {
    benefitsCounselingCaseId: number;
    file: UploadFileOutputDto;
}

export class UploadBSAReportAttachmentDto implements IUploadBSAReportAttachmentDto {
    benefitsCounselingCaseId!: number;
    file!: UploadFileOutputDto;

    constructor(data?: IUploadBSAReportAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.file = new UploadFileOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.benefitsCounselingCaseId = _data["benefitsCounselingCaseId"];
            this.file = _data["file"] ? UploadFileOutputDto.fromJS(_data["file"]) : new UploadFileOutputDto();
        }
    }

    static fromJS(data: any): UploadBSAReportAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBSAReportAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefitsCounselingCaseId"] = this.benefitsCounselingCaseId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadBSAReportAttachmentDto {
    benefitsCounselingCaseId: number;
    file: UploadFileOutputDto;
}

export class UploadBase64OutputDto implements IUploadBase64OutputDto {
    uploadId!: string | undefined;
    files!: FileBase64Dto[] | undefined;

    constructor(data?: IUploadBase64OutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileBase64Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadBase64OutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBase64OutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadBase64OutputDto {
    uploadId: string | undefined;
    files: FileBase64Dto[] | undefined;
}

export class UploadFileDto implements IUploadFileDto {
    fileName!: string | undefined;
    tempPath!: string | undefined;
    isDuplicate!: boolean;
    suggestedFileName!: string | undefined;

    constructor(data?: IUploadFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.tempPath = _data["tempPath"];
            this.isDuplicate = _data["isDuplicate"];
            this.suggestedFileName = _data["suggestedFileName"];
        }
    }

    static fromJS(data: any): UploadFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["tempPath"] = this.tempPath;
        data["isDuplicate"] = this.isDuplicate;
        data["suggestedFileName"] = this.suggestedFileName;
        return data;
    }
}

export interface IUploadFileDto {
    fileName: string | undefined;
    tempPath: string | undefined;
    isDuplicate: boolean;
    suggestedFileName: string | undefined;
}

export class UploadFileForDocumentFormTemplateDto implements IUploadFileForDocumentFormTemplateDto {
    uploadId!: string | undefined;
    documentId!: number | undefined;
    formName!: string | undefined;
    fields!: SaveDocumentTemplateFieldDto[] | undefined;
    mergeUploadIds!: string[] | undefined;

    constructor(data?: IUploadFileForDocumentFormTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.documentId = _data["documentId"];
            this.formName = _data["formName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SaveDocumentTemplateFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["mergeUploadIds"])) {
                this.mergeUploadIds = [] as any;
                for (let item of _data["mergeUploadIds"])
                    this.mergeUploadIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UploadFileForDocumentFormTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileForDocumentFormTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["documentId"] = this.documentId;
        data["formName"] = this.formName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.mergeUploadIds)) {
            data["mergeUploadIds"] = [];
            for (let item of this.mergeUploadIds)
                data["mergeUploadIds"].push(item);
        }
        return data;
    }
}

export interface IUploadFileForDocumentFormTemplateDto {
    uploadId: string | undefined;
    documentId: number | undefined;
    formName: string | undefined;
    fields: SaveDocumentTemplateFieldDto[] | undefined;
    mergeUploadIds: string[] | undefined;
}

export class UploadFileOutputDto implements IUploadFileOutputDto {
    uploadId!: string | undefined;
    files!: UploadFileDto[] | undefined;

    constructor(data?: IUploadFileOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(UploadFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadFileOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadFileOutputDto {
    uploadId: string | undefined;
    files: UploadFileDto[] | undefined;
}

export class UploadHostFormTemplateFileDto implements IUploadHostFormTemplateFileDto {
    uploadId!: string;
    formsType!: TTWFormsType;
    formName!: string;

    constructor(data?: IUploadHostFormTemplateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.formsType = _data["formsType"];
            this.formName = _data["formName"];
        }
    }

    static fromJS(data: any): UploadHostFormTemplateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadHostFormTemplateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["formsType"] = this.formsType;
        data["formName"] = this.formName;
        return data;
    }
}

export interface IUploadHostFormTemplateFileDto {
    uploadId: string;
    formsType: TTWFormsType;
    formName: string;
}

export class UploadPartnerLogoInputDto implements IUploadPartnerLogoInputDto {
    sessionToken!: string;
    logoBase64!: string;
    logoFileName!: string;

    constructor(data?: IUploadPartnerLogoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionToken = _data["sessionToken"];
            this.logoBase64 = _data["logoBase64"];
            this.logoFileName = _data["logoFileName"];
        }
    }

    static fromJS(data: any): UploadPartnerLogoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPartnerLogoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionToken"] = this.sessionToken;
        data["logoBase64"] = this.logoBase64;
        data["logoFileName"] = this.logoFileName;
        return data;
    }
}

export interface IUploadPartnerLogoInputDto {
    sessionToken: string;
    logoBase64: string;
    logoFileName: string;
}

export class UploadPaystubsResultDto implements IUploadPaystubsResultDto {
    uploadedCount!: number;
    skippedDuplicateFileNames!: string[] | undefined;

    constructor(data?: IUploadPaystubsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadedCount = _data["uploadedCount"];
            if (Array.isArray(_data["skippedDuplicateFileNames"])) {
                this.skippedDuplicateFileNames = [] as any;
                for (let item of _data["skippedDuplicateFileNames"])
                    this.skippedDuplicateFileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UploadPaystubsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPaystubsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedCount"] = this.uploadedCount;
        if (Array.isArray(this.skippedDuplicateFileNames)) {
            data["skippedDuplicateFileNames"] = [];
            for (let item of this.skippedDuplicateFileNames)
                data["skippedDuplicateFileNames"].push(item);
        }
        return data;
    }
}

export interface IUploadPaystubsResultDto {
    uploadedCount: number;
    skippedDuplicateFileNames: string[] | undefined;
}

export class UploadSessionInfoDto implements IUploadSessionInfoDto {
    uploadId!: string | undefined;
    expiresAt!: DateTime;
    status!: UploadSessionStatus;

    constructor(data?: IUploadSessionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.expiresAt = _data["expiresAt"] ? DateTime.fromISO(_data["expiresAt"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UploadSessionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSessionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IUploadSessionInfoDto {
    uploadId: string | undefined;
    expiresAt: DateTime;
    status: UploadSessionStatus;
}

export enum UploadSessionStatus {
    Invalid = 0,
    Active = 1,
    Inactive = 2,
}

export class User implements IUser {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    authenticationSource!: string | undefined;
    userName!: string;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    readonly fullName!: string | undefined;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    profilePictureId!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    signInTokenExpireTimeUtc!: DateTime | undefined;
    signInToken!: string | undefined;
    googleAuthenticatorKey!: string | undefined;
    recoveryCode!: string | undefined;
    organizationUnits!: UserOrganizationUnit[] | undefined;
    userType!: UserAccountType;
    readonly isTicketHolder!: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.profilePictureId = _data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"] ? DateTime.fromISO(_data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.signInToken = _data["signInToken"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            this.recoveryCode = _data["recoveryCode"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(UserOrganizationUnit.fromJS(item));
            }
            this.userType = _data["userType"];
            (<any>this).isTicketHolder = _data["isTicketHolder"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toString() : <any>undefined;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["recoveryCode"] = this.recoveryCode;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item.toJSON());
        }
        data["userType"] = this.userType;
        data["isTicketHolder"] = this.isTicketHolder;
        return data;
    }
}

export interface IUser {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: DateTime | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    recoveryCode: string | undefined;
    organizationUnits: UserOrganizationUnit[] | undefined;
    userType: UserAccountType;
    isTicketHolder: boolean;
}

export enum UserAccountType {
    Staff = 0,
    TicketHolder = 1,
}

export class UserApiToken implements IUserApiToken {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    tenantId!: number;
    user!: User;
    userId!: number;
    provider!: UserApiTokenProvider;
    accessToken!: string | undefined;
    refreshToken!: string | undefined;
    tokenType!: UserApiTokenType;
    expiresAtUtc!: DateTime;
    scope!: string | undefined;
    encrypted!: boolean;
    readonly externalApiConnectInfoJson!: string | undefined;
    externalApiConnectInfo!: ExternalApiConnectInfo;

    constructor(data?: IUserApiToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.provider = _data["provider"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.tokenType = _data["tokenType"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? DateTime.fromISO(_data["expiresAtUtc"].toString()) : <any>undefined;
            this.scope = _data["scope"];
            this.encrypted = _data["encrypted"];
            (<any>this).externalApiConnectInfoJson = _data["externalApiConnectInfoJson"];
            this.externalApiConnectInfo = _data["externalApiConnectInfo"] ? ExternalApiConnectInfo.fromJS(_data["externalApiConnectInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserApiToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserApiToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["tokenType"] = this.tokenType;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toString() : <any>undefined;
        data["scope"] = this.scope;
        data["encrypted"] = this.encrypted;
        data["externalApiConnectInfoJson"] = this.externalApiConnectInfoJson;
        data["externalApiConnectInfo"] = this.externalApiConnectInfo ? this.externalApiConnectInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserApiToken {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    tenantId: number;
    user: User;
    userId: number;
    provider: UserApiTokenProvider;
    accessToken: string | undefined;
    refreshToken: string | undefined;
    tokenType: UserApiTokenType;
    expiresAtUtc: DateTime;
    scope: string | undefined;
    encrypted: boolean;
    externalApiConnectInfoJson: string | undefined;
    externalApiConnectInfo: ExternalApiConnectInfo;
}

export class UserApiTokenDto implements IUserApiTokenDto {
    id!: number;
    userId!: number;
    provider!: UserApiTokenProvider;
    accessToken!: string | undefined;
    refreshToken!: string | undefined;
    tokenType!: UserApiTokenType;
    expiresAtUtc!: DateTime;
    scope!: string | undefined;
    encrypted!: boolean;

    constructor(data?: IUserApiTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.provider = _data["provider"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.tokenType = _data["tokenType"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? DateTime.fromISO(_data["expiresAtUtc"].toString()) : <any>undefined;
            this.scope = _data["scope"];
            this.encrypted = _data["encrypted"];
        }
    }

    static fromJS(data: any): UserApiTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserApiTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["tokenType"] = this.tokenType;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toString() : <any>undefined;
        data["scope"] = this.scope;
        data["encrypted"] = this.encrypted;
        return data;
    }
}

export interface IUserApiTokenDto {
    id: number;
    userId: number;
    provider: UserApiTokenProvider;
    accessToken: string | undefined;
    refreshToken: string | undefined;
    tokenType: UserApiTokenType;
    expiresAtUtc: DateTime;
    scope: string | undefined;
    encrypted: boolean;
}

export enum UserApiTokenProvider {
    None = 0,
    MicrosoftGraph = 1,
    GoogleAPI = 2,
    RingCentralAPI = 3,
    DigiSignerAPI = 4,
}

export enum UserApiTokenType {
    Basic = 0,
    Bearer = 1,
    MAC = 2,
    JWT = 3,
    Digest = 4,
    OAuth = 5,
    SAML = 6,
    Hawk = 7,
    Custom = 8,
}

export class UserClaim implements IUserClaim {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDelegationDto implements IUserDelegationDto {
    id!: number;
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserDelegationDto {
    id: number;
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserListDto implements IUserListDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: DateTime;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserListDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: DateTime;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number | undefined;
    defaultAccountLockoutSeconds!: number | undefined;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number | undefined;
    defaultAccountLockoutSeconds: number | undefined;
}

export class UserLogin implements IUserLogin {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    loginType!: LoginType;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.loginType = _data["loginType"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["loginType"] = this.loginType;
        return data;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    loginType: LoginType;
}

export class UserNotification implements IUserNotification {
    id!: string;
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (<any>this).targetNotifiersList!.push(item);
            }
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        return data;
    }
}

export interface IUserNotification {
    id: string;
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class UserOrganizationUnit implements IUserOrganizationUnit {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    organizationUnitId!: number;
    isDeleted!: boolean;

    constructor(data?: IUserOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserOrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IUserOrganizationUnit {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    organizationUnitId: number;
    isDeleted: boolean;
}

export class UserPasswordSettingsEditDto implements IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange!: boolean;
    checkingLastXPasswordCount!: number;
    enablePasswordExpiration!: boolean;
    passwordExpirationDayCount!: number;
    passwordResetCodeExpirationHours!: number;

    constructor(data?: IUserPasswordSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableCheckingLastXPasswordWhenPasswordChange = _data["enableCheckingLastXPasswordWhenPasswordChange"];
            this.checkingLastXPasswordCount = _data["checkingLastXPasswordCount"];
            this.enablePasswordExpiration = _data["enablePasswordExpiration"];
            this.passwordExpirationDayCount = _data["passwordExpirationDayCount"];
            this.passwordResetCodeExpirationHours = _data["passwordResetCodeExpirationHours"];
        }
    }

    static fromJS(data: any): UserPasswordSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableCheckingLastXPasswordWhenPasswordChange"] = this.enableCheckingLastXPasswordWhenPasswordChange;
        data["checkingLastXPasswordCount"] = this.checkingLastXPasswordCount;
        data["enablePasswordExpiration"] = this.enablePasswordExpiration;
        data["passwordExpirationDayCount"] = this.passwordExpirationDayCount;
        data["passwordResetCodeExpirationHours"] = this.passwordResetCodeExpirationHours;
        return data;
    }
}

export interface IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange: boolean;
    checkingLastXPasswordCount: number;
    enablePasswordExpiration: boolean;
    passwordExpirationDayCount: number;
    passwordResetCodeExpirationHours: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    userId!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserRole {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class UserToken implements IUserToken {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: DateTime | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : <any>undefined;
        return data;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: DateTime | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class ValidateSqlInput implements IValidateSqlInput {
    sql!: string;

    constructor(data?: IValidateSqlInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sql = _data["sql"];
        }
    }

    static fromJS(data: any): ValidateSqlInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSqlInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sql"] = this.sql;
        return data;
    }
}

export interface IValidateSqlInput {
    sql: string;
}

export class ValidateSqlResult implements IValidateSqlResult {
    isValid!: boolean;
    message!: string | undefined;

    constructor(data?: IValidateSqlResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidateSqlResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSqlResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["message"] = this.message;
        return data;
    }
}

export interface IValidateSqlResult {
    isValid: boolean;
    message: string | undefined;
}

export class VerifyAuthenticatorCodeInput implements IVerifyAuthenticatorCodeInput {
    code!: string | undefined;
    googleAuthenticatorKey!: string | undefined;

    constructor(data?: IVerifyAuthenticatorCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
        }
    }

    static fromJS(data: any): VerifyAuthenticatorCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyAuthenticatorCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        return data;
    }
}

export interface IVerifyAuthenticatorCodeInput {
    code: string | undefined;
    googleAuthenticatorKey: string | undefined;
}

export class VerifyPasswordlessLoginCodeInput implements IVerifyPasswordlessLoginCodeInput {
    code!: string | undefined;
    providerValue!: string | undefined;

    constructor(data?: IVerifyPasswordlessLoginCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.providerValue = _data["providerValue"];
        }
    }

    static fromJS(data: any): VerifyPasswordlessLoginCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPasswordlessLoginCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["providerValue"] = this.providerValue;
        return data;
    }
}

export interface IVerifyPasswordlessLoginCodeInput {
    code: string | undefined;
    providerValue: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class VwServiceRequestDto implements IVwServiceRequestDto {
    readonly id!: string | undefined;
    idRaw!: number;
    tenantId!: number;
    ticketHolderId!: number;
    serviceType!: ServiceType;
    readonly enumDisplayServiceType!: string | undefined;
    status!: ServiceRequestStatus;
    readonly enumDisplayStatus!: string | undefined;
    dueDate!: DateTime | undefined;
    creationTime!: DateTime;

    constructor(data?: IVwServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.idRaw = _data["idRaw"];
            this.tenantId = _data["tenantId"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.serviceType = _data["serviceType"];
            (<any>this).enumDisplayServiceType = _data["enumDisplayServiceType"];
            this.status = _data["status"];
            (<any>this).enumDisplayStatus = _data["enumDisplayStatus"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VwServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VwServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idRaw"] = this.idRaw;
        data["tenantId"] = this.tenantId;
        data["ticketHolderId"] = this.ticketHolderId;
        data["serviceType"] = this.serviceType;
        data["enumDisplayServiceType"] = this.enumDisplayServiceType;
        data["status"] = this.status;
        data["enumDisplayStatus"] = this.enumDisplayStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IVwServiceRequestDto {
    id: string | undefined;
    idRaw: number;
    tenantId: number;
    ticketHolderId: number;
    serviceType: ServiceType;
    enumDisplayServiceType: string | undefined;
    status: ServiceRequestStatus;
    enumDisplayStatus: string | undefined;
    dueDate: DateTime | undefined;
    creationTime: DateTime;
}

export class WageDataExtractDto implements IWageDataExtractDto {
    employeeName!: string | undefined;
    employerName!: string | undefined;
    employerAddress!: string | undefined;
    employerPhoneNumber!: string | undefined;
    payPeriodStart!: DateTime | undefined;
    payPeriodEnd!: DateTime | undefined;
    payDate!: DateTime | undefined;
    hoursWorked!: number | undefined;
    rate!: number;
    grossPay!: number;

    constructor(data?: IWageDataExtractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.employerName = _data["employerName"];
            this.employerAddress = _data["employerAddress"];
            this.employerPhoneNumber = _data["employerPhoneNumber"];
            this.payPeriodStart = _data["payPeriodStart"] ? DateTime.fromISO(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? DateTime.fromISO(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? DateTime.fromISO(_data["payDate"].toString()) : <any>undefined;
            this.hoursWorked = _data["hoursWorked"];
            this.rate = _data["rate"];
            this.grossPay = _data["grossPay"];
        }
    }

    static fromJS(data: any): WageDataExtractDto {
        data = typeof data === 'object' ? data : {};
        let result = new WageDataExtractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["employerName"] = this.employerName;
        data["employerAddress"] = this.employerAddress;
        data["employerPhoneNumber"] = this.employerPhoneNumber;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["hoursWorked"] = this.hoursWorked;
        data["rate"] = this.rate;
        data["grossPay"] = this.grossPay;
        return data;
    }
}

export interface IWageDataExtractDto {
    employeeName: string | undefined;
    employerName: string | undefined;
    employerAddress: string | undefined;
    employerPhoneNumber: string | undefined;
    payPeriodStart: DateTime | undefined;
    payPeriodEnd: DateTime | undefined;
    payDate: DateTime | undefined;
    hoursWorked: number | undefined;
    rate: number;
    grossPay: number;
}

export enum WageDataRequestStatus {
    Pending = 0,
    CompletedNoWageDataFound = 1,
    CompletedWageDataFound = 2,
}

export enum WageDataSearchProvider {
    TheWorkNumber = 0,
    ExperianVerify = 1,
    Truework = 2,
    CCCVerify = 3,
    InVerify = 4,
    UConfirm = 5,
}

export class WageDataSearchRequestFilterDto implements IWageDataSearchRequestFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    statuses!: WageDataRequestStatus[] | undefined;

    constructor(data?: IWageDataSearchRequestFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static fromJS(data: any): WageDataSearchRequestFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new WageDataSearchRequestFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        return data;
    }
}

export interface IWageDataSearchRequestFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    statuses: WageDataRequestStatus[] | undefined;
}

export enum WageFrequency {
    Hour = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}

export class WageReportProcessingQDto implements IWageReportProcessingQDto {
    id!: number;
    wageFileName!: string | undefined;
    documentId!: number | undefined;
    fromSource!: TicketHolderFileSource;
    readonly enumDisplayFromSource!: string | undefined;
    processingStatus!: WageReportProcessingStatus;
    readonly enumDisplayProcessingStatus!: string | undefined;
    ticketHolderId!: number | undefined;
    ticketHolderName!: string | undefined;
    isPaystub!: boolean;
    creatorUserId!: number | undefined;
    createdBy!: string | undefined;
    removeReason!: WageReportRemovalReason;
    enumDisplayRemoveReason!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IWageReportProcessingQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wageFileName = _data["wageFileName"];
            this.documentId = _data["documentId"];
            this.fromSource = _data["fromSource"];
            (<any>this).enumDisplayFromSource = _data["enumDisplayFromSource"];
            this.processingStatus = _data["processingStatus"];
            (<any>this).enumDisplayProcessingStatus = _data["enumDisplayProcessingStatus"];
            this.ticketHolderId = _data["ticketHolderId"];
            this.ticketHolderName = _data["ticketHolderName"];
            this.isPaystub = _data["isPaystub"];
            this.creatorUserId = _data["creatorUserId"];
            this.createdBy = _data["createdBy"];
            this.removeReason = _data["removeReason"];
            this.enumDisplayRemoveReason = _data["enumDisplayRemoveReason"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WageReportProcessingQDto {
        data = typeof data === 'object' ? data : {};
        let result = new WageReportProcessingQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wageFileName"] = this.wageFileName;
        data["documentId"] = this.documentId;
        data["fromSource"] = this.fromSource;
        data["enumDisplayFromSource"] = this.enumDisplayFromSource;
        data["processingStatus"] = this.processingStatus;
        data["enumDisplayProcessingStatus"] = this.enumDisplayProcessingStatus;
        data["ticketHolderId"] = this.ticketHolderId;
        data["ticketHolderName"] = this.ticketHolderName;
        data["isPaystub"] = this.isPaystub;
        data["creatorUserId"] = this.creatorUserId;
        data["createdBy"] = this.createdBy;
        data["removeReason"] = this.removeReason;
        data["enumDisplayRemoveReason"] = this.enumDisplayRemoveReason;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IWageReportProcessingQDto {
    id: number;
    wageFileName: string | undefined;
    documentId: number | undefined;
    fromSource: TicketHolderFileSource;
    enumDisplayFromSource: string | undefined;
    processingStatus: WageReportProcessingStatus;
    enumDisplayProcessingStatus: string | undefined;
    ticketHolderId: number | undefined;
    ticketHolderName: string | undefined;
    isPaystub: boolean;
    creatorUserId: number | undefined;
    createdBy: string | undefined;
    removeReason: WageReportRemovalReason;
    enumDisplayRemoveReason: string | undefined;
    creationTime: DateTime;
}

export class WageReportProcessingQFilterDto implements IWageReportProcessingQFilterDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    statuses!: WageReportProcessingStatus[] | undefined;
    createdTimeStart!: DateTime | undefined;
    createdTimeEnd!: DateTime | undefined;
    ticketHolderId!: number | undefined;
    createdBy!: string | undefined;
    filter!: string | undefined;

    constructor(data?: IWageReportProcessingQFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            this.createdTimeStart = _data["createdTimeStart"] ? DateTime.fromISO(_data["createdTimeStart"].toString()) : <any>undefined;
            this.createdTimeEnd = _data["createdTimeEnd"] ? DateTime.fromISO(_data["createdTimeEnd"].toString()) : <any>undefined;
            this.ticketHolderId = _data["ticketHolderId"];
            this.createdBy = _data["createdBy"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): WageReportProcessingQFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new WageReportProcessingQFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["createdTimeStart"] = this.createdTimeStart ? this.createdTimeStart.toString() : <any>undefined;
        data["createdTimeEnd"] = this.createdTimeEnd ? this.createdTimeEnd.toString() : <any>undefined;
        data["ticketHolderId"] = this.ticketHolderId;
        data["createdBy"] = this.createdBy;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IWageReportProcessingQFilterDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    statuses: WageReportProcessingStatus[] | undefined;
    createdTimeStart: DateTime | undefined;
    createdTimeEnd: DateTime | undefined;
    ticketHolderId: number | undefined;
    createdBy: string | undefined;
    filter: string | undefined;
}

export class WageReportProcessingQRequestDto implements IWageReportProcessingQRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    ticketHolderId!: number;
    statuses!: WageReportProcessingStatus[] | undefined;

    constructor(data?: IWageReportProcessingQRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.ticketHolderId = _data["ticketHolderId"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static fromJS(data: any): WageReportProcessingQRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WageReportProcessingQRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["ticketHolderId"] = this.ticketHolderId;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        return data;
    }
}

export interface IWageReportProcessingQRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    ticketHolderId: number;
    statuses: WageReportProcessingStatus[] | undefined;
}

export enum WageReportProcessingStatus {
    Pending = 0,
    InProgress = 1,
    Completed = 2,
    Removed = 3,
}

export enum WageReportRemovalReason {
    TooDark = 1,
    TooLight = 2,
    Blurry = 4,
    CutOff = 8,
    NotPaystub = 16,
    Duplicate = 32,
    Employee1099 = 64,
    RequiredInfoMissing = 128,
    MissingPayPeriod = 256,
    MissingPayDate = 512,
    MissingEmployerInfo = 1024,
    MissingEmployeeInfo = 2048,
    MissingEarningsInfo = 4096,
    MissingDeductionsInfo = 8192,
    MissingYearToDateInfo = 16384,
    MissingNetPayInfo = 32768,
    Other = 65536,
}

export class WaitHandle implements IWaitHandle {
    handle!: IntPtr;
    safeWaitHandle!: SafeWaitHandle;

    constructor(data?: IWaitHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handle = _data["handle"] ? IntPtr.fromJS(_data["handle"]) : <any>undefined;
            this.safeWaitHandle = _data["safeWaitHandle"] ? SafeWaitHandle.fromJS(_data["safeWaitHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WaitHandle {
        data = typeof data === 'object' ? data : {};
        let result = new WaitHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handle"] = this.handle ? this.handle.toJSON() : <any>undefined;
        data["safeWaitHandle"] = this.safeWaitHandle ? this.safeWaitHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWaitHandle {
    handle: IntPtr;
    safeWaitHandle: SafeWaitHandle;
}

export class WebhookEvent implements IWebhookEvent {
    id!: string;
    webhookName!: string;
    data!: string | undefined;
    creationTime!: DateTime;
    tenantId!: number | undefined;
    isDeleted!: boolean;
    deletionTime!: DateTime | undefined;

    constructor(data?: IWebhookEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WebhookEvent {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        return data;
    }
}

export interface IWebhookEvent {
    id: string;
    webhookName: string;
    data: string | undefined;
    creationTime: DateTime;
    tenantId: number | undefined;
    isDeleted: boolean;
    deletionTime: DateTime | undefined;
}

export class WebhookSubscription implements IWebhookSubscription {
    id!: string;
    tenantId!: number | undefined;
    webhookUri!: string | undefined;
    secret!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    headers!: { [key: string]: string; } | undefined;

    constructor(data?: IWebhookSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.webhookUri = _data["webhookUri"];
            this.secret = _data["secret"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            if (_data["headers"]) {
                this.headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        (<any>this.headers)![key] = _data["headers"][key];
                }
            }
        }
    }

    static fromJS(data: any): WebhookSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["webhookUri"] = this.webhookUri;
        data["secret"] = this.secret;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (<any>data["headers"])[key] = (<any>this.headers)[key];
            }
        }
        return data;
    }
}

export interface IWebhookSubscription {
    id: string;
    tenantId: number | undefined;
    webhookUri: string | undefined;
    secret: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    headers: { [key: string]: string; } | undefined;
}

export class WebsiteApiKeyDto implements IWebsiteApiKeyDto {
    id!: number;
    name!: string | undefined;
    /** The decrypted key, for the tenant admin to copy into the website's Site:CrmLeadApiKey. */
    key!: string | undefined;
    creationTime!: DateTime;
    creatorUserName!: string | undefined;
    lastUsedTime!: DateTime | undefined;
    revokedTime!: DateTime | undefined;
    readonly isRevoked!: boolean;

    constructor(data?: IWebsiteApiKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserName = _data["creatorUserName"];
            this.lastUsedTime = _data["lastUsedTime"] ? DateTime.fromISO(_data["lastUsedTime"].toString()) : <any>undefined;
            this.revokedTime = _data["revokedTime"] ? DateTime.fromISO(_data["revokedTime"].toString()) : <any>undefined;
            (<any>this).isRevoked = _data["isRevoked"];
        }
    }

    static fromJS(data: any): WebsiteApiKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteApiKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserName"] = this.creatorUserName;
        data["lastUsedTime"] = this.lastUsedTime ? this.lastUsedTime.toString() : <any>undefined;
        data["revokedTime"] = this.revokedTime ? this.revokedTime.toString() : <any>undefined;
        data["isRevoked"] = this.isRevoked;
        return data;
    }
}

export interface IWebsiteApiKeyDto {
    id: number;
    name: string | undefined;
    /** The decrypted key, for the tenant admin to copy into the website's Site:CrmLeadApiKey. */
    key: string | undefined;
    creationTime: DateTime;
    creatorUserName: string | undefined;
    lastUsedTime: DateTime | undefined;
    revokedTime: DateTime | undefined;
    isRevoked: boolean;
}

/** A form submission from the SpringUp marketing website (Thrive.Web.Marketing). Shape matches that site's `Lead` record. */
export class WebsiteLeadInputDto implements IWebsiteLeadInputDto {
    /** Form the lead came from: Contact, Referral, Career or Subscribe. */
    source!: string;
    name!: string;
    email!: string;
    phone!: string | undefined;
    message!: string | undefined;
    smsConsent!: boolean;
    /** Form-specific fields (e.g. ReferredName, Position). Career forms may include
ResumeFileName + ResumeBase64, which are emailed to host admins rather than stored. */
    extra!: { [key: string]: string; } | undefined;

    constructor(data?: IWebsiteLeadInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.message = _data["message"];
            this.smsConsent = _data["smsConsent"];
            if (_data["extra"]) {
                this.extra = {} as any;
                for (let key in _data["extra"]) {
                    if (_data["extra"].hasOwnProperty(key))
                        (<any>this.extra)![key] = _data["extra"][key];
                }
            }
        }
    }

    static fromJS(data: any): WebsiteLeadInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteLeadInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["message"] = this.message;
        data["smsConsent"] = this.smsConsent;
        if (this.extra) {
            data["extra"] = {};
            for (let key in this.extra) {
                if (this.extra.hasOwnProperty(key))
                    (<any>data["extra"])[key] = (<any>this.extra)[key];
            }
        }
        return data;
    }
}

/** A form submission from the SpringUp marketing website (Thrive.Web.Marketing). Shape matches that site's `Lead` record. */
export interface IWebsiteLeadInputDto {
    /** Form the lead came from: Contact, Referral, Career or Subscribe. */
    source: string;
    name: string;
    email: string;
    phone: string | undefined;
    message: string | undefined;
    smsConsent: boolean;
    /** Form-specific fields (e.g. ReferredName, Position). Career forms may include
ResumeFileName + ResumeBase64, which are emailed to host admins rather than stored. */
    extra: { [key: string]: string; } | undefined;
}

/** Settings > Website: the tenant's website keys and partner login page. */
export class WebsiteSettingsDto implements IWebsiteSettingsDto {
    keys!: WebsiteApiKeyDto[] | undefined;
    partnerLoginUrl!: string | undefined;

    constructor(data?: IWebsiteSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keys"])) {
                this.keys = [] as any;
                for (let item of _data["keys"])
                    this.keys!.push(WebsiteApiKeyDto.fromJS(item));
            }
            this.partnerLoginUrl = _data["partnerLoginUrl"];
        }
    }

    static fromJS(data: any): WebsiteSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebsiteSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item.toJSON());
        }
        data["partnerLoginUrl"] = this.partnerLoginUrl;
        return data;
    }
}

/** Settings > Website: the tenant's website keys and partner login page. */
export interface IWebsiteSettingsDto {
    keys: WebsiteApiKeyDto[] | undefined;
    partnerLoginUrl: string | undefined;
}

export enum WeekDays {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data;
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    id!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export enum WorkArrangement {
    NotSpecified = 0,
    Remote = 1,
    Hybrid = 2,
    Onsite = 4,
}

export enum WorkStatus {
    Unknown = 0,
    CurrentlyWorking = 1,
    NoEarningsInPast18Months = 2,
    EarningsInMonthPriorToTicketAssigned = 4,
    EarningsIn3OfPast6Months = 8,
    EarningsIn6OfPast12Months = 16,
    EarningsIn12OfPast18Months = 32,
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export enum ContactType2 {
    Phone = 0,
    Email = 1,
    SMS = 2,
    WebChat = 3,
    MobileChat = 4,
    Fax = 5,
    Mail = 6,
    Others = 7,
}

export enum CurrentStage {
    LeadPool = 1,
    LeadQueue = 2,
    Interested = 3,
    EligibilityChecking = 4,
    IWPPending = 5,
    IWPWaitingSignature = 6,
    IWPSigned = 7,
    NotInterested = 8,
    Disqualified = 9,
    SVRInUse = 10,
    OptOut = 11,
}

export enum CurrentStatus {
    NewByCC = 0,
    NewBySearchAssistant = 1,
    PendingReviewByCC = 2,
    CanceledByCC = 3,
    PendingReviewByTH = 4,
    AppliedByTH = 5,
    PendingApplyByCC = 6,
    AppliedByCC = 7,
    InterviewScheduled = 8,
    Interviewed = 9,
    Offered = 10,
    OfferAccepted = 11,
    OfferRejected = 12,
    UnableToApply = 13,
    Archived = 14,
    Expired = 15,
}

export enum CurrentStatus2 {
    NewByCC = 0,
    NewBySearchAssistant = 1,
    PendingReviewByCC = 2,
    CanceledByCC = 3,
    PendingReviewByTH = 4,
    AppliedByTH = 5,
    PendingApplyByCC = 6,
    AppliedByCC = 7,
    InterviewScheduled = 8,
    Interviewed = 9,
    Offered = 10,
    OfferAccepted = 11,
    OfferRejected = 12,
    UnableToApply = 13,
    Archived = 14,
    Expired = 15,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}